
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4tTm9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $kbVzJ = parcelRequire("kbVzJ");


var $aUTn5 = parcelRequire("aUTn5");


var $cZa7r = parcelRequire("cZa7r");


var $24amZ = parcelRequire("24amZ");

var $l2hqi = parcelRequire("l2hqi");


var $3jwuS = parcelRequire("3jwuS");


var $afGoD = parcelRequire("afGoD");


var $bQm3c = parcelRequire("bQm3c");


var $8Mzkb = parcelRequire("8Mzkb");

const $1d207411f43b18d4$export$a9a76753cd947d5c = ({ pageId: pageId, onCreate: onCreate, onClose: onClose, dom: selectionElement, textSelection: textSelection, inlineNodeTypes: inlineNodeTypes, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar = false, closeObjectSidebar: closeObjectSidebar, isOffline: isOffline })=>{
    const { editorCreateProps: editorCreateProps } = (0, $cZa7r.useAnnotations)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const editorNode = (0, $42omo.useRef)(null);
    const indexFound = (0, $42omo.useRef)(0);
    const textMatches = (0, $42omo.useRef)(0);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Required to close the sidebar once we create a new standalone comment
    (0, $42omo.useEffect)(()=>{
        closeObjectSidebar && editorCreateProps && closeObjectSidebar();
    }, [
        closeObjectSidebar,
        editorCreateProps
    ]);
    (0, $42omo.useEffect)(()=>{
        (0, $8Ss4E.startEditorExperiences)({
            name: (0, $irVI7.ADD_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                mode: isLivePage ? (0, $l2hqi.InlineCommentMode).LIVE : (0, $l2hqi.InlineCommentMode).EDIT,
                framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                edition: edition
            }
        }, {
            name: (0, $irVI7.ADD_INLINE_COMMENT_LOAD_EXPERIENCE)
        }, {
            name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE)
        });
        // both editor and inline comment sidebar share the same class, target the element that isn't the sidebar
        const editorNodes = Array.from(document.querySelectorAll('.ak-editor-content-area > .ProseMirror'));
        if (editorNodes.length) {
            const foundEditorNode = editorNodes.find((element)=>!element.closest('#editor-create-sidebar'));
            if (foundEditorNode) editorNode.current = foundEditorNode;
        }
        if (selectionElement && editorNode.current && textSelection) {
            const ignoredNodes = Array.from(editorNode.current.querySelectorAll((0, $aUTn5.IGNORE_SELECTORS)));
            const { text: text, nodesStartPos: nodesStartPos, nodes: nodes } = (0, $kbVzJ.indexTextNodes)(editorNode.current, ignoredNodes);
            const { index: index, numMatches: numMatches } = (0, $kbVzJ.findMatches)(text, textSelection, // we prefer the TextNode rather than <p> or headings
            selectionElement.parentNode ? selectionElement.parentNode : selectionElement, // default to 0 since the Editor wraps the selection in a <span> now
            0, nodesStartPos, nodes);
            indexFound.current = index;
            textMatches.current = numMatches;
        }
    }, [
        edition,
        selectionElement,
        textSelection,
        isLivePage,
        pageId,
        closeObjectSidebar,
        createAnalyticsEvent,
        editorCreateProps
    ]);
    const selectionOptions = (0, $42omo.useMemo)(()=>({
            originalSelection: textSelection,
            numMatches: textMatches.current,
            matchIndex: indexFound.current,
            inlineNodeTypes: inlineNodeTypes,
            createdFrom: isLivePage ? (0, $afGoD.CommentCreationLocation).LIVE : (0, $afGoD.CommentCreationLocation).EDITOR
        }), [
        textSelection,
        textMatches,
        indexFound,
        isLivePage,
        inlineNodeTypes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Mzkb.CreateComment), {
        pageId: pageId,
        annotationElement: selectionElement,
        selectionOptions: selectionOptions,
        onClose: onClose,
        onCreate: onCreate,
        isEditor: true,
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        isOffline: isOffline
    });
};
module.exports["CreateComponent"] = $1d207411f43b18d4$export$a9a76753cd947d5c;

});

parcelRegister("kbVzJ", function(module, exports) {
// eslint-disable-next-line import/no-cycle

var $2zMIV = parcelRequire("2zMIV");

const $567297790b62d2d4$var$TEXT_NODE_TYPE = 3;
function $567297790b62d2d4$export$2a4369abc54086f5(list, search, from) {
    const startPosInRange = Math.min(from, list.length - 1);
    let l = startPosInRange;
    let r = list.length;
    while(l < r){
        // This is a LEGACY disable statement after rule addition. Use `Math.floor((l+r)/2)` next time
        // eslint-disable-next-line no-bitwise
        const mid = l + r >> 1;
        if (list[mid] <= search) l = mid + 1;
        else r = mid;
    }
    return Math.max(l - 1, startPosInRange);
}
function $567297790b62d2d4$export$2605a3f2b4d7f885(root, ignoredNodes) {
    let textNode;
    let text = '';
    const nodesStartPos = [];
    const nodes = [];
    const nodeFilter = (textNode)=>{
        /**
     * If the text node is a descendent of one of the ignored node.
     * It means the text was rendered by maybe a macro.
     * Ignore these text nodes.
     */ return ignoredNodes.some((node)=>node === textNode || node.contains(textNode)) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
    };
    // createNodeIterator accepts an object with acceptNode field as node filter.
    // However IE 11 is expecting a function directly.
    nodeFilter.acceptNode = nodeFilter;
    const iter = document.createNodeIterator(root, NodeFilter.SHOW_TEXT, nodeFilter, false);
    while(textNode = iter.nextNode()){
        const normalizedText = (0, $2zMIV.textNormalize)(textNode.nodeValue);
        // WS-2885 - \u0020 represents the spacebar character so this regex handles any number of space only characters
        //           that may exist as their own nodes. We don't need to worry about only commenting on a space here
        //           because the popup has logic to only show itself if more than just a space is selected.
        if (/^\u0020+$/.test(normalizedText) || normalizedText.trim()) {
            // If it is not completely empty
            nodesStartPos.push(text.length);
            nodes.push(textNode);
            text += normalizedText;
        }
    }
    return {
        text: text,
        nodesStartPos: nodesStartPos,
        nodes: nodes
    };
}
function $567297790b62d2d4$var$getNodeTextLength(node) {
    return node && node.nodeValue ? node.nodeValue.length : 0;
}
function $567297790b62d2d4$export$f4585c00f32d9257(text, rawSelectedText, startContainer, startOffset, nodesStartPos, nodes, includeTraceForMatches) {
    const matchTraceList = [];
    if (!startContainer) return {
        numMatches: 0,
        index: -1,
        matchTraceList: null
    };
    let start = 0;
    let nodeStart = 0;
    let found = 0;
    let index = -1;
    let numMatches = 0;
    // loop through the provided text body string, starting from the beginning,
    // and update the index to search from until the rawSelectedtext can
    // no longer be found
    while((found = text.indexOf(rawSelectedText, start)) !== -1){
        // nodesStartPos is built by slowly concatenanting each non-empty text node value
        // together into a single string, and storing the index number at which the next string starts
        // with the matched index, find the nearest index value but return that index-1.
        // For example, if our match index is 10 and nodesStartPos = [0, 5, 11, 13],
        // we return index 1 (11 is the nearest but we want the index-1, 5).
        const pos = $567297790b62d2d4$export$2a4369abc54086f5(nodesStartPos, found, nodeStart);
        const textNode = nodes[pos];
        // In Firefox there is a case that startOffset is the end of a text node.
        // In this case it means the selection is actually starting from the next sibling node.
        let startNode = startContainer;
        if (startNode.nodeType === $567297790b62d2d4$var$TEXT_NODE_TYPE && startOffset >= $567297790b62d2d4$var$getNodeTextLength(startNode)) {
            startOffset -= $567297790b62d2d4$var$getNodeTextLength(startNode);
            startNode = startContainer.nextSibling;
        }
        if (startNode && (startNode.nodeType === $567297790b62d2d4$var$TEXT_NODE_TYPE && textNode === startNode || // Text node in IE 11 doesn't have contains method
        startNode.nodeType !== $567297790b62d2d4$var$TEXT_NODE_TYPE && startNode.contains(textNode))) {
            // The current text node might be the one we are selecting.
            // However a single text may have more than one match of the selected text.
            // We need to double check if the offset is correct.
            const offsetForCurrentFoundText = found - nodesStartPos[pos];
            if (offsetForCurrentFoundText <= startOffset) index = numMatches;
        }
        // Trace the text node back to the root if the flag is true
        if (includeTraceForMatches) {
            let element = textNode.parentElement;
            const parentElements = [];
            // We want to loop and record all the elements up to the div#content node
            while(element && element.getAttribute('id') !== 'content'){
                let classes = '';
                let attributes = '';
                const { tagName: tagName } = element;
                const classList = element.classList ? element.classList.value : '';
                const dataAttributes = element.getAttributeNames().filter((attribute)=>attribute.indexOf('data-') !== -1);
                // Handle classes
                if (classList.length) classes = `.${classList.split(' ').join('.')}`;
                // Handle data attributes
                if (dataAttributes.length) dataAttributes.forEach((attribute)=>{
                    // We don't want to get the value of the data-macro-body and data-title attributes
                    // because they can contain user information and we don't want to record it
                    if (attribute !== 'data-macro-body' && attribute !== 'data-title') {
                        // While it's "possible", we'll never actually get here if element is null
                        const value = element?.getAttribute(attribute);
                        attributes += `[${attribute}="${value}"]`;
                    } else attributes += `[${attribute}]`;
                });
                parentElements.unshift(`${tagName}${classes}${attributes}`);
                element = element.parentElement;
            }
            matchTraceList.push(parentElements.join(' > '));
        }
        numMatches++;
        start = found + 1;
        nodeStart = pos;
    }
    return {
        numMatches: numMatches,
        index: index,
        matchTraceList: matchTraceList.length ? matchTraceList : null
    };
}
module.exports["indexTextNodes"] = $567297790b62d2d4$export$2605a3f2b4d7f885;
module.exports["findMatches"] = $567297790b62d2d4$export$f4585c00f32d9257;

});

parcelRegister("2zMIV", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $aUTn5 = parcelRequire("aUTn5");

const $15cdccae323ae129$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $15cdccae323ae129$export$4042f14350dc38e1 = (container, contentId)=>{
    const selection = window.getSelection();
    // getSelection() only returns null for iframes in firefox; in all other cases the type field is set to "None"
    if (!selection || selection?.type === 'None') return false;
    let legacyHighlight;
    try {
        legacyHighlight = (0, $aUTn5.convertSelectionToLegacyFormat)(container, selection.getRangeAt(0), contentId);
    } catch (err) {
        $15cdccae323ae129$var$logger.error`An error occurred while highlighting content - ${err}`;
    }
    if (!legacyHighlight || !legacyHighlight.searchText) return false;
    const { searchText: { selectedText: selectedText, index: index, numMatches: numMatches } } = legacyHighlight;
    /*
   * A valid highlight contains:
   *
   *   A selection that has a length (non-empty)
   *   A matched index (-1 means not found)
   *   A positive non-zero number of matches
   *   A match index that is less than the number of matches
   *
   */ return selectedText.replace(/\n/g, '').length > 0 && index !== -1 && numMatches > 0 && index < numMatches;
};
const $15cdccae323ae129$export$6c73cedfcc8a18f2 = ()=>{
    const selection = window.getSelection();
    if (!selection || selection?.type === 'None') return false;
    const range = $15cdccae323ae129$export$fef151b94550e9f5();
    if (!range) return false;
    const parentElement = $15cdccae323ae129$export$ab738b211369230e(range);
    return parentElement instanceof HTMLElement && Boolean(parentElement.closest('table'));
};
const $15cdccae323ae129$export$42b4db950c80743f = (s)=>{
    /*
    CONF-36789: on IE, selectionRange.toString() always convert all &nbsp; to normal space
    on other browsers, it does not. So we must convert manually to made consistency across all browsers
    */ return s.replace(/\u00a0/g, '\u0020');
};
const $15cdccae323ae129$export$fef151b94550e9f5 = ()=>{
    const selection = window.getSelection();
    // no selection made webkit
    if (!selection || selection.isCollapsed) return null;
    const selectionRange = selection.getRangeAt(0);
    // Don't show popup if selection is white space
    if (!String(selectionRange).trim()) return null;
    return selectionRange;
};
const $15cdccae323ae129$export$cfa2225e87938781 = (node)=>{
    const TEXT_NODE_TYPE = 3;
    if (!node) return null;
    if (node.nodeType !== TEXT_NODE_TYPE && node.scrollWidth > node.clientWidth) return node;
    else return $15cdccae323ae129$export$cfa2225e87938781(node.parentNode);
};
const $15cdccae323ae129$export$6fc0706fcfa876ec = (node)=>{
    const ELEMENT_NODE_TYPE = 1;
    if (!node) return null;
    if (node.nodeType === ELEMENT_NODE_TYPE) {
        if (node.classList.contains('pm-table-sticky-wrapper')) return node;
    }
    if (node.parentElement) return $15cdccae323ae129$export$6fc0706fcfa876ec(node.parentElement);
    return null;
};
const $15cdccae323ae129$export$ab738b211369230e = (selectionRange)=>{
    if (selectionRange.commonAncestorContainer) {
        const selectRangeElement = selectionRange.commonAncestorContainer;
        if (selectRangeElement.nodeType === 3) //Is TextNode
        return selectRangeElement.parentNode;
        return selectRangeElement;
    }
    return null;
};
module.exports["isHighlightValidForInlineComment"] = $15cdccae323ae129$export$4042f14350dc38e1;
module.exports["isHighlightValidForBulkCreateJiraIssues"] = $15cdccae323ae129$export$6c73cedfcc8a18f2;
module.exports["getRange"] = $15cdccae323ae129$export$fef151b94550e9f5;
module.exports["textNormalize"] = $15cdccae323ae129$export$42b4db950c80743f;
module.exports["findStickyHeader"] = $15cdccae323ae129$export$6fc0706fcfa876ec;

});

parcelRegister("aUTn5", function(module, exports) {
/* eslint-disable no-restricted-globals */ 
var $9wGTI = parcelRequire("9wGTI");


var $2zMIV = parcelRequire("2zMIV");


var $kbVzJ = parcelRequire("kbVzJ");

const $92069b7b1bcb2285$export$c5bc138cfa79c2b2 = [
    // Legacy mention
    '.user-mention',
    // Fabric mention
    '[data-mention-id]',
    // Connect macro
    '.ap-container',
    // Links
    'a[href^="/"]',
    // Macros that doesn't have body
    '.conf-macro[data-hasbody="false"]',
    // Normal status
    '.status-lozenge-span',
    // Date will get rendered as "Today" in fabric
    '.date-lozenger-container',
    // Inline Smart Card/Jira issue link
    '[data-inline-card="true"]',
    '.inlineCardView-content-wrap',
    '.smart-link-title-wrapper',
    // Actual jira issue macro
    '.jira-issue',
    // Title for expand
    '.ak-renderer-extension-overflow-container button',
    '[data-node-type="expand"] > button',
    '[data-node-type="nestedExpand"] > button',
    // JIRA Macro
    '.jira-issues',
    // datasource table for new JIM macro
    '.datasource-table',
    // Inline file attachments
    "[data-type='file']",
    // Fabric code snippets
    '.code-block',
    // Legacy code snippets
    '.conf-macro[data-macro-name="code"]',
    // Sticky table headers (WS-2345 - Sticky header comment flow is strange for now, restrict until we can find a better solution)
    '.pm-table-sticky-wrapper',
    // Block cards
    '.blockCardView-content-wrap',
    // Excerpt Includes (WS-2563)
    '.ak-excerpt-include',
    // View All Container
    '#view-all-inline-comments-container',
    // Strikethrough
    's',
    // Emoji
    '[data-emoji-id]',
    // Charts
    "[data-mark-type='dataConsumer']",
    // Reattach Dialog
    '#reattach-container',
    // BEGIN EDITOR EXCLUSIONS
    //
    // Gadget?
    "[extensionkey='gadget']",
    // placeholder content
    'span[data-placeholder]',
    // covers most macros, would this be too encompassing?
    "[contenteditable='false']",
    // page include macro
    "[data-node-type='include']",
    // page properties report adf macro
    '.page-properties-report'
].join(',');
function $92069b7b1bcb2285$var$getSelectionHTML(selectionRange) {
    if ((0, $9wGTI.fg)('confluence-remove-jquery-from-selection-conversion')) {
        const div = document.createElement('div');
        div.appendChild(selectionRange.cloneContents());
        return div.innerHTML;
    } else return $('<div>').append(selectionRange.cloneContents()).html();
}
function $92069b7b1bcb2285$var$getContainingElement(selectionRange) {
    if (selectionRange.commonAncestorContainer) {
        const selectRangeElement = selectionRange.commonAncestorContainer;
        if (selectRangeElement.nodeType === 3) //Is TextNode
        return selectRangeElement.parentNode;
        return selectRangeElement;
    }
}
function $92069b7b1bcb2285$var$getFirstAndLastSelectionRect(selectionRange, clientRects) {
    // In Chrome triple clicking text will cause all the text in an element to be selected. When calling
    // getClientRects after a triple click, the array will contain rects for each line of highlighted text
    // in the highlighted element and also a clientRects for the adjacent sibling element even though no text
    // is highlighted inside it. If the endOffset is zero, we ignore this final clientRect because no text
    // is highlighted inside of it.
    //
    // Also, in Chrome, Safari and Firefox, get client rects return a clientRects representing each inline element
    // including rectangles for all nested elements. IE8 return many less rects, maybe just one for the ancestor
    // element containing the highlight or a clientRects for each line of highlight without individual rects for each
    // inline element
    const rects = {
        first: clientRects[0],
        last: clientRects[clientRects.length - 1]
    };
    if (selectionRange.endOffset !== 'undefined') //In IE, if we highlight on resolved inline comment, we will length of clientRects is 1
    {
        if (selectionRange.endOffset === 0 && clientRects.length > 1) rects.last = clientRects[clientRects.length - 2];
    }
    return rects;
}
function $92069b7b1bcb2285$var$getSelectionRects(selectionRange) {
    // if using documentation theme, get scrolltop of documentation theme content which is fixed size
    // certain browsers give the scrollTop on html element, some give it on the body element. this works in both.
    const scrollTop = window.scrollY;
    const scrollLeft = window.scrollX;
    let clientRects = selectionRange.getClientRects();
    // IE fails to provide client rects when highlighting a paragraph containing only an image or triple clicking to
    // highlight any paragraph containing content other than plain text. In this case, it is safe to assume parent
    // element dimensions will represent the highlighted area
    if (!clientRects.length && selectionRange.parentElement && selectionRange.parentElement()) {
        if ((0, $9wGTI.fg)('confluence-remove-jquery-from-selection-conversion')) {
            const parentElement = selectionRange.parentElement();
            const rect = parentElement.getBoundingClientRect();
            clientRects = [
                {
                    top: rect.top,
                    left: rect.left,
                    bottom: rect.top + scrollTop + rect.height,
                    right: rect.left + scrollLeft + rect.width
                }
            ];
        } else {
            const $parentElement = $(selectionRange.parentElement());
            const parentOffset = $parentElement.offset();
            if (parentOffset) clientRects = [
                {
                    top: parentOffset.top - scrollTop,
                    left: parentOffset.left - scrollLeft,
                    bottom: parentOffset.top + ($parentElement.height() || 0),
                    right: parentOffset.left + ($parentElement.width() || 0)
                }
            ];
        }
    }
    const rects = $92069b7b1bcb2285$var$getFirstAndLastSelectionRect(selectionRange, clientRects);
    /*
   * Calculates Create Issue dialog target area
   */ const getOverlap = function(firstRect, lastRect) {
        const overlap = {};
        overlap.top = firstRect.top;
        overlap.left = (firstRect.left || 0) + scrollLeft;
        overlap.bottom = lastRect.bottom;
        if (firstRect.left !== undefined && firstRect.right !== undefined && lastRect.left !== undefined && lastRect.right !== undefined) {
            if (firstRect.left >= lastRect.right) overlap.right = firstRect.right;
            else overlap.right = lastRect.right;
        }
        overlap.right = (overlap.right || 0) + scrollLeft;
        // adjust top for doc theme
        overlap.top = (overlap.top || 0) + scrollTop;
        overlap.bottom = (overlap.bottom || 0) + scrollTop;
        // set width and height
        overlap.width = overlap.right - overlap.left;
        overlap.height = overlap.bottom - overlap.top;
        return overlap;
    };
    /*
   * Calculates the action panel target area
   */ const getHighlightStart = function(rect) {
        const highlight = {};
        if (!rect) return highlight;
        highlight.width = rect.right - rect.left;
        highlight.height = rect.bottom - rect.top;
        highlight.left = rect.left + scrollLeft;
        highlight.right = rect.right + scrollLeft;
        highlight.top = rect.top + scrollTop;
        highlight.bottom = rect.bottom + scrollTop;
        return highlight;
    };
    return {
        first: getHighlightStart(rects.first),
        average: getOverlap(rects.first, rects.last)
    };
}
function $92069b7b1bcb2285$var$getSelectionText(selectionRange) {
    return (0, $2zMIV.textNormalize)(String(selectionRange));
}
/**
 * Generates javascript object containing the context of the selected text to help locate in storage format
 *
 * @param root container of content which can be selected
 * @param selectedText text that currently highlighted
 * @param selected range object representing the current selection
 * @param pageId the page id we're currently on
 * @param includeTraceForMatches a boolean stating whether or not to include a tree trace for each match
 * @return object containing metadata about the location of the selected text
 */ function $92069b7b1bcb2285$var$computeSearchTextObject(root, selectedText, selected, pageId, includeTraceForMatches) {
    // WS-2345 - Sticky header create comment flow is strange for now, disabling it until a better solution is found
    // https://product-fabric.atlassian.net/browse/CEMS-1100
    //
    // sticky headers create duplicate tables to work, which causes duplicate
    // text content to end up in the inline comment text string. ignore sticky
    // table content when not visible, and vice versa.
    // const inSticky = findStickyHeader(selected.startContainer);
    // const ignoreTable: HTMLElement[] = Array.from(
    //   inSticky
    //     ? root.querySelectorAll(
    //         ".pm-table-container .pm-table-wrapper tr:first-of-type"
    //       )
    //     : root.querySelectorAll(".pm-table-sticky-wrapper")
    // );
    const ignoreTable = Array.from(root.querySelectorAll('.pm-table-sticky-wrapper'));
    const ignoredNodes = Array.from(root.querySelectorAll($92069b7b1bcb2285$export$c5bc138cfa79c2b2));
    const { text: text, nodesStartPos: nodesStartPos, nodes: nodes } = (0, $kbVzJ.indexTextNodes)(root, [
        ...ignoredNodes,
        ...ignoreTable
    ]);
    const { index: index, numMatches: numMatches, matchTraceList: matchTraceList } = (0, $kbVzJ.findMatches)(text, selectedText, selected.startContainer, selected.startOffset, nodesStartPos, nodes, includeTraceForMatches);
    const searchTextObj = {
        pageId: pageId,
        selectedText: selectedText,
        index: index,
        numMatches: numMatches
    };
    if (matchTraceList) searchTextObj.matchTraceList = matchTraceList;
    return searchTextObj;
}
function $92069b7b1bcb2285$export$4ba66d628a1e5980(contentContainer, selectionRange, pageId, lastModified, getTraceForMatches) {
    const rawText = $92069b7b1bcb2285$var$getSelectionText(selectionRange);
    const text = rawText.trim();
    let searchText;
    // It finds all the occurrences of selected text.
    // Since if I select word "is" there maybe a lot occurrences on the page.
    // searchText.index tells the backend which one is really the one I selected.
    // That is among, for example 20 matches, the 5th match is my selection.
    if (text) searchText = $92069b7b1bcb2285$var$computeSearchTextObject(contentContainer, // It is important to pass raw text here
    rawText, selectionRange, pageId, getTraceForMatches);
    return getTraceForMatches ? searchText.matchTraceList : {
        text: text,
        searchText: searchText,
        area: $92069b7b1bcb2285$var$getSelectionRects(selectionRange),
        html: $92069b7b1bcb2285$var$getSelectionHTML(selectionRange),
        containingElement: $92069b7b1bcb2285$var$getContainingElement(selectionRange),
        range: selectionRange,
        lastModified: lastModified
    };
}
function $92069b7b1bcb2285$export$b297c7070f7a854(contentContainer, selectionRange, pageId) {
    const matchTraceList = $92069b7b1bcb2285$export$4ba66d628a1e5980(contentContainer, selectionRange, pageId, null, true);
    return matchTraceList || [];
}
module.exports["IGNORE_SELECTORS"] = $92069b7b1bcb2285$export$c5bc138cfa79c2b2;
module.exports["convertSelectionToLegacyFormat"] = $92069b7b1bcb2285$export$4ba66d628a1e5980;
module.exports["getMatchTraces"] = $92069b7b1bcb2285$export$b297c7070f7a854;

});

parcelRegister("24amZ", function(module, exports) {
var $0096831e5a63492d$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $0096831e5a63492d$export$b21a3980a7aad169;

});

parcelRegister("l2hqi", function(module, exports) {
var $d6376875f96c1896$export$2df6d049e5bad28e = /*#__PURE__*/ function(InlineCommentMode) {
    InlineCommentMode["EDIT"] = "edit";
    InlineCommentMode["VIEW"] = "view";
    InlineCommentMode["LIVE"] = "live";
    return InlineCommentMode;
}({});
module.exports["InlineCommentMode"] = $d6376875f96c1896$export$2df6d049e5bad28e;

});

parcelRegister("8Mzkb", function(module, exports) {
/* CreateComment.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @graphql cc */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");


var $1KmJq = parcelRequire("1KmJq");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $gdv5Z = parcelRequire("gdv5Z");


var $inPa6 = parcelRequire("inPa6");


var $7EEGh = parcelRequire("7EEGh");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $3YBks = parcelRequire("3YBks");


var $8Ss4E = parcelRequire("8Ss4E");


var $gtj7V = parcelRequire("gtj7V");


var $aJPUt = parcelRequire("aJPUt");


var $aGjYc = parcelRequire("aGjYc");


var $hXzKU = parcelRequire("hXzKU");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $bSvtO = parcelRequire("bSvtO");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $cAdj8 = parcelRequire("cAdj8");


var $kmHPt = parcelRequire("kmHPt");


var $daq5m = parcelRequire("daq5m");


var $isdzP = parcelRequire("isdzP");


var $6cWI7 = parcelRequire("6cWI7");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $9CnRS = parcelRequire("9CnRS");


var $aMfLn = parcelRequire("aMfLn");


var $9QIM2 = parcelRequire("9QIM2");


var $3Xfi8 = parcelRequire("3Xfi8");


var $eA7s6 = parcelRequire("eA7s6");


var $k8e76 = parcelRequire("k8e76");


var $56QzY = parcelRequire("56QzY");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


var $hl0fg = parcelRequire("hl0fg");


var $7aRa9 = parcelRequire("7aRa9");


var $5pQ1Y = parcelRequire("5pQ1Y");


var $en1dX = parcelRequire("en1dX");


var $9FoVw = parcelRequire("9FoVw");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $6mKj3 = parcelRequire("6mKj3");


var $b0EGa = parcelRequire("b0EGa");


var $a3q17 = parcelRequire("a3q17");


var $B3Avz = parcelRequire("B3Avz");

const $f4c77c6e390a7914$export$d26c1daa0321174b = (0, $aJPUt.ExperienceTimeout).CREATE_COMMENT_PUBLISH;
const $f4c77c6e390a7914$var$relativeFilePath = 'annotation-provider-inline-comments/CreateComment';
const $f4c77c6e390a7914$var$i18n = (0, $cgtv4.defineMessages)({
    unableToApplyTitle: {
        id: "annotation-provider-inline-comments.create.error.unable.to.apply.title",
        defaultMessage: "Something went wrong"
    },
    unableToApplyDescription: {
        id: "annotation-provider-inline-comments.create.error.unable.to.apply.description",
        defaultMessage: "We failed to display your comment. To view it, refresh now."
    },
    refreshContentLink: {
        id: "annotation-provider-inline-comments.refresh.content.link",
        defaultMessage: "Refresh content"
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f4c77c6e390a7914$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt49l6b",
            __cmplp.className
        ])
    });
});
const $f4c77c6e390a7914$var$styles = {
    commentEditorContainer: "_ca0qutpp"
};
const $f4c77c6e390a7914$var$getNodeType = (element, annotationId)=>{
    const nodeWithAnnotationWrapper = element.querySelector(`[id="${annotationId}"]`);
    if (nodeWithAnnotationWrapper) {
        const firsChildren = nodeWithAnnotationWrapper.firstChild;
        if (firsChildren?.nodeType === Node.TEXT_NODE) return 'text';
        const targetNode = nodeWithAnnotationWrapper.querySelector('[data-node-type]');
        if (targetNode) return targetNode.dataset.nodeType;
    }
    return 'unknown';
}; // Exporting for testing cases
const $f4c77c6e390a7914$export$d4044f5b8f4bc73a = (setWasDraftAnnotationRemoved)=>(mutationList, observer)=>{
        for (const mutation of mutationList){
            if (mutation.type === 'childList') {
                if (mutation.removedNodes.length > 0) mutation.removedNodes.forEach((node)=>{
                    const nodeClassList = Array.from(node.classList ?? []); // COMMENTS-4308 - If any part of the draft annotation was removed, check if the entirity of the draft
                    // 				   was removed, if so, we need to disable the editor buttons as the comment will fail
                    if (nodeClassList.includes('ak-editor-annotation-draft')) {
                        if (document.querySelector('.ak-editor-annotation-draft') === null) {
                            // Tell the editor that the draft annotation was removed
                            setWasDraftAnnotationRemoved(true);
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.debugPoint(`CreateComment dialog - draft annotation removed`); // Disconnect the observer since we no longer need it
                            observer.disconnect();
                        }
                    }
                });
            }
        }
    };
const $f4c77c6e390a7914$var$CommentEditorContainer = ({ children: children })=>(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $f4c77c6e390a7914$var$styles.commentEditorContainer
    }, children) : children;
const $f4c77c6e390a7914$var$CreateCommentComponent = ({ pageId: pageId, annotationElement: annotationElement, selectionOptions: selectionOptions, onClose: onClose, onCreate: onCreate, isEditor: isEditor, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, flags: flags, isOffline: isOffline })=>{
    const started = (0, $42omo.useRef)(false);
    const pageClass = (0, $9QIM2.usePageClass)();
    if (started.current === false) {
        (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.start();
        started.current = true;
    }
    const initialisedSelection = (0, $42omo.useRef)(false);
    if (selectionOptions && selectionOptions?.createdFrom === 'EDITOR' && initialisedSelection.current === false) {
        initialisedSelection.current = true;
        if (selectionOptions.inlineNodeTypes) (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            inlineNodeTypes: selectionOptions.inlineNodeTypes
        });
    }
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const lastContentFetchTime = (0, $42omo.useRef)(1);
    const requestTimeoutHandle = (0, $42omo.useRef)();
    const sidebarEl = (0, $42omo.useRef)(null);
    const draftAnnotationMutationObserverRef = (0, $42omo.useRef)();
    const commentContainerElementRef = (0, $42omo.useRef)(null);
    const { documentUpdated: documentUpdated, publishedDocumentVersion: publishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { setRefetchContent: setRefetchContent } = (0, $5pQ1Y.useContentRefetchDispatch)();
    const createdAnnotationId = (0, $42omo.useRef)(null);
    const createdCommentId = (0, $42omo.useRef)(null);
    const [shouldRefetch, setShouldRefetch] = (0, $42omo.useState)(false);
    const [wasDraftAnnotationRemoved, setWasDraftAnnotationRemoved] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { addUnresolvedInlineComment: addUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { addNewCommentThreads: addNewCommentThreads } = (0, $8i27m.useCommentsDataActions)();
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey } = (0, $3mVfX.useCommentsPanelActions)();
    const { isSticky: isSticky } = (0, $3Xfi8.useShouldCommentSidebarBeSticky)({
        annotationElement: annotationElement,
        isEditor: !!isEditor
    });
    const sidebarOffset = (0, $eA7s6.useCommentSidebarOffset)({
        isEditor: Boolean(isEditor),
        annotationElement: annotationElement,
        windowWidth: windowWidth,
        isSticky: isSticky
    }); // Hide OmniBar while this component is mounted (viewing inline comment)
    const { requestHideOmniBar: requestHideOmniBar, releaseHideOmniBar: releaseHideOmniBar } = (0, $b0EGa.useOmniBarVisibilityActions)();
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $9wGTI.fg)('cc-engagement-omnibar-hide-inline-comments')) {
            requestHideOmniBar();
            return ()=>releaseHideOmniBar();
        }
    }, [
        requestHideOmniBar,
        releaseHideOmniBar
    ]); // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [createCommentFn] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation CreateCommentInlineCommentMutation($input:CreateInlineCommentInput!$pageId:ID!$includeReactionsAndReplies:Boolean!){createInlineComment(input:$input){id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}createdAt{value}createdAtNonLocalized location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment")@include(if:$includeReactionsAndReplies){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}replies@include(if:$includeReactionsAndReplies){id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}createdAt{value}createdAtNonLocalized reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}}`);
    const { createInlineCommentInterop: createInlineCommentInterop } = (0, $6cWI7.useCreateInlineCommentMutation)({
        contentId: pageId
    });
    const { pageInfo: pageInfo, loading: loading, error: error, refetch: refetch } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first',
        onError: (err)=>{
            experienceTracker.stopOnError({
                name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                error: err
            });
        }
    });
    (0, $42omo.useEffect)(()=>{
        // should only refresh on the Content Out of date `Refresh` CTA is clicked
        if (documentUpdated && shouldRefetch && refetch) {
            refetch();
            setShouldRefetch(false);
            onClose && onClose();
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentUpdated,
        shouldRefetch
    ]);
    (0, $42omo.useEffect)(()=>{
        const metadata = document.querySelector('meta[name=confluence-request-time]');
        if (metadata) {
            const fetchTime = Number(metadata.getAttribute('content'));
            lastContentFetchTime.current = isNaN(fetchTime) ? 1 : fetchTime;
        }
        if (pageMode !== (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
            const editorTextArea = document.getElementById('ak-editor-textarea');
            draftAnnotationMutationObserverRef.current = new MutationObserver($f4c77c6e390a7914$export$d4044f5b8f4bc73a(setWasDraftAnnotationRemoved)); // We need to watch the whole editorTextArea because highlights could
            if (editorTextArea) draftAnnotationMutationObserverRef.current.observe(editorTextArea, {
                childList: true,
                subtree: true
            });
        }
        return ()=>{
            if (pageMode !== (0, $cD1qu.PageMode).VIEW && draftAnnotationMutationObserverRef.current && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) draftAnnotationMutationObserverRef.current.disconnect();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Check for highlight element on mount - fail experience if createComment renders without a highlight
    // This tracks the scenario where createComment re-renders on close of the comment box without a highlight
    (0, $42omo.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('confluence_comment_enable_exp_create_rerenderer', 'isEnabled', true)) return;
         // Use a small delay to allow the DOM to settle after any state changes
        const timeoutId = setTimeout(()=>{
            const draftAnnotationElement = $f4c77c6e390a7914$export$292a5d148db8f191(); // Fail experience if createComment renders without a highlight
            if (!draftAnnotationElement && !wasDraftAnnotationRemoved) (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('CreateComment renders without highlight'));
        }, 100);
        return ()=>clearTimeout(timeoutId); // Only run on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const saveAttemptedTracker = (0, $42omo.useRef)({
        lastMutationSucceeded: false,
        totalSaves: 0,
        failedSaves: 0
    });
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            const savesWithoutError = // hit, the experience will already have completed in the `handleSaveComment`.
            saveAttemptedTracker.current.totalSaves - saveAttemptedTracker.current.failedSaves;
            if (saveAttemptedTracker.current.failedSaves > 0) (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
                // eslint-disable-next-line react-hooks/exhaustive-deps
                failedSaves: saveAttemptedTracker.current.failedSaves
            });
            if (savesWithoutError > 1) {
                // At the point this is dismounting -- we don't know for certain if the user intended for this to be discarded or not
                // so we hard fail the full experience (it's possible the dismount is because the second save has worked and
                // the UI is about to load the new comment)
                (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
                    savesWithoutError: savesWithoutError
                });
                const msg = 'User clicked save, but UI did not update following successful save'; // we log a debug point and continue with the flow, since creation is not necessarily failing
                (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.debugPoint(msg);
            }
            if (saveAttemptedTracker.current.lastPublishFailure) {
                if (saveAttemptedTracker.current.lastMutationSucceeded) {
                    // in the case there was a publish failure, but the last mutation succeeded -- we assume the dismount is
                    // because the ui is about to load the new comment - in this case we only mark the experience as a soft
                    // failure (we'll capture more details and fail in the final experience step)
                    (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.softFail(// eslint-disable-next-line react-hooks/exhaustive-deps -- This is intentionally using a ref value due to the indirect flow of comment updates
                    saveAttemptedTracker.current.lastPublishFailure);
                    return;
                } else {
                    // In this scenario -- the user attempted to save at least once, got a network error, and gave up on
                    // trying to create the comment
                    // For a subset of errors -- the user is presented with a human readable error message describing that
                    // the comment creation failure is due to the content changing (e.g. the user has edited the page) and
                    // that they need to refresh the page to apply the comment.  In this scenario we don't treat the comment
                    // creation as a failure, but rather we want to mark the experience as aborted.
                    const contentChangedErrorSubstrings = [
                        'Invalid arguments provided for matchIndex and/or numMatches',
                        'Failed to insert highlight, invalid originalSelection, numMatches, or matchIndex',
                        'Selection was made against a stale version of the content',
                        'Published Version out of date. Please provide correct published version.'
                    ];
                    const isContentChangedError = contentChangedErrorSubstrings.some((substring)=>// eslint-disable-next-line react-hooks/exhaustive-deps
                        saveAttemptedTracker.current.lastPublishFailure?.message.includes(substring));
                    if (isContentChangedError) {
                        (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                            abortReason: 'Unable to apply annotation to document'
                        });
                        return;
                    } // This is handled in the UI appropriately, and we should abort not fail
                    const permissionErrorSubstring = 'Could not create content with type comment';
                    const isPermissionError = saveAttemptedTracker.current.lastPublishFailure?.message.includes(permissionErrorSubstring);
                    if (isPermissionError) (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                        abortReason: 'User does not have space permission to create comments'
                    });
                    (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.stopOnError(// eslint-disable-next-line react-hooks/exhaustive-deps -- This is intentionally using a ref value due to the indirect flow of comment updates
                    saveAttemptedTracker.current.lastPublishFailure);
                    return;
                }
            }
            if (saveAttemptedTracker.current.lastMutationSucceeded) {
                (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.complete();
                return;
            } // In this case the user did not attempt to save the comment, and so we assume this was
            // an intentional discard of the comment.
            // So we abort the draftToPublishExperience here, along with any unfinished initExperience.
            const abortReason = 'Create Comment UI dismissed';
            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                abortReason: abortReason
            });
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.abort({
                abortReason: abortReason
            });
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).cancel();
        };
    }, []);
    const saveAttemptedCounts = (0, $42omo.useRef)({
        total: 0,
        failedSaves: 0
    });
    const failPublishExperience = (0, $42omo.useCallback)((commentPublishError, translatedErrorMsg)=>{
        // COMMENTS-1879 - Only log unexpected errors or annotation application error as failures
        if ((0, $isdzP.isUnexpectedError)(translatedErrorMsg)) experienceTracker.stopOnError({
            name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            error: commentPublishError
        });
        else (0, $7Sm4c.markErrorAsHandled)(commentPublishError);
    }, [
        experienceTracker
    ]);
    const onCacheUpdateError = (0, $42omo.useCallback)((cacheError)=>{
        const { message: message } = (0, $isdzP.parseError)(cacheError);
        failPublishExperience(cacheError, (0, $isdzP.getTranslatedError)(message));
    }, [
        failPublishExperience
    ]);
    const handleSaveCommentWithTimeout = (timeoutInMs, saveMutation)=>{
        const timeout = new Promise((_resolve, reject)=>{
            requestTimeoutHandle.current = setTimeout(()=>{
                experienceTracker.stopOnError({
                    name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                    error: new Error(`Request took longer than ${timeoutInMs}ms`)
                });
                return reject({
                    error: (0, $9CnRS.i18n).createTimeout
                });
            }, timeoutInMs);
        });
        return Promise.race([
            timeout,
            saveMutation
        ]).finally(()=>{
            if (requestTimeoutHandle.current) clearTimeout(requestTimeoutHandle.current);
        });
    };
    const handleSaveComment = (adf, onSuccess)=>{
        saveAttemptedTracker.current.totalSaves = saveAttemptedTracker.current.totalSaves + 1;
        saveAttemptedTracker.current.lastMutationSucceeded = false;
        saveAttemptedCounts.current.total = saveAttemptedCounts.current.total + 1;
        createdAnnotationId.current = null;
        createdCommentId.current = null;
        if (!selectionOptions) // We likely will never get here, but just in case
        return Promise.reject({
            error: (0, $9CnRS.i18n).unableToGenerateStep
        });
        (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.VIEW_PAGE_DIRECT_COMMENT_DATA_FLOW_EXPERIENCE),
            attributes: {
                pageId: pageId,
                pageMode: pageMode,
                isEditor: isEditor
            }
        });
        (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).start();
        (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentCreationStart');
        (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            attributes: {
                timeout: $f4c77c6e390a7914$export$d26c1daa0321174b
            }
        });
        const { numMatches: numMatches, matchIndex: matchIndex, originalSelection: originalSelection, createdFrom: createdFrom, step: step, targetNodeType: targetNodeType } = selectionOptions; // eslint-disable-next-line confluence-feature-gating/inline-usage
        const variables = {
            input: {
                containerId: pageId,
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: 'ATLAS_DOC_FORMAT'
                },
                numMatches: numMatches,
                matchIndex: matchIndex,
                originalSelection: originalSelection,
                createdFrom: createdFrom,
                lastFetchTimeMillis: lastContentFetchTime.current,
                publishedVersion: publishedDocumentVersion,
                ...!!step && {
                    step: (0, $aMfLn.constructStepForGql)(step)
                }
            },
            pageId: pageId,
            includeReactionsAndReplies: false
        }; // Note -- this mixes data saving logic and UI application logic.
        // And when the UI logic fails, the result is that the user is left with
        // the ui looking like the comment failed to save.
        // This should be refactored to separate the two concerns, and on a UI application
        // failure, we should encourage users to refresh (and mark the experience as failed).
        let succeededPublish = false;
        const onCreateSuccess = (retVal)=>{
            saveAttemptedTracker.current.lastMutationSucceeded = true;
            const { data: data } = retVal;
            if (requestTimeoutHandle.current) clearTimeout(requestTimeoutHandle.current);
            succeededPublish = true;
            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.publishSucceeded(); // Mark comment creation end for both cohorts
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentCreationEnd');
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentDataLoadStart');
            const annotationId = data?.createInlineComment?.location?.inlineMarkerRef;
            const commentId = data?.createInlineComment?.id;
            if (!annotationId || !commentId) throw new Error(`Comment was not saved correctly - either annotationId '${annotationId}' or commentId '${commentId}' were undefined`);
            createdAnnotationId.current = annotationId;
            createdCommentId.current = commentId; // Reset the content changing flag
            resetContentChanged(); // Grab the marker ref id returned and update the editor/renderer
            try {
                onCreate(annotationId, data?.createInlineComment);
            } catch (e) {
                // We generate errors in renderer, but this will also handle the editor case
                throw new Error(`Unable to apply annotation to document - ${e.message}`);
            } // Update the unresolved inline comments count
            addUnresolvedInlineComment(annotationId, pageMode); // For experiment cohort, we pass the mutation data to onCreate
            // The experiment success and data load completion will be handled in AnnotationsContext
            // after the view component renders the new data
            const newComment = {
                // (Need to coerce the data from the new Comments Data Manager's mutation because it is
                // defined using the new Relay-generated types that define option fields as "| null | undefined"
                // but the original Apollo-generated types define them as just "| null".  These aren't compatible
                // without the coercion even though the "if (value)" or "value?." expressions would work the same.)
                ...data?.createInlineComment,
                isOpen: true,
                type: (0, $8i27m.CommentType).INLINE,
                wasRemovedByAnotherUser: false,
                replies: [],
                reactionsSummary: null
            };
            addNewCommentThreads({
                general: {},
                inline: {
                    [annotationId]: newComment
                }
            }); // Create inline comment track event
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'created',
                    actionSubject: 'comment',
                    actionSubjectId: commentId,
                    objectType: 'page',
                    objectId: pageId,
                    source: isEditor ? 'editPageScreen' : 'viewPageScreen',
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        source: (0, $en1dX.AnalyticsSource).STANDALONE,
                        commentType: (0, $8i27m.CommentType).INLINE,
                        parentCommentId: null,
                        isReply: false,
                        pageMode: pageMode,
                        isLivePage: createdFrom === 'LIVE',
                        navdexPointType: (0, $56QzY.END),
                        inlineNodeTypes: selectionOptions.inlineNodeTypes,
                        ...annotationElement && !isEditor && {
                            nodeType: $f4c77c6e390a7914$var$getNodeType(annotationElement, annotationId)
                        },
                        ...!isEditor && {
                            targetNodeType: targetNodeType
                        }
                    }
                }
            }).fire(); // Reset the editor
            onSuccess();
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                commentType: 'inline',
                entryPoint: 'create-comment',
                annotationId: annotationId
            }); /*
           * On editor pages, the view-inline-comment experience is started by the editor when the
           * created annotation is automatically selected after successful comment creation. For
           * editor pages, we update the attributes here to ensure that the experience is tracked
           * with the correct entry point.
           */ 
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_create')) {
                const attributes = {
                    annotationId: annotationId,
                    entryPoint: $f4c77c6e390a7914$var$relativeFilePath,
                    pageClass: pageClass
                };
                if (pageClass === 'renderer') experienceTracker.start({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        ...attributes
                    }
                });
                else if (pageClass === 'editor') experienceTracker.updateAttributes({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    attributes: attributes
                });
                if (isCommentsPanelShown) experienceTracker.fail({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('Comments panel is visible when it should not be'),
                    attributes: {
                        stopPoint: $f4c77c6e390a7914$var$relativeFilePath
                    }
                });
            }
        };
        const onCreateFailure = (err)=>{
            saveAttemptedTracker.current.failedSaves = saveAttemptedTracker.current.failedSaves + 1;
            saveAttemptedCounts.current.failedSaves = saveAttemptedCounts.current.failedSaves + 1;
            experienceTracker.fail({
                name: (0, $irVI7.VIEW_PAGE_DIRECT_COMMENT_DATA_FLOW_EXPERIENCE),
                error: err,
                attributes: {
                    pageId: pageId,
                    pageMode: pageMode,
                    isEditor: isEditor,
                    pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui'
                }
            });
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).cancel();
            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.debug({
                error: err,
                createAnalyticsEvent: createAnalyticsEvent,
                extraAttributes: {
                    pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui'
                }
            });
            if (!succeededPublish) saveAttemptedTracker.current.lastPublishFailure = err;
            let contentOutOfDate = false; // Get a truncated graphql error message
            const { errorId: errorId, message: message } = (0, $isdzP.parseError)(err);
            const translatedError = (0, $isdzP.getTranslatedError)(message); // COMMENTS-1879 - The backend will fall back to the old method of trying to make string matches if the content
            // is out of date. If the BE fails to apply a comment when using the old fallback method we should log it
            if ((0, $isdzP.isHighlightError)(translatedError)) {
                // Send the analytics event
                const analyticsObject = {
                    source: 'viewPage',
                    objectType: 'page',
                    objectId: pageId,
                    action: 'invalid',
                    actionSubject: 'highlight',
                    actionSubjectId: 'inlineComment',
                    attributes: {
                        errorMessage: message,
                        editor: 'FABRIC',
                        framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                        errorId: errorId,
                        highlightOrigin: 'userHighlight' // TODO: Do we need to programmatically track this?
                    }
                };
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: analyticsObject
                }).fire();
                contentOutOfDate = true;
            }
            failPublishExperience(err, translatedError); // Use the existing value if it's already set or is an out of date error
            contentOutOfDate = contentOutOfDate || (0, $isdzP.isOutOfDateError)(translatedError); // In the case of an annotation error, we should show a flag to the user to let them know
            // their comment has been saved and they need to refresh the content (view mode only)
            if ((0, $isdzP.isAnnotationError)(translatedError)) {
                const CREATE_ERROR_FLAG_ID = `create-error-${Date.now()}`;
                const getAnnotationErrorFlagActions = ()=>{
                    if (pageMode === (0, $cD1qu.PageMode).VIEW) // Only show the refetch content action on view mode as it's not applicable in editor/live
                    return [
                        {
                            content: formatMessage($f4c77c6e390a7914$var$i18n.refreshContentLink),
                            onClick: ()=>{
                                setRefetchContent(true);
                                handleOnClose();
                                flags.hideFlag(CREATE_ERROR_FLAG_ID);
                            }
                        }
                    ];
                    else {
                        // pageMode === PageMode.EDITOR || PageMode.LIVE
                        if (createdAnnotationId.current && createdCommentId.current && translatedError === (0, $9CnRS.i18n).unableToApplyDanglingCommentAnnotation && (0, $6mKj3.expValEquals)('confluence_fe_show_created_dangling_comment_flag', 'isEnabled', true)) return [
                            {
                                content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                                onClick: ()=>{
                                    if (!isCommentsPanelShown) showCommentsPanel({
                                        openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                                    });
                                    else setCurrentView((0, $3mVfX.ViewValues).DELETED_CONTENT);
                                    setCurrentlySelectedThreadKey(createdAnnotationId.current);
                                    (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                        scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                        context: (0, $9FoVw.NavigationContext).PANEL,
                                        block: 'center',
                                        annotationId: createdAnnotationId.current,
                                        commentId: createdCommentId.current,
                                        commentType: 'INLINE',
                                        annotationClicked: true,
                                        expectedView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                                    });
                                    flags.hideFlag(CREATE_ERROR_FLAG_ID);
                                }
                            }
                        ];
                         // TODO: Add more actions for editor/live if needed
                    }
                    return [];
                };
                flags.showWarningFlag({
                    id: CREATE_ERROR_FLAG_ID,
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f4c77c6e390a7914$var$i18n.unableToApplyTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), translatedError === (0, $9CnRS.i18n).unableToApplyAnnotation ? $f4c77c6e390a7914$var$i18n.unableToApplyDescription : translatedError),
                    actions: getAnnotationErrorFlagActions()
                }); // Log the occurance through analytics so we can still track it
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                        objectType: 'page',
                        objectId: pageId,
                        action: 'failed',
                        actionSubject: 'applyAnnotation',
                        actionSubjectId: 'inlineComment',
                        attributes: {
                            errorMessage: message,
                            editor: 'FABRIC',
                            framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                            isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                            tenantId: cloudId,
                            userId: userId,
                            pageId: pageId
                        }
                    }
                }).fire(); // Some code duplication.
                // Not extracting common code since `else` will be deleted after experiment is shipped.
                if ((0, $6mKj3.expValEquals)('confluence_fe_show_created_dangling_comment_flag', 'isEnabled', true)) (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                    abortReason: 'Unable to apply annotation to document',
                    attributes: {
                        detailedMessage: message,
                        ...errorId ? {
                            errorId: errorId
                        } : {},
                        pageMode: pageMode,
                        context: isEditor ? 'editor' : 'renderer',
                        pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui',
                        pageId: pageId
                    }
                });
                else (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.fail(new Error('Unable to apply annotation to document'), {
                    detailedMessage: message,
                    ...errorId ? {
                        errorId: errorId
                    } : {},
                    pageMode: pageMode,
                    context: isEditor ? 'editor' : 'renderer',
                    pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui',
                    pageId: pageId
                });
                onClose && onClose();
                return;
            }
            // CommentEditor expects a translated error message otherwise it fails
            // TODO: CommentEditor should likely just receive the translated message
            // rather than expect the object needed for FormattedMessage
            return Promise.reject({
                error: contentOutOfDate ? (0, $9CnRS.i18n).contentOutOfDate : translatedError,
                contentOutOfDate: contentOutOfDate
            });
        };
        // Wrap the createCommentFn mutation with the interop logic that handles both the direct Apollo
        // mutation path and the new hook-based for the Comments Data Manager
        const commentCreationInteropWrapper = (options)=>createInlineCommentInterop({
                originalMutationFn: createCommentFn,
                options: options,
                onCacheUpdateError: onCacheUpdateError
            });
        if ((0, $9wGTI.fg)('confluence_frontend_add_inline_comment_timeout')) return handleSaveCommentWithTimeout($f4c77c6e390a7914$export$d26c1daa0321174b, commentCreationInteropWrapper({
            variables: variables
        }).then(onCreateSuccess).catch(onCreateFailure));
        else return commentCreationInteropWrapper({
            variables: variables
        }).then(onCreateSuccess).catch(onCreateFailure);
    };
    const handleOnClose = (0, $42omo.useCallback)((hasContentChanged)=>{
        const reason = hasContentChanged ? 'comment discarded by user' : 'empty comment discarded by user';
        experienceTracker.abort({
            name: (0, $irVI7.ADD_INLINE_COMMENT_EXPERIENCE),
            reason: reason
        }); // Clearing reply draft is handled in the comment editor
        (0, $aGjYc.clearCommentDraft)(isEditor ? 'edit-inline' : 'inline', 'create');
        onClose && onClose();
    }, [
        experienceTracker,
        isEditor,
        onClose
    ]);
    const onEditorLoad = ()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.ADD_INLINE_COMMENT_LOAD_EXPERIENCE)
        });
        const draftAnnotationElement = $f4c77c6e390a7914$export$292a5d148db8f191();
        if (!draftAnnotationElement && !wasDraftAnnotationRemoved) {
            // We have handling to show a message when we detect the draft annotation was removed, indicated by
            // `wasDraftAnnotationRemoved=true`. So we only need to fail the experience if we unexpectedly cannot find
            // the draftAnnotationElement, indicated by `wasDraftAnnotationRemoved=false`
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('No annotation element'));
            return;
        }
        setTimeout(()=>{
            // There are multiple useEffects involved in positioning the comment UI.
            // This works around this by only marking the experience as complete after
            // a short timeout + animation frame.
            requestAnimationFrame(()=>{
                // In the Editor and Renderer, the comment UI is positioned relative to slightly different
                // elements.
                if (!draftAnnotationElement) {
                    (0, $3YBks.createInlineCommentCompoundExperience).initExperience.abort({
                        abortReason: 'Draft annotation removed from document'
                    });
                    return;
                } else if (!sidebarEl.current) (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('Missing create comment ui'));
                else {
                    const commentUIVerticalDistanceFromAnnotation = Math.abs(draftAnnotationElement.getBoundingClientRect().top - sidebarEl.current.getBoundingClientRect?.().top); // The 40 pixel allowance has been arbitrarily chosen to allow for some wiggle room
                    if (commentUIVerticalDistanceFromAnnotation > 40) {
                        const isVisible = sidebarEl.current.checkVisibility();
                        if (isVisible) {
                            // if it's fully visible, but misaligned, we don't treat this as a failure
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.debug({
                                error: new Error('View Created Comment UI too far from annotation'),
                                createAnalyticsEvent: createAnalyticsEvent,
                                extraAttributes: {
                                    misalignedBy: commentUIVerticalDistanceFromAnnotation
                                }
                            });
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.complete();
                        } else {
                            (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
                                misalignedBy: commentUIVerticalDistanceFromAnnotation
                            });
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Draft Comment UI is setup too far from annotation'));
                        }
                    } else (0, $3YBks.createInlineCommentCompoundExperience).initExperience.complete();
                }
            });
        }, 1000);
    };
    if (loading || error) {
        (0, $3YBks.createInlineCommentCompoundExperience).initExperience.debugPoint(`CreateComment dialog ${loading ? 'loading' : 'error'}`, {
            error: error?.message ?? '',
            loading: loading
        });
        return null;
    }
    const spaceId = pageInfo?.space?.id ?? '';
    const pageType = pageInfo?.type ?? ''; // User page permissions
    const operations = pageInfo?.operations || [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    const canAddAttachment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment'); // The user can upload media only if they have update permissions for the page if confluence_comment_use_comment_media_endpoint FG is off
    const hasMediaUploadPermissions = (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? canAddComment && canAddAttachment : operations.some((op)=>op?.operation === 'update' && op?.targetType === pageType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $B3Avz.CommentSidebar), {
        pageId: pageId,
        onClose: handleOnClose,
        isEditor: isEditor,
        annotationElement: annotationElement,
        sidebarOffset: sidebarOffset,
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        sidebarEl: sidebarEl,
        isSticky: isSticky,
        isFabricPage: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f4c77c6e390a7914$var$Container, {
        ref: commentContainerElementRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $daq5m.CommentAuthor), {
        size: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? 'small' : 'medium',
        commentMode: "create",
        userId: userId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f4c77c6e390a7914$var$CommentEditorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXzKU.LazyCommentEditor // @ts-ignore FIXME: `pageId` can be `undefined` here, and needs proper handling
    ), {
        pageId: pageId,
        pageType: pageType,
        spaceId: spaceId,
        appearance: "chromeless",
        EditorComponent: (0, $7EEGh.ChromelessEditor),
        onSaveComment: handleSaveComment,
        onContentChange: onChange,
        commentMode: "create",
        commentType: isEditor ? 'edit-inline' : 'inline',
        onEditorReady: onEditorLoad,
        hideWatchCheckbox: true,
        pageMode: isEditor ? 'edit' : 'view',
        shouldWarnOnInternalNavigation: true,
        useNewWarningModal: true,
        setShouldRefetch: ()=>setShouldRefetch(true),
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        commentContainerElementRef: commentContainerElementRef,
        wasDraftAnnotationRemoved: wasDraftAnnotationRemoved,
        isStandaloneComment: true,
        isOffline: isOffline
    }))));
};
const $f4c77c6e390a7914$export$b217475cf0d7b767 = (0, $7aRa9.withFlags)($f4c77c6e390a7914$var$CreateCommentComponent); /**
                                                                 *
                                                                 * Exported for testing purposes only
                                                                 *
                                                                 * This function is used to find the draft annotation element in the DOM.
                                                                 * It checks both the renderer and editor for the draft annotation element.
                                                                 *
                                                                 * In some scenarios, there are duplicate draft annotations in the DOM such
                                                                 * as in the renderer where the dom for table headers is repeated.
                                                                 *
                                                                 * To mitigate this, we get all possible draft annotation elements and
                                                                 * and return the first one that has a height greater than 0.
                                                                 *
                                                                 * If no draft annotation element is found, it returns null.
                                                                 */ 
function $f4c77c6e390a7914$export$292a5d148db8f191() {
    const possibleAnnotations = document.querySelectorAll('[data-annotation-draft-mark="true"], .ak-editor-annotation-draft');
    if (possibleAnnotations.length === 1) // In cases where there is only one draft annotation, we can return it directly
    // and avoid the performance hit where reflow is triggered by checking if the
    // annotation has a height greater than 0.
    return possibleAnnotations[0];
    for(let i = 0; i < possibleAnnotations.length; i++){
        if (possibleAnnotations[i].getBoundingClientRect().height > 0) return possibleAnnotations[i];
    }
    return null;
}
module.exports["CreateComment"] = $f4c77c6e390a7914$export$b217475cf0d7b767;

});

parcelRegister("aGjYc", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $7W8i8 = parcelRequire("7W8i8");

const $9a76668fa978df44$export$6af3d18059afaa9e = 'outOfDate';
const $9a76668fa978df44$var$logger = (0, $7W8i8.getLogger)('comment-draft-utils');
const $9a76668fa978df44$var$getKey = (type, mode)=>{
    switch(type){
        case 'edit-inline':
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_REPLY;
        case 'inline':
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_REPLY;
        case 'page':
        default:
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_REPLY;
    }
};
const $9a76668fa978df44$export$a4f0a5ceed96eae8 = (adf, pageId, type, mode)=>{
    let b64EncodedDraftObj = null;
    const key = $9a76668fa978df44$var$getKey(type, mode);
    const draftObj = JSON.stringify({
        pageId: pageId,
        adf: adf
    });
    try {
        b64EncodedDraftObj = btoa(draftObj);
    } catch (e) {
        $9a76668fa978df44$var$logger.error`Unable to save draft object for ${pageId}; ${e}`;
    }
    if (b64EncodedDraftObj === null) return false;
    // Store the draft with a 72 hour expiration
    (0, $17wUi.confluenceLocalStorageInstance).setItem(key, b64EncodedDraftObj, 259200);
    return true;
};
const $9a76668fa978df44$export$e7cfba777a0d590e = (type, mode)=>{
    const key = $9a76668fa978df44$var$getKey(type, mode);
    (0, $17wUi.confluenceLocalStorageInstance).removeItem(key);
};
const $9a76668fa978df44$export$5fff31d3d3e1ad8b = (pageId, type, mode)=>Boolean($9a76668fa978df44$export$7c0604f3bd51258a(pageId, type, mode));
const $9a76668fa978df44$export$7c0604f3bd51258a = (pageId, type, mode)=>{
    let draftObj = null;
    const key = $9a76668fa978df44$var$getKey(type, mode);
    const b64EncodedDraftObj = (0, $17wUi.confluenceLocalStorageInstance).getItem(key);
    if (b64EncodedDraftObj !== null) {
        try {
            draftObj = JSON.parse(atob(b64EncodedDraftObj));
        } catch (e) {
            $9a76668fa978df44$var$logger.error`Unable to get draft object for ${pageId}; ${e}`;
        }
        if (draftObj) {
            const { pageId: draftPageId, adf: adf } = draftObj;
            // If the pageId matches, return the ADF, otherwise return null
            if (draftPageId === pageId) return adf;
        }
    }
    return null;
};
module.exports["OUT_OF_DATE_KEY"] = $9a76668fa978df44$export$6af3d18059afaa9e;
module.exports["saveCommentDraft"] = $9a76668fa978df44$export$a4f0a5ceed96eae8;
module.exports["clearCommentDraft"] = $9a76668fa978df44$export$e7cfba777a0d590e;
module.exports["hasCommentDraft"] = $9a76668fa978df44$export$5fff31d3d3e1ad8b;
module.exports["getCommentDraft"] = $9a76668fa978df44$export$7c0604f3bd51258a;

});

parcelRegister("cAdj8", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $1uFM6 = parcelRequire("1uFM6");


var $flE5X = parcelRequire("flE5X");

const $a1394411ec7881e4$var$usePageInfoPageInfoQuery = (0, $eSUdr.default)`query usePageInfoPageInfoQuery($pageId:ID){content(id:$pageId status:["current" "archived" "draft"]){nodes{id type status space{id}operations{operation targetType}version{number}}}}`;
const $a1394411ec7881e4$export$e1b9843c9a40eb2 = {
    id: '',
    type: '',
    status: '',
    space: {
        id: ''
    },
    operations: [],
    version: {
        number: -1
    }
};
const $a1394411ec7881e4$export$7b2dac1793a2824 = ({ fetchPolicy: fetchPolicy = 'cache-and-network', onCompleted: onCompleted, onError: onError } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($a1394411ec7881e4$var$usePageInfoPageInfoQuery, {
        variables: {
            pageId: contentId
        },
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted
    });
    return (0, $42omo.useMemo)(()=>{
        // Handle error case first
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || error instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(error);
            onError?.(error);
            return {
                pageInfo: null,
                loading: false,
                error: error,
                refetch: null
            };
        }
        // If we have data, use it even during loading
        if (data) {
            const pageInfoNode = data.content?.nodes?.[0] ?? null;
            if (pageInfoNode) return {
                pageInfo: pageInfoNode,
                loading: loading,
                error: undefined,
                refetch: refetch
            };
            return {
                pageInfo: {
                    ...$a1394411ec7881e4$export$e1b9843c9a40eb2
                },
                loading: loading,
                error: undefined,
                refetch: refetch
            };
        }
        // Only return null pageInfo if we have no data at all
        return {
            pageInfo: null,
            loading: loading,
            error: undefined,
            refetch: null
        };
    }, [
        data,
        loading,
        error,
        onError,
        refetch
    ]);
};
module.exports["usePageInfo"] = $a1394411ec7881e4$export$7b2dac1793a2824;

});

parcelRegister("kmHPt", function(module, exports) {
var $b271ebdedd90282b$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $b271ebdedd90282b$export$b21a3980a7aad169;

});

parcelRegister("daq5m", function(module, exports) {
/* CommentAuthor.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $8jHAi = parcelRequire("8jHAi");


var $jJK3p = parcelRequire("jJK3p");


var $fs6LW = parcelRequire("fs6LW");


var $1YXTQ = parcelRequire("1YXTQ");


var $gvWVt = parcelRequire("gvWVt");


var $6faGq = parcelRequire("6faGq");


var $7tI6B = parcelRequire("7tI6B");


var $9wGTI = parcelRequire("9wGTI");


var $3ejfs = parcelRequire("3ejfs");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $6b5EI = parcelRequire("6b5EI");


var $cWhxr = parcelRequire("cWhxr");


var $lRNq8 = parcelRequire("lRNq8");

'use no memo';
const $005e7fbdd3b99ea0$var$CommentAuthorInlineCommentAuthorQuery = (0, $eSUdr.default)`query CommentAuthorInlineCommentAuthorQuery($commentId:ID!){content(id:$commentId){nodes{id history{createdBy{displayName profilePicture{path}...on KnownUser{accountId}}}}}}`;
const $005e7fbdd3b99ea0$var$CommentAuthorUserQuery = (0, $eSUdr.default)`query CommentAuthorUserQuery($id:ID!){user:confluence_atlassianUser(id:$id){id displayName photos{value}}}`;
const $005e7fbdd3b99ea0$var$getAuthorContainerMarginLeft = ({ isFixedEditStyles: isFixedEditStyles, commentMode: commentMode, isReply: isReply, isStandaloneComment: isStandaloneComment, isFooterComment: isFooterComment })=>{
    if (isFixedEditStyles) {
        const negativeMarginForEditMode = (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? '-16px' : '-24px';
        return commentMode === 'edit' ? isReply || isStandaloneComment || isFooterComment ? '0' : negativeMarginForEditMode : undefined;
    }
    return commentMode === 'reply' ? '-2px' : 'inherit';
};
const $005e7fbdd3b99ea0$var$getAuthorContainerPaddingBottom = ({ isFixedEditStyles: isFixedEditStyles, commentMode: commentMode, isReply: isReply })=>{
    if (isFixedEditStyles) return commentMode === 'edit' ? isReply ? '8px' : '12px' : undefined;
    return commentMode === 'view' ? undefined : '8px';
};
const $005e7fbdd3b99ea0$var$authorContainerBaseStyles = null;
const $005e7fbdd3b99ea0$var$AuthorContainer = (props)=>{
    const { commentMode: _commentMode, isReply: _isReply, isStandaloneComment: _isStandaloneComment, isFooterComment: _isFooterComment, isFixedEditStyles: _isFixedEditStyles, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            marginLeft: $005e7fbdd3b99ea0$var$getAuthorContainerMarginLeft(props),
            paddingBottom: $005e7fbdd3b99ea0$var$getAuthorContainerPaddingBottom(props)
        },
        ...rest,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1ul9idpf _jva41snc _uvzw1snc _wkreagmp _12rjagmp _gcmzvv82 _1vjrvv82 _5xy14viv _1dtc4viv _1msj4viv"
        ])
    });
};
const $005e7fbdd3b99ea0$var$avatarWrapperBaseStyles = null;
const $005e7fbdd3b99ea0$var$avatarSmallPaddingStyles = null;
const $005e7fbdd3b99ea0$var$avatarLargePaddingStyles = null;
const $005e7fbdd3b99ea0$var$AvatarWrapper = ({ isCommentsTuneupActive: isCommentsTuneupActive, isCommentsPanel: isCommentsPanel, isFooterComment: isFooterComment, isFixedEditStyles: isFixedEditStyles, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_1e0c1txw",
            !isCommentsTuneupActive && (isCommentsPanel || isFooterComment || isFixedEditStyles) ? "_u5f312x7" : "_u5f3u2gc"
        ])
    });
};
const $005e7fbdd3b99ea0$var$containerStyles = null;
const $005e7fbdd3b99ea0$var$Container = ({ useProfileLinkStyle: useProfileLinkStyle, useColumnStyle: useColumnStyle, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1ul9idpf _14yyfhey _hwn17g83 _1msj4viv _5xy14viv _1dtc4viv _17rpwadc _cpznidpf _1s79idpf _amufidpf _x966idpf _387xglyw _14l5azsu _1ptk1j28 _19gdazsu _1gidazsu _1e6pazsu",
            useProfileLinkStyle && "_zulpu2gc _1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _4cvr1q9y _1ul9idpf",
            useColumnStyle && "_zulpidpf _2lx21bp4 _4cvr1y6m"
        ])
    });
};
const $005e7fbdd3b99ea0$var$newPageIconStyle = (0, $ecnYn.xcss)({
    position: 'relative'
}); // TODO: remove the following 3 styles when cleaning up `confluence_frontend_content_wrapper` flag
const $005e7fbdd3b99ea0$var$resolvedPropertiesStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.050'
});
const $005e7fbdd3b99ea0$var$pageIconStyle = (0, $ecnYn.xcss)({
    position: 'relative',
    top: 'space.negative.025'
});
const $005e7fbdd3b99ea0$var$generalCommentFooterStyle = (0, $ecnYn.xcss)({
    top: 'space.negative.050'
});
const $005e7fbdd3b99ea0$var$profileLinkContainerStyle = null;
const $005e7fbdd3b99ea0$var$profileLinkContainerColumnStyle = null;
const $005e7fbdd3b99ea0$var$truncateTextStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
    flex: '1 1 0%',
    wordBreak: 'unset'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$ProfileLinkContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $005e7fbdd3b99ea0$var$Container, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$LozengeWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19bvu2gc _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $005e7fbdd3b99ea0$var$dateContainerBaseStyles = null;
const $005e7fbdd3b99ea0$var$dateContainerStandaloneStyles = null;
const $005e7fbdd3b99ea0$var$dateContainerSubtlestStyles = null;
const $005e7fbdd3b99ea0$var$DateContainer = ({ isStandaloneComment: isStandaloneComment, isCommentsPanel: isCommentsPanel, isFixedEditStyles: isFixedEditStyles, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c1txw _2lx2n7od _4cvrn7od _102ewadc _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _7wy0glyw _1plv1j28 _zmp8azsu _1blwazsu _9b8iazsu _1kcs1y54",
            isStandaloneComment && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_2lx21bp4 _4cvr1y6m",
            (isStandaloneComment || isCommentsPanel && isFixedEditStyles) && "_syaz1rpy"
        ])
    });
}; // confluence_comments_cohiti_date_tooltips exp evaluations will use this component-level i18n object instead of commentsI18n
const $005e7fbdd3b99ea0$var$i18n = (0, $cgtv4.defineMessages)({
    defaultTooltip: {
        id: "inline-comments-common.date-tooltip.default",
        defaultMessage: "Added on {date} at {timestamp}"
    },
    addedTooltip: {
        id: "inline-comments-common.date-tooltip.added",
        defaultMessage: "Added by {username} on {date} at {timeStamp}"
    },
    resolvedTooltip: {
        id: "inline-comments-common.date-tooltip.resolved",
        defaultMessage: "Resolved by {username} on {date} at {timeStamp}"
    },
    reopenedTooltip: {
        id: "inline-comments-common.date-tooltip.reopened",
        defaultMessage: "Reopened by {username} on {date} at {timeStamp}"
    },
    reopenedDateInfoText: {
        id: "inline-comments-common.reopened.date.info.text",
        defaultMessage: "Reopened {timeAgo}{timeStamp, select,\n\t\t\tundefined {}\n\t\t\tother { at {timeStamp}}\n\t\t}"
    },
    resolvedDateInfoText: {
        id: "inline-comments-common.resolved.date.info.text",
        defaultMessage: "Resolved {timeAgo}"
    }
});
const $005e7fbdd3b99ea0$export$d05a2f5fbf67a6d7 = ({ commentMode: commentMode, userId: userId, date: date, createdAtNonLocalized: createdAtNonLocalized, size: size, displayName: displayName, avatarUrl: avatarUrl, commentDateUrl: commentDateUrl, commentId: commentId, permissionType: permissionType, isInactiveComment: isInactiveComment, showCopyLink: showCopyLink = false, resolveProperties: resolveProperties, isCommentsPanel: isCommentsPanel = false, isGeneralComments: isGeneralComments = false, isReply: isReply = false, isFooterComment: isFooterComment = false, isStandaloneComment: isStandaloneComment = false })=>{
    const { data: authorData } = (0, $xQxzY.useQuery)($005e7fbdd3b99ea0$var$CommentAuthorInlineCommentAuthorQuery, {
        variables: {
            commentId: commentId
        },
        fetchPolicy: 'cache-and-network',
        skip: Boolean(userId || !commentId)
    });
    const { data: userData } = (0, $xQxzY.useQuery)($005e7fbdd3b99ea0$var$CommentAuthorUserQuery, {
        variables: {
            id: userId
        },
        fetchPolicy: 'cache-and-network',
        // Skip the query if data is provided or the user is anonymous
        skip: Boolean(avatarUrl && displayName || !userId || commentId)
    });
    const author = (authorData?.content?.nodes || [])[0]?.history?.createdBy;
    const userAvatar = author ? author.profilePicture?.path : (userData?.user?.photos || [])[0]?.value;
    const userDisplayName = author ? author.displayName : userData?.user?.displayName;
    const userAccountId = author?.accountId;
    const linkToComment = `${window.location.origin}/wiki${commentDateUrl}`;
    const intl = (0, $8C5kA.default)();
    const { formatMessage: formatMessage } = intl;
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const timeZone = userTimeZone || tenantTimeZone || undefined;
    const getTooltipContent = ()=>{
        if (resolveProperties?.resolvedTime && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_date_tooltips', 'isEnabled', true)) {
            // resolveProperties.resolved = true -> comment is in resolved state
            // resolveProperties.resolved = false -> comment is in re-opened state
            const i18nMessage = resolveProperties?.resolved ? $005e7fbdd3b99ea0$var$i18n.resolvedTooltip : $005e7fbdd3b99ea0$var$i18n.reopenedTooltip;
            const resolvedTimeBase = new Date(resolveProperties.resolvedTime);
            return formatMessage(i18nMessage, {
                username: resolveProperties?.resolvedUser,
                date: intl.formatDate(resolvedTimeBase, {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    timeZone: timeZone
                }),
                timeStamp: intl.formatTime(resolvedTimeBase, {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timeZone
                })
            });
        }
        if (resolveProperties?.resolved) return formatMessage((0, $3ejfs.commentsi18n).resolvedByTooltipTextCommentsPanel, {
            username: resolveProperties?.resolvedUser
        });
        return formatMessage((0, $3ejfs.commentsi18n).reopenedByTooltipTextCommentsPanel, {
            username: resolveProperties?.resolvedUser,
            createdAtNonLocalized: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
                date: (0, $6faGq.getValidDate)(createdAtNonLocalized),
                usePrepositions: true
            })
        });
    };
    const oldStandloneExperienceResolveInfo = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: resolveProperties?.resolvedFriendlyDate
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "aria-label": formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
                username: resolveProperties?.resolvedUser,
                friendlyDate: resolveProperties?.resolvedFriendlyDate
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 2
        }, formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
            username: resolveProperties?.resolvedUser,
            friendlyDate: resolveProperties?.resolvedFriendlyDate
        }))));
    };
    const getResolvedDateInfoText = ()=>{
        // resolveProperties.resolved = true -> comment is in resolved state
        // resolveProperties.resolved = false -> comment is in re-opened state
        const i18nKey = resolveProperties?.resolved ? 'resolvedDateInfoText' : 'reopenedDateInfoText';
        if (resolveProperties?.resolvedTime && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_date_tooltips', 'isEnabled', true)) {
            const resolvedTimeBase_0 = new Date(resolveProperties.resolvedTime);
            const twentyFourHourThreshold = 86400; // in seconds
            const secondsSinceReopen = (Date.now() - resolvedTimeBase_0.getTime()) / 1000; // Don't include a timestamp if the comment was re-opened less than 24 hours ago
            const shouldIncludeTimeStamp = secondsSinceReopen >= twentyFourHourThreshold;
            return formatMessage($005e7fbdd3b99ea0$var$i18n[i18nKey], {
                // use formatTimeAgo directly so that this string can be injected into aria-label,
                timeAgo: (0, $1YXTQ.formatTimeAgo)(intl, resolvedTimeBase_0, true, {}, userTimeZone, tenantTimeZone),
                timeStamp: shouldIncludeTimeStamp && !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? intl.formatTime(resolvedTimeBase_0, {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timeZone
                }) : undefined
            });
        } else return formatMessage((0, $3ejfs.commentsi18n)[i18nKey], {
            friendlyDate: resolveProperties?.resolvedFriendlyDate
        });
    };
    const newExperienceResolveInfo = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "top",
            content: getTooltipContent()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "aria-label": getResolvedDateInfoText()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 2
        }, getResolvedDateInfoText())));
    };
    const renderResolveInfo = ()=>{
        const standAloneExperience = !isFooterComment && !isCommentsPanel;
        if (standAloneExperience && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isFooterComment && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isCommentsPanel) return newExperienceResolveInfo();
        return oldStandloneExperienceResolveInfo();
    };
    const hasPageCommentIconEnabled = (0, $42omo.useCallback)(()=>{
        if (!isGeneralComments) return false;
        return !isFooterComment;
    }, [
        isGeneralComments,
        isFooterComment
    ]); // TODO: remove renderDateInfoOldExperience() when cleaning up `confluence_frontend_content_wrapper` flag
    const renderDateInfoOldExperience = (resolvedInfo)=>{
        return resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, resolvedInfo, hasPageCommentIconEnabled() && !isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $005e7fbdd3b99ea0$var$pageIconStyle,
                $005e7fbdd3b99ea0$var$resolvedPropertiesStyle,
                isFooterComment && $005e7fbdd3b99ea0$var$generalCommentFooterStyle
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            color: "var(--ds-icon-subtlest, #6B6E76)",
            testId: "general-comment-page-icon",
            label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
            date: (0, $6faGq.getValidDate)((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? createdAtNonLocalized : date)
        }), hasPageCommentIconEnabled() && !isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $005e7fbdd3b99ea0$var$pageIconStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            color: "var(--ds-icon-subtlest, #6B6E76)",
            testId: "general-comment-page-icon",
            label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        })))));
    };
    const renderCopyButton = ()=>{
        const resolvedInfo_0 = renderResolveInfo();
        const renderCopyLinkButton = commentDateUrl && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && (isCommentsPanel && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') || !isCommentsPanel);
        const timeAgoDate = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? createdAtNonLocalized : date;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$DateContainer, {
            isStandaloneComment: isStandaloneComment,
            isCommentsPanel: isCommentsPanel,
            isFixedEditStyles: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
        }, (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050"
        }, resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate ? resolvedInfo_0 : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: (0, $6mKj3.expValEquals)('confluence_comments_cohiti_date_tooltips', 'isEnabled', true) ? formatMessage($005e7fbdd3b99ea0$var$i18n.defaultTooltip, {
                date: intl.formatDate((0, $6faGq.getValidDate)(timeAgoDate), {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    timeZone: timeZone
                }),
                timestamp: intl.formatTime((0, $6faGq.getValidDate)(timeAgoDate), {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timeZone
                })
            }) : undefined
        }, (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cWhxr.RelativeTimestamp), {
            date: (0, $6faGq.getValidDate)(timeAgoDate)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
            date: (0, $6faGq.getValidDate)(timeAgoDate)
        })), hasPageCommentIconEnabled() && !isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $005e7fbdd3b99ea0$var$newPageIconStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            color: "var(--ds-icon-subtlest, #6B6E76)",
            testId: "general-comment-page-icon",
            label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }))))) : renderDateInfoOldExperience(resolvedInfo_0), renderCopyLinkButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6b5EI.CopyLinkButton), {
            visible: showCopyLink,
            textToCopy: linkToComment
        }));
    };
    const isDateShown = (commentMode === 'view' || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && date;
    const name = displayName || userDisplayName || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$AuthorContainer, {
        commentMode: commentMode,
        isReply: isReply,
        isStandaloneComment: isStandaloneComment,
        isFooterComment: isFooterComment,
        isFixedEditStyles: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
        "data-testid": "comment-author"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$AvatarWrapper, {
        isCommentsPanel: isCommentsPanel,
        isFooterComment: isFooterComment,
        isFixedEditStyles: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
        isCommentsTuneupActive: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
        isBlockLevel: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true),
        userId: userId,
        src: avatarUrl || userAvatar,
        trigger: "click",
        size: size,
        name: name
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lRNq8.MaybeTooltip), {
        date: date,
        name: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$Container, {
        useProfileLinkStyle: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true),
        useColumnStyle: !!(resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate) && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$ProfileLinkContainer, null, isInactiveComment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "dummy-profile-link"
    }, displayName || userDisplayName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
        fullName: displayName || userDisplayName,
        userId: userId || userAccountId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            wordBreak: 'break-word',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text, #292A2E)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            fontWeight: "var(--ds-font-weight-medium, 500)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $005e7fbdd3b99ea0$var$truncateTextStyle
        },
        isUnderlinedByDefault: false
    }), permissionType === (0, $7tI6B.SitePermissionType).EXTERNAL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null)) : null), isDateShown && renderCopyButton())));
};
module.exports["CommentAuthor"] = $005e7fbdd3b99ea0$export$d05a2f5fbf67a6d7;

});

parcelRegister("jJK3p", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $jyPfN = parcelRequire("jyPfN");


var $cPER9 = parcelRequire("cPER9");


var $4qzKl = parcelRequire("4qzKl");


var $a6t12 = parcelRequire("a6t12");


var $5XsiK = parcelRequire("5XsiK");


var $dD7ks = parcelRequire("dD7ks");

const $5c1fbd48d7d200d4$var$linkStyles = (0, $ecnYn.xcss)({
    textDecoration: 'underline',
    display: 'inline-block',
    cursor: 'pointer'
});
const $5c1fbd48d7d200d4$var$i18n = (0, $cgtv4.defineMessages)({
    profileLinkName: {
        id: "profile.link.name",
        defaultMessage: "{fullName} profile"
    }
});
const $5c1fbd48d7d200d4$export$a2a4245643e0242b = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { userId: userId, fullName: fullName, isAnonymous: t1, onUserLinkClick: onUserLinkClick, referralSource: referralSource, className: className, style: style, behavior: t2, position: t3, offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: t4 } = t0;
    const isAnonymous = t1 === undefined ? false : t1;
    const behavior = t2 === undefined ? "link" : t2;
    const position = t3 === undefined ? "bottom-start" : t3;
    const isUnderlinedByDefault = t4 === undefined ? true : t4;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $8C5kA.default)();
    const t5 = userId ?? "";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            type: "USER",
            payload: {
                userId: t5
            }
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const { href: teamsAppPersonProfileUrl } = (0, $dD7ks.useNavigateToTeamsApp)(t6);
    let t7;
    if ($[2] !== ariaLabel || $[3] !== behavior || $[4] !== className || $[5] !== fullName || $[6] !== intl || $[7] !== isAnonymous || $[8] !== isUnderlinedByDefault || $[9] !== offset || $[10] !== onUserLinkClick || $[11] !== position || $[12] !== referralSource || $[13] !== style || $[14] !== teamsAppPersonProfileUrl || $[15] !== userId) {
        t7 = ()=>{
            if (behavior === "card") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: isAnonymous,
                userId: userId,
                position: position,
                offset: offset,
                ariaLabel: ariaLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                style: style,
                xcss: $5c1fbd48d7d200d4$var$linkStyles
            }, fullName));
            else {
                const linkStyle = {
                    ...style,
                    ...isUnderlinedByDefault ? {
                        textDecoration: "underline"
                    } : {}
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cPER9.PeopleLink), {
                    target: "_blank",
                    onClick: onUserLinkClick,
                    href: (0, $5XsiK.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, referralSource),
                    className: className,
                    style: linkStyle,
                    "data-testid": "profile-link",
                    "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                        fullName: fullName
                    })
                }, fullName);
            }
        };
        $[2] = ariaLabel;
        $[3] = behavior;
        $[4] = className;
        $[5] = fullName;
        $[6] = intl;
        $[7] = isAnonymous;
        $[8] = isUnderlinedByDefault;
        $[9] = offset;
        $[10] = onUserLinkClick;
        $[11] = position;
        $[12] = referralSource;
        $[13] = style;
        $[14] = teamsAppPersonProfileUrl;
        $[15] = userId;
        $[16] = t7;
    } else t7 = $[16];
    const renderNameComponent = t7;
    let t8;
    if ($[17] !== fullName || $[18] !== hasViewUserProfilePermission || $[19] !== isAnonymous || $[20] !== renderNameComponent || $[21] !== userId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isAnonymous || !userId || userId === "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "profile.anonymous.name",
            defaultMessage: "Anonymous"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, fullName)));
        $[17] = fullName;
        $[18] = hasViewUserProfilePermission;
        $[19] = isAnonymous;
        $[20] = renderNameComponent;
        $[21] = userId;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
};
module.exports["ProfileLink"] = $5c1fbd48d7d200d4$export$a2a4245643e0242b;

});

parcelRegister("cPER9", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $8lYIw = parcelRequire("8lYIw");


var $jlIaF = parcelRequire("jlIaF");


var $5XsiK = parcelRequire("5XsiK");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (props)=>{
    const $ = (0, $frIzR.c)(8);
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, ...otherProps } = props);
        $[0] = props;
        $[1] = href;
        $[2] = otherProps;
        $[3] = to;
    } else {
        href = $[1];
        otherProps = $[2];
        to = $[3];
    }
    const url = to || href;
    const path = url && url.indexOf("/") !== 0 ? `/${url}` : url;
    const destination = !path.startsWith((0, $jlIaF.CONTEXT_PATH)) ? `${0, $jlIaF.CONTEXT_PATH}${path}` : path;
    const t0 = (0, $5XsiK.isTeamsAppEnabled)() ? url : destination;
    let t1;
    if ($[4] !== otherProps || $[5] !== props || $[6] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
            ...props,
            href: t0,
            ...otherProps
        });
        $[4] = otherProps;
        $[5] = props;
        $[6] = t0;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("fs6LW", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $esRft = parcelRequire("esRft");


var $jyPfN = parcelRequire("jyPfN");


var $9wGTI = parcelRequire("9wGTI");


var $a6t12 = parcelRequire("a6t12");

const $98dff64af54e38f8$var$avatarWrapperStyles = {
    base: (0, $ecnYn.xcss)({
        display: 'inline-flex',
        backgroundColor: 'color.background.neutral.subtle',
        borderWidth: '0',
        padding: 'space.0',
        borderRadius: 'radius.full',
        outlineOffset: 'space.0',
        ':focus-within': {
            outlineStyle: 'solid',
            outlineWidth: 'border.width.focused',
            outlineColor: 'color.border.focused'
        }
    }),
    blockBase: (0, $ecnYn.xcss)({
        display: 'flex'
    }),
    cursor: (0, $ecnYn.xcss)({
        cursor: 'pointer'
    })
};
const $98dff64af54e38f8$var$i18n = (0, $cgtv4.defineMessages)({
    label: {
        id: "profile.avatar.image",
        defaultMessage: "profile image of a user"
    },
    ariaLabel: {
        id: "profile.avatar.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
const $98dff64af54e38f8$export$3778be82376b06d7 = (t0)=>{
    const $ = (0, $frIzR.c)(43);
    const { userId: userId, canViewProfile: t1, isAnonymous: t2, size: t3, src: src, onClick: onClick, trigger: trigger, name: name, stackIndex: stackIndex, testId: testId, position: position, borderColor: borderColor, offset: offset, isBlockLevel: t4 } = t0;
    const canViewProfile = t1 === undefined ? true : t1;
    const isAnonymous = t2 === undefined ? false : t2;
    const size = t3 === undefined ? "medium" : t3;
    const isBlockLevel = t4 === undefined ? false : t4;
    const intl = (0, $8C5kA.default)();
    const avatarSrc = isAnonymous || !canViewProfile || !src ? undefined : src;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const avatarRef = (0, $42omo.useRef)(null);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [shouldReturnFocus, setShouldReturnFocus] = (0, $42omo.useState)(false);
    const [wasKeyboardAction, setWasKeyboardAction] = (0, $42omo.useState)(false);
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (isVisible_0)=>{
            setIsVisible(isVisible_0);
        };
        $[0] = t5;
    } else t5 = $[0];
    const handleVisibilityChange = t5;
    let t6;
    let t7;
    if ($[1] !== isVisible || $[2] !== shouldReturnFocus) {
        t6 = ()=>{
            if (shouldReturnFocus && !isVisible && avatarRef.current) {
                avatarRef.current.focus();
                setShouldReturnFocus(false);
            }
        };
        t7 = [
            isVisible,
            shouldReturnFocus
        ];
        $[1] = isVisible;
        $[2] = shouldReturnFocus;
        $[3] = t6;
        $[4] = t7;
    } else {
        t6 = $[3];
        t7 = $[4];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    if ($[5] !== isVisible || $[6] !== wasKeyboardAction) {
        t8 = (e)=>{
            e.stopPropagation();
            if (e.key === "Enter") {
                setWasKeyboardAction(true);
                setIsVisible($98dff64af54e38f8$var$_temp);
                setShouldReturnFocus(true);
            } else if (e.key === "Escape" && isVisible && wasKeyboardAction) {
                setIsVisible(false);
                setWasKeyboardAction(false);
                setShouldReturnFocus(true);
            }
        };
        $[5] = isVisible;
        $[6] = wasKeyboardAction;
        $[7] = t8;
    } else t8 = $[7];
    const handleKeyDown = t8;
    const t9 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? "" : name || "";
    let t10;
    if ($[8] !== intl) {
        t10 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? {} : {
            label: intl.formatMessage($98dff64af54e38f8$var$i18n.label)
        };
        $[8] = intl;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== avatarSrc || $[11] !== borderColor || $[12] !== onClick || $[13] !== size || $[14] !== stackIndex || $[15] !== t10 || $[16] !== t9 || $[17] !== testId) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            src: avatarSrc,
            size: size,
            target: "_blank",
            name: t9,
            ...t10,
            stackIndex: stackIndex,
            testId: testId,
            borderColor: borderColor,
            onClick: onClick
        });
        $[10] = avatarSrc;
        $[11] = borderColor;
        $[12] = onClick;
        $[13] = size;
        $[14] = stackIndex;
        $[15] = t10;
        $[16] = t9;
        $[17] = testId;
        $[18] = t11;
    } else t11 = $[18];
    const Icon = t11;
    let t12;
    if ($[19] !== intl || $[20] !== isVisible || $[21] !== name) {
        t12 = ()=>{
            if ((0, $9wGTI.fg)("a11y_whiteboards_changes")) return {};
            return {
                "aria-haspopup": "true",
                "aria-expanded": isVisible,
                "aria-label": intl.formatMessage($98dff64af54e38f8$var$i18n.ariaLabel, {
                    name: name || ""
                }),
                role: "button",
                tabIndex: 0
            };
        };
        $[19] = intl;
        $[20] = isVisible;
        $[21] = name;
        $[22] = t12;
    } else t12 = $[22];
    const getAriaProps = t12;
    const t13 = name || "";
    let t14;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $9wGTI.fg)("a11y_whiteboards_changes");
        $[23] = t14;
    } else t14 = $[23];
    const t15 = isBlockLevel && $98dff64af54e38f8$var$avatarWrapperStyles.blockBase;
    const t16 = canViewProfile && hasViewUserProfilePermission && $98dff64af54e38f8$var$avatarWrapperStyles.cursor;
    let t17;
    if ($[24] !== t15 || $[25] !== t16) {
        t17 = [
            $98dff64af54e38f8$var$avatarWrapperStyles.base,
            t15,
            t16
        ];
        $[24] = t15;
        $[25] = t16;
        $[26] = t17;
    } else t17 = $[26];
    let t18;
    if ($[27] !== getAriaProps) {
        t18 = getAriaProps();
        $[27] = getAriaProps;
        $[28] = t18;
    } else t18 = $[28];
    let t19;
    if ($[29] !== Icon || $[30] !== handleKeyDown || $[31] !== t17 || $[32] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t17,
            testId: "avatarWrapperTestId",
            ref: avatarRef,
            onKeyDown: handleKeyDown,
            ...t18
        }, Icon);
        $[29] = Icon;
        $[30] = handleKeyDown;
        $[31] = t17;
        $[32] = t18;
        $[33] = t19;
    } else t19 = $[33];
    let t20;
    if ($[34] !== canViewProfile || $[35] !== isAnonymous || $[36] !== offset || $[37] !== position || $[38] !== t13 || $[39] !== t19 || $[40] !== trigger || $[41] !== userId) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            canViewProfile: canViewProfile,
            isAnonymous: isAnonymous,
            trigger: trigger,
            fullName: t13,
            disabledAriaAttributes: t14,
            onVisibilityChange: handleVisibilityChange,
            position: position,
            offset: offset
        }, t19);
        $[34] = canViewProfile;
        $[35] = isAnonymous;
        $[36] = offset;
        $[37] = position;
        $[38] = t13;
        $[39] = t19;
        $[40] = trigger;
        $[41] = userId;
        $[42] = t20;
    } else t20 = $[42];
    return t20;
};
function $98dff64af54e38f8$var$_temp(prev) {
    return !prev;
}
module.exports["ProfileAvatar"] = $98dff64af54e38f8$export$3778be82376b06d7;

});

parcelRegister("gvWVt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4af2e88caf28e461$export$632b2aa69aba4fdd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iyBz0",
    name: "ExternalCollaboratorUserLozenge",
    loader: async ()=>(await (parcelRequire("lWBRe"))).ExternalUserLozenge
});
module.exports["ExternalCollaboratorUserLozenge"] = $4af2e88caf28e461$export$632b2aa69aba4fdd;

});

parcelRegister("lWBRe", function(module, exports) {

let $ff9c617ad0e949e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ff9c617ad0e949e6$var$load("h4Nf7").then(()=>parcelRequire('9fywD'));

});

parcelRegister("6faGq", function(module, exports) {

var $3ejfs = parcelRequire("3ejfs");


var $3iaSn = parcelRequire("3iaSn");

const $fd14f0f09d6b2a27$export$48c62524de3612b3 = (dateString)=>{
    if (!dateString) return new Date(0); // Return earliest possible date if missing
    // Ensure UTC timezone. Some createdAt values are missing the UTC timezone identifier, and some have it
    const normalizedDate = dateString.endsWith('Z') ? dateString : `${dateString}Z`;
    // Try to parse the date, return earliest date if invalid
    const parsed = new Date(normalizedDate);
    return isNaN(parsed.getTime()) ? new Date(0) : parsed;
};

const $fd14f0f09d6b2a27$export$63880caa66d80fb9 = ({ intl: intl, dateString: dateString, commentStatus: commentStatus = (0, $3iaSn.CommentStatus).OPEN, resolveProperties: resolveProperties, isReply: isReply = false })=>{
    if (!dateString) return '';
    // Get formatted timestamp
    let timestamp;
    try {
        const { formatTimeAgo: formatTimeAgo } = (parcelRequire("1JmNR"));
        timestamp = formatTimeAgo(intl, $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString));
    } catch (error) {
        // Fallback to a simple date format if formatTimeAgo is not available
        const date = $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString);
        timestamp = date.toLocaleDateString(intl.locale);
    }
    // For replies, just return the timestamp without comment status
    if (isReply) return timestamp;
    // Format based on comment status
    switch(commentStatus){
        case (0, $3iaSn.CommentStatus).RESOLVED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
                friendlyDate: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).REOPENED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).reopenedByTooltipTextCommentsPanel, {
                createdAtNonLocalized: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).OPEN:
        default:
            return intl.formatMessage((0, $3ejfs.commentsi18n).createdTimestamp, {
                timestamp: timestamp
            });
    }
};
module.exports["getValidDate"] = $fd14f0f09d6b2a27$export$48c62524de3612b3;
module.exports["formatTimestampForAriaLabel"] = $fd14f0f09d6b2a27$export$63880caa66d80fb9;

});

parcelRegister("3ejfs", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $d1e9edb9f1563526$export$454b2229580969d0 = (0, $cgtv4.defineMessages)({
    resolvedByInfoText: {
        id: "comments-util.resolved.by.info.text",
        defaultMessage: "Resolved by {username} {friendlyDate}"
    },
    reopenedByTooltipTextCommentsPanel: {
        id: "comments-util.reopened.by.tooltip.text.comments.panel",
        defaultMessage: "Added {createdAtNonLocalized}, reopened by {username}"
    },
    createdTimestamp: {
        id: "comments-util.timestamp.created",
        defaultMessage: "created {timestamp}"
    },
    resolvedDateInfoText: {
        id: "comments-util.resolved.date.info.text",
        defaultMessage: "Resolved {friendlyDate}"
    },
    reopenedDateInfoText: {
        id: "comments-util.reopened.date.info.text",
        defaultMessage: "Reopened {friendlyDate}"
    },
    generalCommentTooltip: {
        id: "comments-util.view.tooltip.general.comment",
        defaultMessage: "General comment"
    },
    anonymous: {
        id: "comments-util.display.name.anonymous",
        defaultMessage: "Anonymous"
    },
    editedBy: {
        id: "comments-util.edited.by",
        defaultMessage: "Edited by {username} {at}"
    },
    edited: {
        id: "comments-util.edited",
        defaultMessage: "Edited"
    },
    resolvedByTooltipTextCommentsPanel: {
        id: "comments-util.resolved.by.tooltip.text.comments.panel",
        defaultMessage: "By {username}"
    }
});
module.exports["commentsi18n"] = $d1e9edb9f1563526$export$454b2229580969d0;

});

parcelRegister("3iaSn", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $c6395b80aeb36ecd$export$4f1057b172870e9c = /*#__PURE__*/ function(CommentStatus) {
    CommentStatus["OPEN"] = "OPEN";
    CommentStatus["RESOLVED"] = "RESOLVED";
    CommentStatus["REOPENED"] = "REOPENED";
    return CommentStatus;
}({});
const $c6395b80aeb36ecd$export$eac30d30628b994a = ({ resolveProperties: resolveProperties })=>{
    return (0, $42omo.useMemo)(()=>{
        // If no resolve properties, the comment is open
        if (!resolveProperties) return "OPEN";
        // If resolved is false, the comment is reopened
        if (!resolveProperties.resolved) return "REOPENED";
        return "RESOLVED";
    }, [
        resolveProperties
    ]);
};
module.exports["CommentStatus"] = $c6395b80aeb36ecd$export$4f1057b172870e9c;
module.exports["useGetCommentStatus"] = $c6395b80aeb36ecd$export$eac30d30628b994a;

});

parcelRegister("1JmNR", function(module, exports) {
$parcel$export(module.exports, "formatTimeAgo", () => (parcelRequire("1YXTQ")).formatTimeAgo);
$parcel$export(module.exports, "TimeAgo", () => (parcelRequire("1YXTQ")).TimeAgo);
$parcel$export(module.exports, "StaticTimeAgo", () => (parcelRequire("1YXTQ")).StaticTimeAgo);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $1YXTQ = parcelRequire("1YXTQ");


});

parcelRegister("7tI6B", function(module, exports) {
/**
 * @generated SignedSource<<9aed6e6cbc6676e7bd4cc05c0f5959a3>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $89d6a09a4f827a20$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $89d6a09a4f827a20$export$8995abb8169b2cb8;

});

parcelRegister("6b5EI", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $3gadb = parcelRequire("3gadb");


var $1bY7o = parcelRequire("1bY7o");


var $3sFtD = parcelRequire("3sFtD");


var $6F6hl = parcelRequire("6F6hl");


var $aHcFH = parcelRequire("aHcFH");


var $afGoD = parcelRequire("afGoD");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $9CnRS = parcelRequire("9CnRS");

const $0220545780b126ac$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { visible: visible, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_v5641n2p _1e0c116y _4cvr1h6o _1bah1h6o _18u014y2 _tzy4idpf _t9ec1jvs _1mygkb7n _66dk1xty",
            __cmplp.visible && "_tzy4kb7n _t9ec1ygq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0220545780b126ac$var$CustomTooltipWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c116y _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0220545780b126ac$var$CustomizedTooltipTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((t0, ref)=>{
    const $ = (0, $frIzR.c)(7);
    let children;
    let rest;
    if ($[0] !== t0) {
        ({ children: children, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = rest;
    } else {
        children = $[1];
        rest = $[2];
    }
    const t1 = ref;
    let t2;
    if ($[3] !== children || $[4] !== rest || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0220545780b126ac$var$CustomTooltipWrapper, {
            ...rest,
            ref: t1
        }, children);
        $[3] = children;
        $[4] = rest;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
});
const $0220545780b126ac$export$da91d1846689786c = 'link-icon';
const $0220545780b126ac$export$9c785f85e6437122 = 'check-icon';
const $0220545780b126ac$export$266980ac2cfa7919 = 'legacy-clipboard-support';
const $0220545780b126ac$var$RESET_TIMEOUT = 5000;
const $0220545780b126ac$export$534d10f1c5b9c7b3 = (t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { visible: visible, textToCopy: textToCopy, children: children } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isCopied, setCopied] = (0, $42omo.useState)(false);
    const copyWrapperRef = (0, $42omo.useRef)(null);
    const cleanupTimer = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditor = (0, $de2j9.useIsEditorPage)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = !(0, $aHcFH.isClipboardApiSupported)() && !(0, $aHcFH.isIEClipboardApiSupported)();
        $[0] = t1;
    } else t1 = $[0];
    const needRenderCopyArea = t1;
    let t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (needRenderCopyArea) copyWrapperRef.current = document.getElementById("copyWrapperRef");
        };
        t3 = [
            needRenderCopyArea
        ];
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[3] !== isCopied) {
        t4 = ()=>{
            if (isCopied) cleanupTimer.current = setTimeout(()=>setCopied(false), $0220545780b126ac$var$RESET_TIMEOUT);
            return ()=>clearTimeout(cleanupTimer.current);
        };
        t5 = [
            isCopied
        ];
        $[3] = isCopied;
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[6] !== createAnalyticsEvent || $[7] !== isCopied || $[8] !== isEditor || $[9] !== isLivePage || $[10] !== textToCopy) {
        t6 = async (event)=>{
            event.stopPropagation();
            if (isCopied) return;
            if ((0, $aHcFH.isClipboardApiSupported)()) await (0, $aHcFH.copyToClipboard)(textToCopy);
            else if ((0, $aHcFH.isIEClipboardApiSupported)()) await (0, $aHcFH.copyToClipboardIE)(textToCopy);
            else await (0, $aHcFH.legacyCopyToClipboard)(textToCopy, copyWrapperRef.current);
            const pageMode = (isLivePage ? (0, $afGoD.CommentCreationLocation).LIVE : isEditor ? (0, $afGoD.CommentCreationLocation).EDITOR : (0, $afGoD.CommentCreationLocation).RENDERER).toLowerCase();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: isEditor ? "editPageScreen" : "viewPageScreen",
                    action: "clicked",
                    actionSubject: "copyCommentLink",
                    attributes: {
                        pageMode: pageMode
                    }
                }
            }).fire();
            setCopied(true);
        };
        $[6] = createAnalyticsEvent;
        $[7] = isCopied;
        $[8] = isEditor;
        $[9] = isLivePage;
        $[10] = textToCopy;
        $[11] = t6;
    } else t6 = $[11];
    const handleButtonClick = t6;
    let t7;
    if ($[12] !== formatMessage || $[13] !== isCopied) {
        t7 = isCopied ? formatMessage((0, $9CnRS.i18n).linkCopiedTooltip) : formatMessage((0, $9CnRS.i18n).copyLinkTooltip);
        $[12] = formatMessage;
        $[13] = isCopied;
        $[14] = t7;
    } else t7 = $[14];
    const tooltipContent = t7;
    let t8;
    if ($[15] !== formatMessage || $[16] !== isCopied) {
        t8 = !isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: formatMessage((0, $9CnRS.i18n).copyLinkTooltip),
            testId: $0220545780b126ac$export$da91d1846689786c,
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            label: formatMessage((0, $9CnRS.i18n).linkCopiedTooltip),
            color: "var(--ds-icon-success, #6A9A23)",
            testId: $0220545780b126ac$export$9c785f85e6437122,
            spacing: "spacious"
        });
        $[15] = formatMessage;
        $[16] = isCopied;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== handleButtonClick || $[19] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle-link",
            "data-cy": "inline-comment-time-link",
            iconBefore: t8,
            onClick: handleButtonClick,
            spacing: "none"
        });
        $[18] = handleButtonClick;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== t9 || $[22] !== tooltipContent) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipContent,
            position: "top",
            tag: $0220545780b126ac$var$CustomizedTooltipTag,
            hideTooltipOnClick: true
        }, t9);
        $[21] = t9;
        $[22] = tooltipContent;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== children) {
        t11 = needRenderCopyArea && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
            testId: $0220545780b126ac$export$266980ac2cfa7919,
            id: "copyWrapperRef"
        }, children);
        $[24] = children;
        $[25] = t11;
    } else t11 = $[25];
    let t12;
    if ($[26] !== t10 || $[27] !== t11 || $[28] !== visible) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0220545780b126ac$var$Wrapper, {
            visible: visible
        }, t10, t11);
        $[26] = t10;
        $[27] = t11;
        $[28] = visible;
        $[29] = t12;
    } else t12 = $[29];
    return t12;
};
module.exports["CopyLinkButton"] = $0220545780b126ac$export$534d10f1c5b9c7b3;

});

parcelRegister("aHcFH", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $1dnxO = parcelRequire("1dnxO");


var $cD1qu = parcelRequire("cD1qu");


var $i49vP = parcelRequire("i49vP");

const $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7 = 'inline-create-comment-selection';
const $a78c261c3211f7d6$export$b803c692fbaaa5a4 = 'inline-highlight';
const $a78c261c3211f7d6$export$fb3d0eebfe85522a = 'active-highlight';
const $a78c261c3211f7d6$export$b899b07e3f725968 = ()=>{
    const commentData = {
        commentIndex: undefined,
        totalComments: undefined
    };
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) {
        commentData['commentIndex'] = Number(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['position']);
        commentData['totalComments'] = Number(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['totalComments']);
    }
    return commentData;
};
const $a78c261c3211f7d6$export$1f7acceb752add79 = (pageMode)=>{
    const marks = Array.from(document.querySelectorAll($a78c261c3211f7d6$export$8c7b048437c01388(pageMode))).map((node)=>{
        if (pageMode === 'edit') return node.id;
        else return $a78c261c3211f7d6$export$8f4213b45c05ab5d(node);
    });
    /* In case of overlapping comments there will be multiple tags with the same markerRefs. We need to remove
  duplicates in that case so we can navigate between comments correctly */ return new Set(marks);
};
const $a78c261c3211f7d6$export$9b48c18cc387f791 = (markerRefList, pageMode = 'view')=>{
    const distinctMarks = [
        ...$a78c261c3211f7d6$export$1f7acceb752add79(pageMode)
    ];
    return distinctMarks.filter((mark)=>mark && markerRefList.includes(mark));
};
const $a78c261c3211f7d6$export$8c7b048437c01388 = (pageMode = 'view')=>{
    if (pageMode === 'edit') return "[annotationtype='inlineComment']";
    else return '[data-mark-annotation-type="inlineComment"], .inline-comment-marker';
};
const $a78c261c3211f7d6$export$f7ceeb7ba8156450 = ()=>{
    const activeHighlights = document.querySelectorAll(`.${$a78c261c3211f7d6$export$fb3d0eebfe85522a}`);
    activeHighlights.forEach((activeHighlight)=>{
        activeHighlight.classList.remove($a78c261c3211f7d6$export$fb3d0eebfe85522a);
    });
};
const $a78c261c3211f7d6$var$getNextTextNodeOld = (node, boundingParentNode)=>{
    let currentNode = node;
    let nextTextNode = currentNode?.nextSibling;
    // If the node has no next sibling, grab it's parent's next sibling until we find a node
    while(!nextTextNode){
        nextTextNode = currentNode?.parentElement?.nextSibling;
        if (nextTextNode) {
            // WS-2551 - If the bounding parent exists and we're out of bounds of it, we're done looking
            if (boundingParentNode && !boundingParentNode.contains(nextTextNode)) {
                nextTextNode = null;
                break;
            }
            // If we've landed on a text node, then break out
            if (nextTextNode.nodeType === Node.TEXT_NODE) break;
            // If the node exists and it's a hard break (<br />), we do one of two things:
            //   1. If it has a bounding parent, break out because the <br /> signifies the end of the selection
            //   2. If not, then move to the next sibling because we don't count hard breaks in selections
            if (nextTextNode?.tagName === 'BR') {
                if (boundingParentNode) break;
                else nextTextNode = nextTextNode.nextSibling;
            }
        } else // If the text node we tried to access is null, we need to jump up a generation
        currentNode = currentNode?.parentNode;
    }
    // Search for the first text node in the next node
    while(nextTextNode && nextTextNode.nodeType !== Node.TEXT_NODE)nextTextNode = nextTextNode.firstChild;
    return nextTextNode;
};
const $a78c261c3211f7d6$export$3e98291f1f032a77 = (currentNode, boundingNode, isInlineMark)=>{
    let nextTextNode = isInlineMark ? currentNode : currentNode?.nextSibling;
    while(nextTextNode && nextTextNode.nodeType !== Node.TEXT_NODE){
        // If the text node is the bounding node, return that node
        if (boundingNode && nextTextNode?.isSameNode(boundingNode)) return nextTextNode;
        // Check if the node is a hard break (<br />) or an element with role="presentation" we do one of two things:
        if (nextTextNode?.tagName === 'BR') {
            // If it has a bounding parent, break out because the <br /> signifies the end of the selection
            if (boundingNode) return nextTextNode;
            // If not, then move to the next sibling because we don't count hard breaks in selections
            nextTextNode = nextTextNode.nextSibling;
        } else if (nextTextNode?.attributes?.getNamedItem('role')?.value === 'presentation') // If the element has role="presentation", move to the parent element's sibling because this current node does not contain a text node
        nextTextNode = nextTextNode.parentNode?.nextSibling;
        else if ($a78c261c3211f7d6$var$isEmojiNode(nextTextNode)) {
            // If we encounter an emoji and it's also the bounding node, return nothing
            if (boundingNode && nextTextNode?.isSameNode(boundingNode)) return null;
            // Otherwise, just return the node after it and keep going
            nextTextNode = nextTextNode.nextSibling;
        } else // Otherwise, search for the first text node in the next node
        nextTextNode = nextTextNode.firstChild;
    }
    // If we've found the text node, return that node
    if (nextTextNode?.nodeType === Node.TEXT_NODE) return nextTextNode;
    // If the text node we tried to access is null, we need to jump up a generation
    if (!nextTextNode) return $a78c261c3211f7d6$export$3e98291f1f032a77(currentNode?.parentNode, boundingNode);
};
const $a78c261c3211f7d6$var$extractTextNodesIntoRangesOld = (selectedRange)=>{
    const rangesToHighlight = [];
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = selectedRange;
    // NOTE: It's not possible for us to get here with anything other than "#text" nodes
    //       for the start container due to our highlighting restrictions, so we only
    //       need to check the type for endContainer when we get a selected range
    // WS-2551 - Triple clicks are the only thing that can cause the endContainer to be a non-text node
    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
    // If the start and end containers don't match, we need to loop through and extract
    // the text nodes out all common elements and create ranges to represent each of them
    if (!startContainer.isSameNode(endContainer)) {
        let boundingParentNode;
        // Push the starting node into a range
        const startingRange = new Range();
        startingRange.setStart(startContainer, startOffset);
        startingRange.setEnd(startContainer, startContainer.length);
        rangesToHighlight.push(startingRange);
        // WS-2551 - In the case of a triple click, we only want to contain our selection to the
        // first non-comment parent wrapping the starting container to ensure we don't over select
        if (isTripleClick) {
            boundingParentNode = startContainer.parentNode;
            while(!boundingParentNode || boundingParentNode.nodeType === Node.TEXT_NODE || $a78c261c3211f7d6$export$8f4213b45c05ab5d(boundingParentNode) !== null)boundingParentNode = boundingParentNode?.parentNode;
        } else {
            // Push the ending node into a range only if it's not a triple click
            const endingRange = new Range();
            endingRange.setStart(endContainer, 0);
            endingRange.setEnd(endContainer, endOffset);
            rangesToHighlight.push(endingRange);
        }
        // Iterate through all the inner nodes and extract the text ranges
        let node = $a78c261c3211f7d6$var$getNextTextNodeOld(startContainer, boundingParentNode);
        while(node && !node.isSameNode(endContainer) && node.nodeType === Node.TEXT_NODE){
            if (node.length) {
                const range = new Range();
                range.selectNodeContents(node);
                rangesToHighlight.push(range);
            }
            node = $a78c261c3211f7d6$var$getNextTextNodeOld(node, boundingParentNode);
        }
    } else // If they are the same container it's much simpler and we can just use the range
    rangesToHighlight.push(selectedRange);
    return rangesToHighlight;
};
const $a78c261c3211f7d6$var$isEmojiNode = (node)=>{
    if (!node) return false;
    const attributes = node?.attributes;
    const classList = node?.classList;
    return attributes && attributes.getNamedItem('data-emoji-id') || classList && classList.contains('emoji-common-node');
};
const $a78c261c3211f7d6$var$extractTextNodesIntoRanges = (selectedRange)=>{
    const rangesToHighlight = [];
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = selectedRange;
    // NOTE: It's not possible for us to get here with anything other than "#text" nodes
    //       for the start container due to our highlighting restrictions, so we only
    //       need to check the type for endContainer when we get a selected range
    // The endContainer is a non-text node when the user either:
    // 1. Triple clicks a node
    // 2. Highlights a header
    // 3. The highlight goes to the next node but does not actually highlight anything (offset === 0)
    const isNonTextNodeEndContainer = endContainer.nodeType !== Node.TEXT_NODE;
    // If highlight is just one node (i.e. same containers), it's much simpler and we can just use the range
    if (startContainer.isSameNode(endContainer)) {
        rangesToHighlight.push(selectedRange);
        return rangesToHighlight;
    }
    // If the start and end containers don't match, we need to loop through and extract
    // the text nodes out all common elements and create ranges to represent each of them
    let boundingNode;
    // Push the starting node into a range
    const startingRange = new Range();
    startingRange.setStart(startContainer, startOffset);
    startingRange.setEnd(startContainer, startContainer.length);
    rangesToHighlight.push(startingRange);
    // In the case of a non-text node endContainer, we want to set a bounding node to the endContainer so we know
    // to stop traversing the DOM when hidding that bounding node
    if (isNonTextNodeEndContainer) {
        // If the end container is non-text and an emoji, we need to jump up a level or else it is
        // going to be bound to a node that we will never be able to check and thus never exit
        if ($a78c261c3211f7d6$var$isEmojiNode(endContainer)) boundingNode = endContainer.parentNode;
        else boundingNode = endContainer;
    } else {
        // Push the ending node into a range
        const endingRange = new Range();
        endingRange.setStart(endContainer, 0);
        endingRange.setEnd(endContainer, endOffset);
        rangesToHighlight.push(endingRange);
    }
    // Get the first "inner" node between the start and end containers
    let node = $a78c261c3211f7d6$export$3e98291f1f032a77(startContainer, boundingNode);
    // Iterate through all the inner nodes and extract the text ranges
    while(node && !node.isSameNode(endContainer) && node.nodeType === Node.TEXT_NODE){
        if (node.length) {
            const range = new Range();
            range.selectNodeContents(node);
            rangesToHighlight.push(range);
        }
        node = $a78c261c3211f7d6$export$3e98291f1f032a77(node, boundingNode);
    }
    return rangesToHighlight;
};
const $a78c261c3211f7d6$export$739c145b6a07c076 = (isFabricPage, isCreateDialogOpen = false, markerRef = '')=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    let markOffsetTop = 0;
    // Measure the offset of the highlight from the renderer wrapper
    // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
    if (markerRef) {
        const highlight = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef);
        markOffsetTop = $a78c261c3211f7d6$export$331805bfbe18b1c0(highlight);
    } else {
        const selection = window.getSelection();
        // If there is a user selection, we need to create a new temp "highlight" for this
        // new selection as it is removed when the temp "highlight" is created
        const isNewSelection = selection && selection.type == 'Range' && !isCreateDialogOpen;
        if (isNewSelection) {
            // Reset any existing DOM selections
            $a78c261c3211f7d6$export$743373b19993e2b0();
            // Mark the selection in the DOM temporarily
            $a78c261c3211f7d6$export$4147ba71ff179432(false);
        }
        const createCommentHighlight = document.querySelector(`.${highlightClass}`);
        markOffsetTop = $a78c261c3211f7d6$export$331805bfbe18b1c0(createCommentHighlight);
    }
    // On a fabric page, the highlight is positioned relative to the renderer
    // wrapper. To correctly position the sidebar we need to measure the offset
    // of the renderer wrapper and the offset of the highlight from the wrapper
    if (isFabricPage) {
        const rendererWrapper = document.querySelector('#content .ak-renderer-wrapper');
        if (rendererWrapper) markOffsetTop += rendererWrapper.offsetTop;
    } else {
        // In tiny, we need to remove the title and author info offset to position it correctly
        const pageMetadata = document.querySelector('#content-body .page-metadata-modification-info');
        if (pageMetadata) markOffsetTop -= pageMetadata.offsetTop - pageMetadata.offsetHeight;
    }
    return markOffsetTop;
};
const $a78c261c3211f7d6$export$4147ba71ff179432 = (useNewHighlightLogic)=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    const selection = window.getSelection();
    if (!selection || selection.type !== 'Range') // Throw error?
    return;
    // Extract the range
    const selectedRange = selection.getRangeAt(0);
    // Get an array of the ranges to make highlights
    const rangesToHighlight = useNewHighlightLogic ? $a78c261c3211f7d6$var$extractTextNodesIntoRanges(selectedRange) : $a78c261c3211f7d6$var$extractTextNodesIntoRangesOld(selectedRange);
    rangesToHighlight.forEach((range)=>{
        // Create a new wrapper element with the correct class
        const highlightWrapper = document.createElement('span');
        highlightWrapper.classList.add(highlightClass);
        // Extract the contents of the range and add it to the new wrapper
        highlightWrapper.appendChild(range.extractContents());
        // Re-insert the wrapper back into the range
        range.insertNode(highlightWrapper);
    });
    // Clear the selection
    selection.removeAllRanges();
};
const $a78c261c3211f7d6$var$unwrapTextNodes = (wrappedNodes)=>{
    while(wrappedNodes.length){
        const node = wrappedNodes.shift();
        if (!node) return;
        const { parentNode: parentNode } = node;
        // Extract the text contents of the selection node out of the temp wrapper
        while(node.firstChild)parentNode?.insertBefore(node.firstChild, node);
        // After the text has been extracted, delete the wrapper
        parentNode?.removeChild(node);
        // Normalize the parent to fix any text node fragmentation
        parentNode?.normalize();
    }
};
const $a78c261c3211f7d6$export$743373b19993e2b0 = ()=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    // Grab all the newly created selection nodes
    const tempSelectionNodes = Array.from(document.querySelectorAll(`.${highlightClass}`));
    $a78c261c3211f7d6$var$unwrapTextNodes(tempSelectionNodes);
};
const $a78c261c3211f7d6$export$a160a5110cbadcb8 = (isFabricPage, markerRef, isActive = true)=>{
    const createCommentSelectionNodes = document.querySelectorAll(`.${$a78c261c3211f7d6$export$d2bdbdaa2c26e7f7}`);
    const ref = markerRef || '';
    // If we find selection nodes in the DOM, we need to add some attributes to them,
    // based on the page type, so they behave correctly when the user clicks a highlight
    if (createCommentSelectionNodes.length) createCommentSelectionNodes.forEach((selectionNode)=>{
        if (isFabricPage) {
            selectionNode.setAttribute($a78c261c3211f7d6$export$98471574bfa5228e, ref);
            selectionNode.setAttribute('data-mark-annotation-type', 'inlineComment');
        } else {
            selectionNode.setAttribute($a78c261c3211f7d6$export$90ee95b6cd79c832, ref);
            selectionNode.classList.add('inline-comment-marker');
        }
        const classesToAdd = [
            $a78c261c3211f7d6$export$b803c692fbaaa5a4
        ];
        if (isActive) classesToAdd.push($a78c261c3211f7d6$export$fb3d0eebfe85522a);
        // Add the classes needed
        selectionNode.classList.add(...classesToAdd);
        // Finally, remove the selection class to make it a full mark
        selectionNode.classList.remove($a78c261c3211f7d6$export$d2bdbdaa2c26e7f7);
    });
};
const $a78c261c3211f7d6$var$setHighlightsAsActive = (highlightElement, skipClassCheck = false)=>{
    if (skipClassCheck || highlightElement.classList.contains($a78c261c3211f7d6$export$b803c692fbaaa5a4)) highlightElement.classList.add($a78c261c3211f7d6$export$fb3d0eebfe85522a);
    // We need to set all the children of this highlight to active as well
    const { children: children } = highlightElement;
    for(let i = 0; i < children.length; ++i)$a78c261c3211f7d6$var$setHighlightsAsActive(children[i], skipClassCheck);
};
const $a78c261c3211f7d6$export$fd55463aeed84830 = (markerRef, skipClassCheck = false)=>{
    const highlightMarks = $a78c261c3211f7d6$export$6dfccc77fe608546(markerRef) || [];
    highlightMarks.forEach((highlight)=>$a78c261c3211f7d6$var$setHighlightsAsActive(highlight, skipClassCheck));
};
const $a78c261c3211f7d6$export$280edc47a64130be = (markerRef)=>{
    const highlight = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef || '');
    return Boolean(highlight && highlight.classList.contains($a78c261c3211f7d6$export$fb3d0eebfe85522a));
};
const $a78c261c3211f7d6$export$a26c4eafef12029f = (markerRef)=>{
    const highlightMarksToRemove = Array.from($a78c261c3211f7d6$export$6dfccc77fe608546(markerRef));
    $a78c261c3211f7d6$var$unwrapTextNodes(highlightMarksToRemove);
    $a78c261c3211f7d6$export$f7ceeb7ba8156450();
};
const $a78c261c3211f7d6$export$a0939f064b367798 = ()=>{
    const highlightedAnnotations = Array.from(document.querySelectorAll('.ak-editor-annotation-blur, .ak-editor-annotation-focus'));
    const highlightedAnnotationIds = highlightedAnnotations.map((annotation)=>annotation?.closest('.annotationView-content-wrap')?.id).filter((id)=>Boolean(id));
    return new Set(highlightedAnnotationIds);
};
const $a78c261c3211f7d6$export$98471574bfa5228e = 'data-id';
const $a78c261c3211f7d6$export$90ee95b6cd79c832 = 'data-ref';
const $a78c261c3211f7d6$var$hasAdfContent = (input)=>{
    const content = input && input.content;
    return content && content.some($a78c261c3211f7d6$var$validateContent);
};
// Check to make sure if we have item.type as paragraph content is not empty (user did not type anything)
// or user has put in blank spaces(empty string) and clicked save
// Any type other than paragraph is valid (e.g:- when user inserts divider, status etc without content)
const $a78c261c3211f7d6$var$validateContent = (item)=>item.type !== 'paragraph' || $a78c261c3211f7d6$var$validateParagraph(item);
const $a78c261c3211f7d6$var$validateParagraph = (item)=>{
    if (item.content) return item.content.some($a78c261c3211f7d6$var$isParagraphNotEmpty);
    return false;
};
const $a78c261c3211f7d6$var$isParagraphNotEmpty = (item)=>item.type !== 'text' || item.text.trim() !== '';
const $a78c261c3211f7d6$export$915f03d46d87bfd4 = (adf)=>!adf || !$a78c261c3211f7d6$var$hasAdfContent(adf);
const $a78c261c3211f7d6$export$d204c0ea9b3f0d7d = (isFabricPage)=>isFabricPage ? $a78c261c3211f7d6$export$98471574bfa5228e : $a78c261c3211f7d6$export$90ee95b6cd79c832;
const $a78c261c3211f7d6$export$8f4213b45c05ab5d = (element)=>{
    let markerRef = null;
    if (element) {
        markerRef = element.getAttribute($a78c261c3211f7d6$export$98471574bfa5228e);
        if (!markerRef) markerRef = element.getAttribute($a78c261c3211f7d6$export$90ee95b6cd79c832);
    }
    return markerRef;
};
const $a78c261c3211f7d6$export$21445ab787d3b446 = (markerRef, additionalQueryScope = '')=>{
    if (!markerRef) return null;
    // We need to allow for additional query scope to be added to specify particular markerRef comments
    return document.querySelector(`${additionalQueryScope} [${$a78c261c3211f7d6$export$98471574bfa5228e}="${markerRef}"], ${additionalQueryScope} [${$a78c261c3211f7d6$export$90ee95b6cd79c832}="${markerRef}"]`);
};
const $a78c261c3211f7d6$export$6dfccc77fe608546 = (markerRef)=>{
    return document.querySelectorAll(`[${$a78c261c3211f7d6$export$98471574bfa5228e}="${markerRef}"], [${$a78c261c3211f7d6$export$90ee95b6cd79c832}="${markerRef}"]`);
};
const $a78c261c3211f7d6$export$6d23af9d8c2844b1 = [
    'enter',
    'escape'
];
const $a78c261c3211f7d6$var$getDimensions = ()=>{
    try {
        return {
            currentWindowHeight: window.innerHeight || (window.top?.innerHeight ?? 0),
            currentPageOffset: window.scrollY || (window.top?.scrollY ?? 0)
        };
    } catch  {
        // Catch cross origin iframe error https://hello.atlassian.net/browse/CBT-907
        return {
            currentWindowHeight: 0,
            currentPageOffset: 0
        };
    }
};
const $a78c261c3211f7d6$var$getDimensionsForNav4 = ()=>{
    try {
        const nav4ScrollParent = document.getElementById('AkMainContent');
        const currentPageOffset = !!nav4ScrollParent ? nav4ScrollParent.scrollTop : window.scrollY || (window.top?.scrollY ?? 0);
        return {
            currentWindowHeight: window.innerHeight || (window.top?.innerHeight ?? 0),
            currentPageOffset: currentPageOffset
        };
    } catch  {
        // Catch cross origin iframe error https://hello.atlassian.net/browse/CBT-907
        return {
            currentWindowHeight: 0,
            currentPageOffset: 0
        };
    }
};
const $a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET = 350;
const $a78c261c3211f7d6$export$858fd2398afb28e4 = (commentElement, useInstantScroll = false, isAbove = false)=>{
    if (!commentElement) return;
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = $a78c261c3211f7d6$var$getDimensions();
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
    // If the position of the comment box is more than halfway down the screen, reposition it to the center
    if (offset <= currentPageOffset || offset > currentPageOffset + currentWindowHeight * (2 / 3)) {
        const windowOffset = currentWindowHeight / 5;
        window.scrollTo({
            top: offset - windowOffset,
            behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
        });
    }
};
const $a78c261c3211f7d6$export$b451b837f5309ae9 = ({ commentId: commentId, targetCommentId: targetCommentId, isEditor: isEditor, viewingRoomOffset: viewingRoomOffset = -150, useInstantScroll: useInstantScroll = false })=>{
    if (commentId !== targetCommentId) return;
    const commentElement = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (isEditor && commentElement) (0, $i49vP.scrollToElementInEditor)({
        targetElement: commentElement,
        viewingRoomOffset: viewingRoomOffset
    });
    else $a78c261c3211f7d6$export$fc9b5eebad60b835({
        element: commentElement,
        viewingRoomOffset: viewingRoomOffset,
        useInstantScroll: useInstantScroll
    });
};
const $a78c261c3211f7d6$export$e5d4e097ce63febc = ({ commentElement: commentElement, scrollRootElement: scrollRootElement, currentPageOffset: currentPageOffset, currentWindowHeight: currentWindowHeight, isAbove: isAbove, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll })=>{
    if (!commentElement) return;
    // We may be in an iframe so use window.top
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
    const rendererOffset = document.querySelector('#content .ak-renderer-wrapper')?.offsetTop || 0;
    // If the position of the highlight is more than halfway down the screen, reposition it to the center
    if (offset + rendererOffset <= currentPageOffset || offset + rendererOffset > currentPageOffset + currentWindowHeight * (2 / 3)) {
        const windowOffset = isFabricPage ? currentWindowHeight / 5 : currentWindowHeight / 3;
        scrollRootElement.scrollTo({
            top: offset - windowOffset,
            behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
        });
    }
};
const $a78c261c3211f7d6$export$82eb6662255613e = ({ commentElement: commentElement, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll = false, isAbove: isAbove = false, commentThreadContainerId: commentThreadContainerId, isCommentsPanel: isCommentsPanel })=>{
    if (!commentElement) return;
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const nodeToConsider = $a78c261c3211f7d6$export$ee0755cb593feed6(commentElement) || commentElement;
    const targetCommentHighlight = nodeToConsider.getBoundingClientRect();
    const { scrollRootElement: scrollRootElement, getDimensions: getDimensions } = $a78c261c3211f7d6$var$getScrollRootContext(isNav4Enabled);
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = getDimensions();
    const behavior = useInstantScroll ? 'instant' : 'smooth';
    if (isCommentsPanel) {
        const element = document.querySelector(`[data-testid='${commentThreadContainerId}']`);
        const commentThreadParentElement = element.getBoundingClientRect().top;
        const commentThreadSelector = document.querySelector(`[data-testid='comments-panel-list-container']`);
        const inlineCommentPosition = element?.getBoundingClientRect();
        const documentContent = document.getElementById('content');
        const documentContentTopPosition = documentContent?.getBoundingClientRect().top;
        const commentAboveViewport = inlineCommentPosition && documentContentTopPosition && Math.floor(inlineCommentPosition.top) < Math.floor(documentContentTopPosition);
        const commentBelowViewport = inlineCommentPosition && inlineCommentPosition.top + 200 > window.innerHeight;
        const commentHighlightAboveViewPort = Math.floor(targetCommentHighlight.bottom) < currentPageOffset;
        const commentHighlightBelowViewPort = targetCommentHighlight.top + 200 > window.innerHeight;
        /**
     * Determine which panel or section needs to be scrolled:
     * the content area or the comments panel.
     * We need to find out if the highlight or panel is above or below the viewport.
     * This will help us decide which one to scroll.
     */ if (commentHighlightAboveViewPort || commentHighlightBelowViewPort) // if the comment highlight is above or below viewport use content area to scroll;
        scrollRootElement.scrollBy({
            top: window.innerHeight - commentThreadParentElement - (window.innerHeight - targetCommentHighlight.top),
            behavior: behavior
        });
        else if (commentThreadSelector && (commentAboveViewport || commentBelowViewport || window.innerHeight - commentThreadParentElement - (window.innerHeight - targetCommentHighlight.top) < 0)) // if the comment thread is above or below viewport or
        // there is difference in top of comment thread and highlight if completely visible in the viewport
        //  use commentThreadSelector as an element to scroll ;
        commentThreadSelector.scrollBy({
            top: window.innerHeight - targetCommentHighlight.top - (window.innerHeight - commentThreadParentElement),
            behavior: behavior
        });
        else scrollRootElement.scrollBy({
            top: targetCommentHighlight.top - commentThreadParentElement,
            behavior: behavior
        });
    } else {
        // We may be in an iframe so use window.top
        const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
        const rendererOffset = document.querySelector('#content .ak-renderer-wrapper')?.offsetTop || 0;
        // If the position of the highlight is more than halfway down the screen, reposition it to the center
        if (offset + rendererOffset <= currentPageOffset || offset + rendererOffset > currentPageOffset + currentWindowHeight * (2 / 3)) {
            const windowOffset = isFabricPage ? currentWindowHeight / 5 : currentWindowHeight / 3;
            scrollRootElement.scrollTo({
                top: offset - windowOffset,
                behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
            });
        }
    //If comment is in expand, open respective expand
    }
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$export$c7436bd0a15f3e7e = ({ commentElement: commentElement, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll = false, isAbove: isAbove = false, commentThreadAnnotationId: commentThreadAnnotationId, isCommentsPanel: isCommentsPanel })=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        const commentThreadContainerId = `comment-thread-${commentThreadAnnotationId}-container`;
        $a78c261c3211f7d6$export$82eb6662255613e({
            commentElement: commentElement,
            isFabricPage: isFabricPage,
            useInstantScroll: useInstantScroll,
            isAbove: isAbove,
            commentThreadContainerId: commentThreadContainerId,
            isCommentsPanel: isCommentsPanel
        });
        return;
    }
    if (!commentElement) return;
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const nodeToConsider = $a78c261c3211f7d6$export$ee0755cb593feed6(commentElement) || commentElement;
    const targetCommentHighlight = nodeToConsider.getBoundingClientRect();
    const { scrollRootElement: scrollRootElement, getDimensions: getDimensionsFromScrollRootContext } = $a78c261c3211f7d6$var$getScrollRootContext(isNav4Enabled);
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = getDimensionsFromScrollRootContext();
    if (isCommentsPanel) {
        const commentHighlightAboveViewPort = Math.floor(targetCommentHighlight.bottom) < currentPageOffset;
        const commentHighlightBelowViewPort = targetCommentHighlight.top + 200 > window.innerHeight;
        // Scroll the highlight into view in the main content body
        if (commentHighlightAboveViewPort || commentHighlightBelowViewPort) $a78c261c3211f7d6$export$e5d4e097ce63febc({
            commentElement: commentElement,
            scrollRootElement: scrollRootElement,
            currentPageOffset: currentPageOffset,
            currentWindowHeight: currentWindowHeight,
            isAbove: isAbove,
            isFabricPage: !!isFabricPage,
            useInstantScroll: useInstantScroll
        });
    } else $a78c261c3211f7d6$export$e5d4e097ce63febc({
        commentElement: commentElement,
        scrollRootElement: scrollRootElement,
        currentPageOffset: currentPageOffset,
        currentWindowHeight: currentWindowHeight,
        isAbove: isAbove,
        isFabricPage: !!isFabricPage,
        useInstantScroll: useInstantScroll
    });
    //If comment is in expand, open respective expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$export$66b4d1e3b6633573 = (target, scrollContainer)=>{
    const rect = target.getBoundingClientRect();
    const parentRect = scrollContainer.getBoundingClientRect();
    let moveY = 0;
    // The distance (in pixels) between the target and the end of the visible viewport at which point,
    // when scrolling the target into view, scrolling takes place.
    const SCROLL_THRESHOLD = 60;
    // The extra space (in pixels) that is left above or below the target when it is scrolled into view.
    const SCROLL_MARGIN = 120;
    // Note: visible area of the container refers to parentRect.top/bottom +/- SCROLL_THRESHOLD
    if (rect.top < parentRect.top + SCROLL_THRESHOLD) // If the target is above the top of the visible area of the container, moveY should be negative to bring target down into view
    moveY = -(parentRect.top - rect.top + SCROLL_MARGIN);
    else if (rect.bottom > parentRect.bottom - SCROLL_THRESHOLD) // If the target's bottom is below the bottom of the visible area of the container, move Y should be positive to bring target up into view
    moveY = rect.bottom - parentRect.bottom + SCROLL_MARGIN;
    if (moveY) scrollContainer.scrollTop += moveY;
};
const $a78c261c3211f7d6$export$fb40c5e75b82df8 = (isEditor, isViewCommentMode)=>{
    if (isEditor && isViewCommentMode) return 'editor-comments-sidebar';
    else if (isEditor && !isViewCommentMode) return 'editor-create-sidebar';
    else if (!isEditor && isViewCommentMode) return 'renderer-comments-sidebar';
    else return 'renderer-create-sidebar';
};
const $a78c261c3211f7d6$export$db9eae89818590a4 = (commentElement, previousCommentElement, isFabricPage, isEditor)=>{
    if (!commentElement) return;
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const { scrollRootElement: scrollRootElement, scrollRootOffset: scrollRootOffset } = $a78c261c3211f7d6$var$getScrollRootContext(isNav4Enabled);
    // if current open comment is out of viewport, we need to scroll so that the next comment is in viewport
    const sidebarId = $a78c261c3211f7d6$export$fb40c5e75b82df8(isEditor, true); // Hard-coding isViewCommentMode to true because navigation only exists in the view scenario
    const inlineCommentSidebar = document.getElementById(sidebarId);
    const inlineCommentPosition = inlineCommentSidebar?.getBoundingClientRect();
    const documentContent = document.getElementById('content');
    const documentContentTopPosition = documentContent?.getBoundingClientRect().top;
    const commentAboveViewport = inlineCommentPosition && documentContentTopPosition && inlineCommentPosition.top < documentContentTopPosition + scrollRootOffset;
    const commentBelowViewport = inlineCommentPosition && inlineCommentPosition.top + 200 > window.innerHeight;
    if (commentAboveViewport || commentBelowViewport) {
        $a78c261c3211f7d6$export$c7436bd0a15f3e7e({
            commentElement: commentElement,
            isFabricPage: isFabricPage
        });
        return;
    }
    const previousOffset = previousCommentElement ? $a78c261c3211f7d6$export$331805bfbe18b1c0(previousCommentElement) : 0;
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement);
    const differenceOffset = offset - previousOffset;
    scrollRootElement.scrollBy({
        top: differenceOffset,
        behavior: 'smooth' // navigation uses a smooth scroll
    });
    // If comment is in expand, open respective expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$var$adjustNodeForStickyHeader = (stickyHeaderElement)=>{
    let adjustedElement = stickyHeaderElement;
    const markerRef = $a78c261c3211f7d6$export$8f4213b45c05ab5d(adjustedElement);
    // If this is exists it's a commited comment, look for its counterpart in the real table
    // TODO: Support new highlights when we allow it
    if (markerRef) // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
    adjustedElement = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef, '.pm-table-wrapper');
    return adjustedElement;
};
const $a78c261c3211f7d6$export$ee0755cb593feed6 = (element)=>{
    let nodeToReturn = element;
    // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
    // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
    if (nodeToReturn && nodeToReturn.closest && nodeToReturn.closest('.pm-table-sticky-wrapper')) nodeToReturn = $a78c261c3211f7d6$var$adjustNodeForStickyHeader(nodeToReturn);
    if (nodeToReturn) {
        // WS-2718 - If a comment is in an extension macro
        const extensionParent = nodeToReturn.closest('.ak-renderer-extension');
        if (extensionParent) nodeToReturn = extensionParent;
    }
    return nodeToReturn;
};
const $a78c261c3211f7d6$export$331805bfbe18b1c0 = (element, relativeToElement, isRendererAnnotationProviderEnabled)=>{
    let elementOffsetTop = 0;
    let nodeToMeasure = element;
    // new sticky header implementation
    if ((0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false)) {
        if (relativeToElement && nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('tr.pm-table-row-native-sticky-active')) {
            const elementRect = nodeToMeasure.getBoundingClientRect();
            const containerRect = relativeToElement.getBoundingClientRect();
            return elementRect.top - containerRect.top;
        }
    }
    // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
    // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
    if (nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('.pm-table-sticky-wrapper')) // The RAP annotation draft mark is applied to the both pm-table-sticky-wrapper as well as the pm-table-wrapper.
    // Need to check only pm-table-wrapper annotation draft mark for the RAP enabled
    nodeToMeasure = isRendererAnnotationProviderEnabled ? document.querySelector(`.pm-table-wrapper [data-annotation-draft-mark="true"]`) : $a78c261c3211f7d6$var$adjustNodeForStickyHeader(nodeToMeasure);
    // Iterate through the offset parents until we are back to the ak-renderer-wrapper to get the
    // proper offset Fabric Pages wrap the content in a .ak-renderer-wrapper element, but Tiny
    // pages do not have anything like that, but will return null when we get to <body>
    while(nodeToMeasure && !nodeToMeasure.classList.contains('ak-renderer-wrapper') && nodeToMeasure !== relativeToElement){
        elementOffsetTop += nodeToMeasure.offsetTop;
        nodeToMeasure = nodeToMeasure.offsetParent;
    }
    // WS-2718 - If a comment is in an extension macro, we need to add its container offset as well
    if (nodeToMeasure) {
        const extensionParent = nodeToMeasure.closest('.ak-renderer-extension');
        if (extensionParent) elementOffsetTop += extensionParent.offsetTop;
    }
    return elementOffsetTop;
};
const $a78c261c3211f7d6$export$d0d02dc9adb82d62 = (element, isFabricPage)=>{
    //get the child of element passed in
    const expandElement = element?.hasChildNodes() ? element?.firstChild : element;
    //check if element is expand button and return element if so
    if (isFabricPage) {
        if (expandElement?.tagName?.toLowerCase() === 'button') return expandElement;
    } else if (expandElement?.classList?.contains('expand-control')) return expandElement?.firstChild; //it's one child down for tiny pages
    return null;
};
const $a78c261c3211f7d6$export$1a2319f5c2109ee1 = (element, options)=>{
    const { expandSelectors: expandSelectors, getExpandButton: getExpandButton, isExpanded: isExpanded, onExpand: onExpand } = options;
    const nodeToCheck = element;
    // Check if comment is in any expand
    const isInExpand = expandSelectors.some((selector)=>nodeToCheck?.closest?.(selector));
    if (!isInExpand) return;
    // Find all expand buttons that need to be opened, starting from the innermost
    const expandButtonsToOpen = [];
    let currentNode = nodeToCheck;
    while(currentNode){
        // Check if current node has an expand button
        const expandButton = getExpandButton(currentNode);
        if (expandButton) // Check if this expand is already opened
        {
            if (!isExpanded(expandButton)) expandButtonsToOpen.push(expandButton);
        }
        currentNode = currentNode?.parentElement;
    }
    // Open all expand buttons from innermost to outermost
    const buttonsToClick = [
        ...expandButtonsToOpen
    ].reverse();
    buttonsToClick.forEach((expandButton)=>{
        if (onExpand) onExpand(expandButton);
        expandButton.click();
    });
};
const $a78c261c3211f7d6$export$d2685a53bf6957f4 = (element, isFabricPage)=>{
    const expandElementClassname = isFabricPage ? '.expand-content-wrapper' : '.expand-content';
    const nestedExpandElementClassname = '.nestedExpand-content-wrapper';
    const expandSelectors = [
        expandElementClassname,
        nestedExpandElementClassname
    ];
    const getExpandButton = (node)=>$a78c261c3211f7d6$export$d0d02dc9adb82d62(node, isFabricPage);
    const isExpanded = (button)=>{
        return isFabricPage ? button.getAttribute('aria-expanded') === 'true' : button.className.includes('expanded');
    };
    $a78c261c3211f7d6$export$1a2319f5c2109ee1(element, {
        isFabricPage: isFabricPage,
        expandSelectors: expandSelectors,
        getExpandButton: getExpandButton,
        isExpanded: isExpanded
    });
};
const $a78c261c3211f7d6$export$876171b9c9b54aab = (element, isFabricPage)=>{
    $a78c261c3211f7d6$export$d2685a53bf6957f4(element, isFabricPage);
};
const $a78c261c3211f7d6$export$187f977414e8342c = (action, index, markerRefList)=>{
    if (markerRefList.length === 0 || index === undefined || index === -1) return;
    let commentIndex = -1;
    //Navigate to first inline comment if we're on the last comment and the user clicks next,
    // or to the last comment if we're on the first comment and the user clicks previous
    if (action === 'next') commentIndex = index === markerRefList.length - 1 ? 0 : index + 1;
    else if (action === 'previous') commentIndex = index === 0 ? markerRefList.length - 1 : index - 1;
    return markerRefList[commentIndex];
};
const $a78c261c3211f7d6$export$883ebc059dd86e88 = (index, markerRefList, unreadMarkerRefList)=>{
    if (index === undefined || markerRefList.length === 0 || index === -1 || !unreadMarkerRefList || unreadMarkerRefList.length === 0) return;
    let commentIndex = index % markerRefList.length; // Handle case where index is beyond array length
    const refListLength = markerRefList.length;
    let iterations = 0;
    while(markerRefList[commentIndex] !== undefined && !unreadMarkerRefList.includes(markerRefList[commentIndex]) && iterations < refListLength){
        commentIndex = (commentIndex + 1) % markerRefList.length;
        iterations++;
    }
    return markerRefList[commentIndex];
};
const $a78c261c3211f7d6$export$b401b3c3a0774fd7 = ()=>navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $a78c261c3211f7d6$export$bec1a1359bf081c5 = ()=>window.clipboardData && typeof window.clipboardData.setData === 'function';
const $a78c261c3211f7d6$export$dcc703cd1f894b4c = (textToCopy)=>new Promise((resolve, reject)=>{
        if ($a78c261c3211f7d6$export$bec1a1359bf081c5()) {
            window.clipboardData.setData('text', textToCopy);
            resolve();
        } else reject('IE clipboard api is not supported');
    });
const $a78c261c3211f7d6$export$2cdf1b96a9f86d16 = async (text)=>{
    if ($a78c261c3211f7d6$export$b401b3c3a0774fd7()) await navigator.clipboard.writeText(text);
};
const $a78c261c3211f7d6$export$d26ca9d0d4cbdbe9 = (text, ref)=>new Promise((res, rej)=>{
        if (!ref) {
            rej();
            return;
        }
        const textarea = document.createElement('textarea');
        textarea.readOnly = true;
        textarea.defaultValue = text;
        ref.appendChild(textarea);
        textarea.select();
        const wasCopied = document.execCommand('copy');
        ref.removeChild(textarea);
        wasCopied ? res() : rej();
    });
const $a78c261c3211f7d6$export$ab567600730c0b3b = (annotationElement, scrollParentSelector)=>{
    const scrollParent = document.querySelector(scrollParentSelector);
    return $a78c261c3211f7d6$export$331805bfbe18b1c0(annotationElement, scrollParent);
};
const $a78c261c3211f7d6$export$3cdeee3ea1732782 = (annotationElement, scrollParentSelector, isView)=>{
    let offset = 0;
    if (annotationElement) {
        // If the annotation is the wrapperDOM, we actually need #content to be the scrollParent
        const scrollParent = document.querySelector('div#content[data-inline-comments-target="true"]');
        if (scrollParent) {
            let annotationOffset;
            if (isView) annotationOffset = $a78c261c3211f7d6$export$331805bfbe18b1c0(annotationElement);
            else {
                // If the annotation is the wrapperDOM, we need to find the actual highlight instead
                const actualHiglightElement = scrollParent.querySelector(scrollParentSelector);
                annotationOffset = $a78c261c3211f7d6$export$331805bfbe18b1c0(actualHiglightElement, undefined, true);
            }
            offset = annotationOffset + scrollParent.offsetTop;
        }
    }
    return offset;
};
const $a78c261c3211f7d6$export$9f8164812b21bc7a = (entries)=>{
    const windowHeight = window.innerHeight;
    if ((0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true) || (0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_ld')) {
        if (!(0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_ld')) {
            // When fg is ON, we would have verified that there's no
            // endOfPageRecommendations before adding this ResizeObserver.
            // So no need to check it here.
            const endOfPageRecommendations = document.querySelector('.end-of-page-rec-wrapper');
            if (endOfPageRecommendations) return 0;
        }
        const editorTextArea = document.getElementById('ak-editor-textarea');
        const editorBottom = editorTextArea?.getBoundingClientRect().bottom;
        if (editorBottom && windowHeight) {
            // The minimum spacing between bottom of editor content and top of footer is 120px
            const minimumSpacing = 120;
            // - There's an existing fixed 24px margin below editor content.
            // - ObjectAddCommentContainer.tsx has a 64px height.
            // - We lift footer comment top by 14px to make it visually distinct
            //   when a short LiveDoc has some vs zero existing footer comment.
            const editorBottomMargin = 24;
            const addFooterCommentHeight = 64;
            const extraFooterCommentHeightToShow = 14;
            const editorScrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
            const currentScroll = editorScrollParent?.scrollTop ?? 0;
            const editorBottomUnscrolled = editorBottom + currentScroll;
            const verticalDistanceFromWindowBottomUnscrolled = windowHeight - editorBottomUnscrolled;
            return Math.max(verticalDistanceFromWindowBottomUnscrolled - editorBottomMargin - addFooterCommentHeight - extraFooterCommentHeightToShow, minimumSpacing);
        }
    } else {
        // The calculation is
        // 15px of marginTop on the comment container
        // 2px full-page-editor-style bottom which above the viewport
        // 1px border which is cumulates to 120px
        const thresholdTop = 102;
        const editorEntry = entries.find((entry)=>entry.target.id === 'ak-editor-textarea');
        const editorBottom = editorEntry?.target.getBoundingClientRect().bottom;
        const editorContentHeight = document.querySelector(`.ak-editor-content-area .ProseMirror`)?.getBoundingClientRect().height;
        const documentContentBottom = document.querySelector(`[data-testid='full-page-editor-style']`)?.getBoundingClientRect().bottom;
        if (editorContentHeight) {
            // If the document content is larger than the window height, just set it to a static 120 to keep the proper spacing
            if (editorContentHeight > windowHeight) return 120;
            if (documentContentBottom && editorBottom) {
                const verticalDistance = documentContentBottom - editorBottom;
                if (verticalDistance >= thresholdTop && editorContentHeight <= windowHeight) return verticalDistance - thresholdTop;
                else if (verticalDistance <= thresholdTop) return thresholdTop;
            }
        }
    }
};
const $a78c261c3211f7d6$export$e3a17b46d43aa5f6 = ()=>{
    // This is deprecated, and will be replaced by a new approach that works in SSR.
    let newTop = 0;
    const endOfPageRecommendations = document.querySelector('.end-of-page-rec-wrapper');
    const legacyLabels = document.querySelector('[data-vc="view-page-labels-container"]');
    // no extra spacing if the page shows end-of-page recommendations or legacy labels
    if (!endOfPageRecommendations && !legacyLabels) {
        const rendererContent = document.getElementById('main-content');
        const rendererContentBottom = rendererContent?.getBoundingClientRect()?.bottom ?? 0;
        if (rendererContentBottom) {
            // - There's an existing fixed 80px margin below Page content (See
            //   next/packages/view-page-common/src/ViewPageContent.tsx).
            // - ObjectAddCommentContainer.tsx has a 64px height.
            // - We lift footer comment top by 14px (matching Editor version ^)
            //   to make it visually distinct when a short Page has some vs zero
            //   existing footer comment.
            const contentBottomMargin = 80;
            const addFooterCommentHeight = 64;
            const extraFooterCommentHeightToShow = 14;
            // Find the current scroll offset on the Page.
            // This is similar to implementation in getDimensionsForNav4(),
            // but when the window is very narrow, nav4ScrollParent.scrollTop
            // can be 0 (nav4ScrollParent element itself exists on page) while
            // window.scrollY is positive.
            // So this is a more robust implementation. Will explore whether
            // getDimensionsForNav4() can be updated to use this implementation
            // in a separate PR.
            const nav4ScrollParent = document.getElementById('AkMainContent');
            const currentPageOffset = (nav4ScrollParent?.scrollTop ?? 0) + (window.scrollY ?? window.top?.scrollY ?? 0);
            const rendererContentBottomUnscrolled = rendererContentBottom + currentPageOffset;
            const windowHeight = window.innerHeight;
            const verticalDistanceFromWindowBottomUnscrolled = windowHeight - rendererContentBottomUnscrolled - contentBottomMargin;
            newTop = Math.max(verticalDistanceFromWindowBottomUnscrolled - addFooterCommentHeight - extraFooterCommentHeightToShow, 0);
        }
    }
    return newTop;
};
const $a78c261c3211f7d6$export$fc9b5eebad60b835 = ({ element: element, viewingRoomOffset: viewingRoomOffset = -150, useInstantScroll: useInstantScroll = false })=>{
    if (!element) return;
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const { useNav4ScrollRoot: useNav4ScrollRoot, scrollRootElement: scrollRootElement, scrollRootOffset: scrollRootOffset } = $a78c261c3211f7d6$var$getScrollRootContext(isNav4Enabled);
    const elementRect = element.getBoundingClientRect();
    const elementTopViewport = elementRect.top;
    const scrollRootTopViewport = useNav4ScrollRoot ? scrollRootElement.getBoundingClientRect().top : 0;
    const elementTopFromScrollRoot = elementTopViewport - scrollRootTopViewport;
    const targetScrollPosition = elementTopFromScrollRoot + scrollRootOffset + viewingRoomOffset;
    scrollRootElement.scrollTo({
        top: targetScrollPosition,
        behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
    });
    // open expand if the element is inside an expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(element, true);
};
const $a78c261c3211f7d6$export$b3ba907d5759e257 = (commentId)=>{
    let isDisconnected = false;
    let commentFound = false;
    // Find the most specific container to observe
    const commentsPanelListContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    const targetContainer = commentsPanelListContainer || document.body;
    const observer = new MutationObserver(()=>{
        if (isDisconnected || commentFound) return;
        // Look for the comment element directly
        const commentElement = targetContainer.querySelector(`[data-comment-id="${commentId}"]`);
        if (commentElement) {
            commentFound = true;
            commentElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            });
            isDisconnected = true;
            observer.disconnect();
        }
    });
    // Start observing only the specific container
    observer.observe(targetContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
            'data-comment-id'
        ]
    });
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
        }
    };
};
const $a78c261c3211f7d6$export$b1b7c9bcc75c855d = ({ targetCommentId: targetCommentId, onScrollReady: onScrollReady, onFallback: onFallback, timeoutMs: timeoutMs = 10000, markElement: markElement, containerId: containerId })=>{
    if ((0, $6mKj3.expValEquals)('confluence_comments_use_new_observer', 'isEnabled', true)) return $a78c261c3211f7d6$export$4d09fb2a10e54800({
        targetCommentId: targetCommentId,
        onScrollReady: onScrollReady,
        onFallback: onFallback,
        timeoutMs: timeoutMs,
        markElement: markElement,
        containerId: containerId
    });
    let commentFound = false;
    let isDisconnected = false;
    const observer = new MutationObserver((mutations)=>{
        if (isDisconnected) return;
        // First, look for the comment element if we haven't found it yet
        if (!commentFound) {
            for (const mutation of mutations)if (mutation.type === 'childList') {
                for (const addedNode of Array.from(mutation.addedNodes))if (addedNode.nodeType === Node.ELEMENT_NODE) {
                    const element = addedNode;
                    // Check if this element or any of its descendants has the specific data-comment-id
                    const containerElement = containerId ? document.getElementById(containerId) : null;
                    const commentElement = containerElement || element.querySelector?.(`[data-comment-id="${targetCommentId}"]`) || (element.matches?.(`[data-comment-id="${targetCommentId}"]`) ? element : null);
                    if (commentElement) {
                        commentFound = true;
                        // Early return if the comment is in the container element
                        if (containerElement) {
                            onScrollReady(containerElement);
                            isDisconnected = true;
                            observer.disconnect();
                            return;
                        }
                        markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                        // Check the initial state of the show more button
                        const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
                        if (!showMoreButton) {
                            onScrollReady(commentElement);
                            isDisconnected = true;
                            observer.disconnect();
                            return;
                        } else // Trigger click on the show more button to expand all replies
                        showMoreButton.click();
                        break;
                    }
                }
            }
        }
        // If comment is found, watch for the show more button to disappear
        if (commentFound) {
            const commentElement = document.querySelector(`[data-comment-id="${targetCommentId}"]`);
            const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
            if (commentElement && !showMoreButton) {
                markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                onScrollReady(commentElement);
                isDisconnected = true;
                observer.disconnect();
                return;
            }
        }
    });
    // Start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Clean up observer after specified timeout to prevent memory leaks
    const timeoutId = setTimeout(()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            // Fallback behavior if comment was found but button never disappeared
            if (commentFound) {
                const commentElement = document.querySelector(`[data-comment-id="${targetCommentId}"]`);
                if (commentElement) {
                    // Check and open expand sections if needed before scrolling
                    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                    onScrollReady(commentElement);
                }
            } else if (onFallback) onFallback();
        }
    }, timeoutMs);
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            clearTimeout(timeoutId);
        }
    };
};
/**
 * Find the comment element by ID or data-comment-id attribute
 */ const $a78c261c3211f7d6$var$findCommentElement = (targetCommentId, containerId, isFooterCommentInPanel)=>{
    // If isFooterCommentInPanel is true, use comment-thread-${targetCommentId}-container
    if (isFooterCommentInPanel) {
        const panelContainer = document.getElementById(`comment-thread-${targetCommentId}-container`);
        if (panelContainer) return panelContainer;
    }
    // Try container element first if containerId is provided
    if (containerId) {
        const container = document.getElementById(containerId);
        if (container) return container;
    }
    // Fall back to finding by data-comment-id
    return document.querySelector(`[data-comment-id="${targetCommentId}"]`);
};
const $a78c261c3211f7d6$export$5eaef9e6a0975768 = (commentElement, targetCommentId)=>{
    if (!commentElement) return null;
    // 1. Check within commentElement (descendants)
    const buttonInComment = commentElement.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInComment) return buttonInComment;
    // 2. Check in parent element (siblings)
    const parentElement = commentElement.parentElement;
    const buttonInParent = parentElement?.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInParent) return buttonInParent;
    // 3. Check in replies container (specific to this comment thread)
    const repliesContainer = document.querySelector(`[data-testid="comment-thread-${targetCommentId}-replies"]`);
    const buttonInReplies = repliesContainer?.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInReplies) return buttonInReplies;
    return null;
};
/**
 * Handle the comment element being found
 * Checks for show more button and either scrolls immediately or clicks to expand
 */ const $a78c261c3211f7d6$var$handleCommentFound = (commentElement, targetCommentId, containerId, markElement, onScrollReady)=>{
    // If container element exists and we're using it, scroll immediately
    if (containerId && commentElement.id === containerId) {
        markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
        onScrollReady(commentElement);
        return true; // Indicates we should disconnect
    }
    // Expand mark element if needed
    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
    // Check for show more button
    const showMoreButton = $a78c261c3211f7d6$export$5eaef9e6a0975768(commentElement, targetCommentId);
    if (!showMoreButton) {
        // No show more button, scroll immediately
        onScrollReady(commentElement);
        return true; // Indicates we should disconnect
    } else {
        // Show more button exists, click it to expand replies
        showMoreButton.click();
        return false; // Keep watching for button to disappear
    }
};
/**
 * Check if comment element exists in newly added nodes
 */ const $a78c261c3211f7d6$var$checkAddedNodes = (addedNodes, targetCommentId, containerId, isFooterCommentInPanel, onCommentFound)=>{
    for (const addedNode of Array.from(addedNodes)){
        if (addedNode.nodeType !== Node.ELEMENT_NODE) continue;
        const element = addedNode;
        // Check if this element or its descendants contains the comment
        let commentElement = null;
        // First check for container element
        if (containerId) {
            const container = document.getElementById(containerId);
            if (container) commentElement = container;
        }
        // If not found, check for comment by data-comment-id
        if (!commentElement) commentElement = element.querySelector?.(`[data-comment-id="${targetCommentId}"]`) || (element.matches?.(`[data-comment-id="${targetCommentId}"]`) ? element : null);
        // If isFooterCommentInPanel, also check for panel container
        if (!commentElement && isFooterCommentInPanel) {
            const panelContainer = document.getElementById(`comment-thread-${targetCommentId}-container`);
            if (panelContainer) commentElement = panelContainer;
        }
        if (commentElement) {
            const shouldDisconnect = onCommentFound(commentElement);
            if (shouldDisconnect) return true; // Indicates we should stop processing
        }
    }
    return false;
};
const $a78c261c3211f7d6$export$4d09fb2a10e54800 = ({ targetCommentId: targetCommentId, onScrollReady: onScrollReady, onFallback: onFallback, timeoutMs: timeoutMs = 10000, markElement: markElement, containerId: containerId, isFooterCommentInPanel: isFooterCommentInPanel = false })=>{
    let commentFound = false;
    let isDisconnected = false;
    const handleCommentFoundWrapper = (commentElement)=>{
        commentFound = true;
        return $a78c261c3211f7d6$var$handleCommentFound(commentElement, targetCommentId, containerId, markElement, onScrollReady);
    };
    const observer = new MutationObserver((mutations)=>{
        if (isDisconnected) return;
        // First, look for the comment element if we haven't found it yet
        if (!commentFound) {
            for (const mutation of mutations)if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                const shouldStop = $a78c261c3211f7d6$var$checkAddedNodes(mutation.addedNodes, targetCommentId, containerId, isFooterCommentInPanel, handleCommentFoundWrapper);
                if (shouldStop) {
                    isDisconnected = true;
                    observer.disconnect();
                    return;
                }
            }
        }
        // If comment is found, watch for the show more button to disappear
        if (commentFound) {
            const commentElement = $a78c261c3211f7d6$var$findCommentElement(targetCommentId, containerId, isFooterCommentInPanel);
            const showMoreButton = $a78c261c3211f7d6$export$5eaef9e6a0975768(commentElement, targetCommentId);
            // If comment exists and show more button is gone, we're ready to scroll
            if (commentElement && !showMoreButton) {
                markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                onScrollReady(commentElement);
                isDisconnected = true;
                observer.disconnect();
                return;
            }
        }
    });
    // Start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Clean up observer after specified timeout to prevent memory leaks
    const timeoutId = setTimeout(()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            // Fallback behavior if comment was found but button never disappeared
            if (commentFound) {
                const commentElement = $a78c261c3211f7d6$var$findCommentElement(targetCommentId, containerId, isFooterCommentInPanel);
                if (commentElement) {
                    // Check and open expand sections if needed before scrolling
                    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                    onScrollReady(commentElement);
                }
            } else if (onFallback) onFallback();
        }
    }, timeoutMs);
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            clearTimeout(timeoutId);
        }
    };
};
/**
 * Returns the HTMLElement or window that should be used as the scroll root. By default, this is the window.
 * For Nav 4, this is the div with id=AkMainContent, if the id exists in the DOM
 *
 * @param isNav4Enabled - boolean
 */ function $a78c261c3211f7d6$var$getScrollRootContext(isNav4Enabled = false) {
    const nav4ScrollRootElement = document.getElementById('AkMainContent');
    const useNav4ScrollRoot = isNav4Enabled && !!nav4ScrollRootElement;
    const scrollRootElement = useNav4ScrollRoot ? nav4ScrollRootElement : window;
    const scrollRootOffset = useNav4ScrollRoot ? nav4ScrollRootElement.scrollTop : window.scrollY;
    return {
        useNav4ScrollRoot: useNav4ScrollRoot,
        scrollRootElement: scrollRootElement,
        scrollRootOffset: scrollRootOffset,
        getDimensions: isNav4Enabled ? $a78c261c3211f7d6$var$getDimensionsForNav4 : $a78c261c3211f7d6$var$getDimensions
    };
}
// Constants for comment thread visibility
const $a78c261c3211f7d6$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS = 8;
const $a78c261c3211f7d6$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW = 60;
const $a78c261c3211f7d6$var$getTotalOffsetAboveCommentsPanelThreads = (generalCommentsHeaderHeight)=>{
    let objectSidebarPanelHeader = document.querySelector("[data-testid='object-sidebar-panel-header']");
    let additionalOffset = 0;
    if (!objectSidebarPanelHeader) {
        objectSidebarPanelHeader = document.querySelector("[data-testid='scrolled-object-sidebar-panel-header']");
        additionalOffset = $a78c261c3211f7d6$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS;
    }
    const objectSidebarPanelHeaderHeight = objectSidebarPanelHeader?.getBoundingClientRect().height ?? 0;
    const objectHeaderHeight = document.querySelector("[data-testid='object-header-container']")?.getBoundingClientRect().height ?? 0;
    const topNavContainerHeight = document.querySelector("[data-testid='grid-topNav']")?.getBoundingClientRect().height ?? 0;
    const bannerContainerHeight = document.querySelector("[data-testid='banner-container']")?.getBoundingClientRect().height ?? 0;
    const editorControlsOnboardingBannerHeight = document.querySelector("[data-testid='editor-controls-onboarding-banner']")?.getBoundingClientRect().height ?? 0;
    const announcementBannerHeight = document.querySelector("[id='AkBanner']")?.getBoundingClientRect().height ?? 0;
    return objectSidebarPanelHeaderHeight + objectHeaderHeight + topNavContainerHeight + bannerContainerHeight + additionalOffset + generalCommentsHeaderHeight + editorControlsOnboardingBannerHeight + announcementBannerHeight;
};
const $a78c261c3211f7d6$export$4d211f4974dcf196 = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === 'general' ? document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const totalPaddingAboveCommentThreadView = $a78c261c3211f7d6$var$getTotalOffsetAboveCommentsPanelThreads(generalCommentsHeaderHeight);
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    const viewportTop = totalPaddingAboveCommentThreadView;
    const viewportBottom = window.innerHeight - objectSidebarPanelFooterHeight;
    const commentTopInView = commentThreadRect.top >= viewportTop;
    const commentBottomInView = commentThreadRect.bottom <= viewportBottom;
    if (commentTopInView && commentBottomInView) // Comment is 100% in view
    return false;
    else if (!commentTopInView && commentBottomInView) // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
    else if (commentTopInView && !commentBottomInView) {
        // Comment is <100% in view and the hidden part is the bottom of the comment
        const hiddenBottomHeight = commentThreadRect.bottom - viewportBottom;
        if (hiddenBottomHeight <= $a78c261c3211f7d6$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW) // The hidden part is <= 60 pixels
        return false;
        else // The hidden part is > 60 pixels
        return true;
    } else // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
};
const $a78c261c3211f7d6$export$9c5b7a3c864ae31b = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === 'general' ? document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    return(// Element is partially out of view below the comments panel viewport
    commentThreadRect.bottom + generalCommentsHeaderHeight > window.innerHeight - objectSidebarPanelFooterHeight);
};
const $a78c261c3211f7d6$export$e3c287b6d80b16ce = ({ pageMode: pageMode, pageWidthType: pageWidthType, hasEndOfPageRecommendations: hasEndOfPageRecommendations })=>{
    const endOfPageRecommendationsMaxWidth = '1000px';
    if (pageMode === (0, $cD1qu.PageMode).VIEW && ((0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_width') || (0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true))) {
        // pageWidthType is a string like '"default"' / '"full-width"' in renderer mode, and is undefined in live doc mode
        const isDefaultWidth = pageWidthType && JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT;
        if (hasEndOfPageRecommendations) // when end-of-page recommendations is present, always match its width (see EndOfPageRecContainer.tsx)
        return {
            width: isDefaultWidth ? '87.5%' : '100%',
            maxWidth: endOfPageRecommendationsMaxWidth
        };
        else return {
            width: '100%',
            maxWidth: isDefaultWidth ? '760px' : '1800px' // if not defaultWidth, use full page width
        };
    }
    if (pageMode !== (0, $cD1qu.PageMode).VIEW && ((0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_width_ld') || (0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true))) return {
        width: '100%',
        maxWidth: hasEndOfPageRecommendations && (0, $6mKj3.expValEquals)('confluence_ai_related_content_for_live_pages', 'isEnabled', true) ? endOfPageRecommendationsMaxWidth : '100%'
    };
    // Base case: when the fg for the current pageMode isn't ON, i.e. either of:
    // - pageMode === PageMode.VIEW && !fg('confluence_frontend_unify_footer_comment_width') && !expValEquals('confluence_unify_footer_comments_space_width', 'isEnabled', true)
    // - pageMode !== PageMode.VIEW && !fg('confluence_frontend_unify_footer_comment_width_ld') && !expValEquals('confluence_unify_footer_comments_space_width', 'isEnabled', true)
    // This block can be removed entirely once both fgs are rolled out.
    let maxWidth = '100%';
    if (pageWidthType) maxWidth = JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT ? '1000px' : 'unset';
    return {
        width: '100%',
        maxWidth: maxWidth
    };
};
module.exports["CREATE_COMMENT_SELECTION_CLASS"] = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
module.exports["HIGHLIGHT_CLASS"] = $a78c261c3211f7d6$export$b803c692fbaaa5a4;
module.exports["ACTIVE_CLASS"] = $a78c261c3211f7d6$export$fb3d0eebfe85522a;
module.exports["getCommentIndexAndCount"] = $a78c261c3211f7d6$export$b899b07e3f725968;
module.exports["getInlineMarkSelector"] = $a78c261c3211f7d6$export$8c7b048437c01388;
module.exports["getMarkerRef"] = $a78c261c3211f7d6$export$8f4213b45c05ab5d;
module.exports["getSortedMarkerRefs"] = $a78c261c3211f7d6$export$9b48c18cc387f791;
module.exports["clearActiveHighlight"] = $a78c261c3211f7d6$export$f7ceeb7ba8156450;
module.exports["getNextTextNode"] = $a78c261c3211f7d6$export$3e98291f1f032a77;
module.exports["getHighlightOffset"] = $a78c261c3211f7d6$export$739c145b6a07c076;
module.exports["getHighlightFromMarkerRef"] = $a78c261c3211f7d6$export$21445ab787d3b446;
module.exports["calculateElementOffset"] = $a78c261c3211f7d6$export$331805bfbe18b1c0;
module.exports["resetTemporaryDOMHighlight"] = $a78c261c3211f7d6$export$743373b19993e2b0;
module.exports["convertDOMHighlightToMark"] = $a78c261c3211f7d6$export$a160a5110cbadcb8;
module.exports["setCommentAsActive"] = $a78c261c3211f7d6$export$fd55463aeed84830;
module.exports["removeMarkInDOM"] = $a78c261c3211f7d6$export$a26c4eafef12029f;
module.exports["isEmptyAdf"] = $a78c261c3211f7d6$export$915f03d46d87bfd4;
module.exports["keyPropagationList"] = $a78c261c3211f7d6$export$6d23af9d8c2844b1;
module.exports["scrollPageCommentIntoView"] = $a78c261c3211f7d6$export$858fd2398afb28e4;
module.exports["handleScrollToElement"] = $a78c261c3211f7d6$export$b451b837f5309ae9;
module.exports["scrollToElementWithViewingRoom"] = $a78c261c3211f7d6$export$fc9b5eebad60b835;
module.exports["getNodeForTableORMacro"] = $a78c261c3211f7d6$export$ee0755cb593feed6;
module.exports["checkElementExpand"] = $a78c261c3211f7d6$export$876171b9c9b54aab;
module.exports["scrollCommentIntoView"] = $a78c261c3211f7d6$export$c7436bd0a15f3e7e;
module.exports["getSidebarId"] = $a78c261c3211f7d6$export$fb40c5e75b82df8;
module.exports["scrollToComment"] = $a78c261c3211f7d6$export$db9eae89818590a4;
module.exports["checkElementExpandMultiLevelCommon"] = $a78c261c3211f7d6$export$1a2319f5c2109ee1;
module.exports["getNextMarkerRef"] = $a78c261c3211f7d6$export$187f977414e8342c;
module.exports["getNextUnreadThreadKey"] = $a78c261c3211f7d6$export$883ebc059dd86e88;
module.exports["isClipboardApiSupported"] = $a78c261c3211f7d6$export$b401b3c3a0774fd7;
module.exports["isIEClipboardApiSupported"] = $a78c261c3211f7d6$export$bec1a1359bf081c5;
module.exports["copyToClipboardIE"] = $a78c261c3211f7d6$export$dcc703cd1f894b4c;
module.exports["copyToClipboard"] = $a78c261c3211f7d6$export$2cdf1b96a9f86d16;
module.exports["legacyCopyToClipboard"] = $a78c261c3211f7d6$export$d26ca9d0d4cbdbe9;
module.exports["calculateEditorOffsetFromParent"] = $a78c261c3211f7d6$export$ab567600730c0b3b;
module.exports["calculateRendererOffsetFromParent"] = $a78c261c3211f7d6$export$3cdeee3ea1732782;
module.exports["getCommentPositionTopOfSectionEditor"] = $a78c261c3211f7d6$export$9f8164812b21bc7a;
module.exports["getCommentPositionTopOfSectionRenderer"] = $a78c261c3211f7d6$export$e3a17b46d43aa5f6;
module.exports["watchForCommentContainerAndScroll"] = $a78c261c3211f7d6$export$b3ba907d5759e257;
module.exports["watchForCommentRepliesAndScroll"] = $a78c261c3211f7d6$export$b1b7c9bcc75c855d;
module.exports["shouldScrollCommentThreadToTop"] = $a78c261c3211f7d6$export$4d211f4974dcf196;
module.exports["isCommentThreadReplyOutOfView"] = $a78c261c3211f7d6$export$9c5b7a3c864ae31b;
module.exports["getWidthAndMaxWidth"] = $a78c261c3211f7d6$export$e3c287b6d80b16ce;

});

parcelRegister("i49vP", function(module, exports) {

var $gfqXk = parcelRequire("gfqXk");


var $4EKKB = parcelRequire("4EKKB");


var $aHcFH = parcelRequire("aHcFH");

const $36cd0189b09a46b6$var$getElementOffsetFromTopOfPage = (element)=>{
    let elementOffsetTop = 0;
    let nodeToMeasure = element;
    while(nodeToMeasure && !nodeToMeasure.classList.contains('fabric-editor-popup-scroll-parent')){
        elementOffsetTop += nodeToMeasure.offsetTop;
        nodeToMeasure = nodeToMeasure.offsetParent;
    }
    return elementOffsetTop;
};
const $36cd0189b09a46b6$export$cc3d34287540b287 = (element)=>{
    const expandSelectors = [
        '.ak-editor-expand'
    ];
    const getExpandButton = (node)=>{
        if (node.classList.contains('ak-editor-expand')) {
            const button = node.querySelector('.ak-editor-expand__icon-container');
            return button;
        }
        return null;
    };
    const isExpanded = (button)=>{
        const expandContainer = button.closest('.ak-editor-expand');
        return expandContainer?.classList.contains('ak-editor-expand__expanded') || false;
    };
    const onExpand = ()=>{
        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
            isInExpand: true
        });
    };
    (0, $aHcFH.checkElementExpandMultiLevelCommon)(element, {
        isEditor: true,
        expandSelectors: expandSelectors,
        getExpandButton: getExpandButton,
        isExpanded: isExpanded,
        onExpand: onExpand
    });
};
const $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8 = (element)=>{
    $36cd0189b09a46b6$export$cc3d34287540b287(element);
};
const $36cd0189b09a46b6$export$2163ce5a75e4a465 = ({ targetElement: targetElement, targetElementID: targetElementID, shouldScroll: shouldScroll = true })=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8(targetElement);
    emitter.emit('setselectedannotation', targetElementID);
    window.getSelection()?.setPosition(targetElement);
    shouldScroll && $36cd0189b09a46b6$export$4ee22c4fac4681d8({
        targetElement: targetElement,
        viewingRoomOffset: -100
    });
};
const $36cd0189b09a46b6$export$4ee22c4fac4681d8 = ({ targetElement: targetElement, viewingRoomOffset: viewingRoomOffset = 0 })=>{
    const editorScrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
    if (editorScrollableContainer) editorScrollableContainer.scrollTo(0, $36cd0189b09a46b6$var$getElementOffsetFromTopOfPage(targetElement) + viewingRoomOffset // add viewing room
    );
};
const $36cd0189b09a46b6$export$443ba0c8d1b21569 = ({ data: data, previousAnnotations: previousAnnotations })=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const topLevelCommentMarkerRefs = data?.comments?.nodes?.map((node)=>(node?.location).inlineMarkerRef);
    if (topLevelCommentMarkerRefs && topLevelCommentMarkerRefs.length > 0) {
        const newAnnotationsSet = new Set(topLevelCommentMarkerRefs);
        const removedMarkerRefs = [];
        previousAnnotations.forEach((item)=>{
            if (!newAnnotationsSet.has(item)) removedMarkerRefs.push(item);
        });
        let updatedAnnotations = [
            ...previousAnnotations
        ];
        const addedMarkerRefs = [];
        newAnnotationsSet.forEach((item)=>{
            if (!previousAnnotations.includes(item)) addedMarkerRefs.push(item);
        });
        for (const markerRef of addedMarkerRefs){
            emitter.emit('create', markerRef);
            updatedAnnotations.push(markerRef);
        }
        for (const markerRef of removedMarkerRefs){
            emitter.emit('resolve', markerRef);
            updatedAnnotations = updatedAnnotations.filter((annotation)=>annotation !== markerRef);
        }
        return updatedAnnotations;
    }
    return [];
};
module.exports["checkElementExpandInEditor"] = $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8;
module.exports["openInlineCommentInEditor"] = $36cd0189b09a46b6$export$2163ce5a75e4a465;
module.exports["scrollToElementInEditor"] = $36cd0189b09a46b6$export$4ee22c4fac4681d8;

});

parcelRegister("9CnRS", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $90dae8a726ff859c$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    addNew: {
        id: "inline-comments-common.reactions.add.new",
        defaultMessage: "Add new"
    },
    invalidHighlight: {
        id: "inline-comments-common.error.invalid.highlight",
        defaultMessage: "We\u2019re having trouble adding your comment. Try highlighting more or less text."
    },
    replyCommentPlaceholder: {
        id: "inline-comments-common.reply-comment-placeholder",
        defaultMessage: "Reply"
    },
    staleContent: {
        id: "inline-comments-common.error.stale.content",
        defaultMessage: "Refresh to view the latest updates, and try adding your comment again."
    },
    viewNotPermitted: {
        id: "inline-comments-common.error.view.not.permitted",
        defaultMessage: "Your permission settings don\u2019t allow you to view this comment. Check with your administrator if you need this ability."
    },
    createNotPermitted: {
        id: "inline-comments-common.error.create.not.permitted",
        defaultMessage: "You can\u2019t create comments in this space. A space admin can modify your permissions."
    },
    unableToApplyAnnotation: {
        id: "inline-comments-common.error.unable.to.apply.annotation",
        defaultMessage: "Something went wrong when adding this comment to the document. Refresh to see your comment."
    },
    unableToApplyDanglingCommentAnnotation: {
        id: "inline-comments-common.error.unable.to.apply.dangling.comment.annotation",
        defaultMessage: "Your comment was created but could not be added to the document because the text has been changed or removed."
    },
    contentHasBeenRemoved: {
        id: "inline-comments-common.error.create.content.removed",
        defaultMessage: "The text you highlighted has already been deleted by someone else. Refresh to view the latest updates."
    },
    viewOrModifyNotPermitted: {
        id: "inline-comments-common.error.view.or.modify.not.permitted",
        defaultMessage: "You can\u2019t view or modify comments in this space. A space admin can modify your permissions."
    },
    deleteWithRepliesNotAllowed: {
        id: "inline-comments-common.error.delete.with.replies",
        defaultMessage: "You can\u2019t delete this comment anymore because someone else replied to it. Refresh to see all replies."
    },
    commentAlreadyDeleted: {
        id: "inline-comments-common.error.comment.already.deleted",
        defaultMessage: "This comment has been deleted by someone else. Refresh to view the latest updates."
    },
    commentAlreadyDeletedTitle: {
        id: "inline-comments-common.error.comment.already.deleted.title",
        defaultMessage: "Unable to delete comment"
    },
    noCommentsFoundForGivenMarkerRef: {
        id: "inline-comments-common.error.no.comments.found.for.given.marker.ref",
        defaultMessage: "This comment couldn\u2019t be found. Refresh to view the latest updates."
    },
    resolveNotPermitted: {
        id: "inline-comments-common.error.resolve.not.permitted",
        defaultMessage: "You can\u2019t resolve comments in this space. A space admin can modify your permissions."
    },
    resolveError: {
        id: "inline-comments-common.error.resolve.error",
        defaultMessage: "We failed to resolve your comment due to an error. Try resolving the comment again."
    },
    resolveErrorTitle: {
        id: "inline-comments-common.error.resolve.error.title",
        defaultMessage: "Failed to resolve comment"
    },
    deleteError: {
        id: "inline-comments-common.error.delete.error",
        defaultMessage: "We failed to delete your comment due to an error. Try deleting the comment again."
    },
    deleteErrorTitle: {
        id: "inline-comments-common.error.delete.error.title",
        defaultMessage: "Failed to delete comment"
    },
    editNotPermitted: {
        id: "inline-comments-common.error.edit.not.permitted",
        defaultMessage: "You can\u2019t edit comments in this space. A space admin can modify your permissions."
    },
    replyNotPermitted: {
        id: "inline-comments-common.error.reply.not.permitted",
        defaultMessage: "You can\u2019t reply to comments in this space. A space admin can modify your permissions."
    },
    replyNotAllowedParentDeleted: {
        id: "inline-comments-common.error.reply.not.allowed.parent.deleted",
        defaultMessage: "You can\u2019t reply to this comment because it was just deleted by someone else. Refresh to view the latest updates."
    },
    unableToMarkDOM: {
        id: "inline-comments-common.error.unable.to.mark.dom",
        defaultMessage: "Your comment has been successfully created. Refresh to view it."
    },
    networkError: {
        id: "inline-comments-common.error.network",
        defaultMessage: "Your comment wasn't added due to a network error. Check your connection and try again."
    },
    unexpectedError: {
        id: "inline-comments-common.error.unexpected",
        defaultMessage: "Something went wrong when saving this comment. Close the comment or refresh, and try adding your comment again."
    },
    actionNotPermittedTitle: {
        id: "inline-comments-common.error.action.not.permitted.title",
        defaultMessage: "Unauthorized action"
    },
    actionNotPermitted: {
        id: "inline-comments-common.error.action.not.permitted",
        defaultMessage: "You can\u2019t perform that action on inline comments in this space. A space admin can modify your permissions."
    },
    cannotReplyToResolvedComment: {
        id: "inline-comments-common.error.cannot.reply.to.resolved",
        defaultMessage: "You can\u2019t reply to this comment because it was recently resolved by another user. Refresh to view the latest updates."
    },
    cannotUpdateResolvedComment: {
        id: "inline-comments-common.error.cannot.update.resolved",
        defaultMessage: "You can\u2019t edit this comment because it was recently resolved by another user. Refresh to view the latest updates."
    },
    unableToGenerateStep: {
        id: "inline-comments-common.error.unable.to.generate.step",
        defaultMessage: "You can\u2019t create a comment because something went wrong with your highlight. Close this window and create a new highlight."
    },
    contentOutOfDate: {
        id: "inline-comments-common.error.content.out.of.date",
        defaultMessage: "You can\u2019t create a comment here because the text has been changed or removed."
    },
    createTimeout: {
        id: "inline-comments-common.error.create.timeout",
        defaultMessage: "Your request to create a comment timed out. Wait a few moments and save the comment again."
    },
    /**
   * The message below is duplicated in the next files:
   * next/packages/resolved-inline-comments-dialog/src/ResolvedInlineCommentsDialogComponent.tsx
   * packages/confluence-frontend-server/src/components/Comment/PageCommentRenderer.js
   *
   * If you are going to change the message please make sure that the same changes are made in the mentioned above files
   */ a11yCommentLabel: {
        id: "inline-comments-common.a11y.comment.wrapper.label",
        defaultMessage: "Comment by {username}"
    },
    commentActionsMenuLabel: {
        id: "inline-comments-common.comment.actions.menu.label",
        defaultMessage: "More actions"
    },
    copyLinkTooltip: {
        id: "inline-comments-common.tooltip.copy.link",
        defaultMessage: "Copy link to comment"
    },
    linkCopiedTooltip: {
        id: "inline-comments-common.tooltip.link.has.been.copied",
        defaultMessage: "Copied!"
    },
    resolve: {
        id: "inline-comments-common.view.action.resolve",
        defaultMessage: "Resolve"
    },
    resolved: {
        id: "inline-comments-common.view.action.resolved",
        defaultMessage: "Resolved"
    },
    edit: {
        id: "inline-comments-common.view.action.edit",
        defaultMessage: "Edit"
    },
    delete: {
        id: "inline-comments-common.view.action.delete",
        defaultMessage: "Delete"
    },
    reopen: {
        id: "inline-comments-common.action.reopen",
        defaultMessage: "Reopen"
    },
    replyPlaceholder: {
        id: "inline-comments-common.reply.placeholder",
        defaultMessage: "Reply"
    },
    replyPlaceholderWithName: {
        id: "inline-comments-common.reply.placeholder.with-name",
        defaultMessage: "Reply to {name}"
    },
    reactionAriaLabelWithName: {
        id: "inline-comments-common.reaction.aria-label.with-name",
        defaultMessage: "React to {name}\u2019s comment"
    },
    resolveThread: {
        id: "inline-comments-common.resolve-thread",
        defaultMessage: "Resolve comment thread"
    },
    /**
   * Collaborator Onboarding sample comment
   */ sampleAuthor: {
        id: "inline-comments-common.sample.comment.author",
        defaultMessage: "Confluence"
    },
    sampleBody: {
        id: "inline-comments-common.sample.comment.body",
        defaultMessage: "Highlight content to add an inline comment. All viewers can see these, so it\u2019s great for targeted discussion on a specific word or phrase"
    },
    sampleReply: {
        id: "inline-comments-common.sample.reply.input",
        defaultMessage: "disabled reply input"
    },
    sampleReplyPlaceholder: {
        id: "inline-comments-common.sample.reply.placeholder",
        defaultMessage: "Reply"
    },
    sampleReplyTooltip: {
        id: "inline-comments-common.sample.reply.tooltip",
        defaultMessage: "Reply is unavailable for sample comments"
    },
    sampleDeleteHeader: {
        id: "inline-comments-common.sample.comment.delete.header",
        defaultMessage: "Only you can see this."
    },
    sampleDeleteIcon: {
        id: "inline-comments-common.sample.comment.delete.icon",
        defaultMessage: "Delete icon"
    },
    sampleDeleteTooltip: {
        id: "inline-comments-common.sample.comment.delete.tooltip",
        defaultMessage: "Delete sample comment"
    },
    sampleCloseIconLabel: {
        id: "inline-comments-common.sample.comment.delete.icon.label",
        defaultMessage: "Close sample comment"
    },
    collapsedRepliesMore: {
        id: "inline-comments-common.collapsed.replies.more",
        defaultMessage: "{numCollapsedReplies} more replies"
    },
    unreadInlineComment: {
        id: "inline-comments-common.unread.inline.comment",
        defaultMessage: "This is an unread inline comment"
    },
    deletedCommentActionLabel: {
        id: "inline-comments-common.deleted.comment.action.label",
        defaultMessage: "This comment has been deleted"
    },
    resolvedText: {
        id: "inline-comments-common.resolved",
        defaultMessage: "[Resolved]"
    },
    resolvedFlagText: {
        id: "inline-comments-common.resolved.flag.text",
        defaultMessage: "Comment resolved"
    },
    deletedText: {
        id: "inline-comments-common.deleted",
        defaultMessage: "[Deleted]"
    },
    copyLink: {
        id: "inline-comments-common.copy.link",
        defaultMessage: "Copy link"
    },
    goToCommentCTA: {
        id: "inline-comments-common.comment.reopened.flag.cta.gotocomment",
        defaultMessage: "Go to comment"
    },
    undoCTA: {
        id: "inline-comments-common.comment.reopened.flag.cta.undo",
        defaultMessage: "Undo"
    },
    contentDeleted: {
        id: "inline-comments-common.content.deleted",
        defaultMessage: "Content deleted"
    },
    originalContentDeleted: {
        id: "inline-comments-common.original.content.deleted",
        defaultMessage: "Original content deleted"
    },
    thisContentWasDeleted: {
        id: "inline-comments-common.dangling.comments.this.content.was.deleted",
        defaultMessage: "This content was deleted."
    },
    viewDeletedContent: {
        id: "inline-comments-common.dangling.comments.view.deleted.content",
        defaultMessage: "View deleted content"
    },
    collapseDeletedContent: {
        id: "inline-comments-common.dangling.comments.collapse.deleted.content",
        defaultMessage: "Collapse deleted content"
    }
});
module.exports["i18n"] = $90dae8a726ff859c$export$a7357cdd1f0b0168;

});

parcelRegister("cWhxr", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $917iu = parcelRequire("917iu");

var $8uR5k = parcelRequire("8uR5k");

var $d6omw = parcelRequire("d6omw");

var $lvvx5 = parcelRequire("lvvx5");

const $677d422179b5c9e8$var$messages = (0, $cgtv4.defineMessages)({
    now: {
        id: "inline-comments-common.relative-timestamp.now",
        defaultMessage: "Now"
    }
});
const $677d422179b5c9e8$export$705da3a6fb3571ab = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { date: date } = t0;
    const intl = (0, $8C5kA.default)();
    const now = new Date();
    const diffInMinutes = (0, $d6omw.default)(now, date);
    const diffInHours = (0, $8uR5k.default)(now, date);
    const diffInDays = (0, $917iu.default)(now, date);
    const diffInWeeks = (0, $lvvx5.default)(now, date);
    if (diffInMinutes < 2) {
        let t1;
        if ($[0] !== intl) {
            t1 = intl.formatMessage($677d422179b5c9e8$var$messages.now);
            $[0] = intl;
            $[1] = t1;
        } else t1 = $[1];
        let t2;
        if ($[2] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1);
            $[2] = t1;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    if (diffInMinutes < 60) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgtv4.FormattedNumber), {
        value: diffInMinutes,
        style: "unit",
        unit: "minute",
        unitDisplay: "narrow"
    });
    if (diffInHours < 24) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgtv4.FormattedNumber), {
        value: diffInHours,
        style: "unit",
        unit: "hour",
        unitDisplay: "narrow"
    });
    if (diffInWeeks < 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgtv4.FormattedNumber), {
        value: diffInDays,
        style: "unit",
        unit: "day",
        unitDisplay: "narrow"
    });
    const currentYear = now.getFullYear();
    const dateYear = date.getFullYear();
    if (currentYear === dateYear) {
        let t1;
        if ($[4] !== date || $[5] !== intl) {
            t1 = intl.formatDate(date, {
                month: "short",
                day: "numeric"
            });
            $[4] = date;
            $[5] = intl;
            $[6] = t1;
        } else t1 = $[6];
        let t2;
        if ($[7] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1);
            $[7] = t1;
            $[8] = t2;
        } else t2 = $[8];
        return t2;
    }
    let t1;
    if ($[9] !== date || $[10] !== intl) {
        t1 = intl.formatDate(date, {
            month: "short",
            day: "numeric",
            year: "numeric"
        });
        $[9] = date;
        $[10] = intl;
        $[11] = t1;
    } else t1 = $[11];
    let t2;
    if ($[12] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1);
        $[12] = t1;
        $[13] = t2;
    } else t2 = $[13];
    return t2;
};
module.exports["RelativeTimestamp"] = $677d422179b5c9e8$export$705da3a6fb3571ab;

});

parcelRegister("8uR5k", function(module, exports) {
$parcel$export(module.exports, "default", () => $62fa4da7b1bddd96$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $62fa4da7b1bddd96$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInHour);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("d6omw", function(module, exports) {
$parcel$export(module.exports, "default", () => $989ebbba3827b0fa$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $989ebbba3827b0fa$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInMinute);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("lvvx5", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa84f3f15ff2b5dc$export$2e2bcd8739ae039);

var $917iu = parcelRequire("917iu");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $fa84f3f15ff2b5dc$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $917iu.default)(dateLeft, dateRight) / 7;
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("lRNq8", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $3gadb = parcelRequire("3gadb");


var $gdv5Z = parcelRequire("gdv5Z");


var $6faGq = parcelRequire("6faGq");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

const $82d0090970c55653$var$styles = {
    tooltipWrapper: "_1ul9idpf"
};
const $82d0090970c55653$var$i18n = (0, $cgtv4.defineMessages)({
    addedTooltip: {
        id: "inline-comments-common.date-tooltip.added",
        defaultMessage: "Added by {username} on {date} at {timeStamp}"
    }
});
const $82d0090970c55653$export$8d25ba73a810c5c5 = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { children: children, date: date, name: name } = t0;
    const intl = (0, $8C5kA.default)();
    const { formatMessage: formatMessage } = intl;
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const timeZone = userTimeZone || tenantTimeZone || undefined;
    let t1;
    if ($[0] !== children || $[1] !== date || $[2] !== formatMessage || $[3] !== intl || $[4] !== name || $[5] !== timeZone) {
        t1 = date && (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $82d0090970c55653$var$styles.tooltipWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage($82d0090970c55653$var$i18n.addedTooltip, {
                username: name,
                date: intl.formatDate((0, $6faGq.getValidDate)(date), {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                    timeZone: timeZone
                }),
                timeStamp: intl.formatTime((0, $6faGq.getValidDate)(date), {
                    hour: "numeric",
                    minute: "numeric",
                    timeZone: timeZone
                })
            })
        }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[0] = children;
        $[1] = date;
        $[2] = formatMessage;
        $[3] = intl;
        $[4] = name;
        $[5] = timeZone;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
module.exports["MaybeTooltip"] = $82d0090970c55653$export$8d25ba73a810c5c5;

});

parcelRegister("isdzP", function(module, exports) {

var $fJlJm = parcelRequire("fJlJm");


var $hL41C = parcelRequire("hL41C");


var $9CnRS = parcelRequire("9CnRS");

const $e5083fb3da68bf8e$export$e80a9284539c1797 = (error)=>{
    const { message: message } = error;
    let errorMessage = '';
    const parsedError = {
        message: errorMessage,
        isAuthorized: false
    };
    /* If this is a GraphQL error we need to extract the data out of it
   * GraphQL errors that are returned from mutations always have the same format:
   * GraphQL error: <GUID>: <EXCEPTION>: <REASON>
   * The GUID correlates to the microsId so it unfortunately doesn't do much for us
   * With this in mind, we want to extract the REASON as the message for translation
   */ if (message.indexOf('GraphQL error:') !== -1) {
        const reasonStartIdx = message.lastIndexOf(':') + 1;
        errorMessage = message.substr(reasonStartIdx, message.length - reasonStartIdx).trim();
        // Extract the traceId for highlight errors
        parsedError.errorId = (0, $fJlJm.getLogSafeErrorAttributes)(error).traceId;
    } else errorMessage = message;
    parsedError.message = errorMessage;
    // If we have an ApolloErrorInterop, extract the status code and the authorization status
    const { graphQLErrors: graphQLErrors } = error;
    if (graphQLErrors && graphQLErrors.length) {
        parsedError.statusCode = graphQLErrors?.[0]?.extensions?.statusCode;
        parsedError.isAuthorized = graphQLErrors?.[0]?.extensions?.data?.authorized || false;
    }
    return parsedError;
};
const $e5083fb3da68bf8e$export$a67f8c1198066537 = (message, id = '')=>{
    let i18nError;
    // COMMENTS-4199 - This is our own handling of the error thrown by the editor/renderer that we wrap
    //				   in our own message, so to preserve the original error we just check for our message
    if (message.includes('Unable to apply annotation to document')) {
        if (message.includes('Failed to create annotation')) i18nError = (0, $9CnRS.i18n).unableToApplyDanglingCommentAnnotation;
        else i18nError = (0, $9CnRS.i18n).unableToApplyAnnotation;
    } else if (message.startsWith('Network error: ')) i18nError = (0, $9CnRS.i18n).networkError;
    else switch(message){
        case (0, $hL41C.InlineCommentError).INVALID_SELECTION:
        case (0, $hL41C.InlineCommentError).FAILED_TO_INSERT_MARK:
            i18nError = (0, $9CnRS.i18n).invalidHighlight;
            break;
        case (0, $hL41C.InlineCommentError).STALE_SELECTION:
            i18nError = (0, $9CnRS.i18n).staleContent;
            break;
        case (0, $hL41C.InlineCommentError).NO_ANONYMOUS_ACCESS:
            i18nError = (0, $9CnRS.i18n).actionNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF:
        case (0, $hL41C.InlineCommentError).NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF_LIST:
            i18nError = (0, $9CnRS.i18n).noCommentsFoundForGivenMarkerRef;
            break;
        case (0, $hL41C.InlineCommentError).NO_VIEW_PERMS:
        case (0, $hL41C.InlineCommentError).NOT_AUTHORIZED:
        case (0, $hL41C.InlineCommentError).NOT_AUTHORIZED_COMMENTS:
            i18nError = (0, $9CnRS.i18n).viewNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_UPDATE_PERMS.replace('%d', id ? id : ''):
            i18nError = (0, $9CnRS.i18n).editNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_VIEW_OR_MODIFY_PERMS:
        case (0, $hL41C.InlineCommentError).NO_SPACE_PERMS:
            i18nError = (0, $9CnRS.i18n).viewOrModifyNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_DELETE_WITH_CHILDREN:
            i18nError = (0, $9CnRS.i18n).deleteWithRepliesNotAllowed;
            break;
        case (0, $hL41C.InlineCommentError).NO_CREATE_PERMS:
            i18nError = (0, $9CnRS.i18n).createNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).UPDATE_COMMENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).COMMENT_ALREADY_DELETED.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).CANNOT_RESOLVE_DELETED_COMMENT.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).ERROR_404:
            i18nError = (0, $9CnRS.i18n).commentAlreadyDeleted;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_REPLY_TO_DELETED_PARENT:
            i18nError = (0, $9CnRS.i18n).replyNotAllowedParentDeleted;
            break;
        case (0, $hL41C.InlineCommentError).INVALID_ARGUMENT_MATCHES:
            i18nError = (0, $9CnRS.i18n).contentHasBeenRemoved;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_REPLY_TO_RESOLVED_COMMENT:
            i18nError = (0, $9CnRS.i18n).cannotReplyToResolvedComment;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_UPDATE_RESOLVED_COMMENT:
            i18nError = (0, $9CnRS.i18n).cannotUpdateResolvedComment;
            break;
        case (0, $hL41C.InlineCommentError).CONTENT_OUT_OF_DATE:
            i18nError = (0, $9CnRS.i18n).contentOutOfDate;
            break;
        case (0, $hL41C.InlineCommentError).INVALID_ARGUMENT_CREATED_FROM:
        case (0, $hL41C.InlineCommentError).CREATE_COMMENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).PARENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).INCOMPATIBLE_PARENT_TYPE:
        case (0, $hL41C.InlineCommentError).DELETE_ERROR:
        default:
            i18nError = (0, $9CnRS.i18n).unexpectedError;
            break;
    }
    return i18nError;
};
const $e5083fb3da68bf8e$export$336db91bab9fb3ba = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).invalidHighlight.id;
const $e5083fb3da68bf8e$export$68de2e41a5e9d0c3 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).unexpectedError.id;
const $e5083fb3da68bf8e$export$fb2e61e668e6b1d2 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).unableToApplyAnnotation.id || translatedMessage.id === (0, $9CnRS.i18n).unableToApplyDanglingCommentAnnotation.id;
const $e5083fb3da68bf8e$export$81795bac145b8560 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).contentOutOfDate.id || translatedMessage.id === (0, $9CnRS.i18n).staleContent.id;
const $e5083fb3da68bf8e$export$b2e3f629cad072ef = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).commentAlreadyDeleted.id;
const $e5083fb3da68bf8e$export$476aa014e2fd89d5 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).networkError.id;
module.exports["parseError"] = $e5083fb3da68bf8e$export$e80a9284539c1797;
module.exports["getTranslatedError"] = $e5083fb3da68bf8e$export$a67f8c1198066537;
module.exports["isHighlightError"] = $e5083fb3da68bf8e$export$336db91bab9fb3ba;
module.exports["isUnexpectedError"] = $e5083fb3da68bf8e$export$68de2e41a5e9d0c3;
module.exports["isAnnotationError"] = $e5083fb3da68bf8e$export$fb2e61e668e6b1d2;
module.exports["isOutOfDateError"] = $e5083fb3da68bf8e$export$81795bac145b8560;
module.exports["isAlreadyDeletedError"] = $e5083fb3da68bf8e$export$b2e3f629cad072ef;
module.exports["isNetworkError"] = $e5083fb3da68bf8e$export$476aa014e2fd89d5;

});

parcelRegister("hL41C", function(module, exports) {
var $4bdefc881ecc3bb8$export$317614131ad59950 = /*#__PURE__*/ function(InlineCommentError) {
    InlineCommentError["INVALID_SELECTION"] = "Invalid text selection. Cannot create inline comments on macros (mentions, images, emojis, etc.)";
    InlineCommentError["FAILED_TO_INSERT_MARK"] = "Failed to insert highlight, invalid originalSelection, numMatches, or matchIndex";
    InlineCommentError["INVALID_ARGUMENT_CREATED_FROM"] = "Invalid createdFrom, please specify if created from editor or renderer";
    InlineCommentError["STALE_SELECTION"] = "Selection was made against a stale version of the content";
    InlineCommentError["NO_ANONYMOUS_ACCESS"] = "Anonymous access is not permitted";
    InlineCommentError["NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF"] = "No comments found for the given markerRef";
    InlineCommentError["NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF_LIST"] = "No comments found for the given markerRefList";
    InlineCommentError["NO_VIEW_PERMS"] = "User doesn't have VIEW permission for this comment";
    InlineCommentError["NOT_AUTHORIZED"] = "403 Forbidden, current user not permitted to use Confluence.";
    InlineCommentError["NOT_AUTHORIZED_COMMENTS"] = "User does not have permission to access the comment(s)";
    // Create Reply
    InlineCommentError["CREATE_COMMENT_NOT_FOUND"] = "Content with id %d for comment container is not found. Please provide correct container id.";
    InlineCommentError["PARENT_NOT_FOUND"] = "Parent comment with id %d is not found. Please provide correct parent comment id.";
    InlineCommentError["INCOMPATIBLE_PARENT_TYPE"] = "Incompatible parent type. Please provide comment id.";
    InlineCommentError["CANNOT_REPLY_TO_DELETED_PARENT"] = "Cannot add reply to a deleted comment";
    InlineCommentError["CANNOT_REPLY_TO_RESOLVED_COMMENT"] = "Inline comment in RESOLVED status cannot be replied";
    // Delete
    // This is the error message for a NotFoundException only
    InlineCommentError["DELETE_ERROR"] = "Exception occurred while deleting comment with id";
    InlineCommentError["NO_VIEW_OR_MODIFY_PERMS"] = "Parent page view is restricted";
    InlineCommentError["NO_SPACE_PERMS"] = "Space is restricted";
    InlineCommentError["NO_DELETE_WITH_CHILDREN"] = "Inline comment with child cannot be deleted.";
    InlineCommentError["COMMENT_ALREADY_DELETED"] = "Exception occurred while deleting comment with id %d";
    InlineCommentError["ERROR_404"] = "Received status 404";
    // Edit
    InlineCommentError["NO_UPDATE_PERMS"] = "Could not update Content of type  = class com.atlassian.confluence.pages.Comment with id %d";
    InlineCommentError["UPDATE_COMMENT_NOT_FOUND"] = "Could not find Comment for update with id CommentId{id=%d}";
    InlineCommentError["CANNOT_UPDATE_RESOLVED_COMMENT"] = "Inline comment in RESOLVED status cannot be updated";
    // Create
    InlineCommentError["NO_CREATE_PERMS"] = "Could not create content with type comment";
    InlineCommentError["INVALID_ARGUMENT_MATCHES"] = "Invalid arguments provided for matchIndex and/or numMatches";
    InlineCommentError["CONTENT_OUT_OF_DATE"] = "Published Version out of date. Please provide correct published version.";
    InlineCommentError["UNABLE_TO_APPLY_ANNOTATION"] = "Unable to apply annotation to document";
    // Resolve
    InlineCommentError["CANNOT_RESOLVE_DELETED_COMMENT"] = "%d must be existing and be an inline comment";
    return InlineCommentError;
}({});
module.exports["InlineCommentError"] = $4bdefc881ecc3bb8$export$317614131ad59950;

});

parcelRegister("6cWI7", function(module, exports) {

var $l4jQJ = parcelRequire("l4jQJ");


var $42omo = parcelRequire("42omo");


var $308Wd = parcelRequire("308Wd");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");

// This hook returns a mutation function to create a new inline comment. Because the new Comments
// Data Manager caches all the data for comments in Relay, we need to define the mutation here so
// that the cache can be updated fully when a new comment is created - and that means the mutation
// needs to return the full comment data structure that we are using in the returned query part of
// the mutation.  Since that returned query is quite large, we define it here in its own hook to
// avoid having it in many places in the codebase - which makes the code harder to read and could
// lead to the multiple copies getting out of sync.
// Data Mutation Definition:
// Unfortunately our Relay-friendly type generation tools don't support using GQL fragments yet -
// but in order to keep the definition of the comment fields in sync (so the cache update fragment
// is always in sync with the full query) we will need to manually make any changes to one
// definition in any others as well, until our tooling supports fragments and then we move to a
// more fragmented-based approach.  Note there are also comment queries or fragments in the
// following files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data/src/hooks/useCommentById.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// (Note that there is another exported GraphQL mutation variable named "CreateInlineCommentMutation"
// that is exported from @confluence/inline-comments-queries. It's okay that these are the same
// variable name because the other one does not seem to be imported anywhere in the codebase at
// present, this variable is only used internally in this file, and the actual muation's name -
// useCreateInlineCommentMutation - is unique so GQL won't complain.)
const $03f1ee89907a0c1d$var$CreateInlineCommentMutation = (0, $l4jQJ.default);
const $03f1ee89907a0c1d$export$10606ca3587bb707 = ({ contentId: contentId })=>{
    const { addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const [createInlineCommentFn] = (0, $308Wd.useMutationInterop)($03f1ee89907a0c1d$var$CreateInlineCommentMutation);
    const addEmptyInlineRepliesArray = (0, $42omo.useCallback)((commentData)=>{
        return commentData ? {
            ...commentData,
            replies: []
        } : undefined;
    }, []);
    // This is the interop mutation function that will be used by components that need to create
    // inline comments. It will either call the new Comments Data Manager path or the old Apollo
    // mutation path depending on whether the relevant experiment is enabled.
    const createInlineCommentInterop = (0, $42omo.useCallback)(({ originalMutationFn: originalMutationFn, options: options, onCacheUpdateError: onCacheUpdateError })=>{
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            // Strip out the old update function and other options, and adjust variables as needed
            // The includeReactionsAndReplies variable is needed by some of the legacy mutations but is
            // not needed by the new Comments Data Manager. So remove it if we're using the new path -
            // otherwise Typescript will complain and GQL may error as well.
            const { variables: variables } = options;
            const { includeReactionsAndReplies: _includeReactionsAndReplies, ...newVariables } = variables ?? {
                includeReactionsAndReplies: undefined
            };
            const updateNewCommentInCache = (_dataProxy, mutationResult)=>{
                addCommentInCache({
                    newComment: addEmptyInlineRepliesArray(mutationResult.data.createInlineComment),
                    onError: onCacheUpdateError
                });
            };
            return createInlineCommentFn({
                variables: {
                    ...newVariables
                },
                update: updateNewCommentInCache
            });
        } else return originalMutationFn(options);
    }, [
        addCommentInCache,
        addEmptyInlineRepliesArray,
        createInlineCommentFn
    ]);
    return {
        createInlineCommentInterop: createInlineCommentInterop
    };
};
module.exports["useCreateInlineCommentMutation"] = $03f1ee89907a0c1d$export$10606ca3587bb707;

});

parcelRegister("l4jQJ", function(module, exports) {
/**
 * @generated SignedSource<<9167f2621e6cf106559738ba6aef7b0e>>
 * @relayHash e24366c26db43cec71d2389d47713237
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6fb8d32a19fd54f1167b17c440131031a9406832544a4743963e9e462353f885
const $3dcbd79e6f23278f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v9 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v10 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v11 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v12 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "createInlineComment",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "representation",
                            "value": "ATLAS_DOC_FORMAT"
                        }
                    ],
                    "concreteType": "DocumentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": v7 /*: any*/ ,
                    "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "container",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "contentStatus"
                },
                {
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "createdAt",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAtNonLocalized"
                },
                {
                    "concreteType": "Map_LinkType_String",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "commentResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "FooterComment"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineMarkerRef"
                                },
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "inlineResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDangling"
                                        },
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineText"
                                }
                            ],
                            "type": "InlineComment"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "parentId"
                },
                {
                    "concreteType": "CommentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEditable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRemovable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isResolvable"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "childType",
                            "value": "comment"
                        },
                        {
                            "kind": "Literal",
                            "name": "contentType",
                            "value": "page"
                        },
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        }
                    ],
                    "concreteType": "ReactionsSummaryResponse",
                    "kind": "LinkedField",
                    "name": "reactionsSummary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "ari"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "containerAri"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "reactionsCount"
                        },
                        {
                            "concreteType": "ReactionsSummaryForEmoji",
                            "kind": "LinkedField",
                            "name": "reactionsSummaryForEmoji",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "emojiId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "reacted"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v5 /*: any*/ ,
                                v4 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "friendlyWhen"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "when"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCreateInlineCommentMutation",
            "selections": v12 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCreateInlineCommentMutation",
            "selections": v12 /*: any*/ 
        },
        "params": {
            "cacheID": "e24366c26db43cec71d2389d47713237",
            "id": "6fb8d32a19fd54f1167b17c440131031a9406832544a4743963e9e462353f885",
            "metadata": {},
            "name": "useCreateInlineCommentMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateInlineCommentMutation($pageId:ID!,$input:CreateInlineCommentInput!){createInlineComment(input:$input){id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}"
        }
    };
}();
$3dcbd79e6f23278f$var$node.hash = "f3ea5340b40a0a0dd635fcfbf3e8ed68";
var $3dcbd79e6f23278f$export$2e2bcd8739ae039 = $3dcbd79e6f23278f$var$node;
module.exports["default"] = $3dcbd79e6f23278f$export$2e2bcd8739ae039;

});

parcelRegister("a8ZQ3", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $0e1f4810033038ec$export$82f0a2c62bb8fbf = /*#__PURE__*/ (0, $42omo.createContext)({
    documentUpdated: false,
    documentNeedsUpdate: false,
    publishedDocumentVersion: 0,
    currentDocumentVersion: 0
});
$0e1f4810033038ec$export$82f0a2c62bb8fbf.displayName = 'DocumentUpdateStatusContext';
const $0e1f4810033038ec$export$d35f8c93092bdd5a = /*#__PURE__*/ (0, $42omo.createContext)({
    setDocumentUpdated: ()=>{},
    setDocumentNeedsUpdate: ()=>{},
    setPublishedDocumentVersion: ()=>{},
    setCurrentDocumentVersion: ()=>{}
});
$0e1f4810033038ec$export$d35f8c93092bdd5a.displayName = 'DocumentUpdateStatusDispatchContext';
const $0e1f4810033038ec$export$e1e6df7f9af5d046 = ({ children: children })=>{
    const [documentUpdated, setDocumentUpdated] = (0, $42omo.useState)(false);
    const [documentNeedsUpdate, setDocumentNeedsUpdate] = (0, $42omo.useState)(false);
    const [publishedDocumentVersion, setPublishedDocumentVersion] = (0, $42omo.useState)(0);
    const [currentDocumentVersion, setCurrentDocumentVersion] = (0, $42omo.useState)(0);
    const providerValue = (0, $42omo.useMemo)(()=>({
            documentUpdated: documentUpdated,
            documentNeedsUpdate: documentNeedsUpdate,
            publishedDocumentVersion: publishedDocumentVersion,
            currentDocumentVersion: currentDocumentVersion
        }), [
        documentUpdated,
        documentNeedsUpdate,
        publishedDocumentVersion,
        currentDocumentVersion
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setDocumentUpdated: setDocumentUpdated,
            setDocumentNeedsUpdate: setDocumentNeedsUpdate,
            setPublishedDocumentVersion: setPublishedDocumentVersion,
            setCurrentDocumentVersion: setCurrentDocumentVersion
        }), [
        setDocumentUpdated,
        setDocumentNeedsUpdate,
        setPublishedDocumentVersion,
        setCurrentDocumentVersion
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e1f4810033038ec$export$82f0a2c62bb8fbf.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e1f4810033038ec$export$d35f8c93092bdd5a.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $0e1f4810033038ec$export$ff9e1d20f8dc4075 = ()=>{
    return (0, $42omo.useContext)($0e1f4810033038ec$export$82f0a2c62bb8fbf);
};
const $0e1f4810033038ec$export$317fac591d89e2e3 = ()=>{
    return (0, $42omo.useContext)($0e1f4810033038ec$export$d35f8c93092bdd5a);
};
module.exports["DocumentUpdateStatusProvider"] = $0e1f4810033038ec$export$e1e6df7f9af5d046;
module.exports["useDocumentUpdateStatus"] = $0e1f4810033038ec$export$ff9e1d20f8dc4075;
module.exports["useDocumentUpdateStatusDispatch"] = $0e1f4810033038ec$export$317fac591d89e2e3;

});

parcelRegister("aMfLn", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");


var $kDIns = parcelRequire("kDIns");

const $194c389c7ab5ab2c$export$bbbd7ccaedea9691 = async ({ rendererActions: rendererActions, contentId: contentId, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment })=>{
    const allAnnotationMarks = rendererActions?.getAnnotationMarks();
    const allAnnotationIds = allAnnotationMarks?.map((mark)=>mark.attrs.id) || [];
    (0, $kDIns.getRendererAnnotationStates)({
        annotations: allAnnotationIds,
        pageId: contentId,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        validAnnotationsCallback: updateUnresolvedInlineComment,
        isNestedRender: false
    }).catch(()=>{
    //intentional no-op
    });
};
const $194c389c7ab5ab2c$export$2600439b3e609c06 = (step, pos)=>{
    // AddMarkStep has additional properties that aren't allowed in the mutation variables
    const markInfo = {
        mark: {
            attrs: {
                annotationType: 'inlineComment',
                id: step.mark.attrs.id
            },
            type: 'annotation'
        }
    };
    // TODO: remove this logic since pos should be read from step
    if (pos !== undefined) return {
        pos: pos,
        ...markInfo
    };
    if (step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.RemoveMarkStep)) {
        const { from: from, to: to } = step;
        return {
            from: from,
            to: to,
            ...markInfo
        };
    }
    return {
        pos: step.pos,
        ...markInfo
    };
};
module.exports["updateRendererAnnotations"] = $194c389c7ab5ab2c$export$bbbd7ccaedea9691;
module.exports["constructStepForGql"] = $194c389c7ab5ab2c$export$2600439b3e609c06;

});

parcelRegister("3Xfi8", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $7nPJ6 = parcelRequire("7nPJ6");


var $6HwWx = parcelRequire("6HwWx");

const $6a7e747c5d5174c7$export$9be7dcbe458ba189 = ({ annotationElement: annotationElement, isEditor: isEditor })=>{
    const classToCheck = '.pm-table-container';
    let elementToObserve = undefined;
    const isStickyHeaderExperimentEnabled = (0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false);
    // elements to observe, these are different than elements that determine if the table is sticky
    if (isEditor) elementToObserve = isStickyHeaderExperimentEnabled ? annotationElement?.closest(classToCheck)?.querySelector('.pm-table-wrapper > table > tbody > tr') : annotationElement?.closest(classToCheck)?.parentElement?.querySelector('.pm-table-sticky-sentinel-top');
    else elementToObserve = annotationElement?.closest(classToCheck);
    const [isSticky, setIsSticky] = (0, $7nPJ6.useIsSticky)({
        isEditor: isEditor,
        elementToObserve: elementToObserve
    });
    (0, $6HwWx.useStickyTableHeaderObserver)({
        setIsSticky: setIsSticky,
        isEditor: isEditor,
        elementToObserve: elementToObserve
    });
    // Check if annotationElement is a child of tr (th element) and th's immediate parent is tbody
    const thElement = annotationElement?.closest('th');
    if (thElement) {
        const trElement = thElement.parentElement;
        const tbodyElement = trElement?.parentElement;
        // If tr is the first child of tbody, return false
        if (tbodyElement?.firstElementChild !== trElement) return {
            isSticky: false
        };
    }
    // if annotation element is inside a nested table, then return false
    if (annotationElement?.closest('.pm-table-nested-table-with-controls')) return {
        isSticky: false
    };
    // if annotation element is not inside a table header, then return false
    if (!annotationElement?.closest('th')) return {
        isSticky: false
    };
    // Remove debug console logs
    return {
        isSticky: isSticky
    };
};
module.exports["useShouldCommentSidebarBeSticky"] = $6a7e747c5d5174c7$export$9be7dcbe458ba189;

});

parcelRegister("7nPJ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $jW2Ig = parcelRequire("jW2Ig");

const $b1509838bb0fcfff$export$2cf94d5875603a88 = ({ isEditor: isEditor, elementToObserve: elementToObserve })=>{
    const isStickyHeaderExperimentEnabled = (0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false);
    // check if table is already sticky
    const initialStickyState = elementToObserve ? (0, $jW2Ig.getIsSticky)(isEditor && isStickyHeaderExperimentEnabled ? elementToObserve : elementToObserve.parentElement, isEditor) : false;
    const [isSticky, setIsSticky] = (0, $42omo.useState)((0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') && initialStickyState);
    // Sticky state effect for post-render (useEffect)
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        if ((0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        setIsSticky(initialStickyState);
    }, [
        initialStickyState
    ]);
    // Sticky state effect for pre-render (useLayoutEffect)
    (0, $42omo.useLayoutEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        if (!(0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        setIsSticky(initialStickyState);
    }, [
        initialStickyState
    ]);
    return [
        isSticky,
        setIsSticky
    ];
};
module.exports["useIsSticky"] = $b1509838bb0fcfff$export$2cf94d5875603a88;

});

parcelRegister("jW2Ig", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $28177804efc2055d$export$17682ee29db08043 = (tableElement)=>{
    return Boolean(tableElement?.getAttribute('mode') === 'stick');
};
const $28177804efc2055d$export$4676b00e54210cb0 = (tableElement)=>{
    const isStickyHeaderExperimentEnabled = (0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false);
    if (isStickyHeaderExperimentEnabled) return Boolean(tableElement?.classList.contains('pm-table-row-native-sticky-active'));
    return Boolean(tableElement?.classList.contains('pm-table-sticky'));
};
const $28177804efc2055d$export$f3993a99776f75ca = (tableElement, isEditor)=>isEditor ? $28177804efc2055d$export$4676b00e54210cb0(tableElement) : $28177804efc2055d$export$17682ee29db08043(tableElement);
module.exports["isStickyInViewMode"] = $28177804efc2055d$export$17682ee29db08043;
module.exports["isStickyInEditMode"] = $28177804efc2055d$export$4676b00e54210cb0;
module.exports["getIsSticky"] = $28177804efc2055d$export$f3993a99776f75ca;

});

parcelRegister("6HwWx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $jW2Ig = parcelRequire("jW2Ig");

const $cf08b287de1b8d82$export$204fd756b18b92ff = ({ setIsSticky: setIsSticky, isEditor: isEditor, elementToObserve: elementToObserve })=>{
    const isStickyHeaderExperimentEnabled = (0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false);
    // if the experiment is enabled and this is the editor, we need to observe the table element
    // else, we observe the parent element
    const stickyElementToObserve = isEditor && isStickyHeaderExperimentEnabled ? elementToObserve : elementToObserve?.parentElement;
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        // Create mutation observer to track class changes
        const stickyTableHeaderObserver = new MutationObserver((mutationsList)=>{
            mutationsList.forEach((mutation)=>{
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const target = mutation.target;
                    if (isEditor && (0, $jW2Ig.isStickyInEditMode)(target) || (0, $jW2Ig.isStickyInViewMode)(target)) setIsSticky(true);
                    else setIsSticky(false);
                }
            });
        });
        // Start observing class changes
        if (stickyElementToObserve) stickyTableHeaderObserver.observe(stickyElementToObserve, {
            attributes: true,
            attributeFilter: [
                'class'
            ]
        });
        // Clean up all observers
        return ()=>{
            stickyTableHeaderObserver.disconnect();
        };
    }, [
        stickyElementToObserve,
        isEditor,
        setIsSticky
    ]);
};
module.exports["useStickyTableHeaderObserver"] = $cf08b287de1b8d82$export$204fd756b18b92ff;

});

parcelRegister("eA7s6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aHcFH = parcelRequire("aHcFH");

const $168172ede45a02b4$export$aca484f2c8185777 = ({ annotationElement: annotationElement, isEditor: isEditor, isViewCommentMode: isViewCommentMode, windowWidth: windowWidth, isSticky: isSticky })=>{
    return (0, $42omo.useMemo)(()=>{
        if (!annotationElement) return 0;
        if (isEditor) return (0, $aHcFH.calculateEditorOffsetFromParent)(annotationElement, '.fabric-editor-popup-scroll-parent');
        return (0, $aHcFH.calculateRendererOffsetFromParent)(annotationElement, `[data-annotation-draft-mark="true"]`, Boolean(isViewCommentMode));
    // We want to re-calculate when the window width changes or the comment sidebar becomes sticky / unsticky
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isEditor,
        annotationElement,
        isViewCommentMode,
        windowWidth,
        isSticky
    ]);
};
module.exports["useCommentSidebarOffset"] = $168172ede45a02b4$export$aca484f2c8185777;

});

parcelRegister("5pQ1Y", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $676464c7222bdee0$export$d84a6ddaa8e6e9d9 = /*#__PURE__*/ (0, $42omo.createContext)({
    refetchContent: false
});
$676464c7222bdee0$export$d84a6ddaa8e6e9d9.displayName = 'ContentRefetchContext';
const $676464c7222bdee0$export$dfd2d999f6a2731 = /*#__PURE__*/ (0, $42omo.createContext)({
    setRefetchContent: ()=>{}
});
$676464c7222bdee0$export$dfd2d999f6a2731.displayName = 'ContentRefetchDispatchContext';
const $676464c7222bdee0$export$cfa813593f7b7ba = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children } = t0;
    const [refetchContent, setRefetchContent] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== refetchContent) {
        t1 = {
            refetchContent: refetchContent
        };
        $[0] = refetchContent;
        $[1] = t1;
    } else t1 = $[1];
    const providerValue = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            setRefetchContent: (shouldRefetchContent)=>setRefetchContent(shouldRefetchContent)
        };
        $[2] = t2;
    } else t2 = $[2];
    const dispatchProviderValue = t2;
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($676464c7222bdee0$export$dfd2d999f6a2731.Provider, {
            value: dispatchProviderValue
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== providerValue || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($676464c7222bdee0$export$d84a6ddaa8e6e9d9.Provider, {
            value: providerValue
        }, t3);
        $[5] = providerValue;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};
const $676464c7222bdee0$export$68e22604851d391b = ()=>{
    return (0, $42omo.useContext)($676464c7222bdee0$export$d84a6ddaa8e6e9d9);
};
const $676464c7222bdee0$export$8ebf7a2378ada555 = ()=>{
    return (0, $42omo.useContext)($676464c7222bdee0$export$dfd2d999f6a2731);
};
module.exports["ContentRefetchProvider"] = $676464c7222bdee0$export$cfa813593f7b7ba;
module.exports["useContentRefetch"] = $676464c7222bdee0$export$68e22604851d391b;
module.exports["useContentRefetchDispatch"] = $676464c7222bdee0$export$8ebf7a2378ada555;

});

parcelRegister("en1dX", function(module, exports) {
var $88e03e673e36ecc4$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["COMMENTS_PANEL"] = "commentsPanel";
    AnalyticsSource["STANDALONE"] = "standalone";
    AnalyticsSource["PAGE_FOOTER"] = "pageFooter";
    return AnalyticsSource;
}({});
var $88e03e673e36ecc4$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["REOPEN_COMMENT"] = "reopenComment";
    return ActionName;
}({});
var $88e03e673e36ecc4$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    CommentType["PAGE"] = "page";
    return CommentType;
}({});
module.exports["AnalyticsSource"] = $88e03e673e36ecc4$export$6890652a1aff7d1c;
module.exports["ActionName"] = $88e03e673e36ecc4$export$9c95d6e1614bad84;
module.exports["CommentType"] = $88e03e673e36ecc4$export$ffa1150e6a48f9cd;

});

parcelRegister("9FoVw", function(module, exports) {
/**
 * @fileoverview Unified comment navigation utilities for scrolling to different comment types
 * and handling various navigation scenarios across editor and renderer contexts.
 */ 
var $21K7m = parcelRequire("21K7m");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $6mKj3 = parcelRequire("6mKj3");


var $i49vP = parcelRequire("i49vP");


var $aHcFH = parcelRequire("aHcFH");

var $0343eaf78527fd4c$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["NEXT"] = "next";
    ShortcutType["PREVIOUS"] = "previous";
    ShortcutType["UNREAD"] = "unread";
    return ShortcutType;
}({});
var $0343eaf78527fd4c$var$CommentType = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}($0343eaf78527fd4c$var$CommentType || {});
var $0343eaf78527fd4c$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    return ViewValues;
}({});
// Navigation types based on comment scrolling architecture
var $0343eaf78527fd4c$var$NavigationType = /*#__PURE__*/ function(NavigationType) {
    NavigationType["INLINE_ANNOTATION"] = "inline_annotation";
    NavigationType["COMMENTS_PANEL"] = "comments_panel";
    NavigationType["FOOTER_COMMENTS"] = "footer_comments";
    NavigationType["DEEP_LINK"] = "deep_link";
    NavigationType["KEYBOARD_SHORTCUT"] = "keyboard_shortcut";
    NavigationType["INLINE_HEADER_ARROWS"] = "inline_header_arrows";
    return NavigationType;
}($0343eaf78527fd4c$var$NavigationType || {});
var $0343eaf78527fd4c$export$e6e360ac7d345e5 = /*#__PURE__*/ function(ScrollBehavior) {
    ScrollBehavior["INSTANT"] = "instant";
    ScrollBehavior["SMOOTH"] = "smooth";
    return ScrollBehavior;
}({});
var $0343eaf78527fd4c$export$3044ab7fdabeaee6 = /*#__PURE__*/ function(NavigationContext) {
    NavigationContext["EDITOR"] = "editor";
    NavigationContext["RENDERER"] = "renderer";
    NavigationContext["PANEL"] = "panel";
    NavigationContext["REPLY"] = "reply";
    return NavigationContext;
}({});
const $0343eaf78527fd4c$export$9f32f1ed184088e0 = (options)=>{
    const { scrollBehavior: scrollBehavior, context: context, block: block, inline: inline, markElement: markElement, annotationId: annotationId } = options;
    if (!markElement) return false;
    // Handle different contexts
    switch(context){
        case "editor":
            // Check if element needs to be expanded in editor
            (0, $i49vP.checkElementExpandInEditor)(markElement);
            // Emit the setselectedannotation event
            const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
            editorEmitter.emit('setselectedannotation', markElement.id);
            // Scroll to the element in editor
            (0, $i49vP.scrollToElementInEditor)({
                targetElement: markElement,
                viewingRoomOffset: -100
            });
            return true;
        case "renderer":
            // Renderer-specific logic with improved focus management
            const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
            if (focusedMarkerRef?.id !== markElement.id) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                    annotationId: markElement.id
                });
                // Check if element needs to be expanded
                (0, $aHcFH.checkElementExpand)(markElement, true);
            }
            // Scroll to the annotation mark
            markElement.scrollIntoView({
                behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
                block: block,
                inline: inline
            });
            return true;
        case "panel":
            // For panel context, ensure annotation is visible and highlighted
            if (annotationId) {
                // Emit events to ensure the annotation is properly focused
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                    annotationId: annotationId
                });
            }
            // Scroll the annotation into view
            markElement.scrollIntoView({
                behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
                block: block,
                inline: inline
            });
            return true;
        default:
            return false;
    }
};
/**
 * Wait for the comments panel to be rendered in the DOM
 * Returns a Promise that resolves when the panel is available or times out after 5 seconds
 */ const $0343eaf78527fd4c$var$waitForCommentsPanel = ()=>{
    const commentsPanelListContainerId = 'comments-panel-list-container';
    return new Promise((resolve)=>{
        const observer = new MutationObserver(()=>{
            const panel = document.querySelector(`[data-testid='${commentsPanelListContainerId}']`);
            if (panel) {
                observer.disconnect();
                resolve(true);
            }
        });
        // Start observing the document body for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        // Set a timeout to avoid infinite waiting
        setTimeout(()=>{
            observer.disconnect();
            resolve(false);
        }, 5000); // 5 second timeout
    });
};
/**
 * Wait for the comments panel view/filter to change to the specified view
 * Returns a Promise that resolves when the view change is complete or times out after 3 seconds
 */ const $0343eaf78527fd4c$var$waitForViewChange = (expectedView)=>{
    return new Promise((resolve)=>{
        // Check if the view has already changed by checking the data-current-view attribute on the container
        const checkView = ()=>{
            const container = document.querySelector('[data-testid="comments-panel-list-container"]');
            if (container && container.getAttribute('data-current-view') === expectedView) return true;
        };
        if (checkView()) {
            resolve(true);
            return;
        }
        // Observe document body for both container creation and attribute changes
        // This handles cases where the container gets unmounted/remounted
        const observer = new MutationObserver(()=>{
            if (checkView()) {
                observer.disconnect();
                resolve(true);
            }
        });
        // Observe the entire document body to catch:
        // 1. Container being created/removed
        // 2. Attribute changes on the container when it exists
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                'data-current-view'
            ]
        });
        // Set a timeout to avoid infinite waiting
        setTimeout(()=>{
            observer.disconnect();
            resolve(false);
        }, 3000); // 3 second timeout
    });
};
/**
 * Check if the top edge of an element is visible in the viewport
 * Used to determine if scrolling is needed based on element visibility
 */ const $0343eaf78527fd4c$var$isElementTopVisible = (element)=>{
    const rect = element.getBoundingClientRect();
    return rect.top >= 0;
};
/**
 * Wait for an element to finish scrolling into view
 * Returns a Promise that resolves when the element is reasonably visible or times out
 */ const $0343eaf78527fd4c$var$waitForScrollCompletion = (element, timeout = 3000)=>{
    return new Promise((resolve)=>{
        const startTime = Date.now();
        const check = ()=>{
            if ($0343eaf78527fd4c$var$isElementTopVisible(element)) // Add a small delay after element becomes visible to let scrolling settle
            setTimeout(()=>resolve(true), 150);
            else if (Date.now() - startTime > timeout) resolve(false);
            else requestAnimationFrame(check);
        };
        // Small delay to let scroll animation start
        setTimeout(check, 16);
    });
};
/**
 * Helper function for viewport checking - returns true if should skip scrolling due to viewport visibility
 */ const $0343eaf78527fd4c$var$checkAndHandleViewportVisibility = (element, shouldScrollIfCommentIsInViewport)=>{
    if (!shouldScrollIfCommentIsInViewport) {
        const commentIsInViewport = $0343eaf78527fd4c$var$isElementTopVisible(element);
        if (commentIsInViewport) return true;
    }
    return false;
};
/**
 * Handle scroll completion based on awaitScrollCompletion flag and scroll behavior
 */ const $0343eaf78527fd4c$var$handleScrollCompletion = (awaitScrollCompletion, scrollBehavior, element)=>{
    if (awaitScrollCompletion) return scrollBehavior === "smooth" ? $0343eaf78527fd4c$var$waitForScrollCompletion(element) : Promise.resolve(true);
    return true;
};
/**
 * Check if an element is already fully visible within the panel
 * Avoids unnecessary scrolling if the element is already in view
 */ const $0343eaf78527fd4c$var$isElementFullyVisible = (element)=>{
    const elementRect = element.getBoundingClientRect();
    const panelContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    const panelRect = panelContainer?.getBoundingClientRect();
    if (!panelRect) return false;
    return elementRect.top >= panelRect.top && elementRect.bottom <= panelRect.bottom;
};
/**
 * Determine the optimal scroll position based on context and comment type
 * Considers whether to scroll to start, center, or end based on various factors
 */ const $0343eaf78527fd4c$var$determineScrollPosition = (element, block, scrollToEnd, commentType)=>{
    let scrollBlock = block;
    if (scrollToEnd) {
        // Check if the comment thread reply is out of view
        // Map CommentsType to CommentType enum for domUtils functions
        const commentTypeEnum = commentType === 'INLINE' ? "inline" : "general";
        const isOutOfView = (0, $aHcFH.isCommentThreadReplyOutOfView)(element, commentTypeEnum);
        if (isOutOfView) scrollBlock = 'end';
    } else {
        // Check if we should scroll to top
        // Map CommentsType to CommentType enum for domUtils functions
        const commentTypeEnum = commentType === 'INLINE' ? "inline" : "general";
        const shouldScrollToTop = (0, $aHcFH.shouldScrollCommentThreadToTop)(element, commentTypeEnum);
        if (shouldScrollToTop) scrollBlock = 'start';
    }
    return scrollBlock;
};
/**
 * Perform the actual scrolling operation with optimized behavior
 * Handles different scroll scenarios based on user interaction context
 */ const $0343eaf78527fd4c$var$performScrollToElement = (element, scrollBehavior, block, scrollToEnd, hasKeyPressed, annotationClicked, scrollOnLoad, commentType)=>{
    // Skip scrolling if element is already fully visible
    if ($0343eaf78527fd4c$var$isElementFullyVisible(element)) return;
    // Determine scroll behavior based on trigger type
    if (hasKeyPressed || annotationClicked || scrollOnLoad) {
        const scrollBlock = $0343eaf78527fd4c$var$determineScrollPosition(element, block, scrollToEnd, commentType);
        element.scrollIntoView({
            behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
            block: scrollBlock
        });
    } else // Default scroll behavior
    element.scrollIntoView({
        behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
        block: block
    });
};
const $0343eaf78527fd4c$export$390f6df30bfcd812 = (options)=>{
    const { scrollBehavior: scrollBehavior, context: context, block: block, commentId: commentId, annotationId: annotationId, commentType: commentType, scrollToEnd: scrollToEnd = false, hasKeyPressed: hasKeyPressed = false, annotationClicked: annotationClicked = false, scrollOnLoad: scrollOnLoad = false, shouldScrollIfCommentIsInViewport: shouldScrollIfCommentIsInViewport = true, awaitScrollCompletion: awaitScrollCompletion = false } = options;
    // Only handle panel context navigation
    if (context !== "panel") return false;
    // Define panel container and thread selectors
    const commentsPanelListContainerId = 'comments-panel-list-container';
    // annotationId is used for DOM selectors, commentId is the actual comment identifier
    const commentThreadContainerId = `comment-thread-${annotationId}-container`;
    // Check if panel is available, wait if not
    const panelContainer = document.querySelector(`[data-testid='${commentsPanelListContainerId}']`);
    if (!panelContainer) // Panel is not rendered yet, wait for it to appear
    return $0343eaf78527fd4c$var$waitForCommentsPanel().then((panelAvailable)=>{
        if (panelAvailable) // Recursively call the function now that panel is available
        return $0343eaf78527fd4c$export$390f6df30bfcd812(options);
        return false;
    });
    // Look for the specific comment thread container
    const commentThreadElement = document.querySelector(`[data-testid='${commentThreadContainerId}']`);
    // If comment thread exists, scroll immediately
    if (commentThreadElement) {
        const skipScrollDueToViewport = $0343eaf78527fd4c$var$checkAndHandleViewportVisibility(commentThreadElement, shouldScrollIfCommentIsInViewport);
        if (skipScrollDueToViewport) return true;
        $0343eaf78527fd4c$var$performScrollToElement(commentThreadElement, scrollBehavior, block, scrollToEnd, hasKeyPressed, annotationClicked, scrollOnLoad, commentType);
        // For panel navigation, always return Promise when awaitScrollCompletion is true
        return $0343eaf78527fd4c$var$handleScrollCompletion(awaitScrollCompletion, scrollBehavior, commentThreadElement);
    }
    // Use optimized observer to watch for comment thread container creation
    commentId && (0, $aHcFH.watchForCommentContainerAndScroll)(commentId);
    return true;
};
const $0343eaf78527fd4c$export$dcd3c0d6a66d0412 = async (options)=>{
    const { expectedView: expectedView, commentId: commentId, annotationId: annotationId, ...navigationOptions } = options;
    // Only wait for view change for panel context
    if (navigationOptions.context === "panel" && expectedView) await $0343eaf78527fd4c$var$waitForViewChange(expectedView);
    // Then perform the navigation - pass both commentId and annotationId
    return $0343eaf78527fd4c$export$390f6df30bfcd812({
        ...navigationOptions,
        commentId: commentId,
        annotationId: annotationId
    });
};
const $0343eaf78527fd4c$export$34fd7e98d0739b5c = (options)=>{
    const { block: block, inline: inline, commentId: commentId, scrollBehavior: scrollBehavior, navigationContext: navigationContext, shouldScrollIfCommentIsInViewport: shouldScrollIfCommentIsInViewport = true, awaitScrollCompletion: awaitScrollCompletion = false } = options;
    let containerId;
    if (!commentId) return false;
    // Check if comment already exists in DOM
    // Determine container ID based on navigation context:
    // - PANEL: uses comment-thread container
    // - REPLY: uses data-comment-id attribute selector
    // - Default (footer): uses footer-comment-thread container
    if (navigationContext === "panel") containerId = `comment-thread-${commentId}-container`;
    else if (navigationContext === "reply") containerId = `[data-comment-id="${commentId}"]`;
    else containerId = `footer-comment-thread-${commentId}-container`;
    // Use querySelector for REPLY context (attribute selector), getElementById for others (ID)
    const existingComment = navigationContext === "reply" ? document.querySelector(containerId) : document.getElementById(containerId);
    if (existingComment) {
        const skipScrollDueToViewport = $0343eaf78527fd4c$var$checkAndHandleViewportVisibility(existingComment, shouldScrollIfCommentIsInViewport);
        if (skipScrollDueToViewport) return true;
        // Comment is already rendered, scroll to it immediately
        existingComment.scrollIntoView({
            behavior: scrollBehavior,
            block: block,
            inline: inline
        });
        // Wait for scroll completion when awaitScrollCompletion is true, otherwise return true
        return $0343eaf78527fd4c$var$handleScrollCompletion(awaitScrollCompletion, scrollBehavior, existingComment);
    } else {
        // Comment not yet rendered, use DOM resolver to watch for it
        (0, $aHcFH.watchForCommentRepliesAndScroll)({
            targetCommentId: commentId,
            onScrollReady: (commentElement)=>{
                // Find the container element by ID or selector based on navigation context
                const containerElement = navigationContext === "reply" ? document.querySelector(containerId) : document.getElementById(containerId);
                const elementToScroll = containerElement || commentElement;
                elementToScroll.scrollIntoView({
                    behavior: scrollBehavior,
                    block: block,
                    inline: inline
                });
            },
            containerId: containerId
        });
        return true;
    }
};
const $0343eaf78527fd4c$export$ea1c337d9000e2 = (options)=>{
    const { scrollBehavior: scrollBehavior, block: block, inline: inline, commentId: commentId, markElement: markElement, context: context } = options;
    if (!commentId || !markElement) return false;
    // Check if comment already exists in DOM
    const existingComment = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (existingComment) {
        // Comment is already rendered, scroll to it immediately
        existingComment.scrollIntoView({
            behavior: scrollBehavior,
            block: block,
            inline: inline
        });
        return true;
    }
    // we need to click on the annotation in the editor if the comment is not yet rendered
    if (context === "editor" && markElement) (0, $i49vP.openInlineCommentInEditor)({
        targetElement: markElement,
        targetElementID: markElement.id,
        shouldScroll: false
    });
    // Comment not yet rendered, use DOM resolver to watch for it
    (0, $aHcFH.watchForCommentRepliesAndScroll)({
        targetCommentId: commentId,
        onScrollReady: (commentElement)=>{
            commentElement.scrollIntoView({
                behavior: scrollBehavior,
                block: block,
                inline: inline
            });
        },
        markElement: markElement
    });
    return true;
};
const $0343eaf78527fd4c$export$807107038899c351 = (options)=>{
    const { scrollBehavior: scrollBehavior, block: block, inline: inline, annotationId: annotationId, commentId: commentId, commentType: commentType, isCommentsPanelOpen: isCommentsPanelOpen, hasKeyPressed: hasKeyPressed = true, scrollToEnd: scrollToEnd = false, context: context, shortcutType: shortcutType, isResolved: isResolved, previousAnnotationId: previousAnnotationId } = options;
    // Get the mark element for both inline navigation and annotation events
    let markElement = document.getElementById(annotationId);
    const commentElement = document.querySelector(`[data-comment-id="${commentId}"]`);
    // Get the previous comment element for difference-based scrolling
    const previousCommentElement = previousAnnotationId ? document.getElementById(previousAnnotationId) : null;
    // Check if the mark element is in a sticky table header and adjust if needed
    const isInStickyTableHeader = markElement?.closest && markElement.closest('.pm-table-sticky-wrapper');
    if (isInStickyTableHeader && markElement && (0, $6mKj3.expValEquals)('confluence_comment_enable_table_header_navigation', 'isEnabled', true)) // Get the real element from the non-sticky table using getNodeForTableORMacro
    markElement = (0, $aHcFH.getNodeForTableORMacro)(markElement) || markElement;
    if (commentType === 'FOOTER') $0343eaf78527fd4c$export$34fd7e98d0739b5c({
        scrollBehavior: scrollBehavior,
        block: block,
        inline: inline || 'center',
        commentId: annotationId
    });
    // If comments panel is open, use panel navigation
    if (isCommentsPanelOpen) {
        // For inline comments, also call handleInlineAnnotationNavigation to ensure proper inline comment behavior
        if (commentType === 'INLINE' && !isResolved) $0343eaf78527fd4c$export$9f32f1ed184088e0({
            scrollBehavior: scrollBehavior,
            context: context || "panel",
            block: block,
            inline: inline || 'center',
            markElement: markElement,
            annotationId: annotationId
        });
        // This ensure the ViewComponent useEffect is not triggered
        if (markElement && !isResolved) {
            // Emit annotation events for panel navigation
            if (context === "editor") {
                const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
                editorEmitter.emit('setselectedannotation', annotationId);
            } else if (context === "renderer") {
                const rendererEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                rendererEmitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: null
                });
            }
        }
        // Use the existing panel navigation logic
        const result = $0343eaf78527fd4c$export$390f6df30bfcd812({
            scrollBehavior: scrollBehavior,
            context: "panel",
            block: block,
            inline: inline,
            annotationId: annotationId,
            commentType: commentType,
            hasKeyPressed: hasKeyPressed,
            scrollToEnd: scrollToEnd
        });
        if (result instanceof Promise) // For async panel navigation, return true immediately
        // The actual navigation will happen asynchronously
        return true;
        return result;
    }
    if (!markElement) return false;
    // For standalone navigation (comments panel closed), expand the element if needed
    if (commentType === 'INLINE' && context === "renderer") (0, $aHcFH.checkElementExpand)(markElement, true);
    // Use difference-based scrolling if we have both previous and next elements
    if (previousCommentElement && markElement && previousCommentElement !== markElement && (0, $6mKj3.expValEquals)('confluence_comment_use_kbs_exp', 'isEnabled', true)) {
        if (context === "editor") {
            // For editor: use scrollableContainer.scrollBy with difference offset
            const scrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollableContainer) {
                // Calculate difference between next and previous comment positions
                const nextRect = markElement.getBoundingClientRect();
                const previousRect = previousCommentElement.getBoundingClientRect();
                const differenceOffset = nextRect.top - previousRect.top;
                scrollableContainer.scrollBy(0, differenceOffset);
            }
        } else // For renderer: use scrollToComment with difference-based scrolling
        (0, $aHcFH.scrollToComment)(markElement, previousCommentElement, true, false);
        return true;
    }
    // For unread navigation, scroll to the comment element with data-comment-id instead of markElement
    if (shortcutType === "unread" && commentElement) commentElement.scrollIntoView({
        behavior: scrollBehavior,
        block: block,
        inline: inline || 'nearest'
    });
    else // For standalone navigation, we don't emit events - just scroll to the element
    markElement.scrollIntoView({
        behavior: scrollBehavior,
        block: block,
        inline: inline || 'nearest'
    });
    return true;
};
/**
 * Calculate the height of media comment placeholder to adjust scroll offset.
 * When the media comment placeholder is visible, it pushes the contents of the page down,
 * so we need to scroll a bit less to keep the cursor over the navigation arrow icon.
 */ const $0343eaf78527fd4c$var$getMediaCommentPlaceholderHeight = (options)=>{
    const { previousCommentElement: previousCommentElement, action: action, nextCommentIndex: nextCommentIndex, totalComments: totalComments } = options;
    const isCurrentCommentContentMediaComment = previousCommentElement?.closest('.media-single-node');
    const isNavigatingToLastCommentFromPreviousAction = action === 'previous' && nextCommentIndex === totalComments - 1;
    const isNavigatingToFirstCommentFromNextAction = action === 'next' && nextCommentIndex === 0;
    if (isCurrentCommentContentMediaComment && (action === 'next' || isNavigatingToLastCommentFromPreviousAction || isNavigatingToFirstCommentFromNextAction)) {
        const mediaCommentSelectedPlaceholder = document.querySelector('[data-id="caption-placeholder"]');
        return mediaCommentSelectedPlaceholder ? mediaCommentSelectedPlaceholder.offsetHeight : 0;
    }
    return 0;
};
const $0343eaf78527fd4c$export$36dad1a923539611 = (options)=>{
    const { previousMarkerRef: previousMarkerRef, nextMarkerRef: nextMarkerRef, context: context, action: action, nextCommentIndex: nextCommentIndex, totalComments: totalComments } = options;
    // Get the next comment element
    const nextMarkElement = document.getElementById(nextMarkerRef);
    if (!nextMarkElement) return false;
    // Get the previous and next comment elements
    const previousCommentElement = document.getElementById(previousMarkerRef);
    const nextCommentElement = document.getElementById(nextMarkerRef);
    if (previousCommentElement && nextCommentElement) {
        const heightOfMediaCommentSelectedPlaceholder = $0343eaf78527fd4c$var$getMediaCommentPlaceholderHeight({
            previousCommentElement: previousCommentElement,
            action: action,
            nextCommentIndex: nextCommentIndex,
            totalComments: totalComments
        });
        if (context === "editor") {
            // For editor: use scrollableContainer.scrollBy with difference offset
            const scrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollableContainer) {
                // Calculate difference between current and previous comment positions using calculateElementOffset
                // This handles special cases like sticky table headers
                const previousOffset = (0, $aHcFH.calculateElementOffset)(previousCommentElement);
                const nextOffset = (0, $aHcFH.calculateElementOffset)(nextCommentElement);
                const differenceOffset = nextOffset - previousOffset - heightOfMediaCommentSelectedPlaceholder;
                scrollableContainer.scrollBy(0, differenceOffset);
            }
        } else // For renderer: use scrollToComment
        (0, $aHcFH.scrollToComment)(nextCommentElement, previousCommentElement, true, false);
    }
    return true;
};
module.exports["ShortcutType"] = $0343eaf78527fd4c$export$99058db374262376;
module.exports["ScrollBehavior"] = $0343eaf78527fd4c$export$e6e360ac7d345e5;
module.exports["NavigationContext"] = $0343eaf78527fd4c$export$3044ab7fdabeaee6;
module.exports["handleInlineAnnotationNavigation"] = $0343eaf78527fd4c$export$9f32f1ed184088e0;
module.exports["handleCommentsPanelNavigation"] = $0343eaf78527fd4c$export$390f6df30bfcd812;
module.exports["handleCommentsPanelNavigationWithViewChange"] = $0343eaf78527fd4c$export$dcd3c0d6a66d0412;
module.exports["handleFooterCommentsNavigation"] = $0343eaf78527fd4c$export$34fd7e98d0739b5c;
module.exports["handleDeepLinkNavigation"] = $0343eaf78527fd4c$export$ea1c337d9000e2;
module.exports["handleKeyboardShortcutNavigation"] = $0343eaf78527fd4c$export$807107038899c351;
module.exports["handleInlineHeaderArrowsNavigation"] = $0343eaf78527fd4c$export$36dad1a923539611;

});

parcelRegister("b0EGa", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $6d5fb7464c13acdf$var$initialState = {
    hideRequestCount: 0
};
const $6d5fb7464c13acdf$var$actions = {
    /**
	 * Request to hide the OmniBar. Call this when your component/popup opens.
	 * Must be paired with releaseHideOmniBar when the component closes.
	 */ requestHideOmniBar: ()=>({ setState: setState, getState: getState })=>{
            const { hideRequestCount: hideRequestCount } = getState();
            setState({
                hideRequestCount: hideRequestCount + 1
            });
        },
    /**
	 * Release a hide request. Call this when your component/popup closes.
	 * Must be paired with a previous requestHideOmniBar call.
	 */ releaseHideOmniBar: ()=>({ setState: setState, getState: getState })=>{
            const { hideRequestCount: hideRequestCount } = getState();
            if (hideRequestCount > 0) setState({
                hideRequestCount: hideRequestCount - 1
            });
        }
};
const $6d5fb7464c13acdf$export$11b4e542b178c9bc = (0, $1P1Tu.createStore)({
    initialState: $6d5fb7464c13acdf$var$initialState,
    actions: $6d5fb7464c13acdf$var$actions,
    name: 'OmniBarVisibilityStore'
});
const $6d5fb7464c13acdf$export$c640b7434448a8d = (0, $9zUhf.createStateHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc, {
    selector: (state)=>state.hideRequestCount > 0
});
const $6d5fb7464c13acdf$export$6c29083870fa1fac = (0, $9zUhf.createActionsHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc);
module.exports["useOmniBarVisibilityActions"] = $6d5fb7464c13acdf$export$6c29083870fa1fac;

});

parcelRegister("a3q17", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $60a54f1e533f2ef6$export$52ff686bd4414bc5 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
const $60a54f1e533f2ef6$export$ac7f79e65475cee7 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
const $60a54f1e533f2ef6$export$321e1f68b293bf76 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'highlightsRendered',
            endMark: 'highlightsRendered'
        }
    ]
});
const $60a54f1e533f2ef6$export$fc794218ec0a6fa5 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: 'direct-comment-data-flow',
    timings: [
        {
            key: 'commentCreationStart',
            startMark: 'commentCreationStart'
        },
        {
            key: 'commentCreationEnd',
            endMark: 'commentCreationEnd'
        },
        {
            key: 'commentDataLoad',
            startMark: 'commentDataLoadStart',
            endMark: 'commentDataLoadEnd'
        }
    ]
});
module.exports["EDITOR_INLINE_COMMENT_RENDER_METRIC"] = $60a54f1e533f2ef6$export$52ff686bd4414bc5;
module.exports["RENDERER_INLINE_COMMENT_RENDER_METRIC"] = $60a54f1e533f2ef6$export$ac7f79e65475cee7;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_METRIC"] = $60a54f1e533f2ef6$export$321e1f68b293bf76;
module.exports["DIRECT_COMMENT_DATA_FLOW_METRIC"] = $60a54f1e533f2ef6$export$fc794218ec0a6fa5;

});

parcelRegister("B3Avz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $lisKW = parcelRequire("lisKW");


var $T1bCI = parcelRequire("T1bCI");


var $hmuev = parcelRequire("hmuev");


var $ccHMk = parcelRequire("ccHMk");


var $1yB28 = parcelRequire("1yB28");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $hnvzE = parcelRequire("hnvzE");


var $3gadb = parcelRequire("3gadb");


var $6mKj3 = parcelRequire("6mKj3");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $i49vP = parcelRequire("i49vP");


var $eToX6 = parcelRequire("eToX6");


var $bSvtO = parcelRequire("bSvtO");


var $8SCD6 = parcelRequire("8SCD6");


var $cMvMc = parcelRequire("cMvMc");


var $5fMeR = parcelRequire("5fMeR");


var $3D12W = parcelRequire("3D12W");


var $3mVfX = parcelRequire("3mVfX");


var $kRW4Y = parcelRequire("kRW4Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $9wGTI = parcelRequire("9wGTI");


var $666Tc = parcelRequire("666Tc");


var $aWwYt = parcelRequire("aWwYt");


var $gnkil = parcelRequire("gnkil");


var $8uM2K = parcelRequire("8uM2K");


var $6wiaZ = parcelRequire("6wiaZ");


var $bEwJH = parcelRequire("bEwJH");


var $bXQxx = parcelRequire("bXQxx");

const $2cc0402d98a7d80d$export$b8454eaf88df51d0 = (entry, setIsSticky, setSidebarOffset, sidebarOffset)=>{
    if (entry.intersectionRatio === 0) {
        setIsSticky(false);
        setSidebarOffset(sidebarOffset);
    } else {
        setIsSticky(true);
        setSidebarOffset(// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expValEquals)('confluence_fe_fix_sticky_comment_sidebar_position', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? (0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW) : (0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW_OLD));
    }
};
const $2cc0402d98a7d80d$var$redesignedViewAllStyle = (0, $ecnYn.xcss)({
    position: 'absolute',
    right: 'space.500',
    // This gives us 4px between the X and the comment icon
    top: 'space.150' // This lines us up exactly with X
});
const $2cc0402d98a7d80d$var$viewAllContainerStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.150',
    left: 'space.075',
    alignItems: 'center',
    justifyContent: 'center'
});
const $2cc0402d98a7d80d$var$commentHeaderStyle = (0, $ecnYn.xcss)({
    flexDirection: 'column',
    display: 'flex',
    marginTop: 'space.400'
});
const $2cc0402d98a7d80d$var$commentNewHeaderMargin = (0, $ecnYn.xcss)({
    marginTop: 'space.500'
});
const $2cc0402d98a7d80d$var$shadowElementStyle = {
    height: '4px',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.15) 0%, transparent 100%)',
    width: '100%',
    margin: '0',
    padding: '0'
};
const $2cc0402d98a7d80d$var$commentEditorStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.0'
});
const $2cc0402d98a7d80d$var$boxWithMaxHeight = (0, $ecnYn.xcss)({
    maxHeight: 'calc(100vh - 300px)',
    overflowY: 'auto'
});
const $2cc0402d98a7d80d$var$boxWithoutMaxHeight = (0, $ecnYn.xcss)({
    overflowY: 'visible'
});
const $2cc0402d98a7d80d$var$boxWithDynamicMaxHeightAuto = (0, $ecnYn.xcss)({
    overflowY: 'auto'
});
const $2cc0402d98a7d80d$export$d560bdb1ceec916a = ({ pageId: pageId, onClose: onClose, annotationElement: annotationElement, navigationOptions: navigationOptions, isEditor: isEditor, isViewCommentMode: isViewCommentMode, children: children, sidebarOffset: sidebarOffset, commentId: commentId, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, sidebarEl: sidebarEl, annotationId: annotationId, inlineCommentRef: inlineCommentRef = ()=>{}, nudgeRef: nudgeRef, isSticky: isSticky, isFabricPage: isFabricPage, authorName: authorName, setPopupsScrollableElement: setPopupsScrollableElement, onMaxHeightApplied: onMaxHeightApplied })=>{
    const [oldIsSticky, setOldIsSticky] = (0, $42omo.useState)(false);
    const [newSidebarOffset, setSidebarOffset] = (0, $42omo.useState)(sidebarOffset);
    const [showA11yAnnouncement, setShowA11yAnnouncement] = (0, $42omo.useState)(false);
    const [isScrolled, setIsScrolled] = (0, $42omo.useState)(false);
    const [isRefSet, setIsRefSet] = (0, $42omo.useState)(false);
    // Compute isMaxHeightEnabledForSticky first to pass to hook
    const isMaxHeightEnabledForSticky = (0, $6mKj3.expValEquals)('confluence_comment_enable_maxheight', 'isEnabled', true) || isSticky && (0, $9wGTI.fg)('confluence-fe-comment-temp-max-height-fix');
    // Compute hasMaxHeight locally and notify parent via callback
    const { hasMaxHeight: hasMaxHeight, dynamicMaxHeight: dynamicMaxHeight } = (0, $6wiaZ.useHasMaxHeight)({
        sidebarEl: sidebarEl,
        isRefSet: isRefSet,
        isFabricPage: isFabricPage,
        isSticky: isSticky,
        annotationElement: annotationElement,
        isEditor: isEditor,
        sidebarOffset: sidebarOffset,
        isMaxHeightEnabledForSticky: isMaxHeightEnabledForSticky
    });
    const applyMaxHeightStyles = hasMaxHeight && isMaxHeightEnabledForSticky;
    const useDynamicMaxHeight = !!dynamicMaxHeight && (0, $6mKj3.expValEquals)('cc_comments_dynamic_inline_height', 'isEnabled', true);
    // Notify parent when max height styles change
    (0, $42omo.useEffect)(()=>{
        onMaxHeightApplied?.(!!applyMaxHeightStyles);
    }, [
        applyMaxHeightStyles,
        onMaxHeightApplied
    ]);
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey } = (0, $3mVfX.useCommentsPanelActions)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        let offset = 0;
        if (annotationElement && !isEditor) {
            let scrollParent;
            if (isEditor) {
                scrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
                offset = (0, $aHcFH.calculateElementOffset)(annotationElement, scrollParent);
            } else {
                /*
        There's two cases here: a view comment and a create comment.
        We need the correct scrollParent for each case.
        Since it's not the editor in this logical branch we should use #content as the scrollParent.
        */ scrollParent = document.querySelector('div#content[data-inline-comments-target="true"]');
                if (scrollParent) {
                    let annotationOffset = 0;
                    if (isViewCommentMode) // If the sidebar is rendering a view comment, we can use the annotationElement directly.
                    annotationOffset = (0, $aHcFH.calculateElementOffset)(annotationElement);
                    else {
                        /*
            If the sidebar is rendering a create comment the annotationElement is actually the wrapperDOM
            we need to find the actual highlight instead. We can find this by looking for the mark because
            there will always be a mark before the create comment button is clicked.
            */ const actualHiglightElement = scrollParent.querySelector(`[data-annotation-draft-mark="true"]`);
                        annotationOffset = (0, $aHcFH.calculateElementOffset)(actualHiglightElement, undefined, true);
                    }
                    offset = annotationOffset + scrollParent.offsetTop;
                }
            }
            setSidebarOffset(offset);
        }
    }, [
        annotationElement,
        isEditor,
        isViewCommentMode
    ]);
    (0, $42omo.useEffect)(()=>{
        // handles media comment scroll
        if (isRefSet && sidebarEl.current && isEditor) {
            if (isOpeningMediaCommentFromToolbar && annotationElement) (0, $i49vP.scrollToElementInEditor)({
                targetElement: annotationElement,
                viewingRoomOffset: -150
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRefSet,
        annotationElement,
        isOpeningMediaCommentFromToolbar,
        commentId,
        isViewCommentMode,
        isEditor
    ]);
    (0, $42omo.useEffect)(()=>{
        let mouseTrap;
        let focusTrap;
        if (isRefSet && sidebarEl.current) {
            mouseTrap = new (0, (/*@__PURE__*/$parcel$interopDefault($lisKW)))(sidebarEl.current);
            // prevent saving via mod+enter from also publishing the page in edit mode
            mouseTrap.bind((0, $gnkil.INLINE_COMMENTS_SHORTCUT), (event)=>{
                event.stopPropagation();
            });
            if (!showA11yAnnouncement) // We need to show this on a timer so the `aria-live` listener will respond with our message
            setTimeout(()=>{
                setShowA11yAnnouncement(true);
            }, 100);
        }
        return ()=>{
            if (mouseTrap) mouseTrap.reset();
            if (focusTrap) focusTrap.deactivate();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRefSet
    ]);
    const handlePropagation = (event)=>{
        /**
     * prevents an event bubbling up to removing focus
     * from the highlight displaying the sidebar
     */ event.stopPropagation();
    };
    const handleOpeningCommentsPanel = (0, $42omo.useCallback)(()=>{
        showCommentsPanel({
            openWithView: (0, $3mVfX.ViewValues).OPEN
        });
        if (annotationId) {
            setCurrentlySelectedThreadKey(annotationId);
            (0, $9FoVw.handleCommentsPanelNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                context: (0, $9FoVw.NavigationContext).PANEL,
                block: 'center',
                annotationId: annotationId,
                commentId: commentId,
                commentType: 'INLINE',
                annotationClicked: true
            });
        }
    }, [
        showCommentsPanel,
        setCurrentlySelectedThreadKey,
        annotationId,
        commentId
    ]);
    const handleOnClose = (0, $42omo.useCallback)((dialogs, isOpeningCommentsPanel = false)=>{
        if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                isOpeningCommentsPanel ? handleOpeningCommentsPanel() : onClose && onClose(false);
            }
        });
        else isOpeningCommentsPanel ? handleOpeningCommentsPanel() : onClose && onClose(hasContentChanged);
    }, [
        hasContentChanged,
        onClose,
        resetContentChanged,
        handleOpeningCommentsPanel
    ]);
    const handleViewAllClick = (0, $42omo.useCallback)((dialogs)=>{
        handleOnClose(dialogs, true);
    }, [
        handleOnClose
    ]);
    const handleScroll = (0, $42omo.useCallback)((event)=>{
        if (!(0, $9wGTI.fg)('confluence_comment_header_margin')) return;
        const target = event.currentTarget;
        // Check if the inline-comment-sidebar-wrapper is scrolled
        const scrolled = target.scrollTop > 0;
        setIsScrolled(scrolled);
    }, []);
    const sidebarId = (0, $aHcFH.getSidebarId)(isEditor, isViewCommentMode);
    const mode = isEditor ? 'edit' : 'view';
    const intl = (0, $8C5kA.default)();
    const closeCommentBox = intl.formatMessage((0, $bEwJH.i18n).closeCommentBox);
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const sidebarBoundingRect = sidebarEl.current?.getBoundingClientRect();
    const isSidebarExtendedBeyondViewport = (sidebarBoundingRect?.bottom ?? 0) > window.innerHeight;
    /**
   * useEffect to handle sticky comment behavior when attached to a sticky table header.
   * As the user scrolls, the IntersectionObserver triggers the callback the moment the table header starts/stops being sticky
   */ (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) {
            const stickyHeader = annotationElement?.closest('.pm-table-sticky-wrapper');
            if (stickyHeader && !isSidebarExtendedBeyondViewport) {
                // eslint-disable-next-line no-restricted-syntax
                const observer = new IntersectionObserver(([entry])=>$2cc0402d98a7d80d$export$b8454eaf88df51d0(entry, setOldIsSticky, setSidebarOffset, sidebarOffset), {
                    threshold: 1.0
                });
                observer.observe(stickyHeader);
                return ()=>observer.disconnect();
            }
        }
    }, [
        annotationElement,
        sidebarOffset,
        sidebarEl,
        isSidebarExtendedBeyondViewport
    ]);
    const commentSidebarIsSticky = (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? isSticky : oldIsSticky;
    const commentResidesInPreviewPanel = (0, $9wGTI.fg)('confluence_comment_enable_preview_panel_support') ? (0, $eToX6.isInPreviewPanel)() : false;
    const viewAllResidesInPreviewPanel = (0, $9wGTI.fg)('confluence_previewpanel_enable_comments_panel') ? (0, $eToX6.isInPreviewPanel)() : false;
    /**
   * Below logic to set rightOffset is temporary fix.
   * It is very fragile as there are many conditions in ObjectSidebarControl
   * 	component to show/hide action bar and rovo button.
   * Also values are hardcoded.
   */ const getRightOffset = (0, $42omo.useCallback)(()=>{
        let rightOffset = 0;
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expValEquals)('confluence_fe_fix_sticky_comment_sidebar_position', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) // An improved version of getRightOffset()
        {
            if (!commentResidesInPreviewPanel) {
                const baseRightOffset = 112;
                // rendererContent has an extra 40px padding on the right,
                // which we need to add in 'edit' mode to match 'view' mode.
                const extraPadding = 40;
                if (mode === 'edit') rightOffset = extraPadding + (isObjectSidebarShown ? 0 : baseRightOffset);
                else {
                    // `mode === 'view'`
                    if (isObjectSidebarShown) // When `commentSidebarIsSticky === true`, sidebar uses style { position: 'fixed' },
                    // so we need to add extraPadding here to match the `commentSidebarIsSticky === false` case.
                    rightOffset = (0, $aWwYt.MIN_PANEL_WIDTH) + (commentSidebarIsSticky ? extraPadding : 0);
                    else // `isObjectSidebarShown === false`
                    if (!commentSidebarIsSticky) rightOffset = baseRightOffset;
                    else {
                        // `commentSidebarIsSticky === true`, sidebar uses style { position: 'fixed' }
                        // We set rightOffset to be baseRightOffset + the distance between
                        // the right edge of 'main-content' and the right edge of window
                        // (which includes the 40px padding + any extra e.g. the Rovo panel).
                        // The resulting horizontal position of sidebar should match the
                        // `commentSidebarIsSticky === false` case.
                        const rendererContent = document.getElementById('main-content');
                        const rendererContentRight = rendererContent?.getBoundingClientRect()?.right ?? 0;
                        if (rendererContentRight) {
                            const rendererContentDistanceFromWindowRight = window.innerWidth - rendererContentRight;
                            rightOffset = baseRightOffset + rendererContentDistanceFromWindowRight;
                        } else // rendererContentRight === 0, which shouldn't occur, but
                        // we fall back to a hardcoded rightOffset
                        rightOffset = baseRightOffset;
                    }
                }
            } // if `commentResidesInPreviewPanel === true`, rightOffset will be 0
        } else {
            // The old version of getRightOffset()
            if (mode === 'view' && isObjectSidebarShown) /**
         * Need rightOffset only when container size doesn't change when
         * 	action bar panel (e.g details panel, comments panel).
         * That happens currently only in view page.
         */ rightOffset = (0, $aWwYt.MIN_PANEL_WIDTH);
            else if (/**
       * When action bar or rovo button is shown, need to set rightOffset,
       * 	otherwise long comment sidebar overlaps on it.
       */ !isObjectSidebarShown && ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isRovoButtonEnabled)) /**
         * Width of action bar is 48px,
         * 	got it from object-sidebar-components/src/ObjectSidebarControl.tsx.
         * This is not ideal solution, as it is hardcoded.
         * check if previewPanel support is enabled
         */ {
                if (!commentResidesInPreviewPanel) {
                    if ((0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) {
                        rightOffset = 100; // add more offset from the right edge of the page so it doesn't overlap with the object sidebar
                        if (mode === 'view') rightOffset += commentSidebarIsSticky ? 67 : 12;
                        else rightOffset += commentSidebarIsSticky ? 27 : 12;
                    } else rightOffset = 48 + (commentSidebarIsSticky ? 52 : 12);
                }
            }
        }
        return rightOffset;
    }, [
        mode,
        isObjectSidebarShown,
        commentSidebarIsSticky,
        commentResidesInPreviewPanel,
        isRovoButtonEnabled
    ]);
    const a11yProps = (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
        role: 'dialog',
        'aria-modal': false,
        'aria-label': intl.formatMessage((0, $bEwJH.i18n).commentSidebarLabel, {
            name: authorName || ''
        })
    } : {};
    const pickedStickyCommentVerticalOffsetView = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expValEquals)('confluence_fe_fix_sticky_comment_sidebar_position', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? (0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW) : (0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW_OLD);
    const sidebarContainerOffset = (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? commentSidebarIsSticky ? isEditor ? sidebarOffset : pickedStickyCommentVerticalOffsetView : sidebarOffset : newSidebarOffset;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ]
    }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8SCD6.ReactionsProvider), {
            contentId: pageId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "comment-sidebar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.SidebarContainer), {
            offset: sidebarContainerOffset,
            rightOffset: getRightOffset(),
            isSticky: commentSidebarIsSticky,
            onClick: handlePropagation,
            id: sidebarId,
            "data-testid": sidebarId,
            "data-cy": sidebarId,
            mode: mode,
            ref: (el)=>{
                sidebarEl.current = el;
                if (nudgeRef) nudgeRef.current = el;
                setIsRefSet(true);
                inlineCommentRef(el);
            },
            ...a11yProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.TopContainer), {
            showNavigation: Boolean(navigationOptions)
        }, annotationId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            xcss: $2cc0402d98a7d80d$var$viewAllContainerStyles,
            testId: "view-all-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            onClick: ()=>handleViewAllClick(dialogs),
            iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                    ...iconProps,
                    label: "Comment Icon",
                    color: "var(--ds-icon-subtle)"
                }),
            appearance: "subtle",
            spacing: "compact",
            testId: "comment-sidebar-viewall-button",
            interactionName: "view-comments-menu-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtle"
        }, intl.formatMessage((0, $bEwJH.i18n).viewAllCommentsButtonText)))), navigationOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bXQxx.CommentNavigation), {
            pageId: pageId,
            commentData: navigationOptions.commentData,
            isEditor: isEditor,
            onNavigationClick: navigationOptions.onNavigationClick
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $bEwJH.i18n).closeSidebarTooltip),
            hideTooltipOnClick: true,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButton), {
            appearance: "subtle",
            isUpdatedStandaloneComment: false,
            onClick: ()=>handleOnClose(dialogs),
            onMouseDown: (e)=>e.preventDefault(),
            testId: "close-comment-sidebar-button",
            "data-cy": `${isEditor ? 'editor' : 'renderer'}-close-${isViewCommentMode ? 'view' : 'create'}-comment`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: closeCommentBox,
                color: "var(--ds-icon-subtle, #505258)",
                spacing: "none"
            })
        })))), (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $2cc0402d98a7d80d$var$commentHeaderStyle,
                (0, $9wGTI.fg)('confluence_comment_header_margin') && $2cc0402d98a7d80d$var$commentNewHeaderMargin,
                !isViewCommentMode && $2cc0402d98a7d80d$var$commentEditorStyle
            ]
        }, navigationOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bXQxx.CommentNavigation), {
            pageId: pageId,
            commentData: navigationOptions.commentData,
            isEditor: isEditor,
            onNavigationClick: navigationOptions.onNavigationClick
        }), annotationId && !viewAllResidesInPreviewPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            testId: "redesigned-view-all-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $2cc0402d98a7d80d$var$redesignedViewAllStyle,
            onClick: (e)=>{
                e.stopPropagation();
                handleViewAllClick(dialogs);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3D12W.CommentPanelButton), {
            contentId: pageId,
            testId: "standalone-comment-view-all-button",
            isStandaloneComment: true,
            isViewAllIcon: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $bEwJH.i18n).closeSidebarTooltip),
            hideTooltipOnClick: true,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButton), {
            appearance: "subtle",
            onClick: ()=>handleOnClose(dialogs),
            onMouseDown: (e)=>e.preventDefault(),
            testId: "close-comment-sidebar-button",
            "data-cy": `${isEditor ? 'editor' : 'renderer'}-close-${isViewCommentMode ? 'view' : 'create'}-comment`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: intl.formatMessage((0, $bEwJH.i18n).closeInlineCommentThread),
                color: "var(--ds-icon-subtle, #505258)",
                spacing: "none"
            }),
            isUpdatedStandaloneComment: true
        })))), isScrolled && (0, $9wGTI.fg)('confluence_comment_header_margin') && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: $2cc0402d98a7d80d$var$shadowElementStyle
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "inline-comment-sidebar-wrapper",
            ref: (el)=>{
                if (applyMaxHeightStyles) setPopupsScrollableElement?.(el);
            },
            xcss: [
                applyMaxHeightStyles && !useDynamicMaxHeight && $2cc0402d98a7d80d$var$boxWithMaxHeight,
                applyMaxHeightStyles && useDynamicMaxHeight && $2cc0402d98a7d80d$var$boxWithDynamicMaxHeightAuto,
                !applyMaxHeightStyles && $2cc0402d98a7d80d$var$boxWithoutMaxHeight
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: // xcss only supports static styles
            applyMaxHeightStyles && useDynamicMaxHeight ? {
                maxHeight: dynamicMaxHeight
            } : undefined,
            onScroll: handleScroll
        }, children))))));
};
module.exports["CommentSidebar"] = $2cc0402d98a7d80d$export$d560bdb1ceec916a;

});

parcelRegister("8SCD6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $l5y3Y = parcelRequire("l5y3Y");

const $6881c6359fe8b822$export$4da9db299e81cd38 = /*#__PURE__*/ (0, $42omo.createContext)({
    isReactionsEnabled: false
});
$6881c6359fe8b822$export$4da9db299e81cd38.displayName = 'ReactionsContext';
const $6881c6359fe8b822$export$2157a4212fd7f5b1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { contentId: contentId, children: children } = t0;
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    let t1;
    if ($[0] !== isReactionsEnabled) {
        t1 = {
            isReactionsEnabled: isReactionsEnabled
        };
        $[0] = isReactionsEnabled;
        $[1] = t1;
    } else t1 = $[1];
    const reactionsContextValue = t1;
    let t2;
    if ($[2] !== children || $[3] !== reactionsContextValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
            value: reactionsContextValue
        }, children);
        $[2] = children;
        $[3] = reactionsContextValue;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ contentId: contentId, children: children })=>{
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const reactionsContextValue = (0, $42omo.useMemo)(()=>({
            isReactionsEnabled: isReactionsEnabled
        }), [
        isReactionsEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
        value: reactionsContextValue
    }, children);
};
module.exports["ReactionsContext"] = $6881c6359fe8b822$export$4da9db299e81cd38;
module.exports["ReactionsProvider"] = $6881c6359fe8b822$export$2157a4212fd7f5b1;

});

parcelRegister("l5y3Y", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");


var $dPJCf = parcelRequire("dPJCf");

const $13602a0094cde4d6$export$da23010c6e2ddd94 = (contentId)=>{
    const isPDFExport = (0, $dPJCf.usePathnameMatcher)({
        selector: (pathname)=>pathname?.indexOf('/wiki/pdf/') !== -1
    });
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        },
        skip: isPDFExport
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), baseOptions) : (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first'
    });
    return !isPDFExport && Boolean(data?.webPanels?.length);
};
module.exports["useIsReactionsEnabled"] = $13602a0094cde4d6$export$da23010c6e2ddd94;

});

parcelRegister("3D12W", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $1yB28 = parcelRequire("1yB28");


var $jypE9 = parcelRequire("jypE9");


var $21K7m = parcelRequire("21K7m");


var $inPa6 = parcelRequire("inPa6");


var $3gadb = parcelRequire("3gadb");


var $aWwYt = parcelRequire("aWwYt");


var $8aF6s = parcelRequire("8aF6s");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $cMvMc = parcelRequire("cMvMc");


var $ep3mz = parcelRequire("ep3mz");


var $fNzRA = parcelRequire("fNzRA");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $iBnoc = parcelRequire("iBnoc");


var $fHAwL = parcelRequire("fHAwL");


var $cZa7r = parcelRequire("cZa7r");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $1ggpj = parcelRequire("1ggpj");


var $8uM2K = parcelRequire("8uM2K");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $404f4d0022b5692a$var$commentIconContainerStyle = null;
const $404f4d0022b5692a$var$i18n = (0, $cgtv4.defineMessages)({
    openCommentsPanelLabel: {
        id: "object-sidebar-components.open.comments.panel.label",
        defaultMessage: "Open Comments Panel"
    },
    viewAllCommentsLabel: {
        id: "object-sidebar-components.view.all.comments",
        defaultMessage: "View all comments"
    },
    showCommentsLabel: {
        id: "object-sidebar-components.show.comments.label",
        defaultMessage: "Show comments"
    }
});
const $404f4d0022b5692a$export$f5ef73dad1bb3f02 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(66);
    const { collapsed: collapsed, testId: testId, isStandaloneComment: t1, isDisabled: t2, isViewAllIcon: t3 } = t0;
    const isStandaloneComment = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const isViewAllIcon = t3 === undefined ? false : t3;
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { viewProps: viewProps, selectionProps: selectionProps, hoverProps: hoverProps, editorViewProps: editorViewProps, editorCreateProps: editorCreateProps, showCreateComponent: showCreateComponent, selectionOptions: selectionOptions } = (0, $cZa7r.useAnnotations)();
    const { setViewProps: setViewProps, setSelectionProps: setSelectionProps, setHoverProps: setHoverProps, setEditorViewProps: setEditorViewProps, setEditorCreateProps: setEditorCreateProps, setShowCreateComponent: setShowCreateComponent, setSelectionOptions: setSelectionOptions } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panel = (0, $aWwYt.usePanel)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    let t4;
    if ($[0] !== pageMode) {
        t4 = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
        $[0] = pageMode;
        $[1] = t4;
    } else t4 = $[1];
    const eventEmitter = t4;
    const { newCommentHighlight: newCommentHighlight, activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [t5] = (0, $efvKr.useLivePageMode)();
    const { isViewMode: isLiveViewMode, isEditMode: isLiveEditMode } = t5;
    const dataTestId = testId || "object-sidebar-comments-button-id";
    const [contentTypeFromState] = (0, $ep3mz.useContentType)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { closeCommentContainer: closeCommentContainer } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded } = (0, $fNzRA.useObjectCommentContext)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const t6 = pageMode === "edit" || isLiveEditMode;
    let t7;
    if ($[2] !== t6) {
        t7 = {
            shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            isEditorShortcut: t6
        };
        $[2] = t6;
        $[3] = t7;
    } else t7 = $[3];
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t7);
    const isShortcutTextShown = contentTypeFromState !== (0, $1ggpj.ContentType).DATABASE;
    let t8;
    if ($[4] !== activeHighlight || $[5] !== closeCommentContainer || $[6] !== editorCreateProps || $[7] !== editorViewProps || $[8] !== eventEmitter || $[9] !== expanded || $[10] !== hideObjectSidebar || $[11] !== hoverProps || $[12] !== newCommentHighlight || $[13] !== panel?.id || $[14] !== selectionOptions || $[15] !== selectionProps || $[16] !== setEditorCreateProps || $[17] !== setEditorViewProps || $[18] !== setHoverProps || $[19] !== setSelectionOptions || $[20] !== setSelectionProps || $[21] !== setShowCreateComponent || $[22] !== setViewProps || $[23] !== showCommentsPanel || $[24] !== showCreateComponent || $[25] !== viewProps) {
        t8 = ()=>{
            if (viewProps) {
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                setViewProps(null);
            }
            if (showCreateComponent && selectionOptions) {
                setShowCreateComponent(false);
                setSelectionOptions(undefined);
            }
            if (editorViewProps) {
                eventEmitter.emit("setselectedannotation", "");
                setEditorViewProps(null);
            }
            if (selectionProps) {
                selectionProps.onClose();
                setSelectionProps(null);
            }
            if (hoverProps) {
                hoverProps.onClose();
                setHoverProps(null);
            }
            if (editorCreateProps) {
                editorCreateProps?.onClose && editorCreateProps.onClose();
                setEditorCreateProps(null);
            }
            if (newCommentHighlight || activeHighlight) window.dispatchEvent(new Event("closeLegacyInlineCommentSidebar"));
            if (expanded && !(0, $9wGTI.fg)("confluence_comment_panel_close_footer")) closeCommentContainer();
            if (panel?.id === "commentsPanel") hideObjectSidebar();
            else showCommentsPanel();
        };
        $[4] = activeHighlight;
        $[5] = closeCommentContainer;
        $[6] = editorCreateProps;
        $[7] = editorViewProps;
        $[8] = eventEmitter;
        $[9] = expanded;
        $[10] = hideObjectSidebar;
        $[11] = hoverProps;
        $[12] = newCommentHighlight;
        $[13] = panel?.id;
        $[14] = selectionOptions;
        $[15] = selectionProps;
        $[16] = setEditorCreateProps;
        $[17] = setEditorViewProps;
        $[18] = setHoverProps;
        $[19] = setSelectionOptions;
        $[20] = setSelectionProps;
        $[21] = setShowCreateComponent;
        $[22] = setViewProps;
        $[23] = showCommentsPanel;
        $[24] = showCreateComponent;
        $[25] = viewProps;
        $[26] = t8;
    } else t8 = $[26];
    const handleCommentClick = t8;
    let t9;
    if ($[27] !== contentTypeFromState || $[28] !== createAnalyticsEvent || $[29] !== handleCommentClick || $[30] !== hasContentChanged || $[31] !== pageMode || $[32] !== resetContentChanged || $[33] !== resetInitialDataLoadedMap || $[34] !== showModal) {
        t9 = (t10)=>{
            const { triggeredByKeyboardShortcut: t11, isViewAllIcon: t12 } = t10 === undefined ? {} : t10;
            const triggeredByKeyboardShortcut = t11 === undefined ? false : t11;
            const isViewAllIcon_0 = t12 === undefined ? false : t12;
            return ()=>{
                if (isViewAllIcon_0) return;
                if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                    onConfirm: ()=>{
                        resetContentChanged();
                        handleCommentClick();
                        if ((0, $9wGTI.fg)("confluence_comments_reset_data_on_comment_discard")) resetInitialDataLoadedMap();
                    }
                });
                else handleCommentClick();
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "commentsPanel",
                        source: "contentWrapper",
                        attributes: {
                            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                            contentType: contentTypeFromState,
                            pageMode: pageMode
                        }
                    }
                }).fire();
            };
        };
        $[27] = contentTypeFromState;
        $[28] = createAnalyticsEvent;
        $[29] = handleCommentClick;
        $[30] = hasContentChanged;
        $[31] = pageMode;
        $[32] = resetContentChanged;
        $[33] = resetInitialDataLoadedMap;
        $[34] = showModal;
        $[35] = t9;
    } else t9 = $[35];
    const checkUnsavedOnClickCommentsButton = t9;
    let t10;
    if ($[36] !== checkUnsavedOnClickCommentsButton || $[37] !== isLiveViewMode || $[38] !== pageMode) {
        t10 = (pageMode === "view" || isLiveViewMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
            accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            listener: checkUnsavedOnClickCommentsButton({
                triggeredByKeyboardShortcut: true
            })
        });
        $[36] = checkUnsavedOnClickCommentsButton;
        $[37] = isLiveViewMode;
        $[38] = pageMode;
        $[39] = t10;
    } else t10 = $[39];
    let t11;
    if ($[40] !== checkUnsavedOnClickCommentsButton || $[41] !== isLiveEditMode || $[42] !== pageMode) {
        t11 = (pageMode === "edit" || isLiveEditMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            listener: checkUnsavedOnClickCommentsButton({
                triggeredByKeyboardShortcut: true
            })
        });
        $[40] = checkUnsavedOnClickCommentsButton;
        $[41] = isLiveEditMode;
        $[42] = pageMode;
        $[43] = t11;
    } else t11 = $[43];
    let t12;
    if ($[44] !== t10 || $[45] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t10, t11);
        $[44] = t10;
        $[45] = t11;
        $[46] = t12;
    } else t12 = $[46];
    const shortcutListeners = t12;
    if (collapsed) return shortcutListeners;
    let t13;
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (0, $gMc0m.default)([
            "_kqswh2mm"
        ]);
        $[47] = t13;
    } else t13 = $[47];
    let t14;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $404f4d0022b5692a$var$i18n.showCommentsLabel);
        $[48] = t14;
    } else t14 = $[48];
    const t15 = isShortcutTextShown ? commentShortcutStrings : undefined;
    let t16;
    if ($[49] !== allowComments || $[50] !== checkUnsavedOnClickCommentsButton || $[51] !== formatMessage || $[52] !== isDisabled || $[53] !== isRovoButtonEnabled || $[54] !== isStandaloneComment || $[55] !== isViewAllIcon || $[56] !== unreadCommentIDSet?.size) {
        t16 = allowComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            onClick: checkUnsavedOnClickCommentsButton({
                isViewAllIcon: isViewAllIcon
            }),
            appearance: "subtle",
            spacing: isStandaloneComment ? "compact" : undefined,
            shape: isRovoButtonEnabled ? "default" : "circle",
            icon: isStandaloneComment && (0, $6mKj3.expValEquals)("confluence_comments_cohiti_panel_icon_update", "isEnabled", true) ? (0, (/*@__PURE__*/$parcel$interopDefault($jypE9))) : (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
            label: formatMessage($404f4d0022b5692a$var$i18n.openCommentsPanelLabel),
            testId: "sidebar-comments-button",
            interactionName: "view-comments-menu-action",
            ...(0, $6mKj3.expVal)("confluence_frontend_comments_a11y_kb_exp", "isEnabled", false) ? {
                ariaLabel: formatMessage($404f4d0022b5692a$var$i18n.viewAllCommentsLabel)
            } : {},
            isDisabled: isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false)
        }), !isStandaloneComment && unreadCommentIDSet?.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iBnoc.UnreadIndicator), null));
        $[49] = allowComments;
        $[50] = checkUnsavedOnClickCommentsButton;
        $[51] = formatMessage;
        $[52] = isDisabled;
        $[53] = isRovoButtonEnabled;
        $[54] = isStandaloneComment;
        $[55] = isViewAllIcon;
        $[56] = unreadCommentIDSet?.size;
        $[57] = t16;
    } else t16 = $[57];
    const t17 = !isStandaloneComment && shortcutListeners;
    let t18;
    if ($[58] !== t15 || $[59] !== t16 || $[60] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "left",
            content: t14,
            shortcut: t15,
            delay: 0,
            hideTooltipOnClick: true
        }, t16, t17);
        $[58] = t15;
        $[59] = t16;
        $[60] = t17;
        $[61] = t18;
    } else t18 = $[61];
    let t19;
    if ($[62] !== dataTestId || $[63] !== t13 || $[64] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": dataTestId,
            "data-vc": "object-sidebar-comments-button",
            className: t13
        }, t18);
        $[62] = dataTestId;
        $[63] = t13;
        $[64] = t18;
        $[65] = t19;
    } else t19 = $[65];
    return t19;
} : ({ collapsed: collapsed, testId: testId, isStandaloneComment: isStandaloneComment = false, isDisabled: isDisabled = false, isViewAllIcon: isViewAllIcon = false })=>{
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { viewProps: viewProps, selectionProps: selectionProps, hoverProps: hoverProps, editorViewProps: editorViewProps, editorCreateProps: editorCreateProps, showCreateComponent: showCreateComponent, selectionOptions: selectionOptions } = (0, $cZa7r.useAnnotations)();
    const { setViewProps: setViewProps, setSelectionProps: setSelectionProps, setHoverProps: setHoverProps, setEditorViewProps: setEditorViewProps, setEditorCreateProps: setEditorCreateProps, setShowCreateComponent: setShowCreateComponent, setSelectionOptions: setSelectionOptions } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panel = (0, $aWwYt.usePanel)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const { newCommentHighlight: newCommentHighlight, activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [{ isViewMode: isLiveViewMode, isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const dataTestId = testId || 'object-sidebar-comments-button-id';
    const [contentTypeFromState] = (0, $ep3mz.useContentType)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { closeCommentContainer: closeCommentContainer } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded } = (0, $fNzRA.useObjectCommentContext)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        isEditorShortcut: pageMode === 'edit' || isLiveEditMode
    });
    // keyboard events do not bubble up to confluence when focus is in the db iframe.
    // Since the keyboard shortcut does not work, we must hide the shortcut text.
    const isShortcutTextShown = contentTypeFromState !== (0, $1ggpj.ContentType).DATABASE;
    const handleCommentClick = (0, $42omo.useCallback)(()=>{
        // FABRIC PAGES
        // Close the view component if it's open
        if (viewProps) {
            // Inform the Renderer to de-select the annotation
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS); // Remove the display of the comment
            setViewProps(null);
        }
        if (showCreateComponent && selectionOptions) {
            // Inform CreateComment to reset the state
            setShowCreateComponent(false);
            setSelectionOptions(undefined);
        }
        if (editorViewProps) {
            // Inform the editor to de-select the annotation
            eventEmitter.emit('setselectedannotation', ''); // Remove the display of the comment
            setEditorViewProps(null);
        }
        if (selectionProps) {
            selectionProps.onClose();
            setSelectionProps(null);
        }
        if (hoverProps) {
            hoverProps.onClose();
            setHoverProps(null);
        }
        if (editorCreateProps) {
            editorCreateProps?.onClose && editorCreateProps.onClose();
            setEditorCreateProps(null);
        } // LEGACY PAGES
        if (newCommentHighlight || activeHighlight) // Close the legacy inline comment panel
        window.dispatchEvent(new Event('closeLegacyInlineCommentSidebar'));
         // Should unmount the expanded comment editor
        // standalone reply, object footer comment
        if (expanded && !(0, $9wGTI.fg)('confluence_comment_panel_close_footer')) closeCommentContainer();
        if (panel?.id === 'commentsPanel') hideObjectSidebar();
        else showCommentsPanel();
    }, [
        eventEmitter,
        viewProps,
        editorViewProps,
        selectionProps,
        hoverProps,
        newCommentHighlight,
        activeHighlight,
        setViewProps,
        setEditorViewProps,
        setSelectionProps,
        setHoverProps,
        showCommentsPanel,
        hideObjectSidebar,
        panel,
        editorCreateProps,
        closeCommentContainer,
        expanded,
        setEditorCreateProps,
        showCreateComponent,
        selectionOptions,
        setShowCreateComponent,
        setSelectionOptions
    ]);
    const checkUnsavedOnClickCommentsButton = (0, $42omo.useCallback)(({ triggeredByKeyboardShortcut: triggeredByKeyboardShortcut = false, isViewAllIcon: isViewAllIcon_0 = false } = {})=>()=>{
            // Early return for ViewAll icon - no action needed
            if (isViewAllIcon_0) return;
            if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged();
                    handleCommentClick();
                    if ((0, $9wGTI.fg)('confluence_comments_reset_data_on_comment_discard')) resetInitialDataLoadedMap();
                }
            });
            else handleCommentClick();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'commentsPanel',
                    source: 'contentWrapper',
                    attributes: {
                        triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                        contentType: contentTypeFromState,
                        pageMode: pageMode
                    }
                }
            }).fire();
        }, [
        hasContentChanged,
        handleCommentClick,
        resetContentChanged,
        resetInitialDataLoadedMap,
        showModal,
        createAnalyticsEvent,
        contentTypeFromState,
        pageMode
    ]);
    const shortcutListeners = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (pageMode === 'view' || isLiveViewMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: checkUnsavedOnClickCommentsButton({
            triggeredByKeyboardShortcut: true
        })
    }), (pageMode === 'edit' || isLiveEditMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: checkUnsavedOnClickCommentsButton({
            triggeredByKeyboardShortcut: true
        })
    }));
    if (collapsed) return shortcutListeners;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": dataTestId,
        "data-vc": "object-sidebar-comments-button",
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "left",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $404f4d0022b5692a$var$i18n.showCommentsLabel),
        shortcut: isShortcutTextShown ? commentShortcutStrings : undefined,
        delay: 0,
        hideTooltipOnClick: true
    }, allowComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: checkUnsavedOnClickCommentsButton({
            isViewAllIcon: isViewAllIcon
        }),
        appearance: "subtle",
        spacing: isStandaloneComment ? 'compact' : undefined,
        shape: isRovoButtonEnabled ? 'default' : 'circle',
        icon: isStandaloneComment && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_panel_icon_update', 'isEnabled', true) ? (0, (/*@__PURE__*/$parcel$interopDefault($jypE9))) : (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
        label: formatMessage($404f4d0022b5692a$var$i18n.openCommentsPanelLabel),
        testId: "sidebar-comments-button",
        interactionName: "view-comments-menu-action",
        ...(0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
            ariaLabel: formatMessage($404f4d0022b5692a$var$i18n.viewAllCommentsLabel)
        } : {},
        isDisabled: isDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
    }), !isStandaloneComment && unreadCommentIDSet?.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iBnoc.UnreadIndicator), null)), !isStandaloneComment && shortcutListeners));
};
module.exports["CommentPanelButton"] = $404f4d0022b5692a$export$f5ef73dad1bb3f02;

});

parcelRegister("fNzRA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $en1dX = parcelRequire("en1dX");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

var $7b4a2f6cc35c72e1$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    // The footer comments section
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    // The sticky draft that persists outside of the footer
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $7b4a2f6cc35c72e1$export$8a175172a11240d4 = /*#__PURE__*/ (0, $42omo.createContext)({
    expandCommentContainer: ()=>{},
    closeCommentContainer: ()=>{},
    setWrapperWidth: ()=>{},
    setIsObjectCommentWrapperVisible: ()=>{},
    setFooterEditorEntry: ()=>{}
});
$7b4a2f6cc35c72e1$export$8a175172a11240d4.displayName = 'ObjectCommentDispatchContext';
const $7b4a2f6cc35c72e1$export$358734f355c08965 = /*#__PURE__*/ (0, $42omo.createContext)({
    expanded: false,
    footerEditorEntry: undefined,
    width: undefined,
    isObjectCommentWrapperVisible: false
});
$7b4a2f6cc35c72e1$export$358734f355c08965.displayName = 'ObjectCommentContext';
const $7b4a2f6cc35c72e1$export$d248a0e4aca56201 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { children: children } = t0;
    const [expanded, setExpanded] = (0, $42omo.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $42omo.useState)(undefined);
    const [width, setWidth] = (0, $42omo.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $42omo.useState)(false);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== expanded || $[1] !== footerEditorEntry || $[2] !== isObjectCommentWrapperVisible || $[3] !== width) {
        t1 = {
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        };
        $[0] = expanded;
        $[1] = footerEditorEntry;
        $[2] = isObjectCommentWrapperVisible;
        $[3] = width;
        $[4] = t1;
    } else t1 = $[4];
    const providerValue = t1;
    let t2;
    if ($[5] !== edition) {
        t2 = (props)=>{
            const { entryPoint: entryPoint } = props ?? {};
            if (entryPoint && (0, $9wGTI.fg)("confluence_fe_add_page_comment_exp_coverage")) (0, $8Ss4E.startEditorExperiences)({
                name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                attributes: {
                    editor: "FABRIC",
                    isSingleExperience: true,
                    edition: edition,
                    source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                    entryPoint: entryPoint
                }
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
            });
            setExpanded(true);
        };
        $[5] = edition;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setFooterEditorEntry(undefined);
            setExpanded(false);
        };
        t4 = (width_0)=>{
            setWidth(width_0 ? `${width_0}px` : "100%");
        };
        t5 = (visible)=>{
            setIsObjectCommentWrapperVisible(visible);
        };
        t6 = (footerEditorEntry_0)=>{
            setFooterEditorEntry(footerEditorEntry_0);
        };
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else {
        t3 = $[7];
        t4 = $[8];
        t5 = $[9];
        t6 = $[10];
    }
    let t7;
    if ($[11] !== t2) {
        t7 = {
            expandCommentContainer: t2,
            closeCommentContainer: t3,
            setWrapperWidth: t4,
            setIsObjectCommentWrapperVisible: t5,
            setFooterEditorEntry: t6
        };
        $[11] = t2;
        $[12] = t7;
    } else t7 = $[12];
    const dispatchProviderValue = t7;
    let t8;
    if ($[13] !== children || $[14] !== dispatchProviderValue) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
            value: dispatchProviderValue
        }, children);
        $[13] = children;
        $[14] = dispatchProviderValue;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== providerValue || $[17] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
            value: providerValue
        }, t8);
        $[16] = providerValue;
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    return t9;
} : ({ children: children })=>{
    const [expanded, setExpanded] = (0, $42omo.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $42omo.useState)(undefined);
    const [width, setWidth] = (0, $42omo.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $42omo.useState)(false);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const providerValue = (0, $42omo.useMemo)(()=>({
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        }), [
        expanded,
        footerEditorEntry,
        width,
        isObjectCommentWrapperVisible
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            expandCommentContainer: (props)=>{
                const { entryPoint: entryPoint } = props ?? {};
                if (entryPoint && (0, $9wGTI.fg)('confluence_fe_add_page_comment_exp_coverage')) (0, $8Ss4E.startEditorExperiences)({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                    attributes: {
                        editor: 'FABRIC',
                        isSingleExperience: true,
                        edition: edition,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        entryPoint: entryPoint
                    }
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
                });
                setExpanded(true);
            },
            closeCommentContainer: ()=>{
                setFooterEditorEntry(undefined);
                setExpanded(false);
            },
            setWrapperWidth: (width_0)=>{
                setWidth(width_0 ? `${width_0}px` : '100%');
            },
            setIsObjectCommentWrapperVisible: (visible)=>{
                setIsObjectCommentWrapperVisible(visible);
            },
            setFooterEditorEntry: (footerEditorEntry_0)=>{
                setFooterEditorEntry(footerEditorEntry_0);
            }
        }), [
        setExpanded,
        setFooterEditorEntry,
        setWidth,
        setIsObjectCommentWrapperVisible,
        edition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $7b4a2f6cc35c72e1$export$da430766ddf17a6b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
} : ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
};
const $7b4a2f6cc35c72e1$export$8ba3235fe153fa01 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
} : ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
};
module.exports["AddFooterCommentMode"] = $7b4a2f6cc35c72e1$export$94f8d08c2312472b;
module.exports["ObjectCommentProvider"] = $7b4a2f6cc35c72e1$export$d248a0e4aca56201;
module.exports["useObjectCommentContext"] = $7b4a2f6cc35c72e1$export$da430766ddf17a6b;
module.exports["useObjectCommentDispatchContext"] = $7b4a2f6cc35c72e1$export$8ba3235fe153fa01;

});

parcelRegister("9jl6v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $42omo = parcelRequire("42omo");


var $ag6aQ = parcelRequire("ag6aQ");


var $aHcFH = parcelRequire("aHcFH");


var $9FoVw = parcelRequire("9FoVw");


var $i49vP = parcelRequire("i49vP");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $9wGTI = parcelRequire("9wGTI");

const $427c50c01d3953e2$export$87eb11c3f8007b3b = /*#__PURE__*/ (0, $42omo.createContext)({
    createComment: ()=>{},
    clearCreateHighlight: ()=>{},
    onHighlightClick: ()=>{},
    toggleSidebar: ()=>{},
    setResolvedComment: ()=>{},
    setActiveHighlight: ()=>{},
    navigateToInlineComment: ()=>{}
});
$427c50c01d3953e2$export$87eb11c3f8007b3b.displayName = 'InlineCommentsDispatchContext';
const $427c50c01d3953e2$export$e6352a1cdc05c52c = /*#__PURE__*/ (0, $42omo.createContext)({
    newCommentHighlight: undefined,
    highlightOrigin: 'userHighlight',
    activeHighlight: null,
    firstHighlightClicked: false,
    shouldDisplaySidebar: false,
    resolvedComment: null
});
$427c50c01d3953e2$export$e6352a1cdc05c52c.displayName = 'InlineCommentsContext';
const $427c50c01d3953e2$export$f54686667fb05777 = ({ children: children })=>{
    const [newCommentHighlight, setNewCommentHighlight] = (0, $42omo.useState)();
    const [highlightOrigin, setHighlightOrigin] = (0, $42omo.useState)('userHighlight');
    /**
   * We eventually want this value to be the official state for loading/displaying
   * the UI for inline comments. InlineCommentSidebar and some child components have created
   * stateful logic (active highlight, isSidebarShown, etc) that assumes
   * the code is always loaded which we will eventually adjust.
   */ const [shouldDisplaySidebar, setShouldDisplaySidebar] = (0, $42omo.useState)(false);
    const firstHighlightClicked = (0, $42omo.useRef)(false);
    const [activeHighlight, setActiveHighlight] = (0, $42omo.useState)(null);
    const [resolvedComment, setResolvedComment] = (0, $42omo.useState)(null);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const providerValue = (0, $42omo.useMemo)(()=>({
            newCommentHighlight: newCommentHighlight,
            highlightOrigin: highlightOrigin,
            activeHighlight: activeHighlight,
            resolvedComment: resolvedComment,
            firstHighlightClicked: firstHighlightClicked.current,
            shouldDisplaySidebar: shouldDisplaySidebar
        }), [
        activeHighlight,
        highlightOrigin,
        newCommentHighlight,
        resolvedComment,
        shouldDisplaySidebar,
        firstHighlightClicked
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            createComment: (newHighlight, origin = 'userHighlight')=>{
                /**
       * Creating a comment is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ setShouldDisplaySidebar(true);
                setNewCommentHighlight(newHighlight);
                setHighlightOrigin(origin);
                if (resolvedComment) setResolvedComment(null);
            },
            clearCreateHighlight: ()=>setNewCommentHighlight(undefined),
            onHighlightClick: (markerRef)=>{
                if (!firstHighlightClicked.current) firstHighlightClicked.current = true;
                /**
       * Clicking on a highlight is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ if (markerRef) setShouldDisplaySidebar(true);
                else setShouldDisplaySidebar(false);
                setActiveHighlight(markerRef);
            },
            setResolvedComment: setResolvedComment,
            toggleSidebar: (shouldDisplay)=>setShouldDisplaySidebar(shouldDisplay),
            setActiveHighlight: setActiveHighlight,
            navigateToInlineComment: ({ action: action, triggeredByKeyboardShortcut: triggeredByKeyboardShortcut, currentCommentIndex: currentCommentIndex, onNavigationClick: onNavigationClick, getCommentIndex: getCommentIndex, isEditor: isEditor, removeCommentQueryParams: removeCommentQueryParams, unresolvedInlineComments: unresolvedInlineComments, createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isNavigateToNextUnread: isNavigateToNextUnread, unreadInlineComments: unreadInlineComments = [], unreadGeneralComments: unreadGeneralComments = [], footerComments: footerComments = [], scrollToFooterComment: scrollToFooterComment, commentsDataMap: commentsDataMap })=>{
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    navigationAction: action
                });
                const couldBeNavigatingToFooterComment = triggeredByKeyboardShortcut && footerComments?.length > 0 && (0, $9wGTI.fg)('confluence_frontend_content_wrapper');
                if (unresolvedInlineComments?.length < 2 && !couldBeNavigatingToFooterComment) {
                    (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                        abortReason: 'Comment navigation when only one comment'
                    });
                    if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.abort({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        reason: 'Comment navigation when only one comment',
                        checkForTimeout: true,
                        publishDebugPoints: true,
                        attributes: {
                            stopPoint: 'comment-context/InlineCommentsContext'
                        }
                    });
                    return;
                }
                // Clear the focusedCommentId queryParams so that reply does not opens up if any...
                removeCommentQueryParams();
                const combinedInlineFooterComments = [
                    ...unresolvedInlineComments,
                    ...footerComments
                ];
                let nextThreadKey = '';
                let currentThreadKey = '';
                if (triggeredByKeyboardShortcut && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                    if (isNavigateToNextUnread) {
                        // Add 1 to currentCommentIndex to move to the next comment, otherwise it gets stuck on the current comment
                        const nextIndex = currentCommentIndex + 1;
                        nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(nextIndex, combinedInlineFooterComments, [
                            ...unreadInlineComments,
                            ...unreadGeneralComments
                        ]) ?? '';
                    } else nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, combinedInlineFooterComments) ?? '';
                    currentThreadKey = combinedInlineFooterComments[currentCommentIndex];
                } else {
                    nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, unresolvedInlineComments) ?? '';
                    currentThreadKey = unresolvedInlineComments[currentCommentIndex];
                }
                if (!nextThreadKey) {
                    (0, $4EKKB.selectInlineComment).debug(`Couldn't find next annotation to select in document`);
                    return;
                }
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    annotationId: nextThreadKey
                });
                if (triggeredByKeyboardShortcut && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                    if (footerComments.includes(nextThreadKey) && scrollToFooterComment && commentsDataMap?.general?.[nextThreadKey]) {
                        setActiveHighlight(null);
                        scrollToFooterComment(nextThreadKey);
                        (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                            abortReason: 'Navigating to general comment'
                        });
                        return;
                    }
                }
                const nextCommentElement = document.getElementById(nextThreadKey) || ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? document.getElementById(`footer-comment-thread-${nextThreadKey}-container`) : null);
                if (nextCommentElement) (0, $i49vP.checkElementExpandInEditor)(nextCommentElement);
                else (0, $4EKKB.selectInlineComment).debug('No annotation found in doc to check if in expand');
                onNavigationClick(nextThreadKey);
                const nextCommentIndex = getCommentIndex(nextThreadKey);
                const enableOnArrowNavigation = !triggeredByKeyboardShortcut;
                // Handle scrolling navigation
                if (enableOnArrowNavigation) (0, $9FoVw.handleInlineHeaderArrowsNavigation)({
                    previousMarkerRef: currentThreadKey,
                    nextMarkerRef: nextThreadKey,
                    context: isEditor ? (0, $9FoVw.NavigationContext).EDITOR : (0, $9FoVw.NavigationContext).RENDERER,
                    action: action,
                    nextCommentIndex: nextCommentIndex,
                    totalComments: unresolvedInlineComments.length
                });
                if (nextCommentElement) {
                    // As we navigate inline comments with arrow icons, we want to update the cursor location to where the open inline comment is
                    // unless it is a media node in which case, we want our selection to be the media node element.
                    const media = nextCommentElement.querySelector(`.${(0, $ag6aQ.ClassNames).MEDIA_CONTAINER}`);
                    if (media) {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'block',
                            blockType: 'media'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(media);
                    } else {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'inline'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(nextCommentElement);
                    }
                }
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'navigate',
                        actionSubjectId: 'inlineCommentArrowsNavigate',
                        attributes: {
                            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                            action: action
                        },
                        objectType: 'inlineComment',
                        objectId: contentId,
                        source: isEditor ? 'editPageScreen' : 'renderPageScreen'
                    }
                }).fire();
            }
        }), [
        resolvedComment,
        firstHighlightClicked,
        setShouldDisplaySidebar,
        setHighlightOrigin,
        setResolvedComment,
        setActiveHighlight,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($427c50c01d3953e2$export$e6352a1cdc05c52c.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($427c50c01d3953e2$export$87eb11c3f8007b3b.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $427c50c01d3953e2$export$89bc450b4e1563a9 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
} : ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
};
const $427c50c01d3953e2$export$43e36990fc9d516b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
} : ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
};
module.exports["InlineCommentsProvider"] = $427c50c01d3953e2$export$f54686667fb05777;
module.exports["useInlineCommentsContext"] = $427c50c01d3953e2$export$89bc450b4e1563a9;
module.exports["useInlineCommentsDispatchContext"] = $427c50c01d3953e2$export$43e36990fc9d516b;

});

parcelRegister("iBnoc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0360a9befc1d1e18$export$d101cbe06551091d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1wNs0",
    name: "UnreadIndicator",
    loader: async ()=>(await (parcelRequire("9bA4s"))).UnreadIndicator
});
module.exports["UnreadIndicator"] = $0360a9befc1d1e18$export$d101cbe06551091d;

});

parcelRegister("9bA4s", function(module, exports) {

let $6b011f0f99d5e581$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b011f0f99d5e581$var$load("i8hiG").then(()=>parcelRequire('yTrVP'));

});

parcelRegister("fHAwL", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $7fff4328005dca96$var$initialState = {
    // isUpdatingUnreadComments tracks when we're updating the unread comments set
    // (e.g., during initial render or when manually updating the set).
    isUpdatingUnreadComments: true,
    // isUnreadQueryLoading tracks when we're actively fetching comments from the server.
    isUnreadQueryLoading: false,
    unreadCommentIDSet: new Set(),
    shouldClearVisibleThreads: false
};
const $7fff4328005dca96$var$actions = {
    setIsUpdatingUnreadComments: (isUpdatingUnreadComments)=>({ setState: setState })=>{
            setState({
                isUpdatingUnreadComments: isUpdatingUnreadComments
            });
        },
    setIsUnreadQueryLoading: (loading)=>({ setState: setState })=>{
            setState({
                isUnreadQueryLoading: loading
            });
        },
    updateUnreadCommentIDSet: (unreadCommentIDSet, operation = 'initialize')=>({ setState: setState, getState: getState })=>{
            const { unreadCommentIDSet: existingSet } = getState();
            switch(operation){
                case 'initialize':
                    setState({
                        unreadCommentIDSet: unreadCommentIDSet
                    });
                    break;
                case 'add':
                    setState({
                        unreadCommentIDSet: new Set([
                            ...existingSet,
                            ...unreadCommentIDSet
                        ])
                    });
                    break;
                case 'remove':
                    const newSet = new Set(existingSet);
                    unreadCommentIDSet.forEach((id)=>newSet.delete(id));
                    setState({
                        unreadCommentIDSet: newSet
                    });
                    break;
                case 'removeAll':
                    setState({
                        unreadCommentIDSet: new Set()
                    });
                    break;
            }
        },
    setShouldClearVisibleThreads: (shouldClearVisibleThreads)=>({ setState: setState })=>{
            setState({
                shouldClearVisibleThreads: shouldClearVisibleThreads
            });
        }
};
const $7fff4328005dca96$var$UnreadCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $7fff4328005dca96$var$initialState,
    actions: $7fff4328005dca96$var$actions,
    name: 'UnreadCommentsStore'
});
const $7fff4328005dca96$export$df6365a5248dcd96 = (0, $9zUhf.createHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$b7fe87478f70c759 = (0, $9zUhf.createActionsHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$fdd0a0c032c12265 = (0, $9zUhf.createStateHook)($7fff4328005dca96$var$UnreadCommentsStore);
module.exports["useUnreadComments"] = $7fff4328005dca96$export$df6365a5248dcd96;
module.exports["useUnreadCommentsActions"] = $7fff4328005dca96$export$b7fe87478f70c759;
module.exports["useUnreadCommentsState"] = $7fff4328005dca96$export$fdd0a0c032c12265;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("9Q4ck"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("9Q4ck", function(module, exports) {

let $729c39fbd06cc51d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $729c39fbd06cc51d$var$load("fZt2F"),
    $729c39fbd06cc51d$var$load("hhss7"),
    $729c39fbd06cc51d$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");


var $6mKj3 = parcelRequire("6mKj3");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$a586f466261ecb73 = ()=>{
    const baseRoutes = [
        (0, $1NBp8.DATABASE_VIEW).name,
        (0, $1NBp8.VIEW_PAGE).name,
        (0, $1NBp8.WHITEBOARD_BOARD).name,
        (0, $1NBp8.EMBED_VIEW).name
    ];
    if ((0, $6mKj3.expValEquals)('cc-axp-delete-editing-page-redirect', 'isEnabled', true)) return [
        ...baseRoutes,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_PAGE_V2).name
    ];
    return baseRoutes;
};
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE
};
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["getDeleteSuccessRedirectRoutes"] = $2aa2bdb281c6889a$export$a586f466261ecb73;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("8uM2K", function(module, exports) {

var $5spQU = parcelRequire("5spQU");


var $lzcvT = parcelRequire("lzcvT");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

const $214157f3efbb250b$export$dcc461521a57aee7 = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    // Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback
    const isAIFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai') : !(0, $lzcvT.isFedRamp)();
    return isAIFeatureEnabled && isAdminHubAIEnabled && isRovoLLMEnabled;
};
module.exports["useAIRovoButtonEnablement"] = $214157f3efbb250b$export$dcc461521a57aee7;

});

parcelRegister("kRW4Y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $2BAFx = parcelRequire("2BAFx");

class $c329db8a0d5b9472$export$11ff2eb6414212c6 extends (0, $T1bCI.Container) {
    onChildClose(key, ...args) {
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        this.setState((state)=>({
                stack: state.stack.map((frame)=>frame === childFrame ? {
                        ...frame,
                        alive: false
                    } : frame)
            }));
    }
    onChildCloseComplete(key, ...args) {
        // A child dialog called its onCloseComplete prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        this.setState((state)=>({
                stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
            }));
    }
    constructor(stack = []){
        super();
        /*
        Arguably, nextKey belongs in state (as per 'flags' package). But then there's
        an unenviable choice of, in showDialog, putting the React.createElement in the
        setState callback, or giving setState an object instead of a callback and
        risk having two dialogs opened with the same key in the (unlikely) scenario
        that they're both opened in the same tick.
      */ this.showModal = (componentClass, originalProps, children)=>{
            this.showDialog(componentClass, originalProps, children);
        };
        /**
     * @deprecated use `.showModal()` instead (see "next/packages/dialogs/README.md" for migration instructions)
     */ this.showDialog = (componentClass, originalProps, children)=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: (...args)=>this.onChildClose(key, ...args),
                onCloseComplete: (...args)=>this.onChildCloseComplete(key, ...args)
            }, children);
            this.setState((state)=>({
                    stack: [
                        ...state.stack,
                        {
                            key: key,
                            component: component,
                            alive: true,
                            originalProps: {
                                onClose: 'onClose' in props ? props.onClose : undefined,
                                onCloseComplete: 'onCloseComplete' in props ? props.onCloseComplete : undefined
                            }
                        }
                    ]
                }));
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return ()=>{
                this.onChildClose(key);
            };
        };
        this.state = {
            stack: stack
        };
        // If you're pre-supplying a stack, make nextKey bigger than any of its keys
        if (stack.length) {
            const maxKey = Math.max(...stack.map((frame)=>frame.key));
            (0, $2BAFx.dialogKeyState).nextKey = maxKey + 1;
        }
    }
}
module.exports["DialogsStateContainer"] = $c329db8a0d5b9472$export$11ff2eb6414212c6;

});

parcelRegister("666Tc", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $4KS7f = parcelRequire("4KS7f");


var $9wGTI = parcelRequire("9wGTI");

const $003eb47e4cfe7fce$var$slideOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$48377ae1c677702b = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "ul" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8wadc _1yt4v0yc _1e0c1txw _1n261g80 _4cvr1h6o _1tke1f4h",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$4fbc87ee9c503b41 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1as91r31 _j4qy8stv _1wwgnqa1 _v0fytlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$export$f39f3f768bc98e3d = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isSticky: isSticky, isAutoDismissResolve: isAutoDismissResolve, ...__cmpldp } = __cmplp;
        const { rightOffset: t3 } = __cmplp;
        const rightOffset = t3 === undefined ? 0 : t3;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_16090q4": (0, $7sObp.default)(`${rightOffset}px`),
                "--_162hus6": (0, $7sObp.default)(__cmplp.offset, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_19itia51 _2rko1l7b _16qs1nax _bfhkvuon _1xi21dwo _154i1odf _1e0c1txw _2lx21bp4 _vchhusvi _otyr53f4 _1bsb1178 _c71lglyw",
                __cmplp.mode === "view" ? "_1pbyibnn" : "_1pby1ap8",
                __cmplp.isSticky ? "_kqsw1n9t" : "_kqswstnw",
                Boolean(__cmplp.isAutoDismissResolve) && "",
                Boolean(__cmplp.isAutoDismissResolve) && "_y44vuwz3",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $003eb47e4cfe7fce$export$18986330a3dbad03 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _bfhkvuon _521wia51",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$86b1f0d05f7b12cd = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(10);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isCommentsPanel: isCommentsPanel, isFabricPage: isFabricPage, ...__cmpldp } = __cmplp;
        const basePadding = __cmplp.mode === "view" ? "var(--ds-space-150, 12px) var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px) var(--ds-space-150, 12px)";
        const t3 = __cmplp.isCommentsPanel ? "0" : basePadding;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = (0, $7sObp.default)((0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "var(--ds-space-075, 6px) var(--ds-space-100, 8px)" : "var(--ds-space-050, 4px)");
            $[5] = t5;
        } else t5 = $[5];
        let t6;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = (0, $7sObp.default)((0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "var(--ds-text-subtlest, #6B6E76)" : "var(--ds-text-disabled, #080F214A)");
            $[6] = t6;
        } else t6 = $[6];
        let t7;
        if ($[7] !== __cmpls || $[8] !== t4) {
            t7 = {
                ...__cmpls,
                "--_1ms47y0": t4,
                "--_567avp": t5,
                "--_1n1whry": t6
            };
            $[7] = __cmpls;
            $[8] = t4;
            $[9] = t7;
        } else t7 = $[9];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t7,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1yt41vmh _n3tdpxbi _1k0c1qnt _159vzwfg _1wv15a2x",
                __cmplp.isCommentsPanel || __cmplp.isFabricPage && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "_x3doglyw" : "_x3doj0fz",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $003eb47e4cfe7fce$export$5aae1a36fc838370 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41jx0 _1e0c1txw _4cvr1h6o _2lx21bp4 _1i7vwadc _9a6v14no _kckd15o9 _125xi7uo _31ku1h6o _ekv6wadc _dkzuutpp _5lhmtlke _1pzm1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // View mode styled components
const $003eb47e4cfe7fce$export$b38a2fd24b22fb35 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isReply: isReply, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "",
            !__cmplp.isReply && "_1yt4utpp _n7zlia51",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$d1b98bde82a43bb3 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { shouldHaveButtonGap: shouldHaveButtonGap, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1usn19bv _1achz0dk _1scmazsu",
            __cmplp.shouldHaveButtonGap && "_zulpv77o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$export$6e006bd290301009 = '24px';
const $003eb47e4cfe7fce$export$3421cb2750fe78a7 = '28px';
const $003eb47e4cfe7fce$export$28ae196bde1430fd = '24px'; // Needed to get the correct overall size to match the comment icon next to it
const $003eb47e4cfe7fce$var$inlineHeaderButtonTheme = (isSSRFocusedComment)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        return {
            ...theme,
            buttonStyles: {
                ...theme.buttonStyles,
                background: 'none',
                borderRadius: "var(--ds-radius-small, 4px)",
                height: $003eb47e4cfe7fce$export$6e006bd290301009,
                width: $003eb47e4cfe7fce$export$6e006bd290301009,
                '&:hover': {
                    backgroundColor: `${"var(--ds-surface-hovered, #F0F1F2)"}`
                },
                '&:focus': {
                    boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #4688EC)"}`
                },
                cursor: isSSRFocusedComment ? 'not-allowed' : 'pointer',
                '*': {
                    color: isSSRFocusedComment ? `${"var(--ds-text-subtlest, #6B6E76)"}` : `inherit`
                }
            }
        };
    };
const $003eb47e4cfe7fce$export$2616e8e1e1a7c3e5 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    let isSSRFocusedComment;
    let props;
    if ($[0] !== t0) {
        ({ isSSRFocusedComment: isSSRFocusedComment, ...props } = t0);
        $[0] = t0;
        $[1] = isSSRFocusedComment;
        $[2] = props;
    } else {
        isSSRFocusedComment = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== isSSRFocusedComment) {
        t1 = $003eb47e4cfe7fce$var$inlineHeaderButtonTheme(isSSRFocusedComment);
        $[3] = isSSRFocusedComment;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
            theme: t1,
            ...props
        });
        $[5] = props;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $003eb47e4cfe7fce$export$e575a964a1fe8b0 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { shouldShowNavigation: shouldShowNavigation, isReattachHeader: isReattachHeader, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm _1e0c1txw _19bvutpp _u5f3utpp",
            __cmplp.shouldShowNavigation ? "_1bah1yb4" : "_1bahesu3",
            __cmplp.shouldShowNavigation && "_4t3i10yn _ca0qutpp",
            __cmplp.isReattachHeader && "_4t3i10yn _ca0qpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$b3b0191112eea395 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $003eb47e4cfe7fce$export$f39f3f768bc98e3d : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1178 _4t3irvwn",
            __cmplp.showSkeleton ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$export$f895097fe90363d1 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { showNavigation: showNavigation, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.showNavigation ? "_19pkxy5q" : "_19pkze3t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$32dd8f1956fe77b1 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswstnw _1xi2utpp _1pbykb7n _154iutpp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$4b61d9d7155e9162 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulp12x7 _kqswstnw _154ipxbi _1ltvpxbi _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$var$closeButtonTheme = (isUpdatedStandaloneComment)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        return {
            ...theme,
            buttonStyles: {
                ...theme.buttonStyles,
                height: $003eb47e4cfe7fce$export$6e006bd290301009,
                width: isUpdatedStandaloneComment ? $003eb47e4cfe7fce$export$28ae196bde1430fd : $003eb47e4cfe7fce$export$3421cb2750fe78a7
            }
        };
    };
const $003eb47e4cfe7fce$export$de65de8213222d10 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    let isUpdatedStandaloneComment;
    let props;
    if ($[0] !== t0) {
        ({ isUpdatedStandaloneComment: isUpdatedStandaloneComment, ...props } = t0);
        $[0] = t0;
        $[1] = isUpdatedStandaloneComment;
        $[2] = props;
    } else {
        isUpdatedStandaloneComment = $[1];
        props = $[2];
    }
    const t1 = isUpdatedStandaloneComment ?? false;
    let t2;
    if ($[3] !== t1) {
        t2 = $003eb47e4cfe7fce$var$closeButtonTheme(t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== props || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
            theme: t2,
            ...props
        });
        $[5] = props;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["ActionsContainer"] = $003eb47e4cfe7fce$export$48377ae1c677702b;
module.exports["SidebarContainer"] = $003eb47e4cfe7fce$export$f39f3f768bc98e3d;
module.exports["ReplyListContainer"] = $003eb47e4cfe7fce$export$18986330a3dbad03;
module.exports["NewReplyContainer"] = $003eb47e4cfe7fce$export$86b1f0d05f7b12cd;
module.exports["ResolvedNotificationContainer"] = $003eb47e4cfe7fce$export$5aae1a36fc838370;
module.exports["EditorContainer"] = $003eb47e4cfe7fce$export$b38a2fd24b22fb35;
module.exports["NavigationContainer"] = $003eb47e4cfe7fce$export$d1b98bde82a43bb3;
module.exports["InlineHeaderButton"] = $003eb47e4cfe7fce$export$2616e8e1e1a7c3e5;
module.exports["SidebarHeader"] = $003eb47e4cfe7fce$export$e575a964a1fe8b0;
module.exports["LoadingSkeletonContainer"] = $003eb47e4cfe7fce$export$b3b0191112eea395;
module.exports["TopContainer"] = $003eb47e4cfe7fce$export$f895097fe90363d1;
module.exports["CloseButtonContainer"] = $003eb47e4cfe7fce$export$32dd8f1956fe77b1;
module.exports["CloseButton"] = $003eb47e4cfe7fce$export$de65de8213222d10;

});

parcelRegister("6wiaZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $781ef84c6c89584f$export$d1fb14f3b5498c7a = ({ sidebarEl: sidebarEl, isRefSet: isRefSet, isSticky: isSticky, isFabricPage: isFabricPage, annotationElement: annotationElement, isEditor: isEditor, sidebarOffset: sidebarOffset, isMaxHeightEnabledForSticky: isMaxHeightEnabledForSticky })=>{
    const [hasMaxHeight, setHasMaxHeight] = (0, $42omo.useState)(false);
    const [dynamicMaxHeight, setDynamicMaxHeight] = (0, $42omo.useState)(undefined);
    // Shared max height check logic
    const checkMaxHeight = (0, $42omo.useCallback)(()=>{
        // Check if annotation is in a sticky table header & on edit mode
        if (annotationElement && isEditor && isMaxHeightEnabledForSticky && (0, $6mKj3.expValEquals)('cc_comments_dynamic_inline_height', 'isEnabled', true)) {
            const stickyTable = annotationElement.closest('table.pm-table-sticky');
            const inStickyTableHeader = Boolean(stickyTable);
            // Special case: annotation in sticky table header - calculate max height based on where sidebar will be positioned
            // Without this check, long comment threads can sometimes have their bottom permanently below the viewport on small-width pages
            if (inStickyTableHeader && isSticky) {
                const annotationRect = annotationElement.getBoundingClientRect();
                const annotationBottom = annotationRect.bottom;
                // Use the sidebar offset that will be applied (STICKY_COMMENT_VERTICAL_OFFSET_VIEW for view, or sidebarOffset for editor)
                const offset = sidebarOffset ?? 0;
                const sidebarTop = annotationBottom + offset;
                const viewportHeight = window.innerHeight;
                // Calculate max height as distance from where sidebar top will be to bottom of viewport
                const calculatedMaxHeight = viewportHeight - sidebarTop;
                // Only apply if the calculated max height is positive and would actually constrain the sidebar
                // Otherwise, continue to default behavior
                if (calculatedMaxHeight > 0) {
                    setDynamicMaxHeight(`${calculatedMaxHeight}px`);
                    setHasMaxHeight(true);
                    return;
                }
            }
        }
        // Default (i.e. non-special-cate) behavior
        if (!sidebarEl.current) return;
        if (isSticky) {
            setHasMaxHeight(true);
            setDynamicMaxHeight(undefined);
            return;
        }
        const rect = sidebarEl.current.getBoundingClientRect();
        const availableHeight = window.innerHeight - 300;
        setHasMaxHeight(rect.height > availableHeight);
        setDynamicMaxHeight(undefined);
    }, [
        isSticky,
        sidebarEl,
        annotationElement,
        isEditor,
        sidebarOffset,
        isMaxHeightEnabledForSticky
    ]);
    // Max height effect for pre-render (useLayoutEffect)
    (0, $42omo.useLayoutEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return;
        if (!sidebarEl.current) return;
        if (!(0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        checkMaxHeight();
    }, [
        checkMaxHeight,
        isRefSet,
        isFabricPage,
        sidebarEl
    ]);
    // Max height effect for post-render (useEffect)
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return;
        if (!sidebarEl.current) return;
        if ((0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        checkMaxHeight();
    }, [
        checkMaxHeight,
        isRefSet,
        isFabricPage,
        sidebarEl
    ]);
    return {
        hasMaxHeight: hasMaxHeight,
        dynamicMaxHeight: dynamicMaxHeight
    };
};
module.exports["useHasMaxHeight"] = $781ef84c6c89584f$export$d1fb14f3b5498c7a;

});

parcelRegister("bEwJH", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $6015f360c209854c$export$fafb84dd8a714e7a = 5;
const $6015f360c209854c$export$675e64cf259adeff = 125;
const $6015f360c209854c$export$6882b33952f7e4d2 = 122;
const $6015f360c209854c$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    closeCommentBox: {
        id: "annotation-provider-inline-comments.closeCommentBox",
        defaultMessage: "Close inline comments"
    },
    closeInlineCommentThread: {
        id: "annotation-provider-inline-comments.close.InlineCommentThread",
        defaultMessage: "Close inline comment thread"
    },
    closeSidebarTooltip: {
        id: "annotation-provider-inline-comments.close.icon.tooltip",
        defaultMessage: "Close comment"
    },
    viewAllCommentsButtonText: {
        id: "annotation-provider-inline-comments.view-all.button.text",
        defaultMessage: "View all"
    },
    commentSidebarLabel: {
        id: "annotation-provider-inline-comments.comment.sidebar.label",
        defaultMessage: "Inline comment by {name}"
    },
    commentSidebarAnnouncement: {
        id: "annotation-provider-inline-comments.comment.sidebar.announcement",
        defaultMessage: "Comment sidebar shown, use Shift + Tab to reach the comment sidebar"
    }
});
module.exports["MAX_UNCOLLAPSED_REPIES"] = $6015f360c209854c$export$fafb84dd8a714e7a;
module.exports["STICKY_COMMENT_VERTICAL_OFFSET_VIEW_OLD"] = $6015f360c209854c$export$675e64cf259adeff;
module.exports["STICKY_COMMENT_VERTICAL_OFFSET_VIEW"] = $6015f360c209854c$export$6882b33952f7e4d2;
module.exports["i18n"] = $6015f360c209854c$export$a7357cdd1f0b0168;

});

parcelRegister("bXQxx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $7N1sB = parcelRequire("7N1sB");


var $9wGTI = parcelRequire("9wGTI");


var $cZa7r = parcelRequire("cZa7r");


var $3BCCf = parcelRequire("3BCCf");

const $d6eff27ff915f22d$var$positionRightStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.150',
    right: 'space.800'
});
const $d6eff27ff915f22d$var$positionLeftStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.150',
    left: 'space.150'
});
const $d6eff27ff915f22d$export$c7f093fedf3e73fe = ({ pageId: pageId, commentData: commentData, isEditor: isEditor, onNavigationClick: onNavigationClick })=>{
    const { clearStoredCommentData: clearStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const { storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { goToNextInlineComment: originalGoToNext, goToPrevInlineComment: originalGoToPrev } = (0, $3BCCf.useInlineCommentNavigation)({
        isEditor: isEditor,
        pageId: pageId,
        onNavigationClick: onNavigationClick,
        commentData: commentData
    });
    // Wrap navigation functions to clear stored comment data before navigation
    const goToNextInlineComment = (0, $42omo.useCallback)(()=>{
        if (clearStoredCommentData && storedCommentData) clearStoredCommentData();
        originalGoToNext();
    }, [
        clearStoredCommentData,
        storedCommentData,
        originalGoToNext
    ]);
    const goToPrevInlineComment = (0, $42omo.useCallback)(()=>{
        if (clearStoredCommentData && storedCommentData) clearStoredCommentData();
        originalGoToPrev();
    }, [
        clearStoredCommentData,
        storedCommentData,
        originalGoToPrev
    ]);
    return (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            xcss: [
                !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $d6eff27ff915f22d$var$positionRightStyles,
                (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $d6eff27ff915f22d$var$positionLeftStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7N1sB.CommentNavigation), {
            goToNextInlineComment: goToNextInlineComment,
            goToPrevInlineComment: goToPrevInlineComment
        })), [
        goToNextInlineComment,
        goToPrevInlineComment
    ]);
};
module.exports["CommentNavigation"] = $d6eff27ff915f22d$export$c7f093fedf3e73fe;

});

parcelRegister("7N1sB", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $3gadb = parcelRequire("3gadb");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $9wGTI = parcelRequire("9wGTI");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $gtj7V = parcelRequire("gtj7V");


var $aJPUt = parcelRequire("aJPUt");


var $9QIM2 = parcelRequire("9QIM2");


var $e4o8D = parcelRequire("e4o8D");


var $666Tc = parcelRequire("666Tc");

const $c0db869228662b46$var$i18n = (0, $cgtv4.defineMessages)({
    nextCommentLabel: {
        id: "inline-comments-common.next-comment-label",
        defaultMessage: "Next comment"
    },
    previousCommentLabel: {
        id: "inline-comments-common.previous-comment-label",
        defaultMessage: "Previous comment"
    }
});
const $c0db869228662b46$export$c7f093fedf3e73fe = (t0)=>{
    const $ = (0, $frIzR.c)(47);
    const { isSSRFocusedComment: isSSRFocusedComment, goToNextInlineComment: goToNextInlineComment, goToPrevInlineComment: goToPrevInlineComment } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t1;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const t2 = isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT) : (0, $gnkil.PREV_COMMENT_SHORTCUT);
    let t3;
    if ($[0] !== t2) {
        t3 = {
            shortcut: t2
        };
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const prevCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t3);
    const t4 = isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT) : (0, $gnkil.NEXT_COMMENT_SHORTCUT);
    let t5;
    if ($[2] !== t4) {
        t5 = {
            shortcut: t4
        };
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    const nextCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t5);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const noop = $c0db869228662b46$var$_temp;
    const isPageOrDoc = pageClass === "renderer" || pageClass === "editor";
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c0db869228662b46$var$i18n.previousCommentLabel);
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== formatMessage) {
        t8 = formatMessage($c0db869228662b46$var$i18n.previousCommentLabel);
        $[6] = formatMessage;
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
            label: t8,
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious",
            size: "small"
        });
        $[8] = t8;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== experienceTracker || $[11] !== goToPrevInlineComment || $[12] !== isPageOrDoc || $[13] !== isSSRFocusedComment || $[14] !== pageClass) {
        t10 = !isSSRFocusedComment ? ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: "comment-navigation"
            });
            if (isPageOrDoc && (0, $9wGTI.fg)("confluence_frontend_view_inline_comment_arrow_nav")) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    entryPoint: "inline-comments-common/CommentNavigation",
                    pageClass: pageClass
                }
            });
            (0, $4EKKB.selectInlineComment).debug("Navigating to previous comment via button.");
            return goToPrevInlineComment();
        } : noop;
        $[10] = experienceTracker;
        $[11] = goToPrevInlineComment;
        $[12] = isPageOrDoc;
        $[13] = isSSRFocusedComment;
        $[14] = pageClass;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== isSSRFocusedComment || $[17] !== t10 || $[18] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
            isSSRFocusedComment: isSSRFocusedComment,
            "data-cy": "inline-nav-previous",
            testId: "comment-navigation-prev",
            iconBefore: t9,
            onClick: t10
        });
        $[16] = isSSRFocusedComment;
        $[17] = t10;
        $[18] = t9;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== prevCommentShortcutStrings || $[21] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t7,
            shortcut: prevCommentShortcutStrings,
            hideTooltipOnClick: true,
            position: "top"
        }, t11);
        $[20] = prevCommentShortcutStrings;
        $[21] = t11;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c0db869228662b46$var$i18n.nextCommentLabel);
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== formatMessage) {
        t14 = formatMessage($c0db869228662b46$var$i18n.nextCommentLabel);
        $[24] = formatMessage;
        $[25] = t14;
    } else t14 = $[25];
    let t15;
    if ($[26] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: t14,
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious",
            size: "small"
        });
        $[26] = t14;
        $[27] = t15;
    } else t15 = $[27];
    let t16;
    if ($[28] !== experienceTracker || $[29] !== goToNextInlineComment || $[30] !== isPageOrDoc || $[31] !== isSSRFocusedComment || $[32] !== pageClass) {
        t16 = !isSSRFocusedComment ? ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: "comment-navigation"
            });
            if (isPageOrDoc && (0, $9wGTI.fg)("confluence_frontend_view_inline_comment_arrow_nav")) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    entryPoint: "inline-comments-common/CommentNavigation",
                    pageClass: pageClass
                }
            });
            (0, $4EKKB.selectInlineComment).debug("Navigating to next comment via button.");
            return goToNextInlineComment();
        } : noop;
        $[28] = experienceTracker;
        $[29] = goToNextInlineComment;
        $[30] = isPageOrDoc;
        $[31] = isSSRFocusedComment;
        $[32] = pageClass;
        $[33] = t16;
    } else t16 = $[33];
    let t17;
    if ($[34] !== isSSRFocusedComment || $[35] !== t15 || $[36] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
            isSSRFocusedComment: isSSRFocusedComment,
            "data-cy": "inline-nav-next",
            testId: "comment-navigation-next",
            iconBefore: t15,
            onClick: t16
        });
        $[34] = isSSRFocusedComment;
        $[35] = t15;
        $[36] = t16;
        $[37] = t17;
    } else t17 = $[37];
    let t18;
    if ($[38] !== nextCommentShortcutStrings || $[39] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t13,
            shortcut: nextCommentShortcutStrings,
            hideTooltipOnClick: true,
            position: "top"
        }, t17);
        $[38] = nextCommentShortcutStrings;
        $[39] = t17;
        $[40] = t18;
    } else t18 = $[40];
    let t19;
    if ($[41] !== renderServerPlaceholder) {
        t19 = renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            id: "inline-comment-index"
        }) : null;
        $[41] = renderServerPlaceholder;
        $[42] = t19;
    } else t19 = $[42];
    let t20;
    if ($[43] !== t12 || $[44] !== t18 || $[45] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.NavigationContainer), {
            "data-testid": "comment-navigation-container",
            shouldHaveButtonGap: t6
        }, t12, t18, t19);
        $[43] = t12;
        $[44] = t18;
        $[45] = t19;
        $[46] = t20;
    } else t20 = $[46];
    return t20;
};
function $c0db869228662b46$var$_temp() {}
module.exports["CommentNavigation"] = $c0db869228662b46$export$c7f093fedf3e73fe;

});

parcelRegister("3BCCf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9jl6v = parcelRequire("9jl6v");


var $liGyh = parcelRequire("liGyh");


var $8i27m = parcelRequire("8i27m");

const $33dbfc40da2aecd4$export$248861b924bd617d = ({ pageId: pageId, isEditor: isEditor, onNavigationClick: onNavigationClick, commentData: commentData })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { navigateToInlineComment: navigateToInlineComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const orderedActiveAnnotations = (0, $42omo.useMemo)(()=>{
        return orderedActiveAnnotationIdList.map((a)=>a.threadKey);
    }, [
        orderedActiveAnnotationIdList
    ]);
    const getCommentIndex = (0, $42omo.useCallback)((currentMarkerRef)=>{
        return orderedActiveAnnotations?.findIndex((markerRef)=>markerRef === currentMarkerRef);
    }, [
        orderedActiveAnnotations
    ]);
    const currentInlineMarkerRef = commentData?.location?.inlineMarkerRef ?? '';
    const currentCommentIndex = getCommentIndex(currentInlineMarkerRef);
    const goToNextInlineComment = (0, $42omo.useCallback)((triggeredByKeyboardShortcut = false)=>{
        navigateToInlineComment({
            action: 'next',
            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
            currentCommentIndex: currentCommentIndex,
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: isEditor,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: pageId
        });
    }, [
        getCommentIndex,
        navigateToInlineComment,
        createAnalyticsEvent,
        currentCommentIndex,
        onNavigationClick,
        pageId,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        isEditor
    ]);
    const goToPrevInlineComment = (0, $42omo.useCallback)((triggeredByKeyboardShortcut = false)=>{
        navigateToInlineComment({
            action: 'previous',
            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
            currentCommentIndex: currentCommentIndex,
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: isEditor,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: pageId
        });
    }, [
        getCommentIndex,
        navigateToInlineComment,
        createAnalyticsEvent,
        currentCommentIndex,
        onNavigationClick,
        pageId,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        isEditor
    ]);
    return (0, $42omo.useMemo)(()=>({
            currentCommentIndex: currentCommentIndex,
            goToNextInlineComment: goToNextInlineComment,
            goToPrevInlineComment: goToPrevInlineComment,
            commentsCount: orderedActiveAnnotations.length
        }), [
        goToNextInlineComment,
        goToPrevInlineComment,
        orderedActiveAnnotations.length,
        currentCommentIndex
    ]);
};
module.exports["useInlineCommentNavigation"] = $33dbfc40da2aecd4$export$248861b924bd617d;

});

parcelRegister("liGyh", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $6tkbf = parcelRequire("6tkbf");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $7W8i8 = parcelRequire("7W8i8");


var $6mKj3 = parcelRequire("6mKj3");


var $lb2Lp = parcelRequire("lb2Lp");


var $kgNLQ = parcelRequire("kgNLQ");


var $aSsfA = parcelRequire("aSsfA");


var $1rdvc = parcelRequire("1rdvc");

const $ba57c93125c5375a$var$useCommentQueryParamsCommentLocationQuery = (0, $eSUdr.default)`query useCommentQueryParamsCommentLocationQuery($commentId:ID$contentStatus:[GraphQLContentStatus]){comments(commentId:$commentId contentStatus:$contentStatus){nodes{container{id}location{type}}}}`;
const $ba57c93125c5375a$var$logger = (0, $7W8i8.getLogger)('comment-query-params');
const $ba57c93125c5375a$export$63c5e37b7c8d14d1 = ({ location: location, queryArchivedContent: queryArchivedContent = false } = {})=>{
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [pageId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { focusedCommentId: focusedCommentId, editComment: editComment, commentId: commentId, replyToComment: replyToComment, showCommentArea: showCommentArea, shouldMention: shouldMention, unreadCommentMark: unreadCommentMark } = getQueryParams();
    const targetCommentId = focusedCommentId || replyToComment || editComment && commentId;
    const shouldSkipQuery = !targetCommentId || !location;
    // NEW FLOW: Use useCommentById when experiment is enabled
    const { comment: comment, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: targetCommentId || '',
        contentId: pageId || '',
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        options: {
            skip: shouldSkipQuery || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
        }
    });
    // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
    const { data: legacyData, error: legacyError } = (0, $xQxzY.useQuery)($ba57c93125c5375a$var$useCommentQueryParamsCommentLocationQuery, {
        variables: {
            commentId: targetCommentId,
            contentStatus: [
                queryArchivedContent ? (0, $1rdvc.GraphQLContentStatus).ARCHIVED : (0, $1rdvc.GraphQLContentStatus).DRAFT,
                (0, $1rdvc.GraphQLContentStatus).CURRENT
            ]
        },
        skip: shouldSkipQuery || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    });
    if (legacyError) $ba57c93125c5375a$var$logger.error`Error: Unable to query comment location for ${commentId}`;
    // Determine error state - use new flow error or old flow error
    const error = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? commentError : legacyError;
    // Note that this will detect missing inline and footer comments because the query will find
    // either type of comment - so if the comment doesn't exist, we will get the "not found" error
    // In the new flow, useCommentById returns an error when the comment isn't found after loading completes
    const isCommentNotFound = error ? (0, $6tkbf.isCommentNotFoundError)(error.message || String(error)) : false;
    let focusedId;
    let editCommentId;
    let replyToCommentId;
    // Extract location and container ID from either new or old flow
    const commentLocation = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? comment?.location?.type : legacyData?.comments?.nodes?.[0]?.location?.type;
    // Extract container ID from either new or old flow
    let commentContainerId;
    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
        if (comment && 'container' in comment) // Comment replies coming from the new manager don't have a container
        commentContainerId = comment.container?.id;
        else commentContainerId = undefined;
    } else commentContainerId = legacyData?.comments?.nodes?.[0]?.container?.id;
    // Only return comment IDs for relevant location; If no location is given, return them all
    const shouldReturnIds = (!location || location === commentLocation) && (pageId === commentContainerId || commentContainerId === undefined && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false));
    if (shouldReturnIds) {
        /* A focused comment query param just uses "focusedCommentId={COMMENT_ID}" */ focusedId = focusedCommentId ? focusedCommentId : undefined;
        /* An edit comment query param uses a combination of "editComment=true&commentId={COMMENT_ID}" */ editCommentId = editComment && editComment === 'true' && commentId ? commentId : undefined;
        /* A reply to comment query param just uses "replyToComment={COMMENT_ID}" */ replyToCommentId = replyToComment ? replyToComment : undefined;
    }
    /* PAGE COMMENTS ONLY: A new comment uses the "showCommentArea=true" query param */ const shouldOpenNewCommentEditor = showCommentArea === 'true';
    /* A mention comment uses the "shouldMention=true" query param */ const shouldMentionInNewCommentEditor = shouldMention === 'true' && replyToCommentId !== undefined;
    const removeCommentQueryParamsFunction = ()=>{
        let commentTypeKey = '', commentIdKey = '', commentMentionKey = '';
        if (focusedId) commentTypeKey = 'focusedCommentId';
        else if (shouldMentionInNewCommentEditor) {
            commentTypeKey = 'replyToComment';
            commentMentionKey = 'shouldMention';
        } else if (replyToCommentId) commentTypeKey = 'replyToComment';
        else if (editCommentId) {
            commentTypeKey = 'editComment';
            commentIdKey = 'commentId';
        } else if (shouldOpenNewCommentEditor) commentTypeKey = 'showCommentArea';
        if (commentTypeKey || commentIdKey || commentMentionKey || unreadCommentMark) {
            const params = getQueryParams();
            setQueryParams({
                ...params,
                [commentTypeKey]: undefined,
                [commentIdKey]: undefined,
                [commentMentionKey]: undefined,
                unreadCommentMark: undefined
            });
        }
    };
    const removeCommentQueryParamsCallback = (0, $42omo.useCallback)(removeCommentQueryParamsFunction, [
        getQueryParams,
        setQueryParams,
        unreadCommentMark,
        editCommentId,
        replyToCommentId,
        shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor,
        focusedId
    ]);
    const removeCommentQueryParams = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? removeCommentQueryParamsCallback : removeCommentQueryParamsFunction;
    const setFocusedCommentQueryParam = (commentId)=>{
        const params = getQueryParams();
        setQueryParams({
            ...params,
            focusedCommentId: commentId
        });
    };
    return {
        focusedCommentId: focusedId,
        editCommentId: editCommentId,
        replyToCommentId: replyToCommentId,
        shouldOpenNewCommentEditor: shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor: shouldMentionInNewCommentEditor,
        unreadCommentMark: unreadCommentMark,
        removeCommentQueryParams: removeCommentQueryParams,
        setFocusedCommentQueryParam: setFocusedCommentQueryParam,
        isCommentNotFound: isCommentNotFound
    };
};
const $ba57c93125c5375a$export$b073d30d47d4035b = ({ queryArchivedContent: queryArchivedContent = false } = {})=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'INLINE',
        queryArchivedContent: queryArchivedContent
    });
const $ba57c93125c5375a$export$97d0ff531551284c = ()=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'FOOTER'
    });
module.exports["useInlineCommentQueryParams"] = $ba57c93125c5375a$export$b073d30d47d4035b;

});

parcelRegister("6tkbf", function(module, exports) {

var $lb2Lp = parcelRequire("lb2Lp");

const $6b00aa328c211ce7$export$9f99b736afd21d01 = (errorMessage)=>{
    if (errorMessage) {
        // Check if the full error message matches the string thrown from useCommentById
        if (errorMessage === (0, $lb2Lp.USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE)) return true;
        // Also check the reason message (extracted from backend error format)
        const reasonStartIdx = errorMessage.lastIndexOf(':') + 1;
        const reasonMessage = errorMessage.substring(reasonStartIdx, errorMessage.length).trim();
        // If this string is ever updated on the BE and you need to change it - make sure to also update USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE for consistency
        const backendReasonMessage = 'No comment found for the given id';
        return reasonMessage === backendReasonMessage;
    }
    return false;
};
module.exports["isCommentNotFoundError"] = $6b00aa328c211ce7$export$9f99b736afd21d01;

});

parcelRegister("lb2Lp", function(module, exports) {

var $dc3kb = parcelRequire("dc3kb");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");

// The `useCommentById` hook efficiently fetches a single comment by ID with a simple strategy:
// First, it checks the cache for the allCommentsDataQuery using useAllCommentsData with cache-only
// policy. If the comment is found in the cache and data is processed, it uses that data. Otherwise,
// it makes a separate query for just the specific comment. This ensures quick access to individual
// comments without unnecessary network requests when data is already cached. The hook also provides
// loading states, error handling, and comprehensive type safety.
// Unfortunately our Relay-friendly type generation tools don't support GQL fragments yet - but in
// order to keep the definition of the comment fields in sync (so the cache update fragment is
// always in sync with the full query) we will need to manually make any changes to one definition
// in any others as well, until our tooling supports fragments and then we move to a more
// fragmented-based approach.  Note there are also comment queries or fragments in the following
// files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// TODO: Replace with the exported fragment from useAllCommentsData.ts when our tooling supports
// it, if we are allowed to share fragments between packages/files.  If we are not allowed to share
// fragments, we should move this hook - or at least the part that executes the query into the
// useAllCommentsData.ts file.
const $f4841d4502be35b2$var$commentByIdQuery = (0, $dc3kb.default);
const $f4841d4502be35b2$export$4bf99575c214d4b = 'Comment not found: No comment found for the given id';
const $f4841d4502be35b2$export$1f091977fe1929e2 = 'useCommentById requires either commentId or markerRef and contentId to be provided';
const $f4841d4502be35b2$export$778dda4ccca7793f = ({ commentId: commentId, markerRef: markerRef, contentId: contentId, contentStatus: contentStatus = [
    'CURRENT'
], options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onError: parentOnError, skip: explicitlySkipped = false } = options;
    // Skip queries if experiment is disabled or explicitly skipped through options
    const skip = explicitlySkipped || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false);
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // Validate that at least one identifier is provided (only if not skipping)
    const validationError = (0, $42omo.useMemo)(()=>!skip && (!contentId || !commentId && !markerRef) ? new Error($f4841d4502be35b2$export$1f091977fe1929e2) : undefined, [
        skip,
        commentId,
        markerRef,
        contentId
    ]);
    const skipQueries = skip || !!validationError;
    // Skip the individual comment query if we have cached data from the full query, it's been processed, and we're not asking for fresh BE data
    const shouldSkipOneCommentQuery = skipQueries || fetchPolicy !== 'network-only' && processedCommentsData.isDataProcessed;
    // Always query with all 4 content statuses to guarantee cache hits on preloaded data
    // We'll filter the result client-side based on the passed-in contentStatus
    const oneCommentData = (0, $jMyy4.useQueryInterop)($f4841d4502be35b2$var$commentByIdQuery, {
        variables: {
            pageId: contentId ?? '',
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy,
        skip: shouldSkipOneCommentQuery,
        onError: (error)=>{
            // Handle specific GraphQL errors gracefully
            // WS-3494 - If the error isn't related to reactionsSummary returning null, just mark it handled
            // COMMENTS-188 - Or if the error isn't related to cc-pages not being reachable just mark it handled
            if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    // Look for the comment using the flat map for O(1) lookup, or fall back to searching arrays
    const finalComment = (0, $42omo.useMemo)(()=>{
        if (validationError) return undefined;
        // If data is processed, try to find in the flat maps (fastest - O(1))
        if (processedCommentsData.isDataProcessed) {
            if (commentId) {
                const cachedComment = processedCommentsData.flatCommentsMap?.[commentId];
                if (cachedComment) return cachedComment;
            } else if (markerRef) {
                const cachedCommentByMarkerRef = processedCommentsData.flatMarkerRefMap?.[markerRef];
                if (cachedCommentByMarkerRef) return cachedCommentByMarkerRef;
            }
        }
        // Fall back to searching in oneCommentData if available
        if (oneCommentData.data?.comments?.nodes) {
            // Filter out any null nodes - can't just use .filter because TS complains about type
            // mismatch.  Fortunately, this query should only have one comment node anyway.
            const commentData = oneCommentData.data.comments.nodes.map((node)=>node).filter((node)=>node);
            if (!commentData) return undefined;
            // Search in retrieved comments and their replies
            return (0, $kgNLQ.findAndFilterComment)(commentData, commentId, markerRef, contentStatus);
        }
        return undefined;
    }, [
        validationError,
        commentId,
        processedCommentsData.flatCommentsMap,
        processedCommentsData.flatMarkerRefMap,
        processedCommentsData.isDataProcessed,
        oneCommentData.data?.comments?.nodes,
        markerRef,
        contentStatus
    ]);
    // Create an error if we have the full response but can't find the comment
    // 99% of the time this error will be thrown when cachedUseAllCommentsData is populated, but the comment isn't available
    // useCommentByIdQuery **should** throw a similar error if the comment isn't found from the BE,
    // but keep the check here in case the BE changes, or our comment is in another status & is filtered out
    const commentNotFoundError = (0, $42omo.useMemo)(()=>{
        // Only create error if:
        // 1. We're not loading anymore (have full response)
        // 2. We have data (either from processedCommentsData or oneCommentData)
        // 3. We searched for the comment but didn't find it
        // 4. There's no existing error
        if (!skipQueries && processedCommentsData.isDataProcessed && !oneCommentData.loading && !processedCommentsData.error && !oneCommentData.error && finalComment === undefined) return new Error($f4841d4502be35b2$export$4bf99575c214d4b);
        return undefined;
    }, [
        skipQueries,
        processedCommentsData.isDataProcessed,
        processedCommentsData.error,
        oneCommentData.loading,
        oneCommentData.error,
        finalComment
    ]);
    // Memoize the final error to ensure stable reference for use in external useEffects
    const error = (0, $42omo.useMemo)(()=>{
        return validationError || processedCommentsData.error || oneCommentData.error || commentNotFoundError;
    }, [
        validationError,
        processedCommentsData.error,
        oneCommentData.error,
        commentNotFoundError
    ]);
    // Call onError when the error changes
    (0, $42omo.useEffect)(()=>{
        if (error && parentOnError) parentOnError(error);
    }, [
        error,
        parentOnError
    ]);
    return {
        loading: !processedCommentsData.isDataProcessed && oneCommentData.loading,
        error: // (Only loading state if both are loading)
        error,
        comment: finalComment
    };
};
const $f4841d4502be35b2$export$77a85b13740d9b96 = async ({ commentId: commentId, markerRef: markerRef, contentId: contentId, fetchPolicy: fetchPolicy = 'network-only' })=>{
    if (!contentId || !commentId && !markerRef) return Promise.resolve(null);
    const response = await (0, $c0rhi.queryInterop)({
        query: $f4841d4502be35b2$var$commentByIdQuery,
        variables: {
            pageId: contentId,
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            // Query for all content statuses - don't filter by contentStatus
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy
    });
    const nodes = response?.data?.comments?.nodes;
    if (!nodes || nodes.length === 0) return null;
    // Filter out nulls and convert readonly array to mutable array
    const comments = nodes.filter((node)=>node !== null);
    return (0, $kgNLQ.findAndFilterComment)(comments, commentId, markerRef, (0, $NYiei.allContentStatuses));
};
module.exports["USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE"] = $f4841d4502be35b2$export$4bf99575c214d4b;
module.exports["useCommentById"] = $f4841d4502be35b2$export$778dda4ccca7793f;
module.exports["fetchCommentById"] = $f4841d4502be35b2$export$77a85b13740d9b96;

});

parcelRegister("dc3kb", function(module, exports) {
/**
 * @generated SignedSource<<5436b93d76e4ad3ca1b847dd48c8568a>>
 * @relayHash 80f6dc5113d6aef8927adf669909b48e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a7e41ef969ee551d0afd8d103f23ec6991292b83b77931c1782403014e46ce8b
const $09771c757ee62765$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRef"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v4 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v12 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v15 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v17 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v22 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v24 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v4 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "number"
    }, v27 = {
        "kind": "ScalarField",
        "name": "when"
    }, v28 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "commentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Variable",
                    "name": "inlineMarkerRef",
                    "variableName": "inlineMarkerRef"
                },
                v4 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        v13 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ 
                            ]
                        },
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCommentByIdQuery",
            "selections": v28 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCommentByIdQuery",
            "selections": v28 /*: any*/ 
        },
        "params": {
            "cacheID": "80f6dc5113d6aef8927adf669909b48e",
            "id": "a7e41ef969ee551d0afd8d103f23ec6991292b83b77931c1782403014e46ce8b",
            "metadata": {},
            "name": "useCommentByIdQuery",
            "operationKind": "query",
            "text": "query useCommentByIdQuery($pageId:ID!,$commentId:ID,$inlineMarkerRef:String,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,commentId:$commentId,inlineMarkerRef:$inlineMarkerRef){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}}"
        }
    };
}();
$09771c757ee62765$var$node.hash = "ed7145a8b5d08f815e716de36a4b73ca";
var $09771c757ee62765$export$2e2bcd8739ae039 = $09771c757ee62765$var$node;
module.exports["default"] = $09771c757ee62765$export$2e2bcd8739ae039;

});

parcelRegister("1rdvc", function(module, exports) {
/**
 * @generated SignedSource<<5ee01bec8d3f6c744747b059c459e176>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $39a1d37ae379d69e$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["GraphQLContentStatus"] = $39a1d37ae379d69e$export$b634e5de755b7d35;

});

parcelRegister("kBOGD", function(module, exports) {
/* CreateComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $inPa6 = parcelRequire("inPa6");


var $3gadb = parcelRequire("3gadb");


var $7zgzO = parcelRequire("7zgzO");


var $de2j9 = parcelRequire("de2j9");


var $4ri4I = parcelRequire("4ri4I");


var $7NoF3 = parcelRequire("7NoF3");


var $1NBp8 = parcelRequire("1NBp8");


var $6GD8y = parcelRequire("6GD8y");


var $fZAJP = parcelRequire("fZAJP");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $dkIiA = parcelRequire("dkIiA");


var $94z7g = parcelRequire("94z7g");


var $eTign = parcelRequire("eTign");


var $bZSO8 = parcelRequire("bZSO8");


var $jqe2L = parcelRequire("jqe2L");


var $7EIq6 = parcelRequire("7EIq6");


var $jmjWc = parcelRequire("jmjWc");


const $ed7cda18e73c8ae3$export$281386d034e12de1 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "bkMvp",
    name: "WhiteboardGAModalManager",
    loader: async ()=>(await (parcelRequire("iU3Bi"))).WhiteboardGAModalManager
});






const $69ce387dc2d04641$export$cd960f7e7a84b9fe = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "tgqZp",
    name: "LoomMigrationModalManager",
    loader: async ()=>(await (parcelRequire("4Y2RD"))).LoomMigrationModalManager
});



var $8fj5s = parcelRequire("8fj5s");


var $56QzY = parcelRequire("56QzY");


var $5cryL = parcelRequire("5cryL");


var $ivb8S = parcelRequire("ivb8S");


var $fywGr = parcelRequire("fywGr");


var $ep3mz = parcelRequire("ep3mz");


var $7yn0t = parcelRequire("7yn0t");


var $kDja4 = parcelRequire("kDja4");


var $6MlZq = parcelRequire("6MlZq");


var $bqyIi = parcelRequire("bqyIi");


var $hqD0X = parcelRequire("hqD0X");


var $gIdnC = parcelRequire("gIdnC");


var $lqy4C = parcelRequire("lqy4C");


var $gz8ZY = parcelRequire("gz8ZY");




var $luv00 = parcelRequire("luv00");


var $9wGTI = parcelRequire("9wGTI");


var $efvKr = parcelRequire("efvKr");


var $gTyTP = parcelRequire("gTyTP");


var $7aRa9 = parcelRequire("7aRa9");


var $7DERG = parcelRequire("7DERG");


var $6g41Q = parcelRequire("6g41Q");


var $iGpKB = parcelRequire("iGpKB");

'use no memo';
const $433f7c954f8755e5$var$containerStyles = null;

const $433f7c954f8755e5$var$CreateButton = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ZXF2b",
    name: "CreateButton",
    loader: async ()=>(await (parcelRequire("kPga6"))).CreateButton
});
const $433f7c954f8755e5$var$LIVE_DOCS_LINK = 'https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/';
const $433f7c954f8755e5$var$CreateComponentContent = ({ flags: flags })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { setQueryParams: setQueryParams, match: match, push: push, location: location } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isCreationDropdownEnabled = (0, $6MlZq.useIsCreationDropdownEnabled)();
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-component'
    });
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isCreateContentPage = Boolean((0, $1NBp8.CREATE_CONTENT).match(location?.pathname || ''));
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const { isCreateLiveDocEnabled: isCreateLiveDocEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey); // Whiteboard GA
    const [isWhiteboardGASpotlightEnabled, setIsWhiteboardGASpotlightEnabled] = (0, $42omo.useState)(false); // GA onboarding is enabled + NOT on editor route + NOT on create-content route
    // Exclude the editor route to avoid disrupting a user's workflow when they're actively creating
    // Exclude the create-content route because it can quickly redirect and we don't want modal screen events firing twice
    const showWhiteboardGAOnboardingModal = isWhiteboardGAOnboardingEnabled() && !isOnEditRoute && !isCreateContentPage;
    const [hasStartedWhiteboardGAOnboardingCoordination, stopWhiteboardGAOnboardingCoordination] = (0, $8fj5s.useSkippableCoordination)('cc-whiteboards-ga-admin-onboarding-modal', !showWhiteboardGAOnboardingModal);
    const onCloseWhiteboardGAOnboardingModal = (0, $42omo.useCallback)(()=>{
        stopWhiteboardGAOnboardingCoordination();
        setIsWhiteboardGASpotlightEnabled(true);
    }, [
        setIsWhiteboardGASpotlightEnabled,
        stopWhiteboardGAOnboardingCoordination
    ]);
    const onCloseWhiteboardGASpotlight = (0, $42omo.useCallback)(()=>{
        setIsWhiteboardGASpotlightEnabled(false);
    }, [
        setIsWhiteboardGASpotlightEnabled
    ]);
    const [hasStartedLoomPremigrationModalCoordination, stopLoomPremigrationModalCoordination] = (0, $8fj5s.useSkippableCoordination)('cc-content-types-loom-premigration-modal', !(0, $9wGTI.fg)('confluence_loom_premigration_modal'));
    const onCloseLoomPremigrationModal = (0, $42omo.useCallback)(()=>{
        stopLoomPremigrationModalCoordination();
    }, [
        stopLoomPremigrationModalCoordination
    ]);
    const [hasStartedLoomMigrationModalCoordination, stopLoomMigrationModalCoordination] = (0, $8fj5s.useSkippableCoordination)('cc-content-types-loom-migration-modal', !(0, $9wGTI.fg)('confluence_loom_migration_modal'));
    const onCloseLoomMigrationModal = (0, $42omo.useCallback)(()=>{
        stopLoomMigrationModalCoordination();
    }, [
        stopLoomMigrationModalCoordination
    ]);
    const { isEnabled: isOnboardingNewHomeTakeoverEnabled } = (0, $gIdnC.useOnboardingNewHomeTakeoverEnabled)();
    const { setEditSource: setEditSource } = (0, $4ri4I.useEditSourceActions)();
    const { data: data } = (0, $ivb8S.useGetOnboardingState)(Object.values({
        ...(0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS)
    }), !(0, $9wGTI.fg)('cc_onboarding_experience'));
    const { editorOnboardingEligiblity: editorOnboardingEligiblity } = (0, $ivb8S.deserializeState)(data);
    const fireAnalytics = (additionalAttributes = {})=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'create',
                attributes: {
                    selectedItemPageContext: match ? match.name : undefined,
                    navigationLayer: 'global',
                    navVersion: isNav4Enabled ? '4' : '3',
                    navdexPointType: (0, $56QzY.START_TOUCH),
                    ...additionalAttributes
                }
            }
        }).fire();
    };
    const openCreateDialog = ()=>{
        fireAnalytics();
        setQueryParams({
            createDialog: true
        });
    };
    const shouldCreateBlankFabricPage = ()=>{
        if (data && editorOnboardingEligiblity) (0, $fywGr.preloadEditorOnboardingState)();
        return true;
    };
    const createPageHref = (0, $bZSO8.buildCreationLink)({
        contentType: 'page',
        source: 'createBlankFabricPage',
        withFallback: true,
        spaceKey: spaceKey,
        parentPageId: contentId
    });
    const handleCreatePageShortcut = ()=>{
        setEditSource((0, $7NoF3.CREATE_PAGE_SHORTCUT));
        fireAnalytics({
            keyboardShortcut: true
        });
        const shouldCreate = shouldCreateBlankFabricPage();
        if (shouldCreate) push(createPageHref);
    };
    const handleCreatePageButtonClick = (e)=>{
        fireAnalytics();
        const shouldCreate_0 = shouldCreateBlankFabricPage();
        if (shouldCreate_0) {
            if (isNav4Enabled) {
                if (e.metaKey || e.ctrlKey) window.open(createPageHref, '_blank', 'noreferrer');
                else push(createPageHref);
            }
        } else // creation is handled by href for button click
        e.preventDefault();
    };
    const createBlog = ()=>{
        const createBlogLink = (0, $bZSO8.buildCreationLink)({
            contentType: 'blog',
            source: 'globalCreateBlogShortcut',
            spaceKey: spaceKey
        });
        push(createBlogLink);
    };
    const createLiveDoc = ()=>{
        const createLiveDocLink = (0, $bZSO8.buildCreationLink)({
            contentType: 'page',
            subType: (0, $dkIiA.ConfluencePageSubType).LIVE,
            parentPageId: contentId,
            withFallback: true,
            source: 'globalCreateLiveDocShortcut',
            spaceKey: spaceKey
        });
        push(createLiveDocLink);
    };
    const showLiveDocNotEnabledFlag = ()=>{
        flags.showErrorFlag({
            id: 'live-doc-not-enabled-shortcut-flag',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $433f7c954f8755e5$var$i18n.liveDocsNotEnabledTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $433f7c954f8755e5$var$i18n.liveDocsNotEnabledDescription),
            isAutoDismiss: true,
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $433f7c954f8755e5$var$i18n.liveDocsNotEnabledAction),
                    onClick: ()=>{
                        window.open($433f7c954f8755e5$var$LIVE_DOCS_LINK, '_blank');
                    }
                }
            ]
        });
    };
    const getButtonHref = ()=>{
        if ((0, $jqe2L.isCreateBlankFabricPageEnabled)() && !shouldBlockCreate) return createPageHref;
        return undefined;
    };
    const [createPageClickListener, createPageShortcutListener] = (0, $jqe2L.isCreateBlankFabricPageEnabled)() ? [
        handleCreatePageButtonClick,
        handleCreatePageShortcut
    ] : [
        openCreateDialog,
        openCreateDialog
    ]; /**
                                                                                                                                                                                                     * Please also update skeleton in appNavigationLazyItems
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * <NavItemWrapper>
                                                                                                                                                                                                        <CreateButton />
                                                                                                                                                                                                      </NavItemWrapper>
                                                                                                                                                                                                     */ 
    const EngagementInlineDialogLoader = isNav4Enabled ? (0, $6g41Q.EngagementInlineDialogLoader) : (0, $6g41Q.EngagementInlineDialogLoaderNav3);
    const globalCreateContentPopover = (0, $42omo.useCallback)(()=>{
        if (hasStartedWhiteboardGAOnboardingCoordination || isWhiteboardGASpotlightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqyIi.CreateButtonNudgeWrappable), {
            target: (0, $hqD0X.HOVER_TARGET).CREATE,
            shouldWrap: isOnboardingNewHomeTakeoverEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTign.GlobalCreateContentPopoverSpotlightLoader), {
            isGA: true,
            isUniversalCreate: true,
            spotlightEnabled: isWhiteboardGASpotlightEnabled,
            onSpotlightClose: onCloseWhiteboardGASpotlight
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqyIi.CreateButtonNudgeWrappable), {
            target: (0, $hqD0X.HOVER_TARGET).CREATE,
            shouldWrap: isOnboardingNewHomeTakeoverEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $94z7g.UniversalCreate), null));
    }, [
        isWhiteboardGASpotlightEnabled,
        onCloseWhiteboardGASpotlight,
        isOnboardingNewHomeTakeoverEnabled,
        hasStartedWhiteboardGAOnboardingCoordination
    ]);
    const universalGlobalCreateShortcut = (0, $4tOXV.isMac)() ? (0, $gnkil.UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC) : (0, $gnkil.UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN);
    const handlePreload = ()=>{
        if ((0, $9wGTI.fg)('aifc_create_enabled')) // preload smart creation
        (0, $7DERG.ConfluenceSmartCreationModalLoader).preload();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "app-navigation-create",
        "data-pendo-id": "con-*/wiki/home-create",
        "data-vc": "create-component",
        ...ssrPlaceholderIdProp,
        onMouseEnter: handlePreload,
        onFocus: handlePreload,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(EngagementInlineDialogLoader, {
        engagementId: "createComponentButton",
        dataVC: "app-navigation-create-engagement-inline-dialog"
    }, isCreationDropdownEnabled ? globalCreateContentPopover() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: areKeyboardShortcutsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: universalGlobalCreateShortcut,
            isTooltip: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7yn0t.CreateContentButtonPreloader), {
        editSource: (0, $7NoF3.CREATE_NAV_BUTTON_CLICK)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqyIi.CreateButtonNudgeWrappable), {
        target: (0, $hqD0X.HOVER_TARGET).CREATE,
        shouldWrap: isOnboardingNewHomeTakeoverEnabled
    }, isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($433f7c954f8755e5$var$CreateButton, {
        onClick: enforceStorageLimit(createPageClickListener)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $433f7c954f8755e5$var$i18n.create)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iGpKB.CreateButton), {
        onClick: enforceStorageLimit(createPageClickListener),
        href: getButtonHref()
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.GLOBAL_CREATE_SHORTCUT) : undefined,
        accelerator: universalGlobalCreateShortcut,
        listener: enforceStorageLimit(createPageShortcutListener),
        isAppNavigationShortcut: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.BLOG_SHORTCUT) : undefined,
        accelerator: (0, $gnkil.UNIVERSAL_BLOG_SHORTCUT),
        listener: enforceStorageLimit(createBlog),
        isAppNavigationShortcut: true
    }), isCreateLiveDocEnabled && isLivePagesFeatureEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT),
        listener: enforceStorageLimit(createLiveDoc),
        isAppNavigationShortcut: true
    }), !isCreateLiveDocEnabled && isLivePagesFeatureEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT),
        listener: enforceStorageLimit(showLiveDocNotEnabledFlag),
        isAppNavigationShortcut: true
    }), showWhiteboardGAOnboardingModal && hasStartedWhiteboardGAOnboardingCoordination && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ed7cda18e73c8ae3$export$281386d034e12de1), {
        onClose: onCloseWhiteboardGAOnboardingModal,
        parentId: contentId,
        spaceKey: spaceKey
    }), // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    hasStartedLoomPremigrationModalCoordination && (0, $9wGTI.fg)('confluence_loom_beta_enabled') && (0, $9wGTI.fg)('confluence_loom_premigration_modal') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $69ce387dc2d04641$export$cd960f7e7a84b9fe), {
        isPremigration: true,
        onClose: onCloseLoomPremigrationModal
    }), hasStartedLoomMigrationModalCoordination && // Migration
    // This feature gate has the rule: `loombetaprovision` none of `migrated-site` => 100% fail
    // since there not a different feature gate to let us know if the user is migrated
    (0, $9wGTI.fg)('confluence_loom_migration_modal') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $69ce387dc2d04641$export$cd960f7e7a84b9fe), {
        onClose: onCloseLoomMigrationModal
    }));
};
const $433f7c954f8755e5$var$i18n = (0, $cgtv4.defineMessages)({
    // eslint-disable-next-line @atlassian/i18n/require-description
    create: {
        id: "app-navigation.top-navigation.create",
        defaultMessage: "Create"
    },
    liveDocsNotEnabledTitle: {
        id: "app-navigation.shortcuts.flags.liveDocsNotEnabled.title",
        defaultMessage: "Live docs aren\u2019t enabled in this space"
    },
    liveDocsNotEnabledDescription: {
        id: "app-navigation.shortcuts.flags.liveDocsNotEnabled.description",
        defaultMessage: "To use this shortcut, your space admin will need to enable live docs."
    },
    liveDocsNotEnabledAction: {
        id: "app-navigation.shortcuts.flags.liveDocsNotEnabled.action",
        defaultMessage: "Find out more"
    }
});
const $433f7c954f8755e5$export$a9a76753cd947d5c = (0, $7aRa9.withFlags)(/*#__PURE__*/ (0, $42omo.memo)($433f7c954f8755e5$var$CreateComponentContent));
module.exports["CreateComponent"] = $433f7c954f8755e5$export$a9a76753cd947d5c;

});

parcelRegister("4ri4I", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4d309a7dc7a1cda3$export$64697004958d0ff1 = {
    editSource: ''
};
const $4d309a7dc7a1cda3$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        ...$4d309a7dc7a1cda3$export$64697004958d0ff1
    },
    actions: {
        setEditSource: (editSource)=>({ setState: setState })=>{
                setState({
                    editSource: editSource
                });
            }
    },
    name: 'setEditSource'
});
const $4d309a7dc7a1cda3$export$ee479a8e5902b302 = (0, $9zUhf.createHook)($4d309a7dc7a1cda3$var$Store);
const $4d309a7dc7a1cda3$export$7e972f51583fdb8e = (0, $9zUhf.createActionsHook)($4d309a7dc7a1cda3$var$Store);
module.exports["useEditSource"] = $4d309a7dc7a1cda3$export$ee479a8e5902b302;
module.exports["useEditSourceActions"] = $4d309a7dc7a1cda3$export$7e972f51583fdb8e;

});

parcelRegister("7NoF3", function(module, exports) {
const $e900dacf455c7c27$export$45d9f22b250b4fa6 = 'PAGE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$daadd9484abf9243 = 'BLOG_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$18ec89b444ed9e13 = 'SPACE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$1670e1f700b91982 = 'PAGE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$99c4be058cda9518 = 'BLOG_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$9a65fbf92be78751 = 'SPACE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$a5c6eb91dd72e7c0 = 'NAVIGATION_RECENT_DROPDOWN_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$835a97ed77363e2a = 'PAGECARD_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$d8133449fbfd82d4 = 'PAGECARD_DRAFT_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$aca8dbff71ee152b = 'QUICK_ACTIONS_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$3a91fd27464e4cde = 'EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$62ca21e37a92c063 = 'CREATE_PAGE_SHORTCUT';
const $e900dacf455c7c27$export$6eda3121bad7aadf = 'CREATE_NAV_BUTTON_CLICK';
const $e900dacf455c7c27$export$7698b0f9c7cef133 = 'CREATE_PAGETREE_BLOG_BUTTON_CLICK';
const $e900dacf455c7c27$export$d83b4b43e279cde5 = 'CREATE_PAGETREE_CHILDPAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$1dd5c358458f3c8f = 'CREATE_PAGETREE_PAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$6e88709afea7d3ed = [
    $e900dacf455c7c27$export$aca8dbff71ee152b,
    $e900dacf455c7c27$export$835a97ed77363e2a,
    $e900dacf455c7c27$export$d8133449fbfd82d4,
    $e900dacf455c7c27$export$a5c6eb91dd72e7c0
];
module.exports["PAGE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$45d9f22b250b4fa6;
module.exports["BLOG_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$daadd9484abf9243;
module.exports["SPACE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$18ec89b444ed9e13;
module.exports["PAGE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$1670e1f700b91982;
module.exports["BLOG_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$99c4be058cda9518;
module.exports["SPACE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$9a65fbf92be78751;
module.exports["PAGECARD_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$835a97ed77363e2a;
module.exports["QUICK_ACTIONS_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$aca8dbff71ee152b;
module.exports["CREATE_PAGE_SHORTCUT"] = $e900dacf455c7c27$export$62ca21e37a92c063;
module.exports["CREATE_NAV_BUTTON_CLICK"] = $e900dacf455c7c27$export$6eda3121bad7aadf;
module.exports["CREATE_PAGETREE_BLOG_BUTTON_CLICK"] = $e900dacf455c7c27$export$7698b0f9c7cef133;
module.exports["InitialLoadEditSources"] = $e900dacf455c7c27$export$6e88709afea7d3ed;

});

parcelRegister("dkIiA", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
var $ee5b1a976329bd8a$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["ConfluencePageSubType"] = $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8;
module.exports["GraphQLContentStatus"] = $ee5b1a976329bd8a$export$b634e5de755b7d35;

});

parcelRegister("94z7g", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $56QzY = parcelRequire("56QzY");


var $lBYCH = parcelRequire("lBYCH");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $jmjWc = parcelRequire("jmjWc");


var $de2j9 = parcelRequire("de2j9");


var $7zgzO = parcelRequire("7zgzO");


var $gz8ZY = parcelRequire("gz8ZY");


var $3J7nf = parcelRequire("3J7nf");


var $3Yga2 = parcelRequire("3Yga2");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $7EIq6 = parcelRequire("7EIq6");


var $eB1TF = parcelRequire("eB1TF");


var $6e99h = parcelRequire("6e99h");



const $f44feda85e5453ef$var$UniversalCreateButton = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "NRUrF",
    name: "UniversalCreateButton",
    loader: async ()=>{
        if ((0, $9wGTI.fg)('navx_uc_confluence_entrypoint_enabled')) {
            const module = await (parcelRequire("3fbYy"));
            return module.UniversalCreateButtonLazy;
        } else {
            const module = await (parcelRequire("6D86p"));
            return module.default;
        }
    }
});
const $f44feda85e5453ef$var$messages = (0, $cgtv4.defineMessages)({
    create: {
        id: "create-blank-fabric-page.universal-create.create.text",
        defaultMessage: "Create"
    }
});
const $f44feda85e5453ef$export$256eebed8e934f30 = (createButtonTheme)=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...createButtonTheme.default,
                margin: 0,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ':hover': createButtonTheme.hover,
                ':focus': createButtonTheme.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && createButtonTheme.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };
const $f44feda85e5453ef$var$Create = (t0)=>{
    const $ = (0, $frIzR.c)(34);
    const { flags: flags } = t0;
    const { isOpen: isOpen } = (0, $eB1TF.useUniversalCreateState)();
    const { setIsOpen: setIsOpen, setOpenFrom: setOpenFrom } = (0, $eB1TF.useUniversalCreateActions)();
    let t1;
    if ($[0] !== setIsOpen) {
        t1 = ()=>setIsOpen(false);
        $[0] = setIsOpen;
        $[1] = t1;
    } else t1 = $[1];
    const items = (0, $6e99h.useMenuItems)(flags, t1);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { theme: theme } = (0, $42omo.useContext)((0, $lBYCH.AppNavigationContext));
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { introSpotlight: t2 } = (0, $3J7nf.useLiveDocChangeboarding)();
    const { isVisible: introSpotlightVisible } = t2;
    const { cloudId: cloudId, orgId: orgId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isCreateLiveDocEnabled: isCreateLiveDocEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const hasIteratedShownTracker = (0, $42omo.useRef)(false);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $3Yga2.checkShouldShowLozenge)();
        $[2] = t3;
    } else t3 = $[2];
    const shouldShowLozenge = t3;
    let t4;
    if ($[3] !== theme) {
        t4 = theme?.mode?.create ? $f44feda85e5453ef$export$256eebed8e934f30(theme.mode.create) : undefined;
        $[3] = theme;
        $[4] = t4;
    } else t4 = $[4];
    const buttonTheme = t4;
    let t5;
    if ($[5] !== createAnalyticsEvent || $[6] !== isCreateLiveDocEnabled || $[7] !== isNav4Enabled || $[8] !== isOnEditRoute || $[9] !== isOpen || $[10] !== match?.name || $[11] !== setIsOpen) {
        t5 = ()=>{
            if (!isOpen) {
                if (shouldShowLozenge && isCreateLiveDocEnabled && !hasIteratedShownTracker.current) {
                    (0, $3Yga2.iterateLozengeShownTracker)();
                    hasIteratedShownTracker.current = true;
                }
            }
            setIsOpen(!isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "globalCreateContentPopover",
                    source: "globalNavigation",
                    attributes: {
                        selectedItemPageContext: match?.name,
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: isNav4Enabled ? "4" : "3",
                        navdexPointType: (0, $56QzY.START),
                        isOnEditRoute: isOnEditRoute
                    }
                }
            }).fire();
        };
        $[5] = createAnalyticsEvent;
        $[6] = isCreateLiveDocEnabled;
        $[7] = isNav4Enabled;
        $[8] = isOnEditRoute;
        $[9] = isOpen;
        $[10] = match?.name;
        $[11] = setIsOpen;
        $[12] = t5;
    } else t5 = $[12];
    match?.name;
    const onCreateClick = t5;
    let t6;
    if ($[13] !== setIsOpen || $[14] !== setOpenFrom) {
        t6 = ()=>{
            setIsOpen(false);
            setOpenFrom("");
        };
        $[13] = setIsOpen;
        $[14] = setOpenFrom;
        $[15] = t6;
    } else t6 = $[15];
    const onClose = t6;
    let t7;
    if ($[16] !== introSpotlightVisible) {
        t7 = introSpotlightVisible && (0, $9wGTI.fg)("cc_modernize_ga_changeboarding");
        $[16] = introSpotlightVisible;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== cloudId || $[19] !== orgId || $[20] !== userId) {
        t8 = (0, $9wGTI.fg)("navx_uc_enable_suggestion_in_confluence") ? {
            enabled: true,
            compact: true,
            prefetch: true,
            cloudId: cloudId || "",
            orgId: orgId || "",
            accountId: userId || ""
        } : {
            enabled: false
        };
        $[18] = cloudId;
        $[19] = orgId;
        $[20] = userId;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] !== formatMessage) {
        t9 = formatMessage($f44feda85e5453ef$var$messages.create);
        $[22] = formatMessage;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== buttonTheme || $[25] !== isNav4Enabled || $[26] !== isOpen || $[27] !== items || $[28] !== onClose || $[29] !== onCreateClick || $[30] !== t7 || $[31] !== t8 || $[32] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f44feda85e5453ef$var$UniversalCreateButton, {
            items: items,
            onClick: onCreateClick,
            triggerButtonSpotlightTarget: "top-nav-create",
            enableTriggerPulse: false,
            isNav4Enabled: isNav4Enabled,
            isOpen: isOpen,
            onClose: onClose,
            product: "confluence",
            buttonTheme: buttonTheme,
            testId: "create-content-popover-button",
            preventClose: t7,
            suggestionConfig: t8,
            shouldRenderToParent: true
        }, t9);
        $[24] = buttonTheme;
        $[25] = isNav4Enabled;
        $[26] = isOpen;
        $[27] = items;
        $[28] = onClose;
        $[29] = onCreateClick;
        $[30] = t7;
        $[31] = t8;
        $[32] = t9;
        $[33] = t10;
    } else t10 = $[33];
    return t10;
};
const $f44feda85e5453ef$var$CreateWithFlags = (0, $7aRa9.withFlags)($f44feda85e5453ef$var$Create);
function $f44feda85e5453ef$export$b8b0dfc3e3d56c92() {
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).NAVX
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f44feda85e5453ef$var$CreateWithFlags, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
}
module.exports["UniversalCreate"] = $f44feda85e5453ef$export$b8b0dfc3e3d56c92;

});

parcelRegister("3J7nf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $ivb8S = parcelRequire("ivb8S");


var $gTyTP = parcelRequire("gTyTP");


var $3jwuS = parcelRequire("3jwuS");


var $8Lx5S = parcelRequire("8Lx5S");


var $1zBOs = parcelRequire("1zBOs");


var $bPDOf = parcelRequire("bPDOf");

var $9DBk6 = parcelRequire("9DBk6");


var $evORK = parcelRequire("evORK");


var $cgSxj = parcelRequire("cgSxj");


var $irr7I = parcelRequire("irr7I");

const $575144cb3db51cc4$export$7e64b0f7c7042443 = {
    introSpotlight: {
        isVisible: false,
        complete: ()=>{}
    },
    liveDocTour: {
        isVisible: false,
        complete: ()=>{}
    },
    contentWrapperTour: {
        isVisible: false,
        complete: ()=>{}
    },
    aiButtonTour: {
        isVisible: false,
        complete: ()=>{}
    }
};
const $575144cb3db51cc4$export$a26d1635f48253f6 = (changeboarding)=>Object.values(changeboarding).some((tour)=>{
        if (typeof tour === 'object' && tour !== null && 'isVisible' in tour) return tour.isVisible;
        return false;
    });
const $575144cb3db51cc4$export$bea8fd520e488fdb = ()=>{
    const [introSpotlightDismissed, setIntroSpotlightDismissed] = (0, $42omo.useState)(false);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { isAIFCOnbardingEligible: isAIFCOnbardingEligible, loading: isAIFCOnbardingEligibleLoading, error: isAIFCOnbardingEligibleError } = (0, $evORK.useIsAIFCOnbardingEligible)();
    const { isEstablishedUser: isEstablishedUser, loading: isEstablishedUserLoading, error: isEstablishedUserError } = (0, $1zBOs.useIsEstablishedUser)({
        skip: !(0, $9wGTI.fg)('cc_onboarding_changeboarding_for_live_pages_eap')
    });
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        ...Object.values((0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS)),
        ...Object.values((0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS))
    ], !(0, $9wGTI.fg)('cc_modernize_ga_changeboarding') && !(0, $9wGTI.fg)('cc_onboarding_changeboarding_for_live_pages_eap'));
    const { hasDismissedIntroSpotlight: hasDismissedIntroSpotlight, hasDismissedLiveDocTour: hasDismissedLiveDocTour, hasSeenAIFCSpotlight: hasSeenAIFCSpotlight, isAIFCSpotlightActive: isAIFCSpotlightActive } = (0, $ivb8S.deserializeState)(data);
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const isLivePagesAvailableInSpace = (0, $cgSxj.useIsLivePagesAvailableInSpace)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // AIFC onboarding is showing if the user is eligible and has not seen the spotlight or the spotlight is active
    const isAIFCOnboardingShowing = isAIFCOnbardingEligible && (!hasSeenAIFCSpotlight || isAIFCSpotlightActive);
    const introSpotlightBaseCase = !isAIFCOnboardingShowing && !introSpotlightDismissed && isLivePagesFeatureEnabled && !hasDismissedLiveDocTour && !hasDismissedIntroSpotlight && isLivePagesAvailableInSpace && !isLivePage && (isLicensed || isGuest);
    const showIntroSpotlight = introSpotlightBaseCase && !(0, $9wGTI.fg)('cc_modernize_ga_changeboarding') && (0, $9wGTI.fg)('cc_onboarding_changeboarding_for_live_pages_eap');
    const showGAIntroSpotlight = introSpotlightBaseCase && (0, $9wGTI.fg)('cc_modernize_ga_changeboarding');
    const showAiButtonTour = false;
    const { isUserEnrolledInNav4Changeboarding: isUserEnrolledInNav4Changeboarding, isUserCompletedNav4Changeboarding: isUserCompletedNav4Changeboarding, loading: nav4Loading, error: nav4Error } = (0, $irr7I.useIsNav4Changeboarding)();
    const completeIntroSpotlight = (0, $42omo.useCallback)(()=>{
        setIntroSpotlightDismissed(true);
        setOnboardingState({
            key: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedIntroSpotlight,
            value: 'true'
        });
    }, [
        setOnboardingState
    ]);
    const completeLiveDocTour = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedLiveDocTour,
            value: 'true'
        });
    }, [
        setOnboardingState
    ]);
    const completeAiButtonTour = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedAiButtonTour,
            value: 'true'
        });
    }, [
        setOnboardingState
    ]);
    // Skip onboarding for new users if features are enabled, by marking eligible onboarding as complete.
    // If we did not check to see if they were eligible for each onboarding before marking it complete,
    // we would risk marking onboarding complete when the feature is not yet enabled.
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('cc_modernize_ga_changeboarding')) return;
        if (error || loading || isEstablishedUserError || isEstablishedUserLoading || isAIFCOnbardingEligibleLoading || isAIFCOnbardingEligibleError) return;
        if (!isEstablishedUser) {
            if (showIntroSpotlight) completeIntroSpotlight();
            if (showAiButtonTour) completeAiButtonTour();
        }
    }, [
        isEstablishedUser,
        showIntroSpotlight,
        showAiButtonTour,
        completeAiButtonTour,
        completeIntroSpotlight,
        completeLiveDocTour,
        error,
        isAIFCOnbardingEligibleLoading,
        isAIFCOnbardingEligibleError,
        isEstablishedUserError,
        isEstablishedUserLoading,
        loading
    ]);
    if (error || nav4Error || isAIFCOnbardingEligibleError) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        error: error || nav4Error || isAIFCOnbardingEligibleError
    };
    if (loading || nav4Loading || isEstablishedUserLoading || isAIFCOnbardingEligibleLoading) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        loading: true
    };
    if (showGAIntroSpotlight) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        introSpotlight: {
            isVisible: true,
            complete: completeIntroSpotlight
        }
    };
    // Do not start Live Doc changeboarding until eligible user has completed nav4 changeboarding
    if (isUserEnrolledInNav4Changeboarding && !isUserCompletedNav4Changeboarding) return $575144cb3db51cc4$export$7e64b0f7c7042443;
    if (!isEstablishedUser) return $575144cb3db51cc4$export$7e64b0f7c7042443;
    if (showAiButtonTour) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        aiButtonTour: {
            isVisible: true,
            complete: completeAiButtonTour
        }
    };
    if (showIntroSpotlight) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        introSpotlight: {
            isVisible: true,
            complete: completeIntroSpotlight
        }
    };
    return $575144cb3db51cc4$export$7e64b0f7c7042443;
};
module.exports["isLiveDocChangeboardingActive"] = $575144cb3db51cc4$export$a26d1635f48253f6;
module.exports["useLiveDocChangeboarding"] = $575144cb3db51cc4$export$bea8fd520e488fdb;

});

parcelRegister("1zBOs", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $2FNNv = parcelRequire("2FNNv");


var $30D0J = parcelRequire("30D0J");

const $e4b48658f7bfd739$export$fbded7f0a0c86e5e = ({ skip: skip })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isEstablishedUserTraitName = (0, $2FNNv.useIsEstablishedUserTraitName)();
    const { data: data, loading: loading, error: error } = (0, $30D0J.useExperimentalUserPersonalizationQuery)({
        skip: skip || !userId,
        variables: {
            userId: userId ?? ''
        }
    });
    const isEstablishedUser = Boolean(data?.experimentalUserPersonalization?.attributes?.some(({ name: name, value: value })=>name === isEstablishedUserTraitName && value === 'true'));
    return {
        isEstablishedUser: isEstablishedUser,
        loading: loading,
        error: error
    };
};
module.exports["useIsEstablishedUser"] = $e4b48658f7bfd739$export$fbded7f0a0c86e5e;

});

parcelRegister("evORK", function(module, exports) {

var $dlSEv = parcelRequire("dlSEv");


var $9wGTI = parcelRequire("9wGTI");


var $kAcNG = parcelRequire("kAcNG");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $gqypm = parcelRequire("gqypm");

const $eeeb74b654b378be$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $eeeb74b654b378be$export$c71507e40f69e111 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { data: siteUserPersonalizationData, loading: siteUserPersonalizationLoading, error: siteUserPersonalizationError } = (0, $gqypm.useExperimentalSiteUserPersonalization)({
        variables: {
            cloudId: cloudId,
            userId: userId
        },
        skip: !userId || !cloudId || !isLicensed || !isRovoLLMEnabled || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')
    });
    const siteUserPersonalizationAttributes = siteUserPersonalizationData?.experimentalSiteUserPersonalization?.attributes;
    const confluenceFirstActive = siteUserPersonalizationAttributes?.find(({ name: name })=>name === $eeeb74b654b378be$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const { attributes: sitePersonalizationAttributes, loading: sitePersonalizationLoading, error: sitePersonalizationError } = (0, $kAcNG.useSitePersonalizationQuery)({
        cloudId: cloudId,
        skip: !cloudId || !isLicensed || !isRovoLLMEnabled || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')
    });
    const AIFCBetaEnrolledDateTime = sitePersonalizationAttributes?.find(({ name: name })=>name === 'confluence_aifc_enabled_datetime')?.value;
    const isExistingUserBeforeAIFCBetaEnrolled = !!confluenceFirstActive && !!AIFCBetaEnrolledDateTime && (0, $dlSEv.default)(new Date(confluenceFirstActive), new Date(AIFCBetaEnrolledDateTime));
    if (sitePersonalizationError || sitePersonalizationLoading || siteUserPersonalizationError || siteUserPersonalizationLoading || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')) return {
        isAIFCOnbardingEligible: false,
        error: sitePersonalizationError || siteUserPersonalizationError,
        loading: sitePersonalizationLoading || siteUserPersonalizationLoading
    };
    return {
        isAIFCOnbardingEligible: isExistingUserBeforeAIFCBetaEnrolled,
        loading: false
    };
};
module.exports["useIsAIFCOnbardingEligible"] = $eeeb74b654b378be$export$c71507e40f69e111;

});

parcelRegister("dlSEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b87a15bb5e36b12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9b87a15bb5e36b12$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("kAcNG", function(module, exports) {

var $8Lx5S = parcelRequire("8Lx5S");


var $1uFM6 = parcelRequire("1uFM6");


var $aMcHK = parcelRequire("aMcHK");


var $hcDKy = parcelRequire("hcDKy");

let $a3e54b7319a42934$export$98a405b08ebbac37 = false;
const $a3e54b7319a42934$export$3cfde1d6c626a865 = ({ cloudId: cloudId, skip: skip, fetchPolicy: fetchPolicy })=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const skipOptions = skip || !isLicensed || $a3e54b7319a42934$export$98a405b08ebbac37 || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined); // SitePersonalizationQuery isn't preloaded and can be skipped during SSR to avoid unnecessary requests
    const { data: data, loading: loading, error: error } = (0, $hcDKy.useExperimentalSitePersonalizationQuery)({
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: fetchPolicy || 'cache-first',
        skip: skipOptions,
        onError (apolloError) {
            $a3e54b7319a42934$export$98a405b08ebbac37 = apolloError?.graphQLErrors?.some((graphQLError)=>(0, $aMcHK.isStatusCodeError)(graphQLError, '401') || (0, $1uFM6.isUnauthorizedError)(graphQLError));
        }
    });
    const attributes = data?.experimentalSitePersonalization?.attributes || [];
    return {
        loading: loading,
        error: error,
        attributes: attributes
    };
};
module.exports["useSitePersonalizationQuery"] = $a3e54b7319a42934$export$3cfde1d6c626a865;

});

parcelRegister("hcDKy", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $c7a26f042941282d$export$f9ec68434a742b9f = ({ skip: skip, onError: onError, variables: variables, fetchPolicy: fetchPolicy })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`,
        method: 'GET',
        parseResult: (json)=>({
                experimentalSitePersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalSitePersonalizationQuery"] = $c7a26f042941282d$export$f9ec68434a742b9f;

});

parcelRegister("gqypm", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ variables: variables, skip: skip })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId, userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`,
        method: 'GET',
        variables: variables,
        parseResult: (json)=>({
                experimentalSiteUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip
    });
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("cgSxj", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $ep3mz = parcelRequire("ep3mz");


var $iLgzu = parcelRequire("iLgzu");

const $3ddccd966453cb80$export$6dd95cedb3ff0cda = ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: defaultSpaceKeyData } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)({
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    });
    const { data: enabledContentTypesData } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query useIsLivePagesAvailableInSpaceSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id key spaceTypeSettings{enabledContentTypes{isBlogsEnabled isDatabasesEnabled isEmbedsEnabled isLivePagesEnabled isWhiteboardsEnabled isFoldersEnabled}}}}`, {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    });
    return enabledContentTypesData ? enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isLivePagesEnabled : false;
};
module.exports["useIsLivePagesAvailableInSpace"] = $3ddccd966453cb80$export$6dd95cedb3ff0cda;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("irr7I", function(module, exports) {

var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $gz8ZY = parcelRequire("gz8ZY");


var $bQm3c = parcelRequire("bQm3c");


var $gqypm = parcelRequire("gqypm");

const $e18371ec7eace185$var$NAV_4_CHANGEBOARDING_ENROLLED_TRAIT = 'segment_confluence_nav_4_changeboarding_cloned_siteuser';
const $e18371ec7eace185$var$NAV_4_CHANGEBOARDING_COMPLETED_TRAIT = 'completed_cc-nav-4-changeboarding-prod';
const $e18371ec7eace185$var$isExpectedError = (error)=>{
    if ((0, $1uFM6.isUnauthorizedError)(error)) // 401s are expected when users don't have permissions
    return true;
    return false;
};
const $e18371ec7eace185$export$67ed1464307296e4 = ()=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { data: data, loading: loading, error: error } = (0, $gqypm.useExperimentalSiteUserPersonalization)({
        variables: {
            cloudId: cloudId,
            userId: userId
        },
        skip: !userId || !isNav4Enabled
    });
    if (error && $e18371ec7eace185$var$isExpectedError(error)) // Suppress error from Splunk
    (0, $7Sm4c.markErrorAsHandled)(error);
    if (!isNav4Enabled) return {
        isUserEnrolledInNav4Changeboarding: false,
        isUserCompletedNav4Changeboarding: false
    };
    const attributes = data?.experimentalSiteUserPersonalization?.attributes;
    const isUserEnrolledInNav4Changeboarding = Boolean(attributes?.some(({ name: name, value: value })=>name === $e18371ec7eace185$var$NAV_4_CHANGEBOARDING_ENROLLED_TRAIT && value === 'true'));
    const isUserCompletedNav4Changeboarding = Boolean(attributes?.some(({ name: name, value: value })=>name === $e18371ec7eace185$var$NAV_4_CHANGEBOARDING_COMPLETED_TRAIT && !!value));
    return {
        isUserEnrolledInNav4Changeboarding: isUserEnrolledInNav4Changeboarding,
        isUserCompletedNav4Changeboarding: isUserCompletedNav4Changeboarding,
        loading: loading,
        error: error
    };
};
module.exports["useIsNav4Changeboarding"] = $e18371ec7eace185$export$67ed1464307296e4;

});

parcelRegister("3Yga2", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $6mKj3 = parcelRequire("6mKj3");

const $6522d8231f11b4f4$var$MAX_TIMES_SHOWN = 3;
const $6522d8231f11b4f4$export$2dd930e418397758 = ()=>{
    if (!(0, $6mKj3.expValEquals)('confluence_hide_live_doc_lozenge', 'isEnabled', true)) return true;
    const currentValue = Number((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER));
    return currentValue < $6522d8231f11b4f4$var$MAX_TIMES_SHOWN;
};
const $6522d8231f11b4f4$export$ac038305f1d136b9 = ()=>{
    if (!(0, $6mKj3.expValEquals)('confluence_hide_live_doc_lozenge', 'isEnabled', true)) return;
    const currentValue = Number((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER));
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER, currentValue + 1);
};
const $6522d8231f11b4f4$export$78c6def31d4333a6 = ()=>{
    if (!(0, $6mKj3.expValEquals)('confluence_hide_live_doc_lozenge', 'isEnabled', true)) return;
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER, $6522d8231f11b4f4$var$MAX_TIMES_SHOWN);
};
const $6522d8231f11b4f4$export$fb6c8b2f3b8bb597 = ()=>{
    if (!(0, $6mKj3.expValEquals)('confluence_hide_live_doc_lozenge', 'isEnabled', true)) return;
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER, 0);
};
module.exports["checkShouldShowLozenge"] = $6522d8231f11b4f4$export$2dd930e418397758;
module.exports["iterateLozengeShownTracker"] = $6522d8231f11b4f4$export$ac038305f1d136b9;
module.exports["setLozengeShownTrackerMax"] = $6522d8231f11b4f4$export$78c6def31d4333a6;

});

parcelRegister("7EIq6", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $jtuBN = parcelRequire("jtuBN");


var $iLgzu = parcelRequire("iLgzu");


var $7NtNc = parcelRequire("7NtNc");

const $649b778bbd82b1bb$export$1defcb29347f9ac6 = (spaceKey)=>{
    const $ = (0, $frIzR.c)(15);
    const t0 = spaceKey !== undefined;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== t0) {
        t2 = {
            skip: t0,
            variables: t1
        };
        $[1] = t0;
        $[2] = t2;
    } else t2 = $[2];
    const { data: defaultSpaceKeyData } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)(t2);
    const t3 = !spaceKey && !defaultSpaceKeyData;
    const t4 = spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id;
    let t5;
    if ($[3] !== t4) {
        t5 = {
            spaceKey: t4
        };
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== t3 || $[6] !== t5) {
        t6 = {
            errorPolicy: "all",
            skip: t3,
            variables: t5
        };
        $[5] = t3;
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    const spaceEnabledContentTypesQueryOptions = t6;
    const { data: enabledContentTypesData } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $7NtNc.SpaceEnabledContentTypesQuery), spaceEnabledContentTypesQueryOptions);
    const isCreateWhiteboardEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isWhiteboardsEnabled);
    const isCreateBlogEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isBlogsEnabled);
    const isCreateDatabaseEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isDatabasesEnabled);
    const isCreateSmartLinkEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isEmbedsEnabled);
    const isCreateLiveDocEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isLivePagesEnabled);
    const isCreateFolderEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isFoldersEnabled);
    let t7;
    if ($[8] !== isCreateBlogEnabled || $[9] !== isCreateDatabaseEnabled || $[10] !== isCreateFolderEnabled || $[11] !== isCreateLiveDocEnabled || $[12] !== isCreateSmartLinkEnabled || $[13] !== isCreateWhiteboardEnabled) {
        t7 = {
            isCreateWhiteboardEnabled: isCreateWhiteboardEnabled,
            isCreateBlogEnabled: isCreateBlogEnabled,
            isCreateDatabaseEnabled: isCreateDatabaseEnabled,
            isCreateSmartLinkEnabled: isCreateSmartLinkEnabled,
            isCreateLiveDocEnabled: isCreateLiveDocEnabled,
            isCreateFolderEnabled: isCreateFolderEnabled
        };
        $[8] = isCreateBlogEnabled;
        $[9] = isCreateDatabaseEnabled;
        $[10] = isCreateFolderEnabled;
        $[11] = isCreateLiveDocEnabled;
        $[12] = isCreateSmartLinkEnabled;
        $[13] = isCreateWhiteboardEnabled;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
};
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("7NtNc", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $ada047e01258ab08$export$a08098e2700d7e94 = (0, $eSUdr.default)`query SpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id key spaceTypeSettings{enabledContentTypes{isBlogsEnabled isDatabasesEnabled isEmbedsEnabled isLivePagesEnabled isWhiteboardsEnabled isFoldersEnabled}}}}`;
module.exports["SpaceEnabledContentTypesQuery"] = $ada047e01258ab08$export$a08098e2700d7e94;

});

parcelRegister("eB1TF", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $bf0e479659c73d50$var$initialState = {
    isOpen: false,
    openFrom: ''
};
const $bf0e479659c73d50$var$actions = {
    setIsOpen: (isOpen)=>({ setState: setState })=>{
            setState({
                isOpen: isOpen
            });
        },
    setOpenFrom: (openFrom)=>({ setState: setState })=>{
            setState({
                openFrom: openFrom
            });
        }
};
const $bf0e479659c73d50$var$Store = (0, $1P1Tu.createStore)({
    initialState: $bf0e479659c73d50$var$initialState,
    actions: $bf0e479659c73d50$var$actions,
    name: 'UniversalCreateStore'
});
const $bf0e479659c73d50$export$c7381b2490bb4d36 = (0, $9zUhf.createStateHook)($bf0e479659c73d50$var$Store);
const $bf0e479659c73d50$export$6c5b9a107b000099 = (0, $9zUhf.createActionsHook)($bf0e479659c73d50$var$Store);
module.exports["useUniversalCreateState"] = $bf0e479659c73d50$export$c7381b2490bb4d36;
module.exports["useUniversalCreateActions"] = $bf0e479659c73d50$export$6c5b9a107b000099;

});

parcelRegister("6e99h", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $de2j9 = parcelRequire("de2j9");


var $dPJCf = parcelRequire("dPJCf");


var $3jwuS = parcelRequire("3jwuS");


var $56QzY = parcelRequire("56QzY");


var $ep3mz = parcelRequire("ep3mz");


var $1KBSi = parcelRequire("1KBSi");


var $yuLaV = parcelRequire("yuLaV");


var $9wGTI = parcelRequire("9wGTI");


var $kDja4 = parcelRequire("kDja4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7EIq6 = parcelRequire("7EIq6");


var $fSDMD = parcelRequire("fSDMD");


var $jrwID = parcelRequire("jrwID");


var $dAC7y = parcelRequire("dAC7y");


var $ejGOi = parcelRequire("ejGOi");


var $3LivB = parcelRequire("3LivB");


var $1OVup = parcelRequire("1OVup");


var $fw6FY = parcelRequire("fw6FY");


var $4e5hr = parcelRequire("4e5hr");


var $8hdRZ = parcelRequire("8hdRZ");


var $a26i4 = parcelRequire("a26i4");

const $279d18c421fdc96b$var$ANALYTICS_EVENT_SOURCE = 'globalCreateContentPopover';
const $279d18c421fdc96b$var$messages = (0, $cgtv4.defineMessages)({
    // eslint-disable-next-line @atlassian/i18n/require-description
    moreFromAtlassian: {
        id: "create-blank-fabric-page.universal-create.suggestions",
        defaultMessage: "Suggestions"
    }
});
function $279d18c421fdc96b$export$aad046bd9909db8f(flags, closeMenu, openFrom) {
    const $ = (0, $frIzR.c)(76);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== isLivePage || $[2] !== isOnEditRoute || $[3] !== openFrom || $[4] !== routeDataRef) {
        t0 = (actionSubjectId, attributes)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: actionSubjectId,
                    source: $279d18c421fdc96b$var$ANALYTICS_EVENT_SOURCE,
                    attributes: {
                        navdexPointType: (0, $56QzY.END),
                        isOnEditRoute: isOnEditRoute,
                        currentRouteName: routeDataRef?.current?.routeName,
                        currentRouteIsLive: isLivePage,
                        openFrom: openFrom,
                        ...attributes
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isLivePage;
        $[2] = isOnEditRoute;
        $[3] = openFrom;
        $[4] = routeDataRef;
        $[5] = t0;
    } else t0 = $[5];
    const handleAnalyticsAndResetStickySearch = t0;
    let t1;
    if ($[6] !== closeMenu || $[7] !== handleAnalyticsAndResetStickySearch) {
        t1 = (actionSubjectId_0, attributes_0)=>{
            handleAnalyticsAndResetStickySearch(actionSubjectId_0, attributes_0);
            closeMenu?.();
        };
        $[6] = closeMenu;
        $[7] = handleAnalyticsAndResetStickySearch;
        $[8] = t1;
    } else t1 = $[8];
    const onClick = t1;
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled, isCreateBlogEnabled: isCreateBlogEnabled, isCreateLiveDocEnabled: isCreateLiveDocEnabled, isCreateDatabaseEnabled: isCreateDatabaseEnabled, isCreateSmartLinkEnabled: isCreateSmartLinkEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const { canCreateSpace: canCreateSpace } = (0, $1KBSi.useCanCreateSpace)();
    const isLoomEntryPointEnabled = (0, $fSDMD.useIsCreateMenuLoomRecorderEntryPointEnabled)();
    let t2;
    if ($[9] !== contentId || $[10] !== onClick || $[11] !== spaceKey) {
        t2 = {
            source: "globalCreateDropdown-liveDoc",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[9] = contentId;
        $[10] = onClick;
        $[11] = spaceKey;
        $[12] = t2;
    } else t2 = $[12];
    const liveDoc = (0, $jrwID.useLiveDocItem)(t2);
    let t3;
    if ($[13] !== contentId || $[14] !== onClick || $[15] !== spaceKey) {
        t3 = {
            source: "globalCreateDropdown-page",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[13] = contentId;
        $[14] = onClick;
        $[15] = spaceKey;
        $[16] = t3;
    } else t3 = $[16];
    const page = (0, $dAC7y.usePageItem)(t3);
    let t4;
    if ($[17] !== contentId || $[18] !== onClick || $[19] !== spaceKey) {
        t4 = {
            source: "globalCreateDropdown-whiteboard",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[17] = contentId;
        $[18] = onClick;
        $[19] = spaceKey;
        $[20] = t4;
    } else t4 = $[20];
    const whiteboard = (0, $ejGOi.useWhiteboardItem)(t4);
    let t5;
    if ($[21] !== contentId || $[22] !== onClick || $[23] !== spaceKey) {
        t5 = {
            source: "globalCreateDropdown-database",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[21] = contentId;
        $[22] = onClick;
        $[23] = spaceKey;
        $[24] = t5;
    } else t5 = $[24];
    const database = (0, $3LivB.useDatabaseItem)(t5);
    let t6;
    if ($[25] !== contentId || $[26] !== onClick || $[27] !== spaceKey) {
        t6 = {
            source: "globalCreateDropdown-blog",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[25] = contentId;
        $[26] = onClick;
        $[27] = spaceKey;
        $[28] = t6;
    } else t6 = $[28];
    const blog = (0, $1OVup.useBlogItem)(t6);
    let t7;
    if ($[29] !== contentId || $[30] !== onClick || $[31] !== spaceKey) {
        t7 = {
            source: "globalCreateDropdown-smartLinkEmbed",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[29] = contentId;
        $[30] = onClick;
        $[31] = spaceKey;
        $[32] = t7;
    } else t7 = $[32];
    const embed = (0, $fw6FY.useEmbedItem)(t7);
    let t8;
    if ($[33] !== contentId || $[34] !== flags || $[35] !== onClick || $[36] !== spaceKey) {
        t8 = {
            source: "globalCreateDropdown-smartLinkEmbed",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick,
            flags: flags
        };
        $[33] = contentId;
        $[34] = flags;
        $[35] = onClick;
        $[36] = spaceKey;
        $[37] = t8;
    } else t8 = $[37];
    const loom = (0, $8hdRZ.useLoomItem)(t8);
    let t9;
    if ($[38] !== contentId || $[39] !== onClick || $[40] !== spaceKey) {
        t9 = {
            source: $279d18c421fdc96b$var$ANALYTICS_EVENT_SOURCE,
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[38] = contentId;
        $[39] = onClick;
        $[40] = spaceKey;
        $[41] = t9;
    } else t9 = $[41];
    const space = (0, $4e5hr.useSpaceItem)(t9);
    let t10;
    if ($[42] !== onClick || $[43] !== openFrom || $[44] !== spaceKey) {
        t10 = {
            source: "globalCreateDropdown-smartCreate",
            spaceKey: spaceKey,
            onClick: onClick,
            openFrom: openFrom
        };
        $[42] = onClick;
        $[43] = openFrom;
        $[44] = spaceKey;
        $[45] = t10;
    } else t10 = $[45];
    const smartCreate = (0, $a26i4.useAISmartCreateItem)(t10);
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    let t11;
    if ($[46] !== isWhiteboardFeatureEnabled) {
        t11 = isWhiteboardFeatureEnabled("whiteboardOptOut");
        $[46] = isWhiteboardFeatureEnabled;
        $[47] = t11;
    } else t11 = $[47];
    const isOptedOutedOfWhiteboards = t11;
    let t12;
    if ($[48] !== isWhiteboardFeatureEnabled) {
        t12 = isWhiteboardFeatureEnabled("whiteboardsEnabled");
        $[48] = isWhiteboardFeatureEnabled;
        $[49] = t12;
    } else t12 = $[49];
    const isWhiteboardsEnabled = t12;
    const whiteboardOptIn = !isOptedOutedOfWhiteboards && isWhiteboardsEnabled;
    let t13;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)("database") && !(0, $9wGTI.fg)("confluence_frontend_databases_opt-out");
        $[50] = t13;
    } else t13 = $[50];
    const databaseOptIn = t13;
    const isAnonymousUser = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || !isLoggedIn;
    let t14;
    if ($[51] !== blog || $[52] !== canCreateSpace || $[53] !== database || $[54] !== embed || $[55] !== isAnonymousUser || $[56] !== isCreateBlogEnabled || $[57] !== isCreateDatabaseEnabled || $[58] !== isCreateLiveDocEnabled || $[59] !== isCreateSmartLinkEnabled || $[60] !== isCreateWhiteboardEnabled || $[61] !== isRovoLLMEnabled || $[62] !== liveDoc || $[63] !== page || $[64] !== smartCreate || $[65] !== space || $[66] !== whiteboard || $[67] !== whiteboardOptIn) {
        const getNativeItems = ()=>{
            const isAifcEnabled = isRovoLLMEnabled && !isAnonymousUser && (0, $9wGTI.fg)("aifc_create_enabled");
            return {
                items: [
                    ...isAifcEnabled ? [
                        smartCreate
                    ] : [],
                    ...isCreateLiveDocEnabled ? [
                        liveDoc
                    ] : [],
                    page,
                    ...isCreateWhiteboardEnabled && whiteboardOptIn ? [
                        whiteboard
                    ] : [],
                    ...isCreateDatabaseEnabled && databaseOptIn ? [
                        database
                    ] : [],
                    ...isCreateBlogEnabled ? [
                        blog
                    ] : [],
                    ...isCreateSmartLinkEnabled ? [
                        embed
                    ] : [],
                    ...canCreateSpace ? [
                        space
                    ] : []
                ]
            };
        };
        t14 = getNativeItems();
        $[51] = blog;
        $[52] = canCreateSpace;
        $[53] = database;
        $[54] = embed;
        $[55] = isAnonymousUser;
        $[56] = isCreateBlogEnabled;
        $[57] = isCreateDatabaseEnabled;
        $[58] = isCreateLiveDocEnabled;
        $[59] = isCreateSmartLinkEnabled;
        $[60] = isCreateWhiteboardEnabled;
        $[61] = isRovoLLMEnabled;
        $[62] = liveDoc;
        $[63] = page;
        $[64] = smartCreate;
        $[65] = space;
        $[66] = whiteboard;
        $[67] = whiteboardOptIn;
        $[68] = t14;
    } else t14 = $[68];
    const menuItems = [
        t14
    ];
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (isCreateSmartLinkEnabled && isLoomEntryPointEnabled) {
        let t15;
        if ($[69] !== formatMessage) {
            t15 = formatMessage($279d18c421fdc96b$var$messages.moreFromAtlassian);
            $[69] = formatMessage;
            $[70] = t15;
        } else t15 = $[70];
        let t16;
        if ($[71] !== loom) {
            t16 = [
                loom
            ];
            $[71] = loom;
            $[72] = t16;
        } else t16 = $[72];
        let t17;
        if ($[73] !== t15 || $[74] !== t16) {
            t17 = {
                heading: t15,
                items: t16
            };
            $[73] = t15;
            $[74] = t16;
            $[75] = t17;
        } else t17 = $[75];
        menuItems.push(t17);
    }
    return menuItems;
}
module.exports["useMenuItems"] = $279d18c421fdc96b$export$aad046bd9909db8f;

});

parcelRegister("1KBSi", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $fEhQK = parcelRequire("fEhQK");

const $15029de520f1b9e8$export$cadd7e072478f5e = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(6);
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const t0 = !isLicensed;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            skip: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { data: canCreateData } = (0, $jMyy4.useQueryInterop)((0, $fEhQK.default), t1);
    let t2;
    if ($[2] !== canCreateData?.user?.confluence?.operations) {
        t2 = canCreateData?.user?.confluence?.operations.some($15029de520f1b9e8$var$_temp);
        $[2] = canCreateData?.user?.confluence?.operations;
        $[3] = t2;
    } else t2 = $[3];
    const canCreateSpace = Boolean(t2);
    let t3;
    if ($[4] !== canCreateSpace) {
        t3 = {
            canCreateSpace: canCreateSpace
        };
        $[4] = canCreateSpace;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ()=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { data: canCreateData } = (0, $jMyy4.useQueryInterop)(// Due to circular dependency issues we are using the PreloadCreateSpaceQuery from create-space-preload package
    (0, $fEhQK.default), {
        skip: !isLicensed
    });
    const canCreateSpace = Boolean(canCreateData?.user?.confluence?.operations.some((obj)=>obj?.operation === 'create_space'));
    return {
        canCreateSpace: canCreateSpace
    };
};
function $15029de520f1b9e8$var$_temp(obj) {
    return obj?.operation === "create_space";
}
module.exports["useCanCreateSpace"] = $15029de520f1b9e8$export$cadd7e072478f5e;

});

parcelRegister("fSDMD", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $2Yaht = parcelRequire("2Yaht");


var $cQDYl = parcelRequire("cQDYl");


var $7hpmn = parcelRequire("7hpmn");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $jojoK = parcelRequire("jojoK");


var $lKj5W = parcelRequire("lKj5W");


var $7aRa9 = parcelRequire("7aRa9");


var $4R3wx = parcelRequire("4R3wx");


var $9uAPw = parcelRequire("9uAPw");


var $dPJCf = parcelRequire("dPJCf");


var $7QM6o = parcelRequire("7QM6o");


var $8fj5s = parcelRequire("8fj5s");


var $lqy4C = parcelRequire("lqy4C");


var $9wGTI = parcelRequire("9wGTI");


var $bZSO8 = parcelRequire("bZSO8");


var $h7OOD = parcelRequire("h7OOD");


var $5Krdf = parcelRequire("5Krdf");

const $30211231850ecfc1$var$i18n = (0, $cgtv4.defineMessages)({
    openingLoomRecorder: {
        id: "create-blank-fabric-page.create.content.loom-video.opening-loom-recorder",
        defaultMessage: "Opening Loom recorder"
    },
    loomVideoTitle: {
        id: "create-blank-fabric-page.create.content.loom-video.title",
        defaultMessage: "Loom video"
    }
});
const $30211231850ecfc1$var$iconWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexShrink: 0
});
const $30211231850ecfc1$export$fb281ae10f502d32 = ()=>{
    const $ = (0, $frIzR.c)(1);
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "BETA",
            "CO_USE",
            "CROSS_JOIN"
        ];
        $[0] = t0;
    } else t0 = $[0];
    return t0.includes(entryPointVariant);
};
const $30211231850ecfc1$var$RecordLoomPopoverItemComponent = (t0)=>{
    const $ = (0, $frIzR.c)(40);
    const { entryPointLocation: entryPointLocation, flags: flags, onClick: onClick, onRecorderOpenComplete: onRecorderOpenComplete, source: source, spaceKey: spaceKey, parentId: parentId, withFallback: t1, isDisabled: t2, location: t3 } = t0;
    const withFallback = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const location = t3 === undefined ? "" : t3;
    const intl = (0, $8C5kA.default)();
    const prefersReducedMotion = (0, $7hpmn.useIsReducedMotion)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const [isGASpotlightOpen, setIsGASpotlightOpen] = (0, $42omo.useState)(true);
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            source: "record-loom-popover-item"
        };
        $[0] = t4;
    } else t4 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t4);
    const prevIsOpeningRecorder = (0, $42omo.useRef)(false);
    let t5;
    if ($[1] !== entryPointLocation || $[2] !== flags) {
        t5 = {
            entryPointLocation: entryPointLocation,
            flags: flags
        };
        $[1] = entryPointLocation;
        $[2] = flags;
        $[3] = t5;
    } else t5 = $[3];
    const { openLoomRecorder: openLoomRecorder, isLoomRecorderInitialized: isLoomRecorderInitialized, isOpeningRecorder: isOpeningRecorder, hasRecordingAccess: hasRecordingAccess } = (0, $9uAPw.useLoomRecorderEntryPoint)(t5);
    let t6;
    if ($[4] !== hasRecordingAccess || $[5] !== isLoomRecorderInitialized) {
        t6 = isLoomRecorderInitialized && hasRecordingAccess && (0, $9wGTI.fg)("confluence_m25_onboarding_spotlights");
        $[4] = hasRecordingAccess;
        $[5] = isLoomRecorderInitialized;
        $[6] = t6;
    } else t6 = $[6];
    const shouldShowLoomGAOnboarding = t6;
    const [isLoomGAOnboardingActive, stopLoomGAOnboarding] = (0, $8fj5s.useSkippableCoordination)("cc-loom-onboarding-spotlight-creation", !shouldShowLoomGAOnboarding || shouldBlockCreate);
    let t7;
    let t8;
    if ($[7] !== isOpeningRecorder || $[8] !== onRecorderOpenComplete) {
        t7 = ()=>{
            if (prevIsOpeningRecorder.current && !isOpeningRecorder) onRecorderOpenComplete?.();
            prevIsOpeningRecorder.current = isOpeningRecorder;
        };
        t8 = [
            isOpeningRecorder,
            onRecorderOpenComplete
        ];
        $[7] = isOpeningRecorder;
        $[8] = onRecorderOpenComplete;
        $[9] = t7;
        $[10] = t8;
    } else {
        t7 = $[9];
        t8 = $[10];
    }
    (0, $42omo.useEffect)(t7, t8);
    let t9;
    if ($[11] !== isLoomGAOnboardingActive || $[12] !== stopLoomGAOnboarding) {
        t9 = ()=>{
            if (isLoomGAOnboardingActive) {
                setIsGASpotlightOpen(false);
                stopLoomGAOnboarding();
            }
        };
        $[11] = isLoomGAOnboardingActive;
        $[12] = stopLoomGAOnboarding;
        $[13] = t9;
    } else t9 = $[13];
    const handleSpotlightClose = t9;
    let t10;
    if ($[14] !== createAnalyticsEvent || $[15] !== location || $[16] !== onClick || $[17] !== openLoomRecorder || $[18] !== parentId || $[19] !== push || $[20] !== source || $[21] !== spaceId || $[22] !== spaceKey || $[23] !== withFallback) {
        t10 = ()=>{
            onClick("createLoomPopoverItem");
            openLoomRecorder({
                onInsert: (videoUrl)=>{
                    const createUrl = (0, $bZSO8.buildCreationLink)({
                        contentType: "smartLinkEmbed",
                        parentPageId: parentId,
                        ...withFallback && {
                            withFallback: withFallback
                        },
                        smartLinkCreateSource: "loomRecordSDK",
                        smartLinkEmbedUrl: videoUrl,
                        source: source,
                        spaceKey: spaceKey
                    });
                    push(createUrl);
                    (0, $jojoK.getHashedLoomVideoIdFromUrl)(videoUrl).then((hashedVideoId)=>{
                        createAnalyticsEvent({
                            type: "sendTrackEvent",
                            data: {
                                action: "insertVideo",
                                actionSubject: "loom",
                                source: source,
                                objectType: "embed",
                                containerType: "space",
                                containerId: spaceId,
                                attributes: {
                                    location: "contentTreeItem",
                                    video_id: hashedVideoId
                                }
                            }
                        }).fire();
                    });
                },
                insertButtonText: "Insert video",
                location: location
            });
        };
        $[14] = createAnalyticsEvent;
        $[15] = location;
        $[16] = onClick;
        $[17] = openLoomRecorder;
        $[18] = parentId;
        $[19] = push;
        $[20] = source;
        $[21] = spaceId;
        $[22] = spaceKey;
        $[23] = withFallback;
        $[24] = t10;
    } else t10 = $[24];
    const handleClick = t10;
    let t11;
    if ($[25] !== enforceStorageLimit || $[26] !== handleClick) {
        t11 = enforceStorageLimit(handleClick);
        $[25] = enforceStorageLimit;
        $[26] = handleClick;
        $[27] = t11;
    } else t11 = $[27];
    const handleClickWithStorageEnforcement = t11;
    let t12;
    if ($[28] !== handleClickWithStorageEnforcement || $[29] !== intl || $[30] !== isDisabled || $[31] !== isLoomRecorderInitialized || $[32] !== isOpeningRecorder || $[33] !== prefersReducedMotion) {
        t12 = !isLoomRecorderInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Krdf.MenuItemWrapper), {
            isDisabled: isDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cQDYl.default), {
            hasIcon: true,
            isShimmering: !prefersReducedMotion,
            testId: "skeleton-create-menu-button-item"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Krdf.MenuItemWrapper), {
            isDisabled: isDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h7OOD.LoadingPopoverItem), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Krdf.ContentIconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $30211231850ecfc1$var$iconWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)"
            }))),
            isLoading: isOpeningRecorder,
            loadingLabel: intl.formatMessage($30211231850ecfc1$var$i18n.openingLoomRecorder),
            onClick: handleClickWithStorageEnforcement,
            testId: "create-menu-button-item",
            isDisabled: isDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Krdf.TitleContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Krdf.ContentTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $30211231850ecfc1$var$i18n.loomVideoTitle)))));
        $[28] = handleClickWithStorageEnforcement;
        $[29] = intl;
        $[30] = isDisabled;
        $[31] = isLoomRecorderInitialized;
        $[32] = isOpeningRecorder;
        $[33] = prefersReducedMotion;
        $[34] = t12;
    } else t12 = $[34];
    const menuItem = t12;
    if (shouldShowLoomGAOnboarding && isLoomGAOnboardingActive && isGASpotlightOpen) {
        let t13;
        if ($[35] !== handleClickWithStorageEnforcement || $[36] !== handleSpotlightClose || $[37] !== menuItem || $[38] !== source) {
            t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lKj5W.RecordLoomPopoverItemSpotlight), {
                onRecord: handleClickWithStorageEnforcement,
                onClose: handleSpotlightClose,
                source: source
            }, menuItem);
            $[35] = handleClickWithStorageEnforcement;
            $[36] = handleSpotlightClose;
            $[37] = menuItem;
            $[38] = source;
            $[39] = t13;
        } else t13 = $[39];
        return t13;
    }
    return menuItem;
};
const $30211231850ecfc1$export$4d5ee8c1efd60993 = (0, $7aRa9.withFlags)($30211231850ecfc1$var$RecordLoomPopoverItemComponent);
module.exports["useIsCreateMenuLoomRecorderEntryPointEnabled"] = $30211231850ecfc1$export$fb281ae10f502d32;
module.exports["RecordLoomPopoverItem"] = $30211231850ecfc1$export$4d5ee8c1efd60993;

});

parcelRegister("cQDYl", function(module, exports) {
/* skeleton-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $e0b2ee147542345d$var$skeletonItemElemSize = 20;
const $e0b2ee147542345d$var$N20A = 'rgba(9, 30, 66, 0.04)';
const $e0b2ee147542345d$var$N30A = 'rgba(9, 30, 66, 0.08)';
const $e0b2ee147542345d$var$styles = {
    root: "_1rjcze3t _18zrv47k _1e0c1txw _1tke1ylp _4cvr1h6o _lcxvglyw _14mj53f4 _1qdgrdoj _1hfkizff _aetrb3bt _3mxot94y",
    defaultWidth: "_sf1e1n8h _4rfy1ssb _baud1nrf _mr7o1vuk _69tq19wn _kt4d1n05",
    customWidth: "_11w8rzut",
    beforeElement: "_1mp4gktf _kfgtgktf _7bjqidpf _1rusizff _1kt9b3bt _1mbqdlk8 _1rhxv77o",
    avatar: "_rfx31rr0",
    icon: "_rfx3fajl",
    sideNavSkeleton: "_18zru2gc _kfgt1k8s _1mbqpxbi _1mp41k8s"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ const $e0b2ee147542345d$var$shimmerKeyframes = null; /**
                                * These styles are defined using `css` rather than `cssMap` as there is a bug when using
                                * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
                                */ 
const $e0b2ee147542345d$var$shimmerStyles = null; /**
                             * __Skeleton item__
                             *
                             * A skeleton item is used in place of an item when its contents it not ready.
                             *
                             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
                             * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                             */ 
const $e0b2ee147542345d$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, isSideNavSkeleton: isSideNavSkeleton = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $e0b2ee147542345d$var$styles.root,
            (hasAvatar || hasIcon) && $e0b2ee147542345d$var$styles.beforeElement,
            hasAvatar && $e0b2ee147542345d$var$styles.avatar,
            hasIcon && $e0b2ee147542345d$var$styles.icon,
            width ? $e0b2ee147542345d$var$styles.customWidth : $e0b2ee147542345d$var$styles.defaultWidth,
            isSideNavSkeleton && $e0b2ee147542345d$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_unfq1yy8 _9nev1yy8 _kwc012o8 _joxl12o8 _18f312c5 _evp612c5 _19oh1254 _10881254 _18lgp3kn _zo24p3kn _1hfkizff _1rusizff",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-testid": testId
    });
};
var $e0b2ee147542345d$export$2e2bcd8739ae039 = $e0b2ee147542345d$var$SkeletonItem;
module.exports["default"] = $e0b2ee147542345d$export$2e2bcd8739ae039;

});

parcelRegister("jojoK", function(module, exports) {
const $6eadce97261b744f$var$LOOM_URL_REGEX = // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})");
function $6eadce97261b744f$var$extractLoomVideoId(url) {
    const match = url.match($6eadce97261b744f$var$LOOM_URL_REGEX);
    return match?.groups?.videoId;
}
async function $6eadce97261b744f$var$digestMessage(message) {
    // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
    if (window?.crypto?.subtle?.digest) {
        const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
        const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgUint8); // hash the message
        const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
        const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
        return hashHex;
    }
    return '';
}
async function $6eadce97261b744f$export$495fb2ecc80ca6c0(url) {
    try {
        const videoId = $6eadce97261b744f$var$extractLoomVideoId(url);
        if (videoId) {
            const data = atob('c2U1UTwgekZlVEYkP1MzRno1QmV5WXBoSE13SHg8RWpjM10saHJQZmhPMVVHKHM=') + videoId;
            const digestHex = await $6eadce97261b744f$var$digestMessage(data);
            return digestHex ? `vidhash-${digestHex}` : '';
        }
        return '';
    } catch (_) {
        return '';
    }
}
module.exports["getHashedLoomVideoIdFromUrl"] = $6eadce97261b744f$export$495fb2ecc80ca6c0;

});

parcelRegister("lKj5W", function(module, exports) {
/* RecordLoomPopoverItemSpotlight.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $7hpmn = parcelRequire("7hpmn");


var $5RBJ9 = parcelRequire("5RBJ9");

var $6cnUO = parcelRequire("6cnUO");

var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");


var $inPa6 = parcelRequire("inPa6");


var $kEpoS = parcelRequire("kEpoS");

const $d76519bfc34d877a$var$i18n = (0, $cgtv4.defineMessages)({
    body: {
        id: "loom-onboarding.create.content.spotlight.body",
        defaultMessage: "Explain the context for this page once with shareable, async video."
    },
    globalCreateBody: {
        id: "loom-onboarding.create.content.globalCreate.spotlight.body",
        defaultMessage: "Record a walkthrough of this page to share updates and progress."
    },
    dismissButton: {
        id: "loom-onboarding.create.content.spotlight.dismissButton",
        defaultMessage: "Dismiss"
    },
    recordButton: {
        id: "loom-onboarding.create.content.spotlight.recordButton",
        defaultMessage: "Record"
    }
});
// Backup outline in case we disable the spotlight pulse for a11y reasons
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $d76519bfc34d877a$var$SpotlightTargetContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1qi0 _16qs1peg",
            __cmplp.className
        ])
    });
});
const $d76519bfc34d877a$var$GA_SCREEN_NAME = 'recordLoomGAPopoverItemSpotlight';
const $d76519bfc34d877a$export$12f8cc70e5dbb118 = ({ children: children, onRecord: onRecord, onClose: onClose, source: source, shouldWatchTarget: shouldWatchTarget })=>{
    const isReducedMotion = (0, $7hpmn.useIsReducedMotion)();
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spotlightTargetRef = (0, $42omo.useRef)(null);
    const isClosed = (0, $42omo.useRef)(false);
    const close = (0, $42omo.useCallback)(()=>{
        if (!isClosed.current) {
            isClosed.current = true;
            onClose?.();
        }
    }, [
        onClose
    ]);
    // Call `onClose()` when this component unmounts if it wasn't already closed in order to catch when the spotlight
    // disappears if users click outside of it. This is important because we need the parent to know when to call `stop()`
    // for the EP message so we don't block other onboarding from appearing for 5 min (the default expiration time)
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            close();
        };
    }, [
        close
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: $d76519bfc34d877a$var$GA_SCREEN_NAME,
                attributes: {
                    nudgeSource: source
                }
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismiss',
                source: $d76519bfc34d877a$var$GA_SCREEN_NAME,
                attributes: {
                    nudgeSource: source
                }
            }
        }).fire();
        close();
    }, [
        close,
        createAnalyticsEvent,
        source
    ]);
    const handleTryIt = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'record',
                source: $d76519bfc34d877a$var$GA_SCREEN_NAME,
                attributes: {
                    nudgeSource: source
                }
            }
        }).fire();
        onRecord?.();
        close();
    }, [
        onRecord,
        close,
        createAnalyticsEvent,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), {
        onBlanketClicked: handleDismiss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "create-menu-item-loom-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d76519bfc34d877a$var$SpotlightTargetContainer, {
        ref: spotlightTargetRef
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5RBJ9.default), {
        target: "create-menu-item-loom-spotlight",
        targetBgColor: "var(--ds-text-inverse, #FFFFFF)",
        pulse: !isReducedMotion,
        targetRadius: 4,
        dialogPlacement: "right bottom",
        dialogWidth: 275,
        shouldWatchTarget: shouldWatchTarget,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($kEpoS))),
        actions: [
            {
                onClick: handleTryIt,
                text: intl.formatMessage($d76519bfc34d877a$var$i18n.recordButton)
            },
            {
                onClick: handleDismiss,
                text: intl.formatMessage($d76519bfc34d877a$var$i18n.dismissButton)
            }
        ]
    }, source == 'globalCreateDropdown-smartLinkEmbed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d76519bfc34d877a$var$i18n.globalCreateBody) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d76519bfc34d877a$var$i18n.body))));
};
module.exports["RecordLoomPopoverItemSpotlight"] = $d76519bfc34d877a$export$12f8cc70e5dbb118;

});

parcelRegister("kEpoS", function(module, exports) {
module.exports = new URL("createSpotlightImage.f64dc988.png", import.meta.url).toString();

});

parcelRegister("4R3wx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $9wGTI = parcelRequire("9wGTI");


var $932VV = parcelRequire("932VV");


var $cYe4v = parcelRequire("cYe4v");


var $dpJII = parcelRequire("dpJII");


var $eNjW4 = parcelRequire("eNjW4");

const $c8aabf9b2e3d2d10$export$62184c98af916d7a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(10);
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    let t0;
    if ($[0] !== isBetaEnabled || $[1] !== isLoomDisabled || $[2] !== isLoomEntryPointsEnabled) {
        t0 = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell");
        $[0] = isBetaEnabled;
        $[1] = isLoomDisabled;
        $[2] = isLoomEntryPointsEnabled;
        $[3] = t0;
    } else t0 = $[3];
    const skipPermsCheck = t0;
    const t1 = skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t2;
    if ($[4] !== t1) {
        t2 = {
            skip: t1
        };
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)(t2);
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) {
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    if (isBetaEnabled) {
        let t3;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "BETA"
            };
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    if (!(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell")) {
        let t3;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    if (loomEntryPointVariant.entryPointVariant === "CROSS_FLOW" && (0, $9wGTI.fg)("confluence_frontend_loom_cross_flow_ads_opt_out")) {
        let t3;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    return loomEntryPointVariant;
} : ()=>{
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    // This can be replaced entirely by `isLoomDisabled` once Loom Beta is cleaned up
    const skipPermsCheck = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell');
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)({
        // If the entry point variant has been SSRd, use that result and skip the permissions check
        skip: skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    // If the entry point already exists via SSR, return that value in the hook here (no need to check anything else)
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) return {
        entryPointVariant: 'DISABLED'
    };
    if (isBetaEnabled) return {
        entryPointVariant: 'BETA'
    };
    // This should be moved into useIsLoomDisabled once Loom Beta is cleaned up.
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) return {
        entryPointVariant: 'DISABLED'
    };
    if (loomEntryPointVariant.entryPointVariant === 'CROSS_FLOW' && (0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) return {
        entryPointVariant: 'DISABLED'
    };
    return loomEntryPointVariant;
};
module.exports["useLoomEntryPointVariant"] = $c8aabf9b2e3d2d10$export$62184c98af916d7a;

});

parcelRegister("932VV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $dHiKK = parcelRequire("dHiKK");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $i8Ofl = parcelRequire("i8Ofl");

const $45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery = (0, $dHiKK.default);
const $45094daeb894a50e$export$5d821a9fc4b7faa = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(11);
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== activationId || $[3] !== cloudId) {
        t1 = (0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId);
        $[2] = activationId;
        $[3] = cloudId;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== t1) {
        t2 = {
            headers: {
                ...t1
            }
        };
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const t3 = shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t4;
    if ($[7] !== t0 || $[8] !== t2 || $[9] !== t3) {
        t4 = {
            variables: t0,
            context: t2,
            skip: t3
        };
        $[7] = t0;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, t4);
    if (window.__SSR_LOOM_ENTRY_POINT__) return;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
} : ()=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        variables: {
            cloudId: cloudId
        },
        context: {
            headers: {
                ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
            }
        },
        skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return undefined;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["useIsLoomEntryPointsEnabled"] = $45094daeb894a50e$export$5d821a9fc4b7faa;

});

parcelRegister("dHiKK", function(module, exports) {
/**
 * @generated SignedSource<<b0fb41d42738db4128917afea956b213>>
 * @relayHash 255e1eee858b61b7fb061e8b9eb8fbc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0
const $dc96dcb71a986382$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceLoomEntryPoints",
            "kind": "LinkedField",
            "name": "confluence_loomEntryPoints",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLoomEntryPointsEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "255e1eee858b61b7fb061e8b9eb8fbc9",
            "id": "52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0",
            "metadata": {},
            "name": "useIsLoomEntryPointsEnabledQuery",
            "operationKind": "query",
            "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled}}"
        }
    };
}();
$dc96dcb71a986382$var$node.hash = "767e6480b08dd1cf6643fe7ca065c357";
var $dc96dcb71a986382$export$2e2bcd8739ae039 = $dc96dcb71a986382$var$node;
module.exports["default"] = $dc96dcb71a986382$export$2e2bcd8739ae039;

});

parcelRegister("i8Ofl", function(module, exports) {
const $bde9a1914731baf3$var$PRODUCT = 'Confluence Cloud';
const $bde9a1914731baf3$var$buildWorkspaceId = (tenantId, activationId)=>{
    return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};
const $bde9a1914731baf3$export$14ef296862e3705e = (tenantId, activationId)=>{
    const atlAttributionHeader = {
        atlWorkspaceId: $bde9a1914731baf3$var$buildWorkspaceId(tenantId, activationId),
        tenantId: tenantId,
        product: $bde9a1914731baf3$var$PRODUCT,
        service: 'cc-fe-bifrost'
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
};
module.exports["createAtlAttributionHeader"] = $bde9a1914731baf3$export$14ef296862e3705e;

});

parcelRegister("cYe4v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $8dwdz = parcelRequire("8dwdz");

const $9ecfddb6136413dc$export$a3777efa0eef336c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
        $[0] = t0;
    } else t0 = $[0];
    const isMobileDeviceOrMobileWeb = t0;
    let t1;
    if ($[1] !== isConfluenceLicensed) {
        t1 = isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)("confluence_loom_beta_enabled");
        $[1] = isConfluenceLicensed;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};
module.exports["useIsLoomBetaEnabled"] = $9ecfddb6136413dc$export$a3777efa0eef336c;

});

parcelRegister("dpJII", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $5CUwy = parcelRequire("5CUwy");

const $42c1694041a86183$export$da228976f78945fd = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: t2 } = t1;
    const skip = t2 === undefined ? false : t2;
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [t3, t4] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { loomEntryPointVariant: loomEntryPointVariant } = t3;
    const { initLoomEntryPointVariant: initLoomEntryPointVariant } = t4;
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    let t5;
    let t6;
    if ($[2] !== cloudId || $[3] !== entryPointVariant || $[4] !== environment || $[5] !== initLoomEntryPointVariant || $[6] !== loading || $[7] !== skip || $[8] !== userId) {
        t5 = ()=>{
            if (skip) return;
            if (entryPointVariant === "NONE" && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
        };
        t6 = [
            cloudId,
            initLoomEntryPointVariant,
            loading,
            entryPointVariant,
            skip,
            userId,
            environment
        ];
        $[2] = cloudId;
        $[3] = entryPointVariant;
        $[4] = environment;
        $[5] = initLoomEntryPointVariant;
        $[6] = loading;
        $[7] = skip;
        $[8] = userId;
        $[9] = t5;
        $[10] = t6;
    } else {
        t5 = $[9];
        t6 = $[10];
    }
    (0, $42omo.useEffect)(t5, t6);
    if (entryPointVariant === "NONE") {
        let t7;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                entryPointVariant: "NONE",
                loading: true
            };
            $[11] = t7;
        } else t7 = $[11];
        return t7;
    }
    return loomEntryPointVariant;
} : ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [{ loomEntryPointVariant: loomEntryPointVariant }, { initLoomEntryPointVariant: initLoomEntryPointVariant }] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        if (entryPointVariant === 'NONE' && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
    }, [
        cloudId,
        initLoomEntryPointVariant,
        loading,
        entryPointVariant,
        skip,
        userId,
        environment
    ]);
    if (entryPointVariant === 'NONE') return {
        entryPointVariant: 'NONE',
        loading: true
    };
    return loomEntryPointVariant;
};
module.exports["useLoomPermissionStatus"] = $42c1694041a86183$export$da228976f78945fd;

});

parcelRegister("5CUwy", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cbc8g = parcelRequire("cbc8g");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");



var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $8J8QJ = parcelRequire("8J8QJ");


var $2gAEP = parcelRequire("2gAEP");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        const licensedProducts = await (0, $c0rhi.queryInterop)({
            query: (0, $2gAEP.default)
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId, environment)=>{
    const resourceId = `ari:cloud:loom::site/${cloudId}`;
    try {
        let permitted;
        {
            const response = await (0, $8J8QJ.postJson)(`/gateway/api/permissions/permitted`, {
                permissionId: 'write',
                resourceId: resourceId,
                checkProductStatus: true
            });
            permitted = response?.permitted;
        }
        return !!permitted ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId, environment)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId, environment);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    // arbitrarily deciding on just 1 retry until we have more data to understand the eventual consistency here
                    retryWait: 500
                });
                (0, $cbc8g.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $1P1Tu.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $9zUhf.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $9zUhf.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["getLoomUserPermissionStatus"] = $9633e2f0bea217d1$export$85de6c803181afa9;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;
module.exports["useLoomEntryPointVariantActions"] = $9633e2f0bea217d1$export$fd0650c7a15c6ef2;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $d6NtA = parcelRequire("d6NtA");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'identity-platform'
            } : {}
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["postJson"] = $a326082f26863093$export$c776284ef4b1209a;
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("2gAEP", function(module, exports) {
/**
 * @generated SignedSource<<e139440afb86fce20d0d7fdd22b96ac3>>
 * @relayHash e7355c15b066e2e1bf0badd5083ad1e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af
const $936b36fbe81f4fb7$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e7355c15b066e2e1bf0badd5083ad1e0",
            "id": "828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af",
            "metadata": {},
            "name": "useLoomTenantProvisionStatusQuery",
            "operationKind": "query",
            "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$936b36fbe81f4fb7$var$node.hash = "21c387cdafea215b61e4183319580a69";
var $936b36fbe81f4fb7$export$2e2bcd8739ae039 = $936b36fbe81f4fb7$var$node;
module.exports["default"] = $936b36fbe81f4fb7$export$2e2bcd8739ae039;

});

parcelRegister("eNjW4", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $5spQU = parcelRequire("5spQU");


var $lzcvT = parcelRequire("lzcvT");


var $9wGTI = parcelRequire("9wGTI");


var $8dwdz = parcelRequire("8dwdz");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a42f1b873e59961a$export$9cca7cb3443dfd1 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const isInFedRamp = (0, $lzcvT.isFedRamp)();
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $9wGTI.fg)("use_frontend_feature_encoding_sdk") ? (0, $5spQU.isFeatureEnabled)("confluence", "confluence-loom-integration") : !isInFedRamp;
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    if (!isLoomFeatureEnabled) return true;
    if (isMobile) return true;
    return false;
} : ()=>{
    const isInFedRamp = (0, $lzcvT.isFedRamp)();
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    // When the gate is ON, we use the feature-encoding SDK to check if the feature is enabled in the current environment
    const isLoomFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-loom-integration') : !isInFedRamp;
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};
module.exports["useIsLoomDisabled"] = $a42f1b873e59961a$export$9cca7cb3443dfd1;

});

parcelRegister("9uAPw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $8aF6s = parcelRequire("8aF6s");


var $bQm3c = parcelRequire("bQm3c");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $7dgT3 = parcelRequire("7dgT3");


var $cl98v = parcelRequire("cl98v");


var $jHGaM = parcelRequire("jHGaM");


var $4R3wx = parcelRequire("4R3wx");

const $a5710166add0079d$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorTitleRecordingAlreadyInProgress: {
        id: "loom-utils.error-flag.title.recording-already-in-progress",
        defaultMessage: "Recording already in progress"
    },
    errorTitleNotReady: {
        id: "loom-utils.error-flag.title.not-ready",
        defaultMessage: "The Loom recorder wasn\u2019t ready"
    },
    errorIncompatibleBrowser: {
        id: "loom-utils.error-flag.description.incompatible-browser",
        defaultMessage: "The browser you\u2019re currently using isn\u2019t compatible with Loom (or you could be trying to use it in private/incognito mode). <a>Which browsers are compatible?</a>"
    },
    errorThirdPartyCookieDisabled: {
        id: "loom-utils.error-flag.description.third-party-cookie-disabled",
        defaultMessage: "Check that you have third-party cookies enabled, then try again."
    },
    errorNoMediaStreamSupport: {
        id: "loom-utils.error-flag.description.no-media-stream-support",
        defaultMessage: "You might need to try a different browser. <a>Which browsers are compatible?</a>"
    },
    errorSDKNotInitialized: {
        id: "loom-utils.error-flag.description.sdk-not-initialized",
        defaultMessage: "Try to start recording again now."
    },
    errorBackendFFNotEnabledYet: {
        id: "loom-utils.error-flag.description.be-ff-not-enabled-yet",
        defaultMessage: "Loom was recently enabled. Try again in a few minutes."
    },
    errorUnexpectedAuthTokenFailure: {
        id: "loom-utils.error-flag.description.unexpected-auth-token-failure",
        defaultMessage: "Something went wrong with the Loom recorder. Try again later, or contact Atlassian Support for help."
    },
    errorLoomUserNotCreatedYet: {
        id: "loom-utils.error-flag.description.loom-user-not-created-yet",
        defaultMessage: "Loom is enabled, just give us a few minutes to set everything up. You can try recording again in a bit."
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    },
    errorRecordingAlreadyInProgress: {
        id: "loom-utils.error-flag.description.recording-already-in-progress",
        defaultMessage: "Finish your current Loom video so you can start another."
    }
});
const $a5710166add0079d$var$LoomSDKSupportLink = 'https://support.loom.com/hc/en-us/articles/360020667617-loomSDK-FAQ';
function $a5710166add0079d$var$getUnsupportedSDKErrorDescription(error) {
    if (error === 'third-party-cookies-disabled') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorThirdPartyCookieDisabled);
    else if (error === 'no-media-streams-support') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$a5710166add0079d$export$a7357cdd1f0b0168.errorNoMediaStreamSupport,
        values: {
            a: (chunks)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__integrations') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: $a5710166add0079d$var$LoomSDKSupportLink,
                    target: "_blank"
                }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                    href: $a5710166add0079d$var$LoomSDKSupportLink,
                    target: "_blank"
                }, chunks)
        }
    });
    else if (error === 'incompatible-browser') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$a5710166add0079d$export$a7357cdd1f0b0168.errorIncompatibleBrowser,
        values: {
            a: (chunks)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__integrations') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: $a5710166add0079d$var$LoomSDKSupportLink,
                    target: "_blank"
                }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                    href: $a5710166add0079d$var$LoomSDKSupportLink,
                    target: "_blank"
                }, chunks)
        }
    });
}
const $a5710166add0079d$export$c8d9dc913e9e33ec = ({ entryPointLocation: entryPointLocation, flags: flags, resetInsertFunctionOnUnmount: resetInsertFunctionOnUnmount = false })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const [singletonLoomSDK, { initLoomSDK: initLoomSDK }] = (0, $jHGaM.useLoomEntryPointGlobalState)();
    const [isOpeningRecorder, setIsOpeningRecorder] = (0, $42omo.useState)(false);
    const runningSDKButton = (0, $42omo.useRef)(null);
    // the call site for openLoomRecorder might be outside of React lifecycle
    // (e.g. editor DOM button onclick) so we need to ensure we maintain reference
    const singletonLoomSDKRef = (0, $42omo.useRef)(singletonLoomSDK);
    singletonLoomSDKRef.current = singletonLoomSDK;
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (entryPointVariant === 'BETA' || entryPointVariant === 'CO_USE') initLoomSDK({
            cloudId: cloudId,
            environment: environment,
            entryPointLocation: entryPointLocation
        });
    }, [
        initLoomSDK,
        cloudId,
        createAnalyticsEvent,
        environment,
        entryPointVariant,
        entryPointLocation
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (resetInsertFunctionOnUnmount && runningSDKButton.current && singletonLoomSDKRef.current.initializedLoomSDK) {
                singletonLoomSDKRef.current.initializedLoomSDK.updateConfig({
                    config: {
                        insertButtonText: 'Open on Loom'
                    }
                });
                runningSDKButton.current.off('insert-click');
                runningSDKButton.current.on('insert-click', (video)=>{
                    window.open(video.sharedUrl, '_blank');
                    experienceTracker.succeed({
                        name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                        attributes: {
                            inserted: true,
                            insertFunctionWasReset: true
                        }
                    });
                    /**
           * Why do we need to add sendUIEvent if we are already sending a experienceTracker.succeed(ui taskSuccess) event?
           * "ui taskSuccess" does not have Statsig as destination, so we need to send a sendUIEvent to Statsig
           */ createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: entryPointLocation,
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'insertVideoLink',
                            attributes: {
                                insertFunctionWasReset: true
                            }
                        }
                    }).fire();
                });
            }
        };
    }, [
        entryPointLocation,
        resetInsertFunctionOnUnmount,
        experienceTracker,
        createAnalyticsEvent
    ]);
    const openLoomRecorder = (0, $42omo.useCallback)(async (loomRecorderParams)=>{
        if (singletonLoomSDKRef.current.initializedLoomSDK && singletonLoomSDKRef.current.initializedLoomSDK.status().state === 'active-recording') {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleRecordingAlreadyInProgress),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorRecordingAlreadyInProgress)
            });
            return;
        }
        experienceTracker.start({
            name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        if (singletonLoomSDKRef.current.isInitializing) {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleNotReady),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorSDKNotInitialized)
            });
            experienceTracker.abort({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                reason: 'SDK has not been configured yet.'
            });
            return;
        }
        // TODO CTIA- 2019: fire a clicked UI event here
        if (singletonLoomSDKRef.current.isLoomSDKSupportedError) {
            const description = $a5710166add0079d$var$getUnsupportedSDKErrorDescription(singletonLoomSDKRef.current.isLoomSDKSupportedError);
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                description: description
            });
            experienceTracker.abort({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                reason: `SDK not supported: ${singletonLoomSDKRef.current.isLoomSDKSupportedError}.`
            });
            return;
        }
        if (!singletonLoomSDKRef.current.hasRecordingAccess) {
            const noRecordingAccessReason = singletonLoomSDKRef.current.noRecordingAccessReason;
            if (noRecordingAccessReason === 'backendFF') {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorBackendFFNotEnabledYet)
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'loom enablement in progress'
                });
            } else if (noRecordingAccessReason === 'not-created') {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorLoomUserNotCreatedYet)
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'user not created yet'
                });
            } else if (noRecordingAccessReason === 'not-mastered' || noRecordingAccessReason === 'not-mastered-enterprise') {
                // mastering for enterprise users is not available until M3
                const isMasteringFlowEnabledForEdition = noRecordingAccessReason !== 'not-mastered-enterprise';
                showModal((0, $7dgT3.NonMasteredUserModalLoader), {
                    isMasteringFlowEnabled: isMasteringFlowEnabledForEdition
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'Does not have access to record looms from Confluence.',
                    attributes: {
                        noRecordingAccessReason: noRecordingAccessReason
                    }
                });
            } else {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorUnexpectedAuthTokenFailure)
                });
                experienceTracker.fail({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    error: singletonLoomSDKRef.current.authTokenError || new Error('unexpected error from Loom auth token or Loom user status')
                });
            }
            return;
        }
        if (!singletonLoomSDKRef.current.initializedLoomSDK || !singletonLoomSDKRef.current.initializedLoomSDK.status().success) {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorSDKFailedToInitialize)
            });
            experienceTracker.fail({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                error: singletonLoomSDKRef.current.initializedLoomSDKError || new Error('Loom SDK did not successfully initialize.'),
                attributes: {
                    loomSDKSuccessStatus: singletonLoomSDKRef.current.initializedLoomSDK?.status()?.success
                }
            });
            return;
        }
        (0, $cl98v.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
        setIsOpeningRecorder(true);
        createAnalyticsEvent({
            // a track event is fired once recorder is opened, this event is speficially used for monitoring in StatSig
            type: 'sendTrackEvent',
            data: {
                source: entryPointLocation,
                action: 'opened',
                actionSubject: 'loomSdkRecorder'
            }
        }).fire();
        const { configureButton: configureButton, updateConfig: updateConfig } = singletonLoomSDKRef.current.initializedLoomSDK;
        const sdkButton = configureButton();
        updateConfig({
            config: {
                insertButtonText: loomRecorderParams ? loomRecorderParams.insertButtonText : undefined,
                entryPointName: entryPointLocation
            }
        });
        if (loomRecorderParams) sdkButton.on('insert-click', async (video_0)=>{
            // TODO CTIA-2019: fire a inserted track event here
            loomRecorderParams.onInsert(video_0.sharedUrl, video_0);
            experienceTracker.succeed({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                attributes: {
                    inserted: true
                }
            });
            /**
         * Why do we need to add sendUIEvent if we are already sending a experienceTracker.succeed(ui taskSuccess) event?
         * "ui taskSuccess" does not have Statsig as destination, so we need to send a sendUIEvent to Statsig
         */ createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'insertVideoLink',
                    attributes: {
                        insertFunctionWasReset: false
                    }
                }
            }).fire();
        });
        sdkButton.on('start', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingStart'
                }
            }).fire();
        });
        sdkButton.on('recording-start', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'started',
                    actionSubject: 'loomRecording'
                }
            }).fire();
        });
        sdkButton.on('cancel', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingCancel'
                }
            }).fire();
        });
        sdkButton.on('complete', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingComplete',
                    attributes: {
                        location: loomRecorderParams?.location
                    }
                }
            }).fire();
        });
        sdkButton.on('recording-complete', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'completed',
                    actionSubject: 'loomRecording',
                    attributes: {
                        location: loomRecorderParams?.location
                    }
                }
            }).fire();
        });
        sdkButton.on('upload-complete', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'uploaded',
                    actionSubject: 'loomRecording'
                }
            }).fire();
        });
        sdkButton.on('lifecycle-update', (lifecycleState)=>{
            if (lifecycleState === 'pre-recording') {
                (0, $cl98v.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
                setIsOpeningRecorder(false);
            } else if (lifecycleState === 'closed') {
                runningSDKButton.current = null;
                experienceTracker.succeed({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    attributes: {
                        closed: true,
                        insertFunctionDefined: loomRecorderParams !== undefined
                    }
                });
            } else if (lifecycleState === 'cascaded') experienceTracker.succeed({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                attributes: {
                    cascaded: true,
                    entryPointLocation: entryPointLocation
                }
            });
        });
        sdkButton.openPreRecordPanel();
        runningSDKButton.current = sdkButton;
    }, [
        entryPointLocation,
        experienceTracker,
        flags,
        showModal,
        createAnalyticsEvent
    ]);
    return {
        openLoomRecorder: openLoomRecorder,
        isOpeningRecorder: isOpeningRecorder,
        isLoomRecorderInitialized: !singletonLoomSDKRef.current.isInitializing,
        hasRecordingAccess: singletonLoomSDKRef.current.hasRecordingAccess
    };
};
module.exports["useLoomRecorderEntryPoint"] = $a5710166add0079d$export$c8d9dc913e9e33ec;

});

parcelRegister("7dgT3", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $e2faf2da1cbb0cf6$export$fc2bc837ff93e32f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "n2Ktr",
    name: "NonMasteredUserModalLoader",
    loader: async ()=>(await (parcelRequire("g2fKo"))).NonMasteredUserModal
});
module.exports["NonMasteredUserModalLoader"] = $e2faf2da1cbb0cf6$export$fc2bc837ff93e32f;

});

parcelRegister("g2fKo", function(module, exports) {

let $bac90c565c4e75f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bac90c565c4e75f7$var$load("hhss7"),
    $bac90c565c4e75f7$var$load("np2ZB")
]).then(()=>parcelRequire('6i2Ga'));

});

parcelRegister("cl98v", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

const $dd21d598b55c38cc$export$873f91e3be81ab94 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.OPEN_LOOM_RECORDER_SDK_INTERACTION)
});
const $dd21d598b55c38cc$export$bf1068aa9f020d8f = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION)
});
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC"] = $dd21d598b55c38cc$export$873f91e3be81ab94;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC"] = $dd21d598b55c38cc$export$bf1068aa9f020d8f;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["VIEW_AI_PRESENTATION_INTERACTION"] = $4fa41f80373a2ebe$export$af1eb8557193d022;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("jHGaM", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cl98v = parcelRequire("cl98v");


var $3d6VZ = parcelRequire("3d6VZ");


var $gmNpb = parcelRequire("gmNpb");


var $38NxZ = parcelRequire("38NxZ");

const $82feff28757ef801$var$initialState = {
    isInitializing: true,
    initializedLoomSDK: null,
    _hasLoomSDKInitializationStarted: false,
    hasRecordingAccess: false,
    noRecordingAccessReason: undefined,
    authTokenError: undefined,
    isLoomSDKSupportedError: undefined,
    initializedLoomSDKError: null
};


const $82feff28757ef801$var$initSDK = ({ cloudId: cloudId, environment: environment, entryPointLocation: entryPointLocation })=>async ({ getState: getState, setState: setState })=>{
        if (getState().initializedLoomSDK || getState()._hasLoomSDKInitializationStarted) // singleton: only want 1 Loom SDK instance
        return;
        setState({
            _hasLoomSDKInitializationStarted: true
        });
        (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
        try {
            const { isSupported: isSupported } = await (parcelRequire("aWuvK"));
            const { supported: supported, error: isLoomSDKSupportedError } = await isSupported();
            if (!supported) {
                setState({
                    isLoomSDKSupportedError: isLoomSDKSupportedError,
                    isInitializing: false
                });
                (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
                return;
            }
        } catch  {
            // If SDK isSupported import/exec fails: treat as incompatible browser
            setState({
                isLoomSDKSupportedError: 'incompatible-browser',
                isInitializing: false
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
            return;
        }
        const { recorderToken: recorderToken, tokenError: tokenError } = await (0, $3d6VZ.getAuthToken)();
        if (!recorderToken || tokenError) {
            const noRecordingAccessReason = await (0, $38NxZ.getNoRecordingAccessReason)(tokenError);
            setState({
                isInitializing: false,
                noRecordingAccessReason: noRecordingAccessReason,
                authTokenError: tokenError
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
            return;
        }
        setState({
            hasRecordingAccess: true
        });
        try {
            const { createInstance: createInstance } = await (parcelRequire("e1JC3"));
            const initializedLoomSDK = await createInstance((0, $gmNpb.getLoomInstanceDataByEnvironment)({
                environment: environment,
                jws: recorderToken,
                siteId: cloudId,
                entryPointName: entryPointLocation
            }));
            setState({
                initializedLoomSDK: initializedLoomSDK,
                isInitializing: false
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
        } catch (err) {
            setState({
                isInitializing: false,
                initializedLoomSDKError: err
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
        }
    };
const $82feff28757ef801$var$actions = {
    initLoomSDK: $82feff28757ef801$var$initSDK
};
const $82feff28757ef801$export$6f57813fe9f31bf9 = (0, $1P1Tu.createStore)({
    initialState: $82feff28757ef801$var$initialState,
    actions: $82feff28757ef801$var$actions,
    name: 'loomEntryPointGlobalStateStore'
});
const $82feff28757ef801$export$160753b85ca93fc7 = (0, $9zUhf.createHook)($82feff28757ef801$export$6f57813fe9f31bf9);
module.exports["useLoomEntryPointGlobalState"] = $82feff28757ef801$export$160753b85ca93fc7;

});

parcelRegister("3d6VZ", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $e01Lp = parcelRequire("e01Lp");


var $55UbZ = parcelRequire("55UbZ");

const $000d418a80b56fba$export$38e1f53b76ec7fed = async ()=>{
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const tokenQuery = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $e01Lp.LoomAuthTokenQuery),
            fetchPolicy: 'network-only'
        });
        return {
            recorderToken: tokenQuery.data.loomToken?.token
        };
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return {
            tokenError: e
        };
    }
};
const $000d418a80b56fba$export$36491da625b5403b = async ()=>{
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const authStateQuery = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $55UbZ.LoomAuthStateQuery)
        });
        return authStateQuery.data.loomUserStatus;
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return undefined;
    }
};
module.exports["getAuthToken"] = $000d418a80b56fba$export$38e1f53b76ec7fed;
module.exports["getAuthState"] = $000d418a80b56fba$export$36491da625b5403b;

});

parcelRegister("e01Lp", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $eeb31b52c8d53ac0$export$68069cc596b806b = (0, $eSUdr.default)`query LoomAuthTokenQuery{loomToken{token}}`;
module.exports["LoomAuthTokenQuery"] = $eeb31b52c8d53ac0$export$68069cc596b806b;

});

parcelRegister("55UbZ", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $80afd1194d3d0c84$export$ee3fd3c5221b99c = (0, $eSUdr.default)`query LoomAuthStateQuery{loomUserStatus}`;
module.exports["LoomAuthStateQuery"] = $80afd1194d3d0c84$export$ee3fd3c5221b99c;

});

parcelRegister("gmNpb", function(module, exports) {
const $39913087ba6f73e2$var$PUBLIC_APP_IDS = {
    noBackend: 'a3f31403-5892-4b68-baf9-a8b1c1f9ef80',
    staging: '811e05d4-b0aa-4ec9-80e4-68cf5e924102',
    production: {
        development: 'dba4f6db-8419-44f6-ac25-32b6fc352747',
        userFacing: '8e345daf-482a-4abf-a612-cb6457110817'
    }
};
const $39913087ba6f73e2$export$c150e4a8d8a3ab35 = ({ environment: environment, jws: jws, siteId: siteId, entryPointName: entryPointName })=>{
    const commonParams = {
        jws: jws,
        siteId: siteId,
        config: {
            enableNewUi: true,
            productName: 'Confluence',
            entryPointName: entryPointName
        }
    };
    if (environment === 'DEVELOPMENT') return {
        ...commonParams,
        mode: 'standard',
        publicAppId: $39913087ba6f73e2$var$PUBLIC_APP_IDS.noBackend,
        environment: 'production' // TODO CTIA-2116: importing the enum as a value causes a big jump in package size (250kb).
    };
    if (environment === 'STAGING') return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: $39913087ba6f73e2$var$PUBLIC_APP_IDS.staging,
        environment: 'staging' // TODO CTIA-2116: importing the enum as a value causes a big jump in package size (250kb).
    };
    return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: (0, $39913087ba6f73e2$var$PUBLIC_APP_IDS.production.userFacing),
        environment: 'production' // TODO CTIA-2116: importing the enum as a value causes a big jump in package size (250kb).
    };
};
module.exports["getLoomInstanceDataByEnvironment"] = $39913087ba6f73e2$export$c150e4a8d8a3ab35;

});

parcelRegister("38NxZ", function(module, exports) {

var $3d6VZ = parcelRequire("3d6VZ");


var $dn8bs = parcelRequire("dn8bs");

const $0e5a08ec05b30096$var$graphqlErrorHasMessage = (error, messageMatch)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some(({ message: message })=>message.includes(messageMatch));
    return false;
};
const $0e5a08ec05b30096$var$FF_DISABLED_MESSAGE = 'Attempted to fetch Loom token without feature flag enabled';
const $0e5a08ec05b30096$var$UNFOUND_OR_UNMASTERED_USER_MESSAGE = 'Failed to fetch loom auth token. Status code: 404';
const $0e5a08ec05b30096$export$5a9a2c39ccb5534c = async (tokenError)=>{
    if ($0e5a08ec05b30096$var$graphqlErrorHasMessage(tokenError, $0e5a08ec05b30096$var$FF_DISABLED_MESSAGE)) return 'backendFF';
    if ($0e5a08ec05b30096$var$graphqlErrorHasMessage(tokenError, $0e5a08ec05b30096$var$UNFOUND_OR_UNMASTERED_USER_MESSAGE)) {
        const authState = await (0, $3d6VZ.getAuthState)();
        if (authState === (0, $dn8bs.LoomUserStatus).NOT_FOUND) return 'not-created';
        if (authState === (0, $dn8bs.LoomUserStatus).LINKED) return 'not-mastered';
        if (authState === (0, $dn8bs.LoomUserStatus).LINKED_ENTERPRISE) return 'not-mastered-enterprise';
    }
    return 'unexpected';
};
module.exports["getNoRecordingAccessReason"] = $0e5a08ec05b30096$export$5a9a2c39ccb5534c;

});

parcelRegister("dn8bs", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $80735413f00f04fc$export$9d643cbb1392f8e6 = /*#__PURE__*/ function(LoomUserStatus) {
    LoomUserStatus["LINKED"] = "LINKED";
    LoomUserStatus["LINKED_ENTERPRISE"] = "LINKED_ENTERPRISE";
    LoomUserStatus["MASTERED"] = "MASTERED";
    LoomUserStatus["NOT_FOUND"] = "NOT_FOUND";
    return LoomUserStatus;
}({});
module.exports["LoomUserStatus"] = $80735413f00f04fc$export$9d643cbb1392f8e6;

});

parcelRegister("aWuvK", function(module, exports) {

let $7f76fd05798145a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f76fd05798145a7$var$load("lwKXH"),
    $7f76fd05798145a7$var$load("4byV5")
]).then(()=>parcelRequire('3f9PV'));

});

parcelRegister("e1JC3", function(module, exports) {

let $a3648a6d47826ac7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a3648a6d47826ac7$var$load("8UcgD"),
    $a3648a6d47826ac7$var$load("lkOIY"),
    $a3648a6d47826ac7$var$load("5seoL"),
    $a3648a6d47826ac7$var$load("izUd1"),
    $a3648a6d47826ac7$var$load("jryxA"),
    $a3648a6d47826ac7$var$load("dWZbK"),
    $a3648a6d47826ac7$var$load("6wr18"),
    $a3648a6d47826ac7$var$load("a3Uq6"),
    $a3648a6d47826ac7$var$load("SqT67"),
    $a3648a6d47826ac7$var$load("xvDzM"),
    $a3648a6d47826ac7$var$load("jle6Z"),
    $a3648a6d47826ac7$var$load("4drdS"),
    $a3648a6d47826ac7$var$load("lLK0D"),
    $a3648a6d47826ac7$var$load("9LQGG"),
    $a3648a6d47826ac7$var$load("wIOhQ"),
    $a3648a6d47826ac7$var$load("lwKXH"),
    $a3648a6d47826ac7$var$load("fisfU"),
    $a3648a6d47826ac7$var$load("9a2oY"),
    $a3648a6d47826ac7$var$load("ffEVr"),
    $a3648a6d47826ac7$var$load("7EorR"),
    $a3648a6d47826ac7$var$load("btYwu")
]).then(()=>parcelRequire('fIeud'));

});

parcelRegister("8fj5s", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lwNi3 = parcelRequire("lwNi3");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");

const $595fe854badba39a$export$a691d616fae8bb9d = (messageId, skip = false, withChoreographer = true)=>{
    const [isMessageActive, setisMessageActive] = (0, $42omo.useState)(false);
    const [isLoading, setLoading] = (0, $42omo.useState)(true);
    const coordinationClient = (0, $lwNi3.useCoordinationClient)(withChoreographer);
    (0, $42omo.useEffect)(()=>{
        async function startMessage() {
            try {
                const _isMessageActive = await coordinationClient.start(messageId);
                setisMessageActive(_isMessageActive);
            } catch (err) {
                (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                    attribution: (0, $3IBnw.Attribution).CONTENPLATES
                });
            }
            setLoading(false);
        }
        if (skip) return;
        startMessage();
    }, [
        coordinationClient,
        messageId,
        skip
    ]);
    const stop = (0, $42omo.useCallback)(async (force = false)=>{
        if (!force && !isMessageActive) return;
        try {
            await coordinationClient.stop(messageId);
            setisMessageActive(false);
        } catch (err) {
            (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                attribution: (0, $3IBnw.Attribution).CONTENPLATES
            });
        }
    }, [
        isMessageActive,
        coordinationClient,
        messageId
    ]);
    return [
        isMessageActive,
        stop,
        skip ? false : isLoading
    ];
};
module.exports["useSkippableCoordination"] = $595fe854badba39a$export$a691d616fae8bb9d;

});

parcelRegister("lwNi3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $04e9M = parcelRequire("04e9M");


var $jOtRZ = parcelRequire("jOtRZ");


var $lBR3p = parcelRequire("lBR3p");

const $5efec5cf952678ca$export$ddc368dc94a41e62 = (withChoreographer = true)=>{
    const { cloudId: cloudId, activationId: activationId, environment: environment } = (0, $bQm3c.useSessionData)();
    const workspaceId = (0, $04e9M.getWorkspaceId)(cloudId, activationId);
    const disableEngagementForTests = sessionStorage.getItem('confluence.disable-engagement-for-tests') === 'true';
    const envType = (0, $jOtRZ.useAnalyticsEnvironment)(environment);
    return (0, $42omo.useMemo)(()=>(0, $lBR3p.getCoordinationClient)(disableEngagementForTests, cloudId, workspaceId, withChoreographer, envType), [
        disableEngagementForTests,
        cloudId,
        workspaceId,
        withChoreographer,
        envType
    ]);
};
module.exports["useCoordinationClient"] = $5efec5cf952678ca$export$ddc368dc94a41e62;

});

parcelRegister("lBR3p", function(module, exports) {

var $5loD0 = parcelRequire("5loD0");


var $fw9LG = parcelRequire("fw9LG");

const $b379edbfb382bc54$var$noop = async ()=>false;
const $b379edbfb382bc54$export$a3f969ef7d35205d = (disableEngagementForTests, cloudId, workspaceId, enableChoreographer, environment)=>{
    if (disableEngagementForTests) return {
        start: $b379edbfb382bc54$var$noop,
        stop: $b379edbfb382bc54$var$noop
    };
    else {
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: environment,
            additionalData: {
                sourceProductId: (0, $fw9LG.ProductIds).CONFLUENCE
            }
        };
        return new (0, $5loD0.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api',
            isFedRAMPEnvironment: false,
            workspaceId: workspaceId,
            coordinationOptions: coordinationOptions
        });
    }
};
module.exports["getCoordinationClient"] = $b379edbfb382bc54$export$a3f969ef7d35205d;

});

parcelRegister("5loD0", function(module, exports) {

var $ll2sR = parcelRequire("ll2sR");


var $4nGsu = parcelRequire("4nGsu");

class $4b61f610720049a6$export$2e2bcd8739ae039 {
    async start(messageId, variationId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    constructor(configOrCloudId, stargateUrl){
        this.cloudId = void 0;
        this.stargateUrl = void 0;
        this.orgId = void 0;
        this.workspaceId = void 0;
        this.coordinationOptions = void 0;
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
}
module.exports["default"] = $4b61f610720049a6$export$2e2bcd8739ae039;

});

parcelRegister("lqy4C", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $42omo.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<634d8ca034d2498a989d5a4ffee872da>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $1P1Tu.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $9zUhf.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $9zUhf.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("bZSO8", function(module, exports) {

var $c3Qwv = parcelRequire("c3Qwv");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $hQnHK = parcelRequire("hQnHK");


var $6mKj3 = parcelRequire("6mKj3");


var $98wxI = parcelRequire("98wxI");

const $e7afa99020494478$var$queryParamKeys = {
    subType: 'subType',
    parentPageId: 'parentPageId',
    title: 'title',
    draftId: 'draftId',
    linkCreation: 'linkCreation',
    fromPageId: 'fromPageId',
    // used by createpage.action endpoint.
    spaceKey: 'spaceKey',
    source: 'source',
    withFallback: 'withFallback',
    openTemplatesGallery: 'openTemplatesGallery',
    paywallStatus: 'paywallStatus',
    deactivationIdentifier: 'deactivationIdentifier',
    openJiraImportTool: (0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM),
    cloudId: (0, $hQnHK.CLOUD_ID),
    projectUuid: (0, $hQnHK.PROJECT_UUID),
    autoImportJiraIssues: (0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM),
    jiraImportJql: (0, $hQnHK.JIRA_IMPORT_JQL),
    insertTemplateWithKey: (0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM),
    smartLinkCreateSource: 'smartLinkCreateSource',
    smartLinkEmbedUrl: 'smartLinkEmbedUrl',
    restoreVersionContentId: 'restoreVersionContentId',
    openTemplatePicker: 'openTemplatePicker',
    journeyId: 'journeyId',
    templateKey: 'templateKey',
    /* Created By Flow Analytic contributes to Core Actions/FO and should sometimes be disabled 
  (ex: user going through onboarding may be firing this event during onboarding screens and should not contribute to KR metric)*/ disableCreatedByFlowAnalytic: 'dcbfa'
};
const $e7afa99020494478$var$SUPPORTED_CONTENT_TYPES = [
    'page',
    'blog',
    'whiteboard',
    'database',
    'smartLinkEmbed',
    'folder'
];
const $e7afa99020494478$export$b3086acbf0304043 = (options)=>{
    const queryParams = {};
    if ('subType' in options && options.subType) queryParams[$e7afa99020494478$var$queryParamKeys.subType] = options.subType;
    if ('spaceKey' in options && options.spaceKey) queryParams[$e7afa99020494478$var$queryParamKeys.spaceKey] = options.spaceKey;
    if ('parentPageId' in options && options.parentPageId) queryParams[$e7afa99020494478$var$queryParamKeys.parentPageId] = options.parentPageId;
    if ('openTemplatePicker' in options && options.openTemplatePicker !== undefined) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatePicker] = options.openTemplatePicker;
    if ('title' in options && options.title) queryParams[$e7afa99020494478$var$queryParamKeys.title] = options.title;
    if ('draftId' in options && options.draftId) queryParams[$e7afa99020494478$var$queryParamKeys.draftId] = options.draftId;
    if ('linkCreation' in options && options.linkCreation) queryParams[$e7afa99020494478$var$queryParamKeys.linkCreation] = options.linkCreation;
    if ('withFallback' in options && options.withFallback) queryParams[$e7afa99020494478$var$queryParamKeys.withFallback] = options.withFallback;
    if ('openTemplatesGallery' in options && options.openTemplatesGallery) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatesGallery] = options.openTemplatesGallery;
    if ('source' in options && options.source) queryParams[$e7afa99020494478$var$queryParamKeys.source] = options.source;
    if ('paywallStatus' in options && options.paywallStatus) queryParams[$e7afa99020494478$var$queryParamKeys.paywallStatus] = options.paywallStatus;
    if ('deactivationIdentifier' in options && options.deactivationIdentifier) queryParams[$e7afa99020494478$var$queryParamKeys.deactivationIdentifier] = options.deactivationIdentifier;
    if ((0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM) in options && options.openJiraImportTool) queryParams[$e7afa99020494478$var$queryParamKeys.openJiraImportTool] = options.openJiraImportTool;
    if ((0, $hQnHK.CLOUD_ID) in options && options.cloudId) queryParams[$e7afa99020494478$var$queryParamKeys.cloudId] = options.cloudId;
    if ((0, $hQnHK.PROJECT_UUID) in options && options.projectUuid) queryParams[$e7afa99020494478$var$queryParamKeys.projectUuid] = options.projectUuid;
    if ((0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM) in options && options.autoImportJiraIssues) queryParams[$e7afa99020494478$var$queryParamKeys.autoImportJiraIssues] = options.autoImportJiraIssues;
    if ((0, $hQnHK.JIRA_IMPORT_JQL) in options && options.jiraImportJql) queryParams[$e7afa99020494478$var$queryParamKeys.jiraImportJql] = options.jiraImportJql;
    if ((0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM) in options && options.insertTemplateWithKey) queryParams[$e7afa99020494478$var$queryParamKeys.insertTemplateWithKey] = options.insertTemplateWithKey;
    if ('smartLinkCreateSource' in options && options.smartLinkCreateSource) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkCreateSource] = options.smartLinkCreateSource;
    if ('smartLinkEmbedUrl' in options && options.smartLinkEmbedUrl) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl] = options.smartLinkEmbedUrl;
    if ('restoreVersionContentId' in options && options.restoreVersionContentId) queryParams[$e7afa99020494478$var$queryParamKeys.restoreVersionContentId] = options.restoreVersionContentId;
    if ('journeyId' in options && options.journeyId) queryParams[$e7afa99020494478$var$queryParamKeys.journeyId] = options.journeyId;
    if ('templateKey' in options && options.templateKey) queryParams[$e7afa99020494478$var$queryParamKeys.templateKey] = options.templateKey;
    if ('disableCreatedByFlowAnalytic' in options && options.disableCreatedByFlowAnalytic) queryParams[$e7afa99020494478$var$queryParamKeys.disableCreatedByFlowAnalytic] = options.disableCreatedByFlowAnalytic;
    return (0, $1NBp8.CREATE_CONTENT).toUrl({
        contentType: options.contentType
    }, {
        query: queryParams
    });
};
const $e7afa99020494478$var$useContentType = (0, $dPJCf.createRouteParamHook)('contentType');
const $e7afa99020494478$export$963d972ae7433a64 = ()=>{
    const contentType = $e7afa99020494478$var$useContentType();
    if ($e7afa99020494478$var$SUPPORTED_CONTENT_TYPES.includes(contentType)) {
        if (contentType === "folder" && !(0, $6mKj3.UNSAFE_expValNoExposure)("cfind-4930-get-started-doc-notification", "isEnabled", false)) return;
        return contentType;
    }
};
const $e7afa99020494478$export$67c4cee80a3410cd = (queryParams)=>{
    const subType = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.subType);
    const spaceKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.spaceKey);
    const parentPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.parentPageId);
    const title = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.title);
    const draftId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.draftId);
    const linkCreation = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.linkCreation);
    const fromPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.fromPageId);
    const withFallback = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.withFallback) ? true : undefined;
    const openTemplatesGallery = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatesGallery) ? true : undefined;
    const source = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.source);
    const deactivationIdentifier = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.deactivationIdentifier);
    const paywallStatus = (0, $98wxI.PaywallStatus)[(0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.paywallStatus) || ''];
    const openJiraImportTool = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openJiraImportTool) ? true : undefined;
    const cloudId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.cloudId);
    const projectUuid = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.projectUuid);
    const autoImportJiraIssues = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.autoImportJiraIssues) ? true : undefined;
    const jiraImportJql = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.jiraImportJql);
    const insertTemplateWithKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.insertTemplateWithKey) ?? undefined;
    const smartLinkCreateSource = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkCreateSource);
    const smartLinkEmbedUrl = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl);
    const restoreVersionContentId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.restoreVersionContentId);
    const journeyId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.journeyId);
    const openTemplatePickerParam = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatePicker);
    const openTemplatePicker = openTemplatePickerParam ? openTemplatePickerParam === 'true' : undefined;
    const templateKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.templateKey);
    const disableCreatedByFlowAnalytic = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.disableCreatedByFlowAnalytic) === 'true';
    return {
        subType: subType,
        spaceKey: spaceKey,
        parentPageId: parentPageId || fromPageId,
        title: // prefer new parameter over old parameter
        title,
        draftId: draftId,
        linkCreation: linkCreation,
        withFallback: withFallback,
        source: source,
        paywallStatus: paywallStatus,
        deactivationIdentifier: deactivationIdentifier,
        openJiraImportTool: openJiraImportTool,
        cloudId: cloudId,
        projectUuid: projectUuid,
        autoImportJiraIssues: autoImportJiraIssues,
        jiraImportJql: jiraImportJql,
        insertTemplateWithKey: insertTemplateWithKey,
        smartLinkCreateSource: smartLinkCreateSource,
        smartLinkEmbedUrl: smartLinkEmbedUrl,
        restoreVersionContentId: restoreVersionContentId,
        openTemplatesGallery: openTemplatesGallery,
        openTemplatePicker: openTemplatePicker,
        journeyId: journeyId,
        templateKey: templateKey,
        disableCreatedByFlowAnalytic: disableCreatedByFlowAnalytic
    };
};
var $e7afa99020494478$export$f9ad0711e89cafb5 = /*#__PURE__*/ function(ExperienceResolution) {
    ExperienceResolution[ExperienceResolution["ABORT"] = 0] = "ABORT";
    ExperienceResolution[ExperienceResolution["SUCCEED"] = 1] = "SUCCEED";
    return ExperienceResolution;
}({});
module.exports["buildCreationLink"] = $e7afa99020494478$export$b3086acbf0304043;
module.exports["useCreateRouteSupportedContentType"] = $e7afa99020494478$export$963d972ae7433a64;
module.exports["parseQueryParams"] = $e7afa99020494478$export$67c4cee80a3410cd;
module.exports["ExperienceResolution"] = $e7afa99020494478$export$f9ad0711e89cafb5;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;

});

parcelRegister("98wxI", function(module, exports) {
var $5046ea0ba58442ff$export$d9669dcdbd1161d9 = /*#__PURE__*/ function(PaywallStatus) {
    PaywallStatus["ACTIVE"] = "ACTIVE";
    PaywallStatus["DEACTIVATED"] = "DEACTIVATED";
    PaywallStatus["UNSET"] = "UNSET";
    return PaywallStatus;
}({});
module.exports["PaywallStatus"] = $5046ea0ba58442ff$export$d9669dcdbd1161d9;

});

parcelRegister("h7OOD", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $56M4r = parcelRequire("56M4r");


var $9hlns = parcelRequire("9hlns");


var $6F6hl = parcelRequire("6F6hl");

const $8acd43e7dd84c3a6$export$a0fbd5b601316213 = (t0)=>{
    const $ = (0, $frIzR.c)(22);
    let children;
    let isLoading;
    let loadingLabel;
    let onClick;
    let props;
    if ($[0] !== t0) {
        ({ children: children, isLoading: isLoading, loadingLabel: loadingLabel, onClick: onClick, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = isLoading;
        $[3] = loadingLabel;
        $[4] = onClick;
        $[5] = props;
    } else {
        children = $[1];
        isLoading = $[2];
        loadingLabel = $[3];
        onClick = $[4];
        props = $[5];
    }
    let t1;
    if ($[6] !== isLoading || $[7] !== onClick) {
        t1 = (e)=>{
            if (isLoading) return;
            onClick?.(e);
        };
        $[6] = isLoading;
        $[7] = onClick;
        $[8] = t1;
    } else t1 = $[8];
    const handleClick = t1;
    let t2;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        });
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== loadingLabel) {
        t3 = {
            "aria-disabled": true,
            "aria-label": loadingLabel,
            iconAfter: t2
        };
        $[10] = loadingLabel;
        $[11] = t3;
    } else t3 = $[11];
    const loadingProps = t3;
    const t4 = isLoading ? loadingLabel : undefined;
    let t5;
    if ($[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
            role: "status"
        }, t4);
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    const t6 = isLoading && loadingProps;
    let t7;
    if ($[14] !== children || $[15] !== handleClick || $[16] !== props || $[17] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
            onClick: handleClick,
            ...props,
            ...t6
        }, children);
        $[14] = children;
        $[15] = handleClick;
        $[16] = props;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== t5 || $[20] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t5, t7);
        $[19] = t5;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    return t8;
};
module.exports["LoadingPopoverItem"] = $8acd43e7dd84c3a6$export$a0fbd5b601316213;

});

parcelRegister("5Krdf", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $853df67b1c2afe8a$var$contentTitleStyles = (0, $ecnYn.xcss)({
    fontWeight: 'font.weight.medium',
    color: 'color.text',
    marginRight: 'space.075'
});
const $853df67b1c2afe8a$export$35e09ba17cc51c69 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $853df67b1c2afe8a$export$aaf6264d06ddc4ce = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $853df67b1c2afe8a$var$contentTitleStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $853df67b1c2afe8a$export$f80c710c106023ee = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_k48p127f _syaz1gmx",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $853df67b1c2afe8a$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $853df67b1c2afe8a$var$nonStandardIconSize = '18px !important';
const $853df67b1c2afe8a$export$5159722bed5f8afe = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1o9zidpf _1bah1h6o _1bsb1ejb _1xjx1o4j _17521o4j _e2oo1o4j _w8l51o4j",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $853df67b1c2afe8a$export$d69e1d473e997f8 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
        const t3 = __cmplp.isDisabled ? "50%" : "100%";
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_y1fz7b": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_tzy4jn7l _159i1lhn _1tdsn7od _1pum1jfw _10jxn7od _1m8y1jfw",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
module.exports["TitleContainer"] = $853df67b1c2afe8a$export$35e09ba17cc51c69;
module.exports["ContentTitle"] = $853df67b1c2afe8a$export$aaf6264d06ddc4ce;
module.exports["DisabledContentTitle"] = $853df67b1c2afe8a$export$f80c710c106023ee;
module.exports["LozengeWrapper"] = $853df67b1c2afe8a$export$75180efdd3f4d9c2;
module.exports["ContentIconWrapper"] = $853df67b1c2afe8a$export$5159722bed5f8afe;
module.exports["MenuItemWrapper"] = $853df67b1c2afe8a$export$d69e1d473e997f8;

});

parcelRegister("jrwID", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $e0ycV = parcelRequire("e0ycV");


var $6yCpa = parcelRequire("6yCpa");


var $lqy4C = parcelRequire("lqy4C");


var $8Qafc = parcelRequire("8Qafc");


var $dilhZ = parcelRequire("dilhZ");


var $3J7nf = parcelRequire("3J7nf");


var $dPJCf = parcelRequire("dPJCf");


var $b3j2Y = parcelRequire("b3j2Y");


var $9wGTI = parcelRequire("9wGTI");


var $3Yga2 = parcelRequire("3Yga2");


var $bZSO8 = parcelRequire("bZSO8");


var $bBaUQ = parcelRequire("bBaUQ");


var $dkIiA = parcelRequire("dkIiA");


var $jo6R7 = parcelRequire("jo6R7");

const $27cf2e1d8d21e923$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.liveDoc.title",
        defaultMessage: "Live Doc"
    },
    newLozenge: {
        id: "create-blank-fabric-page.universal-create.liveDoc.new.lozenge",
        defaultMessage: "New"
    }
});
const $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM = 'create-live-doc-popover-item';
function $27cf2e1d8d21e923$export$5af7ed73ba9cf3af(t0) {
    const $ = (0, $frIzR.c)(28);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        t2 = (0, $bZSO8.buildCreationLink)({
            contentType: "page",
            subType: (0, $dkIiA.ConfluencePageSubType).LIVE,
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        });
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[5] !== hybridLinkClick || $[6] !== onClick) {
        t3 = (e)=>{
            onClick("createLiveDocPopoverItem");
            hybridLinkClick(e);
            (0, $3Yga2.setLozengeShownTrackerMax)();
        };
        $[5] = hybridLinkClick;
        $[6] = onClick;
        $[7] = t3;
    } else t3 = $[7];
    const handleClick = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $3Yga2.checkShouldShowLozenge)();
        $[8] = t4;
    } else t4 = $[8];
    const shouldShowLozenge = t4;
    let t5;
    if ($[9] !== formatMessage) {
        t5 = (0, $9wGTI.fg)("confluence_remove_live_page_lozenge_hello") || !shouldShowLozenge ? formatMessage($27cf2e1d8d21e923$var$messages.title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jo6R7.ItemTitleWithLozenge), {
            lozenge: formatMessage($27cf2e1d8d21e923$var$messages.newLozenge)
        }, formatMessage($27cf2e1d8d21e923$var$messages.title));
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    const titleItem = t5;
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:livedoc");
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== enforceStorageLimit || $[13] !== handleClick) {
        t7 = enforceStorageLimit(handleClick);
        $[12] = enforceStorageLimit;
        $[13] = handleClick;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== createHref || $[16] !== shouldBlockCreate) {
        t8 = !shouldBlockCreate && {
            href: createHref
        };
        $[15] = createHref;
        $[16] = shouldBlockCreate;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== createHref || $[19] !== handleClick || $[20] !== source) {
        t9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($27cf2e1d8d21e923$var$LiveDocSpotlightWrapper, {
                ...props,
                source: source,
                createHref: createHref,
                handleClick: handleClick
            });
        $[18] = createHref;
        $[19] = handleClick;
        $[20] = source;
        $[21] = t9;
    } else t9 = $[21];
    const t10 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t11;
    if ($[22] !== t10 || $[23] !== t7 || $[24] !== t8 || $[25] !== t9 || $[26] !== titleItem) {
        t11 = {
            ati: t6,
            children: titleItem,
            onClick: t7,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
            ...t8,
            Wrapper: t9,
            testId: t10
        };
        $[22] = t10;
        $[23] = t7;
        $[24] = t8;
        $[25] = t9;
        $[26] = titleItem;
        $[27] = t11;
    } else t11 = $[27];
    return t11;
}
const $27cf2e1d8d21e923$var$LiveDocSpotlightWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((t0)=>{
    const $ = (0, $frIzR.c)(22);
    const { children: children, source: source, createHref: createHref, handleClick: handleClick } = t0;
    const hasFiredOnStartEventRef = (0, $42omo.useRef)(false);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { introSpotlight: introSpotlight, error: error } = (0, $3J7nf.useLiveDocChangeboarding)();
    const { isVisible: shouldShowIntroSpotlight, complete: completeIntroSpotlight } = introSpotlight;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== createAnalyticsEvent || $[2] !== source) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "shown",
                    actionSubject: "spotlight",
                    actionSubjectId: "liveDocIntro",
                    source: source
                }
            }).fire();
        };
        $[1] = createAnalyticsEvent;
        $[2] = source;
        $[3] = t2;
    } else t2 = $[3];
    const onSpotlightStart = t2;
    let t3;
    let t4;
    if ($[4] !== onSpotlightStart || $[5] !== shouldShowIntroSpotlight) {
        t3 = ()=>{
            if (shouldShowIntroSpotlight && !hasFiredOnStartEventRef.current) {
                onSpotlightStart();
                hasFiredOnStartEventRef.current = true;
            }
        };
        t4 = [
            shouldShowIntroSpotlight,
            onSpotlightStart
        ];
        $[4] = onSpotlightStart;
        $[5] = shouldShowIntroSpotlight;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[8] !== completeIntroSpotlight || $[9] !== createHref || $[10] !== enforceStorageLimit || $[11] !== error || $[12] !== handleClick || $[13] !== push || $[14] !== source) {
        t5 = (element)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dilhZ.CreateLiveDocPopoverItemSpotlight), {
                handleDismiss: ()=>{
                    completeIntroSpotlight();
                },
                handleProceed: enforceStorageLimit((e)=>{
                    completeIntroSpotlight();
                    handleClick(e);
                    push(createHref);
                }),
                targetName: $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM,
                source: source,
                fireAnalyticsEventOnMessageDisposition: false
            }, element, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }));
        $[8] = completeIntroSpotlight;
        $[9] = createHref;
        $[10] = enforceStorageLimit;
        $[11] = error;
        $[12] = handleClick;
        $[13] = push;
        $[14] = source;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== children) {
        t6 = children();
        $[16] = children;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== shouldShowIntroSpotlight || $[19] !== t5 || $[20] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Qafc.CreateButtonSpotlightPulseWrapper), {
            condition: shouldShowIntroSpotlight,
            wrapper: t5
        }, t6);
        $[18] = shouldShowIntroSpotlight;
        $[19] = t5;
        $[20] = t6;
        $[21] = t7;
    } else t7 = $[21];
    return t7;
});
module.exports["useLiveDocItem"] = $27cf2e1d8d21e923$export$5af7ed73ba9cf3af;

});

parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("42omo")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("8Qafc", function(module, exports) {

var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");

const $49dbd1574f09cb09$export$d92f76549f7edf23 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).FLYWHEEL_ACTIVATION
})(({ condition: condition, wrapper: wrapper, children: children })=>condition ? wrapper(children) : children);
module.exports["CreateButtonSpotlightPulseWrapper"] = $49dbd1574f09cb09$export$d92f76549f7edf23;

});

parcelRegister("dilhZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $cOrQJ = parcelRequire("cOrQJ");


var $inPa6 = parcelRequire("inPa6");


var $6cnUO = parcelRequire("6cnUO");

var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");


var $hmuev = parcelRequire("hmuev");


var $1qfLF = parcelRequire("1qfLF");


var $lsxnT = parcelRequire("lsxnT");


var $9wGTI = parcelRequire("9wGTI");


var $aZfTF = parcelRequire("aZfTF");


var $6YEO8 = parcelRequire("6YEO8");


var $aCAOX = parcelRequire("aCAOX");

const $4859e80d7eeaa186$export$e2163c7fe73fc602 = ({ children: children, handleDismiss: handleDismiss, handleProceed: handleProceed, targetName: targetName, source: source, fireAnalyticsEventOnMessageDisposition: fireAnalyticsEventOnMessageDisposition = true })=>{
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const sourceComponent = source.toLowerCase();
    const isContextual = sourceComponent.includes('contextual');
    const isGlobalCreate = sourceComponent.includes('global');
    const theme = (0, $cOrQJ.default)();
    const GAImage = theme.colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($6YEO8))) : (0, (/*@__PURE__*/$parcel$interopDefault($aCAOX)));
    const dialogPlacement = (0, $42omo.useMemo)(()=>{
        if (isContextual) return 'right middle';
        else if (isGlobalCreate) return 'left top';
        return undefined;
    }, [
        isContextual,
        isGlobalCreate
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onMessageDisposition = (0, $42omo.useCallback)((disposition)=>{
        if (disposition === 'started') createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'shown',
                actionSubject: 'spotlight',
                actionSubjectId: 'liveDocIntro',
                source: sourceComponent
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        sourceComponent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: targetName
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
        dialogPlacement: dialogPlacement,
        actions: [
            {
                onClick: (e)=>{
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'tryItOut',
                            source: 'liveDocIntroSpotlight',
                            attributes: {
                                spotlightSource: sourceComponent
                            }
                        }
                    }).fire();
                    handleProceed(e);
                },
                text: formatMessage($4859e80d7eeaa186$var$introSpotlight.tryItOut)
            },
            (0, $9wGTI.fg)('cc_modernize_ga_changeboarding') ? {
                onClick: ()=>{
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'findOutMore',
                            source: 'liveDocIntroSpotlight',
                            attributes: {
                                spotlightSource: sourceComponent
                            }
                        }
                    }).fire();
                    handleDismiss();
                    window.open('https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/', '_blank');
                },
                text: formatMessage($4859e80d7eeaa186$var$introSpotlight.findOutMore),
                appearance: 'subtle'
            } : {
                onClick: ()=>{
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'dismiss',
                            source: 'liveDocIntroSpotlight',
                            attributes: {
                                spotlightSource: sourceComponent
                            }
                        }
                    }).fire();
                    handleDismiss();
                },
                text: formatMessage($4859e80d7eeaa186$var$introSpotlight.dismiss)
            }
        ],
        heading: formatMessage((0, $9wGTI.fg)('cc_modernize_ga_changeboarding') ? $4859e80d7eeaa186$var$introSpotlight.headingForGA : $4859e80d7eeaa186$var$introSpotlight.heading),
        headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            testId: "live-docs-intro-spotlight-dismiss",
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                    ...iconProps,
                    color: "var(--ds-icon-inverse, #FFFFFF)"
                }),
            appearance: "subtle",
            label: formatMessage($4859e80d7eeaa186$var$introSpotlight.dismiss),
            onClick: ()=>{
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'dismiss',
                        source: 'liveDocIntroSpotlight',
                        attributes: {
                            spotlightSource: sourceComponent
                        }
                    }
                }).fire();
                handleDismiss();
            }
        }),
        targetRadius: 6,
        target: targetName,
        key: `${targetName}-key`,
        messageType: "engagement",
        messageId: `${targetName}-message-id`,
        image: (0, $9wGTI.fg)('cc_modernize_ga_changeboarding') ? GAImage : (0, (/*@__PURE__*/$parcel$interopDefault($aZfTF))),
        dialogWidth: (0, $9wGTI.fg)('cc_modernize_ga_changeboarding') ? 320 : 338,
        targetOnClick: (eventData)=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'tryItOut',
                    source: 'onboardingLiveDocIntroSpotlight',
                    attributes: {
                        menu: sourceComponent
                    }
                }
            }).fire();
            handleProceed(eventData.event);
        },
        //Node: Both `scrollPositionBlock` and `shouldWatchTarget` are needed to make sure the spotlight positioned correctly in contextual create flow of page tree
        //There is known bug logged for the shifting issue from platform component: https://product-fabric.atlassian.net/browse/DSP-18777
        shouldWatchTarget: true,
        scrollPositionBlock: isContextual ? 'nearest' : undefined,
        ...fireAnalyticsEventOnMessageDisposition ? {
            onMessageDisposition: onMessageDisposition
        } : {},
        targetBgColor: "var(--ds-surface-overlay, #FFFFFF)"
    }, formatMessage((0, $9wGTI.fg)('cc_modernize_ga_changeboarding') ? $4859e80d7eeaa186$var$introSpotlight.bodyForGA : $4859e80d7eeaa186$var$introSpotlight.body))));
};
const $4859e80d7eeaa186$var$introSpotlight = (0, $cgtv4.defineMessages)({
    heading: {
        id: "onboarding-live-doc-changeboarding.introSpotlight.heading",
        defaultMessage: "Start collaborating with Live Docs"
    },
    headingForGA: {
        id: "onboarding-live-doc-changeboarding.introSpotlight.headingGA",
        defaultMessage: "Bring ideas to life with Live Docs"
    },
    body: {
        id: "onboarding-live-doc-changeboarding.introSpotlight.body",
        defaultMessage: "Use live docs for quick, messy brainstorming and collaboration with your team."
    },
    bodyForGA: {
        id: "onboarding-live-doc-changeboarding.introSpotlight.bodyGA",
        defaultMessage: "Use live docs for quick brainstorming and team collaboration."
    },
    dismiss: {
        id: "onboarding-live-doc-changeboarding.introSpotlight.dismiss",
        defaultMessage: "Dismiss"
    },
    findOutMore: {
        id: "onboarding-live-doc-changeboarding.introSpotlight.learnMore",
        defaultMessage: "Find out more"
    },
    tryItOut: {
        id: "onboarding-live-doc-changeboarding.introSpotlight.tryItOut",
        defaultMessage: "Try it out"
    }
});
module.exports["CreateLiveDocPopoverItemSpotlight"] = $4859e80d7eeaa186$export$e2163c7fe73fc602;

});

parcelRegister("aZfTF", function(module, exports) {
module.exports = new URL("LiveDocsIntroGif.d2fc0787.gif", import.meta.url).toString();

});

parcelRegister("6YEO8", function(module, exports) {
module.exports = new URL("LiveDocIntroGADark.45e6357d.svg", import.meta.url).toString();

});

parcelRegister("aCAOX", function(module, exports) {
module.exports = new URL("LiveDocIntroGALight.8a32f41a.svg", import.meta.url).toString();

});

parcelRegister("bBaUQ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $dHSeC = parcelRequire("dHSeC");


var $dPJCf = parcelRequire("dPJCf");

const $de58db0b8f5ba7ec$export$7947243b7b7e6ed9 = (href)=>{
    const $ = (0, $frIzR.c)(4);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const matchRoute = (0, $dPJCf.useMatchRoute)();
    let t0;
    if ($[0] !== href || $[1] !== matchRoute || $[2] !== push) {
        t0 = (event)=>{
            const isSpaTransition = !!(0, $dHSeC.getSpaTransitionDetails)(event, {
                matchRoute: matchRoute
            });
            if (isSpaTransition && href) {
                event.preventDefault();
                push(href);
            }
        };
        $[0] = href;
        $[1] = matchRoute;
        $[2] = push;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};
module.exports["useHybridLinkClick"] = $de58db0b8f5ba7ec$export$7947243b7b7e6ed9;

});

parcelRegister("jo6R7", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $5nBzc = parcelRequire("5nBzc");


var $ibDKJ = parcelRequire("ibDKJ");

const $925aeaac5c2ec2fe$var$titleSpacingStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.075'
});
const $925aeaac5c2ec2fe$export$32629a9f34b6d093 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children, lozenge: lozenge, useLabsLozenge: useLabsLozenge } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $925aeaac5c2ec2fe$var$titleSpacingStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== lozenge || $[3] !== useLabsLozenge) {
        t2 = useLabsLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ibDKJ.AILabsLozenge), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "new"
        }, lozenge);
        $[2] = lozenge;
        $[3] = useLabsLozenge;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            alignItems: "center",
            justifyContent: "space-between"
        }, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["ItemTitleWithLozenge"] = $925aeaac5c2ec2fe$export$32629a9f34b6d093;

});

parcelRegister("ibDKJ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $cOrQJ = parcelRequire("cOrQJ");


var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");


var $36Swo = parcelRequire("36Swo");

const $e5b02ec9368d4295$var$i18n = (0, $cgtv4.defineMessages)({
    tooltip: {
        id: "ai-common.ai-labs-lozenge.tooltip",
        defaultMessage: "Beta: This feature is still in development."
    }
});
const $e5b02ec9368d4295$var$lozengeStyles = {
    lozenge: "_2rko12b0 _18zr1b66 _1e0c1txw _4cvr1h6o _1bah1h6o",
    tooltip: "_2rko12b0 _11c8wadc _vchhusvi _p12f7l9q _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna"
};
const $e5b02ec9368d4295$var$gradientWaveKeyframes = null;
const $e5b02ec9368d4295$var$lozengeAnimatedBorder = null; // Using a custom tooltip is a workaround to avoid odd spacing due to default styles,
// primarily for the English locale
const $e5b02ec9368d4295$var$CustomTooltip = /*#__PURE__*/ (0, $42omo.forwardRef)(function CustomTooltip({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $afneb.default), {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            $e5b02ec9368d4295$var$lozengeStyles.tooltip
        ]),
        children: children
    });
});
const $e5b02ec9368d4295$export$48aba4499a97f6bf = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)(); // We don't want to i18n the term 'AI Labs' because it is the branding name
    // and should be the same across all languages
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        component: $e5b02ec9368d4295$var$CustomTooltip,
        content: formatMessage($e5b02ec9368d4295$var$i18n.tooltip),
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-testid": "ai-labs-lozenge",
            className: (0, $gMc0m.default)([
                $e5b02ec9368d4295$var$lozengeStyles.lozenge,
                "_2rko12b0 _18zr1b66 _kqswh2mm _bfhksm61 _1e0c1txw _4cvr1h6o _1bah1h6o _1pbyidpf _1tesidpf _rfx312b0 _1414t94y _p7f0t94y _7gpxt94y _syayt94y _1s6kyrfl _16qq1ajn _1kt9b3bt _1cs8stnw _1ankm4tz _12a1epuu _x5brkvto _13sb1p67 _dsq4glyw _1g0v1mrw"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                grow: "hug",
                space: "space.025",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $36Swo.LabsIcon), {
                        darkMode: colorMode === 'dark'
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            weight: "semibold",
                            color: "color.text",
                            children: "LABS"
                        })
                    })
                ]
            })
        })
    });
};
module.exports["AILabsLozenge"] = $e5b02ec9368d4295$export$48aba4499a97f6bf;

});

parcelRegister("36Swo", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $ffeb61eca9109eeb$export$36be37b392de5213 = ({ darkMode: darkMode = false })=>{
    return darkMode ? /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        "data-testid": "ai-labs-icon-dark",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                clipPath: "url(#clip0_1466_13761)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_1466_13761",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "8.25276",
                        height: "7.89",
                        fill: "white",
                        transform: "translate(0.9375 0.0625)"
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        "data-testid": "ai-labs-icon",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                clipPath: "url(#clip0_1352_45568)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
                    fill: "#1E1F21"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_1352_45568",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "8.25276",
                        height: "7.89",
                        fill: "white",
                        transform: "translate(0.9375 0.0625)"
                    })
                })
            })
        ]
    });
};
module.exports["LabsIcon"] = $ffeb61eca9109eeb$export$36be37b392de5213;

});

parcelRegister("dAC7y", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $8jHAi = parcelRequire("8jHAi");


var $6yCpa = parcelRequire("6yCpa");


var $lqy4C = parcelRequire("lqy4C");


var $bZSO8 = parcelRequire("bZSO8");


var $bBaUQ = parcelRequire("bBaUQ");

const $f6498381976d168b$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.page.title",
        defaultMessage: "Page"
    }
});
function $f6498381976d168b$export$e324b86258d66a8f(t0) {
    const $ = (0, $frIzR.c)(22);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-page-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        t2 = (0, $bZSO8.buildCreationLink)({
            contentType: "page",
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        });
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[5] !== hybridPageLinkClick || $[6] !== onClick) {
        t3 = (e)=>{
            onClick("createPagePopoverItem");
            hybridPageLinkClick(e);
        };
        $[5] = hybridPageLinkClick;
        $[6] = onClick;
        $[7] = t3;
    } else t3 = $[7];
    const handleClick = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:page");
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($f6498381976d168b$var$messages.title);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== enforceStorageLimit || $[12] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[11] = enforceStorageLimit;
        $[12] = handleClick;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== createHref || $[15] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[14] = createHref;
        $[15] = shouldBlockCreate;
        $[16] = t7;
    } else t7 = $[16];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
            ...t7,
            testId: t8
        };
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
}
module.exports["usePageItem"] = $f6498381976d168b$export$e324b86258d66a8f;

});

parcelRegister("ejGOi", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $ZDq1z = parcelRequire("ZDq1z");


var $inPa6 = parcelRequire("inPa6");


var $gj7hi = parcelRequire("gj7hi");


var $6yCpa = parcelRequire("6yCpa");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $lqy4C = parcelRequire("lqy4C");


var $eVXGa = parcelRequire("eVXGa");


var $8aF6s = parcelRequire("8aF6s");


var $lv5Bc = parcelRequire("lv5Bc");

var $gUusY = parcelRequire("gUusY");


var $8fj5s = parcelRequire("8fj5s");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $eB1TF = parcelRequire("eB1TF");


var $bZSO8 = parcelRequire("bZSO8");


var $bBaUQ = parcelRequire("bBaUQ");


var $5nX81 = parcelRequire("5nX81");


var $fCfQ7 = parcelRequire("fCfQ7");


var $98wxI = parcelRequire("98wxI");


var $dcUvx = parcelRequire("dcUvx");

const $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT = 'cc-whiteboard-nudge-global-create-experiment';
const $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT_PARAM = 'globalCreateCohort';
const $10e7e2c648ba4dd0$export$118062d2c7c760ca = {
    experimentName: $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT,
    cohort: $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT_PARAM
};
const $10e7e2c648ba4dd0$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.whiteboard.title",
        defaultMessage: "Whiteboard"
    },
    toolTipTextAnonymous: {
        id: "create-blank-fabric-page.universal-create.whiteboard.tooltip.text-anonymous",
        defaultMessage: "Log in to create a whiteboard"
    },
    toolTipTextUnlicensed: {
        id: "create-blank-fabric-page.universal-create.whiteboard.tooltip.text-unlicensed",
        defaultMessage: "Sign up to Confluence to create a whiteboard"
    }
});
const $10e7e2c648ba4dd0$var$PAYWALL_EXPERIENCE_ATTRIBUTES = {
    contentType: 'whiteboard',
    paywallFlow: 'upfront'
};
const $10e7e2c648ba4dd0$var$f1GameStyles = {
    itemWrapper: "_4cvr1h6o _1bah1yb4 _1e0c1txw _kqswh2mm",
    childrenWrapper: "_16jlkb7n",
    rightIcon: "_4t3idlk8 _kqswstnw _1xi2pxbi _lcxvglyw"
};
const $10e7e2c648ba4dd0$var$F1GameWrapper = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { children: children } = t0;
    const [showRacecarIcon, setShowRacecarIcon] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (_)=>{
            (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && setShowRacecarIcon(true);
        };
        $[0] = t1;
    } else t1 = $[0];
    const handleOnMouseEnter = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (__0)=>{
            (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && setShowRacecarIcon(false);
        };
        $[1] = t2;
    } else t2 = $[1];
    const handleOnMouseLeave = t2;
    let t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $gMc0m.default)([
            $10e7e2c648ba4dd0$var$f1GameStyles.itemWrapper
        ]);
        t4 = (0, $gMc0m.default)([
            $10e7e2c648ba4dd0$var$f1GameStyles.childrenWrapper
        ]);
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    let t5;
    if ($[4] !== children) {
        t5 = children();
        $[4] = children;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t4
        }, t5);
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== showRacecarIcon) {
        t7 = showRacecarIcon && (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dcUvx))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($dcUvx))),
            alt: "",
            testId: "confluence-whiteboards-car-icon",
            className: (0, $gMc0m.default)([
                $10e7e2c648ba4dd0$var$f1GameStyles.rightIcon
            ])
        });
        $[8] = showRacecarIcon;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== t6 || $[11] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: handleOnMouseEnter,
            onFocus: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            onBlur: handleOnMouseLeave,
            className: t3
        }, t6, t7);
        $[10] = t6;
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
};
function $10e7e2c648ba4dd0$export$15c9136e9dd6e3b5(t0) {
    const $ = (0, $frIzR.c)(59);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isOpen: isOpen } = (0, $eB1TF.useUniversalCreateState)();
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== isOpen) {
        t1 = (0, $9wGTI.fg)("load-whiteboards-paywall-query-when-menu-is-open") && !isOpen;
        $[0] = isOpen;
        $[1] = t1;
    } else t1 = $[1];
    const skipPaywallQuery = t1;
    const { deactivationIdentifier: deactivationIdentifier, error: creationPaywallError, paywallStatus: paywallStatus, showPaywallBeforeCreate: showPaywallBeforeCreate } = (0, $5nX81.useWhiteboardCreationPaywall)(skipPaywallQuery);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            source: "create-whiteboard-popover-item"
        };
        $[2] = t2;
    } else t2 = $[2];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t2);
    let t3;
    if ($[3] !== deactivationIdentifier || $[4] !== parentId || $[5] !== paywallStatus || $[6] !== source || $[7] !== spaceKey) {
        t3 = (t4, t5)=>{
            const creationOverrides = t4 === undefined ? {} : t4;
            const sourceSuffix = t5 === undefined ? "" : t5;
            return (0, $bZSO8.buildCreationLink)({
                contentType: "whiteboard",
                parentPageId: parentId,
                withFallback: true,
                source: source + sourceSuffix,
                spaceKey: spaceKey,
                deactivationIdentifier: deactivationIdentifier,
                paywallStatus: paywallStatus,
                ...creationOverrides
            });
        };
        $[3] = deactivationIdentifier;
        $[4] = parentId;
        $[5] = paywallStatus;
        $[6] = source;
        $[7] = spaceKey;
        $[8] = t3;
    } else t3 = $[8];
    const buildWhiteboardCreationLink = t3;
    let t4;
    if ($[9] !== buildWhiteboardCreationLink) {
        t4 = buildWhiteboardCreationLink();
        $[9] = buildWhiteboardCreationLink;
        $[10] = t4;
    } else t4 = $[10];
    const createHref = t4;
    const hybridLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t5;
    if ($[11] !== buildWhiteboardCreationLink || $[12] !== createAnalyticsEvent || $[13] !== creationPaywallError || $[14] !== experienceTracker || $[15] !== hybridLinkClick || $[16] !== onClick || $[17] !== paywallStatus || $[18] !== showModal || $[19] !== showPaywallBeforeCreate || $[20] !== source) {
        t5 = (e)=>{
            onClick("createWhiteboardPopoverItem");
            if ((0, $9wGTI.fg)("confluence_content_creation_paywall_fix_enabled")) {
                experienceTracker.start({
                    name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
                    attributes: $10e7e2c648ba4dd0$var$PAYWALL_EXPERIENCE_ATTRIBUTES,
                    collect: (0, $5nX81.collectStartCreateWhiteboardExperience)
                });
                if (creationPaywallError) experienceTracker.fail({
                    name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
                    error: creationPaywallError
                });
            }
            if (showPaywallBeforeCreate) {
                e.stopPropagation();
                e.preventDefault();
                showModal((0, $fCfQ7.WhiteboardCreationPaywallDialog), {
                    buildWhiteboardCreationLink: buildWhiteboardCreationLink
                });
            } else {
                if (paywallStatus === (0, $98wxI.PaywallStatus).UNSET) createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "createUnsetWhiteboardLink",
                        source: source,
                        attributes: {
                            reason: creationPaywallError ? "error" : "loading"
                        }
                    }
                }).fire();
                hybridLinkClick(e);
            }
        };
        $[11] = buildWhiteboardCreationLink;
        $[12] = createAnalyticsEvent;
        $[13] = creationPaywallError;
        $[14] = experienceTracker;
        $[15] = hybridLinkClick;
        $[16] = onClick;
        $[17] = paywallStatus;
        $[18] = showModal;
        $[19] = showPaywallBeforeCreate;
        $[20] = source;
        $[21] = t5;
    } else t5 = $[21];
    const handleClick = t5;
    const { getExperiment: getExperiment, skipCoordinationClientForExperiment: skipCoordinationClientForExperiment } = (0, $gUusY.useWhiteboardNudgeExperiments)($10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT, $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT_PARAM);
    const [isWhiteboardExperimentationSpotlightActive, stopWhiteboardExperimentationSpotlight] = (0, $8fj5s.useSkippableCoordination)("cc-whiteboards-nudge-exp-spotlight-v2", shouldBlockCreate || skipCoordinationClientForExperiment);
    const [isSpotlightOpen, setIsSpotlightOpen] = (0, $42omo.useState)(true);
    let t6;
    if ($[22] !== getExperiment || $[23] !== isWhiteboardExperimentationSpotlightActive) {
        t6 = isWhiteboardExperimentationSpotlightActive && getExperiment($10e7e2c648ba4dd0$export$118062d2c7c760ca.experimentName, $10e7e2c648ba4dd0$export$118062d2c7c760ca.cohort, true) === "variation";
        $[22] = getExperiment;
        $[23] = isWhiteboardExperimentationSpotlightActive;
        $[24] = t6;
    } else t6 = $[24];
    const isEligibleToSeeSpotlight = t6;
    let t7;
    if ($[25] !== stopWhiteboardExperimentationSpotlight) {
        t7 = ()=>{
            setIsSpotlightOpen(false);
            stopWhiteboardExperimentationSpotlight();
        };
        $[25] = stopWhiteboardExperimentationSpotlight;
        $[26] = t7;
    } else t7 = $[26];
    const handleSpotlightClose = t7;
    let t8;
    if ($[27] !== createHref || $[28] !== handleClick || $[29] !== handleSpotlightClose || $[30] !== source) {
        t8 = (t9)=>{
            const { children: children } = t9;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lv5Bc.CreateWhiteboardExperimentPopoverItemSpotlight), {
                createHref: createHref,
                spotlightDialogPlacement: "right middle",
                handleSpotlightClose: handleSpotlightClose,
                handleClosePopoverMenu: handleClick,
                source: source,
                shouldWatchTarget: true
            }, children());
        };
        $[27] = createHref;
        $[28] = handleClick;
        $[29] = handleSpotlightClose;
        $[30] = source;
        $[31] = t8;
    } else t8 = $[31];
    const WhiteboardSpotlightWrapper = t8;
    let t9;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:whiteboard");
        $[32] = t9;
    } else t9 = $[32];
    let t10;
    if ($[33] !== creationPaywallError) {
        t10 = !(0, $9wGTI.fg)("confluence_content_creation_paywall_fix_enabled") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
            collect: (0, $5nX81.collectStartCreateWhiteboardExperience),
            attributes: $10e7e2c648ba4dd0$var$PAYWALL_EXPERIENCE_ATTRIBUTES
        }), creationPaywallError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
            name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
            error: creationPaywallError
        }));
        $[33] = creationPaywallError;
        $[34] = t10;
    } else t10 = $[34];
    let t11;
    if ($[35] !== formatMessage) {
        t11 = formatMessage($10e7e2c648ba4dd0$var$messages.title);
        $[35] = formatMessage;
        $[36] = t11;
    } else t11 = $[36];
    let t12;
    if ($[37] !== t10 || $[38] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, t10, t11);
        $[37] = t10;
        $[38] = t11;
        $[39] = t12;
    } else t12 = $[39];
    let t13;
    if ($[40] !== enforceStorageLimit || $[41] !== handleClick) {
        t13 = enforceStorageLimit(handleClick);
        $[40] = enforceStorageLimit;
        $[41] = handleClick;
        $[42] = t13;
    } else t13 = $[42];
    let t14;
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && {
            Wrapper: $10e7e2c648ba4dd0$var$F1GameWrapper
        };
        $[43] = t14;
    } else t14 = $[43];
    let t15;
    if ($[44] !== createHref || $[45] !== isAllowedToCreateWhiteboard || $[46] !== shouldBlockCreate) {
        t15 = !shouldBlockCreate && isAllowedToCreateWhiteboard && {
            href: createHref
        };
        $[44] = createHref;
        $[45] = isAllowedToCreateWhiteboard;
        $[46] = shouldBlockCreate;
        $[47] = t15;
    } else t15 = $[47];
    let t16;
    if ($[48] !== WhiteboardSpotlightWrapper || $[49] !== isAllowedToCreateWhiteboard || $[50] !== isEligibleToSeeSpotlight || $[51] !== isSpotlightOpen) {
        t16 = isSpotlightOpen && isEligibleToSeeSpotlight && isAllowedToCreateWhiteboard && {
            Wrapper: WhiteboardSpotlightWrapper
        };
        $[48] = WhiteboardSpotlightWrapper;
        $[49] = isAllowedToCreateWhiteboard;
        $[50] = isEligibleToSeeSpotlight;
        $[51] = isSpotlightOpen;
        $[52] = t16;
    } else t16 = $[52];
    const t17 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t18;
    if ($[53] !== t12 || $[54] !== t13 || $[55] !== t15 || $[56] !== t16 || $[57] !== t17) {
        t18 = {
            ati: t9,
            children: t12,
            onClick: t13,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
            ...t14,
            ...t15,
            ...t16,
            testId: t17
        };
        $[53] = t12;
        $[54] = t13;
        $[55] = t15;
        $[56] = t16;
        $[57] = t17;
        $[58] = t18;
    } else t18 = $[58];
    return t18;
}
module.exports["useWhiteboardItem"] = $10e7e2c648ba4dd0$export$15c9136e9dd6e3b5;

});

parcelRegister("gfIPU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("lv5Bc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $5RBJ9 = parcelRequire("5RBJ9");

var $6cnUO = parcelRequire("6cnUO");

var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");


var $fdesk = parcelRequire("fdesk");

const $7dc6ee521626b5e5$var$i18n = (0, $cgtv4.defineMessages)({
    tryWhiteboardsButton: {
        id: "content-types-experiments.spotlight.try.whiteboards.button",
        defaultMessage: "Try whiteboards"
    },
    dismissButton: {
        id: "content-types-experiments.spotlight.dismiss.button",
        defaultMessage: "Dismiss"
    },
    body: {
        id: "content-types-experiments.spotlight.body.text",
        defaultMessage: "Collaborate on ideas and visualize work with whiteboards."
    }
});
const $7dc6ee521626b5e5$var$spotlightBodyContainer = (0, $ecnYn.xcss)({
    height: '60px'
});
const $7dc6ee521626b5e5$export$93870b810be7c78 = ({ children: children, createHref: createHref, handleSpotlightClose: handleSpotlightClose, handleClosePopoverMenu: handleClosePopoverMenu, spotlightDialogPlacement: spotlightDialogPlacement, source: source, shouldWatchTarget: shouldWatchTarget = false })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spotlightRef = (0, $42omo.useRef)(false);
    const close = (0, $42omo.useCallback)(()=>{
        if (!spotlightRef.current) {
            spotlightRef.current = true;
            handleSpotlightClose?.();
        }
    }, [
        handleSpotlightClose
    ]);
    // Call `handleSpotlightClose()` when this component unmounts from global create, if it wasn't already closed in order to catch when the spotlight
    // disappears if users click outside of it. This is important because we need the parent to know when to call `stop()`
    // for the EP message so we don't block other onboarding from appearing for 5 min (the default expiration time)
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            close();
        };
    }, [
        close,
        createAnalyticsEvent,
        source
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'whiteboardNudgeCampaignSpotlight',
                attributes: {
                    nudgeSource: source
                }
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleTryWhiteboards = (0, $42omo.useCallback)((e)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'tryIt',
                source: 'whiteboardNudgeCampaignSpotlight',
                attributes: {
                    nudgeSource: source
                }
            }
        }).fire();
        handleClosePopoverMenu?.(e);
        close();
    }, [
        handleClosePopoverMenu,
        close,
        createAnalyticsEvent,
        source
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismiss',
                source: 'whiteboardNudgeCampaignSpotlight',
                attributes: {
                    nudgeSource: source
                }
            }
        }).fire();
        close();
    }, [
        close,
        createAnalyticsEvent,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), {
        onBlanketClicked: close
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "create-whiteboard-experimentation-spotlight"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5RBJ9.default), {
        target: "create-whiteboard-experimentation-spotlight",
        targetBgColor: "var(--ds-text-inverse, #FFFFFF)",
        targetRadius: 4,
        dialogPlacement: spotlightDialogPlacement,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($fdesk))),
        dialogWidth: 275,
        shouldWatchTarget: shouldWatchTarget,
        actions: [
            {
                href: createHref,
                onClick: handleTryWhiteboards,
                text: intl.formatMessage($7dc6ee521626b5e5$var$i18n.tryWhiteboardsButton)
            },
            {
                appearance: 'subtle',
                onClick: handleDismiss,
                text: intl.formatMessage($7dc6ee521626b5e5$var$i18n.dismissButton)
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $7dc6ee521626b5e5$var$spotlightBodyContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $7dc6ee521626b5e5$var$i18n.body)))));
};
module.exports["CreateWhiteboardExperimentPopoverItemSpotlight"] = $7dc6ee521626b5e5$export$93870b810be7c78;

});

parcelRegister("fdesk", function(module, exports) {
module.exports = new URL("WhiteboardExperimentSpotlightImage.49c94c1b.svg", import.meta.url).toString();

});

parcelRegister("gUusY", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $25403102f20c9d1a$export$3682e798c29d602a = (experiment, experimentCohort)=>{
    const getExperiment = (experimentName, cohort, shouldFireExperimentExposure)=>{
        // eslint-disable-next-line confluence-feature-gating/static-feature-gates
        const [experiment, fireExposure] = (0, $6mKj3.UNSAFE_noExposureExp)(experimentName);
        shouldFireExperimentExposure && fireExposure();
        return experiment.get(cohort, 'not-enrolled');
    };
    const currentExperimentValue = getExperiment(experiment, experimentCohort, false);
    const getSkipCoordinationClient = (experimentValue)=>{
        if (experimentValue === 'not-enrolled') return true;
        return false;
    };
    return {
        skipCoordinationClientForExperiment: getSkipCoordinationClient(currentExperimentValue),
        getExperiment: getExperiment
    };
};
module.exports["useWhiteboardNudgeExperiments"] = $25403102f20c9d1a$export$3682e798c29d602a;

});

parcelRegister("5nX81", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $euL71 = parcelRequire("euL71");


var $bQm3c = parcelRequire("bQm3c");


var $irVI7 = parcelRequire("irVI7");


var $eVXGa = parcelRequire("eVXGa");


var $98wxI = parcelRequire("98wxI");

const $4581e300b3378ab2$export$6ff73ccc41a81a83 = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const forceSkipQuery = t0 === undefined ? false : t0;
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)();
    const shouldSkipQuery = forceSkipQuery || !isAllowedToCreateWhiteboard || isPremium;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $eSUdr.default)`query useWhiteboardCreationPaywallWhiteboardCreationPaywallContentToDisableQuery{paywallContentToDisable(contentType:"whiteboard"){deactivationIdentifier link title}}`;
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== shouldSkipQuery) {
        t2 = {
            fetchPolicy: "no-cache",
            skip: shouldSkipQuery
        };
        $[1] = shouldSkipQuery;
        $[2] = t2;
    } else t2 = $[2];
    const { data: data, error: error } = (0, $xQxzY.useQuery)(t1, t2);
    if (isPremium) {
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                deactivationIdentifier: undefined,
                paywallStatus: (0, $98wxI.PaywallStatus).ACTIVE,
                showPaywallBeforeCreate: false
            };
            $[3] = t3;
        } else t3 = $[3];
        return t3;
    }
    const deactivationIdentifier = data?.paywallContentToDisable?.deactivationIdentifier;
    const t3 = data ? (0, $98wxI.PaywallStatus).ACTIVE : (0, $98wxI.PaywallStatus).UNSET;
    const t4 = Boolean(deactivationIdentifier);
    let t5;
    if ($[4] !== deactivationIdentifier || $[5] !== error || $[6] !== t3 || $[7] !== t4) {
        t5 = {
            deactivationIdentifier: deactivationIdentifier,
            error: error,
            paywallStatus: t3,
            showPaywallBeforeCreate: t4
        };
        $[4] = deactivationIdentifier;
        $[5] = error;
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
};
const $4581e300b3378ab2$export$a8c755bcaca8c3d1 = (events, experience)=>{
    const whiteboardExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE));
    if (whiteboardExperienceStart) experience.succeed();
};
module.exports["useWhiteboardCreationPaywall"] = $4581e300b3378ab2$export$6ff73ccc41a81a83;
module.exports["collectStartCreateWhiteboardExperience"] = $4581e300b3378ab2$export$a8c755bcaca8c3d1;

});

parcelRegister("fCfQ7", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $xQxzY = parcelRequire("xQxzY");


var $inPa6 = parcelRequire("inPa6");


var $2Nwuj = parcelRequire("2Nwuj");


var $fpGTa = parcelRequire("fpGTa");

var $ecnYn = parcelRequire("ecnYn");


var $9wGTI = parcelRequire("9wGTI");


var $euL71 = parcelRequire("euL71");


var $1NBp8 = parcelRequire("1NBp8");


var $bQm3c = parcelRequire("bQm3c");


var $5vUJ3 = parcelRequire("5vUJ3");


var $dPJCf = parcelRequire("dPJCf");


var $b3j2Y = parcelRequire("b3j2Y");


var $1ytiN = parcelRequire("1ytiN");


var $hQnHK = parcelRequire("hQnHK");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");


var $98wxI = parcelRequire("98wxI");

const $804515fdfa3a1f20$var$SCREEN_NAME = `${(0, $hQnHK.WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX)}upfrontDialog`;
const $804515fdfa3a1f20$var$i18n = (0, $cgtv4.defineMessages)({
    body: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body",
        defaultMessage: "You have a limit of three editable whiteboards. If you create a new whiteboard, an older whiteboard will become view-only."
    },
    // For feature flag: FREE edition variant (three whiteboards)
    bodyFree: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body-free",
        defaultMessage: "You have a limit of three editable whiteboards. If you create a new whiteboard, an older whiteboard will become view-only."
    },
    // For feature flag: STANDARD edition variant (ten whiteboards)
    bodyStandard: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body-standard",
        defaultMessage: "You have a limit of ten editable whiteboards. If you create a new whiteboard, an older whiteboard will become view-only."
    },
    bodyUpsell: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.bodyUpsell",
        defaultMessage: "To create unlimited whiteboards, upgrade to Premium."
    },
    bodyAdminStandard: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body-admin-standard",
        defaultMessage: "You can only edit ten whiteboards at a time. Until you upgrade, your oldest boards will become view-only as you create new ones."
    },
    bodyEndUserStandard: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body-end-user-standard",
        defaultMessage: "You can only edit ten whiteboards at a time. Until you upgrade through your admin, your oldest boards will become view-only as you create new ones."
    },
    bodyAdminFree: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body-admin-free",
        defaultMessage: "You can only edit three whiteboards at a time. Until you upgrade, your oldest boards will become view-only as you create new ones."
    },
    bodyEndUserFree: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body-end-user-free",
        defaultMessage: "You can only edit three whiteboards at a time. Until you upgrade through your admin, your oldest boards will become view-only as you create new ones."
    },
    createWhiteboard: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.createWhiteboard",
        defaultMessage: "Create whiteboard"
    },
    defaultTitle: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.defaultWhiteboardName",
        defaultMessage: "An older board will become view-only"
    },
    learnMore: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.learnMore",
        defaultMessage: "Learn about usage"
    },
    title: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.title",
        defaultMessage: "{whiteboardName} will become view-only"
    }
});
const $804515fdfa3a1f20$var$whiteboardLinkStyle = (0, $ecnYn.xcss)({
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
    }
});
const $804515fdfa3a1f20$var$DialogTitle = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { href: href, name: name } = t0;
    const renderWhiteboardLink = $804515fdfa3a1f20$var$_temp;
    let t1;
    if ($[0] !== href || $[1] !== name) {
        t1 = ()=>{
            if (!name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$804515fdfa3a1f20$var$i18n.defaultTitle,
                tagName: "span"
            });
            const whiteboardName_0 = href ? renderWhiteboardLink(`${(0, $1NBp8.WIKI).toUrl()}${href}`, name) : name;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$804515fdfa3a1f20$var$i18n.title,
                values: {
                    whiteboardName: whiteboardName_0
                }
            });
        };
        $[0] = href;
        $[1] = name;
        $[2] = t1;
    } else t1 = $[2];
    const getTitleText = t1;
    let t2;
    if ($[3] !== getTitleText) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-testid": "paywall-title"
        }, getTitleText());
        $[3] = getTitleText;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
const $804515fdfa3a1f20$export$9736e1fe2430fa6 = (t0)=>{
    const $ = (0, $frIzR.c)(40);
    const { onClose: onClose, onCloseComplete: onCloseComplete, buildWhiteboardCreationLink: buildWhiteboardCreationLink } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const sessionData = (0, $bQm3c.useSessionData)();
    const edition = sessionData?.edition;
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $eSUdr.default)`query WhiteboardCreationPaywallDialogWhiteboardCreationPaywallContentToDisableQuery{paywallContentToDisable(contentType:"whiteboard"){deactivationIdentifier link title}}`;
        t2 = {
            fetchPolicy: "no-cache"
        };
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)(t1, t2);
    let deactivationIdentifier;
    let link;
    let t3;
    let title;
    if ($[2] !== buildWhiteboardCreationLink || $[3] !== data?.paywallContentToDisable) {
        ({ link: link, title: title, deactivationIdentifier: deactivationIdentifier } = data?.paywallContentToDisable || {});
        t3 = buildWhiteboardCreationLink({
            deactivationIdentifier: deactivationIdentifier,
            paywallStatus: (0, $98wxI.PaywallStatus).ACTIVE
        }, "-creationPaywall");
        $[2] = buildWhiteboardCreationLink;
        $[3] = data?.paywallContentToDisable;
        $[4] = deactivationIdentifier;
        $[5] = link;
        $[6] = t3;
        $[7] = title;
    } else {
        deactivationIdentifier = $[4];
        link = $[5];
        t3 = $[6];
        title = $[7];
    }
    const creationHref = t3;
    let t4;
    let t5;
    if ($[8] !== createAnalyticsEvent || $[9] !== creationHref || $[10] !== deactivationIdentifier || $[11] !== error || $[12] !== loading || $[13] !== onClose || $[14] !== onCloseComplete || $[15] !== push) {
        t4 = ()=>{
            if (!loading && !error && !deactivationIdentifier) {
                push(creationHref);
                createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        action: "autoCreate",
                        actionSubject: "activeSlotAvailableAfterRenderingCreationPaywall",
                        source: $804515fdfa3a1f20$var$SCREEN_NAME
                    }
                }).fire();
                onClose();
                onCloseComplete();
            }
        };
        t5 = [
            deactivationIdentifier,
            loading,
            error,
            creationHref,
            onClose,
            onCloseComplete,
            push,
            createAnalyticsEvent
        ];
        $[8] = createAnalyticsEvent;
        $[9] = creationHref;
        $[10] = deactivationIdentifier;
        $[11] = error;
        $[12] = loading;
        $[13] = onClose;
        $[14] = onCloseComplete;
        $[15] = push;
        $[16] = t4;
        $[17] = t5;
    } else {
        t4 = $[16];
        t5 = $[17];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[18] !== onClose || $[19] !== onCloseComplete) {
        t6 = ()=>{
            onClose();
            onCloseComplete();
        };
        $[18] = onClose;
        $[19] = onCloseComplete;
        $[20] = t6;
    } else t6 = $[20];
    let t7;
    if ($[21] !== creationHref || $[22] !== t6) {
        t7 = {
            actionSubjectId: "whiteboardPaywallCreateNewWhiteboardButton",
            messageDescriptor: $804515fdfa3a1f20$var$i18n.createWhiteboard,
            href: creationHref,
            onClick: t6,
            target: "_self"
        };
        $[21] = creationHref;
        $[22] = t6;
        $[23] = t7;
    } else t7 = $[23];
    const creationLink = t7;
    let t8;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
            actionSubjectId: (0, $hQnHK.WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID),
            href: "https://support.atlassian.com/confluence-cloud/docs/understand-confluence-whiteboards-plans-and-features/",
            messageDescriptor: $804515fdfa3a1f20$var$i18n.learnMore
        };
        $[24] = t8;
    } else t8 = $[24];
    const learnMoreLink = t8;
    let bodyMessage = $804515fdfa3a1f20$var$i18n.body;
    if ((0, $9wGTI.fg)("ten_active_boards_in_standard")) {
        if (edition === (0, $euL71.ConfluenceEdition).STANDARD) bodyMessage = isSiteAdmin ? $804515fdfa3a1f20$var$i18n.bodyAdminStandard : $804515fdfa3a1f20$var$i18n.bodyEndUserStandard;
        else bodyMessage = isSiteAdmin ? $804515fdfa3a1f20$var$i18n.bodyAdminFree : $804515fdfa3a1f20$var$i18n.bodyEndUserFree;
    }
    let t9;
    if ($[25] !== link || $[26] !== title) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($804515fdfa3a1f20$var$DialogTitle, {
            href: link,
            name: title
        });
        $[25] = link;
        $[26] = title;
        $[27] = t9;
    } else t9 = $[27];
    let t10;
    if ($[28] !== bodyMessage) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...bodyMessage,
            tagName: "p"
        });
        $[28] = bodyMessage;
        $[29] = t10;
    } else t10 = $[29];
    let t11;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = !(0, $9wGTI.fg)("ten_active_boards_in_standard") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$804515fdfa3a1f20$var$i18n.bodyUpsell,
            tagName: "p"
        });
        $[30] = t11;
    } else t11 = $[30];
    let t12;
    if ($[31] !== error) {
        t12 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
            name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
            error: error
        }));
        $[31] = error;
        $[32] = t12;
    } else t12 = $[32];
    let t13;
    if ($[33] !== creationLink || $[34] !== onClose || $[35] !== onCloseComplete || $[36] !== t10 || $[37] !== t12 || $[38] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5vUJ3.WhiteboardsActiveBoardLimitModal), {
            learnMoreLink: learnMoreLink,
            onClose: onClose,
            onCloseComplete: onCloseComplete,
            secondaryLink: creationLink,
            source: $804515fdfa3a1f20$var$SCREEN_NAME,
            title: t9,
            upgradeEditionActionSubjectId: (0, $hQnHK.WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID)
        }, t10, t11, t12);
        $[33] = creationLink;
        $[34] = onClose;
        $[35] = onCloseComplete;
        $[36] = t10;
        $[37] = t12;
        $[38] = t9;
        $[39] = t13;
    } else t13 = $[39];
    return t13;
};
function $804515fdfa3a1f20$var$_temp(url, whiteboardName) {
    if ((0, $9wGTI.fg)("ten_active_boards_in_standard")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
        xcss: $804515fdfa3a1f20$var$whiteboardLinkStyle,
        href: url
    }, whiteboardName);
    if ((0, $9wGTI.fg)("dst-a11y__replace-anchor-with-link__content-types")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: url,
        target: "_blank"
    }, whiteboardName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        href: url,
        target: "_blank"
    }, whiteboardName);
}
module.exports["WhiteboardCreationPaywallDialog"] = $804515fdfa3a1f20$export$9736e1fe2430fa6;

});

parcelRegister("5vUJ3", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $ci7Ox = parcelRequire("ci7Ox");


var $gj7hi = parcelRequire("gj7hi");


var $8TTLA = parcelRequire("8TTLA");

var $8CZUH = parcelRequire("8CZUH");


var $3gadb = parcelRequire("3gadb");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $9wGTI = parcelRequire("9wGTI");


var $1ytiN = parcelRequire("1ytiN");


var $euL71 = parcelRequire("euL71");


var $lHQAj = parcelRequire("lHQAj");


var $hvXOl = parcelRequire("hvXOl");


var $5hK0S = parcelRequire("5hK0S");


var $iDxbX = parcelRequire("iDxbX");


var $2aQ91 = parcelRequire("2aQ91");


var $cHKtk = parcelRequire("cHKtk");

const $5b99abaa71dd0a9a$var$CardWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko22hw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko22hw",
            __cmplp.className
        ])
    });
});
const $5b99abaa71dd0a9a$var$getLinkAppearance = (isSiteAdmin, secondaryLink, endUserRequestUpgradeButtonExists)=>{
    if (endUserRequestUpgradeButtonExists) return 'default';
    else if (secondaryLink.appearance) return secondaryLink.appearance;
    return isSiteAdmin ? 'link' : 'primary';
};
const $5b99abaa71dd0a9a$var$WhiteboardsActiveBoardLimitModalContents = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(44);
    const { children: children, learnMoreLink: learnMoreLink, secondaryLink: secondaryLink, onClose: onClose, source: source, title: title, upgradeEditionActionSubjectId: upgradeEditionActionSubjectId } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { showRequestUpgradeButton: showRequestUpgradeButton, loading: loading } = (0, $cHKtk.useEnableEndUserRequestUpgrade)(source);
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== source) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: source
                }
            }).fire();
        };
        t2 = [
            createAnalyticsEvent,
            source
        ];
        $[0] = createAnalyticsEvent;
        $[1] = source;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[4] !== createAnalyticsEvent || $[5] !== learnMoreLink.actionSubjectId || $[6] !== source) {
        t3 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: learnMoreLink.actionSubjectId,
                    source: source
                }
            }).fire();
        };
        $[4] = createAnalyticsEvent;
        $[5] = learnMoreLink.actionSubjectId;
        $[6] = source;
        $[7] = t3;
    } else t3 = $[7];
    const fireLearnMoreClickedAnalytics = t3;
    let t4;
    if ($[8] !== isSiteAdmin) {
        t4 = isSiteAdmin && !(0, $9wGTI.fg)("ten_active_boards_in_standard");
        $[8] = isSiteAdmin;
        $[9] = t4;
    } else t4 = $[9];
    const showLearnMoreButton = t4;
    let t5;
    if ($[10] !== children) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[10] = children;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== learnMoreLink || $[13] !== showRequestUpgradeButton) {
        t6 = showRequestUpgradeButton ? undefined : {
            ...learnMoreLink,
            appearance: learnMoreLink.appearance || "link"
        };
        $[12] = learnMoreLink;
        $[13] = showRequestUpgradeButton;
        $[14] = t6;
    } else t6 = $[14];
    const t7 = Boolean(showRequestUpgradeButton);
    let t8;
    if ($[15] !== isSiteAdmin || $[16] !== secondaryLink || $[17] !== t7) {
        t8 = $5b99abaa71dd0a9a$var$getLinkAppearance(isSiteAdmin, secondaryLink, t7);
        $[15] = isSiteAdmin;
        $[16] = secondaryLink;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== secondaryLink || $[20] !== t8) {
        t9 = {
            ...secondaryLink,
            appearance: t8
        };
        $[19] = secondaryLink;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    let t10;
    if ($[22] !== fireLearnMoreClickedAnalytics || $[23] !== formatMessage || $[24] !== learnMoreLink.href || $[25] !== learnMoreLink.messageDescriptor || $[26] !== showLearnMoreButton) {
        t10 = showLearnMoreButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage(learnMoreLink.messageDescriptor)
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "subtle-link",
                href: learnMoreLink.href,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
                    label: formatMessage(learnMoreLink.messageDescriptor),
                    color: "var(--ds-text-subtle, #505258)"
                }),
                spacing: "none",
                target: "_blank",
                ...tooltipProps,
                onClick: (event)=>{
                    tooltipProps?.onClick?.(event);
                    fireLearnMoreClickedAnalytics();
                }
            }));
        $[22] = fireLearnMoreClickedAnalytics;
        $[23] = formatMessage;
        $[24] = learnMoreLink.href;
        $[25] = learnMoreLink.messageDescriptor;
        $[26] = showLearnMoreButton;
        $[27] = t10;
    } else t10 = $[27];
    let t11;
    if ($[28] !== onClose) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
            testId: "whiteboards-active-board-modal-close-button",
            onClick: ()=>{
                onClose?.("close");
            }
        });
        $[28] = onClose;
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== t10 || $[31] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t10, t11);
        $[30] = t10;
        $[31] = t11;
        $[32] = t12;
    } else t12 = $[32];
    let t13;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: (0, $9wGTI.fg)("ten_active_boards_in_standard") ? (0, (/*@__PURE__*/$parcel$interopDefault($iDxbX))) : (0, (/*@__PURE__*/$parcel$interopDefault($hvXOl))),
            srcDark: (0, $9wGTI.fg)("ten_active_boards_in_standard") ? (0, (/*@__PURE__*/$parcel$interopDefault($2aQ91))) : (0, (/*@__PURE__*/$parcel$interopDefault($5hK0S))),
            alt: "",
            width: "100%"
        });
        $[33] = t13;
    } else t13 = $[33];
    let t14;
    if ($[34] !== loading || $[35] !== showRequestUpgradeButton || $[36] !== source || $[37] !== t12 || $[38] !== t5 || $[39] !== t6 || $[40] !== t9 || $[41] !== title || $[42] !== upgradeEditionActionSubjectId) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5b99abaa71dd0a9a$var$CardWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lHQAj.Card), {
            body: t5,
            isLoadingRequestUpgradeButton: loading,
            showRequestUpgradeButton: showRequestUpgradeButton,
            learnMoreLink: t6,
            secondaryLink: t9,
            source: source,
            targetEdition: (0, $euL71.ConfluenceEdition).PREMIUM,
            title: title,
            upgradeEditionActionSubjectId: upgradeEditionActionSubjectId,
            headerButton: t12
        }, t13));
        $[34] = loading;
        $[35] = showRequestUpgradeButton;
        $[36] = source;
        $[37] = t12;
        $[38] = t5;
        $[39] = t6;
        $[40] = t9;
        $[41] = title;
        $[42] = upgradeEditionActionSubjectId;
        $[43] = t14;
    } else t14 = $[43];
    return t14;
} : ({ children: children, learnMoreLink: learnMoreLink, secondaryLink: secondaryLink, onClose: onClose, source: source, title: title, upgradeEditionActionSubjectId: upgradeEditionActionSubjectId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { showRequestUpgradeButton: showRequestUpgradeButton, loading: loading } = (0, $cHKtk.useEnableEndUserRequestUpgrade)(source);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: source
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const fireLearnMoreClickedAnalytics = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: learnMoreLink.actionSubjectId,
                source: source
            }
        }).fire();
    };
    const showLearnMoreButton = isSiteAdmin && !(0, $9wGTI.fg)('ten_active_boards_in_standard');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5b99abaa71dd0a9a$var$CardWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lHQAj.Card), {
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children),
        isLoadingRequestUpgradeButton: loading,
        showRequestUpgradeButton: showRequestUpgradeButton,
        learnMoreLink: showRequestUpgradeButton ? undefined : {
            ...learnMoreLink,
            appearance: learnMoreLink.appearance || 'link'
        },
        secondaryLink: {
            ...secondaryLink,
            appearance: $5b99abaa71dd0a9a$var$getLinkAppearance(isSiteAdmin, secondaryLink, Boolean(showRequestUpgradeButton))
        },
        source: source,
        targetEdition: (0, $euL71.ConfluenceEdition).PREMIUM,
        title: title,
        upgradeEditionActionSubjectId: upgradeEditionActionSubjectId,
        headerButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, showLearnMoreButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage(learnMoreLink.messageDescriptor)
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "subtle-link",
                href: learnMoreLink.href,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
                    label: formatMessage(learnMoreLink.messageDescriptor),
                    color: "var(--ds-text-subtle, #505258)"
                }),
                spacing: "none",
                target: "_blank",
                ...tooltipProps,
                onClick: (event)=>{
                    tooltipProps?.onClick?.(event);
                    fireLearnMoreClickedAnalytics();
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
            testId: "whiteboards-active-board-modal-close-button",
            onClick: ()=>{
                onClose?.('close');
            }
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, $9wGTI.fg)('ten_active_boards_in_standard') ? (0, (/*@__PURE__*/$parcel$interopDefault($iDxbX))) : (0, (/*@__PURE__*/$parcel$interopDefault($hvXOl))),
        srcDark: (0, $9wGTI.fg)('ten_active_boards_in_standard') ? (0, (/*@__PURE__*/$parcel$interopDefault($2aQ91))) : (0, (/*@__PURE__*/$parcel$interopDefault($5hK0S))),
        alt: "",
        width: "100%"
    })));
};
const $5b99abaa71dd0a9a$var$WrappedWhiteboardsActiveBoardLimitModalContents = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
})($5b99abaa71dd0a9a$var$WhiteboardsActiveBoardLimitModalContents);
const $5b99abaa71dd0a9a$export$f66bbc4d5ea612d4 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    if ($[0] !== props) {
        t0 = ()=>props.onClose?.("close");
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5b99abaa71dd0a9a$var$WrappedWhiteboardsActiveBoardLimitModalContents, props);
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== props.onCloseComplete || $[5] !== t0 || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
            onClose: t0,
            onCloseComplete: props.onCloseComplete,
            shouldScrollInViewport: true,
            testId: "whiteboards-upsell-modal",
            width: "440px"
        }, t1);
        $[4] = props.onCloseComplete;
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        onClose: ()=>props.onClose?.('close'),
        onCloseComplete: props.onCloseComplete,
        shouldScrollInViewport: true,
        testId: "whiteboards-upsell-modal",
        width: "440px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5b99abaa71dd0a9a$var$WrappedWhiteboardsActiveBoardLimitModalContents, props));
module.exports["WhiteboardsActiveBoardLimitModal"] = $5b99abaa71dd0a9a$export$f66bbc4d5ea612d4;

});

parcelRegister("lHQAj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4WmbV = parcelRequire("4WmbV");

const $5558feba06e8dbf9$export$60332b2344f7fe41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            ...props,
            withTasteAndToneStyling: true,
            buttonGroupAlignment: "right"
        }));
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardLayout, null, t1, t2);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardLayout, null, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true,
        buttonGroupAlignment: "right"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardLayout = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardSectionMessageContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardContentsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18rx4jg8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18rx4jg8",
            __cmplp.className
        ])
    });
});
$5558feba06e8dbf9$var$CardContentsContainer.displayName = 'CardContentsContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardWithBorderAndBox = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$export$8a23e74e5cf3ca41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
module.exports["Card"] = $5558feba06e8dbf9$export$60332b2344f7fe41;
module.exports["CardContainer"] = $5558feba06e8dbf9$export$8a23e74e5cf3ca41;

});

parcelRegister("4WmbV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $hArLp = parcelRequire("hArLp");

var $eEA8O = parcelRequire("eEA8O");


var $1ytiN = parcelRequire("1ytiN");


var $iJ9aA = parcelRequire("iJ9aA");


var $ki6F7 = parcelRequire("ki6F7");


var $k4Vdy = parcelRequire("k4Vdy");


var $iC1wS = parcelRequire("iC1wS");


var $lNKOh = parcelRequire("lNKOh");


var $bhvFb = parcelRequire("bhvFb");


var $9wGTI = parcelRequire("9wGTI");


var $cHKtk = parcelRequire("cHKtk");


var $kpYGL = parcelRequire("kpYGL");

var $3a454656eb0e87cd$export$d33a80488b9cab17 = /*#__PURE__*/ function(SectionMessageButtonConfig) {
    SectionMessageButtonConfig["DEFAULT"] = "default";
    SectionMessageButtonConfig["UPGRADE_ONLY"] = "upgradeOnly";
    SectionMessageButtonConfig["NONE"] = "none";
    return SectionMessageButtonConfig;
}({});
const $3a454656eb0e87cd$export$2e68cfab3dc25476 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(61);
    let footer;
    let grandfathered;
    let headerButton;
    let learnMoreLink;
    let onUpFlowOpen;
    let props;
    let secondaryLink;
    let source;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let targetEdition;
    if ($[0] !== t0) {
        ({ canShowUpgradeButton: t1, buttonConfig: t2, upgradeEditionActionSubjectId: t3, grandfathered: grandfathered, source: source, onUpFlowOpen: onUpFlowOpen, secondaryLink: secondaryLink, targetEdition: targetEdition, learnMoreLink: learnMoreLink, footer: footer, headerButton: headerButton, showRequestUpgradeButton: t4, isLoadingRequestUpgradeButton: t5, ...props } = t0);
        $[0] = t0;
        $[1] = footer;
        $[2] = grandfathered;
        $[3] = headerButton;
        $[4] = learnMoreLink;
        $[5] = onUpFlowOpen;
        $[6] = props;
        $[7] = secondaryLink;
        $[8] = source;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
        $[14] = targetEdition;
    } else {
        footer = $[1];
        grandfathered = $[2];
        headerButton = $[3];
        learnMoreLink = $[4];
        onUpFlowOpen = $[5];
        props = $[6];
        secondaryLink = $[7];
        source = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        t4 = $[12];
        t5 = $[13];
        targetEdition = $[14];
    }
    const canShowUpgradeButton = t1 === undefined ? true : t1;
    const buttonConfig = t2 === undefined ? "default" : t2;
    const upgradeEditionActionSubjectId = t3 === undefined ? "freeTryNow" : t3;
    const showRequestUpgradeButton = t4 === undefined ? false : t4;
    const isLoadingRequestUpgradeButton = t5 === undefined ? false : t5;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const t6 = Boolean(grandfathered);
    let t7;
    if ($[15] !== isSiteAdmin || $[16] !== t6) {
        t7 = {
            isSiteAdmin: isSiteAdmin,
            isGrandfathered: t6
        };
        $[15] = isSiteAdmin;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    const CTAAnalyticsAttributes = t7;
    let t8;
    if ($[18] !== CTAAnalyticsAttributes || $[19] !== source) {
        t8 = (actionSubjectId)=>({
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: CTAAnalyticsAttributes
            });
        $[18] = CTAAnalyticsAttributes;
        $[19] = source;
        $[20] = t8;
    } else t8 = $[20];
    const generateCTAAnalyticsProps = t8;
    let t9;
    if ($[21] !== CTAAnalyticsAttributes || $[22] !== createAnalyticsEvent || $[23] !== source) {
        t9 = (clickEventActionSubjectId, linkMessage)=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: clickEventActionSubjectId,
                    source: source,
                    attributes: {
                        ...CTAAnalyticsAttributes,
                        linkMessage: linkMessage
                    }
                }
            }).fire();
        };
        $[21] = CTAAnalyticsAttributes;
        $[22] = createAnalyticsEvent;
        $[23] = source;
        $[24] = t9;
    } else t9 = $[24];
    const triggerLinkClickAnalytics = t9;
    let t10;
    if ($[25] !== secondaryLink || $[26] !== triggerLinkClickAnalytics) {
        t10 = ()=>{
            const link = secondaryLink;
            if (link) {
                triggerLinkClickAnalytics(link.actionSubjectId, link.messageDescriptor.defaultMessage);
                if (typeof link.onClick === "function") link.onClick();
            }
        };
        $[25] = secondaryLink;
        $[26] = triggerLinkClickAnalytics;
        $[27] = t10;
    } else t10 = $[27];
    const handleSecondaryLinkClick = t10;
    let t11;
    let t12;
    if ($[28] !== CTAAnalyticsAttributes || $[29] !== createAnalyticsEvent || $[30] !== source) {
        t11 = ()=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "changeEditionGatewayScreen",
                    attributes: {
                        ...CTAAnalyticsAttributes,
                        source: source
                    }
                }
            }).fire();
        };
        t12 = [
            createAnalyticsEvent,
            CTAAnalyticsAttributes,
            source
        ];
        $[28] = CTAAnalyticsAttributes;
        $[29] = createAnalyticsEvent;
        $[30] = source;
        $[31] = t11;
        $[32] = t12;
    } else {
        t11 = $[31];
        t12 = $[32];
    }
    (0, $42omo.useEffect)(t11, t12);
    let T0;
    let t13;
    if ($[33] !== buttonConfig || $[34] !== canShowUpgradeButton || $[35] !== generateCTAAnalyticsProps || $[36] !== handleSecondaryLinkClick || $[37] !== isLoadingRequestUpgradeButton || $[38] !== isSiteAdmin || $[39] !== learnMoreLink || $[40] !== onUpFlowOpen || $[41] !== props || $[42] !== secondaryLink || $[43] !== showRequestUpgradeButton || $[44] !== source || $[45] !== targetEdition || $[46] !== upgradeEditionActionSubjectId) {
        const renderButtons = ()=>{
            if (isLoadingRequestUpgradeButton && (0, $9wGTI.fg)("connie_end_user_request_kill_switch")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
                width: "200px",
                height: "32px"
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lNKOh.ChangeEditionSectionMessageButtonsWrapper), {
                isSiteAdmin: isSiteAdmin,
                canShowUpgradeButton: canShowUpgradeButton,
                shouldShowLearnMore: !Boolean(secondaryLink),
                showRequestUpgradeButton: showRequestUpgradeButton
            }, (t14)=>{
                const { showUpgradeTryNowButton: showUpgradeTryNowButton, showLearnMore: showLearnMore, learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA } = t14;
                let primary;
                const upgradeEditionButton = showUpgradeTryNowButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ki6F7.UpgradeEditionButton), {
                    analyticsProps: generateCTAAnalyticsProps(upgradeEditionActionSubjectId),
                    onUpFlowOpen: onUpFlowOpen,
                    targetEdition: targetEdition,
                    ...props
                }) : null;
                if (upgradeEditionButton) primary = upgradeEditionButton;
                else if (showRequestUpgradeButton && (0, $9wGTI.fg)("connie_end_user_request_kill_switch")) primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cHKtk.EndUserRequestUpgradeButton), {
                    source: source
                });
                let secondaries;
                if (buttonConfig !== "upgradeOnly" || !isSiteAdmin) {
                    if (upgradeEditionButton && primary !== upgradeEditionButton) secondaries = [
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(upgradeEditionButton, {
                            appearance: "link"
                        })
                    ];
                    else secondaries = getSecondaries(showLearnMore, learnMoreIsPrimaryCTA);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primary, secondaries);
            });
        };
        const getSecondaries = (showLearnMore_0, learnMoreIsPrimaryCTA_0)=>{
            const withIcon = Boolean(learnMoreLink?.icon);
            const learnMoreAppearance = withIcon || learnMoreIsPrimaryCTA_0 ? learnMoreLink?.appearance || "default" : "link";
            const learnMoreButton = showLearnMore_0 ? renderLearnMoreLink({
                appearance: learnMoreAppearance
            }) : null;
            const secondaryLinkComponent = secondaryLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                key: "secondLink",
                appearance: secondaryLink.appearance || "default",
                href: secondaryLink.href ? secondaryLink.href : undefined,
                id: "secondaryLink",
                spacing: "default",
                target: secondaryLink.target || "_blank",
                onClick: handleSecondaryLinkClick,
                testId: (0, $k4Vdy.calculateTestId)({
                    source: source,
                    actionSubjectId: secondaryLink.actionSubjectId
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), secondaryLink.messageDescriptor)) : null;
            return secondaryLink?.appearance === "primary" && learnMoreAppearance !== "primary" ? [
                secondaryLinkComponent,
                learnMoreButton
            ] : [
                learnMoreButton,
                secondaryLinkComponent
            ];
        };
        const renderLearnMoreLink = (t15)=>{
            const { children: children, ...learnMoreProps } = t15;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ9aA.LearnMoreButton), {
                key: "learnMore",
                analyticsProps: generateCTAAnalyticsProps(learnMoreLink?.actionSubjectId || "freeLearnMore"),
                appearance: learnMoreLink?.appearance || "default",
                onUpFlowOpen: onUpFlowOpen,
                targetEdition: targetEdition,
                inProductHelpId: learnMoreLink?.inProductHelpId,
                inProductHelpTopic: learnMoreLink?.inProductHelpTopic,
                href: learnMoreLink?.href,
                icon: learnMoreLink?.icon,
                ariaLabel: learnMoreLink?.ariaLabel,
                ...learnMoreProps,
                onClick: learnMoreLink?.onClick
            }, children !== undefined ? children : learnMoreLink?.messageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), learnMoreLink.messageDescriptor) : undefined);
        };
        T0 = (0, $bhvFb.EditionSectionMessage);
        t13 = buttonConfig !== "none" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, renderButtons()) : undefined;
        $[33] = buttonConfig;
        $[34] = canShowUpgradeButton;
        $[35] = generateCTAAnalyticsProps;
        $[36] = handleSecondaryLinkClick;
        $[37] = isLoadingRequestUpgradeButton;
        $[38] = isSiteAdmin;
        $[39] = learnMoreLink;
        $[40] = onUpFlowOpen;
        $[41] = props;
        $[42] = secondaryLink;
        $[43] = showRequestUpgradeButton;
        $[44] = source;
        $[45] = targetEdition;
        $[46] = upgradeEditionActionSubjectId;
        $[47] = T0;
        $[48] = t13;
    } else {
        T0 = $[47];
        t13 = $[48];
    }
    let t14;
    if ($[49] !== footer || $[50] !== isSiteAdmin) {
        t14 = isSiteAdmin && footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, footer) : null;
        $[49] = footer;
        $[50] = isSiteAdmin;
        $[51] = t14;
    } else t14 = $[51];
    let t15;
    if ($[52] !== headerButton) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, headerButton);
        $[52] = headerButton;
        $[53] = t15;
    } else t15 = $[53];
    let t16;
    if ($[54] !== T0 || $[55] !== props || $[56] !== t13 || $[57] !== t14 || $[58] !== t15 || $[59] !== targetEdition) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            actions: t13,
            edition: targetEdition,
            footer: t14,
            headerButton: t15,
            ...props
        });
        $[54] = T0;
        $[55] = props;
        $[56] = t13;
        $[57] = t14;
        $[58] = t15;
        $[59] = targetEdition;
        $[60] = t16;
    } else t16 = $[60];
    return t16;
} : ({ canShowUpgradeButton: canShowUpgradeButton = true, buttonConfig: buttonConfig = "default", upgradeEditionActionSubjectId: upgradeEditionActionSubjectId = 'freeTryNow', grandfathered: grandfathered, source: source, onUpFlowOpen: onUpFlowOpen, secondaryLink: secondaryLink, targetEdition: targetEdition, learnMoreLink: learnMoreLink, footer: footer, headerButton: headerButton, showRequestUpgradeButton: showRequestUpgradeButton = false, isLoadingRequestUpgradeButton: isLoadingRequestUpgradeButton = false, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const CTAAnalyticsAttributes = (0, $42omo.useMemo)(()=>{
        return {
            isSiteAdmin: isSiteAdmin,
            isGrandfathered: Boolean(grandfathered)
        };
    }, [
        grandfathered,
        isSiteAdmin
    ]);
    const generateCTAAnalyticsProps = (actionSubjectId)=>({
            actionSubjectId: actionSubjectId,
            source: source,
            attributes: CTAAnalyticsAttributes
        });
    const triggerLinkClickAnalytics = (clickEventActionSubjectId, linkMessage)=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: clickEventActionSubjectId,
                source: source,
                attributes: {
                    ...CTAAnalyticsAttributes,
                    linkMessage: linkMessage
                }
            }
        }).fire();
    };
    const handleSecondaryLinkClick = ()=>{
        const link = secondaryLink;
        if (link) {
            triggerLinkClickAnalytics(link.actionSubjectId, link.messageDescriptor.defaultMessage);
            if (typeof link.onClick === 'function') link.onClick();
        }
    };
    (0, $42omo.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'changeEditionGatewayScreen',
                attributes: {
                    ...CTAAnalyticsAttributes,
                    source: source
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        CTAAnalyticsAttributes,
        source
    ]);
    const renderButtons = ()=>{
        if (isLoadingRequestUpgradeButton && (0, $9wGTI.fg)('connie_end_user_request_kill_switch')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "200px",
            height: "32px"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lNKOh.ChangeEditionSectionMessageButtonsWrapper), {
            isSiteAdmin: isSiteAdmin,
            canShowUpgradeButton: canShowUpgradeButton,
            shouldShowLearnMore: !Boolean(secondaryLink),
            showRequestUpgradeButton: showRequestUpgradeButton
        }, ({ showUpgradeTryNowButton: showUpgradeTryNowButton, showLearnMore: showLearnMore, learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA })=>{
            //
            // primary
            //
            let primary;
            const upgradeEditionButton = showUpgradeTryNowButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ki6F7.UpgradeEditionButton), {
                analyticsProps: generateCTAAnalyticsProps(upgradeEditionActionSubjectId),
                onUpFlowOpen: onUpFlowOpen,
                targetEdition: targetEdition,
                ...props
            }) : null;
            if (upgradeEditionButton) primary = upgradeEditionButton;
            else if (showRequestUpgradeButton && (0, $9wGTI.fg)('connie_end_user_request_kill_switch')) primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cHKtk.EndUserRequestUpgradeButton), {
                source: source
            });
            //
            // secondaries
            //
            let secondaries;
            if (buttonConfig !== "upgradeOnly" || !isSiteAdmin) {
                // If the 'Try it free/now' button is to be shown, but it is not the
                // primary CTA, then make sure its appearance is appropriate for a
                // secondary:
                if (upgradeEditionButton && primary !== upgradeEditionButton) secondaries = [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(upgradeEditionButton, {
                        appearance: 'link'
                    })
                ];
                else secondaries = getSecondaries(showLearnMore, learnMoreIsPrimaryCTA);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primary, secondaries);
        });
    };
    const getSecondaries = (showLearnMore_0, learnMoreIsPrimaryCTA_0)=>{
        const withIcon = Boolean(learnMoreLink?.icon);
        const learnMoreAppearance = withIcon || learnMoreIsPrimaryCTA_0 ? learnMoreLink?.appearance || 'default' : 'link';
        const learnMoreButton = showLearnMore_0 ? renderLearnMoreLink({
            appearance: learnMoreAppearance
        }) : null;
        const secondaryLinkComponent = secondaryLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            key: "secondLink",
            appearance: secondaryLink.appearance || 'default',
            href: secondaryLink.href ? secondaryLink.href : undefined,
            id: "secondaryLink",
            spacing: "default",
            target: secondaryLink.target || '_blank',
            onClick: handleSecondaryLinkClick,
            testId: (0, $k4Vdy.calculateTestId)({
                source: source,
                actionSubjectId: secondaryLink.actionSubjectId
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), secondaryLink.messageDescriptor)) : null;
        return secondaryLink?.appearance === 'primary' && learnMoreAppearance !== 'primary' ? [
            secondaryLinkComponent,
            learnMoreButton
        ] : [
            learnMoreButton,
            secondaryLinkComponent
        ];
    };
    const renderLearnMoreLink = ({ children: children, ...learnMoreProps })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ9aA.LearnMoreButton), {
            key: "learnMore",
            analyticsProps: generateCTAAnalyticsProps(learnMoreLink?.actionSubjectId || 'freeLearnMore'),
            appearance: learnMoreLink?.appearance || 'default',
            onUpFlowOpen: onUpFlowOpen,
            targetEdition: targetEdition,
            inProductHelpId: learnMoreLink?.inProductHelpId,
            inProductHelpTopic: learnMoreLink?.inProductHelpTopic,
            href: learnMoreLink?.href,
            icon: learnMoreLink?.icon,
            ariaLabel: learnMoreLink?.ariaLabel,
            ...learnMoreProps,
            onClick: learnMoreLink?.onClick
        }, children !== undefined ? children : learnMoreLink?.messageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), learnMoreLink.messageDescriptor) : undefined);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bhvFb.EditionSectionMessage), {
        actions: buttonConfig !== "none" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, renderButtons()) : undefined,
        edition: targetEdition,
        footer: isSiteAdmin && footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, footer) : null,
        headerButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, headerButton),
        ...props
    });
};
module.exports["SectionMessageButtonConfig"] = $3a454656eb0e87cd$export$d33a80488b9cab17;
module.exports["ChangeEditionSectionMessage"] = $3a454656eb0e87cd$export$2e68cfab3dc25476;

});

parcelRegister("iJ9aA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $bsrY7 = parcelRequire("bsrY7");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $eEA8O = parcelRequire("eEA8O");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $2KmnS = parcelRequire("2KmnS");


var $bQm3c = parcelRequire("bQm3c");


var $f7tt0 = parcelRequire("f7tt0");


var $gsZdA = parcelRequire("gsZdA");


var $f7Bnv = parcelRequire("f7Bnv");


var $iC1wS = parcelRequire("iC1wS");


var $euL71 = parcelRequire("euL71");


var $e5k34 = parcelRequire("e5k34");


var $k4Vdy = parcelRequire("k4Vdy");

const $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    margin: 'auto'
});
const $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding = (0, $ecnYn.xcss)({
    padding: 'space.0'
});
const $c00269aedb3a5e7e$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    tryItFree: {
        id: "change-edition.section.message.try.free",
        defaultMessage: "Try it free"
    },
    learnMoreButton: {
        id: "change-edition.section.message.general.button.link",
        defaultMessage: "Learn more"
    }
});
const $c00269aedb3a5e7e$export$628b38b203828231 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(40);
    let { analyticsProps: analyticsProps, appearance: appearance, isSiteAdmin: isSiteAdmin, onUpFlowOpen: onUpFlowOpen, targetEdition: t1, isGrandfathered: t2, inProductHelpId: inProductHelpId, inProductHelpTopic: inProductHelpTopic, href: href, children: children, icon: icon, onClick: onClick, ariaLabel: ariaLabel, ...learnMoreProps } = t0;
    const targetEdition = t1 === undefined ? (0, $euL71.ConfluenceEdition).STANDARD : t1;
    const isGrandfathered = t2 === undefined ? false : t2;
    const intl = (0, $8C5kA.default)();
    const { cloudId: cloudId, edition: edition, userId: userId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isUpFlowOpen, setIsUpFlowOpen] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const showUpFlow = isLicensed && (!isSiteAdmin || edition === (0, $euL71.ConfluenceEdition).FREE);
    const { source: source, actionSubjectId: actionSubjectId } = analyticsProps;
    const testId = (0, $k4Vdy.calculateTestId)({
        source: source,
        actionSubjectId: actionSubjectId
    });
    let t3;
    if ($[0] !== children) {
        t3 = children !== undefined ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton);
        $[0] = children;
        $[1] = t3;
    } else t3 = $[1];
    const message = t3;
    const iconOnly = icon && !message;
    let t4;
    let t5;
    if ($[2] !== experienceTracker || $[3] !== showUpFlow) {
        t4 = ()=>()=>{
                if (!showUpFlow) experienceTracker.abort({
                    name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                    reason: "Canceled by user"
                });
            };
        t5 = [
            experienceTracker,
            showUpFlow
        ];
        $[2] = experienceTracker;
        $[3] = showUpFlow;
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[6] !== actionSubjectId || $[7] !== analyticsProps || $[8] !== createAnalyticsEvent || $[9] !== edition || $[10] !== experienceTracker || $[11] !== isSiteAdmin || $[12] !== showUpFlow || $[13] !== source || $[14] !== targetEdition) {
        t6 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: "freeLearnMore",
                    ...analyticsProps,
                    attributes: {
                        currentEdition: edition,
                        isSiteAdmin: isSiteAdmin,
                        linkMessage: $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton.defaultMessage,
                        targetEdition: targetEdition,
                        ...analyticsProps.attributes
                    }
                }
            }).fire();
            experienceTracker.start({
                name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                attributes: {
                    currentEdition: edition,
                    linkClicked: actionSubjectId || "freeLearnMore",
                    source: source,
                    targetEdition: targetEdition
                }
            });
        };
        $[6] = actionSubjectId;
        $[7] = analyticsProps;
        $[8] = createAnalyticsEvent;
        $[9] = edition;
        $[10] = experienceTracker;
        $[11] = isSiteAdmin;
        $[12] = showUpFlow;
        $[13] = source;
        $[14] = targetEdition;
        $[15] = t6;
    } else t6 = $[15];
    const fireClickAnalytics = t6;
    let t7;
    if ($[16] !== onUpFlowOpen) {
        t7 = ()=>{
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($bsrY7)))(onUpFlowOpen)) setIsUpFlowOpen(false);
        };
        $[16] = onUpFlowOpen;
        $[17] = t7;
    } else t7 = $[17];
    const onUpFlowClose = t7;
    const renderLearnMoreButton = (t8)=>{
        const props = t8 === undefined ? {} : t8;
        if (appearance === "inline-link") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", props, message);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: appearance,
            className: appearance === "subtle-link" ? undefined : "primaryButton",
            id: "learnMoreLink",
            spacing: iconOnly ? "none" : "default",
            iconBefore: icon,
            testId: testId,
            ...props
        }, message);
    };
    let t9;
    if ($[18] !== createAnalyticsEvent || $[19] !== inProductHelpId) {
        t9 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "helpLink",
                    source: "adminKeyUpSell",
                    attributes: {
                        targetArticleId: inProductHelpId,
                        isSPA: true
                    }
                }
            }).fire();
        };
        $[18] = createAnalyticsEvent;
        $[19] = inProductHelpId;
        $[20] = t9;
    } else t9 = $[20];
    const fireAnalyticsEvent = t9;
    if (isGrandfathered && !isSiteAdmin) return null;
    if (!href) href = showUpFlow ? "#" : (0, $gsZdA.LEARN_MORE_LINK);
    const target = href.startsWith("#") ? undefined : "_blank";
    let t10;
    if ($[21] !== fireClickAnalytics || $[22] !== onClick || $[23] !== showUpFlow || $[24] !== target) {
        t10 = (ev)=>{
            fireClickAnalytics();
            if (onClick) {
                onClick();
                return;
            }
            if (!target && showUpFlow) {
                setIsUpFlowOpen(true);
                ev.preventDefault();
            }
        };
        $[21] = fireClickAnalytics;
        $[22] = onClick;
        $[23] = showUpFlow;
        $[24] = target;
        $[25] = t10;
    } else t10 = $[25];
    const buttonProps = {
        target: target,
        href: href,
        onClick: t10,
        "aria-label": ariaLabel && intl.formatMessage(ariaLabel),
        testId: testId,
        ...learnMoreProps
    };
    const t11 = !showUpFlow && inProductHelpId && inProductHelpTopic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: iconOnly ? $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding : $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7tt0.InProductHelpButton), {
        articleId: inProductHelpId,
        onClick: fireAnalyticsEvent,
        articleTopic: inProductHelpTopic,
        testId: testId,
        ...learnMoreProps
    }, iconOnly ? icon : message)) : renderLearnMoreButton(buttonProps);
    let t12;
    if ($[26] !== cloudId || $[27] !== edition || $[28] !== isSiteAdmin || $[29] !== isUpFlowOpen || $[30] !== onUpFlowClose || $[31] !== onUpFlowOpen || $[32] !== showUpFlow || $[33] !== source || $[34] !== targetEdition || $[35] !== userId) {
        t12 = showUpFlow && isUpFlowOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
            cloudId: cloudId,
            atlassianAccountId: userId || undefined,
            canChangeEdition: isSiteAdmin,
            currentEdition: edition || undefined,
            targetEdition: targetEdition,
            flow: (0, $2KmnS.UpFlowComponentFlowType).LEARN_MORE,
            product: "confluence",
            touchpointId: source,
            onClose: onUpFlowClose,
            onOpen: onUpFlowOpen,
            isExperienceTrackerEnabled: true,
            epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
        });
        $[26] = cloudId;
        $[27] = edition;
        $[28] = isSiteAdmin;
        $[29] = isUpFlowOpen;
        $[30] = onUpFlowClose;
        $[31] = onUpFlowOpen;
        $[32] = showUpFlow;
        $[33] = source;
        $[34] = targetEdition;
        $[35] = userId;
        $[36] = t12;
    } else t12 = $[36];
    let t13;
    if ($[37] !== t11 || $[38] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t11, t12);
        $[37] = t11;
        $[38] = t12;
        $[39] = t13;
    } else t13 = $[39];
    return t13;
} : ({ analyticsProps: analyticsProps, appearance: appearance, isSiteAdmin: isSiteAdmin, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, isGrandfathered: isGrandfathered = false, inProductHelpId: inProductHelpId, inProductHelpTopic: inProductHelpTopic, href: href, children: children, icon: icon, onClick: onClick, ariaLabel: ariaLabel, ...learnMoreProps })=>{
    const intl = (0, $8C5kA.default)();
    const { cloudId: cloudId, edition: edition, userId: userId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isUpFlowOpen, setIsUpFlowOpen] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const showUpFlow = isLicensed && (!isSiteAdmin || edition === (0, $euL71.ConfluenceEdition).FREE);
    const { source: source, actionSubjectId: actionSubjectId } = analyticsProps;
    const testId = (0, $k4Vdy.calculateTestId)({
        source: source,
        actionSubjectId: actionSubjectId
    });
    const message = children !== undefined ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton);
    const iconOnly = icon && !message;
    (0, $42omo.useEffect)(()=>()=>{
            if (!showUpFlow) experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Canceled by user'
            });
        }, [
        experienceTracker,
        showUpFlow
    ]);
    const fireClickAnalytics = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'freeLearnMore',
                ...analyticsProps,
                attributes: {
                    currentEdition: edition,
                    isSiteAdmin: isSiteAdmin,
                    linkMessage: $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton.defaultMessage,
                    targetEdition: targetEdition,
                    ...analyticsProps.attributes
                }
            }
        }).fire();
        experienceTracker.start({
            name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
            attributes: {
                currentEdition: edition,
                linkClicked: actionSubjectId || 'freeLearnMore',
                source: source,
                targetEdition: targetEdition
            }
        });
    };
    const onUpFlowClose = ()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bsrY7)))(onUpFlowOpen)) // only attempt to close if there is no onUpFlowOpen handler (as
        // UpFlowComponent will invoke it to unmount our parent already)
        setIsUpFlowOpen(false);
    };
    const renderLearnMoreButton = (props = {})=>{
        if (appearance === 'inline-link') return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", props, message));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: appearance,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
            className: appearance === 'subtle-link' ? undefined : 'primaryButton',
            id: "learnMoreLink",
            spacing: iconOnly ? 'none' : 'default',
            iconBefore: icon,
            testId: testId,
            ...props
        }, message);
    };
    const fireAnalyticsEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'helpLink',
                source: 'adminKeyUpSell',
                attributes: {
                    targetArticleId: inProductHelpId,
                    isSPA: true
                }
            }
        }).fire();
    };
    if (isGrandfathered && !isSiteAdmin) return null;
    // prioritizing href if it passed by the consumer regardless of edition type
    if (!href) href = showUpFlow ? '#' : (0, $gsZdA.LEARN_MORE_LINK);
    const target = href.startsWith('#') ? undefined : '_blank';
    const buttonProps = {
        target: target,
        href: href,
        onClick: (ev)=>{
            fireClickAnalytics();
            if (onClick) {
                onClick();
                return;
            }
            if (!target && showUpFlow) {
                setIsUpFlowOpen(true);
                ev.preventDefault();
            }
        },
        'aria-label': ariaLabel && intl.formatMessage(ariaLabel),
        testId: testId,
        ...learnMoreProps
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !showUpFlow && inProductHelpId && inProductHelpTopic ? /**
     * Special handling In Product Help Button
     * InProductHelpButton force the spacing to none, thus creating a BOX here to add back the padding and margin
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: iconOnly ? $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding : $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7tt0.InProductHelpButton), {
        articleId: inProductHelpId,
        onClick: fireAnalyticsEvent,
        articleTopic: inProductHelpTopic,
        testId: testId,
        ...learnMoreProps
    }, iconOnly ? icon : message)) : renderLearnMoreButton(buttonProps), showUpFlow && isUpFlowOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
        cloudId: cloudId,
        atlassianAccountId: userId || undefined,
        canChangeEdition: isSiteAdmin,
        currentEdition: edition || undefined,
        targetEdition: targetEdition,
        flow: (0, $2KmnS.UpFlowComponentFlowType).LEARN_MORE,
        product: "confluence",
        touchpointId: source,
        onClose: onUpFlowClose,
        onOpen: onUpFlowOpen,
        isExperienceTrackerEnabled: true,
        epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
    }));
};
const $c00269aedb3a5e7e$export$176492db868efc7f = (0, $f7Bnv.withIsSiteAdmin)($c00269aedb3a5e7e$export$628b38b203828231);
module.exports["i18n"] = $c00269aedb3a5e7e$export$a7357cdd1f0b0168;
module.exports["LearnMoreButtonComponent"] = $c00269aedb3a5e7e$export$628b38b203828231;
module.exports["LearnMoreButton"] = $c00269aedb3a5e7e$export$176492db868efc7f;

});

parcelRegister("2KmnS", function(module, exports) {
var $af6754ea8048b03c$export$a719c036dcaa8cea = /*#__PURE__*/ function(UpFlowComponentFlowType) {
    UpFlowComponentFlowType["LEARN_MORE"] = "learn-more";
    UpFlowComponentFlowType["UPGRADE"] = "upgrade";
    UpFlowComponentFlowType["REQUEST_UPGRADE"] = "request-upgrade";
    UpFlowComponentFlowType["REQUEST_LEARN_MORE"] = "request-learn-more";
    return UpFlowComponentFlowType;
}({});
module.exports["UpFlowComponentFlowType"] = $af6754ea8048b03c$export$a719c036dcaa8cea;

});

parcelRegister("f7tt0", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0dfdd35e9850cea$export$b14685a9b52779e1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xD_n9",
    name: "InProductHelpButton",
    loader: async ()=>(await (parcelRequire("j0wkI"))).InProductHelpButton
});
module.exports["InProductHelpButton"] = $d0dfdd35e9850cea$export$b14685a9b52779e1;

});

parcelRegister("j0wkI", function(module, exports) {

let $dd671919af841761$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dd671919af841761$var$load("82QsP").then(()=>parcelRequire('lcEzf'));

});

parcelRegister("gsZdA", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ const $f57489e4f8cda39e$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Cloud+plans';
var $f57489e4f8cda39e$export$fd53124e1292f3e0 = /*#__PURE__*/ function(SECTION_MESSAGE_APPEARANCE_TYPES) {
    SECTION_MESSAGE_APPEARANCE_TYPES["DEFAULT"] = "default";
    SECTION_MESSAGE_APPEARANCE_TYPES["FLAT"] = "flat";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE"] = "inline";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE_MODAL"] = "inline-modal";
    return SECTION_MESSAGE_APPEARANCE_TYPES;
}({});
const $f57489e4f8cda39e$export$9d01cd0779f8a694 = 'confluence-up-flow-modal';
module.exports["LEARN_MORE_LINK"] = $f57489e4f8cda39e$export$997e23a0aec74966;
module.exports["SECTION_MESSAGE_APPEARANCE_TYPES"] = $f57489e4f8cda39e$export$fd53124e1292f3e0;
module.exports["UP_FLOW_EP_MESSAGE_ID"] = $f57489e4f8cda39e$export$9d01cd0779f8a694;

});

parcelRegister("f7Bnv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1ytiN = parcelRequire("1ytiN");

function $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5(WrappedComponent) {
    return function WithIsSiteAdminComponent(props) {
        const { isSiteAdmin: isSiteAdmin, error: error, loading: loading } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
        if (error || loading) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            isSiteAdmin: isSiteAdmin
        });
    };
}
module.exports["withIsSiteAdmin"] = $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5;

});

parcelRegister("iC1wS", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $8ea1c6a3abbe8170$var$EditionsAnalyticsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $8ea1c6a3abbe8170$export$198c73506737f848 = (payload, data)=>({
        ...payload,
        data: {
            ...payload.data,
            attributes: {
                ...payload.data.attributes,
                ...data?.customAttributes
            }
        }
    });
const $8ea1c6a3abbe8170$export$ce3e4b18be9c194b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(8);
    const internalData = (0, $42omo.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== internalData) {
        t0 = (data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData);
        $[0] = internalData;
        $[1] = t0;
    } else t0 = $[1];
    const wrapAnalyticsEventPayload = t0;
    let t1;
    if ($[2] !== createAnalyticsEvent || $[3] !== wrapAnalyticsEventPayload) {
        t1 = (initialPayload)=>createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload));
        $[2] = createAnalyticsEvent;
        $[3] = wrapAnalyticsEventPayload;
        $[4] = t1;
    } else t1 = $[4];
    const wrappedCreateAnalyticsEvent = t1;
    let t2;
    if ($[5] !== wrapAnalyticsEventPayload || $[6] !== wrappedCreateAnalyticsEvent) {
        t2 = {
            createAnalyticsEvent: wrappedCreateAnalyticsEvent,
            wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
        };
        $[5] = wrapAnalyticsEventPayload;
        $[6] = wrappedCreateAnalyticsEvent;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ()=>{
    const internalData = (0, $42omo.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const wrapAnalyticsEventPayload = (0, $42omo.useCallback)((data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData), [
        internalData
    ]);
    const wrappedCreateAnalyticsEvent = (0, $42omo.useCallback)((initialPayload)=>createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload)), [
        createAnalyticsEvent,
        wrapAnalyticsEventPayload
    ]);
    return {
        createAnalyticsEvent: wrappedCreateAnalyticsEvent,
        wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
    };
};
const $8ea1c6a3abbe8170$var$emptyAttributes = {};
const $8ea1c6a3abbe8170$export$1b581a2ec13e37f1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, customAttributes: t1 } = t0;
    const customAttributes = t1 === undefined ? $8ea1c6a3abbe8170$var$emptyAttributes : t1;
    let t2;
    if ($[0] !== customAttributes) {
        t2 = {
            customAttributes: customAttributes
        };
        $[0] = customAttributes;
        $[1] = t2;
    } else t2 = $[1];
    const editionsAnalyticsContextValue = t2;
    let t3;
    if ($[2] !== children || $[3] !== editionsAnalyticsContextValue) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8ea1c6a3abbe8170$var$EditionsAnalyticsContext.Provider, {
            value: editionsAnalyticsContextValue
        }, children);
        $[2] = children;
        $[3] = editionsAnalyticsContextValue;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, customAttributes: customAttributes = $8ea1c6a3abbe8170$var$emptyAttributes })=>{
    const editionsAnalyticsContextValue = (0, $42omo.useMemo)(()=>({
            customAttributes: customAttributes
        }), [
        customAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8ea1c6a3abbe8170$var$EditionsAnalyticsContext.Provider, {
        value: editionsAnalyticsContextValue
    }, children);
};
const $8ea1c6a3abbe8170$export$19bbfac2f7120ab5 = (Component)=>{
    const WrappedComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
        const $ = (0, $frIzR.c)(3);
        const context = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b();
        let t0;
        if ($[0] !== context || $[1] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                ...props,
                ...context
            });
            $[0] = context;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props)=>{
        const context = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            ...props,
            ...context
        });
    };
    return WrappedComponent;
};
module.exports["useEditionsAnalyticsContext"] = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b;
module.exports["AnalyticsProvider"] = $8ea1c6a3abbe8170$export$1b581a2ec13e37f1;

});

parcelRegister("k4Vdy", function(module, exports) {

var $12IaO = parcelRequire("12IaO");

const $b05bae0ef566e919$export$b1556774836001f5 = ({ actionSubjectId: actionSubjectId, source: source })=>actionSubjectId !== undefined ? `${source}${(0, (/*@__PURE__*/$parcel$interopDefault($12IaO)))(actionSubjectId)}` : undefined;
module.exports["calculateTestId"] = $b05bae0ef566e919$export$b1556774836001f5;

});

parcelRegister("ki6F7", function(module, exports) {

var $ey6Pt = parcelRequire("ey6Pt");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $4KS7f = parcelRequire("4KS7f");


var $ccHMk = parcelRequire("ccHMk");


var $izVB4 = parcelRequire("izVB4");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $b3j2Y = parcelRequire("b3j2Y");


var $bQm3c = parcelRequire("bQm3c");


var $ij4CE = parcelRequire("ij4CE");


var $2UjZJ = parcelRequire("2UjZJ");


var $gsZdA = parcelRequire("gsZdA");


var $5M47w = parcelRequire("5M47w");


var $dqdrq = parcelRequire("dqdrq");


var $ktelT = parcelRequire("ktelT");


var $l0DoV = parcelRequire("l0DoV");


var $euL71 = parcelRequire("euL71");


var $e5k34 = parcelRequire("e5k34");


var $fDbEj = parcelRequire("fDbEj");


var $k4Vdy = parcelRequire("k4Vdy");


var $iC1wS = parcelRequire("iC1wS");

const $3615035320db7a8b$var$i18n = (0, $cgtv4.defineMessages)({
    tryItFree: {
        id: "change-edition.upgrade.try.free",
        defaultMessage: "Try it free"
    },
    tryItNow: {
        id: "change-edition.upgrade.try.now",
        defaultMessage: "Try it now"
    },
    tryPremium: {
        id: "change-edition.upgrade.try.premium",
        defaultMessage: "Try Premium"
    }
});
const $3615035320db7a8b$var$editionMap = {
    [(0, $euL71.ConfluenceEdition).FREE]: (0, $5M47w.CommerceDeepLinksTargetEdition).FREE,
    [(0, $euL71.ConfluenceEdition).STANDARD]: (0, $5M47w.CommerceDeepLinksTargetEdition).STANDARD,
    [(0, $euL71.ConfluenceEdition).PREMIUM]: (0, $5M47w.CommerceDeepLinksTargetEdition).PREMIUM
};
const $3615035320db7a8b$var$determineButtonComponent = (appearance)=>{
    if (appearance === 'primary') return 0, $dqdrq.GradientCTAButton;
    if (appearance === 'subtle-link') return 0, $ktelT.GradientSubtleLinkButton;
    return 0, $4KS7f.default;
};
const $3615035320db7a8b$export$2f4bd8d23e81b246 = ({ analyticsProps: { actionSubjectId: actionSubjectId, attributes: attributes, source: source }, appearance: appearance = 'primary', children: children, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, onUpgradeButtonClick: onUpgradeButtonClick })=>{
    const [openUpFlow, setOpenUpFlow] = (0, $42omo.useState)(false);
    const [pollingError, setPollingError] = (0, $42omo.useState)();
    const { cloudId: cloudId, edition: currentEdition, userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $ey6Pt.default)
    });
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // free -> standard: upflow spa;
    // free/standard -> premium: adminhub
    const showUpFlow = targetEdition === (0, $euL71.ConfluenceEdition).STANDARD;
    const { cohort: upflowV2ExperimentCohort, isSiteAdmin: isSiteAdmin, isBillingAdmin: isBillingAdmin, loading: upflowV2EligibilityHookLoading } = (0, $2UjZJ.useUpflowV2ConfluenceStandardFGsExperiment)({
        skip: !showUpFlow || !openUpFlow,
        touchpointId: source,
        currentEdition: currentEdition,
        targetEdition: targetEdition
    });
    const { commerceBackendName: commerceBackendName, planConsentDeepLink: planConsentDeepLink, errorMessage: commerceDeepLinksError } = (0, $5M47w.useCommerceDeepLinks)({
        targetEdition: $3615035320db7a8b$var$editionMap[targetEdition],
        skipDeepLinks: showUpFlow
    });
    (0, $42omo.useEffect)(()=>()=>{
            // 1. With upflow enabled, when the user clicks on the upgrade CTA, the
            //    upflow dialog opens and this component unmounts; the upsell experience
            //    continues and experience tracking is subsequently handled by the
            //    UpFlow component.
            // or
            // 2. With upflow DISabled, unmounting here simply means user navigated away
            //    from the upsell UI and we DO want to signal an aborted experience.
            if (!showUpFlow) experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Canceled by user'
            });
        }, [
        experienceTracker,
        showUpFlow
    ]);
    (0, $42omo.useEffect)(()=>{
        // Using a TRACK event for tacking the traffic to the UpgradeEditionButton.
        // This will help us gauage Commerce API traffic to compute the deep links.
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'upgradeEditionButton',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...attributes,
                    currentEdition: currentEdition,
                    targetEdition: targetEdition
                }
            }
        }).fire();
    // We only need this to fire once, when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fireClickAnalytics = ()=>{
        if (attributes) {
            attributes.currentEdition = currentEdition;
            attributes.targetEdition = targetEdition;
            attributes.commerceBackend = commerceBackendName;
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: attributes
            }
        }).fire();
        if (commerceDeepLinksError) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'errored',
                actionSubject: 'useCommerceDeepLinks',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...attributes,
                    currentEdition: currentEdition,
                    targetEdition: targetEdition,
                    upsellDeepLink: planConsentDeepLink ? planConsentDeepLink.split('?')[0] : undefined,
                    errorMessage: commerceDeepLinksError
                }
            }
        }).fire();
    };
    const onTryWithoutUpFlowClick = async ()=>{
        if (onUpgradeButtonClick) onUpgradeButtonClick();
        // start polling and reload the page when done
        try {
            const updatedEdition = await (0, $fDbEj.waitForEditionChange)(currentEdition, writeFragmentInterop);
            experienceTracker.succeed({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                attributes: {
                    currentEdition: currentEdition,
                    targetEdition: updatedEdition
                }
            });
            // Default behavior
            window.location.reload();
        } catch (error) {
            if (error === (0, $fDbEj.TimeoutError)) // We don't expect the user to always proceed to upgrade in Admin Hub after seeing the estimated billing info.
            experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Possibly canceled by user'
            });
            else {
                (0, $fGzMp.stopExperienceOnError)((0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE), error);
                setPollingError(error);
            }
        }
    };
    const onUpFlowClose = ()=>{
        setOpenUpFlow(false);
    };
    const onTryButtonClick = ()=>{
        // we always want to fire both the exposure event as well as the click event
        fireClickAnalytics();
        // start the experience tracker
        experienceTracker.start({
            name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
            attributes: {
                currentEdition: currentEdition,
                linkClicked: actionSubjectId,
                source: source,
                targetEdition: targetEdition
            }
        });
        // then handle the click behaviour based on FF
        if (showUpFlow) setOpenUpFlow(true);
        else onTryWithoutUpFlowClick();
    };
    const buttonProps = {
        appearance: appearance,
        className: 'primaryButton',
        href: showUpFlow ? undefined : planConsentDeepLink,
        onClick: onTryButtonClick,
        target: showUpFlow ? undefined : '_blank',
        iconBefore: appearance === 'primary' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: "",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        }) : undefined,
        testId: (0, $k4Vdy.calculateTestId)({
            source: source,
            actionSubjectId: actionSubjectId
        })
    };
    const upflowV2ExperimentButtonProps = {
        appearance: appearance,
        testId: 'upflowV2ExperimentLoadingButton',
        isDisabled: true,
        isLoading: true,
        iconBefore: appearance === 'primary' ? (0, (/*@__PURE__*/$parcel$interopDefault($izVB4))) : undefined
    };
    const buttonChildren = children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3615035320db7a8b$var$i18n.tryItFree);
    const ButtonComponent = $3615035320db7a8b$var$determineButtonComponent(appearance);
    const renderModalContent = ()=>{
        if (upflowV2EligibilityHookLoading) return null;
        if (upflowV2ExperimentCohort === 'variation') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l0DoV.TryStandardUpflowV2ExperimentTreatmentModalLoadable), {
            isOpen: openUpFlow,
            closeModal: onUpFlowClose,
            touchpointId: source,
            targetEdition: targetEdition,
            isBillingAdmin: isBillingAdmin,
            isSiteAdmin: isSiteAdmin,
            currentEdition: currentEdition
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
            canChangeEdition: true // this component should only ever be used for site admins
            ,
            cloudId: cloudId,
            currentEdition: currentEdition || undefined,
            atlassianAccountId: userId || undefined,
            flow: "upgrade",
            product: "confluence",
            targetEdition: targetEdition,
            touchpointId: source,
            isExperienceTrackerEnabled: true,
            onClose: // Note: onUpFlowOpen function closes the parent component which
            // means we don't need to trigger the onClose.
            onUpFlowOpen ? undefined : onUpFlowClose,
            onOpen: onUpFlowOpen,
            epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, pollingError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: pollingError
    }) : null, upflowV2EligibilityHookLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), upflowV2ExperimentButtonProps, buttonChildren) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, buttonProps, buttonChildren), showUpFlow && openUpFlow ? renderModalContent() : null);
};
module.exports["UpgradeEditionButton"] = $3615035320db7a8b$export$2f4bd8d23e81b246;

});

parcelRegister("ey6Pt", function(module, exports) {
/**
 * @generated SignedSource<<9788b38f2bb32f836366310152c95cca>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $377a05a3faea70b3$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "UpgradeEditionButtonFragment",
        "selections": [
            {
                "concreteType": "Editions",
                "kind": "LinkedField",
                "name": "editions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "confluence"
                    },
                    v0 /*: any*/ 
                ]
            },
            v0 /*: any*/ 
        ],
        "type": "ConfluenceTenantContext"
    };
}();
$377a05a3faea70b3$var$node.hash = "bee007bb99f1be1656322a1f41effd37";
var $377a05a3faea70b3$export$2e2bcd8739ae039 = $377a05a3faea70b3$var$node;
module.exports["default"] = $377a05a3faea70b3$export$2e2bcd8739ae039;

});

parcelRegister("izVB4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56b88a11fb19ee4bef2fa0f940debca3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8682c67cc42b6ad$var$_react = $d8682c67cc42b6ad$var$_interopRequireDefault((parcelRequire("42omo")));

var $d8682c67cc42b6ad$var$_baseNew = $d8682c67cc42b6ad$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d8682c67cc42b6ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing premium features and functionality. Editions may replace the current premium sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8682c67cc42b6ad$var$EditionsIcon = (props)=>/*#__PURE__*/ $d8682c67cc42b6ad$var$_react.default.createElement($d8682c67cc42b6ad$var$_baseNew.default, Object.assign({
        name: "EditionsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.614 1.353A.75.75 0 0 1 3.25 1h9.5a.75.75 0 0 1 .636.353l2.5 4a.75.75 0 0 1-.065.884l-7.25 8.5a.75.75 0 0 1-1.142 0l-7.25-8.5a.75.75 0 0 1-.065-.885zM3.666 2.5 2.103 5H4.7l.78-2.5zm3.385 0L6.271 5H9.73l-.781-2.5zm3.47 0L11.3 5h2.596l-1.563-2.5zm3.103 4h-2.328l-1.424 4.399zM8 11.813 9.72 6.5H6.28zM4.704 6.5l1.424 4.399L2.375 6.5z" clip-rule="evenodd"/>`
    }, props));
$d8682c67cc42b6ad$var$EditionsIcon.displayName = 'EditionsIcon';
var $d8682c67cc42b6ad$var$_default = module.exports.default = $d8682c67cc42b6ad$var$EditionsIcon;

});

parcelRegister("2UjZJ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $gXR0B = parcelRequire("gXR0B");


var $f1B2z = parcelRequire("f1B2z");

const $dd8da84ad086336b$export$2bbc11bf12d076a0 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { skip: skip, touchpointId: touchpointId, currentEdition: currentEdition, targetEdition: targetEdition } = t0;
    const fireExperimentExposureEvent = (0, $gXR0B.useFeatureExposedAnalytics)();
    const [abCohort, setAbCohort] = (0, $42omo.useState)(null);
    let t1;
    if ($[0] !== currentEdition || $[1] !== skip || $[2] !== targetEdition) {
        t1 = {
            skip: skip,
            currentEdition: currentEdition,
            targetEdition: targetEdition
        };
        $[0] = currentEdition;
        $[1] = skip;
        $[2] = targetEdition;
        $[3] = t1;
    } else t1 = $[3];
    const { isEligible: isEligible, isSiteAdmin: isSiteAdmin, isBillingAdmin: isBillingAdmin, error: eligibilityHookError, loading: eligibilityHookLoading } = (0, $f1B2z.useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment)(t1);
    let t2;
    let t3;
    if ($[4] !== currentEdition || $[5] !== eligibilityHookError || $[6] !== fireExperimentExposureEvent || $[7] !== isBillingAdmin || $[8] !== isEligible || $[9] !== isSiteAdmin || $[10] !== targetEdition || $[11] !== touchpointId) {
        t2 = ()=>{
            if (isEligible) {
                fireExperimentExposureEvent({
                    flagKey: "grw-1930_confluence_upv2_standard_ab",
                    cohort: (0, $6mKj3.expVal)("grw-1930_confluence_upv2_standard_ab", "cohort", "not-enrolled"),
                    growthInitiative: "luna",
                    touchpointId: touchpointId,
                    additionalAttributes: {
                        currentEdition: currentEdition,
                        targetEdition: targetEdition,
                        isSiteAdmin: isSiteAdmin,
                        isBillingAdmin: isBillingAdmin
                    }
                });
                setAbCohort((0, $6mKj3.expVal)("grw-1930_confluence_upv2_standard_ab", "cohort", "not-enrolled"));
            } else if (eligibilityHookError) setAbCohort(null);
            else setAbCohort("not-enrolled");
        };
        t3 = [
            fireExperimentExposureEvent,
            isEligible,
            eligibilityHookError,
            currentEdition,
            targetEdition,
            isSiteAdmin,
            isBillingAdmin,
            touchpointId
        ];
        $[4] = currentEdition;
        $[5] = eligibilityHookError;
        $[6] = fireExperimentExposureEvent;
        $[7] = isBillingAdmin;
        $[8] = isEligible;
        $[9] = isSiteAdmin;
        $[10] = targetEdition;
        $[11] = touchpointId;
        $[12] = t2;
        $[13] = t3;
    } else {
        t2 = $[12];
        t3 = $[13];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[14] !== abCohort || $[15] !== eligibilityHookError || $[16] !== eligibilityHookLoading || $[17] !== isBillingAdmin || $[18] !== isSiteAdmin) {
        t4 = {
            cohort: abCohort,
            isSiteAdmin: isSiteAdmin,
            isBillingAdmin: isBillingAdmin,
            loading: eligibilityHookLoading,
            error: eligibilityHookError
        };
        $[14] = abCohort;
        $[15] = eligibilityHookError;
        $[16] = eligibilityHookLoading;
        $[17] = isBillingAdmin;
        $[18] = isSiteAdmin;
        $[19] = t4;
    } else t4 = $[19];
    return t4;
} : ({ skip: skip, touchpointId: touchpointId, currentEdition: currentEdition, targetEdition: targetEdition })=>{
    const fireExperimentExposureEvent = (0, $gXR0B.useFeatureExposedAnalytics)();
    const [abCohort, setAbCohort] = (0, $42omo.useState)(null);
    const { isEligible: isEligible, isSiteAdmin: isSiteAdmin, isBillingAdmin: isBillingAdmin, error: eligibilityHookError, loading: eligibilityHookLoading } = (0, $f1B2z.useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment)({
        skip: skip,
        currentEdition: currentEdition,
        targetEdition: targetEdition
    });
    (0, $42omo.useEffect)(()=>{
        if (isEligible) {
            fireExperimentExposureEvent({
                flagKey: 'grw-1930_confluence_upv2_standard_ab',
                cohort: (0, $6mKj3.expVal)('grw-1930_confluence_upv2_standard_ab', 'cohort', 'not-enrolled'),
                growthInitiative: 'luna',
                touchpointId: touchpointId,
                additionalAttributes: {
                    currentEdition: currentEdition,
                    targetEdition: targetEdition,
                    isSiteAdmin: isSiteAdmin,
                    isBillingAdmin: isBillingAdmin
                }
            });
            setAbCohort((0, $6mKj3.expVal)('grw-1930_confluence_upv2_standard_ab', 'cohort', 'not-enrolled'));
        } else if (eligibilityHookError) // Error occurred, reset to null
        setAbCohort(null);
        else setAbCohort('not-enrolled');
    }, [
        fireExperimentExposureEvent,
        isEligible,
        eligibilityHookError,
        currentEdition,
        targetEdition,
        isSiteAdmin,
        isBillingAdmin,
        touchpointId
    ]);
    return {
        cohort: abCohort,
        isSiteAdmin: isSiteAdmin,
        isBillingAdmin: isBillingAdmin,
        loading: eligibilityHookLoading,
        error: eligibilityHookError
    };
};
module.exports["useUpflowV2ConfluenceStandardFGsExperiment"] = $dd8da84ad086336b$export$2bbc11bf12d076a0;

});

parcelRegister("gXR0B", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $c07cc869290551b6$export$5218ddb3d9c658c0 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const sentFlagKeys = (0, $42omo.useRef)(t0);
    let t1;
    if ($[1] !== createAnalyticsEvent) {
        t1 = (t2)=>{
            const { flagKey: flagKey, cohort: cohort, touchpointId: touchpointId, growthInitiative: growthInitiative, additionalAttributes: t3 } = t2;
            const additionalAttributes = t3 === undefined ? {} : t3;
            const flagTouchpointKey = `${flagKey}:${touchpointId}`;
            if (sentFlagKeys.current.includes(flagTouchpointKey)) return;
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "exposed",
                    actionSubject: "experiment",
                    actionSubjectId: `${flagKey}-exposed`,
                    source: flagKey,
                    attributes: {
                        cohort: cohort,
                        touchpointId: touchpointId,
                        growthInitiative: growthInitiative,
                        ...additionalAttributes
                    }
                }
            }).fire();
            sentFlagKeys.current.push(flagTouchpointKey);
        };
        $[1] = createAnalyticsEvent;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sentFlagKeys = (0, $42omo.useRef)([]);
    // This ensures the experiment exposure event is only fired once per flagKey / touchpoint combination.
    return (0, $42omo.useCallback)(({ flagKey: flagKey, cohort: cohort, touchpointId: touchpointId, growthInitiative: growthInitiative, additionalAttributes: additionalAttributes = {} })=>{
        const flagTouchpointKey = `${flagKey}:${touchpointId}`;
        if (sentFlagKeys.current.includes(flagTouchpointKey)) return;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'exposed',
                actionSubject: 'experiment',
                actionSubjectId: `${flagKey}-exposed`,
                source: flagKey,
                attributes: {
                    cohort: cohort,
                    touchpointId: touchpointId,
                    growthInitiative: growthInitiative,
                    ...additionalAttributes
                }
            }
        }).fire();
        sentFlagKeys.current.push(flagTouchpointKey);
    }, [
        createAnalyticsEvent
    ]);
};
module.exports["useFeatureExposedAnalytics"] = $c07cc869290551b6$export$5218ddb3d9c658c0;

});

parcelRegister("f1B2z", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $inPa6 = parcelRequire("inPa6");


var $8hmrm = parcelRequire("8hmrm");

var $gwZbZ = parcelRequire("gwZbZ");

var $6o7wX = parcelRequire("6o7wX");


var $1ytiN = parcelRequire("1ytiN");


var $bQm3c = parcelRequire("bQm3c");


var $gKr8t = parcelRequire("gKr8t");


var $euL71 = parcelRequire("euL71");

const $26baada861c32413$var$extractBillingAdminStatus = (billingData)=>{
    return billingData?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.transactionAccount?.isCurrentUserBillingAdmin;
};
const $26baada861c32413$export$6da6d4db5c51c32 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { skip: t1, currentEdition: currentEdition, targetEdition: targetEdition } = t0;
    const skip = t1 === undefined ? false : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const isBasicEligible = Boolean(cloudId && currentEdition === (0, $euL71.ConfluenceEdition).FREE && targetEdition === (0, $euL71.ConfluenceEdition).STANDARD && isSiteAdmin);
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $eSUdr.default)`query useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery($cloudId:ID!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:"confluence.ondemand"){entitlement{id transactionAccount{...on Node{id __typename}isCurrentUserBillingAdmin}}}}}`;
        t3 = (0, $gKr8t.getAGGClient)();
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    let t4;
    if ($[2] !== cloudId) {
        t4 = {
            cloudId: cloudId
        };
        $[2] = cloudId;
        $[3] = t4;
    } else t4 = $[3];
    const t5 = skip || !isBasicEligible;
    let t6;
    if ($[4] !== t4 || $[5] !== t5) {
        t6 = {
            client: t3,
            variables: t4,
            skip: t5
        };
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    const { data: billingAdminData, loading: isBillingAdminQueryLoading, error: billingAdminQueryError } = (0, $xQxzY.useQuery)(t2, t6);
    let t7;
    let t8;
    if ($[7] !== billingAdminQueryError || $[8] !== createAnalyticsEvent) {
        t7 = ()=>{
            if (billingAdminQueryError) {
                const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
                    product: (0, $gwZbZ.Product).CONFLUENCE,
                    team: (0, $6o7wX.Team).GROWTH_LUNA,
                    experimentMeta: {
                        experimentKey: "grw-1930_confluence_upv2_standard_ab"
                    },
                    errorType: (0, $gwZbZ.ErrorType).GRAPHQL,
                    errorMessage: billingAdminQueryError.message,
                    source: "useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment hook",
                    severity: (0, $gwZbZ.Severity).HIGH
                });
                createAnalyticsEvent(eventPayload).fire();
            }
        };
        t8 = [
            billingAdminQueryError,
            createAnalyticsEvent
        ];
        $[7] = billingAdminQueryError;
        $[8] = createAnalyticsEvent;
        $[9] = t7;
        $[10] = t8;
    } else {
        t7 = $[9];
        t8 = $[10];
    }
    (0, $42omo.useEffect)(t7, t8);
    let t9;
    if ($[11] !== billingAdminData) {
        t9 = $26baada861c32413$var$extractBillingAdminStatus(billingAdminData);
        $[11] = billingAdminData;
        $[12] = t9;
    } else t9 = $[12];
    const isBillingAdmin = t9;
    const t10 = Boolean(isBasicEligible && isBillingAdmin);
    let t11;
    if ($[13] !== billingAdminQueryError || $[14] !== isBillingAdmin || $[15] !== isBillingAdminQueryLoading || $[16] !== isSiteAdmin || $[17] !== t10) {
        t11 = {
            isEligible: t10,
            isSiteAdmin: isSiteAdmin,
            isBillingAdmin: isBillingAdmin,
            loading: isBillingAdminQueryLoading,
            error: billingAdminQueryError
        };
        $[13] = billingAdminQueryError;
        $[14] = isBillingAdmin;
        $[15] = isBillingAdminQueryLoading;
        $[16] = isSiteAdmin;
        $[17] = t10;
        $[18] = t11;
    } else t11 = $[18];
    return t11;
} : ({ skip: skip = false, currentEdition: currentEdition, targetEdition: targetEdition })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const isBasicEligible = Boolean(cloudId && currentEdition === (0, $euL71.ConfluenceEdition).FREE && targetEdition === (0, $euL71.ConfluenceEdition).STANDARD && isSiteAdmin);
    const { data: billingAdminData, loading: isBillingAdminQueryLoading, error: billingAdminQueryError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery($cloudId:ID!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:"confluence.ondemand"){entitlement{id transactionAccount{...on Node{id __typename}isCurrentUserBillingAdmin}}}}}`, {
        client: (0, $gKr8t.getAGGClient)(),
        variables: {
            cloudId: cloudId
        },
        skip: skip || !isBasicEligible
    });
    (0, $42omo.useEffect)(()=>{
        if (billingAdminQueryError) {
            const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
                product: (0, $gwZbZ.Product).CONFLUENCE,
                team: (0, $6o7wX.Team).GROWTH_LUNA,
                experimentMeta: {
                    experimentKey: 'grw-1930_confluence_upv2_standard_ab'
                },
                errorType: (0, $gwZbZ.ErrorType).GRAPHQL,
                errorMessage: billingAdminQueryError.message,
                source: 'useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment hook',
                severity: (0, $gwZbZ.Severity).HIGH
            });
            createAnalyticsEvent(eventPayload).fire();
        }
    }, [
        billingAdminQueryError,
        createAnalyticsEvent
    ]);
    const isBillingAdmin = (0, $42omo.useMemo)(()=>{
        return $26baada861c32413$var$extractBillingAdminStatus(billingAdminData);
    }, [
        billingAdminData
    ]);
    return {
        isEligible: Boolean(isBasicEligible && isBillingAdmin),
        isSiteAdmin: isSiteAdmin,
        isBillingAdmin: isBillingAdmin,
        loading: isBillingAdminQueryLoading,
        error: billingAdminQueryError
    };
};
module.exports["useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment"] = $26baada861c32413$export$6da6d4db5c51c32;

});

parcelRegister("8hmrm", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");


var $gvWCD = parcelRequire("gvWCD");


var $3HIy9 = parcelRequire("3HIy9");


var $39G0n = parcelRequire("39G0n");

const $31b517e9b4290477$export$8c06ae8e7f403dea = ({ product: product, team: team, experimentMeta: experimentMeta, errorType: errorType, errorMessage: errorMessage, source: source, severity: severity, additionalAttributes: additionalAttributes = {} }, isActiveExperiment = true)=>{
    (0, $39G0n.validateExperimentName)(experimentMeta.experimentKey);
    const eventPayload = (0, $gvWCD.createEventPayload)({
        team: team,
        experimentMeta: experimentMeta,
        errorType: errorType,
        errorMessage: errorMessage,
        source: source,
        severity: severity,
        isActiveExperiment: isActiveExperiment,
        additionalAttributes: additionalAttributes,
        product: product
    });
    switch(product){
        case (0, $gwZbZ.Product).ADMIN_HUB:
            return {
                data: eventPayload
            };
        case (0, $gwZbZ.Product).JIRA:
            return {
                data: eventPayload,
                productSpecificRules: {
                    jira: {
                        createAnalyticsEventPayload: (0, $3HIy9.convertEventPayloadForJiraCreateAnalyticsEvent)({
                            data: eventPayload
                        }),
                        fireEventPayload: (0, $3HIy9.convertEventAttributesForJiraFireEvent)({
                            data: eventPayload
                        })
                    }
                }
            };
        case (0, $gwZbZ.Product).CONFLUENCE:
            return {
                type: (0, $gwZbZ.CONFLUENCE_OPERATIONAL_EVENT_TYPE),
                data: eventPayload
            };
        default:
            throw new Error(`Unsupported product: ${product}`);
    }
};
module.exports["createProductSpecificAnalyticsIntegrationPayload"] = $31b517e9b4290477$export$8c06ae8e7f403dea;

});

parcelRegister("gwZbZ", function(module, exports) {
const $64e202edaa8eb03b$export$ec4825154d679381 = 'error';
const $64e202edaa8eb03b$export$a924d1f92c0e2e78 = 'growth-experiment';
const $64e202edaa8eb03b$export$e5025d93161b0712 = 'sendOperationalEvent';
const $64e202edaa8eb03b$export$5c3e8a6b8e7ba45b = 'growth-error-analytics';
var $64e202edaa8eb03b$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["JIRA"] = "jira";
    Product["CONFLUENCE"] = "confluence";
    Product["ADMIN_HUB"] = "admin-hub";
    return Product;
}({});
var $64e202edaa8eb03b$export$dba1278861bf0dc1 = /*#__PURE__*/ function(ErrorType) {
    ErrorType["GRAPHQL"] = "graphql";
    ErrorType["REST"] = "rest";
    ErrorType["ERROR_BOUNDARY"] = "error-boundary";
    ErrorType["GENERIC"] = "generic";
    return ErrorType;
}({});
var $64e202edaa8eb03b$export$918a9776c0a3cf27 = /*#__PURE__*/ function(Severity) {
    Severity["LOW"] = "low";
    Severity["MEDIUM"] = "medium";
    Severity["HIGH"] = "high";
    return Severity;
}({});
const $64e202edaa8eb03b$export$a61493d7ab73936 = 'growth';
module.exports["ERROR_ACTION"] = $64e202edaa8eb03b$export$ec4825154d679381;
module.exports["ERROR_ACTION_SUBJECT"] = $64e202edaa8eb03b$export$a924d1f92c0e2e78;
module.exports["CONFLUENCE_OPERATIONAL_EVENT_TYPE"] = $64e202edaa8eb03b$export$e5025d93161b0712;
module.exports["Product"] = $64e202edaa8eb03b$export$264ad599d7cef668;
module.exports["ErrorType"] = $64e202edaa8eb03b$export$dba1278861bf0dc1;
module.exports["Severity"] = $64e202edaa8eb03b$export$918a9776c0a3cf27;
module.exports["EVENT_TAG_GROWTH"] = $64e202edaa8eb03b$export$a61493d7ab73936;

});

parcelRegister("gvWCD", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");

const $d2a9f5f63821177b$export$f2a94361d01a626c = ({ team: team, experimentMeta: experimentMeta, errorType: errorType, errorMessage: errorMessage, source: source, severity: severity, isActiveExperiment: isActiveExperiment, product: product, additionalAttributes: additionalAttributes = {} })=>{
    const actionSubjectId = `${(0, $gwZbZ.ERROR_ACTION_SUBJECT)}-${experimentMeta.experimentKey}-${errorType}`;
    return {
        action: (0, $gwZbZ.ERROR_ACTION),
        actionSubject: (0, $gwZbZ.ERROR_ACTION_SUBJECT),
        actionSubjectId: actionSubjectId,
        source: experimentMeta.experimentKey,
        attributes: {
            errorType: errorType,
            team: team,
            experimentKey: experimentMeta.experimentKey,
            cohort: experimentMeta?.cohort,
            severity: severity,
            errorMessage: errorMessage,
            isActiveExperiment: isActiveExperiment,
            product: product,
            detailedSource: source,
            ...additionalAttributes
        },
        tags: [
            (0, $gwZbZ.EVENT_TAG_GROWTH)
        ]
    };
};
module.exports["createEventPayload"] = $d2a9f5f63821177b$export$f2a94361d01a626c;

});

parcelRegister("3HIy9", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");


var $8hmrm = parcelRequire("8hmrm");

const $de70a0c4deb210a2$export$d5090ca98c07c12d = (payload)=>{
    const { data: data } = payload;
    return {
        action: data.action,
        actionSubject: data.actionSubject,
        source: data.source,
        actionSubjectId: data.actionSubjectId,
        tags: data.tags
    };
};
const $de70a0c4deb210a2$export$2144cc21b87dd554 = (payload)=>{
    const { data: data } = payload;
    const eventName = `${data.actionSubject} ${data.action}`;
    return {
        eventName: eventName,
        attributes: data.attributes
    };
};
const $de70a0c4deb210a2$export$f106561f47f05126 = (event)=>{
    const { payload: payload } = event;
    // Extract attributes from the event payload and create a formatted payload
    // specifically for Jira product integration
    const analyticsEventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
        product: (0, $gwZbZ.Product).JIRA,
        team: payload.attributes.team,
        experimentMeta: {
            experimentKey: payload.attributes.experimentKey,
            cohort: payload.attributes.cohort
        },
        errorType: payload.attributes.errorType,
        errorMessage: payload.attributes.errorMessage,
        source: payload.attributes.source,
        severity: payload.attributes.severity
    });
    // Return both payload formats needed for complete Jira analytics integration:
    // 1. createEventPayload: Used with Jira's createAnalyticsEvent
    // 2. fireEventPayload: Used with Jira's fireEvent
    return {
        createEventPayload: $de70a0c4deb210a2$export$d5090ca98c07c12d(analyticsEventPayload),
        fireEventPayload: $de70a0c4deb210a2$export$2144cc21b87dd554(analyticsEventPayload)
    };
};
module.exports["convertEventPayloadForJiraCreateAnalyticsEvent"] = $de70a0c4deb210a2$export$d5090ca98c07c12d;
module.exports["convertEventAttributesForJiraFireEvent"] = $de70a0c4deb210a2$export$2144cc21b87dd554;

});

parcelRegister("39G0n", function(module, exports) {
/**
 * Validates that an experiment name doesn't contain spaces.
 * Experiment names with spaces can cause issues in dashboards and analytics tracking.
 *
 * @param experimentName The experiment name to validate
 * @throws Error if experiment name contains spaces
 */ const $34ecc222054f7431$export$7fa6b5da621cbeb2 = (experimentName)=>{
    if (experimentName.includes(' ')) throw new Error(`Experiment name "${experimentName}" contains spaces. ` + 'Experiment names must not contain spaces to ensure proper tracking in dashboards. ' + 'Use camelCase or hyphens instead (e.g., "myExperiment" or "my-experiment").');
};
module.exports["validateExperimentName"] = $34ecc222054f7431$export$7fa6b5da621cbeb2;

});

parcelRegister("6o7wX", function(module, exports) {
/**
 * Enumeration of authorized teams for growth error analytics
 *
 * IMPORTANT: If your team wants to use growth-commons-error-analytics:
 * 1. Add your team name following the convention 'TEAM_NAME = team-name'
 * 2. Create a PR and request review from the #growth-luna channel
 * 3. Provide context about your team and use case in the PR description
 *
 * The growth-luna team reviews all additions to maintain analytics quality
 * and ensure proper integration with dashboards.
 *
 * @example
 * // Adding a new team:
 * // GROWTH_NEW_TEAM = 'growth-new-team', // requires approval
 */ var $7d6dde24ede24951$export$3e5d0af8e738b082 = /*#__PURE__*/ function(Team) {
    Team["GROWTH_LUNA"] = "growth-luna";
    return Team;
}({});
module.exports["Team"] = $7d6dde24ede24951$export$3e5d0af8e738b082;

});

parcelRegister("5M47w", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $6Co6F = parcelRequire("6Co6F");


var $6bHqX = parcelRequire("6bHqX");


var $lzcvT = parcelRequire("lzcvT");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $1ytiN = parcelRequire("1ytiN");


var $gKr8t = parcelRequire("gKr8t");


var $8H5XZ = parcelRequire("8H5XZ");


var $7Sm4c = parcelRequire("7Sm4c");





var $lh1MN = parcelRequire("lh1MN");


var $hfUvC = parcelRequire("hfUvC");

var $ae96eb60e6557b8b$export$92b15cc7e26a62fb = /*#__PURE__*/ function(CommerceDeepLinksTargetEdition) {
    CommerceDeepLinksTargetEdition["FREE"] = "free";
    CommerceDeepLinksTargetEdition["STANDARD"] = "standard";
    CommerceDeepLinksTargetEdition["PREMIUM"] = "premium";
    return CommerceDeepLinksTargetEdition;
}({});
const $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS = {
    PRODUCTION: 'https://admin.atlassian.com',
    STAGING: 'https://admin.stg.atlassian.com'
};
const $ae96eb60e6557b8b$export$16287b6da0e34b4e = '/admin/billing/applications/change-edition/confluence.ondemand';
const $ae96eb60e6557b8b$export$4591cf268e289775 = '/admin/billing/applications';
const $ae96eb60e6557b8b$var$addAtlOriginToUrl = (url)=>{
    const origin = new (0, $6Co6F.default)({
        product: 'confluence'
    });
    return origin.addToUrl(url);
};
const $ae96eb60e6557b8b$export$39685ba9de2c4192 = ({ cloudId: cloudId, environment: environment, orgId: orgId })=>{
    const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
    if (orgId || cloudId) return orgId ? `${CLOUD_ADMIN_URL}/o/${orgId}/billing-preview` : `${CLOUD_ADMIN_URL}/s/${cloudId}/billing-preview`;
    // In an extreme case where we cannot detect cloudId or orgId, we route user to main AdminHub page.
    return CLOUD_ADMIN_URL;
};
const $ae96eb60e6557b8b$var$buildPlanSelectionLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, environment: environment, entitlementId: entitlementId, transactionAccountId: transactionAccountId, orgId: orgId } = params;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) return $ae96eb60e6557b8b$export$16287b6da0e34b4e;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) {
        const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
        // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId/change-plan?referrer=[referrer]
        // See https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2652063891/How+to+Deeplink+to+BAC+s+change+plan
        return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=confluence`;
    }
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
const $ae96eb60e6557b8b$var$buildPlanConsentLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, entitlementId: entitlementId, environment: environment, orgId: orgId, transactionAccountId: transactionAccountId, targetEdition: targetEdition } = params;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) return targetEdition ? `${$ae96eb60e6557b8b$var$buildPlanSelectionLink(params)}/${targetEdition}` : $ae96eb60e6557b8b$var$buildPlanSelectionLink(params);
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId/change-plan?offeringName=[offering name]&referrer=[referrer]
    // See https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2820329173/How+to+Deeplink+change+plan+consent
    return targetEdition ? `${$ae96eb60e6557b8b$var$buildPlanSelectionLink(params)}&offeringName=${targetEdition}` : $ae96eb60e6557b8b$var$buildPlanSelectionLink(params);
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
const $ae96eb60e6557b8b$var$buildSubscriptionDetailsLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, environment: environment, entitlementId: entitlementId, orgId: orgId, transactionAccountId: transactionAccountId } = params;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) return $ae96eb60e6557b8b$export$4591cf268e289775;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) {
        const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
        // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId
        return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}/entitlement/${entitlementId}`;
    }
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
// (Concept is adopted from Kent C. Dodds here:
//  https://kentcdodds.com/blog/get-a-catch-block-error-message-with-typescript)
const $ae96eb60e6557b8b$var$getErrorMessage = (label, error)=>{
    const message = error instanceof Error ? error.message : String(error);
    return `${label}: ${message}`;
};
const $ae96eb60e6557b8b$export$91505ae0b86ded0b = ({ targetEdition: targetEdition, skipDeepLinks: skipDeepLinks = false })=>{
    const { environment: environment, cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    if (!isSiteAdmin || !cloudId) skipDeepLinks = true;
    /**
   * The best practice advocates for one graphql per component and ideally no graphql quries in a hook
   * but to construct the deeplink, we need to:
   * 1. first call Commerce API to retrieve the Confluence instance backend service (CCP or HAMS),
   * 2. for CCP, call ccgraphql to retrieve the ccpEntitlementId
   * 3. for CCP, call AGG to retrieve the CCP transaction account Id using the ccpEntitlementId retrieved in step #2.
   *
   * This is a stop gap solution while we work with Commerce to eventually have one AGG query
   * to provide everything we need with just a CloudId and the product key (e.g. confluence
   */ const { commerceBackendName: commerceBackendName, loading: commerceBackendNameLoading, error: commerceBackendNameError } = (0, $hfUvC.useCommerceRolloutInformation)(skipDeepLinks || (0, $lzcvT.isFedRamp)());
    // If it is in FedRamp, we can assume it is CCP backend.
    // More details -> https://atlassian.slack.com/archives/C04LF8UKAE4/p1734981625650579
    const isCcpBackend = commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) || (0, $lzcvT.isFedRamp)();
    const { data: ccpEntitlementIdData, loading: ccpEntitlementIdLoading, error: ccpEntitlementIdError } = (0, $j1Ss3.useQuery)(/** @schema cc */ (0, $eSUdr.default)`query useCommerceDeepLinksCcpEntitlementQuery{confluence_tenantContext{licenseStates{confluence{ccpEntitlementId}}}tenant{cloudId}}`, {
        skip: skipDeepLinks || !isCcpBackend
    });
    const ccpEntitlementId = !ccpEntitlementIdLoading ? (0, $lh1MN.getCcpEntitlementFromQuery)(ccpEntitlementIdData) : undefined;
    const { data: ccpEntitlementTxaIdData, loading: ccpEntitlementTxaIdLoading, error: ccpEntitlementTxaIdError } = (0, $j1Ss3.useQuery)(/** @schema agg */ (0, $eSUdr.default)`query useCommerceDeepLinksCcpTransactionAccountIdQuery($entitlementId:ID!$targetEditionName:String$shouldFetchChangeOffering:Boolean!){ccp{entitlement(id:$entitlementId){transactionAccountId experienceCapabilities@include(if:$shouldFetchChangeOffering){changeOfferingV2(offeringName:$targetEditionName){experienceUrl}}}}}`, {
        variables: {
            entitlementId: ccpEntitlementId || '',
            targetEditionName: targetEdition || '',
            shouldFetchChangeOffering: (0, $9wGTI.fg)('ld-74-fetch-change-offering-url-in-upgrade-edition')
        },
        skip: skipDeepLinks || !isCcpBackend || !ccpEntitlementId,
        client: (0, $gKr8t.getAGGClient)()
    });
    if (skipDeepLinks) return {
        commerceBackendName: null,
        planSelectionDeepLink: undefined,
        planConsentDeepLink: undefined,
        subscriptionDetailsDeepLink: undefined,
        loading: false,
        errorMessage: undefined
    };
    let errorMessage;
    let planSelectionDeepLink;
    let planConsentDeepLink;
    let subscriptionDetailsDeepLink;
    let changeOfferingDeepLink;
    try {
        const entitlementId = ccpEntitlementId;
        const transactionAccountId = ccpEntitlementTxaIdData?.ccp?.entitlement?.transactionAccountId;
        // format -> https://admin.stg.atlassian.com/billing/UUID/entitlement/TWC-UUID-OR-CONF/change-plan?requireAtlOrigin=true&referrer=confluence
        // Note: if product is TWC Confluence, then there is no referrer param added from ccp-graphql
        const changeOfferingExperienceUrl = ccpEntitlementTxaIdData?.ccp?.entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl ?? undefined;
        const commerceParams = {
            cloudId: cloudId,
            commerceBackendName: commerceBackendName,
            environment: environment,
            entitlementId: entitlementId,
            orgId: orgId,
            transactionAccountId: transactionAccountId || undefined
        };
        planSelectionDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildPlanSelectionLink(commerceParams));
        planConsentDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildPlanConsentLink({
            targetEdition: targetEdition,
            ...commerceParams
        }));
        if (changeOfferingExperienceUrl) {
            if ((0, $6mKj3.expValEquals)('confluence_fix_referrer_param_commerce_deeplinks', 'cohort', 'variation')) {
                const url = new URL(changeOfferingExperienceUrl);
                url.searchParams.set('referrer', 'confluence');
                changeOfferingDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl(url.toString());
            } else changeOfferingDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl(`${changeOfferingExperienceUrl}confluence`);
        }
        subscriptionDetailsDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildSubscriptionDetailsLink(commerceParams));
        // Mark all graphql errors as handled since we will return the fallback plan selection url
        if ((0, $8H5XZ.isGraphQLError)(ccpEntitlementIdError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(ccpEntitlementIdError)) (0, $7Sm4c.markErrorAsHandled)(ccpEntitlementIdError);
        if ((0, $8H5XZ.isGraphQLError)(ccpEntitlementTxaIdError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(ccpEntitlementTxaIdError)) (0, $7Sm4c.markErrorAsHandled)(ccpEntitlementTxaIdError);
        if (commerceBackendNameError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving Commerce Backend Service', commerceBackendNameError);
        else if (ccpEntitlementIdError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving CCP Entitlement Id', ccpEntitlementIdError);
        else if (ccpEntitlementTxaIdError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving CCP Transaction Account Id', ccpEntitlementTxaIdError);
    } catch (e) {
        errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error in useCommerceDeepLinks', e);
    }
    const loading = commerceBackendNameLoading || ccpEntitlementIdLoading || ccpEntitlementTxaIdLoading;
    return {
        commerceBackendName: commerceBackendName,
        planSelectionDeepLink: planSelectionDeepLink,
        planConsentDeepLink: changeOfferingDeepLink || planConsentDeepLink,
        subscriptionDetailsDeepLink: subscriptionDetailsDeepLink,
        loading: loading,
        errorMessage: errorMessage
    };
};
module.exports["CommerceDeepLinksTargetEdition"] = $ae96eb60e6557b8b$export$92b15cc7e26a62fb;
module.exports["useCommerceDeepLinks"] = $ae96eb60e6557b8b$export$91505ae0b86ded0b;

});

parcelRegister("6bHqX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gstll = parcelRequire("gstll");

var $6H9BA = parcelRequire("6H9BA");


var $4Twfb = parcelRequire("4Twfb");


var $3yFL2 = parcelRequire("3yFL2");

var $3SLm1 = parcelRequire("3SLm1");

var $cEhot = parcelRequire("cEhot");


var $1Y5Zp = parcelRequire("1Y5Zp");

const $30c48f23b8aa47be$var$BILLING_API_GATEWAY_URL = `${(0, $gstll.GATEWAY_URL)}/bag`;
const $30c48f23b8aa47be$export$56507f8f3f7349a5 = 'HAMS';
const $30c48f23b8aa47be$export$9a39331b1bb2f849 = 'CCP';
const $30c48f23b8aa47be$export$49ab1426acf387e4 = async (params, { fetch: fetch })=>{
    try {
        const response = await fetch(`${$30c48f23b8aa47be$var$BILLING_API_GATEWAY_URL}/rollout/service?cloudId=${encodeURIComponent(params.cloudId)}`);
        if (response.status !== 200) return {
            payload: undefined,
            error: `Failed to fetch commerce rollout information: ${response.statusText}`,
            exception: undefined
        };
        const service = (await response.json()).service;
        return {
            payload: service === 'CCP' ? {
                commerceBackend: service,
                ccp: {}
            } : {
                commerceBackend: service,
                hams: {}
            },
            error: undefined,
            exception: undefined
        };
    } catch (exception) {
        return {
            payload: undefined,
            error: undefined,
            exception: exception
        };
    }
};
const $30c48f23b8aa47be$export$532017a098b73852 = (params, options)=>{
    const fetch = (0, $6H9BA.useCommerceFetch)();
    const effectiveOptions = (0, $42omo.useMemo)(()=>({
            fetch: fetch,
            ...options
        }), [
        fetch,
        options
    ]);
    const startTask = (0, $cEhot.useTaskTracker)({
        action: 'fetched',
        actionSubject: 'commerceRolloutInformation',
        source: 'unknown'
    });
    return (0, $4Twfb.useFetchService)((0, $42omo.useCallback)(async ()=>{
        const taskResult = await startTask(async ()=>{
            const result = await $30c48f23b8aa47be$export$49ab1426acf387e4(params, effectiveOptions);
            if ((0, $1Y5Zp.isSuccessful)(result)) return {
                succeed: {
                    payload: result.payload
                }
            };
            else if ((0, $1Y5Zp.isException)(result)) // fetch can sometimes throw, but most likely this is a bug
            return {
                fail: {
                    payload: result.exception,
                    loggablePayload: result.exception,
                    responsibleService: (0, $3SLm1).COMMERCE_LIBRARIES,
                    probabilityOfBug: (0, $3yFL2).GUARANTEED
                }
            };
            return {
                // Failed response from server.
                fail: {
                    payload: result.error,
                    responsibleService: (0, $3SLm1).BILLING_API_GATEWAY,
                    // TODO: Review HTTP codes to differentiate between bug and normal errors
                    probabilityOfBug: (0, $3yFL2).MAYBE
                }
            };
        });
        if (taskResult.succeed !== undefined) return taskResult.succeed.payload;
        throw taskResult.fail.payload;
    }, [
        startTask,
        params,
        effectiveOptions
    ]));
};
module.exports["COMMERCE_BACKEND_HAMS"] = $30c48f23b8aa47be$export$56507f8f3f7349a5;
module.exports["COMMERCE_BACKEND_CCP"] = $30c48f23b8aa47be$export$9a39331b1bb2f849;
module.exports["fetchCommerceRolloutInformation"] = $30c48f23b8aa47be$export$49ab1426acf387e4;

});

parcelRegister("gstll", function(module, exports) {
// top level domain should have a stargate proxy under this path
// see https://developer.atlassian.com/platform/stargate/concepts/domains/
const $973c3a69f9510c45$export$91e8019c72e4e6d = `/gateway/api`;
module.exports["GATEWAY_URL"] = $973c3a69f9510c45$export$91e8019c72e4e6d;

});

parcelRegister("6H9BA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4u5NT = parcelRequire("4u5NT");


var $goqBE = parcelRequire("goqBE");


var $bIMHH = parcelRequire("bIMHH");


var $1cK19 = parcelRequire("1cK19");


var $1EMUC = parcelRequire("1EMUC");


var $lzJ3V = parcelRequire("lzJ3V");

const $5f57f8a421838b9c$export$5f844fc0012b62a = ()=>{
    const commerceContextFetch = (0, $1EMUC.useCommerceOverride)(fetch);
    const dispatchSentryException = (0, $bIMHH.useSentryExceptionDispatch)();
    return (0, $42omo.useCallback)(async (...args)=>{
        const startTime = performance.now();
        const [fetchInput] = args;
        const sanitizedUrl = (0, $1cK19.sanitizeUrlString)((0, $lzJ3V.getRequestUrl)(fetchInput));
        try {
            const response = await commerceContextFetch(...args);
            if (response.status >= 400) dispatchSentryException({
                exception: new Error(`Status: ${response.status}\nURL: ${sanitizedUrl}`)
            });
            (0, $4u5NT.addSpanToAll)('fetch', sanitizedUrl, [
                {
                    name: 'network'
                }
            ], startTime, performance.now(), JSON.stringify(response).length);
            return response;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
            const oldErrorMessage = (()=>{
                if (error instanceof Error) return error.stack ?? error.toString();
                else return JSON.stringify(error);
            })();
            const newErrorMessage = `An error occurred when fetching from ${sanitizedUrl}\n\n ${oldErrorMessage}`;
            const wrappedError = new Error(newErrorMessage);
            dispatchSentryException({
                exception: wrappedError
            });
            throw error;
        }
    }, [
        commerceContextFetch,
        dispatchSentryException
    ]);
};
const $5f57f8a421838b9c$export$2eeff918208c7909 = (request, dispatchSentryException)=>request.catch((error)=>{
        // reportHttpError doesn't dispatch url as HttpResponseError has a resource name in the message
        if (error instanceof (0, $goqBE.HttpResponseError)) dispatchSentryException({
            exception: error
        });
        const oldErrorMessage = (()=>{
            if (error instanceof Error) return error.stack ?? error.toString();
            else return JSON.stringify(error);
        })();
        const newErrorMessage = `An error occurred when fetching data\n\n ${oldErrorMessage}`;
        dispatchSentryException({
            exception: new Error(newErrorMessage)
        });
        return error;
    });
module.exports["useCommerceFetch"] = $5f57f8a421838b9c$export$5f844fc0012b62a;

});

parcelRegister("goqBE", function(module, exports) {
class $de24e055bcb736b9$export$d2f2761cbe9cebf2 extends Error {
    constructor(resourceName, statusCode, body){
        super(`Unable to fetch ${resourceName}, status: ${statusCode}`);
        this.statusCode = void 0;
        this.body = void 0;
        this.name = 'HttpResponseError';
        this.statusCode = statusCode;
        this.body = body;
        // necessary as Subclassing Error needs special treatment in typescript for some compilation targets
        //https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $de24e055bcb736b9$export$d2f2761cbe9cebf2.prototype);
    }
}
const $de24e055bcb736b9$export$a4c208475de70990 = async (resourceName, response)=>{
    const res = await response;
    if (res.ok) return response;
    throw new $de24e055bcb736b9$export$d2f2761cbe9cebf2(resourceName, res.status, // ignore error if there is no body,
    // there is no way to check if body is set as https://developer.mozilla.org/en-US/docs/Web/API/Body/bodyUsed is not supported by many browsers
    await res.json().catch(()=>undefined));
};
module.exports["HttpResponseError"] = $de24e055bcb736b9$export$d2f2761cbe9cebf2;
module.exports["rejectOnHttpError"] = $de24e055bcb736b9$export$a4c208475de70990;

});

parcelRegister("bIMHH", function(module, exports) {

var $aNwpq = parcelRequire("aNwpq");


var $k6lJw = parcelRequire("k6lJw");


var $6YLhE = parcelRequire("6YLhE");

const $48dc7deec6188f73$export$3c3f21d4489e178a = (0, $aNwpq.internalGasV3UIEventChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$5e75c4fb0a07e6f4 = (0, $aNwpq.internalGasV3ScreenEventChannel).useEventDispatch;
const $48dc7deec6188f73$export$eb1dac57abae25e8 = (0, $aNwpq.internalGasV3TrackEventChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$ab6d20b2228c09c6 = (0, $aNwpq.internalGasV3OperationalEventChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$cf4d833c52e18bed = (0, $aNwpq.internalSentryExceptionChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$8eb9a37a282b8ea6 = (0, $k6lJw.createAtlaskitToEventChannelRepackager)($48dc7deec6188f73$export$3c3f21d4489e178a);
const $48dc7deec6188f73$export$d6cab26720f11779 = (0, $aNwpq.breadcrumbMountedEventChannel).Listener;
const $48dc7deec6188f73$export$794ea2871d096951 = (Component, name, attributes)=>(0, $6YLhE.withBreadcrumb)(Component, (0, $aNwpq.Breadcrumb), name, attributes);
module.exports["useSentryExceptionDispatch"] = $48dc7deec6188f73$export$cf4d833c52e18bed;

});

parcelRegister("aNwpq", function(module, exports) {

var $6YLhE = parcelRequire("6YLhE");


var $eUjEX = parcelRequire("eUjEX");

const $48f3d8edf25a7fa7$var$breadcrumbAPI = (0, $6YLhE.createBreadcrumbAPI)();
const $48f3d8edf25a7fa7$export$1622e7b9340efb0 = $48f3d8edf25a7fa7$var$breadcrumbAPI.breadcrumbMountedEventChannel;
const $48f3d8edf25a7fa7$export$dabcc1ec9dd9d1cc = $48f3d8edf25a7fa7$var$breadcrumbAPI.Breadcrumb;
const $48f3d8edf25a7fa7$export$a841c408695b0137 = $48f3d8edf25a7fa7$var$breadcrumbAPI.useGetBreadcrumbs;
const $48f3d8edf25a7fa7$export$58a908b728d2cddc = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$34eb9485fd3a664a = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$fb5e587076f78057 = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$f92d259194a988f8 = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$d9c23c680d73705d = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$b7973f9532f3f87f = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
const $48f3d8edf25a7fa7$export$5a78c7e669ed705e = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$90a2fbbf51eb525f = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
const $48f3d8edf25a7fa7$export$c70a8fa9e6b52c91 = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
const $48f3d8edf25a7fa7$export$d9101fe70b7457a1 = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
module.exports["breadcrumbMountedEventChannel"] = $48f3d8edf25a7fa7$export$1622e7b9340efb0;
module.exports["Breadcrumb"] = $48f3d8edf25a7fa7$export$dabcc1ec9dd9d1cc;
module.exports["internalGasV3UIEventChannel"] = $48f3d8edf25a7fa7$export$b7973f9532f3f87f;
module.exports["internalGasV3ScreenEventChannel"] = $48f3d8edf25a7fa7$export$5a78c7e669ed705e;
module.exports["internalGasV3TrackEventChannel"] = $48f3d8edf25a7fa7$export$90a2fbbf51eb525f;
module.exports["internalGasV3OperationalEventChannel"] = $48f3d8edf25a7fa7$export$c70a8fa9e6b52c91;
module.exports["internalSentryExceptionChannel"] = $48f3d8edf25a7fa7$export$d9101fe70b7457a1;

});

parcelRegister("6YLhE", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $eUjEX = parcelRequire("eUjEX");

const $098bf883a354e4d9$var$emptyObject = {};
const $098bf883a354e4d9$export$783e5d823c500873 = ()=>{
    const context = /*#__PURE__*/ (0, $42omo.createContext)(()=>undefined);
    const useGetBreadcrumbs = ()=>(0, $42omo.useContext)(context);
    const breadcrumbMountedEventChannel = (0, $eUjEX.createEventChannel)();
    const { useEventDispatch: useEventDispatch } = breadcrumbMountedEventChannel;
    const EmitEventOnMount = ({ name: name, getMountedBreadcrumbPayload: getMountedBreadcrumbPayload })=>{
        const eventDispatch = useEventDispatch();
        (0, $42omo.useEffect)(()=>{
            // Should always be defined at this point.
            eventDispatch(getMountedBreadcrumbPayload());
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            name
        ]);
        return null;
    };
    const Breadcrumb = ({ children: children, ...breadcrumbPayload })=>{
        const getParentBreadcrumbs = useGetBreadcrumbs();
        // TODO: Type inference doesn't seem to understand that children and name are never a part of breadcrumbPayload. Investigate and fix.
        const castBreadcrumbPayload = breadcrumbPayload;
        // Prevents breadcrumb callback from being recreated everytime props change/every-render
        const breadcrumbRef = (0, $42omo.useRef)(castBreadcrumbPayload);
        (0, $42omo.useLayoutEffect)(()=>{
            // Ensures that the breadcrumb only updates when it component is mounted
            breadcrumbRef.current = castBreadcrumbPayload;
        });
        // TODO: Memoize this in the future?
        const getMountedBreadcrumbPayload = (0, $42omo.useCallback)(()=>({
                breadcrumbs: [
                    ...getParentBreadcrumbs()?.breadcrumbs ?? [],
                    breadcrumbRef.current
                ],
                payload: breadcrumbRef.current
            }), [
            getParentBreadcrumbs
        ]);
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(EmitEventOnMount, {
                    name: breadcrumbPayload.name,
                    getMountedBreadcrumbPayload: getMountedBreadcrumbPayload
                }),
                /*#__PURE__*/ (0, $l998X.jsx)(context.Provider, {
                    value: getMountedBreadcrumbPayload,
                    children: children
                })
            ]
        });
    };
    return {
        breadcrumbMountedEventChannel: /**
		 * An event channel whos event represents that a breadcrumb was mounted
		 */ breadcrumbMountedEventChannel,
        Breadcrumb: Breadcrumb,
        useGetBreadcrumbs: useGetBreadcrumbs
    };
};
const $098bf883a354e4d9$export$d3653322274df895 = ({ useGetBreadcrumbs: useGetBreadcrumbs }, createEventChannelFn = (0, $eUjEX.createEventChannel))=>{
    const { Listener: Listener, useEventDispatch: useEventDispatch } = createEventChannelFn();
    const useBreadcrumbedEventDispatch = ()=>{
        const eventDispatch = useEventDispatch();
        const getParentBreadcrumbs = useGetBreadcrumbs();
        const breadcrumbedEventDispatch = (0, $42omo.useCallback)((payload)=>eventDispatch({
                breadcrumbs: getParentBreadcrumbs()?.breadcrumbs ?? [],
                payload: payload
            }), [
            getParentBreadcrumbs,
            eventDispatch
        ]);
        return breadcrumbedEventDispatch;
    };
    return {
        Listener: Listener,
        useEventDispatch: useEventDispatch,
        useBreadcrumbedEventDispatch: useBreadcrumbedEventDispatch
    };
};
const $098bf883a354e4d9$export$794ea2871d096951 = (Component, Breadcrumb, name, // TODO: Fix up this type
breadcrumbFields = $098bf883a354e4d9$var$emptyObject)=>{
    const ComponentWithBreadcrumb = (props)=>/*#__PURE__*/ (0, $l998X.jsx)(Breadcrumb, {
            ...breadcrumbFields,
            name: name,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...props
            })
        });
    return ComponentWithBreadcrumb;
};
module.exports["createBreadcrumbAPI"] = $098bf883a354e4d9$export$783e5d823c500873;
module.exports["createBreadcrumbedEventChannel"] = $098bf883a354e4d9$export$d3653322274df895;
module.exports["withBreadcrumb"] = $098bf883a354e4d9$export$794ea2871d096951;

});

parcelRegister("eUjEX", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $e0bd124d99ee3c1b$export$5f3dbb5babc7e42e = (defaultOnEventCallback)=>{
    const context = /*#__PURE__*/ (0, $42omo.createContext)(defaultOnEventCallback);
    const useEventDispatch = ()=>{
        const onEventCallback = (0, $42omo.useContext)(context);
        const fireEventCallback = (0, $42omo.useCallback)((event)=>{
            onEventCallback?.(event);
        }, [
            onEventCallback
        ]);
        return fireEventCallback;
    };
    const EventCatcher = ({ onEvent: onEvent, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)(context.Provider, {
            value: onEvent,
            children: children
        });
    return {
        Listener: EventCatcher,
        useEventDispatch: useEventDispatch
    };
};
const $e0bd124d99ee3c1b$export$7b182ad6fa711a33 = ()=>{
    const catchingEventChannel = $e0bd124d99ee3c1b$export$5f3dbb5babc7e42e();
    const ListenerThatDoesntConsumeEvent = $e0bd124d99ee3c1b$export$a5fa32b3c7f79e99({
        from: catchingEventChannel.Listener,
        to: catchingEventChannel.useEventDispatch
    });
    return {
        Listener: ListenerThatDoesntConsumeEvent,
        useEventDispatch: catchingEventChannel.useEventDispatch
    };
};
const $e0bd124d99ee3c1b$export$21d0f08655d40180 = (...listenersToCombine)=>{
    const CombinedListener = ({ children: children, onEvent: onEvent })=>{
        let wrappedChildren = children;
        for (const ListenerToCombine of listenersToCombine)wrappedChildren = ListenerToCombine({
            onEvent: onEvent,
            children: wrappedChildren
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: wrappedChildren
        });
    };
    return CombinedListener;
};
const $e0bd124d99ee3c1b$export$9591aa59b8e3deeb = ({ from: inboundListenerValue, to: useOutboundEventDispatch, useTransformer: useTransformer })=>{
    const InboundListener = Array.isArray(inboundListenerValue) ? $e0bd124d99ee3c1b$export$21d0f08655d40180(...inboundListenerValue) : inboundListenerValue;
    const Transformer = ({ children: children, ...transformerProps })=>{
        const dispatchTransformedEvent = useOutboundEventDispatch();
        const transform = useTransformer(transformerProps);
        const transformFn = (0, $42omo.useCallback)((payload)=>{
            const transformed = transform(payload);
            dispatchTransformedEvent(transformed);
        }, [
            dispatchTransformedEvent,
            transform
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)(InboundListener, {
            onEvent: transformFn,
            children: children
        });
    };
    return Transformer;
};
const $e0bd124d99ee3c1b$export$a5fa32b3c7f79e99 = ({ from: from, to: to })=>{
    const ListenerThatDoesntConsumeEvent = $e0bd124d99ee3c1b$export$9591aa59b8e3deeb({
        from: from,
        to: to,
        useTransformer: ({ onEvent: onEvent })=>(0, $42omo.useCallback)((payload)=>{
                onEvent(payload);
                return payload;
            }, [
                onEvent
            ])
    });
    return ListenerThatDoesntConsumeEvent;
};
const $e0bd124d99ee3c1b$export$6c91a1925c226122 = (Listener, filter)=>{
    const FilteredListener = ({ onEvent: onEvent, ...other })=>{
        const filteredOnEvent = (0, $42omo.useCallback)((eventPayload)=>{
            if (filter(eventPayload)) onEvent(eventPayload);
        }, [
            onEvent
        ]);
        return Listener({
            onEvent: filteredOnEvent,
            ...other
        });
    };
    return FilteredListener;
};
const $e0bd124d99ee3c1b$export$acca048df1683b81 = (children, components)=>{
    let wrappedChildren = /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    for(let i = components.length - 1; i >= 0; i--){
        const { Listener: Listener, onEvent: onEvent } = components[i];
        wrappedChildren = /*#__PURE__*/ (0, $l998X.jsx)(Listener, {
            onEvent: onEvent,
            children: wrappedChildren
        });
    }
    return wrappedChildren;
};
module.exports["createCatchingEventChannel"] = $e0bd124d99ee3c1b$export$5f3dbb5babc7e42e;
module.exports["createEventChannel"] = $e0bd124d99ee3c1b$export$7b182ad6fa711a33;

});

parcelRegister("k6lJw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");

var $inPa6 = parcelRequire("inPa6");

const $39d282bcf5375d57$var$ATLASKIT_CHANNEL = 'atlaskit';
const $39d282bcf5375d57$export$b1e3a2222bb9a86d = (useEventDispatch, channel)=>{
    const RepackageAnalyticsNextEvent = ({ children: children, ...uiProperties })=>{
        const dispatchAnalytics = useEventDispatch();
        const repackageAtlaskitEvent = (0, $42omo.useCallback)((event)=>{
            dispatchAnalytics({
                ...uiProperties,
                ...event.payload,
                attributes: {
                    ...uiProperties.attributes,
                    ...event.payload.attributes
                }
            });
        }, [
            dispatchAnalytics,
            uiProperties
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $kDuN4.default), {
            channel: channel,
            onEvent: repackageAtlaskitEvent,
            children: children
        });
    };
    return RepackageAnalyticsNextEvent;
};
const $39d282bcf5375d57$export$1ec809871e34d2f0 = (// TODO: Technically, we can make the type more specific than just UIAnalyticsPayload
useEventDispatch)=>{
    const RepackageAtlaskitEvent = $39d282bcf5375d57$export$b1e3a2222bb9a86d(useEventDispatch, 'atlaskit');
    return RepackageAtlaskitEvent;
};
const $39d282bcf5375d57$export$ad0c43fbe23d07ab = (Listener, channel = $39d282bcf5375d57$var$ATLASKIT_CHANNEL)=>{
    return ({ children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
        const fireAsAtlaskitEvent = (0, $42omo.useCallback)((payload)=>{
            createAnalyticsEvent(payload).fire(channel);
        }, [
            createAnalyticsEvent
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)(Listener, {
            onEvent: fireAsAtlaskitEvent,
            children: children
        });
    };
};
module.exports["createAtlaskitToEventChannelRepackager"] = $39d282bcf5375d57$export$1ec809871e34d2f0;

});

parcelRegister("1cK19", function(module, exports) {
/**
 * @param url The URL you want to sanitize
 * @returns A URL string without any user generated content (UGC) or PII (personally identifiable information). The URL will not necessarily be valid URL.
 */ const $3031758fc3a9c9bd$export$ceb09b958e605eff = (url)=>{
    // TODO: Should redact anything not from atlassian.com/atlassian.net/bitbucket.org/etc
    return url.replace(/\?.*$/, '');
};
module.exports["sanitizeUrlString"] = $3031758fc3a9c9bd$export$ceb09b958e605eff;

});

parcelRegister("1EMUC", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9Bcp3 = parcelRequire("9Bcp3");

const $fb2833db791c8fde$export$8d3ccdf5c3b9600a = ({ children: children, overrides: overrides })=>{
    const [registry] = (0, $42omo.useState)(()=>new Map(overrides));
    (0, $42omo.useEffect)(()=>{
        const callbacks = overrides.map(([subject, target])=>$fb2833db791c8fde$export$87a46fc2314946e0(registry, subject, target));
        return ()=>callbacks.forEach((cb)=>cb());
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    overrides);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9Bcp3.overrideContext).Provider, {
        value: registry,
        children: children
    });
};
const $fb2833db791c8fde$export$edb6244a86733174 = ()=>(0, $42omo.useContext)((0, $9Bcp3.overrideContext));
const $fb2833db791c8fde$export$87a46fc2314946e0 = (registry, subject, override)=>{
    registry.set(subject, override);
    return ()=>{
        registry.delete(subject);
    };
};
const $fb2833db791c8fde$export$9218bfcced62f524 = (registry, subject)=>{
    return registry.get(subject) || subject;
};
const $fb2833db791c8fde$export$cf6f15ae0c6d3b84 = (subject)=>{
    const registry = $fb2833db791c8fde$export$edb6244a86733174();
    return (registry || new Map()).get(subject) || subject;
};
const $fb2833db791c8fde$export$ef191f4a42af511d = (subject, target)=>[
        subject,
        target
    ];
module.exports["useCommerceOverride"] = $fb2833db791c8fde$export$cf6f15ae0c6d3b84;

});

parcelRegister("9Bcp3", function(module, exports) {
// eslint-disable-next-line import/no-extraneous-dependencies

var $42omo = parcelRequire("42omo");

const $0f5923cabface8ba$export$81b0387840a1a60c = (0, $42omo.createContext)(new Map());
module.exports["overrideContext"] = $0f5923cabface8ba$export$81b0387840a1a60c;

});

parcelRegister("lzJ3V", function(module, exports) {
const $8b805f09b2bef0e7$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
module.exports["getRequestUrl"] = $8b805f09b2bef0e7$export$14619c0eed01a470;

});

parcelRegister("4Twfb", function(module, exports) {
// eslint-disable-next-line import/no-extraneous-dependencies

var $42omo = parcelRequire("42omo");

const $b022c09cd7385a9a$export$6de4685a6c88b4e9 = (request, initialState = {
    loading: false,
    data: undefined,
    error: undefined
})=>{
    const [state, setState] = (0, $42omo.useState)(initialState);
    const fetchData = (0, $42omo.useCallback)(async (...requestArgs)=>{
        setState({
            loading: true,
            data: undefined,
            error: undefined
        });
        try {
            const data = await request(...requestArgs);
            setState({
                loading: false,
                data: data,
                error: undefined
            });
            return data;
        } catch (error) {
            // Casting promise error to provided type. I assumes that the person that
            // provides types know that kind of type promise will return on reject.
            setState({
                loading: false,
                data: undefined,
                error: error
            });
            throw error;
        }
    }, [
        request
    ]);
    return (0, $42omo.useMemo)(()=>({
            ...state,
            fetchData: fetchData
        }), [
        state,
        fetchData
    ]);
};
const $b022c09cd7385a9a$export$ff7e5879ade03276 = (request)=>{
    const service = $b022c09cd7385a9a$export$6de4685a6c88b4e9(request, {
        loading: true,
        data: undefined,
        error: undefined
    });
    const { fetchData: fetchData } = service;
    (0, $42omo.useEffect)(()=>{
        // on error promise will be resolved to undefined, error instance available in state
        // eslint-disable-next-line no-console
        fetchData().catch((error)=>console.warn(error));
    }, [
        fetchData
    ]);
    return (0, $42omo.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            refresh: ()=>fetchData()
        };
    }, [
        service
    ]);
};
const $b022c09cd7385a9a$export$18e513c1248d8ad5 = (request)=>{
    const service = $b022c09cd7385a9a$export$6de4685a6c88b4e9(request, {
        loading: false,
        data: undefined,
        error: undefined
    });
    return (0, $42omo.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            update: fetchData
        };
    }, [
        service
    ]);
};
const $b022c09cd7385a9a$export$d9765c5cd98039 = (request)=>{
    const service = $b022c09cd7385a9a$export$18e513c1248d8ad5(request);
    return (0, $42omo.useMemo)(()=>{
        const { update: update, ...state } = service;
        return {
            ...state,
            fetch: update
        };
    }, [
        service
    ]);
};
const $b022c09cd7385a9a$export$7077fee76310bc60 = (request)=>{
    const service = $b022c09cd7385a9a$export$6de4685a6c88b4e9(request);
    return (0, $42omo.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            create: fetchData
        };
    }, [
        service
    ]);
};
module.exports["useFetchService"] = $b022c09cd7385a9a$export$ff7e5879ade03276;
module.exports["useUpdateService"] = $b022c09cd7385a9a$export$18e513c1248d8ad5;

});

parcelRegister("3yFL2", function(module, exports) {
/**
 * For when the code is meant to only ever executed when a bug has ocurred.
 *
 * Note: Choosing a probability-of-bug value should not be speculate/account for specific bugs in the code base
 *
 * Examples:
 * - A top-level try-catch whos only purpose is to prevent your entire application from crashing when random exceptions are thrown
 * - HTTP 500 status code handling logic (assuming 500s only happen when the server has experienced a bug/crash)
 * - Server responses that signal that the JSON payload frontend sent was completely wrong
 * - Part of your app unexpectedly crashes
 * - Any response bodys/HTTP statuses you were not expecting to receive
 */ const $46d5cbdb1ec76aac$export$6af268b89fae390b = 'guaranteed';
const $46d5cbdb1ec76aac$export$dab33e9f81ed2cbf = 'maybe';
const $46d5cbdb1ec76aac$export$c53d0f541b41b88e = 'none';
module.exports["GUARANTEED"] = $46d5cbdb1ec76aac$export$6af268b89fae390b;
module.exports["MAYBE"] = $46d5cbdb1ec76aac$export$dab33e9f81ed2cbf;
module.exports["NONE"] = $46d5cbdb1ec76aac$export$c53d0f541b41b88e;

});

parcelRegister("3SLm1", function(module, exports) {
/**
 * Note: If you add a service here please name after what's mentioned in Microscope.
 * It'll make figuring out who to page (if we need to) easier. See: https://microscope.prod.atl-paas.net/services/commerce-libraries
 *
 * TODO: Probably worth adding some sort of build check to make sure this is enforced
 */ /**
 * It's not enforced, but if you add a service here
 */ /**
 * Generally, you'll want to use this value if you're not 100% sure who can cause the error.
 */ const $a2df338368098843$export$78244dbb77cfa6b6 = 'unknown';
const $a2df338368098843$export$aed27a6561cc0f5c = 'unknown-external';
const $a2df338368098843$export$983d8427a452c1b = 'commerce-libraries';
const $a2df338368098843$export$d5a5208541f78b0 = 'hams';
const $a2df338368098843$export$856303030f6df405 = 'billing-api-gateway';
module.exports["UNKNOWN"] = $a2df338368098843$export$78244dbb77cfa6b6;
module.exports["UNKNOWN_EXTERNAL"] = $a2df338368098843$export$aed27a6561cc0f5c;
module.exports["COMMERCE_LIBRARIES"] = $a2df338368098843$export$983d8427a452c1b;
module.exports["HAMS"] = $a2df338368098843$export$d5a5208541f78b0;
module.exports["BILLING_API_GATEWAY"] = $a2df338368098843$export$856303030f6df405;

});

parcelRegister("cEhot", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3yFL2 = parcelRequire("3yFL2");


var $aNwpq = parcelRequire("aNwpq");


var $in0Xj = parcelRequire("in0Xj");


var $3SLm1 = parcelRequire("3SLm1");


var $jVQXW = parcelRequire("jVQXW");

const $d09c0c9679eec46e$export$9a00dee1beb8f576 = (actionSubject)=>{
    return actionSubject.charAt(0).toUpperCase() + actionSubject.substring(1);
};
const $d09c0c9679eec46e$export$4903c942fa101973 = {
    TASK_FAILURE: 'fe.user.task.failure',
    TASK_SUCCESS: 'fe.user.task.success'
};
const $d09c0c9679eec46e$export$b921bb722afe30af = ({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, histogramBuckets: _histogramBuckets = '4000' })=>{
    const dispatchGasV3Track = (0, $aNwpq.internalGasV3TrackEventChannel).useBreadcrumbedEventDispatch();
    const dispatchSentry = (0, $aNwpq.internalSentryExceptionChannel).useBreadcrumbedEventDispatch();
    const task = actionSubjectId ? `${actionSubjectId}` : `${action}${$d09c0c9679eec46e$export$9a00dee1beb8f576(actionSubject)}`;
    return (0, $42omo.useCallback)((payload)=>{
        const sharedGasV3Payload = {
            ...payload
        };
        const sendSentryEvent = (loggablePayload, eventName, eventTaskId, exceptionTags)=>{
            if (loggablePayload === undefined && [
                (0, $3yFL2.MAYBE),
                (0, $3yFL2.NONE)
            ].includes(exceptionTags.probabilityOfBug)) // Don't bother sending a payload if it's undefined and the probability of bug isn't guaranteed
            // TODO: Should enforce that it's never undefined for ProbabilityOfBug.GUARANTEED
            return;
            dispatchSentry({
                exception: loggablePayload,
                scopeContext: (0, $in0Xj.withTelemetryInfoScopeContext)({
                    tags: {
                        task: task,
                        eventName: eventName,
                        ...exceptionTags,
                        ...eventTaskId !== undefined ? {
                            eventTaskId: eventTaskId
                        } : undefined,
                        ...payload.actionSubjectId !== undefined ? {
                            actionSubjectId: payload.actionSubjectId
                        } : undefined
                    }
                })
            });
        };
        const fail = ({ loggablePayload: loggablePayload, probabilityOfBug: probabilityOfBug = (0, $3yFL2.MAYBE), eventTaskId: baseEventTaskId, responsibleService: responsibleService = (0, $3SLm1.UNKNOWN) } = {})=>{
            const eventTaskId = (()=>{
                if (baseEventTaskId !== undefined) return baseEventTaskId;
                if (probabilityOfBug === (0, $3yFL2.GUARANTEED)) {
                    if ((0, $jVQXW.responsibleServiceIncludesCommerceLibraries)(responsibleService)) return 'guaranteed-bug';
                    return 'external-bug';
                }
                // Not sending any other values in fear of cardinality problems
                return undefined;
            })();
            sendSentryEvent(loggablePayload, $d09c0c9679eec46e$export$4903c942fa101973.TASK_FAILURE, eventTaskId, {
                probabilityOfBug: probabilityOfBug,
                responsibleService: responsibleService
            });
        // TODO: Consider sending some sort of GasV3 failure information
        };
        const succeed = ({ loggablePayload: loggablePayload, eventTaskId: eventTaskId, responsibleService: responsibleService = (0, $3SLm1.UNKNOWN) } = {})=>{
            sendSentryEvent(loggablePayload, $d09c0c9679eec46e$export$4903c942fa101973.TASK_SUCCESS, eventTaskId, {
                probabilityOfBug: (0, $3yFL2.NONE),
                responsibleService: responsibleService
            });
            dispatchGasV3Track(sharedGasV3Payload);
        };
        return {
            fail: fail,
            succeed: succeed
        };
    }, [
        dispatchGasV3Track,
        dispatchSentry,
        task
    ]);
};
const $d09c0c9679eec46e$export$94273a7593441cd3 = (x)=>x.succeed !== undefined;
const $d09c0c9679eec46e$export$8ea5335bded027a0 = (taskInfo)=>{
    const startTask = $d09c0c9679eec46e$export$b921bb722afe30af(taskInfo);
    const taskInfoRef = (0, $42omo.useRef)(taskInfo);
    // TODO: replace by useEvent once it is available. Ponyfilling with useRef for now
    const higherLevelStartTask = (0, $42omo.useCallback)(/**
		 * Please note that thrown errors will be interpreted as guaranteed buggy failures.
		 * @param payload This data passed into this function will be shared between both failure and successful tasks
		 */ async (callback, payload)=>{
        const { fail: fail, succeed: succeed } = startTask(payload || taskInfoRef.current);
        try {
            const result = await callback();
            if (result.succeed !== undefined) succeed(result.succeed);
            else if (result.fail !== undefined) fail(result.fail);
            else fail({
                probabilityOfBug: (0, $3yFL2.GUARANTEED),
                loggablePayload: {
                    result: result,
                    error: new Error('Could not find succeed nor fail')
                }
            });
            return result;
        } catch (err) {
            if (err instanceof TypeError && err.message === 'Failed to fetch') fail({
                probabilityOfBug: (0, $3yFL2.MAYBE),
                loggablePayload: err
            });
            else fail({
                probabilityOfBug: (0, $3yFL2.GUARANTEED),
                loggablePayload: err
            });
            throw err;
        }
    }, [
        startTask
    ]);
    return higherLevelStartTask;
};
module.exports["useTaskTracker"] = $d09c0c9679eec46e$export$8ea5335bded027a0;

});

parcelRegister("in0Xj", function(module, exports) {

var $3yFL2 = parcelRequire("3yFL2");


var $3SLm1 = parcelRequire("3SLm1");


var $jVQXW = parcelRequire("jVQXW");

const $2cec5ac4f8c71665$export$bf5f90a1a9d2de58 = ({ probabilityOfBug: probabilityOfBug, responsibleService: responsibleService })=>{
    switch(probabilityOfBug){
        case 0, $3yFL2.GUARANTEED:
            if ((0, $jVQXW.responsibleServiceIncludesCommerceLibraries)(responsibleService)) return 'fatal';
            return 'error';
        case 0, $3yFL2.MAYBE:
            return 'warning';
        case 0, $3yFL2.NONE:
            return 'log';
        default:
            // Should never happen so sending critical :3
            return 'fatal';
    }
};
const $2cec5ac4f8c71665$var$severityOrdering = new Map([
    [
        'fatal',
        0
    ],
    [
        'fatal',
        1
    ],
    [
        'error',
        2
    ],
    [
        'warning',
        3
    ],
    [
        'info',
        4
    ],
    [
        'log',
        5
    ],
    [
        undefined,
        6
    ]
]);
const $2cec5ac4f8c71665$export$cae73843c52c598b = (severity1, severity2)=>{
    if ($2cec5ac4f8c71665$var$severityOrdering.get(severity1) <= $2cec5ac4f8c71665$var$severityOrdering.get(severity2)) return severity1;
    return severity2;
};
const $2cec5ac4f8c71665$export$c7063fd1387b3458 = (scopeContext)=>{
    const tags = {
        ...scopeContext.tags,
        responsibleService: scopeContext.tags.responsibleService ?? (0, $3SLm1.UNKNOWN)
    };
    return {
        ...scopeContext,
        tags: tags,
        level: $2cec5ac4f8c71665$export$bf5f90a1a9d2de58(tags)
    };
};
module.exports["withTelemetryInfoScopeContext"] = $2cec5ac4f8c71665$export$c7063fd1387b3458;

});

parcelRegister("jVQXW", function(module, exports) {

var $3SLm1 = parcelRequire("3SLm1");

const $d91c14f6a33096f8$export$6d5fcf71bce583e2 = (responsibleService)=>responsibleService === (0, $3SLm1.COMMERCE_LIBRARIES) || responsibleService === (0, $3SLm1.UNKNOWN);
module.exports["responsibleServiceIncludesCommerceLibraries"] = $d91c14f6a33096f8$export$6d5fcf71bce583e2;

});

parcelRegister("1Y5Zp", function(module, exports) {
const $1fb762876766bde5$export$40f07171f4b6ee01 = (result)=>result.exception !== undefined;
const $1fb762876766bde5$export$e6127cc7fe7395c3 = (result)=>result.error !== undefined;
const $1fb762876766bde5$export$a7324067d5b1efd6 = (result)=>result.payload !== undefined;
const $1fb762876766bde5$export$4ece3b219cb1e8e7 = (result)=>result.payload === undefined;
const $1fb762876766bde5$export$d0a8c5cfb02e95fe = (error)=>({
        error: error,
        payload: undefined,
        exception: undefined
    });
const $1fb762876766bde5$export$6338ef6f72008c7 = (payload)=>({
        payload: payload,
        error: undefined,
        exception: undefined
    });
const $1fb762876766bde5$export$89242b2b73a7bdd = (exception)=>{
    return {
        payload: undefined,
        error: undefined,
        exception: exception
    };
};
module.exports["isException"] = $1fb762876766bde5$export$40f07171f4b6ee01;
module.exports["isSuccessful"] = $1fb762876766bde5$export$a7324067d5b1efd6;

});

parcelRegister("lh1MN", function(module, exports) {
const $7f1ee6750f4adf66$export$db45730c9afae012 = (data)=>{
    if (!data) return undefined;
    return data.confluence_tenantContext?.licenseStates?.confluence?.ccpEntitlementId || undefined;
};
module.exports["getCcpEntitlementFromQuery"] = $7f1ee6750f4adf66$export$db45730c9afae012;

});

parcelRegister("hfUvC", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $42omo = parcelRequire("42omo");


var $6bHqX = parcelRequire("6bHqX");


var $bXe73 = parcelRequire("bXe73");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");

const $e7daf7179cc3ad9e$export$b65b36d21c9a62a9 = 'confluence.ondemand';
const $e7daf7179cc3ad9e$var$memoizedFetchCommerceRolloutInformation = (0, $2XqLN.default)(async (cloudId)=>{
    const rolloutInfoResult = await (0, $6bHqX.fetchCommerceRolloutInformation)({
        cloudId: cloudId,
        productKey: $e7daf7179cc3ad9e$export$b65b36d21c9a62a9
    }, {
        fetch: (0, $f7B1p.cfetch)
    });
    return rolloutInfoResult;
});
const $e7daf7179cc3ad9e$export$44d1450d6b2633f0 = (skip = false)=>{
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(null);
    const [commerceBackendName, setCommerceBackendName] = (0, $42omo.useState)(null);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    if (!cloudId) skip = true;
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        const fetchCommerceRolloutInformation = async ()=>{
            try {
                const rolloutInfoResult = await $e7daf7179cc3ad9e$var$memoizedFetchCommerceRolloutInformation(cloudId);
                if ((0, $bXe73.isSuccessful)(rolloutInfoResult)) setCommerceBackendName(rolloutInfoResult.payload.commerceBackend);
                else {
                    const error_1 = (0, $bXe73.isException)(rolloutInfoResult) ? rolloutInfoResult.exception : rolloutInfoResult.error;
                    setError(error_1);
                }
            } catch (error_0) {
                error_0.message = `useCommerceBackendName: ${error_0.message}`;
                setError(error_0);
            } finally{
                setLoading(false);
            }
        };
        fetchCommerceRolloutInformation();
    }, [
        cloudId,
        skip
    ]);
    return {
        commerceBackendName: skip ? null : commerceBackendName,
        loading: skip ? false : loading,
        error: skip ? null : error
    };
};
module.exports["useCommerceRolloutInformation"] = $e7daf7179cc3ad9e$export$44d1450d6b2633f0;

});

parcelRegister("bXe73", function(module, exports) {
const $f975479e12996987$export$40f07171f4b6ee01 = (result)=>result.exception !== undefined;
const $f975479e12996987$export$e6127cc7fe7395c3 = (result)=>result.error !== undefined;
const $f975479e12996987$export$a7324067d5b1efd6 = (result)=>result.payload !== undefined;
const $f975479e12996987$export$4ece3b219cb1e8e7 = (result)=>result.payload === undefined;
const $f975479e12996987$export$d0a8c5cfb02e95fe = (error)=>({
        error: error,
        payload: undefined,
        exception: undefined
    });
const $f975479e12996987$export$6338ef6f72008c7 = (payload)=>({
        payload: payload,
        error: undefined,
        exception: undefined
    });
const $f975479e12996987$export$89242b2b73a7bdd = (exception)=>{
    return {
        payload: undefined,
        error: undefined,
        exception: exception
    };
};
module.exports["isException"] = $f975479e12996987$export$40f07171f4b6ee01;
module.exports["isSuccessful"] = $f975479e12996987$export$a7324067d5b1efd6;

});

parcelRegister("dqdrq", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $izVB4 = parcelRequire("izVB4");


var $j4WDj = parcelRequire("j4WDj");


var $6J7Bn = parcelRequire("6J7Bn");

const $ce55fe36479bc4cf$var$StyledButton = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(11);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? (0, $6J7Bn.ButtonBase) : t2;
        let t3;
        let t4;
        let t5;
        let t6;
        let t7;
        let t8;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_START));
            t4 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_END));
            t5 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_START));
            t6 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_END));
            t7 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_START));
            t8 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_END));
            $[3] = t3;
            $[4] = t4;
            $[5] = t5;
            $[6] = t6;
            $[7] = t7;
            $[8] = t8;
        } else {
            t3 = $[3];
            t4 = $[4];
            t5 = $[5];
            t6 = $[6];
            t7 = $[7];
            t8 = $[8];
        }
        let t9;
        if ($[9] !== __cmpls) {
            t9 = {
                ...__cmpls,
                "--_iozncj": t3,
                "--_id2ec3": t4,
                "--_1wa1xp5": t5,
                "--_1ck0ygl": t6,
                "--_1jf6nc6": t7,
                "--_1kksnqn": t8
            };
            $[9] = __cmpls;
            $[10] = t9;
        } else t9 = $[10];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmplp,
            style: t9,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1wgmglyw _1tnq12b0 _nup9qsa8 _ge1r1cay _h99ltlke _r7sm1uxc _1xlotlke _1jypidpf _1fm3idpf _12z9idpf _1dwpidpf _kl6h116y _1w901gfe _1l5a1gfe _zelm1gfe _1fh11gfe _1f1j1gfe",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = (0, $6J7Bn.ButtonBase), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_iozncj": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_START)),
            "--_id2ec3": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_END)),
            "--_1wa1xp5": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_START)),
            "--_1ck0ygl": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_END)),
            "--_1jf6nc6": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_START)),
            "--_1kksnqn": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_END))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1wgmglyw _1tnq12b0 _nup9qsa8 _ge1r1cay _h99ltlke _r7sm1uxc _1xlotlke _1jypidpf _1fm3idpf _12z9idpf _1dwpidpf _kl6h116y _1w901gfe _1l5a1gfe _zelm1gfe _1fh11gfe _1f1j1gfe",
            __cmplp.className
        ])
    });
});
const $ce55fe36479bc4cf$var$ButtonText = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw _4cvr1h6o _1bah1h6o _k48p1wq8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw _4cvr1h6o _1bah1h6o _k48p1wq8",
            __cmplp.className
        ])
    });
}); /**
     * A styled button with a gradient background, intended to be used as a product edition upgrade CTA button.
     */ 
const $ce55fe36479bc4cf$export$d1aef6466b5ecaa5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    let buttonProps;
    let children;
    if ($[0] !== t0) {
        ({ children: children, ...buttonProps } = t0);
        $[0] = t0;
        $[1] = buttonProps;
        $[2] = children;
    } else {
        buttonProps = $[1];
        children = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: ""
        });
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$ButtonText, null, children);
        $[4] = children;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== buttonProps || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$StyledButton, {
            iconBefore: t1,
            ...buttonProps
        }, t2);
        $[6] = buttonProps;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ children: children, ...buttonProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$StyledButton, {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: ""
        }),
        ...buttonProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$ButtonText, null, children));
};
module.exports["GradientCTAButton"] = $ce55fe36479bc4cf$export$d1aef6466b5ecaa5;

});

parcelRegister("j4WDj", function(module, exports) {
const $67193f3c2d75b820$export$3ff4048780acdec9 = "var(--ds-chart-purple-bolder, #AF59E1)";
const $67193f3c2d75b820$export$ac8ee41608bff6f4 = "var(--ds-chart-blue-bolder, #357DE8)";
const $67193f3c2d75b820$export$12fbdde791205cea = "var(--ds-chart-purple-bolder-hovered, #964AC0)";
const $67193f3c2d75b820$export$7653c62635354aaf = "var(--ds-chart-blue-bolder-hovered, #1868DB)";
const $67193f3c2d75b820$export$d4accc94291dcf84 = "var(--ds-chart-purple-boldest, #803FA5)";
const $67193f3c2d75b820$export$16a15d5a9b73591b = "var(--ds-chart-blue-boldest, #1558BC)";
const $67193f3c2d75b820$export$fca70c3c81bb0f58 = "var(--ds-background-accent-blue-subtlest, #E9F2FE)";
const $67193f3c2d75b820$export$f737ffc625de304f = "var(--ds-background-accent-purple-subtlest, #F8EEFE)";
const $67193f3c2d75b820$export$b1ab5fb618714abb = "var(--ds-border-accent-purple, #AF59E1)";
const $67193f3c2d75b820$export$7a262e0e9c5a1e2a = "var(--ds-border-accent-blue, #357DE8)";
const $67193f3c2d75b820$export$71b6aed4f8256b2 = "var(--ds-background-discovery-bold-pressed, #673286)";
const $67193f3c2d75b820$export$c9d89eb8e0b59a5a = "var(--ds-background-selected-bold-pressed, #123263)";
module.exports["GRADIENT_CTA_BUTTON_DEFAULT_START"] = $67193f3c2d75b820$export$3ff4048780acdec9;
module.exports["GRADIENT_CTA_BUTTON_DEFAULT_END"] = $67193f3c2d75b820$export$ac8ee41608bff6f4;
module.exports["GRADIENT_CTA_BUTTON_HOVER_START"] = $67193f3c2d75b820$export$12fbdde791205cea;
module.exports["GRADIENT_CTA_BUTTON_HOVER_END"] = $67193f3c2d75b820$export$7653c62635354aaf;
module.exports["GRADIENT_CTA_BUTTON_ACTIVE_START"] = $67193f3c2d75b820$export$d4accc94291dcf84;
module.exports["GRADIENT_CTA_BUTTON_ACTIVE_END"] = $67193f3c2d75b820$export$16a15d5a9b73591b;
module.exports["GRADIENT_BACKGROUND_SUBTLEST_START"] = $67193f3c2d75b820$export$fca70c3c81bb0f58;
module.exports["GRADIENT_BACKGROUND_SUBTLEST_END"] = $67193f3c2d75b820$export$f737ffc625de304f;
module.exports["GRADIENT_CTA_BUTTON_INVERTED_BORDER_START"] = $67193f3c2d75b820$export$b1ab5fb618714abb;
module.exports["GRADIENT_CTA_BUTTON_INVERTED_BORDER_END"] = $67193f3c2d75b820$export$7a262e0e9c5a1e2a;
module.exports["GRADIENT_CTA_BUTTON_SELECTED_START"] = $67193f3c2d75b820$export$71b6aed4f8256b2;
module.exports["GRADIENT_CTA_BUTTON_SELECTED_END"] = $67193f3c2d75b820$export$c9d89eb8e0b59a5a;

});

parcelRegister("6J7Bn", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");

const $e9beab952dc913a3$export$b0bb876e969289cd = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $eEA8O.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_d16p1ano _1dqt12x7 _1toh1r31 _5jyqglyw _mrqmnqa1 _if29116y _1kba1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_d16p1ano _1dqt12x7 _1toh1r31 _5jyqglyw _mrqmnqa1 _if29116y _1kba1h6o",
            __cmplp.className
        ])
    });
});
module.exports["ButtonBase"] = $e9beab952dc913a3$export$b0bb876e969289cd;

});

parcelRegister("ktelT", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $izVB4 = parcelRequire("izVB4");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-html-anchor -- To migrate as part of go/ui-styling-standard
const $903332396267b541$var$LinkWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "a" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11q71879 _11c8fhey _zulpv77o _1e0c116y _4cvr1h6o _80omtlke _k48pwu06 _1bsb1ns9 _pjrq1758 _oo9g1j28 _18u01b66 _1xjxgktf _1nj1uyj3 _13r27vkz _1nm57vkz _19lc19y2 _1fyq1yf3 _1h7d1kdv _v6kc1j28",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q71879 _11c8fhey _zulpv77o _1e0c116y _4cvr1h6o _80omtlke _k48pwu06 _1bsb1ns9 _pjrq1758 _oo9g1j28 _18u01b66 _1xjxgktf _1nj1uyj3 _13r27vkz _1nm57vkz _19lc19y2 _1fyq1yf3 _1h7d1kdv _v6kc1j28",
            __cmplp.className
        ])
    });
});
const $903332396267b541$export$7e6e2bf13161f2a = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { href: href, onClick: onClick, target: target, children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: ""
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== href || $[3] !== onClick || $[4] !== target) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($903332396267b541$var$LinkWrapper, {
            href: href,
            onClick: onClick,
            target: target,
            role: "link"
        }, t1, children);
        $[1] = children;
        $[2] = href;
        $[3] = onClick;
        $[4] = target;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ href: href, onClick: onClick, target: target, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($903332396267b541$var$LinkWrapper, {
        href: href,
        onClick: onClick,
        target: target,
        role: "link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
        label: ""
    }), children);
};
module.exports["GradientSubtleLinkButton"] = $903332396267b541$export$7e6e2bf13161f2a;

});

parcelRegister("l0DoV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $537ed6b0b56c707f$export$5422bd88477f90e5 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uHF1j",
    name: "TryStandardUpflowV2ExperimentTreatmentModalLoadable",
    loader: async ()=>(await (parcelRequire("2S06J"))).TryStandardUpflowV2ExperimentTreatmentModalWithErrorBoundary
});
module.exports["TryStandardUpflowV2ExperimentTreatmentModalLoadable"] = $537ed6b0b56c707f$export$5422bd88477f90e5;

});

parcelRegister("2S06J", function(module, exports) {

let $2170b54a33289a47$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2170b54a33289a47$var$load("6wr18"),
    $2170b54a33289a47$var$load("eeaKR"),
    $2170b54a33289a47$var$load("ffEVr"),
    $2170b54a33289a47$var$load("iqKwT"),
    $2170b54a33289a47$var$load("hhss7"),
    $2170b54a33289a47$var$load("fYFVU")
]).then(()=>parcelRequire('h60zh'));

});

parcelRegister("fDbEj", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $6mKj3 = parcelRequire("6mKj3");


var $gQY3Y = parcelRequire("gQY3Y");


var $jKFU9 = parcelRequire("jKFU9");

const $3737157ebbad3bf6$var$timeNow = ()=>new Date().getTime();
const $3737157ebbad3bf6$export$66d311bf29d5c89c = new Error('TIMEOUT');
const $3737157ebbad3bf6$export$d63cfb67ca7b2a0 = (currentEdition, writeFragmentInterop)=>{
    if (!currentEdition) return Promise.reject(new Error('No currentEdition supplied'));
    const pollEndTime = new Date($3737157ebbad3bf6$var$timeNow() + (0, $jKFU9.CHANGE_EDITION_POLL_DURATION_MINS) * 60000).getTime();
    const pollAndResolve = (resolve, reject)=>{
        if ($3737157ebbad3bf6$var$timeNow() > pollEndTime) reject($3737157ebbad3bf6$export$66d311bf29d5c89c);
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        (0, $hp2SH.getApolloClient)().query({
            query: (0, $gQY3Y.waitForEditionChangeQuery),
            errorPolicy: 'all',
            fetchPolicy: 'network-only'
        }).then((response)=>{
            const polledEdition = response.data?.tenant?.editions?.confluence;
            if (polledEdition && currentEdition !== polledEdition) {
                // Write the latest edition to cache.
                if ((0, $6mKj3.expValEquals)('remove_usages_of_cache_read_write', 'isEnabled', true)) writeFragmentInterop({
                    fragmentId: '$ROOT_QUERY.confluence_tenantContext',
                    data: {
                        editions: {
                            confluence: polledEdition,
                            __typename: 'ConfluenceEditions'
                        },
                        __typename: 'Tenant'
                    }
                });
                else // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
                (0, $hp2SH.getApolloClient)().writeQuery({
                    query: (0, $gQY3Y.waitForEditionChangeQuery),
                    data: {
                        tenant: {
                            editions: {
                                confluence: polledEdition,
                                __typename: 'ConfluenceEditions'
                            },
                            __typename: 'Tenant'
                        }
                    }
                });
                resolve(polledEdition);
            } else setTimeout(()=>{
                pollAndResolve(resolve, reject);
            }, (0, $jKFU9.CHANGE_EDITION_POLL_INTERVAL_SECS) * 1000);
        }).catch(reject);
    };
    return new Promise((resolve, reject)=>pollAndResolve(resolve, reject));
};
module.exports["TimeoutError"] = $3737157ebbad3bf6$export$66d311bf29d5c89c;
module.exports["waitForEditionChange"] = $3737157ebbad3bf6$export$d63cfb67ca7b2a0;

});

parcelRegister("gQY3Y", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");

const $1047f6c600fde1f6$export$291c2fa2b3781c67 = (0, $eSUdr.default)`query waitForEditionChangeQuery{tenant:confluence_tenantContext{editions{confluence}}}`;
module.exports["waitForEditionChangeQuery"] = $1047f6c600fde1f6$export$291c2fa2b3781c67;

});

parcelRegister("jKFU9", function(module, exports) {
const $97f7046950ca68f7$export$4f9b7eb5b7999045 = 3;
const $97f7046950ca68f7$export$6925031fb600919f = 1;
module.exports["CHANGE_EDITION_POLL_INTERVAL_SECS"] = $97f7046950ca68f7$export$4f9b7eb5b7999045;
module.exports["CHANGE_EDITION_POLL_DURATION_MINS"] = $97f7046950ca68f7$export$6925031fb600919f;

});

parcelRegister("lNKOh", function(module, exports) {
const $5ea77288491beecf$export$2321d4fb07b49d13 = ({ canShowUpgradeButton: canShowUpgradeButton, children: children, isSiteAdmin: isSiteAdmin, shouldShowLearnMore: shouldShowLearnMore = true, showRequestUpgradeButton: showRequestUpgradeButton })=>{
    let showUpgradeTryNowButton = false;
    let showLearnMore = true;
    let learnMoreIsPrimaryCTA = true;
    if (canShowUpgradeButton) {
        if (isSiteAdmin) showUpgradeTryNowButton = true;
        if (showUpgradeTryNowButton) {
            // NOTE: Don't show 'Learn More' CTA if it will appear in between the
            // Upgrade Edition button and a secondary feature link (like
            // "Remove this page's restrictions" button). In those cases, "Learn
            // More" CTA will be displayed at the end of the general text content,
            // outside of this component.
            showLearnMore = shouldShowLearnMore;
            learnMoreIsPrimaryCTA = false;
        }
    }
    if (showRequestUpgradeButton) // If an end user request upgrade button is present,
    // we don't show the learn more link if it's not specifically provided.
    showLearnMore = shouldShowLearnMore;
    return children({
        showUpgradeTryNowButton: showUpgradeTryNowButton,
        showLearnMore: showLearnMore,
        learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA
    });
};
module.exports["ChangeEditionSectionMessageButtonsWrapper"] = $5ea77288491beecf$export$2321d4fb07b49d13;

});

parcelRegister("bhvFb", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3HQYo = parcelRequire("3HQYo");


var $9wGTI = parcelRequire("9wGTI");


var $gsZdA = parcelRequire("gsZdA");

const $1848832735763b59$var$contentContainerStyles = {
    regular: "_1e0c1txw _2lx21bp4 _16jlkb7n _p12f1lk2",
    isCard: "_p12f1osq"
};
const $1848832735763b59$var$sectionMessageTitleStyles = {
    regular: "_11c81e3o _19pkidpf _syazi7uo",
    regularNew: "_11c81af2 _k48p1wq8 _19pkidpf _syazi7uo",
    inlineModal: "_11c81af2 _19pkze3t _n3tdpxbi"
};
const $1848832735763b59$var$sectionMessageBodyStyles = {
    withTitle: "_19pku2gc",
    noTitle: "_19pkidpf"
};
const $1848832735763b59$var$sectionMessageHeaderButtonStyles = {
    regular: "_1e0c1txw _1bahesu3 _kqswstnw _154ipxbi _1xi21ejb",
    default: "_154ixy5q _1xi2oahv",
    isCardDefault: "_1xi2xy5q",
    isCard: "_1xi2pxbi"
};
const $1848832735763b59$var$sectionMessageActionRowStyles = {
    default: "_1e0c1txw _19pkpxbi",
    right: "_1bahesu3 _166l1sbv _6ufw1q9c",
    inlineModal: "_19pk16xz _1e0c1txw"
};
const $1848832735763b59$var$sectionMessageFooterStyles = {
    default: "_x3do1uh4 _19pkpxbi _otyrpxbi _ca0qutpp"
};
const $1848832735763b59$var$sectionMessageContainerStyles = {
    regular: "_2rkofajl _19pkidpf _2hwx1wug _otyridpf _18u01wug _bfhk1bhr _1e0c1txw _16jlkb7n",
    withTasteAndToneStyling: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk1j28",
    default: "_1yt44ar7 _16qs130s _p12fasau",
    flat: "_1yt44ar7 _p12fasau",
    inline: "_11c8fhey",
    inlineModal: "_p12f1kdj"
};
const $1848832735763b59$export$d8126cfce410377d = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(35);
    const { actions: actions, appearanceType: appearanceType, body: body, footer: footer, title: title, headerButton: headerButton, withTasteAndToneStyling: t1, buttonGroupAlignment: t2 } = t0;
    const withTasteAndToneStyling = t1 === undefined ? false : t1;
    const buttonGroupAlignment = t2 === undefined ? "left" : t2;
    const withTitle = Boolean(title);
    const isCard = Boolean(buttonGroupAlignment === "right");
    const updatedAppearanceType = appearanceType || (withTasteAndToneStyling ? (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE : (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT);
    const t3 = withTasteAndToneStyling && $1848832735763b59$var$sectionMessageContainerStyles.withTasteAndToneStyling;
    const t4 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageContainerStyles["default"];
    const t5 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).FLAT && $1848832735763b59$var$sectionMessageContainerStyles.flat;
    const t6 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE && $1848832735763b59$var$sectionMessageContainerStyles.inline;
    const t7 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageContainerStyles.inlineModal;
    let t8;
    if ($[0] !== t3 || $[1] !== t4 || $[2] !== t5 || $[3] !== t6 || $[4] !== t7) {
        t8 = (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageContainerStyles.regular,
            t3,
            t4,
            t5,
            t6,
            t7
        ]);
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
        $[3] = t6;
        $[4] = t7;
        $[5] = t8;
    } else t8 = $[5];
    const t9 = isCard && $1848832735763b59$var$contentContainerStyles.isCard;
    let t10;
    if ($[6] !== t9) {
        t10 = (0, $gMc0m.default)([
            $1848832735763b59$var$contentContainerStyles.regular,
            t9
        ]);
        $[6] = t9;
        $[7] = t10;
    } else t10 = $[7];
    let t11;
    if ($[8] !== title || $[9] !== updatedAppearanceType || $[10] !== withTitle) {
        t11 = withTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $1848832735763b59$var$sectionMessageTitleStyles[(0, $9wGTI.fg)("ten_active_boards_in_standard") ? "regularNew" : "regular"],
                updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageTitleStyles.inlineModal
            ])
        }, title);
        $[8] = title;
        $[9] = updatedAppearanceType;
        $[10] = withTitle;
        $[11] = t11;
    } else t11 = $[11];
    let t12;
    if ($[12] !== body || $[13] !== withTitle) {
        t12 = typeof body === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: (0, (/*@__PURE__*/$parcel$interopDefault($3HQYo))).sanitize(body)
            },
            className: (0, $gMc0m.default)([
                $1848832735763b59$var$sectionMessageBodyStyles.noTitle,
                withTitle && $1848832735763b59$var$sectionMessageBodyStyles.withTitle
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $1848832735763b59$var$sectionMessageBodyStyles.noTitle,
                withTitle && $1848832735763b59$var$sectionMessageBodyStyles.withTitle
            ])
        }, body);
        $[12] = body;
        $[13] = withTitle;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== headerButton || $[16] !== isCard || $[17] !== updatedAppearanceType) {
        t13 = headerButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $1848832735763b59$var$sectionMessageHeaderButtonStyles.regular,
                updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles["default"],
                isCard && $1848832735763b59$var$sectionMessageHeaderButtonStyles.isCard,
                isCard && updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles.isCardDefault
            ])
        }, headerButton);
        $[15] = headerButton;
        $[16] = isCard;
        $[17] = updatedAppearanceType;
        $[18] = t13;
    } else t13 = $[18];
    let t14;
    if ($[19] !== actions || $[20] !== buttonGroupAlignment || $[21] !== updatedAppearanceType) {
        t14 = actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $1848832735763b59$var$sectionMessageActionRowStyles["default"],
                buttonGroupAlignment === "right" && $1848832735763b59$var$sectionMessageActionRowStyles.right,
                updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageActionRowStyles.inlineModal,
                "actionButtons"
            ])
        }, actions);
        $[19] = actions;
        $[20] = buttonGroupAlignment;
        $[21] = updatedAppearanceType;
        $[22] = t14;
    } else t14 = $[22];
    let t15;
    if ($[23] !== footer) {
        t15 = footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $1848832735763b59$var$sectionMessageFooterStyles["default"]
            ])
        }, footer);
        $[23] = footer;
        $[24] = t15;
    } else t15 = $[24];
    let t16;
    if ($[25] !== t10 || $[26] !== t11 || $[27] !== t12 || $[28] !== t13 || $[29] !== t14 || $[30] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t10
        }, t11, t12, t13, t14, t15);
        $[25] = t10;
        $[26] = t11;
        $[27] = t12;
        $[28] = t13;
        $[29] = t14;
        $[30] = t15;
        $[31] = t16;
    } else t16 = $[31];
    let t17;
    if ($[32] !== t16 || $[33] !== t8) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "edition-section-message",
            className: t8
        }, t16);
        $[32] = t16;
        $[33] = t8;
        $[34] = t17;
    } else t17 = $[34];
    return t17;
} : ({ actions: actions, appearanceType: appearanceType, body: body, footer: footer, title: title, headerButton: headerButton, withTasteAndToneStyling: withTasteAndToneStyling = false, buttonGroupAlignment: buttonGroupAlignment = 'left' })=>{
    const withTitle = Boolean(title);
    const isCard = Boolean(buttonGroupAlignment === 'right');
    const updatedAppearanceType = appearanceType || (withTasteAndToneStyling ? (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE : (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "edition-section-message",
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageContainerStyles['regular'],
            withTasteAndToneStyling && $1848832735763b59$var$sectionMessageContainerStyles['withTasteAndToneStyling'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageContainerStyles['default'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).FLAT && $1848832735763b59$var$sectionMessageContainerStyles['flat'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE && $1848832735763b59$var$sectionMessageContainerStyles['inline'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageContainerStyles['inlineModal']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$contentContainerStyles['regular'],
            isCard && $1848832735763b59$var$contentContainerStyles['isCard']
        ])
    }, withTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageTitleStyles[(0, $9wGTI.fg)('ten_active_boards_in_standard') ? 'regularNew' : 'regular'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageTitleStyles['inlineModal']
        ])
    }, title), typeof body === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // See https://hello.atlassian.net/browse/APOLLO-3511
    , {
        // and other code tagged with this ticket
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($3HQYo))).sanitize(body)
        },
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageBodyStyles['noTitle'],
            withTitle && $1848832735763b59$var$sectionMessageBodyStyles['withTitle']
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageBodyStyles['noTitle'],
            withTitle && $1848832735763b59$var$sectionMessageBodyStyles['withTitle']
        ])
    }, body), headerButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageHeaderButtonStyles['regular'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles['default'],
            isCard && $1848832735763b59$var$sectionMessageHeaderButtonStyles['isCard'],
            isCard && updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles['isCardDefault']
        ])
    }, headerButton), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageActionRowStyles['default'],
            buttonGroupAlignment === 'right' && $1848832735763b59$var$sectionMessageActionRowStyles['right'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageActionRowStyles['inlineModal'],
            "actionButtons"
        ])
    }, actions), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageFooterStyles['default']
        ])
    }, footer)));
};
module.exports["EditionSectionMessage"] = $1848832735763b59$export$d8126cfce410377d;

});

parcelRegister("3HQYo", function(module, exports) {
/*! @license DOMPurify 2.5.8 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.8/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.8';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});

parcelRegister("cHKtk", function(module, exports) {

var $hG9ZM = parcelRequire("hG9ZM");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $ccHMk = parcelRequire("ccHMk");


var $6xdDU = parcelRequire("6xdDU");


var $inPa6 = parcelRequire("inPa6");


var $4PPzL = parcelRequire("4PPzL");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $1ytiN = parcelRequire("1ytiN");


var $gKr8t = parcelRequire("gKr8t");


var $TCbX7 = parcelRequire("TCbX7");

const $0db05c5b00b76da2$export$27af94f3cd3903e7 = {
    pageInsights: {
        requestedEdition: 'standard',
        requestedFeature: 'pageInsights'
    },
    archiveUpsellDialog: {
        requestedEdition: 'standard',
        requestedFeature: 'archive'
    },
    generalAccessLevelSelector: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    shareAndRestrictDialogUpsell: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    quickSummaryUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'rovo'
    },
    teamCalendarUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'calendars'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    }
};
const $0db05c5b00b76da2$export$4af81e07a25a3fcc = (source)=>{
    const { cloudId: cloudId, edition: edition, userId: userId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const offeringName = $0db05c5b00b76da2$export$27af94f3cd3903e7[source]?.requestedEdition ?? 'standard';
    const { loading: loading, data: data } = (0, $jMyy4.useQueryInterop)((0, $hG9ZM.default), {
        variables: {
            cloudId: cloudId,
            offeringName: offeringName
        },
        fetchPolicy: 'cache-first',
        skip: !(0, $9wGTI.fg)('connie_end_user_request_kill_switch') || isSiteAdmin || edition !== (0, $d9tcB.ConfluenceEdition).FREE || !(source in $0db05c5b00b76da2$export$27af94f3cd3903e7),
        client: (0, $gKr8t.getAGGClient)()
    });
    const isEligibleForEndUserRequest = (0, $42omo.useMemo)(()=>{
        const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
        const isInCollection = entitlement?.relatesFromEntitlements?.find((item)=>item?.relationshipType === 'COLLECTION')?.entitlementId;
        const isChangeOfferingAvailable = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
        const changeOfferingToStandardExperienceUrl = entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl;
        const canUpgrade = Boolean(isChangeOfferingAvailable && changeOfferingToStandardExperienceUrl);
        const hasPaymentDetailsEntered = Boolean(entitlement?.transactionAccount?.isBillToPresent);
        const entitlementInfo = data?.tenantContexts?.[0]?.entitlementInfo;
        const entitlementId = entitlementInfo?.entitlementId;
        const transactionAccountId = entitlement?.transactionAccount?.key;
        return Boolean(!loading && !isInCollection && edition === (0, $d9tcB.ConfluenceEdition).FREE && hasPaymentDetailsEntered && !canUpgrade && Boolean(userId) && Boolean(changeOfferingToStandardExperienceUrl) && Boolean(transactionAccountId) && Boolean(entitlementId));
    }, [
        data,
        loading,
        edition,
        userId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isEligibleForEndUserRequest) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'exposed',
                actionSubject: 'feature',
                source: 'useEnableEndUserRequestUpgrade',
                attributes: {
                    cohort: (0, $6mKj3.expVal)('connie_end_user_request_exp', 'cohort', 'not-enrolled'),
                    flagKey: 'connie_end_user_request_exp',
                    touchpoint: source
                }
            }
        }).fire();
    }, [
        isEligibleForEndUserRequest,
        createAnalyticsEvent,
        source
    ]);
    return {
        showRequestUpgradeButton: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        isEligibleForEndUserRequest && (0, $9wGTI.fg)('connie_end_user_request_kill_switch') && (0, $6mKj3.expValEquals)('connie_end_user_request_exp', 'cohort', 'variation'),
        loading: loading
    };
};
const $0db05c5b00b76da2$export$ccc7e3a47fa3a9b0 = ({ source: source })=>{
    const [showModal, setShowModal] = (0, $42omo.useState)(false);
    const [isLoadingModal, setIsLoadingModal] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleCloseModal = ()=>{
        setShowModal(false);
    };
    const handleOpenModal = ()=>{
        setIsLoadingModal(true);
        setShowModal(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'endUserRequestUpgradeButton',
                source: source
            }
        }).fire();
    };
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'button',
                actionSubjectId: 'endUserRequestUpgradeButton',
                source: source
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    return(// We usually use Attribution.GROWTH_TRANSMUTERS but the import is now deprecated
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: 'growth-transmuters'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: handleOpenModal,
        appearance: "primary",
        isLoading: isLoadingModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "experiment-confluence-enable-end-user-request.request-upgrade-button.label",
        defaultMessage: "Request to try"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, showModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $TCbX7.EndUserRequestUpgradeModalEntrypoint), {
        source: source,
        handleCloseModal: handleCloseModal,
        setIsLoadingModal: setIsLoadingModal
    }))));
};
module.exports["ELIGIBLE_TOUCHPOINTS"] = $0db05c5b00b76da2$export$27af94f3cd3903e7;
module.exports["useEnableEndUserRequestUpgrade"] = $0db05c5b00b76da2$export$4af81e07a25a3fcc;
module.exports["EndUserRequestUpgradeButton"] = $0db05c5b00b76da2$export$ccc7e3a47fa3a9b0;

});

parcelRegister("hG9ZM", function(module, exports) {
/**
 * @generated SignedSource<<aa20e0d18ab2394955ff9d16a2d4e4f5>>
 * @relayHash 989abf351aeb67905f94bc68fcbdc6f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID af36fdb75e5ba6fe2375c3d04cb026bb8ab7a77e90b1ba2f68692d54063709a6
const $a3d3dc9056ba2c7e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "offeringName"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "confluence.ondemand"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "offeringName",
            "variableName": "offeringName"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v11 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEnableEndUserRequestUpgradeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEnableEndUserRequestUpgradeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "989abf351aeb67905f94bc68fcbdc6f9",
            "id": "af36fdb75e5ba6fe2375c3d04cb026bb8ab7a77e90b1ba2f68692d54063709a6",
            "metadata": {},
            "name": "useEnableEndUserRequestUpgradeQuery",
            "operationKind": "query",
            "text": "query useEnableEndUserRequestUpgradeQuery($cloudId:ID!,$offeringName:String!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,entitlementId,entitlement{id,__typename,experienceCapabilities{__typename,changeOfferingV2(offeringName:$offeringName){__typename,isAvailableToUser,experienceUrl}},transactionAccount{__typename,key,isBillToPresent,...on Node{__isNode:__typename,id}},relatesFromEntitlements{__typename,entitlementId,relationshipType}}}}}"
        }
    };
}();
$a3d3dc9056ba2c7e$var$node.hash = "0499128be9f3a7a4d5f8ca7826eaa363";
var $a3d3dc9056ba2c7e$export$2e2bcd8739ae039 = $a3d3dc9056ba2c7e$var$node;
module.exports["default"] = $a3d3dc9056ba2c7e$export$2e2bcd8739ae039;

});

parcelRegister("TCbX7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2d60c82434c5c2c8$export$8512e09daabbe9d7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "i-AMj",
    name: "EndUserRequestUpgradeModalEntrypoint",
    loader: async ()=>(await (parcelRequire("1NdZJ"))).EndUserRequestUpgradeModal
});
module.exports["EndUserRequestUpgradeModalEntrypoint"] = $2d60c82434c5c2c8$export$8512e09daabbe9d7;

});

parcelRegister("1NdZJ", function(module, exports) {

let $14e5391b1df3e703$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $14e5391b1df3e703$var$load("6wr18"),
    $14e5391b1df3e703$var$load("8UKe0"),
    $14e5391b1df3e703$var$load("bjfAh"),
    $14e5391b1df3e703$var$load("kiGNy"),
    $14e5391b1df3e703$var$load("Wowvf"),
    $14e5391b1df3e703$var$load("ffEVr"),
    $14e5391b1df3e703$var$load("iqKwT"),
    $14e5391b1df3e703$var$load("hhss7"),
    $14e5391b1df3e703$var$load("eRrWU")
]).then(()=>parcelRequire('4YFRT'));

});

parcelRegister("hvXOl", function(module, exports) {
module.exports = new URL("WhiteboardsPaywall.cf2c63af.svg", import.meta.url).toString();

});

parcelRegister("5hK0S", function(module, exports) {
module.exports = new URL("WhiteboardsPaywallDark.0948bce6.svg", import.meta.url).toString();

});

parcelRegister("iDxbX", function(module, exports) {
module.exports = new URL("WhiteboardsPaywallV2.5dd554e3.svg", import.meta.url).toString();

});

parcelRegister("2aQ91", function(module, exports) {
module.exports = new URL("WhiteboardsPaywallDarkV2.e9c25635.svg", import.meta.url).toString();

});

parcelRegister("dcUvx", function(module, exports) {
module.exports = new URL("Racecar.f378b1ee.svg", import.meta.url).toString();

});

parcelRegister("3LivB", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6B0jU = parcelRequire("6B0jU");


var $6yCpa = parcelRequire("6yCpa");


var $lqy4C = parcelRequire("lqy4C");


var $bZSO8 = parcelRequire("bZSO8");


var $bBaUQ = parcelRequire("bBaUQ");

const $c6e82055c002803e$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.page.database",
        defaultMessage: "Database"
    }
});
function $c6e82055c002803e$export$c03ba1b69410a0fd(t0) {
    const $ = (0, $frIzR.c)(22);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-database-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        const createContentOptions = {
            contentType: "database",
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        };
        t2 = (0, $bZSO8.buildCreationLink)(createContentOptions);
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[5] !== hybridPageLinkClick || $[6] !== onClick) {
        t3 = (e)=>{
            onClick("createDatabasePopoverItem");
            hybridPageLinkClick(e);
        };
        $[5] = hybridPageLinkClick;
        $[6] = onClick;
        $[7] = t3;
    } else t3 = $[7];
    const handleClick = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:database");
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($c6e82055c002803e$var$messages.title);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== enforceStorageLimit || $[12] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[11] = enforceStorageLimit;
        $[12] = handleClick;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== createHref || $[15] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[14] = createHref;
        $[15] = shouldBlockCreate;
        $[16] = t7;
    } else t7 = $[16];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
            ...t7,
            testId: t8
        };
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
}
module.exports["useDatabaseItem"] = $c6e82055c002803e$export$c03ba1b69410a0fd;

});

parcelRegister("1OVup", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9RVmI = parcelRequire("9RVmI");


var $6yCpa = parcelRequire("6yCpa");


var $lqy4C = parcelRequire("lqy4C");


var $bZSO8 = parcelRequire("bZSO8");


var $bBaUQ = parcelRequire("bBaUQ");

const $b66cd3653b467139$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.blog.title",
        defaultMessage: "Blog"
    }
});
function $b66cd3653b467139$export$1850e31ba3eb45b0(t0) {
    const $ = (0, $frIzR.c)(21);
    const { source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-blog-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== source || $[2] !== spaceKey) {
        t2 = (0, $bZSO8.buildCreationLink)({
            contentType: "blog",
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        });
        $[1] = source;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[4] !== hybridPageLinkClick || $[5] !== onClick) {
        t3 = (e)=>{
            onClick("createBlogPopoverItem");
            hybridPageLinkClick(e);
        };
        $[4] = hybridPageLinkClick;
        $[5] = onClick;
        $[6] = t3;
    } else t3 = $[6];
    const handleClick = t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:blogpost");
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== formatMessage) {
        t5 = formatMessage($b66cd3653b467139$var$messages.title);
        $[8] = formatMessage;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== enforceStorageLimit || $[11] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[10] = enforceStorageLimit;
        $[11] = handleClick;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== createHref || $[14] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[13] = createHref;
        $[14] = shouldBlockCreate;
        $[15] = t7;
    } else t7 = $[15];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
            ...t7,
            testId: t8
        };
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    return t9;
}
module.exports["useBlogItem"] = $b66cd3653b467139$export$1850e31ba3eb45b0;

});

parcelRegister("fw6FY", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $duwSm = parcelRequire("duwSm");


var $6yCpa = parcelRequire("6yCpa");


var $lqy4C = parcelRequire("lqy4C");


var $bZSO8 = parcelRequire("bZSO8");


var $bBaUQ = parcelRequire("bBaUQ");

const $2e6ededdd99584ac$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.smart-link-embed.title",
        defaultMessage: "Smart Link"
    }
});
function $2e6ededdd99584ac$export$da2a30a64353a280(t0) {
    const $ = (0, $frIzR.c)(22);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-smart-link-embed-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        const createContentOptions = {
            contentType: "smartLinkEmbed",
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        };
        t2 = (0, $bZSO8.buildCreationLink)(createContentOptions);
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[5] !== hybridPageLinkClick || $[6] !== onClick) {
        t3 = (e)=>{
            onClick("createSmartLinkEmbedPopoverItem");
            hybridPageLinkClick(e);
        };
        $[5] = hybridPageLinkClick;
        $[6] = onClick;
        $[7] = t3;
    } else t3 = $[7];
    const handleClick = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:embed");
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($2e6ededdd99584ac$var$messages.title);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== enforceStorageLimit || $[12] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[11] = enforceStorageLimit;
        $[12] = handleClick;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== createHref || $[15] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[14] = createHref;
        $[15] = shouldBlockCreate;
        $[16] = t7;
    } else t7 = $[16];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($duwSm))),
            ...t7,
            testId: t8
        };
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
}
module.exports["useEmbedItem"] = $2e6ededdd99584ac$export$da2a30a64353a280;

});

parcelRegister("4e5hr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $buthI = parcelRequire("buthI");


var $hbYDZ = parcelRequire("hbYDZ");


var $inPa6 = parcelRequire("inPa6");


var $gdv5Z = parcelRequire("gdv5Z");


var $6yCpa = parcelRequire("6yCpa");


var $lBYCH = parcelRequire("lBYCH");


var $lqy4C = parcelRequire("lqy4C");


var $bAyaS = parcelRequire("bAyaS");


var $eSLr0 = parcelRequire("eSLr0");


var $4vyfK = parcelRequire("4vyfK");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $jyA9t = parcelRequire("jyA9t");


var $bQm3c = parcelRequire("bQm3c");

const $293cf5b691bb25ab$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.space.title",
        defaultMessage: "Space"
    }
});
function $293cf5b691bb25ab$export$4adf07b2777336fa({ source: source, onClick: onClick }) {
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { openDrawer: openDrawer } = (0, $bAyaS.useCreateSpaceStoreActions)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-space-button'
    });
    const { resetStickySearchRef: resetStickySearchRef, createContentPopoverButtonRef: createContentPopoverButtonRef } = (0, $42omo.useContext)((0, $lBYCH.AppNavigationContext));
    const createSpaceButtonRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)((e)=>{
        resetStickySearchRef?.current?.();
        const location = 'topCreateNav';
        if (isRovoLLMEnabled && (0, $9wGTI.fg)('aifc_space_creation_enabled')) openModal('globalCreateSpaceButton', '');
        else openDrawer(createContentPopoverButtonRef || createSpaceButtonRef, location);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createSpaceButton',
                source: source,
                attributes: {
                    location: location
                }
            }
        }).fire();
        onClick('createSpacePopoverItem');
        e.stopPropagation();
    }, [
        createAnalyticsEvent,
        createContentPopoverButtonRef,
        openDrawer,
        onClick,
        openModal,
        resetStickySearchRef,
        source,
        isRovoLLMEnabled
    ]);
    const preloadCreateSpace = ()=>{
        (0, $4vyfK.preloadWebItemLocation)({
            location: (0, $eSLr0.CREATE_SPACE_DIALOG)
        });
    };
    const PreloadSpaceWrap = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            onMouseDown: preloadCreateSpace
        }, children());
    return {
        ati: (0, $6yCpa.Ati).parse('ati:cloud:confluence:space'),
        children: formatMessage($293cf5b691bb25ab$var$messages.title),
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, $6mKj3.expVal)('confluence_space_icon_update', 'isEnabled', false) ? (0, (/*@__PURE__*/$parcel$interopDefault($hbYDZ))) : (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
        testId: 'create-menu-button-item',
        Wrapper: PreloadSpaceWrap
    };
}
module.exports["useSpaceItem"] = $293cf5b691bb25ab$export$4adf07b2777336fa;

});

parcelRegister("hbYDZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aa391a3d57e28f300b24cee0bba3c43>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c842815f2fb3ef87$var$_react = $c842815f2fb3ef87$var$_interopRequireDefault((parcelRequire("42omo")));

var $c842815f2fb3ef87$var$_baseNew = $c842815f2fb3ef87$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c842815f2fb3ef87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for use for Jira Projects for now. This will replace the Jira rocket. 

More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c842815f2fb3ef87$var$SpacesIcon = (props)=>/*#__PURE__*/ $c842815f2fb3ef87$var$_react.default.createElement($c842815f2fb3ef87$var$_baseNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.496a5.98 5.98 0 0 1-2.809 3.7 5.98 5.98 0 0 1-4.608.583 29.4 29.4 0 0 0 3.858-1.881 29.4 29.4 0 0 0 3.559-2.402"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.425 2.308-.447.377-.013.751.017 1.083.126.338.11.678.32.888.684.354.613.152 1.297-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.397a20 20 0 0 1-1.517 1.263 29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.58c-.65.275-1.272.506-1.85.683h-.003q-.28.087-.548.159c-.783.206-1.511.317-2.116.288-.505-.025-1.114-.162-1.49-.63l-.052-.069-.07-.109-.07-.139a1.6 1.6 0 0 1-.078-.972c.071-.342.231-.681.431-1.001.35-.559.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.499c-.302.324-.536.62-.698.879-.147.235-.213.407-.236.515l-.004.046c.048.022.155.056.37.067.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34c.089.504.265 1.004.538 1.475.198.344.435.652.702.921 1.181-.43 2.542-1.062 3.945-1.872s2.63-1.672 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36a6 6 0 0 0-1.111.166q.233.306.432.647.196.341.342.695c.394-.423.665-.788.816-1.08.098-.192.121-.303.127-.355q-.016-.009-.041-.019a1.7 1.7 0 0 0-.565-.053" clip-rule="evenodd"/>`
    }, props));
$c842815f2fb3ef87$var$SpacesIcon.displayName = 'SpacesIcon';
var $c842815f2fb3ef87$var$_default = module.exports.default = $c842815f2fb3ef87$var$SpacesIcon;

});

parcelRegister("bAyaS", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $8eabddf4fe78ba91$var$initialState = {
    showCreateSpaceDrawer: false,
    shouldRenderDrawer: false,
    createSpaceButtonRef: {
        current: null
    },
    createSpaceButtonLocation: undefined
};
const $8eabddf4fe78ba91$export$e324594224ef24da = {
    openDrawer: (value, createSpaceButtonLocation)=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: true,
                shouldRenderDrawer: true,
                createSpaceButtonRef: value,
                createSpaceButtonLocation: createSpaceButtonLocation
            });
        },
    closeDrawer: ()=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: false,
                createSpaceButtonLocation: undefined
            });
        }
};
const $8eabddf4fe78ba91$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $8eabddf4fe78ba91$var$initialState,
    actions: $8eabddf4fe78ba91$export$e324594224ef24da,
    name: 'createSpaceStore'
});
const $8eabddf4fe78ba91$export$5642c413017336a4 = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
const $8eabddf4fe78ba91$var$getShouldRenderDrawer = (state)=>{
    return state.shouldRenderDrawer;
};
const $8eabddf4fe78ba91$export$34596812152477bc = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getShouldRenderDrawer
});
const $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing = (state)=>{
    return state.showCreateSpaceDrawer;
};
const $8eabddf4fe78ba91$export$5ff6e7335b182a8e = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing
});
const $8eabddf4fe78ba91$export$ad3d638eaaafd693 = (0, $9zUhf.createActionsHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
module.exports["useCreateSpaceStore"] = $8eabddf4fe78ba91$export$5642c413017336a4;
module.exports["useShouldRenderDrawer"] = $8eabddf4fe78ba91$export$34596812152477bc;
module.exports["useCreateSpaceStoreActions"] = $8eabddf4fe78ba91$export$ad3d638eaaafd693;

});

parcelRegister("4vyfK", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $dAxoX = parcelRequire("dAxoX");


var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");


var $iEfsZ = parcelRequire("iEfsZ");

const $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery = (0, $dAxoX.default);
function $2272f3d6a41ef128$export$8120ee10837c1dd({ location: location = null, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null } = {}) {
    if (!contentId && spaceKey) return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return (0, $dYU3e.query)({
            query: $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery,
            variables: {
                location: Array.isArray(location) ? null : location,
                locations: Array.isArray(location) ? location : [],
                spaceKey: spaceKey,
                version: version
            }
        }).then(({ data: data })=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            if (data?.space?.homepageId) (0, $fEmGS.writeQueryInterop)({
                query: (0, $iEfsZ.default),
                variables: {
                    location: Array.isArray(location) ? null : location,
                    locations: Array.isArray(location) ? location : [],
                    contentId: data?.space?.homepageId,
                    spaceKey: null,
                    version: version
                },
                data: {
                    webItemSections: data?.space?.homepageWebSections || []
                }
            });
        });
    })();
    const variables = {
        // GraphQL doesn't cache single location strings properly when passed to locations
        // unless we're using multiple locations we should be using the location variable
        location: Array.isArray(location) ? null : location,
        locations: Array.isArray(location) ? location : [],
        contentId: contentId,
        spaceKey: spaceKey,
        version: version
    };
    return (0, $dYU3e.query)({
        query: (0, $iEfsZ.default),
        variables: variables
    });
}
module.exports["preloadWebItemLocation"] = $2272f3d6a41ef128$export$8120ee10837c1dd;

});

parcelRegister("dAxoX", function(module, exports) {
/**
 * @generated SignedSource<<ed760a61c0c4025dac1c4e0b43c3297f>>
 * @relayHash c407d329f5154dd3cb147b16d24f7f21
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511
const $074c400385fc6141$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "location"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locations"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "version"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "label"
    }, v3 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "location",
                            "variableName": "location"
                        },
                        {
                            "kind": "Variable",
                            "name": "locations",
                            "variableName": "locations"
                        },
                        {
                            "kind": "Variable",
                            "name": "version",
                            "variableName": "version"
                        }
                    ],
                    "concreteType": "WebSection",
                    "kind": "LinkedField",
                    "name": "homepageWebSections",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "cacheKey"
                        },
                        v3 /*: any*/ ,
                        {
                            "concreteType": "WebItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accessKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "completeKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCondition"
                                },
                                v1 /*: any*/ ,
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "height"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "width"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "params",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "moduleKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "section"
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "tooltip"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "urlWithoutContextPath"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "weight"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "c407d329f5154dd3cb147b16d24f7f21",
            "id": "3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511",
            "metadata": {},
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query preloadWebItemLocationWithSpaceKeyQuery($location:String,$locations:[String],$spaceKey:String,$version:Int){space(key:$spaceKey){id,homepageId,homepageWebSections(location:$location,locations:$locations,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}}"
        }
    };
}();
$074c400385fc6141$var$node.hash = "fb9ef136f5257fc82dc16b8dc37de41b";
var $074c400385fc6141$export$2e2bcd8739ae039 = $074c400385fc6141$var$node;
module.exports["default"] = $074c400385fc6141$export$2e2bcd8739ae039;

});

parcelRegister("jyA9t", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $691f60820ad9b181$var$initialState = {
    showSmartCreationModal: false,
    spaceKey: '',
    parentContent: {
        id: '',
        title: '',
        contentType: ''
    },
    content: undefined,
    stagingAreaActive: false,
    entryPoint: 'confluenceUnknown',
    submitCallback: undefined
};
const $691f60820ad9b181$export$e324594224ef24da = {
    openModal: (entryPoint, spaceKey, parentContent, stagingAreaActive, content, submitCallback)=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: true,
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent ?? {
                    id: '',
                    title: '',
                    contentType: ''
                },
                content: content ?? undefined,
                stagingAreaActive: stagingAreaActive ?? false,
                submitCallback: submitCallback ?? undefined
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: false,
                content: undefined,
                stagingAreaActive: false,
                entryPoint: 'confluenceUnknown'
            });
        }
};
const $691f60820ad9b181$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $691f60820ad9b181$var$initialState,
    actions: $691f60820ad9b181$export$e324594224ef24da,
    name: 'smartCreationModalStore'
});
const $691f60820ad9b181$export$137abd744dc8b433 = (0, $9zUhf.createHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$809bddce75a17b3 = (0, $9zUhf.createActionsHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$46ab492df7c46301 = (0, $9zUhf.createStateHook)($691f60820ad9b181$export$390f32400eaf98c9);
module.exports["useSmartCreationModalStore"] = $691f60820ad9b181$export$137abd744dc8b433;
module.exports["useSmartCreationModalActions"] = $691f60820ad9b181$export$809bddce75a17b3;
module.exports["useSmartCreationModalState"] = $691f60820ad9b181$export$46ab492df7c46301;

});

parcelRegister("8hdRZ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $2Yaht = parcelRequire("2Yaht");


var $jojoK = parcelRequire("jojoK");


var $6yCpa = parcelRequire("6yCpa");


var $4R3wx = parcelRequire("4R3wx");


var $f5Ulo = parcelRequire("f5Ulo");


var $9uAPw = parcelRequire("9uAPw");


var $8Q0mA = parcelRequire("8Q0mA");


var $lqy4C = parcelRequire("lqy4C");


var $dPJCf = parcelRequire("dPJCf");


var $7QM6o = parcelRequire("7QM6o");


var $lKj5W = parcelRequire("lKj5W");


var $8fj5s = parcelRequire("8fj5s");


var $9wGTI = parcelRequire("9wGTI");


var $bZSO8 = parcelRequire("bZSO8");


var $jo6R7 = parcelRequire("jo6R7");

const $3e0600a499c498b6$var$ANALYTICS_EVENT_SOURCE = 'globalCreateContentPopover';
const $3e0600a499c498b6$var$CROSS_JOIN = 'CROSS_JOIN';
const $3e0600a499c498b6$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.loom.title",
        defaultMessage: "Loom video"
    },
    crossJoinPopupTitle: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinPopupTitle",
        defaultMessage: "Share your work with a video"
    },
    crossJoinPopupDescription: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinPopupDescription",
        defaultMessage: "Save time and engage your team with a video walkthrough, demo, update, and more."
    },
    crossJoinCTA: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinCTA",
        defaultMessage: "Try now"
    },
    crossJoinLozenge: {
        id: "create-blank-fabric-page.universal-create.loom.cross-join-lozenge",
        defaultMessage: "Join"
    }
});
function $3e0600a499c498b6$export$5c18cb5d6208bad4(flags, error, loading, source) {
    const $ = (0, $frIzR.c)(21);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const href = (0, $f5Ulo.useLoomCrossJoinUrl)();
    let t0;
    if ($[0] !== flags || $[1] !== formatMessage || $[2] !== source) {
        t0 = (t1)=>{
            const { children: children } = t1;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Q0mA.LoomCrossJoinPopupCard), {
                description: formatMessage($3e0600a499c498b6$var$messages.crossJoinPopupDescription),
                entryPointId: "loom-confluence-create-menu",
                sourceComponent: source,
                shouldRenderToParent: false,
                title: formatMessage($3e0600a499c498b6$var$messages.crossJoinPopupTitle),
                sourceActionSubjectId: "createLoomPopoverItem",
                triggerLink: (_, triggerProps)=>children({
                        triggerProps: triggerProps
                    }),
                flags: (0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") ? flags : undefined
            });
        };
        $[0] = flags;
        $[1] = formatMessage;
        $[2] = source;
        $[3] = t0;
    } else t0 = $[3];
    const PopupWrapper = t0;
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:loom-cross-join");
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== error || $[6] !== href || $[7] !== loading) {
        t2 = !(0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") && !error && !loading && {
            href: href
        };
        $[5] = error;
        $[6] = href;
        $[7] = loading;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== formatMessage) {
        t3 = formatMessage($3e0600a499c498b6$var$messages.crossJoinLozenge);
        $[9] = formatMessage;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== formatMessage) {
        t4 = formatMessage($3e0600a499c498b6$var$messages.title);
        $[11] = formatMessage;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t3 || $[14] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jo6R7.ItemTitleWithLozenge), {
            lozenge: t3
        }, t4);
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== PopupWrapper || $[17] !== loading || $[18] !== t2 || $[19] !== t5) {
        t6 = {
            ati: t1,
            ...t2,
            isLoading: loading,
            target: "_blank",
            testId: "create-menu-link-item",
            children: t5,
            Wrapper: PopupWrapper,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($2Yaht)))
        };
        $[16] = PopupWrapper;
        $[17] = loading;
        $[18] = t2;
        $[19] = t5;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
}
const $3e0600a499c498b6$export$3bdf8358f565b3a3 = (t0)=>{
    const $ = (0, $frIzR.c)(39);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick, flags: flags } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== flags) {
        t1 = {
            entryPointLocation: $3e0600a499c498b6$var$ANALYTICS_EVENT_SOURCE,
            flags: flags
        };
        $[0] = flags;
        $[1] = t1;
    } else t1 = $[1];
    const { openLoomRecorder: openLoomRecorder, isLoomRecorderInitialized: isLoomRecorderInitialized, hasRecordingAccess: hasRecordingAccess } = (0, $9uAPw.useLoomRecorderEntryPoint)(t1);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            source: "record-loom-popover-item"
        };
        $[2] = t2;
    } else t2 = $[2];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t2);
    let t3;
    if ($[3] !== createAnalyticsEvent || $[4] !== onClick || $[5] !== openLoomRecorder || $[6] !== parentId || $[7] !== push || $[8] !== source || $[9] !== spaceId || $[10] !== spaceKey) {
        t3 = ()=>{
            onClick("createLoomPopoverItem");
            openLoomRecorder({
                onInsert: (videoUrl)=>{
                    const createUrl = (0, $bZSO8.buildCreationLink)({
                        contentType: "smartLinkEmbed",
                        parentPageId: parentId,
                        withFallback: true,
                        smartLinkCreateSource: "loomRecordSDK",
                        smartLinkEmbedUrl: videoUrl,
                        source: source,
                        spaceKey: spaceKey
                    });
                    push(createUrl);
                    (0, $jojoK.getHashedLoomVideoIdFromUrl)(videoUrl).then((hashedVideoId)=>{
                        createAnalyticsEvent({
                            type: "sendTrackEvent",
                            data: {
                                action: "insertVideo",
                                actionSubject: "loom",
                                source: source,
                                objectType: "embed",
                                containerType: "space",
                                containerId: spaceId,
                                attributes: {
                                    location: "contentTreeItem",
                                    video_id: hashedVideoId
                                }
                            }
                        }).fire();
                    });
                },
                insertButtonText: "Insert video",
                location: "topNav"
            });
        };
        $[3] = createAnalyticsEvent;
        $[4] = onClick;
        $[5] = openLoomRecorder;
        $[6] = parentId;
        $[7] = push;
        $[8] = source;
        $[9] = spaceId;
        $[10] = spaceKey;
        $[11] = t3;
    } else t3 = $[11];
    const handleClick = t3;
    let t4;
    if ($[12] !== hasRecordingAccess || $[13] !== isLoomRecorderInitialized) {
        t4 = isLoomRecorderInitialized && hasRecordingAccess && (0, $9wGTI.fg)("confluence_m25_onboarding_spotlights");
        $[12] = hasRecordingAccess;
        $[13] = isLoomRecorderInitialized;
        $[14] = t4;
    } else t4 = $[14];
    const shouldShowLoomGAOnboarding = t4;
    const [isLoomGAOnboardingActive, stopLoomGAOnboarding] = (0, $8fj5s.useSkippableCoordination)("cc-loom-onboarding-spotlight-creation", !shouldShowLoomGAOnboarding || shouldBlockCreate);
    const [isGASpotlightOpen, setIsGASpotlightOpen] = (0, $42omo.useState)(true);
    let t5;
    if ($[15] !== isLoomGAOnboardingActive || $[16] !== stopLoomGAOnboarding) {
        t5 = ()=>{
            if (isLoomGAOnboardingActive) {
                setIsGASpotlightOpen(false);
                stopLoomGAOnboarding();
            }
        };
        $[15] = isLoomGAOnboardingActive;
        $[16] = stopLoomGAOnboarding;
        $[17] = t5;
    } else t5 = $[17];
    const handleSpotlightClose = t5;
    let t6;
    if ($[18] !== enforceStorageLimit || $[19] !== handleClick || $[20] !== handleSpotlightClose || $[21] !== source) {
        t6 = (t7)=>{
            const { children: children } = t7;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lKj5W.RecordLoomPopoverItemSpotlight), {
                onRecord: enforceStorageLimit(handleClick),
                onClose: handleSpotlightClose,
                source: source,
                shouldWatchTarget: true
            }, children());
        };
        $[18] = enforceStorageLimit;
        $[19] = handleClick;
        $[20] = handleSpotlightClose;
        $[21] = source;
        $[22] = t6;
    } else t6 = $[22];
    const RecordLoomSpotlightWrapper = t6;
    let t7;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:video");
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== formatMessage) {
        t8 = formatMessage($3e0600a499c498b6$var$messages.title);
        $[24] = formatMessage;
        $[25] = t8;
    } else t8 = $[25];
    const t9 = !isLoomRecorderInitialized;
    let t10;
    if ($[26] !== enforceStorageLimit || $[27] !== handleClick) {
        t10 = enforceStorageLimit(handleClick);
        $[26] = enforceStorageLimit;
        $[27] = handleClick;
        $[28] = t10;
    } else t10 = $[28];
    let t11;
    if ($[29] !== RecordLoomSpotlightWrapper || $[30] !== isGASpotlightOpen || $[31] !== isLoomGAOnboardingActive || $[32] !== shouldShowLoomGAOnboarding) {
        t11 = shouldShowLoomGAOnboarding && isLoomGAOnboardingActive && isGASpotlightOpen && {
            Wrapper: RecordLoomSpotlightWrapper
        };
        $[29] = RecordLoomSpotlightWrapper;
        $[30] = isGASpotlightOpen;
        $[31] = isLoomGAOnboardingActive;
        $[32] = shouldShowLoomGAOnboarding;
        $[33] = t11;
    } else t11 = $[33];
    let t12;
    if ($[34] !== t10 || $[35] !== t11 || $[36] !== t8 || $[37] !== t9) {
        t12 = {
            ati: t7,
            children: t8,
            isLoading: t9,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))),
            testId: "create-menu-button-item",
            onClick: t10,
            ...t11
        };
        $[34] = t10;
        $[35] = t11;
        $[36] = t8;
        $[37] = t9;
        $[38] = t12;
    } else t12 = $[38];
    return t12;
};
function $3e0600a499c498b6$export$2c423d86f10c527b(props) {
    const { entryPointVariant: entryPointVariant, error: error, loading: loading } = (0, $4R3wx.useLoomEntryPointVariant)();
    const recordItem = $3e0600a499c498b6$export$3bdf8358f565b3a3(props);
    const crossJoinItem = $3e0600a499c498b6$export$5c18cb5d6208bad4(props.flags, error, loading, props.source);
    return entryPointVariant === $3e0600a499c498b6$var$CROSS_JOIN ? crossJoinItem : recordItem;
}
module.exports["useLoomItem"] = $3e0600a499c498b6$export$2c423d86f10c527b;

});

parcelRegister("f5Ulo", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $dedJV = parcelRequire("dedJV");


var $bQm3c = parcelRequire("bQm3c");

const $3326fe0c1f9a5868$var$environmentMap = {
    DEVELOPMENT: 'dev',
    STAGING: 'stg',
    PRODUCTION: 'prod'
};
const $3326fe0c1f9a5868$export$80677895f41c9591 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const t0 = $3326fe0c1f9a5868$var$environmentMap[environment];
    let t1;
    if ($[0] !== t0) {
        t1 = (0, $dedJV.getATLContextDomain)("id", [
            t0,
            "commercial"
        ]);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const identityDomain = t1;
    const loomResourceAri = `ari:cloud:loom::site/${cloudId}`;
    const continueUrl = environment === "PRODUCTION" ? "https://loom.com/api/auth/atlassian" : "https://stage.loom.com/api/auth/atlassian";
    const userAccessUrl = encodeURIComponent(`https://${identityDomain}/join/user-access?resource=${loomResourceAri}&continue=${continueUrl}`);
    return `https://${identityDomain}/login?continue=${userAccessUrl}`;
} : ()=>{
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    // Using `environment` from session data (rather than letting `getATLContextDomain` determine it
    // internally) in order to better support local development that can be targeted at different
    // Confluence BE environments
    const identityDomain = (0, $dedJV.getATLContextDomain)('id', [
        $3326fe0c1f9a5868$var$environmentMap[environment],
        'commercial'
    ]);
    const loomResourceAri = `ari:cloud:loom::site/${cloudId}`;
    const continueUrl = environment === 'PRODUCTION' ? 'https://loom.com/api/auth/atlassian' : 'https://stage.loom.com/api/auth/atlassian';
    const userAccessUrl = encodeURIComponent(`https://${identityDomain}/join/user-access?resource=${loomResourceAri}&continue=${continueUrl}`);
    return `https://${identityDomain}/login?continue=${userAccessUrl}`;
};
module.exports["useLoomCrossJoinUrl"] = $3326fe0c1f9a5868$export$80677895f41c9591;

});

parcelRegister("8Q0mA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $gd8AW = parcelRequire("gd8AW");


var $erVVf = parcelRequire("erVVf");


var $f5Ulo = parcelRequire("f5Ulo");


var $cnQgR = parcelRequire("cnQgR");

const $012e0fafda229e4e$var$sourceAdType = 'crossJoin';
const $012e0fafda229e4e$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    crossJoinCTA: {
        id: "loom-utils.loom-cross-sell-popup-card.crossJoinCTA",
        defaultMessage: "Try now"
    },
    requestAccessSuccessFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.title",
        defaultMessage: "Your admins were notified of your request"
    },
    requestAccessSuccessFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.description",
        defaultMessage: "You\u2019ll receive an email once they\u2019ve approved it."
    },
    requestAccessErrorFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.title",
        defaultMessage: "We couldn't add you to Loom"
    },
    requestAccessErrorFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.description",
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, "
    },
    requestAccessErrorFlagActionTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.action.title",
        defaultMessage: "contact support"
    }
});
const $012e0fafda229e4e$export$9937e9f99bf53911 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(40);
    const { description: description, entryPointId: entryPointId, placement: placement, shouldRenderToParent: shouldRenderToParent, sourceActionSubjectId: sourceActionSubjectId, sourceComponent: sourceComponent, title: title, triggerLink: triggerLink, flags: flags } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { stopPulse: stopPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    let t1;
    if ($[0] !== entryPointId || $[1] !== flags || $[2] !== sourceComponent) {
        t1 = {
            entryPointId: entryPointId,
            flags: flags,
            source: "loomCrossJoinPopupCard",
            sourceAdType: $012e0fafda229e4e$var$sourceAdType,
            sourceComponent: sourceComponent
        };
        $[0] = entryPointId;
        $[1] = flags;
        $[2] = sourceComponent;
        $[3] = t1;
    } else t1 = $[3];
    const streamliningCrossJoinOnButtonClicked = (0, $erVVf.useStreamliningCrossJoin)(t1);
    let t2;
    if ($[4] !== stopPulse) {
        t2 = ()=>{
            stopPulse();
        };
        $[4] = stopPulse;
        $[5] = t2;
    } else t2 = $[5];
    const stopDiscoverabilityPulse = t2;
    let t3;
    if ($[6] !== entryPointId || $[7] !== experienceTracker || $[8] !== stopDiscoverabilityPulse) {
        t3 = ()=>{
            stopDiscoverabilityPulse();
            experienceTracker.succeed({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                attributes: {
                    sourceComponent: entryPointId,
                    adType: $012e0fafda229e4e$var$sourceAdType
                }
            });
        };
        $[6] = entryPointId;
        $[7] = experienceTracker;
        $[8] = stopDiscoverabilityPulse;
        $[9] = t3;
    } else t3 = $[9];
    const onCrossJoinSuccess = t3;
    let t4;
    if ($[10] !== createAnalyticsEvent || $[11] !== entryPointId || $[12] !== onCrossJoinSuccess || $[13] !== sourceComponent || $[14] !== streamliningCrossJoinOnButtonClicked) {
        t4 = async ()=>{
            if ((0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate")) await streamliningCrossJoinOnButtonClicked(false);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "tryNow",
                    source: "loomCrossJoinPopupCard",
                    attributes: {
                        adType: $012e0fafda229e4e$var$sourceAdType,
                        entrypoint: entryPointId,
                        sourceComponent: sourceComponent
                    }
                }
            }).fire();
            onCrossJoinSuccess();
        };
        $[10] = createAnalyticsEvent;
        $[11] = entryPointId;
        $[12] = onCrossJoinSuccess;
        $[13] = sourceComponent;
        $[14] = streamliningCrossJoinOnButtonClicked;
        $[15] = t4;
    } else t4 = $[15];
    const onTryNowButtonClick = t4;
    let t5;
    if ($[16] !== createAnalyticsEvent || $[17] !== entryPointId || $[18] !== onCrossJoinSuccess || $[19] !== sourceActionSubjectId || $[20] !== sourceComponent || $[21] !== streamliningCrossJoinOnButtonClicked) {
        t5 = async ()=>{
            if ((0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate")) await streamliningCrossJoinOnButtonClicked(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: sourceActionSubjectId,
                    source: sourceActionSubjectId,
                    attributes: {
                        adType: $012e0fafda229e4e$var$sourceAdType,
                        entrypoint: entryPointId,
                        sourceComponent: sourceComponent
                    }
                }
            }).fire();
            onCrossJoinSuccess();
        };
        $[16] = createAnalyticsEvent;
        $[17] = entryPointId;
        $[18] = onCrossJoinSuccess;
        $[19] = sourceActionSubjectId;
        $[20] = sourceComponent;
        $[21] = streamliningCrossJoinOnButtonClicked;
        $[22] = t5;
    } else t5 = $[22];
    const onCrossJoinTriggerClick = t5;
    let t6;
    if ($[23] !== crossJoinHref || $[24] !== intl || $[25] !== onTryNowButtonClick) {
        t6 = (0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "discovery",
            onClick: onTryNowButtonClick
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            appearance: "discovery",
            href: crossJoinHref,
            onClick: onTryNowButtonClick,
            rel: "noreferrer",
            target: "_blank"
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA));
        $[23] = crossJoinHref;
        $[24] = intl;
        $[25] = onTryNowButtonClick;
        $[26] = t6;
    } else t6 = $[26];
    let t7;
    if ($[27] !== crossJoinHref || $[28] !== onCrossJoinTriggerClick || $[29] !== triggerLink) {
        t7 = (popupTriggerProps)=>triggerLink(!(0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") ? crossJoinHref : "", {
                ...popupTriggerProps,
                onClick: onCrossJoinTriggerClick
            });
        $[27] = crossJoinHref;
        $[28] = onCrossJoinTriggerClick;
        $[29] = triggerLink;
        $[30] = t7;
    } else t7 = $[30];
    let t8;
    if ($[31] !== description || $[32] !== entryPointId || $[33] !== placement || $[34] !== shouldRenderToParent || $[35] !== sourceComponent || $[36] !== t6 || $[37] !== t7 || $[38] !== title) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cnQgR.BaseLoomPopupCard), {
            actions: t6,
            description: description,
            entryPointId: entryPointId,
            placement: placement,
            shouldRenderToParent: shouldRenderToParent,
            title: title,
            trigger: t7,
            sourceAdType: $012e0fafda229e4e$var$sourceAdType,
            sourceComponent: sourceComponent
        });
        $[31] = description;
        $[32] = entryPointId;
        $[33] = placement;
        $[34] = shouldRenderToParent;
        $[35] = sourceComponent;
        $[36] = t6;
        $[37] = t7;
        $[38] = title;
        $[39] = t8;
    } else t8 = $[39];
    return t8;
} : ({ description: description, entryPointId: entryPointId, placement: placement, shouldRenderToParent: shouldRenderToParent, sourceActionSubjectId: sourceActionSubjectId, sourceComponent: sourceComponent, title: title, triggerLink: triggerLink, flags: flags })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { stopPulse: stopPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    const streamliningCrossJoinOnButtonClicked = (0, $erVVf.useStreamliningCrossJoin)({
        entryPointId: entryPointId,
        flags: flags,
        source: 'loomCrossJoinPopupCard',
        sourceAdType: $012e0fafda229e4e$var$sourceAdType,
        sourceComponent: sourceComponent
    });
    const stopDiscoverabilityPulse = (0, $42omo.useCallback)(()=>{
        stopPulse();
    }, [
        stopPulse
    ]);
    const onCrossJoinSuccess = (0, $42omo.useCallback)(()=>{
        stopDiscoverabilityPulse();
        experienceTracker.succeed({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: entryPointId,
                adType: $012e0fafda229e4e$var$sourceAdType
            }
        });
    }, [
        entryPointId,
        experienceTracker,
        stopDiscoverabilityPulse
    ]);
    const onTryNowButtonClick = (0, $42omo.useCallback)(async ()=>{
        if ((0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate')) await streamliningCrossJoinOnButtonClicked(false);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'tryNow',
                source: 'loomCrossJoinPopupCard',
                attributes: {
                    adType: $012e0fafda229e4e$var$sourceAdType,
                    entrypoint: entryPointId,
                    sourceComponent: sourceComponent
                }
            }
        }).fire();
        onCrossJoinSuccess();
    }, [
        createAnalyticsEvent,
        entryPointId,
        onCrossJoinSuccess,
        sourceComponent,
        streamliningCrossJoinOnButtonClicked
    ]);
    const onCrossJoinTriggerClick = (0, $42omo.useCallback)(async ()=>{
        if ((0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate')) await streamliningCrossJoinOnButtonClicked(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: sourceActionSubjectId,
                source: sourceActionSubjectId,
                attributes: {
                    adType: $012e0fafda229e4e$var$sourceAdType,
                    entrypoint: entryPointId,
                    sourceComponent: sourceComponent
                }
            }
        }).fire();
        onCrossJoinSuccess();
    }, [
        createAnalyticsEvent,
        entryPointId,
        onCrossJoinSuccess,
        sourceActionSubjectId,
        sourceComponent,
        streamliningCrossJoinOnButtonClicked
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cnQgR.BaseLoomPopupCard), {
        actions: (0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "discovery",
            onClick: onTryNowButtonClick
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            appearance: "discovery",
            href: crossJoinHref,
            onClick: onTryNowButtonClick,
            rel: "noreferrer",
            target: "_blank"
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA)),
        description: description,
        entryPointId: entryPointId,
        placement: placement,
        shouldRenderToParent: shouldRenderToParent,
        title: title,
        trigger: (popupTriggerProps)=>// the link button behaviour is handled in streamliningCrossJoinOnButtonClicked
            // when feature gate is on for Loom crossjoin experiment
            triggerLink(!(0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate') ? crossJoinHref : '', {
                ...popupTriggerProps,
                onClick: onCrossJoinTriggerClick
            }),
        sourceAdType: $012e0fafda229e4e$var$sourceAdType,
        sourceComponent: sourceComponent
    });
};
module.exports["LoomCrossJoinPopupCard"] = $012e0fafda229e4e$export$9937e9f99bf53911;

});

parcelRegister("gd8AW", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $f4d1b21b30388c2e$export$48bd74b0cdc86564 = ()=>{
    return !!(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED);
};
const $f4d1b21b30388c2e$export$675fdafde077272f = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED, true);
};
const $f4d1b21b30388c2e$var$initialState = {
    activeMessageId: null,
    entryPointIds: [],
    clickTrackingHandler: null,
    dismissHandler: null,
    wasDismissedByUser: false
};
const $f4d1b21b30388c2e$var$actions = {
    startPulse: (entryPointId, messageId, handlers)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const nextState = state.activeMessageId !== messageId ? {
                activeMessageId: messageId,
                entryPointIds: [
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? null,
                dismissHandler: handlers?.onDismiss ?? null,
                wasDismissedByUser: false
            } : {
                activeMessageId: messageId,
                entryPointIds: state.entryPointIds.includes(entryPointId) ? state.entryPointIds : [
                    ...state.entryPointIds,
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? state.clickTrackingHandler,
                dismissHandler: handlers?.onDismiss ?? state.dismissHandler,
                wasDismissedByUser: false
            };
            const hasEntryPointListChanged = nextState.entryPointIds !== state.entryPointIds;
            const hasClickHandlerChanged = nextState.clickTrackingHandler !== state.clickTrackingHandler;
            const hasDismissHandlerChanged = nextState.dismissHandler !== state.dismissHandler;
            const hasMessageChanged = nextState.activeMessageId !== state.activeMessageId;
            const hasDismissalReset = state.wasDismissedByUser;
            if (!hasEntryPointListChanged && !hasClickHandlerChanged && !hasDismissHandlerChanged && !hasMessageChanged && !hasDismissalReset) return;
            setState(nextState);
        },
    stopPulse: ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            state.clickTrackingHandler?.();
            state.dismissHandler?.();
            if (!$f4d1b21b30388c2e$export$48bd74b0cdc86564()) $f4d1b21b30388c2e$export$675fdafde077272f();
            if (state.activeMessageId === null && state.entryPointIds.length === 0 && state.dismissHandler === null && state.clickTrackingHandler === null && state.wasDismissedByUser) return;
            setState({
                activeMessageId: null,
                entryPointIds: [],
                clickTrackingHandler: null,
                dismissHandler: null,
                wasDismissedByUser: true
            });
        }
};
const $f4d1b21b30388c2e$var$Store = (0, $1P1Tu.createStore)({
    initialState: $f4d1b21b30388c2e$var$initialState,
    actions: $f4d1b21b30388c2e$var$actions,
    name: 'LoomEntryPointsDiscoverabilityPulse'
});
const $f4d1b21b30388c2e$export$e812389786ffbfd0 = (0, $9zUhf.createStateHook)($f4d1b21b30388c2e$var$Store, {
    selector: (state, entryPointId)=>state.entryPointIds.includes(entryPointId) && !state.wasDismissedByUser
});
const $f4d1b21b30388c2e$export$5628ed37e6d9f626 = (0, $9zUhf.createActionsHook)($f4d1b21b30388c2e$var$Store);
module.exports["havePulsesEnded"] = $f4d1b21b30388c2e$export$48bd74b0cdc86564;
module.exports["endPulses"] = $f4d1b21b30388c2e$export$675fdafde077272f;
module.exports["useIsPulseActive"] = $f4d1b21b30388c2e$export$e812389786ffbfd0;
module.exports["useDiscoverabilityPulseActions"] = $f4d1b21b30388c2e$export$5628ed37e6d9f626;

});

parcelRegister("erVVf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $7p4As = parcelRequire("7p4As");


var $6mKj3 = parcelRequire("6mKj3");


var $f5Ulo = parcelRequire("f5Ulo");


var $64hvi = parcelRequire("64hvi");

const $7197be9efeb6a957$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    requestAccessSuccessFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.title",
        defaultMessage: "Your admins were notified of your request"
    },
    requestAccessSuccessFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.description",
        defaultMessage: "You\u2019ll receive an email once they\u2019ve approved it."
    },
    requestAccessErrorFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.title",
        defaultMessage: "We couldn't add you to Loom"
    },
    requestAccessErrorFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.description",
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, "
    },
    requestAccessErrorFlagActionTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.action.title",
        defaultMessage: "contact support"
    },
    requestAccessNote: {
        id: "loom-utils.use-streamlining-cross-join.request-access-note.content",
        defaultMessage: "Hi, admin \uD83D\uDC4B I'd like to use Loom to collaborate with my team."
    }
});
const $7197be9efeb6a957$export$76d3f97e5e2f022d = ({ entryPointId: entryPointId, flags: flags, source: source, sourceAdType: sourceAdType, sourceComponent: sourceComponent })=>{
    const intl = (0, $8C5kA.default)();
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const requestAccess = (0, $64hvi.useRequestAccessService)({
        entryPointId: entryPointId,
        source: source,
        sourceAdType: sourceAdType,
        note: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessNote)
    });
    const fetchRequestAccessCapability = (0, $64hvi.useFetchRequestAccessCapability)({
        entryPointId: entryPointId,
        source: source,
        sourceAdType: sourceAdType
    });
    return (0, $42omo.useCallback)(async (fromTrigger = false)=>{
        const capability = await fetchRequestAccessCapability();
        if (capability === 'REQUEST_ACCESS') {
            if ([
                'control',
                'variation'
            ].includes((0, $6mKj3.expVal)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'not-enrolled'))) {
                if (fromTrigger) {
                    // Open new tab for control and do nothing for variation
                    if ((0, $6mKj3.expValEquals)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'control')) window && window.open(crossJoinHref, '_blank');
                    return;
                }
                // fire manual feature exposed event for control and variation cohorts only
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'exposed',
                        actionSubject: 'feature',
                        source: source,
                        attributes: {
                            adType: sourceAdType,
                            entrypoint: entryPointId,
                            flagKey: 'twcg-1241_streamlining_loom_cross_join',
                            cohort: (0, $6mKj3.expVal)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'not-enrolled'),
                            fromTrigger: fromTrigger // we should always receive false here
                        }
                    }
                }).fire();
                // streamlining access request flow for variation cohort
                if ((0, $6mKj3.expValEquals)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'variation')) try {
                    const requestedAccess = await requestAccess();
                    if (requestedAccess) {
                        flags && flags.showSuccessFlag({
                            title: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessSuccessFlagTitle),
                            description: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessSuccessFlagDescription)
                        });
                        // after successful access request, we do not proceed to open the cross join link
                        return;
                    }
                } catch (error) {
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'failed',
                            actionSubject: 'requestAccess',
                            source: source,
                            attributes: {
                                adType: sourceAdType,
                                entrypoint: entryPointId,
                                sourceComponent: sourceComponent,
                                error: error instanceof Error ? error.message : 'unknown'
                            }
                        }
                    }).fire();
                    flags && flags.showErrorFlag({
                        title: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessErrorFlagTitle),
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessErrorFlagDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
                            href: "https://support.atlassian.com/contact",
                            target: "_blank",
                            rel: "noreferrer"
                        }, intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessErrorFlagActionTitle)))
                    });
                }
            }
        }
        // for other capability, we bring back the default link behaviour here
        // as we have disabled the default link behaviour for the trigger button
        window && window.open(crossJoinHref, '_blank');
    }, [
        createAnalyticsEvent,
        crossJoinHref,
        entryPointId,
        fetchRequestAccessCapability,
        flags,
        intl,
        requestAccess,
        source,
        sourceAdType,
        sourceComponent
    ]);
};
module.exports["useStreamliningCrossJoin"] = $7197be9efeb6a957$export$76d3f97e5e2f022d;

});

parcelRegister("64hvi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $hCOLa = parcelRequire("hCOLa");


var $fNwcJ = parcelRequire("fNwcJ");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");

const $92f7d7126b973070$var$fetchJson = async (input)=>{
    const { url: url, ...options } = input;
    const response = await (0, $f7B1p.cfetch)(url, options);
    return response.json();
};
const $92f7d7126b973070$export$1c1d3bfbd79d853f = ({ entryPointId: entryPointId, note: note, source: source, sourceAdType: sourceAdType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const deps = (0, $42omo.useMemo)(()=>({
            createAnalyticsEvent: ({ type: type, data: data })=>createAnalyticsEvent({
                    type: type,
                    data: {
                        source: source,
                        ...data
                    }
                }),
            fetchJSON: $92f7d7126b973070$var$fetchJson,
            getCurrentCloudId: ()=>cloudId,
            getCurrentUserId: ()=>userId ?? '',
            getCurrentProduct: ()=>'confluence'
        }), [
        createAnalyticsEvent,
        cloudId,
        source,
        userId
    ]);
    const requestAccess = (0, $hCOLa.useService)((0, $fNwcJ.requestAccess), deps);
    return (0, $42omo.useCallback)(async ()=>{
        try {
            const { result: result = '' } = await requestAccess({
                product: 'loom',
                integration: entryPointId,
                note: note
            });
            const success = result === 'PENDING_REQUEST_CREATED';
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'succeeded',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccess',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        result: result,
                        success: success
                    }
                }
            }).fire();
            return success;
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccess',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        error: error instanceof Error ? error.message : 'unknown',
                        result: undefined,
                        success: false
                    }
                }
            }).fire();
            throw error;
        }
    }, [
        entryPointId,
        note,
        requestAccess,
        source,
        sourceAdType,
        createAnalyticsEvent
    ]);
};
const $92f7d7126b973070$export$a74078d93650d63f = ({ entryPointId: entryPointId, source: source, sourceAdType: sourceAdType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return (0, $42omo.useCallback)(async ()=>{
        const resource = `ari:cloud:loom::site/${cloudId}`;
        try {
            const params = new URLSearchParams({
                resource: resource
            });
            const url = `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
            const response = await $92f7d7126b973070$var$fetchJson({
                url: url
            });
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'succeeded',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccessCapability',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        resource: resource
                    }
                }
            }).fire();
            return response.results[resource] || undefined;
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccessCapability',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        error: error instanceof Error ? error.message : 'unknown',
                        resource: resource
                    }
                }
            }).fire();
        }
        return undefined;
    }, [
        cloudId,
        createAnalyticsEvent,
        entryPointId,
        source,
        sourceAdType
    ]);
};
module.exports["useRequestAccessService"] = $92f7d7126b973070$export$1c1d3bfbd79d853f;
module.exports["useFetchRequestAccessCapability"] = $92f7d7126b973070$export$a74078d93650d63f;

});

parcelRegister("hCOLa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jdJm1 = parcelRequire("jdJm1");

const $5c38ed4eae58ec94$export$6de4685a6c88b4e9 = (service, depsOverrides)=>{
    const memoizedRef = (0, $42omo.useRef)({
        service: undefined,
        depsOverrides: undefined,
        result: undefined
    });
    const memoized = memoizedRef.current;
    if (!memoized || memoized.service !== service || !$5c38ed4eae58ec94$var$areObjectsEqualShallow(memoized.depsOverrides, depsOverrides)) {
        memoizedRef.current.result = (0, $jdJm1.resolveService)(service, depsOverrides);
        memoizedRef.current.depsOverrides = depsOverrides;
        memoizedRef.current.service = service;
    }
    return memoizedRef.current.result;
};
const $5c38ed4eae58ec94$var$DIFFERENT = false;
const $5c38ed4eae58ec94$var$EQUAL = true;
const $5c38ed4eae58ec94$var$areObjectsEqualShallow = (prevObject, nextObject)=>{
    if (nextObject === prevObject) return $5c38ed4eae58ec94$var$EQUAL;
    if (!prevObject || !nextObject) return $5c38ed4eae58ec94$var$DIFFERENT;
    else {
        const prevKeys = Object.keys(prevObject);
        const keys = Object.keys(nextObject);
        if (keys.length !== prevKeys.length) return $5c38ed4eae58ec94$var$DIFFERENT;
        else for (let key of keys){
            if (nextObject[key] !== prevObject[key]) return $5c38ed4eae58ec94$var$DIFFERENT;
        }
        return $5c38ed4eae58ec94$var$EQUAL;
    }
};
module.exports["useService"] = $5c38ed4eae58ec94$export$6de4685a6c88b4e9;

});

parcelRegister("jdJm1", function(module, exports) {

var $7DBey = parcelRequire("7DBey");

function $e28c424ef32ed9ff$export$388f24d19a29b0a2(service, providedDeps) {
    if (typeof service === 'function' && (0, $7DBey.isServiceWithDeps)(service)) return (input)=>{
        return service(input, $e28c424ef32ed9ff$var$ResolvedServiceDependencyContext(service.dependencies, providedDeps ?? {}));
    };
    return service;
}
const $e28c424ef32ed9ff$var$ResolvedServiceDependencyContext = (declaredDependencies, depsOverrides)=>{
    let resolvedDeps = undefined;
    return {
        dependencies () {
            if (resolvedDeps) return resolvedDeps;
            resolvedDeps = {};
            for (let [k, dependency] of Object.entries(declaredDependencies)){
                const key = k;
                resolvedDeps[key] = // TODO is this type-safe?
                // TODO resolve the override dep as well?
                key in depsOverrides ? depsOverrides[key] : $e28c424ef32ed9ff$export$388f24d19a29b0a2(dependency, depsOverrides);
            }
            return resolvedDeps;
        }
    };
}; // TODO: support multiple services to be resolved with common deps
 // export function resolveServices<DeclaredServices extends DeclaredServicesBase>(
 // 	services: DeclaredServices,
 // 	deps: any /*TODO*/,
 // ) {
 // 	return services as ResolvedServices<DeclaredServices>;
 // }
module.exports["resolveService"] = $e28c424ef32ed9ff$export$388f24d19a29b0a2;

});

parcelRegister("7DBey", function(module, exports) {
const $91acf6157f8b5c3c$export$4094c5185600bd73 = (maybeService)=>typeof maybeService === 'function' && 'dependencies' in maybeService;
const $91acf6157f8b5c3c$export$6e9f7b680f09bab1 = (serviceName)=>Object.assign((_input)=>{
        throw TypeError(`Unimplemented abstract service: ${serviceName}`);
    }, {
        abstract: true
    });
const $91acf6157f8b5c3c$export$cc3b967c039ed3e7 = (maybeError)=>{
    if (maybeError instanceof Error) return maybeError;
    return new TypeError('Service Error: ' + maybeError);
};
module.exports["isServiceWithDeps"] = $91acf6157f8b5c3c$export$4094c5185600bd73;
module.exports["unimplementedAbstractService"] = $91acf6157f8b5c3c$export$6e9f7b680f09bab1;
module.exports["toError"] = $91acf6157f8b5c3c$export$cc3b967c039ed3e7;

});

parcelRegister("fNwcJ", function(module, exports) {
/**
 * This file defines the requestAccess() service.
 */ 
var $dh538 = parcelRequire("dh538");


var $k4HRJ = parcelRequire("k4HRJ");


var $7DBey = parcelRequire("7DBey");


var $2Q94g = parcelRequire("2Q94g");


var $bmTr3 = parcelRequire("bmTr3");

/**
 * Valid values are defined in IIS:
 * https://bitbucket.org/atlassian/id-invitations-service/src/master/src/main/java/com/atlassian/identity/invitations/model/EnablementTouchpoint.java
 */ const $bf9bb0e4c78e4bdb$var$EnablementTouchpoint = {
    CROSSJOIN_NUDGE: 'Crossjoin Nudge'
};
// Dependencies - generally common to all RA's/joins:
const $bf9bb0e4c78e4bdb$var$dependencies = {
    fetchJSON: $bmTr3.fetchJSON,
    createAnalyticsEvent: $2Q94g.createAnalyticsEvent,
    getStargateURL: $2Q94g.getStargateURL,
    getCurrentUserId: $2Q94g.getCurrentUserId,
    getCurrentCloudId: $2Q94g.getCurrentCloudId,
    getCurrentProduct: $2Q94g.getCurrentProduct
};
const $bf9bb0e4c78e4bdb$export$cd9e5995821603e1 = Object.assign($bf9bb0e4c78e4bdb$var$requestAccessImpl, {
    dependencies: $bf9bb0e4c78e4bdb$var$dependencies
});
async function $bf9bb0e4c78e4bdb$var$requestAccessImpl(input, context) {
    const deps = context.dependencies();
    const cloudId = input.cloudId ?? deps.getCurrentCloudId();
    const userId = deps.getCurrentUserId();
    let result;
    const resource = (0, $dh538.fg)('puma-1344-request-access-metadata') ? (0, $k4HRJ.AnyAri).create({
        resourceType: 'site',
        resourceId: cloudId,
        resourceOwner: input.product
    }).toString() : `ari:cloud:${input.product}::site/${cloudId}`;
    try {
        // https://developer.atlassian.com/platform/identity/rest/v1/api-group-access-requests/#api-v2-access-requests-request-post
        const response = await deps.fetchJSON({
            url: deps.getStargateURL('/invitations/v1/access-requests/request'),
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: resource,
                ...input.note && (0, $dh538.fg)('puma-1287-add-note-payload') ? {
                    note: input.note
                } : {},
                ...(0, $dh538.fg)('puma-1344-request-access-metadata') ? {
                    metadata: {
                        sourceProduct: deps.getCurrentProduct(),
                        ...input.touchpoint ? {
                            touchpoint: input.touchpoint
                        } : {}
                    }
                } : {}
            })
        });
        result = $bf9bb0e4c78e4bdb$var$mapRequestAccessResponse(response, {
            resource: resource,
            userId: userId,
            ...input
        });
    } catch (error) {
        result = {
            error: (0, $7DBey.toError)(error),
            ...input,
            result: null,
            resource: resource,
            userId: userId
        };
    }
    $bf9bb0e4c78e4bdb$var$fireRequestAccessAnalytics({
        ...input,
        ...result
    }, context);
    return result;
}
function $bf9bb0e4c78e4bdb$var$mapRequestAccessResponse(response, input) {
    return {
        error: null,
        result: response.results[input.resource],
        ...input
    };
}
// Analytics functions for these common events might later become
// exported for standalone use
function $bf9bb0e4c78e4bdb$var$fireRequestAccessAnalytics({ error: error, product: product, result: result }, context) {
    if (!error) {
        const currentUserId = context.dependencies().getCurrentUserId();
        const attributes = {
            userAaid: currentUserId,
            actorAaid: currentUserId,
            roleName: 'product/member',
            inviteStatus: result,
            sourceProduct: context.dependencies().getCurrentProduct(),
            sourceTenantId: context.dependencies().getCurrentCloudId(),
            product: product
        };
        if (result === 'ACCESS_GRANTED') $bf9bb0e4c78e4bdb$var$fireProductJoined(attributes, context);
        else $bf9bb0e4c78e4bdb$var$fireProductAccessRequested(attributes, context);
    }
}
function $bf9bb0e4c78e4bdb$var$fireProductAccessRequested(input, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'productAccess',
            action: 'requested',
            actionSubjectId: input.userAaid,
            attributes: input
        }
    }).fire();
}
function $bf9bb0e4c78e4bdb$var$fireProductJoined({ userUuid: userUuid, userAaid: userAaid, roleName: roleName, sourceTenantId: sourceTenantId, sourceProduct: sourceProduct, recommendationSources: recommendationSources, product: product }, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'product',
            action: 'joined',
            actionSubjectId: product,
            attributes: {
                userUuid: userUuid,
                userAaid: userAaid,
                roleName: roleName,
                sourceTenantId: sourceTenantId,
                sourceProduct: sourceProduct,
                recommendationSources: recommendationSources,
                product: product
            }
        }
    }).fire();
}
module.exports["requestAccess"] = $bf9bb0e4c78e4bdb$export$cd9e5995821603e1;

});

parcelRegister("2Q94g", function(module, exports) {
/**
 * This file contains declaration of smaller services,
 * commonly used as building blocks to create more specific
 * endpoint wrapping services
 */ 
var $dh538 = parcelRequire("dh538");


var $7DBey = parcelRequire("7DBey");

const $26f4407bbf6764a3$export$c7904a8284e43beb = (url)=>`/gateway/api${url}`;
const $26f4407bbf6764a3$export$ddb1688281a3443e = (0, $7DBey.unimplementedAbstractService)('getCurrentCloudId');
const $26f4407bbf6764a3$export$5ebc6cb2748e1881 = (0, $7DBey.unimplementedAbstractService)('getCurrentUserId');
const $26f4407bbf6764a3$export$d01408ed6f850a64 = (0, $7DBey.unimplementedAbstractService)('getCurrentProduct');
const $26f4407bbf6764a3$export$a48841c0475a8073 = (0, $7DBey.unimplementedAbstractService)('createAnalyticsEvent');
const $26f4407bbf6764a3$export$a27c21aa3ed8f0f1 = (0, $7DBey.unimplementedAbstractService)('fireErrorAnalytics');
class $26f4407bbf6764a3$export$26e841bcf1aeb894 extends Error {
    constructor(action, responseCode, response, responseJson, errorType){
        if (responseJson?.message) {
            super(responseJson.message);
            this.responseCode = void 0;
            this.errorType = void 0;
            this.response = void 0;
            this.responseJson = void 0;
        } else {
            super(`Received error response during action ${action}: ${response.statusText}`);
            this.responseCode = void 0;
            this.errorType = void 0;
            this.response = void 0;
            this.responseJson = void 0;
        }
        this.name = 'FetchError';
        this.responseCode = responseCode;
        this.response = response;
        this.responseJson = responseJson;
        this.errorType = errorType;
    }
}
const $26f4407bbf6764a3$export$33e83b6fee5d732d = (err)=>({
        code: err instanceof Error ? err.name : 'UNKNOWN',
        message: err instanceof Error ? err.message : String(err),
        status: // Trying to get the status code (404, 500 etc.) from multiple properties
        // because Expansion Services can be used in different environments,
        // which may dependency-inject different fetchJSON() implementations.
        // These throw different FetchError shapes across the main products.
        // Because we're dealing with exceptions, this is not guarded by types.
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        (0, $dh538.fg)('puma-1321-expansion-services-event-error-status') && err ? $26f4407bbf6764a3$var$getErrorStatusProperty(err, 'responseCode') ?? $26f4407bbf6764a3$var$getErrorStatusProperty(err, 'statusCode') ?? $26f4407bbf6764a3$var$getErrorStatusProperty(err, 'status') : err instanceof $26f4407bbf6764a3$export$26e841bcf1aeb894 ? err.responseCode : undefined
    });
const $26f4407bbf6764a3$var$getErrorStatusProperty = (error, key)=>{
    const value = error[key];
    if (typeof value === 'number') return value;
};
const $26f4407bbf6764a3$export$678d91a98f79a24d = (errorMessage, statusCode)=>!statusCode && $26f4407bbf6764a3$export$e1b6bb1617649e83(errorMessage) || statusCode === 401;
const $26f4407bbf6764a3$export$1f2663aaa83f036d = 'Failed to fetch';
const $26f4407bbf6764a3$export$65e55894e6e38a89 = 'NetworkError when attempting to fetch resource.';
const $26f4407bbf6764a3$export$f25400ad927aa79c = 'A server with the specified hostname could not be found.';
const $26f4407bbf6764a3$export$6827a0909c1bf12f = [
    $26f4407bbf6764a3$export$1f2663aaa83f036d,
    $26f4407bbf6764a3$export$65e55894e6e38a89,
    $26f4407bbf6764a3$export$f25400ad927aa79c
];
const $26f4407bbf6764a3$export$e1b6bb1617649e83 = (errorMessage)=>$26f4407bbf6764a3$export$6827a0909c1bf12f.some((failureMessage)=>errorMessage?.includes(failureMessage));
const $26f4407bbf6764a3$export$c53f16dd5442ef61 = 'EMAIL_BLOCKED';
const $26f4407bbf6764a3$export$e27975535396141b = 'REACHED_MAX_NUMBER_OF_EMAIL_ALIAS_SIGNUPS';
const $26f4407bbf6764a3$var$INVALID_EMAIL = 'INVALID_EMAIL';
const $26f4407bbf6764a3$var$MISSING_USERNAME = 'MISSING_USERNAME';
const $26f4407bbf6764a3$var$EMPTY_USERNAME = 'EMPTY_USERNAME';
const $26f4407bbf6764a3$var$USERNAME_MUST_BE_EMAIL = 'USERNAME_MUST_BE_EMAIL';
const $26f4407bbf6764a3$export$80a3c1a1eb6f063 = 'noDefaultGroup';
const $26f4407bbf6764a3$export$e089e1d2018847da = 'Default group for the requested resource not found.';
const $26f4407bbf6764a3$export$cb3290253184cb70 = (message, error)=>{
    try {
        const badRequestResponse = JSON.parse(message);
        return badRequestResponse.some((val)=>val.errorCodes.userName.includes(error));
    } catch (e) {
        return false;
    }
};
const $26f4407bbf6764a3$export$395f41a02d6a8be0 = (errorKey, errorMessage)=>errorKey === $26f4407bbf6764a3$export$80a3c1a1eb6f063 || errorMessage === $26f4407bbf6764a3$export$e089e1d2018847da;
const $26f4407bbf6764a3$export$1c4c1f7e2d529330 = (response)=>{
    const { key: key, message: message, status: status } = response;
    return $26f4407bbf6764a3$export$678d91a98f79a24d(message, status) || status === 400 && ($26f4407bbf6764a3$export$cb3290253184cb70(message, $26f4407bbf6764a3$export$c53f16dd5442ef61) || $26f4407bbf6764a3$export$cb3290253184cb70(message, $26f4407bbf6764a3$export$e27975535396141b)) || status === 412 && $26f4407bbf6764a3$export$395f41a02d6a8be0(key, message);
};
const $26f4407bbf6764a3$export$9de493bcd9b1d977 = 'bad-request';
const $26f4407bbf6764a3$export$e5254cb9f7678ab9 = 'licence-exceeded';
const $26f4407bbf6764a3$export$90cda429f609d666 = (response)=>{
    const { code: code, message: message } = response;
    if (code === $26f4407bbf6764a3$export$9de493bcd9b1d977 && message === 'User cannot invite themselves') return false;
    if (code === $26f4407bbf6764a3$export$e5254cb9f7678ab9) return false;
    return true;
};
module.exports["getStargateURL"] = $26f4407bbf6764a3$export$c7904a8284e43beb;
module.exports["getCurrentCloudId"] = $26f4407bbf6764a3$export$ddb1688281a3443e;
module.exports["getCurrentUserId"] = $26f4407bbf6764a3$export$5ebc6cb2748e1881;
module.exports["getCurrentProduct"] = $26f4407bbf6764a3$export$d01408ed6f850a64;
module.exports["createAnalyticsEvent"] = $26f4407bbf6764a3$export$a48841c0475a8073;
module.exports["getErrorDetails"] = $26f4407bbf6764a3$export$33e83b6fee5d732d;
module.exports["isAcceptableFailure"] = $26f4407bbf6764a3$export$678d91a98f79a24d;
module.exports["isAcceptableFailureForUserInvite"] = $26f4407bbf6764a3$export$1c4c1f7e2d529330;
module.exports["shouldReportFailedInvite"] = $26f4407bbf6764a3$export$90cda429f609d666;

});

parcelRegister("bmTr3", function(module, exports) {

var $7DBey = parcelRequire("7DBey");

const $c1aca408fa9ca14a$export$81bec6e38e8b706b = // XXX: This is a generic function - careful with types!
// TypeScript has limitations when transforming generic functions.
// Here, the function signature will pass through our helper unimplementedAbstractService()
// untouched, which TypeScript can handle.
(0, $7DBey.unimplementedAbstractService)('fetchJSON');
module.exports["fetchJSON"] = $c1aca408fa9ca14a$export$81bec6e38e8b706b;

});

parcelRegister("cnQgR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4rwCt = parcelRequire("4rwCt");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $cO1el = parcelRequire("cO1el");


var $gj7hi = parcelRequire("gj7hi");


var $cOrQJ = parcelRequire("cOrQJ");


var $lAFHW = parcelRequire("lAFHW");


var $lGgRw = parcelRequire("lGgRw");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $fdtRy = parcelRequire("fdtRy");

var $fNcP1 = parcelRequire("fNcP1");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $6mKj3 = parcelRequire("6mKj3");


var $2fvAC = parcelRequire("2fvAC");


var $5M6IM = parcelRequire("5M6IM");


var $kqrkb = parcelRequire("kqrkb");

const $282df3a04f7add9c$export$e4ecefef0a48fd72 = 400;
const $282df3a04f7add9c$var$i18n = (0, $cgtv4.defineMessages)({
    tryNow: {
        id: "loom-utils.loom-cross-sell-popup-card.tryNow",
        defaultMessage: "Try now"
    }
});
const $282df3a04f7add9c$var$cardStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    overflow: 'auto',
    width: '352px'
});
const $282df3a04f7add9c$var$cardContentStyles = (0, $ecnYn.xcss)({
    padding: 'space.300'
});
const $282df3a04f7add9c$var$imageContainerStyles = (0, $ecnYn.xcss)({
    height: '201px'
});
const $282df3a04f7add9c$var$spotlightContentContainerStyles = (0, $ecnYn.xcss)({
    position: 'fixed'
});
const $282df3a04f7add9c$export$48e89f1cdc429537 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(87);
    const { actions: actions, description: description, entryPointId: entryPointId, placement: placement, spotlightPlacement: spotlightPlacement, shouldRenderToParent: t1, title: title, trigger: trigger, sourceAdType: sourceAdType, sourceComponent: sourceComponent, primaryOnClick: primaryOnClick, adControl: adControl } = t0;
    const shouldRenderToParent = t1 === undefined ? true : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isDarkMode = colorMode === "dark";
    const intl = (0, $8C5kA.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const hasStartedPreloadingImage = (0, $42omo.useRef)(false);
    const closePopupTimerRef = (0, $42omo.useRef)(null);
    const openPopupTimerRef = (0, $42omo.useRef)(null);
    const contentWrapperElementRef = (0, $42omo.useRef)(null);
    const triggerElementRef = (0, $42omo.useRef)(null);
    const isOpenOnFocusDisabled = (0, $42omo.useRef)(false);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (closePopupTimerRef.current) {
                clearTimeout(closePopupTimerRef.current);
                closePopupTimerRef.current = null;
            }
        };
        $[0] = t2;
    } else t2 = $[0];
    const clearClosePopupTimer = t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            if (openPopupTimerRef.current) {
                clearTimeout(openPopupTimerRef.current);
                openPopupTimerRef.current = null;
            }
        };
        $[1] = t3;
    } else t3 = $[1];
    const clearOpenPopupTimer = t3;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t4;
    let t5;
    if ($[2] !== entryPointId || $[3] !== experienceTracker || $[4] !== isOpen || $[5] !== sourceAdType) {
        t4 = ()=>{
            if (isOpen) experienceTracker.start({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                attributes: {
                    sourceComponent: entryPointId,
                    adType: sourceAdType
                }
            });
        };
        t5 = [
            entryPointId,
            experienceTracker,
            isOpen,
            sourceAdType
        ];
        $[2] = entryPointId;
        $[3] = experienceTracker;
        $[4] = isOpen;
        $[5] = sourceAdType;
        $[6] = t4;
        $[7] = t5;
    } else {
        t4 = $[6];
        t5 = $[7];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[8] !== entryPointId || $[9] !== experienceTracker || $[10] !== sourceAdType) {
        t6 = ()=>{
            setIsOpen(false);
            experienceTracker.abort({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                reason: "Loom pop up closed",
                attributes: {
                    sourceComponent: entryPointId,
                    adType: sourceAdType
                }
            });
            isOpenOnFocusDisabled.current = true;
            setTimeout(()=>{
                isOpenOnFocusDisabled.current = false;
            }, 0);
        };
        $[8] = entryPointId;
        $[9] = experienceTracker;
        $[10] = sourceAdType;
        $[11] = t6;
    } else t6 = $[11];
    const safeClosePopup = t6;
    let t7;
    if ($[12] !== safeClosePopup) {
        t7 = ()=>{
            clearOpenPopupTimer();
            if (!closePopupTimerRef.current) closePopupTimerRef.current = setTimeout(()=>{
                safeClosePopup();
                closePopupTimerRef.current = null;
            }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
        };
        $[12] = safeClosePopup;
        $[13] = t7;
    } else t7 = $[13];
    const startClosePopupTimer = t7;
    let t8;
    if ($[14] !== createAnalyticsEvent || $[15] !== entryPointId || $[16] !== sourceAdType || $[17] !== sourceComponent) {
        t8 = ()=>{
            clearClosePopupTimer();
            if (!hasStartedPreloadingImage.current) {
                hasStartedPreloadingImage.current = true;
                const img = new Image();
                img.src = (0, (/*@__PURE__*/$parcel$interopDefault($2fvAC)));
            }
            if (!openPopupTimerRef.current) openPopupTimerRef.current = setTimeout(()=>{
                if (sourceAdType === "crossFlow") (0, $6mKj3.expVal)("migrate_confluence_loom_xflow_popup_to_spotlight", "exposure", false);
                createAnalyticsEvent({
                    type: "sendScreenEvent",
                    data: {
                        name: "loomAdPopupCard",
                        attributes: {
                            adType: sourceAdType,
                            entrypoint: entryPointId,
                            sourceComponent: sourceComponent,
                            isMigrateToSpotlightEnabled: sourceAdType === "crossFlow" && (0, $6mKj3.UNSAFE_expValNoExposure)("migrate_confluence_loom_xflow_popup_to_spotlight", "isEnabled", false)
                        }
                    }
                }).fire();
                setIsOpen(true);
                openPopupTimerRef.current = null;
            }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
        };
        $[14] = createAnalyticsEvent;
        $[15] = entryPointId;
        $[16] = sourceAdType;
        $[17] = sourceComponent;
        $[18] = t8;
    } else t8 = $[18];
    const startOpenPopupTimer = t8;
    let t9;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>{
            clearOpenPopupTimer();
        };
        $[19] = t9;
    } else t9 = $[19];
    const handleTriggerBlur = t9;
    let t10;
    if ($[20] !== startOpenPopupTimer) {
        t10 = ()=>{
            if (!isOpenOnFocusDisabled.current) startOpenPopupTimer();
        };
        $[20] = startOpenPopupTimer;
        $[21] = t10;
    } else t10 = $[21];
    const handleTriggerFocus = t10;
    let t11;
    if ($[22] !== startOpenPopupTimer) {
        t11 = ()=>{
            startOpenPopupTimer();
        };
        $[22] = startOpenPopupTimer;
        $[23] = t11;
    } else t11 = $[23];
    const handleTriggerMouseEnter = t11;
    let t12;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = ()=>{
            clearClosePopupTimer();
        };
        $[24] = t12;
    } else t12 = $[24];
    const handleCardMouseEnter = t12;
    let t13;
    if ($[25] !== startClosePopupTimer) {
        t13 = ()=>{
            if (!contentWrapperElementRef.current?.contains(document.activeElement) && document.activeElement !== triggerElementRef.current) startClosePopupTimer();
        };
        $[25] = startClosePopupTimer;
        $[26] = t13;
    } else t13 = $[26];
    const handleMouseLeave = t13;
    let t14;
    if ($[27] !== actions || $[28] !== description || $[29] !== handleMouseLeave || $[30] !== title) {
        t14 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                onMouseEnter: handleCardMouseEnter,
                onMouseLeave: handleMouseLeave,
                ref: contentWrapperElementRef,
                xcss: $282df3a04f7add9c$var$cardStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $282df3a04f7add9c$var$imageContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
                alt: "",
                height: "201px",
                width: "352px",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($2fvAC)))
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                space: "space.300",
                xcss: $282df3a04f7add9c$var$cardContentStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
                as: "h2",
                size: "small"
            }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                as: "p",
                color: "color.text.subtle"
            }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                alignBlock: "center",
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.LoomAttributionLogo), {
                appearance: "brand",
                size: "medium"
            }), actions)));
        $[27] = actions;
        $[28] = description;
        $[29] = handleMouseLeave;
        $[30] = title;
        $[31] = t14;
    } else t14 = $[31];
    const content = t14;
    if (sourceAdType === "crossFlow" && (0, $6mKj3.UNSAFE_expValNoExposure)("migrate_confluence_loom_xflow_popup_to_spotlight", "isEnabled", false)) {
        let t15;
        if ($[32] !== handleMouseLeave || $[33] !== handleTriggerFocus || $[34] !== handleTriggerMouseEnter || $[35] !== isOpen || $[36] !== trigger) {
            t15 = trigger({
                ref: triggerElementRef,
                isSelected: isOpen,
                onBlur: handleTriggerBlur,
                onFocus: handleTriggerFocus,
                onMouseEnter: handleTriggerMouseEnter,
                onMouseLeave: handleMouseLeave,
                "aria-expanded": isOpen,
                "aria-haspopup": true
            });
            $[32] = handleMouseLeave;
            $[33] = handleTriggerFocus;
            $[34] = handleTriggerMouseEnter;
            $[35] = isOpen;
            $[36] = trigger;
            $[37] = t15;
        } else t15 = $[37];
        let t16;
        if ($[38] !== t15) {
            t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, t15);
            $[38] = t15;
            $[39] = t16;
        } else t16 = $[39];
        const t17 = spotlightPlacement || "left-start";
        let t18;
        if ($[40] !== title) {
            t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
                as: "span",
                size: "xsmall"
            }, title);
            $[40] = title;
            $[41] = t18;
        } else t18 = $[41];
        let t19;
        if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
            t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null);
            $[42] = t19;
        } else t19 = $[42];
        let t20;
        if ($[43] !== adControl) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, t19, adControl);
            $[43] = adControl;
            $[44] = t20;
        } else t20 = $[44];
        let t21;
        if ($[45] !== t18 || $[46] !== t20) {
            t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, t18, t20);
            $[45] = t18;
            $[46] = t20;
            $[47] = t21;
        } else t21 = $[47];
        const t22 = isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($kqrkb))) : (0, (/*@__PURE__*/$parcel$interopDefault($5M6IM)));
        let t23;
        if ($[48] !== t22) {
            t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
                alt: "",
                src: t22
            }));
            $[48] = t22;
            $[49] = t23;
        } else t23 = $[49];
        let t24;
        if ($[50] !== description) {
            t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                as: "p"
            }, description));
            $[50] = description;
            $[51] = t24;
        } else t24 = $[51];
        let t25;
        if ($[52] !== intl) {
            t25 = intl.formatMessage($282df3a04f7add9c$var$i18n.tryNow);
            $[52] = intl;
            $[53] = t25;
        } else t25 = $[53];
        let t26;
        if ($[54] !== primaryOnClick || $[55] !== t25) {
            t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
                onClick: primaryOnClick
            }, t25)));
            $[54] = primaryOnClick;
            $[55] = t25;
            $[56] = t26;
        } else t26 = $[56];
        let t27;
        if ($[57] !== t21 || $[58] !== t23 || $[59] !== t24 || $[60] !== t26) {
            t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
                testId: "loom-cross-sell-spotlight-content-card"
            }, t21, t23, t24, t26);
            $[57] = t21;
            $[58] = t23;
            $[59] = t24;
            $[60] = t26;
            $[61] = t27;
        } else t27 = $[61];
        let t28;
        if ($[62] !== isOpen || $[63] !== safeClosePopup || $[64] !== t17 || $[65] !== t27) {
            t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
                isVisible: isOpen,
                placement: t17,
                dismiss: safeClosePopup,
                testId: "loom-cross-sell-spotlight-content",
                strategy: "absolute",
                shouldDismissOnClickOutside: false
            }, t27);
            $[62] = isOpen;
            $[63] = safeClosePopup;
            $[64] = t17;
            $[65] = t27;
            $[66] = t28;
        } else t28 = $[66];
        let t29;
        if ($[67] !== handleMouseLeave || $[68] !== t28) {
            t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                ref: triggerElementRef,
                testId: "loom-cross-sell-spotlight-content-container",
                onMouseEnter: handleCardMouseEnter,
                onMouseLeave: handleMouseLeave,
                xcss: $282df3a04f7add9c$var$spotlightContentContainerStyles
            }, t28);
            $[67] = handleMouseLeave;
            $[68] = t28;
            $[69] = t29;
        } else t29 = $[69];
        let t30;
        if ($[70] !== t16 || $[71] !== t29) {
            t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, t16, t29);
            $[70] = t16;
            $[71] = t29;
            $[72] = t30;
        } else t30 = $[72];
        return t30;
    }
    const t15 = placement || "auto";
    let t16;
    if ($[73] !== handleMouseLeave || $[74] !== handleTriggerFocus || $[75] !== handleTriggerMouseEnter || $[76] !== isOpen || $[77] !== trigger) {
        t16 = (popupTriggerProps)=>trigger({
                ...popupTriggerProps,
                isSelected: isOpen,
                onBlur: handleTriggerBlur,
                onFocus: handleTriggerFocus,
                onMouseEnter: handleTriggerMouseEnter,
                onMouseLeave: handleMouseLeave,
                ref: (0, $4rwCt.mergeRefs)([
                    popupTriggerProps.ref,
                    triggerElementRef
                ])
            });
        $[73] = handleMouseLeave;
        $[74] = handleTriggerFocus;
        $[75] = handleTriggerMouseEnter;
        $[76] = isOpen;
        $[77] = trigger;
        $[78] = t16;
    } else t16 = $[78];
    let t17;
    if ($[79] !== content || $[80] !== isOpen || $[81] !== safeClosePopup || $[82] !== shouldRenderToParent || $[83] !== t15 || $[84] !== t16 || $[85] !== title) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            autoFocus: false,
            content: content,
            isOpen: isOpen,
            label: title,
            onClose: safeClosePopup,
            placement: t15,
            role: "dialog",
            shouldRenderToParent: shouldRenderToParent,
            trigger: t16
        });
        $[79] = content;
        $[80] = isOpen;
        $[81] = safeClosePopup;
        $[82] = shouldRenderToParent;
        $[83] = t15;
        $[84] = t16;
        $[85] = title;
        $[86] = t17;
    } else t17 = $[86];
    return t17;
} : ({ actions: actions, description: description, entryPointId: entryPointId, placement: placement, spotlightPlacement: spotlightPlacement, shouldRenderToParent: shouldRenderToParent = true, title: title, trigger: trigger, sourceAdType: sourceAdType, sourceComponent: sourceComponent, primaryOnClick: primaryOnClick, adControl: adControl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isDarkMode = colorMode === 'dark';
    const intl = (0, $8C5kA.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const hasStartedPreloadingImage = (0, $42omo.useRef)(false);
    const closePopupTimerRef = (0, $42omo.useRef)(null);
    const openPopupTimerRef = (0, $42omo.useRef)(null);
    const contentWrapperElementRef = (0, $42omo.useRef)(null);
    const triggerElementRef = (0, $42omo.useRef)(null);
    const isOpenOnFocusDisabled = (0, $42omo.useRef)(false);
    const clearClosePopupTimer = (0, $42omo.useCallback)(()=>{
        if (closePopupTimerRef.current) {
            clearTimeout(closePopupTimerRef.current);
            closePopupTimerRef.current = null;
        }
    }, []);
    const clearOpenPopupTimer = (0, $42omo.useCallback)(()=>{
        if (openPopupTimerRef.current) {
            clearTimeout(openPopupTimerRef.current);
            openPopupTimerRef.current = null;
        }
    }, []);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>{
        if (isOpen) experienceTracker.start({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: entryPointId,
                adType: sourceAdType
            }
        });
    }, [
        entryPointId,
        experienceTracker,
        isOpen,
        sourceAdType
    ]);
    /**
   * Temporarily disable the popup from re-opening (for a tick) on focus
   * because in many cases, closing the popup returns focus back to the
   * trigger, which would normally open the popup again.
   */ const safeClosePopup = (0, $42omo.useCallback)(()=>{
        setIsOpen(false);
        experienceTracker.abort({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            reason: 'Loom pop up closed',
            attributes: {
                sourceComponent: entryPointId,
                adType: sourceAdType
            }
        });
        isOpenOnFocusDisabled.current = true;
        setTimeout(()=>{
            isOpenOnFocusDisabled.current = false;
        }, 0);
    }, [
        entryPointId,
        experienceTracker,
        sourceAdType
    ]);
    const startClosePopupTimer = (0, $42omo.useCallback)(()=>{
        clearOpenPopupTimer();
        if (!closePopupTimerRef.current) closePopupTimerRef.current = setTimeout(()=>{
            safeClosePopup();
            closePopupTimerRef.current = null;
        }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
    }, [
        clearOpenPopupTimer,
        safeClosePopup
    ]);
    /**
   * Don't open the popup card immediately on hover or focus
   *
   * 1) Focus: We want KB users to be able to quickly navigate through areas with entrypoints that
   * are alongside many other UI controls (e.g., Page Header, Page Editor Toolbar) without triggering
   * the popup card and getting "stuck" (needing to hit "esc" to continue).
   *
   * 2) Hover: We don't want users to feel like the popup card gets in their way of clicking other
   * things in the UI just because their mouse briefly brushed over the entrypoint button.
   *
   * This was heavily inspired by the hover cards used in the Page Tree (`useHoverPageCard`)
   */ const startOpenPopupTimer = (0, $42omo.useCallback)(()=>{
        clearClosePopupTimer();
        if (!hasStartedPreloadingImage.current) {
            hasStartedPreloadingImage.current = true;
            const img = new Image();
            img.src = (0, (/*@__PURE__*/$parcel$interopDefault($2fvAC)));
        }
        if (!openPopupTimerRef.current) openPopupTimerRef.current = setTimeout(()=>{
            if (sourceAdType === 'crossFlow') // We are only migrating the cross-flow popup to spotlight for now https://atlassian.slack.com/archives/C0A7J84AS68/p1768356523913099)
            (0, $6mKj3.expVal)('migrate_confluence_loom_xflow_popup_to_spotlight', 'exposure', false); // fire exposure event when the popup is actually opened
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'loomAdPopupCard',
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        sourceComponent: sourceComponent,
                        isMigrateToSpotlightEnabled: sourceAdType === 'crossFlow' && (0, $6mKj3.UNSAFE_expValNoExposure)('migrate_confluence_loom_xflow_popup_to_spotlight', 'isEnabled', false)
                    }
                }
            }).fire();
            setIsOpen(true);
            openPopupTimerRef.current = null;
        }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
    }, [
        clearClosePopupTimer,
        createAnalyticsEvent,
        entryPointId,
        sourceAdType,
        sourceComponent
    ]);
    const handleTriggerBlur = (0, $42omo.useCallback)(()=>{
        clearOpenPopupTimer();
    }, [
        clearOpenPopupTimer
    ]);
    const handleTriggerFocus = (0, $42omo.useCallback)(()=>{
        if (!isOpenOnFocusDisabled.current) startOpenPopupTimer();
    }, [
        startOpenPopupTimer
    ]);
    const handleTriggerMouseEnter = (0, $42omo.useCallback)(()=>{
        startOpenPopupTimer();
    }, [
        startOpenPopupTimer
    ]);
    const handleCardMouseEnter = (0, $42omo.useCallback)(()=>{
        clearClosePopupTimer();
    }, [
        clearClosePopupTimer
    ]);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        /**
     * Don't close the popup card when moving the mouse outside of it (or the trigger) if something
     * inside it (or the trigger itself) is focused
     */ if (!contentWrapperElementRef.current?.contains(document.activeElement) && document.activeElement !== triggerElementRef.current) startClosePopupTimer();
    }, [
        startClosePopupTimer
    ]);
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            onMouseEnter: handleCardMouseEnter,
            onMouseLeave: handleMouseLeave,
            ref: contentWrapperElementRef,
            xcss: $282df3a04f7add9c$var$cardStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $282df3a04f7add9c$var$imageContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            alt: "",
            height: "201px",
            width: "352px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($2fvAC)))
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.300",
            xcss: $282df3a04f7add9c$var$cardContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            as: "h2",
            size: "small"
        }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            as: "p",
            color: "color.text.subtle"
        }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.LoomAttributionLogo), {
            appearance: "brand",
            size: "medium"
        }), actions)));
    if (sourceAdType === 'crossFlow' && // We are only migrating the cross-flow popup to spotlight for now https://atlassian.slack.com/archives/C0A7J84AS68/p1768356523913099
    (0, $6mKj3.UNSAFE_expValNoExposure)('migrate_confluence_loom_xflow_popup_to_spotlight', 'isEnabled', false)) /**
     * We are migrating the crossflow popup to use the new ADS spotlight design.
     * We will be conducting this as a no-harm experiment.
     * Poster: https://hello.atlassian.net/wiki/spaces/Growth/pages/6294901981/Migrate+Confluence+Loom+Crossflow+Popup+to+Spotlight+Eng+led+TWCG-1446+Project+Poster+FY26
     */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, trigger({
        ref: triggerElementRef,
        isSelected: isOpen,
        onBlur: handleTriggerBlur,
        onFocus: handleTriggerFocus,
        onMouseEnter: handleTriggerMouseEnter,
        onMouseLeave: handleMouseLeave,
        'aria-expanded': isOpen,
        'aria-haspopup': true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        ref: triggerElementRef,
        testId: "loom-cross-sell-spotlight-content-container",
        onMouseEnter: handleCardMouseEnter,
        onMouseLeave: handleMouseLeave,
        xcss: $282df3a04f7add9c$var$spotlightContentContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        isVisible: isOpen,
        placement: spotlightPlacement || 'left-start',
        dismiss: safeClosePopup,
        testId: "loom-cross-sell-spotlight-content",
        strategy: "absolute",
        shouldDismissOnClickOutside: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
        testId: "loom-cross-sell-spotlight-content-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        as: "span",
        size: "xsmall"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null), adControl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: "",
        src: isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($kqrkb))) : (0, (/*@__PURE__*/$parcel$interopDefault($5M6IM)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "p"
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
        onClick: primaryOnClick
    }, intl.formatMessage($282df3a04f7add9c$var$i18n.tryNow))))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        autoFocus: false,
        content: content,
        isOpen: isOpen,
        /**
   * Using `titleId` and adding the same value as an `id` to the Heading in the popup content
   * does not announce properly in macOS VoiceOver
   */ label: title,
        onClose: safeClosePopup,
        placement: placement || 'auto',
        role: "dialog",
        shouldRenderToParent: shouldRenderToParent,
        trigger: (popupTriggerProps)=>trigger({
                ...popupTriggerProps,
                isSelected: isOpen,
                onBlur: handleTriggerBlur,
                onFocus: handleTriggerFocus,
                onMouseEnter: handleTriggerMouseEnter,
                onMouseLeave: handleMouseLeave,
                ref: (0, $4rwCt.mergeRefs)([
                    popupTriggerProps.ref,
                    triggerElementRef
                ])
            })
    });
};
module.exports["BaseLoomPopupCard"] = $282df3a04f7add9c$export$48e89f1cdc429537;

});

parcelRegister("fdtRy", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $5df9daaf2c005ad4$var$styles = {
    root: "_1reo15vq _18m915vq _1bsbaq3k _4t3ihcro"
};
const $5df9daaf2c005ad4$export$cf33151c3f01cd9a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: ref,
        xcss: $5df9daaf2c005ad4$var$styles.root,
        testId: testId,
        children: children
    });
});
module.exports["SpotlightMedia"] = $5df9daaf2c005ad4$export$cf33151c3f01cd9a;

});

parcelRegister("2fvAC", function(module, exports) {
module.exports = new URL("LoomCrossSellPopupCardImage.6e60c328.png", import.meta.url).toString();

});

parcelRegister("5M6IM", function(module, exports) {
module.exports = new URL("LoomCrossSellPopupCardImageNewVisual_Light.55587eef.png", import.meta.url).toString();

});

parcelRegister("kqrkb", function(module, exports) {
module.exports = new URL("LoomCrossSellPopupCardImageNewVisual_Dark.c1c1769c.png", import.meta.url).toString();

});

parcelRegister("a26i4", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $h7YX1 = parcelRequire("h7YX1");


var $gNXND = parcelRequire("gNXND");


var $6yCpa = parcelRequire("6yCpa");


var $16lEl = parcelRequire("16lEl");

var $hUyPY = parcelRequire("hUyPY");


var $6mKj3 = parcelRequire("6mKj3");


var $dDAsV = parcelRequire("dDAsV");


var $jyA9t = parcelRequire("jyA9t");


var $b8pRY = parcelRequire("b8pRY");


var $cbBHq = parcelRequire("cbBHq");


var $1NBp8 = parcelRequire("1NBp8");


var $9wGTI = parcelRequire("9wGTI");


var $eB1TF = parcelRequire("eB1TF");


var $jo6R7 = parcelRequire("jo6R7");


var $85eZj = parcelRequire("85eZj");

const $03068ae1a528f6bf$var$i18n = (0, $cgtv4.defineMessages)({
    smartCreateTitle: {
        id: "create-blank-fabric-page.create.content.smart-create-with-ai.title",
        defaultMessage: "Create with Rovo"
    },
    smartCreateWithAiTitle: {
        id: "create-blank-fabric-page.create.content.smart-create-with-rovo-ai.title",
        defaultMessage: "Create with Rovo AI"
    }
});
const $03068ae1a528f6bf$var$getSpaceKeyForCreation = async ()=>{
    const spaceKeyRequest = {
        promotedSpaceKey: undefined
    };
    const spaceKeyResponse = (await (0, $dDAsV.experimentalPromotedSpacesQuery)({
        variables: {
            ...spaceKeyRequest,
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1
        }
    })).data;
    return spaceKeyResponse?.experimentalPromotedSpaces?.nodes?.[0]?.id ?? '';
};
function $03068ae1a528f6bf$export$57669fd702f839a2(t0) {
    const $ = (0, $frIzR.c)(31);
    const { spaceKey: spaceKey, onClick: onClick, source: source } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { isOpen: isOpen } = (0, $eB1TF.useUniversalCreateState)();
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const preloadSmartCreationModal = (0, $cbBHq.usePreloadSmartCreationModal)();
    const [fetchedSpaceKey, setFetchedSpaceKey] = (0, $42omo.useState)("");
    const [spaceKeyLoading, setSpaceKeyLoading] = (0, $42omo.useState)(true);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setSpaceKeyLoading(true);
            $03068ae1a528f6bf$var$getSpaceKeyForCreation().then(setFetchedSpaceKey).finally(()=>setSpaceKeyLoading(false));
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[2] !== isOpen || $[3] !== preloadSmartCreationModal) {
        t3 = ()=>{
            if (isOpen) preloadSmartCreationModal();
        };
        t4 = [
            isOpen,
            preloadSmartCreationModal
        ];
        $[2] = isOpen;
        $[3] = preloadSmartCreationModal;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[6] !== experienceTracker || $[7] !== fetchedSpaceKey || $[8] !== openModal || $[9] !== source || $[10] !== spaceKey) {
        t5 = ()=>{
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).AIFC_LOAD_STAGING_AREA_MODAL,
                id: (0, $16lEl.ExperienceName).AIFC_LOAD_STAGING_AREA_MODAL,
                attributes: {
                    product: "confluence",
                    source: source
                }
            });
            const shouldExcludeContext = source === "globalCreateDropdown-smartCreate" && (0, $6mKj3.expValEquals)("platform_use_llm_space_recommendations", "isEnabled", true);
            if (shouldExcludeContext) openModal(source);
            else openModal(source, spaceKey ?? fetchedSpaceKey);
        };
        $[6] = experienceTracker;
        $[7] = fetchedSpaceKey;
        $[8] = openModal;
        $[9] = source;
        $[10] = spaceKey;
        $[11] = t5;
    } else t5 = $[11];
    const handleOpenCreateWithRovoExperience = t5;
    let t6;
    if ($[12] !== handleOpenCreateWithRovoExperience || $[13] !== onClick) {
        t6 = (e, actionSubjectId, attributes)=>{
            onClick(actionSubjectId, attributes);
            if (e?.metaKey || e?.ctrlKey) return;
            e.preventDefault();
            handleOpenCreateWithRovoExperience();
        };
        $[12] = handleOpenCreateWithRovoExperience;
        $[13] = onClick;
        $[14] = t6;
    } else t6 = $[14];
    const handleItemOnClick = t6;
    let t7;
    if ($[15] !== handleOpenCreateWithRovoExperience || $[16] !== source || $[17] !== spaceKeyLoading) {
        t7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $85eZj.AnimatedGradientBorder), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8pRY.UniversalCreateWithRovoSpotlight), {
                onClick: ()=>handleOpenCreateWithRovoExperience(),
                isLoading: spaceKeyLoading,
                source: source
            }, props.children && props.children()));
        $[15] = handleOpenCreateWithRovoExperience;
        $[16] = source;
        $[17] = spaceKeyLoading;
        $[18] = t7;
    } else t7 = $[18];
    const CreateWithRovoSpotlightWrapper = t7;
    let t8;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $1NBp8.HOME).toUrl({}, {
            query: {
                openCreateWithRovo: "true"
            }
        });
        $[19] = t8;
    } else t8 = $[19];
    const href = t8;
    let t9;
    if ($[20] !== formatMessage) {
        t9 = ()=>{
            const message = (0, $6mKj3.expValEquals)("cc_fd_aifc_copy_change_experiment", "isEnabled", true) ? $03068ae1a528f6bf$var$i18n.smartCreateWithAiTitle : $03068ae1a528f6bf$var$i18n.smartCreateTitle;
            if ((0, $9wGTI.fg)("aifc_onboarding_ga_enabled")) {
                if ((0, $6mKj3.expValEquals)("cc-aifc-databases-experiment", "isEnabled", true)) return formatMessage(message);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jo6R7.ItemTitleWithLozenge), {
                useLabsLozenge: true
            }, formatMessage(message));
        };
        $[20] = formatMessage;
        $[21] = t9;
    } else t9 = $[21];
    const getChildren = t9;
    let t10;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:page");
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== getChildren) {
        t11 = getChildren();
        $[23] = getChildren;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== handleItemOnClick) {
        t12 = (e_0)=>handleItemOnClick(e_0, "createAISmartCreatePopoverItem");
        $[25] = handleItemOnClick;
        $[26] = t12;
    } else t12 = $[26];
    let t13;
    if ($[27] !== CreateWithRovoSpotlightWrapper || $[28] !== t11 || $[29] !== t12) {
        t13 = {
            ati: t10,
            children: t11,
            Wrapper: CreateWithRovoSpotlightWrapper,
            onClick: t12,
            href: href,
            elemBefore: (0, $6mKj3.expValEquals)("cc_fd_aifc_copy_change_experiment", "isEnabled", true) ? (0, (/*@__PURE__*/$parcel$interopDefault($gNXND))) : (0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))),
            testId: "create-menu-link-item"
        };
        $[27] = CreateWithRovoSpotlightWrapper;
        $[28] = t11;
        $[29] = t12;
        $[30] = t13;
    } else t13 = $[30];
    return t13;
}
module.exports["useAISmartCreateItem"] = $03068ae1a528f6bf$export$57669fd702f839a2;

});

parcelRegister("h7YX1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c646a99d277cd4b5b22a16e5f42dbd2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7825eb38d10cf15$var$_react = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("42omo")));

var $c7825eb38d10cf15$var$_baseNew = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c7825eb38d10cf15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7825eb38d10cf15$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $c7825eb38d10cf15$var$_react.default.createElement($c7825eb38d10cf15$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$c7825eb38d10cf15$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $c7825eb38d10cf15$var$_default = module.exports.default = $c7825eb38d10cf15$var$AiGenerativeTextIcon;

});

parcelRegister("gNXND", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a463dbdb96f5dd0cff6dca797202b246>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3bf9be9856ff4d9$var$_react = $c3bf9be9856ff4d9$var$_interopRequireDefault((parcelRequire("42omo")));

var $c3bf9be9856ff4d9$var$_baseNew = $c3bf9be9856ff4d9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c3bf9be9856ff4d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3bf9be9856ff4d9$var$RovoIcon = (props)=>/*#__PURE__*/ $c3bf9be9856ff4d9$var$_react.default.createElement($c3bf9be9856ff4d9$var$_baseNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$c3bf9be9856ff4d9$var$RovoIcon.displayName = 'RovoIcon';
var $c3bf9be9856ff4d9$var$_default = module.exports.default = $c3bf9be9856ff4d9$var$RovoIcon;

});

parcelRegister("16lEl", function(module, exports) {
const $99e3e594de94f1bc$export$b881bd9f00ed8ed1 = {
    LOAD_PANEL: 'aiMateLoadPanel',
    LOAD_PANEL_COMPOSABLE_EDITOR: 'aiMateLoadPanelComposableEditor',
    LOAD_INLINE_EDITOR: 'aiMateLoadInlineComposableEditor',
    LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
    LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
    FETCH_CHAT: 'aiMateFetchChat',
    FETCH_AGENTS: 'aiMateFetchAgents',
    FETCH_AGENTS_PAGINATED: 'aiMateFetchAgentsPaginated',
    FETCH_AGENTS_OVERRIDES: 'aiMateFetchAgentsOverrides',
    FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
    FETCH_SCENARIO_LIST: 'aiMateFetchScenarioList',
    FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
    FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE: 'aiMateFetchAgentByExternalConfigReference',
    FETCH_AGENT_DEBUG_MODAL_DATA: 'aiMateFetchAgentDebugModalData',
    FETCH_AGENT_DEBUG_MODAL_CONVERSATION_REVIEW: 'aiMateFetchAgentDebugModalDataConversationReview',
    CREATE_AGENT: 'aiMateCreateAgent',
    UPDATE_AGENT: 'aiMateUpdateAgent',
    DELETE_AGENT: 'aiMateDeleteAgent',
    HYDRATE_AGENT_DATA: 'aiMateHydrateAgentData',
    FAVOURITE_AGENT: 'aiMateFavouriteAgent',
    UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
    CLEAR_CHAT: 'aiMateClearChat',
    SEND_MESSAGE: 'aiMateSendMessage',
    SEND_MESSAGE_ROVO_CUSTOM_AGENT: 'aiMateSendMessageRovoCustomAgent',
    SEND_DR_MESSAGE: 'aiMateSendDRMessage',
    SEND_TD_MESSAGE: 'aiMateSendThinkDeeperMessage',
    SEND_CONFIRMED_TOOLS_MESSAGE: 'aiMateSendConfirmedToolsMessage',
    RECONNECT_TO_ACTIVE_STREAM: 'aiMateReconnectToActiveStream',
    ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
    HYDRATE_CONVERSATION: 'aiMateHydrateConversation',
    GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
    GET_CONVERSATION_CHANNELS_INITIAL_LOAD: 'aiMateGetConversationChannelsInitialLoad',
    UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
    CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
    PUBSUB_LISTENER: 'aiMatePubSubListener',
    FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
    RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
    BULK_RESOLVE_CONVERSATION_ACTIONS: 'aiMateBulkResolveConversationActions',
    MESSAGE_RENDERER: 'aiMateMessageRenderer',
    FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
    FETCH_DYNAMIC_CONVERSATION_STARTERS: 'aiMateFetchDynamicConversationStarters',
    GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
    FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
    FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
    CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
    GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions',
    AIFC_FINALIZE_CONTENT: 'aiMateAIFCFinalizeContent',
    PREVIEW_CONTENT: 'aiMatePreviewContent',
    PREVIEW_CARD_RENDER: 'aiMatePreviewCardRender',
    JIRA_PREVIEW_CARD_RENDER: 'aiMateJiraPreviewCardRender',
    FETCH_AGENT_SITE_PERMISSIONS: 'aiMateFetchAgentSitePermissions',
    SEND_MESSAGE_NL_AGENT: 'aiMateSendMessageNLAgent',
    GET_RECOMMENDED_AGENTS: 'aiMateGetRecommendedAgents',
    UPLOAD_FILES_TO_CONVERSATION: 'aiMateUploadFilesToConversation',
    VALIDATE_FILES: 'aiMateValidateFiles',
    GET_CONVERSATION_FILES: 'aiMateGetConversationFiles',
    AIFC_MESSAGE: 'aiMateAifcMessage',
    AIFC_LOAD_STAGING_AREA_MODAL: 'aiMateLoadStagingAreaModal',
    AIFC_LOAD_DRAFTS_SECTION: 'aiMateLoadDraftsSection',
    AIFC_GENERATE_CONTENT: 'aiMateAifcGenerateContent',
    AIFC_GENERATE_CONTENT_IN_CHAT: 'aiMateAifcGenerateContentInChat',
    AIFC_INITIAL_DATA_RECEIVED: 'aiMateAifcInitialDataReceived',
    AIFC_ALL_DATA_HANDLED: 'aiMateAifcAllDataHandled',
    AIFC_UPDATE_CONTENT: 'aiMateAifcUpdateContent',
    AIFC_MODAL_SESSION: 'aiMateAifcModalSession',
    CSM_WIDGET_RENDER: 'csmWidgetRender',
    CSM_AGENT_IDENTITY_NAME: 'csmAgentIdentityName',
    CSM_AGENT_IDENTITY_COMPANY: 'csmAgentIdentityCompany',
    CSM_AGENT_IDENTITY_TONE: 'csmAgentIdentityTone',
    CSM_AGENT_IDENTITY_GREETING_MESSAGE: 'csmAgentIdentityGreetingMessage',
    CSM_AGENT_IDENTITY_CONVERSATION_STARTERS: 'csmAgentIdentityConversationStarters',
    CSM_AGENT_IDENTITY_GENERATE_CONVERSATION_STARTERS: 'csmAgentIdentityGenerateConversationStarters',
    GET_AUTO_APPLY_STATE: 'aiMateGetAutoApplyState',
    SET_AUTO_APPLY_STATE: 'aiMateSetAutoApplyState',
    AGENTS_MODAL_AND_SIDEBAR_LIST: 'aiMateAgentsModalAndSidebarList',
    AGENTS_MODAL_FAVOURITE_AGENTS: 'aiMateAgentsModalFavouriteAgents',
    AGENTS_FULLSCREEN_AGENT_LIST: 'aiMateAgentsFullscreenAgentList'
};
var $99e3e594de94f1bc$export$3615d040a39afa1e = /*#__PURE__*/ function(ExperienceNamePostfix) {
    ExperienceNamePostfix["MINI_MODAL"] = "miniModal";
    return ExperienceNamePostfix;
}({});
const $99e3e594de94f1bc$export$97bfa295b10f6f9e = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, isCustomRovoAgent: isCustomRovoAgent })=>{
    if (isCustomRovoAgent) return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (deepResearchEnabled) return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_DR_MESSAGE;
    if (thinkDeeperEnabled) return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_TD_MESSAGE;
    return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_MESSAGE;
};
const $99e3e594de94f1bc$export$233a4307e330ea30 = [
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT_IN_CHAT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_UPDATE_CONTENT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_FINALIZE_CONTENT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_LOAD_STAGING_AREA_MODAL,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_MODAL_SESSION
];
const $99e3e594de94f1bc$export$449b821dadec8760 = [
    // Experiences with timeouts must be listed first:
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_INITIAL_DATA_RECEIVED,
    // Experiences without timeouts:
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_ALL_DATA_HANDLED,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.PREVIEW_CONTENT,
    ...$99e3e594de94f1bc$export$233a4307e330ea30
];
module.exports["ExperienceName"] = $99e3e594de94f1bc$export$b881bd9f00ed8ed1;
module.exports["ExperienceNamePostfix"] = $99e3e594de94f1bc$export$3615d040a39afa1e;
module.exports["sendMessageExperienceName"] = $99e3e594de94f1bc$export$97bfa295b10f6f9e;
module.exports["AIFC_EXPERIENCES_TO_FAIL"] = $99e3e594de94f1bc$export$233a4307e330ea30;
module.exports["AIFC_EXPERIENCES_TO_ABORT"] = $99e3e594de94f1bc$export$449b821dadec8760;

});

parcelRegister("hUyPY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $c6GJD = parcelRequire("c6GJD");


var $4u5NT = parcelRequire("4u5NT");


var $9tntP = parcelRequire("9tntP");


var $j2DyP = parcelRequire("j2DyP");


var $1yaYZ = parcelRequire("1yaYZ");


var $kIvLT = parcelRequire("kIvLT");


var $16lEl = parcelRequire("16lEl");

var $a0b22d0a467d60f5$var$_ExperienceTrackerHandler;
const $a0b22d0a467d60f5$var$isRovoInstrumentedError = (error)=>error && typeof error === 'object' && 'errorAttributes' in error && typeof error.errorAttributes === 'object';
class $a0b22d0a467d60f5$export$5a92a056565f01cc {
    setSendAnalyticsEvent(sendAnalyticsEvent) {
        this.sendAnalyticsEvent = sendAnalyticsEvent;
    }
    static getInstance() {
        if (!$a0b22d0a467d60f5$export$5a92a056565f01cc.instance) {
            const dropEvents = (0, $c6GJD.default).getExperimentValue('platform_ai_drop_instrumentation_tracking', 'value', false);
            $a0b22d0a467d60f5$export$5a92a056565f01cc.instance = new $a0b22d0a467d60f5$export$5a92a056565f01cc(dropEvents);
        }
        return $a0b22d0a467d60f5$export$5a92a056565f01cc.instance;
    }
    /**
   * @internal For tests only.
   */ static resetInstance() {
        $a0b22d0a467d60f5$export$5a92a056565f01cc.instance = undefined;
    }
    static setLabelStack(labelStack) {
        $a0b22d0a467d60f5$export$5a92a056565f01cc.labelStack = labelStack;
    }
    constructor(dropEvents){
        this.experienceTracker = new (0, $9tntP.ExperienceTracker)();
        this.sendAnalyticsEvent = null;
        if (!dropEvents) this.experienceTracker.subscribe((event)=>{
            let filteredErrorAttributes = {};
            let preventSendingLogException = false;
            // for FailEvent
            if ('error' in event) {
                // do not fail experience tracking if the error is a client fetch error
                if ((0, $j2DyP.isClientFetchError)(event.error)) preventSendingLogException = true;
                if (event.attributes) {
                    const { webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled } = event.attributes;
                    if (webSearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        webSearchEnabled: webSearchEnabled
                    };
                    if (deepResearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        deepResearchEnabled: deepResearchEnabled
                    };
                    if (thinkDeeperEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        thinkDeeperEnabled: thinkDeeperEnabled
                    };
                }
                if ($a0b22d0a467d60f5$var$isRovoInstrumentedError(event.error)) {
                    const errorAttributes = event.error.errorAttributes;
                    // Remove undefined properties
                    filteredErrorAttributes = Object.fromEntries(Object.entries(errorAttributes).filter(([, value])=>value !== undefined));
                }
                if (!preventSendingLogException) {
                    const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                    const attributes = event.attributes;
                    // this is added by `useExperienceTracker` below
                    const touchpointSource = attributes?.touchpointSource;
                    const teamName = attributes?.teamName;
                    const { traceId: traceIdFromErrorObject, ...filteredErrorAttributesRest } = filteredErrorAttributes;
                    const altTraceId = attributes?.traceId || traceIdFromErrorObject;
                    (0, $1yaYZ.logException)({
                        exception: error,
                        name: event.name,
                        tags: {
                            source: 'aiMateExperienceTracker',
                            ...filteredErrorAttributesRest,
                            ...touchpointSource && {
                                touchpointSource: touchpointSource
                            },
                            ...teamName && {
                                teamName: teamName
                            },
                            // Rename traceId to atlTraceId if present in attributes to distinguish from Sentry's Trace ID
                            ...altTraceId && {
                                altTraceId: altTraceId
                            }
                        }
                    });
                }
            }
            if (event.action === 'taskSuccess' || event.action === 'taskFail' || event.action === 'taskAbort') // the experience tracker already uses performance.now() to calculate the duration, so we can just piggyback on that,
            // we will loose some precision due to rounding of duration, but it's good enough for our purposes
            (0, $4u5NT.addSpanToAll)('custom', `exp-${event.name}`, $a0b22d0a467d60f5$export$5a92a056565f01cc.labelStack, event.startTime, event.startTime + event.duration);
            this.sendAnalyticsEvent?.({
                eventType: 'operational',
                action: event.action,
                actionSubject: 'ui',
                attributes: {
                    task: event.name,
                    taskId: event.id,
                    startTime: event.startTime,
                    // Only add duration if event is SuccessEvent or FailEvent
                    ...(event.action === 'taskSuccess' || event.action === 'taskFail') && {
                        duration: event.duration
                    },
                    ...event.action === 'taskFail' && {
                        error: event.error.message,
                        ...filteredErrorAttributes
                    },
                    ...event.attributes
                }
            }, {
                removeDefaultTags: true
            });
        });
    }
}
$a0b22d0a467d60f5$var$_ExperienceTrackerHandler = $a0b22d0a467d60f5$export$5a92a056565f01cc;
$a0b22d0a467d60f5$export$5a92a056565f01cc.instance = void 0;
$a0b22d0a467d60f5$export$5a92a056565f01cc.labelStack = [];
const $a0b22d0a467d60f5$export$63af6e7bbb4f375d = ()=>{
    return (0, $42omo.useCallback)((componentLabelStack)=>{
        $a0b22d0a467d60f5$export$5a92a056565f01cc.setLabelStack(componentLabelStack);
    }, []);
};
const $a0b22d0a467d60f5$export$412c53791574f6f0 = (params)=>{
    (0, $fBMbo.di)((0, $kIvLT.useAnalytics));
    const { sendAnalyticsEvent: sendAnalyticsEvent, mode: conversationAssistantUIMode } = (0, $kIvLT.useAnalytics)();
    const getNameOverride = (0, $42omo.useCallback)((name)=>{
        switch(conversationAssistantUIMode){
            case 'mini-modal':
                return `${name}.${(0, $16lEl.ExperienceNamePostfix).MINI_MODAL}`;
            default:
                return name;
        }
    }, [
        conversationAssistantUIMode
    ]);
    (0, $42omo.useMemo)(()=>{
        const experienceTracker = $a0b22d0a467d60f5$export$5a92a056565f01cc.getInstance();
        // this is not ideal, okay just because `sendAnalyticsEvent` is never change
        // since every hook instance will override the singleton sendAnalyticsEvent
        experienceTracker.setSendAnalyticsEvent(sendAnalyticsEvent);
    }, [
        sendAnalyticsEvent
    ]);
    const experienceTrackerProxy = (0, $42omo.useMemo)(()=>{
        const proxyHandler = {
            get: (target, prop)=>{
                // Overriding the experienceTracker target methods to add additional attributes
                if (prop === 'fail') return (failParams)=>{
                    target.fail({
                        ...failParams,
                        attributes: {
                            ...failParams.attributes,
                            name: !!failParams.name ? getNameOverride(failParams.name) : failParams.name,
                            touchpointSource: params?.touchpointSource,
                            teamName: failParams.teamName
                        }
                    });
                };
                if (prop === 'succeed') return (succeedParams)=>{
                    target.succeed({
                        ...succeedParams,
                        name: !!succeedParams.name ? getNameOverride(succeedParams.name) : succeedParams.name,
                        attributes: {
                            ...succeedParams.attributes,
                            touchpointSource: params?.touchpointSource
                        }
                    });
                };
                if (prop === 'start') return (startParams)=>{
                    target.start({
                        ...startParams,
                        name: !!startParams.name ? getNameOverride(startParams.name) : startParams.name
                    });
                };
                if (prop === 'abort') return (abortParams)=>{
                    target.abort({
                        ...abortParams,
                        name: !!abortParams.name ? getNameOverride(abortParams.name) : abortParams.name
                    });
                };
                if (prop === 'stopOnError') return (stopOnErrorParams)=>{
                    target.stopOnError({
                        ...stopOnErrorParams,
                        name: !!stopOnErrorParams.name ? getNameOverride(stopOnErrorParams.name) : stopOnErrorParams.name
                    });
                };
                return typeof target[prop] === 'function' ? target[prop].bind(target) : target[prop];
            }
        };
        return new Proxy($a0b22d0a467d60f5$export$5a92a056565f01cc.getInstance().experienceTracker, proxyHandler);
    }, [
        params?.touchpointSource,
        getNameOverride
    ]);
    return experienceTrackerProxy;
};
module.exports["useUFOLabelStackSetter"] = $a0b22d0a467d60f5$export$63af6e7bbb4f375d;
module.exports["useAIMateExperienceTracker"] = $a0b22d0a467d60f5$export$412c53791574f6f0;

});

parcelRegister("fBMbo", function(module, exports) {

var $dNGPK = parcelRequire("dNGPK");


var $7qH1e = parcelRequire("7qH1e");

function $b5cfafc926496f98$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $dNGPK.Context)._currentRenderer2 && (0, $dNGPK.Context)._currentValue2 || // grab value from default renderer
    (0, $dNGPK.Context)._currentValue || (0, $7qH1e.globalDi);
    return getDependencies(deps, target);
}
module.exports["di"] = $b5cfafc926496f98$export$479d1ccc5f2ab701;

});

parcelRegister("dNGPK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7qH1e = parcelRequire("7qH1e");

const $a0c113d1cdcf525c$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getDependencies: (0, $7qH1e.globalDi).getDependencies
});
module.exports["Context"] = $a0c113d1cdcf525c$export$841858b892ce1f4c;

});

parcelRegister("7qH1e", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $b1tX2 = parcelRequire("b1tX2");

const $568c54c2a75aa99b$var$replacementMap = new Map();
const $568c54c2a75aa99b$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($568c54c2a75aa99b$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $b1tX2.findInjectable)($568c54c2a75aa99b$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($568c54c2a75aa99b$var$replacementMap.size) throw new Error(`${(0, $ipvr6.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj));
    },
    clear () {
        $568c54c2a75aa99b$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $ipvr6.diRegistry).get(inj).global) (0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $b1tX2.removeInjectableFromMap)($568c54c2a75aa99b$var$replacementMap, inj));
    }
};
function $568c54c2a75aa99b$export$b887ce09d70113f9(thunk, deps) {
    $568c54c2a75aa99b$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function' && typeof result.finally === 'function') result.finally($568c54c2a75aa99b$export$a775919ebd7dd28a.clear);
        else $568c54c2a75aa99b$export$a775919ebd7dd28a.clear();
    }
}
module.exports["globalDi"] = $568c54c2a75aa99b$export$a775919ebd7dd28a;

});

parcelRegister("ipvr6", function(module, exports) {
const $d672f259068efdcd$export$4203fb010fad9bf0 = new WeakMap();
const $d672f259068efdcd$export$b8b9d90f9e5bd72b = 'react-magnetic-di';
module.exports["diRegistry"] = $d672f259068efdcd$export$4203fb010fad9bf0;
module.exports["PACKAGE_NAME"] = $d672f259068efdcd$export$b8b9d90f9e5bd72b;

});

parcelRegister("b1tX2", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $aqxLC = parcelRequire("aqxLC");

let $80670563c880fcd1$var$hasWarned = false;
function $80670563c880fcd1$export$5b28268982f175ba(message) {
    if (!$80670563c880fcd1$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $80670563c880fcd1$var$hasWarned = true;
    }
}
function $80670563c880fcd1$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $aqxLC.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $80670563c880fcd1$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $80670563c880fcd1$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $80670563c880fcd1$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $80670563c880fcd1$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $aqxLC.stats).track(candidate);
    return candidate;
}
module.exports["addInjectableToMap"] = $80670563c880fcd1$export$7a7134bdd2f9ae2e;
module.exports["removeInjectableFromMap"] = $80670563c880fcd1$export$8057a2244a849b7b;
module.exports["findInjectable"] = $80670563c880fcd1$export$7c436e151c3ee289;

});

parcelRegister("aqxLC", function(module, exports) {
const $79768685dc5c2f62$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $79768685dc5c2f62$export$7804429c45dff272 = {
    state: $79768685dc5c2f62$var$createState(),
    set (injObj) {
        var _injObj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === injObj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(injObj, new Error(`Unused "di" injectable: ${((_injObj$value = injObj.value) == null ? void 0 : _injObj$value.displayName) || injObj.value}.`, {
            cause: injObj.cause
        }));
        // reset to avoid potential memory leaks via stack traces
        injObj.cause = null;
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
    },
    reset () {
        this.state = $79768685dc5c2f62$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};
module.exports["stats"] = $79768685dc5c2f62$export$7804429c45dff272;

});

parcelRegister("j2DyP", function(module, exports) {
// Referenced from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Issues we are not gonna track in Sentry
const $3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_LIMITED = [
    'server with the specified hostname could not be found',
    'connection failure',
    'Failed to fetch',
    'Network request failed',
    'NetworkError',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted'
];
const $3c7c331d93a4dcee$var$isClientFetchErrorMessage = (message)=>{
    const errorTypes = $3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_LIMITED;
    return Boolean(message) && !!errorTypes.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
};
const $3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_TYPES = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $3c7c331d93a4dcee$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name) || $3c7c331d93a4dcee$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || $3c7c331d93a4dcee$var$isClientFetchErrorMessage(error.cause.message)));
module.exports["isClientFetchError"] = $3c7c331d93a4dcee$export$2e7adc44463c3f4f;

});

parcelRegister("1yaYZ", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $8Igpw = parcelRequire("8Igpw");


var $j2DyP = parcelRequire("j2DyP");


var $35fh0 = parcelRequire("35fh0");


var $ldpU6 = parcelRequire("ldpU6");


// importing local file instead of from '@sentry/browser' otherwise there will be typescript errors
const $26a7abafe1ae99d6$var$importSentryAsync = async ()=>(parcelRequire("6jYyB"));
let $26a7abafe1ae99d6$var$sentryClient;
let $26a7abafe1ae99d6$var$accountIdPromise;
// copied from platform/packages/people-and-teams/teams-client/src/services/sentry/utils/initialise-sentry.ts
const $26a7abafe1ae99d6$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
const $26a7abafe1ae99d6$var$getEnvironment = ()=>{
    return 'production';
};
const $26a7abafe1ae99d6$export$d8bd0edf6c978788 = async ({ customSentryDsn: customSentryDsn, packageName: packageName, product: productOverride, ignoreErrors: ignoreErrors, packageVersion: packageVersion } = {})=>{
    let accountId = 'UNKNOWN_AAID';
    let product = productOverride ?? (0, $35fh0.getRovoChatProduct)();
    try {
        if ((0, $dh538.fg)('rovo_chat_enable_additional_breadcrumbs')) {
            if (!$26a7abafe1ae99d6$var$accountIdPromise) $26a7abafe1ae99d6$var$accountIdPromise = new Promise((resolve, reject)=>{
                (0, $8Igpw.performHttpFetch)({
                    path: '/gateway/api/me',
                    options: {
                        method: 'GET'
                    }
                }).then((profileData)=>{
                    if (profileData?.account_id) resolve(profileData.account_id);
                    else reject(new Error('Profile data not loaded'));
                }).catch((error)=>{
                    reject(error);
                });
            });
            accountId = await $26a7abafe1ae99d6$var$accountIdPromise;
        } else {
            const profileData = await (0, $8Igpw.performHttpFetch)({
                path: '/gateway/api/me',
                options: {
                    method: 'GET'
                }
            });
            if (profileData?.account_id) accountId = profileData.account_id;
        }
    } catch  {
    // do nothing
    }
    if ($26a7abafe1ae99d6$var$sentryClient) {
        // if sentry is trying to be initialized again with new product or account id
        // update the user and tags
        $26a7abafe1ae99d6$var$sentryClient.setTag('product', product);
        $26a7abafe1ae99d6$var$sentryClient.setUser({
            id: accountId
        });
        // do not initialise sentry again, only update the existing one
        return;
    }
    let importedSentry;
    try {
        importedSentry = await $26a7abafe1ae99d6$var$importSentryAsync();
    } catch (e) {
        console.warn('Failed to load conversation-assistant sentry', e); // eslint-disable-line no-console
        return;
    }
    // https://atlassian-2y.sentry.io/projects/ai-mate-conversation-assistant/getting-started/
    const defaultSentryDsn = 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680';
    importedSentry.init({
        dsn: customSentryDsn || defaultSentryDsn,
        environment: $26a7abafe1ae99d6$var$getEnvironment(),
        integrations: (integrations)=>{
            return integrations.filter((integration)=>{
                return $26a7abafe1ae99d6$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        },
        initialScope: {
            user: {
                id: accountId
            },
            tags: {
                packageName: packageName || '@atlassian/conversation-assistant',
                product: product,
                packageVersion: packageVersion
            }
        },
        // referencing jira/src/packages/platform/observability/errors-handling/src/utils/sentry/handling/normalise-sentry-event.tsx
        beforeSend: (event, hint)=>{
            const exception = hint?.originalException;
            // Ignore network-like errors
            if ((0, $j2DyP.isClientFetchError)(exception)) return null;
            if (!event.tags?.name) // we only want to capture errors that has `name` tag from `logException` function below
            // since the `DISABLED_INTEGRATIONS` filter above is not enough to prevent unhandled errors
            return null;
            let updatedEvent = event;
            if (updatedEvent.request?.url) {
                // Ignore events from localhost and staging
                if (updatedEvent.request.url.includes('localhost') || updatedEvent.request.url.includes('jira-dev.com') || updatedEvent.request.url.includes('stg.atlassian.com') || updatedEvent.request.url.includes('stg.internal.atlassian.com') || updatedEvent.request.url.includes('stg-east.frontend.public.atl-paas.net')) return null;
                updatedEvent.request.url = (0, $ldpU6.normaliseUrl)(updatedEvent.request.url);
            }
            if (updatedEvent.exception?.values) {
                const allMatchedUUIDs = [];
                updatedEvent.exception.values = updatedEvent.exception.values.map((exception)=>{
                    const { normalized: normalized, matchedUUIDs: matchedUUIDs } = (0, $ldpU6.normalizeUUID)(exception.value);
                    allMatchedUUIDs.push(...matchedUUIDs);
                    return {
                        ...exception,
                        value: normalized
                    };
                });
                if (allMatchedUUIDs.length > 0) {
                    if (!updatedEvent.tags) updatedEvent.tags = {};
                    updatedEvent.tags.matchedUUID = JSON.stringify(allMatchedUUIDs);
                }
            }
            return updatedEvent;
        },
        attachStacktrace: true,
        ignoreErrors: ignoreErrors
    });
    $26a7abafe1ae99d6$var$sentryClient = importedSentry;
};
const $26a7abafe1ae99d6$var$getSentryClient = async ()=>{
    if (!$26a7abafe1ae99d6$var$sentryClient) // this only happens if something using sentry before the initialisation in root app
    await $26a7abafe1ae99d6$export$d8bd0edf6c978788();
    return $26a7abafe1ae99d6$var$sentryClient;
};
const $26a7abafe1ae99d6$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
    const sentryClient = await $26a7abafe1ae99d6$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        scope.setTag('name', name);
        if (tags) scope.setTags(tags);
        if (tags?.source === 'aiMateExperienceTracker') scope.setTag('experience', name);
        sentryClient.captureException(exception, scope);
    });
};
async function $26a7abafe1ae99d6$export$de29810e0b4aa46e(crumb) {
    if (!(0, $dh538.fg)('rovo_chat_enable_additional_breadcrumbs')) // do not add breadcrumbs if the feature flag is disabled
    return;
    const sentryClient = await $26a7abafe1ae99d6$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.addBreadcrumb(typeof crumb === 'string' ? {
        message: crumb
    } : crumb);
}
module.exports["setupSentryClient"] = $26a7abafe1ae99d6$export$d8bd0edf6c978788;
module.exports["logException"] = $26a7abafe1ae99d6$export$f86b2a1a2ce291b3;
module.exports["addSentryBreadcrumb"] = $26a7abafe1ae99d6$export$de29810e0b4aa46e;

});

parcelRegister("8Igpw", function(module, exports) {
const $43e5bdc11d95b8bf$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
class $43e5bdc11d95b8bf$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
class $43e5bdc11d95b8bf$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $43e5bdc11d95b8bf$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $43e5bdc11d95b8bf$var$processHttpErrorResponse({
            response: response
        });
        return await response.json();
    } catch (err) {
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        const statusCode = err instanceof $43e5bdc11d95b8bf$var$HttpApiError ? err?.errorAttributes?.statusCode : undefined;
        throw new $43e5bdc11d95b8bf$export$26e841bcf1aeb894(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError',
            statusCode: statusCode
        });
    }
};
const $43e5bdc11d95b8bf$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $43e5bdc11d95b8bf$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: $43e5bdc11d95b8bf$export$9f229e40eb65abfc(response)
    });
};
module.exports["getTraceIdFromResponse"] = $43e5bdc11d95b8bf$export$9f229e40eb65abfc;
module.exports["FetchError"] = $43e5bdc11d95b8bf$export$26e841bcf1aeb894;
module.exports["performHttpFetch"] = $43e5bdc11d95b8bf$export$a38d93aa782475f6;

});

parcelRegister("35fh0", function(module, exports) {
const $a3e3dc6fd5fb1937$export$d4fdfa93c283ffc = ()=>{
    let product = 'UNKNOWN';
    if (window && window.__ROVO_CHAT_CONFIG_PRODUCT__) product = window.__ROVO_CHAT_CONFIG_PRODUCT__;
    return product;
};
module.exports["getRovoChatProduct"] = $a3e3dc6fd5fb1937$export$d4fdfa93c283ffc;

});

parcelRegister("ldpU6", function(module, exports) {
const $62424571d4d73005$var$pathnamePrefixes = [
    '/jira/',
    '/wiki/',
    '/browse/'
];
const $62424571d4d73005$var$ATLAS_HOST = 'home.atlassian.com';
const $62424571d4d73005$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
const $62424571d4d73005$var$UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $62424571d4d73005$export$d57ae76c6dc57a5 = (url)=>{
    try {
        let parsedUrl = new URL(url);
        let normalizedPath = '/any/';
        if (parsedUrl.host === $62424571d4d73005$var$ATLAS_HOST || parsedUrl.host === $62424571d4d73005$var$ATLAS_TEAM_HOST) // Replace org ID with "orgId" in the path
        normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
        const prefixRegex = new RegExp(`^(${$62424571d4d73005$var$pathnamePrefixes.join('|')})`);
        if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
        const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
        return normalizedUrl;
    } catch (error) {
        return 'https://could-not-parse.example.com';
    }
};
const $62424571d4d73005$export$5efaf8444170fe75 = (str)=>{
    if (!str) return {
        normalized: '',
        matchedUUIDs: []
    };
    const matchedUUIDs = str.match($62424571d4d73005$var$UUID_REGEX) || [];
    const normalized = str.replace($62424571d4d73005$var$UUID_REGEX, '{uuid}');
    return {
        normalized: normalized,
        matchedUUIDs: matchedUUIDs
    };
};
module.exports["normaliseUrl"] = $62424571d4d73005$export$d57ae76c6dc57a5;
module.exports["normalizeUUID"] = $62424571d4d73005$export$5efaf8444170fe75;

});

parcelRegister("6jYyB", function(module, exports) {

let $49a37dcba4f239e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $49a37dcba4f239e3$var$load("h3ABO"),
    $49a37dcba4f239e3$var$load("kC80R")
]).then(()=>parcelRequire('7hGsm'));

});

parcelRegister("kIvLT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6v6KC = parcelRequire("6v6KC");

var $inPa6 = parcelRequire("inPa6");


var $fYQcF = parcelRequire("fYQcF");


var $1yaYZ = parcelRequire("1yaYZ");


var $TwPkE = parcelRequire("TwPkE");


var $jA9SA = parcelRequire("jA9SA");


var $bQGO7 = parcelRequire("bQGO7");


var $lUZCl = parcelRequire("lUZCl");

const $6e0837af2bd4bfd5$var$isTownSquareEvent = ()=>[
        'home.atlassian.com',
        'team.atlassian.com'
    ].some((host)=>window.location?.host?.includes(host));
const $6e0837af2bd4bfd5$var$DEFAULT_TAGS = [
    'atlaskit',
    'aiMate'
];
const $6e0837af2bd4bfd5$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef, mode: mode } = (0, $TwPkE.useAnalyticsPropertiesContext)();
    // TODO: Improve this functionality, potentially with a higher order provider for tags or similar
    // This is a temporary solution to add the 'townsquare' tag to operational events so Experience Tracker works in Atlas
    const maybeAtlasOperationalTags = (0, $42omo.useCallback)((inputPayload)=>{
        const payload = (0, $6v6KC.isUIAnalyticsEvent)(inputPayload) ? inputPayload.payload : inputPayload;
        if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $6e0837af2bd4bfd5$var$isTownSquareEvent()) return [
            'townsquare'
        ];
        return [];
    }, []);
    const tagsForAIAnalytics = [
        ...$6e0837af2bd4bfd5$var$DEFAULT_TAGS
    ];
    if ($6e0837af2bd4bfd5$var$isTownSquareEvent()) tagsForAIAnalytics.push('townsquare');
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultAction: trackAIResultAction, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)({
        // Required configruation
        product: propertiesRef.current.product,
        subproduct: propertiesRef.current.product,
        aiFeatureName: 'aiChat',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        tags: tagsForAIAnalytics,
        customAnalyticsFire: (rawEvent, _createdEvent)=>{
            // Build event and apply context attributes
            const event = createAnalyticsEvent(rawEvent);
            const aiMateContextAttributes = (0, $lUZCl.getAttributesFromContexts)(event.context);
            // Fire
            event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $bQGO7.ANALYTICS_CHANNEL));
        }
    });
    const getDefaultAttributes = (0, $42omo.useCallback)(()=>{
        const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, agentExternalConfigReference: agentExternalConfigReference, agentActions: agentActions, agentIsDefault: agentIsDefault, agentIsVerified: agentIsVerified, conversationChannelId: conversationChannelId, experienceId: experienceId, fullScreen: fullScreen, product: product, productHeader: productHeader, mode: mode } = propertiesRef.current;
        return {
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).productHeader]: productHeader,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentExternalConfigReference]: agentExternalConfigReference,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentActions]: agentActions,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentIsDefault]: agentIsDefault,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentIsVerified]: agentIsVerified,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).mode]: mode
        };
    }, [
        propertiesRef
    ]);
    const trackAIMAUEvent = (0, $42omo.useCallback)((payload)=>{
        // Handle tags
        const tags = [
            ...$6e0837af2bd4bfd5$var$DEFAULT_TAGS
        ];
        if ($6e0837af2bd4bfd5$var$isTownSquareEvent()) tags.push('townsquare');
        const { source: source, subjectId: subjectId, proactive: proactive, userGenerated: userGenerated, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, timestamp: timestamp, citedProductList: citedProductList, citedProduct: citedProduct, sourceProducts: sourceProducts, sourceProduct: sourceProduct, invokedPlugins: invokedPlugins, responseSources: responseSources, usesJsm: usesJsm, invokedFrom: invokedFrom, conversationChannelId: conversationChannelId, attributes: customAttributes } = payload;
        let attributes = {
            ...getDefaultAttributes(),
            isAIFeature: 1,
            proactiveAIGenerated: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0,
            aiFeatureName: 'aiChat',
            citedProductList: citedProductList,
            citedProduct: citedProduct,
            sourceProducts: sourceProducts,
            sourceProduct: sourceProduct,
            ...customAttributes
        };
        if (messageId) attributes.messageId = messageId;
        if (messageActions) attributes.messageActions = messageActions;
        if (invokedFrom) attributes.invokedFrom = invokedFrom;
        if (timestamp) attributes.timestamp = timestamp;
        if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
        if (invokedPlugins) attributes.invokedPlugins = invokedPlugins;
        if (responseSources) attributes.responseSources = responseSources;
        if (usesJsm !== undefined) attributes.usesJsm = usesJsm;
        if (deepResearchEnabled) attributes.deepResearchEnabled = deepResearchEnabled;
        if (webSearchEnabled) attributes.webSearchEnabled = webSearchEnabled;
        if (conversationChannelId) attributes.conversationChannelId = conversationChannelId;
        let libAttributes = {
            ...attributes,
            aiFeatureName: 'aiChat',
            proactiveGeneratedAI: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0
        };
        switch(payload.type){
            case 'initiated':
                trackAIInteractionInit({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'viewed':
                trackAIResultView({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'error':
                trackAIResultError({
                    aiErrorMessage: payload.errorMessage
                }, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'dismissed':
                trackAIInteractionDismiss({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'actioned':
                trackAIResultAction(payload.actionResult, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'feedback':
                trackAIFeedbackSubmit(payload.feedbackResult, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
        }
    // Handle specific AI MAU events
    }, [
        getDefaultAttributes,
        trackAIInteractionInit,
        trackAIResultView,
        trackAIResultError,
        trackAIInteractionDismiss,
        trackAIResultAction,
        trackAIFeedbackSubmit
    ]);
    const sendAnalyticsEvent = (0, $42omo.useCallback)((payload, options)=>{
        const extraTags = options?.removeDefaultTags ? [] : $6e0837af2bd4bfd5$var$DEFAULT_TAGS;
        const allTags = Array.from(new Set([
            ...extraTags,
            ...payload.tags || [],
            ...maybeAtlasOperationalTags(payload)
        ]));
        const defaultAttributes = getDefaultAttributes();
        let eventToBeLoggedWithSentry;
        if ((0, $6v6KC.isUIAnalyticsEvent)(payload)) {
            const aiMateContextAttributes = (0, $lUZCl.getAttributesFromContexts)(payload.context);
            const updatedEvent = payload.update({
                ...payload.payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.payload.attributes,
                    ...aiMateContextAttributes
                }
            });
            updatedEvent.fire((0, $bQGO7.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent;
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.attributes
                }
            });
            const aiMateContextAttributes = (0, $lUZCl.getAttributesFromContexts)(event.context);
            const updatedEvent = event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            });
            updatedEvent.fire((0, $bQGO7.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent;
        }
        if (eventToBeLoggedWithSentry && eventToBeLoggedWithSentry.payload?.eventType !== 'operational') // choosing to log the event with Sentry if it is not an operational event to prevent noise in Sentry and not eat up the Sentry quota
        (0, $1yaYZ.addSentryBreadcrumb)(`sendAnalyticsEvent event: ${JSON.stringify(eventToBeLoggedWithSentry)}`);
    }, [
        createAnalyticsEvent,
        maybeAtlasOperationalTags,
        getDefaultAttributes
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent,
        mode: mode
    };
};
module.exports["useAnalytics"] = $6e0837af2bd4bfd5$export$e955abb82869dc84;

});

parcelRegister("fYQcF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dWJ5i = parcelRequire("dWJ5i");


var $3pfAb = parcelRequire("3pfAb");


var $inPa6 = parcelRequire("inPa6");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $1M9Av = parcelRequire("1M9Av");


var $ea2ui = parcelRequire("ea2ui");


var $j4EkW = parcelRequire("j4EkW");

const $a22fd04a8888d493$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $42omo.useContext)((0, $ifW2H.AIEventsInstrumentationContext));
    const aiEventAttributesOverride = (0, $42omo.useRef)({});
    if (customConfig) context = {
        config: {
            ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $j4EkW.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $42omo.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $dWJ5i.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $ea2ui.AISessionState).unset,
            nextState: (0, $dWJ5i.P).union((0, $ea2ui.AISessionState).viewed, (0, $ea2ui.AISessionState).error, (0, $ea2ui.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $ea2ui.AISessionState).initiated,
            nextState: (0, $dWJ5i.P).union((0, $ea2ui.AISessionState).submitted, (0, $ea2ui.AISessionState).actioned, (0, $ea2ui.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $42omo.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $3pfAb.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $42omo.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes,
                ...aiEventAttributesOverride.current
            }
        };
        return (0, $dWJ5i.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $1M9Av.getTagsWithPlatformTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $dWJ5i.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $dWJ5i.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        aiExperienceName,
        aiFeatureName,
        proactiveGeneratedAI,
        userGeneratedAI,
        isAIFeature
    ]);
    const trackAIInteractionInit = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $42omo.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $42omo.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $42omo.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    return {
        updateAIAttributes: updateAIAttributes,
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
};
module.exports["useAIEventsInstrumentation"] = $a22fd04a8888d493$export$ddf49ad062368ad2;

});

parcelRegister("dWJ5i", function(module, exports) {
const $a273a9fd41301c8f$var$t = Symbol.for("@ts-pattern/matcher"), $a273a9fd41301c8f$var$e = Symbol.for("@ts-pattern/isVariadic"), $a273a9fd41301c8f$var$n = "@ts-pattern/anonymous-select-key", $a273a9fd41301c8f$var$r = (t)=>Boolean(t && "object" == typeof t), $a273a9fd41301c8f$var$i = (e)=>e && !!e[$a273a9fd41301c8f$var$t], $a273a9fd41301c8f$var$o = (n, s, c)=>{
    if ($a273a9fd41301c8f$var$i(n)) {
        const e = n[$a273a9fd41301c8f$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($a273a9fd41301c8f$var$r(n)) {
        if (!$a273a9fd41301c8f$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $a273a9fd41301c8f$var$i(s) && s[$a273a9fd41301c8f$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$a273a9fd41301c8f$var$o(t, e[n], c)) && r.every((t, e)=>$a273a9fd41301c8f$var$o(t, n[e], c)) && (0 === a.length || $a273a9fd41301c8f$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$a273a9fd41301c8f$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $a273a9fd41301c8f$var$i(a = r) && "optional" === a[$a273a9fd41301c8f$var$t]().matcherType) && $a273a9fd41301c8f$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $a273a9fd41301c8f$var$s = (e)=>{
    var n, o, a;
    return $a273a9fd41301c8f$var$r(e) ? $a273a9fd41301c8f$var$i(e) ? null != (n = null == (o = (a = e[$a273a9fd41301c8f$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s) : $a273a9fd41301c8f$var$c(Object.values(e), $a273a9fd41301c8f$var$s) : [];
}, $a273a9fd41301c8f$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $a273a9fd41301c8f$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$a273a9fd41301c8f$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $a273a9fd41301c8f$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $a273a9fd41301c8f$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$a273a9fd41301c8f$var$l(t),
        and: (e)=>$a273a9fd41301c8f$var$m(t, e),
        or: (e)=>$a273a9fd41301c8f$var$d(t, e),
        select: (e)=>void 0 === e ? $a273a9fd41301c8f$var$y(t) : $a273a9fd41301c8f$var$y(e, t)
    });
}
function $a273a9fd41301c8f$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$a273a9fd41301c8f$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$a273a9fd41301c8f$var$h($a273a9fd41301c8f$var$l(t)),
        select: (e)=>$a273a9fd41301c8f$var$h(void 0 === e ? $a273a9fd41301c8f$var$y(t) : $a273a9fd41301c8f$var$y(e, t))
    });
}
function $a273a9fd41301c8f$var$l(e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($a273a9fd41301c8f$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $a273a9fd41301c8f$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$s(e),
                matcherType: "optional"
            })
    });
}
const $a273a9fd41301c8f$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $a273a9fd41301c8f$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $a273a9fd41301c8f$var$m(...e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$a273a9fd41301c8f$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s),
                matcherType: "and"
            })
    });
}
function $a273a9fd41301c8f$var$d(...e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$a273a9fd41301c8f$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s),
                matcherType: "or"
            })
    });
}
function $a273a9fd41301c8f$var$p(e) {
    return {
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $a273a9fd41301c8f$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $a273a9fd41301c8f$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $a273a9fd41301c8f$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $a273a9fd41301c8f$var$n
                    ].concat(void 0 === i ? [] : $a273a9fd41301c8f$var$s(i))
            })
    });
}
function $a273a9fd41301c8f$var$v(t) {
    return "number" == typeof t;
}
function $a273a9fd41301c8f$var$b(t) {
    return "string" == typeof t;
}
function $a273a9fd41301c8f$var$w(t) {
    return "bigint" == typeof t;
}
const $a273a9fd41301c8f$var$S = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return !0;
})), $a273a9fd41301c8f$var$O = $a273a9fd41301c8f$var$S, $a273a9fd41301c8f$var$j = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length >= t))(e))),
        length: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && Boolean(t.match(n))))));
        }
    }), $a273a9fd41301c8f$var$K = $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$b)), $a273a9fd41301c8f$var$x = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        between: (e, n)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t, e)=>$a273a9fd41301c8f$var$p((n)=>$a273a9fd41301c8f$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e < t))(e))),
        gt: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e > t))(e))),
        lte: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e <= t))(e))),
        gte: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e >= t))(e))),
        int: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && t > 0))),
        negative: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && t < 0)))
    }), $a273a9fd41301c8f$var$E = $a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$v)), $a273a9fd41301c8f$var$A = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        between: (e, n)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t, e)=>$a273a9fd41301c8f$var$p((n)=>$a273a9fd41301c8f$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e < t))(e))),
        gt: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e > t))(e))),
        lte: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e <= t))(e))),
        gte: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e >= t))(e))),
        positive: ()=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$w(t) && t > 0))),
        negative: ()=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$w(t) && t < 0)))
    }), $a273a9fd41301c8f$var$P = $a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$w)), $a273a9fd41301c8f$var$T = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return "boolean" == typeof t;
})), $a273a9fd41301c8f$var$B = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return "symbol" == typeof t;
})), $a273a9fd41301c8f$var$_ = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return null == t;
})), $a273a9fd41301c8f$var$k = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return null != t;
}));
var $a273a9fd41301c8f$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $a273a9fd41301c8f$var$t,
    optional: $a273a9fd41301c8f$var$l,
    array: function(...e) {
        return $a273a9fd41301c8f$var$h({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $a273a9fd41301c8f$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$a273a9fd41301c8f$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $a273a9fd41301c8f$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $a273a9fd41301c8f$var$f(t, (t)=>$a273a9fd41301c8f$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $a273a9fd41301c8f$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $a273a9fd41301c8f$var$g(t, (t, e)=>{
                                const n = $a273a9fd41301c8f$var$o(s, e, r), i = $a273a9fd41301c8f$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$a273a9fd41301c8f$var$s(e[0]),
                            ...$a273a9fd41301c8f$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $a273a9fd41301c8f$var$m,
    union: $a273a9fd41301c8f$var$d,
    not: function(e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$a273a9fd41301c8f$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $a273a9fd41301c8f$var$p,
    select: $a273a9fd41301c8f$var$y,
    any: $a273a9fd41301c8f$var$S,
    _: $a273a9fd41301c8f$var$O,
    string: $a273a9fd41301c8f$var$K,
    number: $a273a9fd41301c8f$var$E,
    bigint: $a273a9fd41301c8f$var$P,
    boolean: $a273a9fd41301c8f$var$T,
    symbol: $a273a9fd41301c8f$var$B,
    nullish: $a273a9fd41301c8f$var$_,
    nonNullable: $a273a9fd41301c8f$var$k,
    instanceOf: function(t) {
        return $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p($a273a9fd41301c8f$export$ce1e7a33533a73d9(t)));
    }
};
class $a273a9fd41301c8f$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $a273a9fd41301c8f$var$$ = {
    matched: !1,
    value: void 0
};
function $a273a9fd41301c8f$export$4659b591c19bdf3d(t) {
    return new $a273a9fd41301c8f$var$I(t, $a273a9fd41301c8f$var$$);
}
class $a273a9fd41301c8f$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$a273a9fd41301c8f$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $a273a9fd41301c8f$var$$ : {
            matched: !0,
            value: e(s ? $a273a9fd41301c8f$var$n in c ? c[$a273a9fd41301c8f$var$n] : c : this.input, this.input)
        };
        return new $a273a9fd41301c8f$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $a273a9fd41301c8f$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $a273a9fd41301c8f$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $a273a9fd41301c8f$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}
function $a273a9fd41301c8f$var$L(t) {
    throw new $a273a9fd41301c8f$export$6c1467edb54d3773(t);
}
module.exports["P"] = $a273a9fd41301c8f$export$56c0d5a1e737357d;
module.exports["match"] = $a273a9fd41301c8f$export$4659b591c19bdf3d;

});

parcelRegister("ifW2H", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $62e0541727c97e34$export$4f059feb37b5835e = (0, $42omo.createContext)(null);
module.exports["AIEventsInstrumentationContext"] = $62e0541727c97e34$export$4f059feb37b5835e;

});

parcelRegister("8Y3mE", function(module, exports) {

var $ea2ui = parcelRequire("ea2ui");

const $a544c5804dc19870$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $ea2ui.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};
module.exports["defaultAIEventsInstrumentationConfigValues"] = $a544c5804dc19870$export$5013b36eeed4ec19;

});

parcelRegister("ea2ui", function(module, exports) {
var $5a6bb3bf0e14987c$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $5a6bb3bf0e14987c$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});
module.exports["AISessionState"] = $5a6bb3bf0e14987c$export$af92e0e920a45719;
module.exports["EventDispatcherSources"] = $5a6bb3bf0e14987c$export$7052d5b66e36f60f;

});

parcelRegister("1M9Av", function(module, exports) {
const $699df07a7cf548d4$export$e053e424fcbfebe9 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};
module.exports["getTagsWithPlatformTag"] = $699df07a7cf548d4$export$e053e424fcbfebe9;

});

parcelRegister("j4EkW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kTkuM = parcelRequire("kTkuM");


var $a4NM6 = parcelRequire("a4NM6");


var $ea2ui = parcelRequire("ea2ui");

const $a4ec83494ea42b83$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $42omo.useRef)(undefined);
    const aiSessionStateRef = (0, $42omo.useRef)((0, $ea2ui.AISessionState).unset);
    const setAISessionState = (0, $42omo.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $42omo.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $42omo.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $kTkuM.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $a4NM6.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $42omo.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $a4NM6.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};
module.exports["useAIInstrumentationSetup"] = $a4ec83494ea42b83$export$259576f4e7ac6488;

});

parcelRegister("kTkuM", function(module, exports) {

var $dWJ5i = parcelRequire("dWJ5i");


var $cUcZ5 = parcelRequire("cUcZ5");

function $9779584a42635fbf$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $dWJ5i.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $dWJ5i.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $dWJ5i.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
}
module.exports["getNewSingleInstrumentationID"] = $9779584a42635fbf$export$cee2a1482be61648;

});

parcelRegister("a4NM6", function(module, exports) {

var $hEbxW = parcelRequire("hEbxW");

var $eGd7K = parcelRequire("eGd7K");

const $2674cc9dba61bfc1$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $2674cc9dba61bfc1$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $2674cc9dba61bfc1$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $eGd7K.setCookie)($2674cc9dba61bfc1$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $2674cc9dba61bfc1$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $hEbxW.getCookie)($2674cc9dba61bfc1$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $2674cc9dba61bfc1$export$72d8c154d3f75075;
module.exports["setSingleInstrumentationIDCookie"] = $2674cc9dba61bfc1$export$9a4eaf99327c19fe;
module.exports["readSingleInstrumentationIDCookie"] = $2674cc9dba61bfc1$export$d6fb1caea334c7c7;

});

parcelRegister("TwPkE", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");

const $19e5e9ef880dfbce$var$initialState = {
    conversationChannelId: '',
    experienceId: '',
    product: '',
    productHeader: '',
    agentId: null,
    agentExternalConfigReference: null,
    agentActions: [],
    agentIsDefault: null,
    agentIsVerified: null,
    fullScreen: false,
    agentCreatorType: '',
    agentVisibility: '',
    singleInstrumentationID: '',
    mode: undefined
};
const $19e5e9ef880dfbce$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $42omo.createContext)({
    propertiesRef: {
        current: {
            ...$19e5e9ef880dfbce$var$initialState
        }
    },
    mode: undefined,
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $19e5e9ef880dfbce$export$5ae3634fdb64882c = /*#__PURE__*/ (0, $42omo.createContext)({
    sharedFeaturesInstrumentationId: undefined,
    isInSmartCreateFlow: undefined
});
const $19e5e9ef880dfbce$export$1aefd27d2ed3c1c9 = ({ children: children, mode: mode })=>{
    const propertiesRef = (0, $42omo.useRef)({
        ...$19e5e9ef880dfbce$var$initialState
    });
    const setAnalyticsPropertiesWithoutRerender = (0, $42omo.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $42omo.useMemo)(()=>({
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender,
        mode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($19e5e9ef880dfbce$var$AnalyticsPropertiesContext.Provider, {
        value: value,
        children: children
    });
};
const $19e5e9ef880dfbce$export$a00cd3c213413389 = ({ source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow })=>{
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $42omo.useContext)($19e5e9ef880dfbce$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const data = (0, $42omo.useMemo)(()=>({
            source: source,
            attributes: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow
            }
        }), [
        source,
        sharedFeaturesInstrumentationId,
        parentSharedFeaturesInstrumentationId,
        isInSmartCreateFlow
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: data,
        children: /*#__PURE__*/ (0, $l998X.jsx)($19e5e9ef880dfbce$export$5ae3634fdb64882c.Provider, {
            value: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)($19e5e9ef880dfbce$export$1aefd27d2ed3c1c9, {
                mode: mode,
                children: children
            })
        })
    });
};
const $19e5e9ef880dfbce$export$ab8aa3dfd687f012 = ()=>{
    return (0, $42omo.useContext)($19e5e9ef880dfbce$var$AnalyticsPropertiesContext);
};
module.exports["SharedFeaturesInstrumentationIdContext"] = $19e5e9ef880dfbce$export$5ae3634fdb64882c;
module.exports["AnalyticsContextWithSourceAndProperties"] = $19e5e9ef880dfbce$export$a00cd3c213413389;
module.exports["useAnalyticsPropertiesContext"] = $19e5e9ef880dfbce$export$ab8aa3dfd687f012;

});

parcelRegister("jA9SA", function(module, exports) {
/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */ const $eb66f40a0f078927$export$8cffc8b2c93affd4 = {
    agentCreatorType: 'agentCreatorType',
    agentId: 'agentId',
    agentVisibility: 'agentVisibility',
    agentExternalConfigReference: 'agentExternalConfigReference',
    agentActions: 'agentActions',
    agentIsDefault: 'agentIsDefault',
    agentIsVerified: 'agentIsVerified',
    conversationChannelId: 'conversationChannelId',
    experienceId: 'experienceId',
    fullScreen: 'fullScreen',
    mode: 'mode',
    product: 'product',
    productHeader: 'productHeader',
    singleInstrumentationID: 'singleInstrumentationID',
    sharedFeaturesInstrumentationId: 'sharedFeaturesInstrumentationId'
};
module.exports["AI_MATE_ATTRIBUTES"] = $eb66f40a0f078927$export$8cffc8b2c93affd4;

});

parcelRegister("bQGO7", function(module, exports) {

var $3pfAb = parcelRequire("3pfAb");

const $7940b633dc028a3e$export$85183a312807388d = (0, $3pfAb.FabricChannel).aiMate;
var $7940b633dc028a3e$export$406073150b1a408 = /*#__PURE__*/ function(AUTOSUGGEST_SOURCE) {
    AUTOSUGGEST_SOURCE["ROVO_CHAT"] = "rovo-chat";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC"] = "confluence-aifc";
    return AUTOSUGGEST_SOURCE;
}({});
module.exports["ANALYTICS_CHANNEL"] = $7940b633dc028a3e$export$85183a312807388d;
module.exports["AUTOSUGGEST_SOURCE"] = $7940b633dc028a3e$export$406073150b1a408;

});

parcelRegister("lUZCl", function(module, exports) {

var $ffCOo = parcelRequire("ffCOo");


var $iN5LM = parcelRequire("iN5LM");

const $ee6ebd3561b1c806$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return (0, $iN5LM.ALLOWED_AI_MATE_SOURCES).includes(x.source);
};
const $ee6ebd3561b1c806$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let contextsThatHaveAttributes = context.filter((x)=>$ee6ebd3561b1c806$var$isSourceAndAttributes(x) || x[0, $ffCOo.AI_MATE_CONTEXT]);
    return contextsThatHaveAttributes.reduce((acc, x)=>{
        return {
            ...acc,
            ...x[0, $ffCOo.AI_MATE_CONTEXT]?.attributes ?? {},
            ...x.attributes ?? {}
        };
    }, {});
};
module.exports["getAttributesFromContexts"] = $ee6ebd3561b1c806$export$d97c97ed77ff09e8;

});

parcelRegister("iN5LM", function(module, exports) {
const $79e4722581e5fb43$export$e31e24b63b7085fd = [
    'AIMate',
    'smart-create',
    'CSMAI',
    'CSMAIEmbed',
    'rovoServiceAgent'
];
module.exports["ALLOWED_AI_MATE_SOURCES"] = $79e4722581e5fb43$export$e31e24b63b7085fd;

});

parcelRegister("dDAsV", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $jaPWl = parcelRequire("jaPWl");

const $accffb80f429232b$export$bdbe5e70ac4420b8 = async ({ variables: variables, fetchPolicy: fetchPolicy })=>{
    const promotedSpacesLimit = variables && variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables && variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables && variables.promotedSpaceKey || '';
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        variables: variables || {},
        fetchPolicy: fetchPolicy,
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        }
    });
    return {
        data: result.data
    };
};
module.exports["experimentalPromotedSpacesQuery"] = $accffb80f429232b$export$bdbe5e70ac4420b8;

});

parcelRegister("iS5Ay", function(module, exports) {

var $4HDYO = parcelRequire("4HDYO");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $4HDYO.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("b8pRY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cSCao = parcelRequire("cSCao");

const $a873bb1c9107ef25$export$8432db7340d3c5cd = ({ onClick: onClick, isLoading: isLoading, source: source, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSCao.AISmartCreateSpotlight), {
        onClick: onClick,
        offset: [
            0,
            16
        ],
        placement: "left-end",
        source: source,
        isLoading: isLoading
    }, children);
};
module.exports["UniversalCreateWithRovoSpotlight"] = $a873bb1c9107ef25$export$8432db7340d3c5cd;

});

parcelRegister("cSCao", function(module, exports) {
/* AISmartCreateSpotlight.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $gj7hi = parcelRequire("gj7hi");


var $fT2ta = parcelRequire("fT2ta");


var $caX7N = parcelRequire("caX7N");


var $iXCQx = parcelRequire("iXCQx");


var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fdtRy = parcelRequire("fdtRy");

var $fNcP1 = parcelRequire("fNcP1");

var $8tIbq = parcelRequire("8tIbq");


var $lsxnT = parcelRequire("lsxnT");


var $9wGTI = parcelRequire("9wGTI");


var $bPDOf = parcelRequire("bPDOf");


var $ivb8S = parcelRequire("ivb8S");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $kkssp = parcelRequire("kkssp");


var $9zecR = parcelRequire("9zecR");


var $evORK = parcelRequire("evORK");

const $fc0094d2feaf8930$var$styles = {
    image: "_1bsbaq3k _4t3ihcro _bfhkdaj9"
};
const $fc0094d2feaf8930$var$i18n = (0, $cgtv4.defineMessages)({
    smartCreateTitle: {
        id: "onboarding-ai-first-create.nudge.smart-create-with-ai.title",
        defaultMessage: "Start work faster with Rovo"
    },
    smartCreateDescription: {
        id: "onboarding-ai-first-create.nudge.smart-create-with-ai.description",
        defaultMessage: "Let Rovo draft the doc or whiteboard you need to get started fast."
    },
    smartCreateCTA: {
        id: "onboarding-ai-first-create.nudge.smart-create-with-ai.cta",
        defaultMessage: "Try it now"
    }
});
const $fc0094d2feaf8930$export$21865c28a29cfa2f = ({ children: children, onClick: onClick, source: source, isLoading: isLoading, offset: offset = [
    0,
    2
], placement: placement = 'left-start' })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $42omo.useState)(false);
    const handleSpotlightStart = (0, $42omo.useCallback)(()=>{
        setOnboardingState([
            {
                key: (0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS).hasSeenAIFCSpotlight,
                value: 'true'
            }
        ]);
        setIsSpotlightActive(true);
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'AISmartCreateSpotlight',
                attributes: {
                    source: source
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        setOnboardingState,
        source
    ]);
    const handleSpotlightStop = ()=>{
        setIsSpotlightActive(false);
    };
    const choreographer = useChoreographer('AISmartCreateSpotlight', {
        start: handleSpotlightStart,
        stop: handleSpotlightStop
    });
    const { isAIFCOnbardingEligible: isChangboardingEligible, loading: isChangboardingEligibleLoading, error: isChangboardingEligibleError } = (0, $evORK.useIsAIFCOnbardingEligible)();
    const { data: onboardingStateData, loading: isOnboardingStateLoading, error: isOnboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        ...Object.values((0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS))
    ], !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled'));
    const { hasSeenAIFCSpotlight: hasSeenAIFCSpotlight } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const handleSpotlightInteraction = (0, $42omo.useCallback)((e)=>{
        onClick?.(e);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'AISmartCreateSpotlightCTA',
                source: source
            }
        }).fire();
        choreographer.stopMessage();
    }, [
        choreographer,
        createAnalyticsEvent,
        onClick,
        source
    ]);
    const handleOnClick = (0, $42omo.useCallback)((e)=>{
        handleSpotlightInteraction(e);
    }, [
        handleSpotlightInteraction
    ]);
    const handleOnDismiss = (0, $42omo.useCallback)(()=>{
        setIsSpotlightActive(false);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'AISmartCreateSpotlightDismiss',
                source: source
            }
        }).fire();
        choreographer.stopMessage();
    }, [
        choreographer,
        createAnalyticsEvent,
        source
    ]);
    const getLocalOverrideValue = (0, $42omo.useCallback)(()=>{
        try {
            if ((0, $17wUi.confluenceSessionStorageInstance).getItem((0, $1UApO.keys).AIFC_CREATE_SPOTLIGHT_SESSION_KEY)) return true;
        } catch  {
            return false;
        }
        return false;
    }, []);
    (0, $42omo.useEffect)(()=>{
        const localOverride = getLocalOverrideValue();
        const loadingComplete = !isLoading && !isChangboardingEligibleLoading && !isChangboardingEligibleError && !isOnboardingStateLoading && !isOnboardingStateError;
        if (loadingComplete && isChangboardingEligible && !hasSeenAIFCSpotlight) choreographer.startMessage();
        else if (localOverride) {
            handleSpotlightStart();
            (0, $17wUi.confluenceSessionStorageInstance).removeItem((0, $1UApO.keys).AIFC_CREATE_SPOTLIGHT_SESSION_KEY);
        }
    }, [
        choreographer,
        hasSeenAIFCSpotlight,
        isLoading,
        isChangboardingEligible,
        isChangboardingEligibleError,
        isChangboardingEligibleLoading,
        isOnboardingStateError,
        isOnboardingStateLoading,
        getLocalOverrideValue,
        handleSpotlightStart
    ]);
    const CreateWithRovoSpotlightMedia = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $fc0094d2feaf8930$var$styles.image
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($9zecR))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($kkssp))),
            width: 295,
            height: 135,
            alt: ""
        }));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8tIbq.UNSAFE_UpdateOnChange), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caX7N.default), {
        zIndex: 600
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        dismiss: handleOnDismiss,
        isVisible: isSpotlightActive,
        placement: placement,
        offset: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        entranceDirection: placement === 'right-end' ? 'right' : 'left'
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
            testId: "ai-smart-create-spotlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage($fc0094d2feaf8930$var$i18n.smartCreateTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, CreateWithRovoSpotlightMedia), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($fc0094d2feaf8930$var$i18n.smartCreateDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
            onClick: (e)=>handleOnClick(e)
        }, formatMessage($fc0094d2feaf8930$var$i18n.smartCreateCTA))))))))));
};
module.exports["AISmartCreateSpotlight"] = $fc0094d2feaf8930$export$21865c28a29cfa2f;

});

parcelRegister("8tIbq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hTKp4 = parcelRequire("hTKp4");


var $2MPqq = parcelRequire("2MPqq");

const $50e1434d8c6bc030$var$defaultOptions = {
    childList: true,
    subtree: true
};
const $50e1434d8c6bc030$export$6a6a5d23d75b0f62 = ({ selectors: selectors = [
    'body'
], options: options = $50e1434d8c6bc030$var$defaultOptions })=>{
    const { popoverContent: popoverContent } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const { update: update } = popoverContent;
    (0, $42omo.useEffect)(()=>{
        if (!update || selectors.length === 0) return;
        const doc = (0, $hTKp4.getDocument)();
        if (!doc) return;
        const elements = new Set();
        selectors.forEach((selector)=>{
            const element = doc.querySelector(selector);
            if (!element) return;
            elements.add(element);
        });
        if (elements.size === 0) return;
        const observers = [];
        elements.forEach((element)=>{
            const observer = new MutationObserver((mutations)=>{
                if (mutations.length === 0) return;
                update();
            });
            observer.observe(element, options);
            observers.push(observer);
        });
        return ()=>{
            observers.forEach((observer)=>observer.disconnect());
        };
    }, [
        selectors,
        options,
        update
    ]);
    return null;
};
module.exports["UNSAFE_UpdateOnChange"] = $50e1434d8c6bc030$export$6a6a5d23d75b0f62;

});

parcelRegister("kkssp", function(module, exports) {
module.exports = new URL("CreateWithRovoSpotlightAnimationDark.886221cf.gif", import.meta.url).toString();

});

parcelRegister("9zecR", function(module, exports) {
module.exports = new URL("CreateWithRovoSpotlightAnimationLight.1a1df728.gif", import.meta.url).toString();

});

parcelRegister("cbBHq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lvOsp = parcelRequire("lvOsp");


var $9wGTI = parcelRequire("9wGTI");


var $2PxwR = parcelRequire("2PxwR");


var $5Cllo = parcelRequire("5Cllo");

const $0b3da77a55c8d66c$export$47d6a944ca09299 = ()=>{
    const [preloadSmartCreationModalQuery] = (0, $lvOsp.useLazyQueryInterop)(/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ (0, $5Cllo.ConfluenceSmartCreationModalQuery));
    return (0, $42omo.useCallback)(()=>{
        if ((0, $9wGTI.fg)('aifc_create_enabled')) {
            preloadSmartCreationModalQuery();
            (0, $2PxwR.LazyConfluenceSmartCreationModal).preload();
        }
    }, [
        preloadSmartCreationModalQuery
    ]);
};
module.exports["usePreloadSmartCreationModal"] = $0b3da77a55c8d66c$export$47d6a944ca09299;

});

parcelRegister("2PxwR", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c156286aa1d634b0$export$116ded32e65c3603 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4mwBk",
    name: "LazyConfluenceSmartCreationModal",
    loader: async ()=>(await (parcelRequire("4e8vd"))).ConfluenceSmartCreationModal
});
module.exports["LazyConfluenceSmartCreationModal"] = $c156286aa1d634b0$export$116ded32e65c3603;

});

parcelRegister("4e8vd", function(module, exports) {

let $313f10a56b23a128$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $313f10a56b23a128$var$load("8yMMu"),
    $313f10a56b23a128$var$load("jryxA"),
    $313f10a56b23a128$var$load("dWZbK"),
    $313f10a56b23a128$var$load("kUbUu"),
    $313f10a56b23a128$var$load("h3ABO"),
    $313f10a56b23a128$var$load("bGCo4"),
    $313f10a56b23a128$var$load("55ckW"),
    $313f10a56b23a128$var$load("iqTGf"),
    $313f10a56b23a128$var$load("cUIaj"),
    $313f10a56b23a128$var$load("76iIp"),
    $313f10a56b23a128$var$load("az9CK"),
    $313f10a56b23a128$var$load("2YffH"),
    $313f10a56b23a128$var$load("bK1V3"),
    $313f10a56b23a128$var$load("hgSi1"),
    $313f10a56b23a128$var$load("k3OeJ"),
    $313f10a56b23a128$var$load("b0QMY"),
    $313f10a56b23a128$var$load("fGTig"),
    $313f10a56b23a128$var$load("R7cS6"),
    $313f10a56b23a128$var$load("fJtJG"),
    $313f10a56b23a128$var$load("lhRZW"),
    $313f10a56b23a128$var$load("d63le"),
    $313f10a56b23a128$var$load("l8GL7"),
    $313f10a56b23a128$var$load("gVbhn"),
    $313f10a56b23a128$var$load("dmXVq"),
    $313f10a56b23a128$var$load("dsd0q"),
    $313f10a56b23a128$var$load("cyGuT"),
    $313f10a56b23a128$var$load("k6h1Q"),
    $313f10a56b23a128$var$load("lz6Bt"),
    $313f10a56b23a128$var$load("9XYQ9"),
    $313f10a56b23a128$var$load("3EXzu"),
    $313f10a56b23a128$var$load("jMj86"),
    $313f10a56b23a128$var$load("b2FtX"),
    $313f10a56b23a128$var$load("cJpD7"),
    $313f10a56b23a128$var$load("ht6hk"),
    $313f10a56b23a128$var$load("h9rdz"),
    $313f10a56b23a128$var$load("3w411"),
    $313f10a56b23a128$var$load("eY3St"),
    $313f10a56b23a128$var$load("bkd4T"),
    $313f10a56b23a128$var$load("atfX6"),
    $313f10a56b23a128$var$load("8xx1l"),
    $313f10a56b23a128$var$load("855o0"),
    $313f10a56b23a128$var$load("8MfZE"),
    $313f10a56b23a128$var$load("6wr18"),
    $313f10a56b23a128$var$load("kjZZD"),
    $313f10a56b23a128$var$load("ht5OT"),
    $313f10a56b23a128$var$load("sj9Xz"),
    $313f10a56b23a128$var$load("Wowvf"),
    $313f10a56b23a128$var$load("6nDfv"),
    $313f10a56b23a128$var$load("ffEVr"),
    $313f10a56b23a128$var$load("hhss7"),
    $313f10a56b23a128$var$load("hGfPD"),
    $313f10a56b23a128$var$load("7Gmjr"),
    $313f10a56b23a128$var$load("6u1hm"),
    $313f10a56b23a128$var$load("5seoL"),
    $313f10a56b23a128$var$load("izUd1"),
    $313f10a56b23a128$var$load("iqKwT"),
    $313f10a56b23a128$var$load("k0nPy"),
    $313f10a56b23a128$var$load("bgHzk"),
    $313f10a56b23a128$var$load("7EorR"),
    $313f10a56b23a128$var$load("fQKYr")
]).then(()=>parcelRequire('6CLTo'));

});

parcelRegister("5Cllo", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $282624469d1d8eb2$export$4f9d75f33ae603ea = (0, $eSUdr.gql)`query ConfluenceSmartCreationModalQuery{user:confluence_atlassianUser(current:true){id title}}`;
module.exports["ConfluenceSmartCreationModalQuery"] = $282624469d1d8eb2$export$4f9d75f33ae603ea;

});

parcelRegister("85eZj", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cOrQJ = parcelRequire("cOrQJ");


var $6mKj3 = parcelRequire("6mKj3");

const $6fbba8ca34a359ae$export$4c7f2883fc9f8d51 = '#FCA700';
const $6fbba8ca34a359ae$export$33063ab650a21729 = '#6A9A23';
const $6fbba8ca34a359ae$export$10e476bac9ec0ef5 = '#1868DB';
const $6fbba8ca34a359ae$export$df75671260772505 = '#AF59E0';
const $6fbba8ca34a359ae$export$e09051f7939a7d45 = '#FCA700';
const $6fbba8ca34a359ae$export$7754a3784fa3cc3f = '#82B536';
const $6fbba8ca34a359ae$export$9bbdafe829e411b8 = '#357DE8';
const $6fbba8ca34a359ae$export$6401c517c949fb36 = '#BF63F3';
const $6fbba8ca34a359ae$var$svgStrokeAnimation = null;
const $6fbba8ca34a359ae$var$styles = {
    svg: "_kqswstnw _lswu1j28 _mam9yfq0",
    container: "_kqswh2mm _p5tjidpf _3fei1j2e _10r8kb7n"
};
const $6fbba8ca34a359ae$var$rectProps = {
    line1: {
        dashMultiplier: 0,
        light: $6fbba8ca34a359ae$export$4c7f2883fc9f8d51,
        dark: $6fbba8ca34a359ae$export$e09051f7939a7d45
    },
    line2: {
        dashMultiplier: 0.66,
        light: $6fbba8ca34a359ae$export$33063ab650a21729,
        dark: $6fbba8ca34a359ae$export$7754a3784fa3cc3f
    },
    line3: {
        dashMultiplier: 0.46,
        light: $6fbba8ca34a359ae$export$10e476bac9ec0ef5,
        dark: $6fbba8ca34a359ae$export$9bbdafe829e411b8
    },
    line4: {
        dashMultiplier: 0.2,
        light: $6fbba8ca34a359ae$export$df75671260772505,
        dark: $6fbba8ca34a359ae$export$6401c517c949fb36
    }
};
const $6fbba8ca34a359ae$export$3bfefaa89ceb40fc = (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { children: children, borderRadius: t1 } = t0;
    const borderRadius = t1 === undefined ? true : t1;
    const ref = (0, $42omo.useRef)(null);
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const theme = colorMode === "dark" ? "dark" : "light";
    const [perimeter, setPerimeter] = (0, $42omo.useState)(0);
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            const rect = ref?.current?.getBoundingClientRect();
            const height = rect?.height || 0;
            const width = rect?.width || 0;
            setPerimeter(height * 2 + width * 2);
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[2] !== perimeter) {
        t4 = (key)=>{
            const multiplier = $6fbba8ca34a359ae$var$rectProps[key].dashMultiplier;
            const dashArrayLength = Math.round(multiplier * perimeter);
            return multiplier === 0 ? 0 : `${dashArrayLength} ${perimeter - dashArrayLength}`;
        };
        $[2] = perimeter;
        $[3] = t4;
    } else t4 = $[3];
    const calculateDashArray = t4;
    if (!(0, $6mKj3.expValEquals)("cc_fd_aifc_copy_change_experiment", "isEnabled", true)) return children;
    let t5;
    if ($[4] !== perimeter) {
        t5 = {
            "--stroke-perimeter": perimeter
        };
        $[4] = perimeter;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $gMc0m.default)([
            $6fbba8ca34a359ae$var$styles.container
        ]);
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== borderRadius || $[8] !== calculateDashArray || $[9] !== theme) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, Object.keys($6fbba8ca34a359ae$var$rectProps).map((key_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
                key: key_0
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
                height: "100%",
                width: "100%",
                xmlns: "http://www.w3.org/2000/svg",
                className: (0, $gMc0m.default)([
                    $6fbba8ca34a359ae$var$styles.svg
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
                "data-testid": key_0,
                strokeDasharray: calculateDashArray(key_0),
                rx: borderRadius ? "4" : "0",
                ry: borderRadius ? "4" : "0",
                x: "1",
                y: "1",
                height: "94%",
                width: "99%",
                stroke: $6fbba8ca34a359ae$var$rectProps[key_0][theme],
                strokeWidth: "var(--ds-space-025, 2px)"
            })))));
        $[7] = borderRadius;
        $[8] = calculateDashArray;
        $[9] = theme;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== children) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children);
        $[11] = children;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== t5 || $[14] !== t7 || $[15] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: ref,
            style: t5,
            className: t6
        }, t7, t8);
        $[13] = t5;
        $[14] = t7;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
};
module.exports["AnimatedGradientBorder"] = $6fbba8ca34a359ae$export$3bfefaa89ceb40fc;

});

parcelRegister("3fbYy", function(module, exports) {

let $25cc0fecc83d7c1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $25cc0fecc83d7c1e$var$load("8xx1l"),
    $25cc0fecc83d7c1e$var$load("k0nPy"),
    $25cc0fecc83d7c1e$var$load("djhXV"),
    $25cc0fecc83d7c1e$var$load("kFEyO"),
    $25cc0fecc83d7c1e$var$load("k3OeJ"),
    $25cc0fecc83d7c1e$var$load("hhss7"),
    $25cc0fecc83d7c1e$var$load("6u1hm"),
    $25cc0fecc83d7c1e$var$load("9ftJe"),
    $25cc0fecc83d7c1e$var$load("7EorR"),
    $25cc0fecc83d7c1e$var$load("3fgvt")
]).then(()=>parcelRequire('dAcK0'));

});

parcelRegister("6D86p", function(module, exports) {

let $4d3cab8eaa846955$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4d3cab8eaa846955$var$load("8HgfY"),
    $4d3cab8eaa846955$var$load("8xx1l"),
    $4d3cab8eaa846955$var$load("5seoL"),
    $4d3cab8eaa846955$var$load("izUd1"),
    $4d3cab8eaa846955$var$load("k0nPy"),
    $4d3cab8eaa846955$var$load("6wr18"),
    $4d3cab8eaa846955$var$load("4KTzp"),
    $4d3cab8eaa846955$var$load("e1fGs"),
    $4d3cab8eaa846955$var$load("3VpLA"),
    $4d3cab8eaa846955$var$load("djhXV"),
    $4d3cab8eaa846955$var$load("kFEyO"),
    $4d3cab8eaa846955$var$load("k3OeJ"),
    $4d3cab8eaa846955$var$load("hhss7"),
    $4d3cab8eaa846955$var$load("ffEVr"),
    $4d3cab8eaa846955$var$load("6u1hm"),
    $4d3cab8eaa846955$var$load("9ftJe"),
    $4d3cab8eaa846955$var$load("7EorR"),
    $4d3cab8eaa846955$var$load("4XUbE")
]).then(()=>parcelRequire('7aarm'));

});

parcelRegister("eTign", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $5RBJ9 = parcelRequire("5RBJ9");

var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");


var $jmjWc = parcelRequire("jmjWc");


var $94z7g = parcelRequire("94z7g");


var $aQZ08 = parcelRequire("aQZ08");

const $65cf0976c45402f8$var$i18n = (0, $cgtv4.defineMessages)({
    gaSpotlightBody: {
        id: "create-blank-fabric-page.global-create.ga-spotlight-body",
        defaultMessage: "Create a whiteboard at any time using this button."
    },
    gaSpotlightCloseButton: {
        id: "create-blank-fabric-page.global-create.ga-spotlight-close",
        defaultMessage: "Okay"
    },
    spotlightBody: {
        id: "create-blank-fabric-page.global-create.spotlight-body",
        defaultMessage: "Create whiteboards from wherever you are in Confluence, whenever inspiration strikes."
    },
    spotlightCloseButton: {
        id: "create-blank-fabric-page.global-create.spotlight-close",
        defaultMessage: "Got it"
    }
});
const $65cf0976c45402f8$export$6965f847afddc834 = (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { isGA: isGA, isUniversalCreate: t1, spotlightEnabled: spotlightEnabled, onSpotlightClose: onSpotlightClose } = t0;
    const isUniversalCreate = t1 === undefined ? false : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== isGA || $[2] !== onSpotlightClose) {
        t2 = ()=>{
            onSpotlightClose();
            if (isGA) createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "closeWhiteboardGAOnboardingSpotlight",
                    source: "globalCreateSpotlight"
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isGA;
        $[2] = onSpotlightClose;
        $[3] = t2;
    } else t2 = $[3];
    const onClose = t2;
    let t3;
    let t4;
    if ($[4] !== createAnalyticsEvent || $[5] !== isGA || $[6] !== spotlightEnabled) {
        t3 = ()=>{
            if (spotlightEnabled && isGA) createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "globalCreateWBSpotlightScreen",
                    attributes: {
                        boardType: "ga-onboarding"
                    },
                    source: "globalNavigation"
                }
            }).fire();
        };
        t4 = [
            createAnalyticsEvent,
            isGA,
            spotlightEnabled
        ];
        $[4] = createAnalyticsEvent;
        $[5] = isGA;
        $[6] = spotlightEnabled;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== isUniversalCreate) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: "nav-create-whiteboard-onboarding"
        }, isUniversalCreate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $94z7g.UniversalCreate), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aQZ08.GlobalCreateContentPopover), null));
        $[9] = isUniversalCreate;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== formatMessage || $[12] !== isGA || $[13] !== onClose || $[14] !== spotlightEnabled) {
        t6 = spotlightEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5RBJ9.default), {
            dialogWidth: 287,
            targetRadius: 3,
            actions: [
                {
                    onClick: onClose,
                    text: formatMessage(isGA ? $65cf0976c45402f8$var$i18n.gaSpotlightCloseButton : $65cf0976c45402f8$var$i18n.spotlightCloseButton)
                }
            ],
            target: "nav-create-whiteboard-onboarding",
            key: "nav-create-whiteboard-onboarding"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), isGA ? $65cf0976c45402f8$var$i18n.gaSpotlightBody : $65cf0976c45402f8$var$i18n.spotlightBody));
        $[11] = formatMessage;
        $[12] = isGA;
        $[13] = onClose;
        $[14] = spotlightEnabled;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, t6);
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== t5 || $[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t5, t7);
        $[18] = t5;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
};

const $65cf0976c45402f8$export$57112b45afa4aad9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3ZtCp",
    name: "GlobalCreateContentPopoverSpotlightLoader",
    loader: async ()=>(await module.exports).GlobalCreateContentPopoverSpotlight
});
module.exports["GlobalCreateContentPopoverSpotlight"] = $65cf0976c45402f8$export$6965f847afddc834;
module.exports["GlobalCreateContentPopoverSpotlightLoader"] = $65cf0976c45402f8$export$57112b45afa4aad9;

});

parcelRegister("aQZ08", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $lGgRw = parcelRequire("lGgRw");


var $inPa6 = parcelRequire("inPa6");


var $5izcQ = parcelRequire("5izcQ");


var $jmjWc = parcelRequire("jmjWc");


var $56QzY = parcelRequire("56QzY");


var $7zgzO = parcelRequire("7zgzO");


var $de2j9 = parcelRequire("de2j9");


var $ep3mz = parcelRequire("ep3mz");


var $gz8ZY = parcelRequire("gz8ZY");


var $7EIq6 = parcelRequire("7EIq6");


var $gsXbX = parcelRequire("gsXbX");

const $dc1ea4817175b6dd$export$e961788b96f97626 = ()=>{
    const $ = (0, $frIzR.c)(19);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== isNav4Enabled || $[2] !== isOnEditRoute || $[3] !== isOpen || $[4] !== match?.name) {
        t0 = ()=>{
            setIsOpen(!isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "globalCreateContentPopover",
                    source: "globalNavigation",
                    attributes: {
                        selectedItemPageContext: match?.name,
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: isNav4Enabled ? "4" : "3",
                        navdexPointType: (0, $56QzY.START),
                        isOnEditRoute: isOnEditRoute
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isNav4Enabled;
        $[2] = isOnEditRoute;
        $[3] = isOpen;
        $[4] = match?.name;
        $[5] = t0;
    } else t0 = $[5];
    const onClick = t0;
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled, isCreateBlogEnabled: isCreateBlogEnabled, isCreateLiveDocEnabled: isCreateLiveDocEnabled, isCreateDatabaseEnabled: isCreateDatabaseEnabled, isCreateSmartLinkEnabled: isCreateSmartLinkEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    let t1;
    if ($[6] !== isCreateBlogEnabled || $[7] !== isCreateDatabaseEnabled || $[8] !== isCreateLiveDocEnabled || $[9] !== isCreateSmartLinkEnabled || $[10] !== isCreateWhiteboardEnabled) {
        t1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($dc1ea4817175b6dd$var$GlobalCreateContentPopoverMenuLoader, {
                closePopup: ()=>setIsOpen(false),
                isCreateBlogEnabled: isCreateBlogEnabled,
                isCreateLiveDocEnabled: isCreateLiveDocEnabled,
                isCreateWhiteboardEnabled: isCreateWhiteboardEnabled,
                isCreateDatabaseEnabled: isCreateDatabaseEnabled,
                isCreateSmartLinkEnabled: isCreateSmartLinkEnabled
            });
        $[6] = isCreateBlogEnabled;
        $[7] = isCreateDatabaseEnabled;
        $[8] = isCreateLiveDocEnabled;
        $[9] = isCreateSmartLinkEnabled;
        $[10] = isCreateWhiteboardEnabled;
        $[11] = t1;
    } else t1 = $[11];
    const popupContent = t1;
    let t2;
    if ($[12] !== onClick) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
                name: "space-types-changeboarding-target"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gsXbX.GlobalCreateContentButton), {
                onClick: onClick,
                triggerProps: triggerProps
            })));
        $[12] = onClick;
        $[13] = t2;
    } else t2 = $[13];
    const popupTrigger = t2;
    let t3;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsOpen(false);
        $[14] = t3;
    } else t3 = $[14];
    let t4;
    if ($[15] !== isOpen || $[16] !== popupContent || $[17] !== popupTrigger) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: t3,
            placement: "bottom-start",
            content: popupContent,
            trigger: popupTrigger,
            testId: "create-content-popover",
            shouldRenderToParent: true
        });
        $[15] = isOpen;
        $[16] = popupContent;
        $[17] = popupTrigger;
        $[18] = t4;
    } else t4 = $[18];
    return t4;
};

const $dc1ea4817175b6dd$var$GlobalCreateContentPopoverMenuLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "5t0g-",
    name: "GlobalCreateContentPopoverMenuLoader",
    loader: async ()=>(await (parcelRequire("3KvoG"))).GlobalCreateContentPopoverMenu
});
module.exports["GlobalCreateContentPopover"] = $dc1ea4817175b6dd$export$e961788b96f97626;

});

parcelRegister("3KvoG", function(module, exports) {

let $2bae05c3726d12bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2bae05c3726d12bd$var$load("6wr18"),
    $2bae05c3726d12bd$var$load("7QQL7"),
    $2bae05c3726d12bd$var$load("aDPqY"),
    $2bae05c3726d12bd$var$load("ffEVr"),
    $2bae05c3726d12bd$var$load("7EorR"),
    $2bae05c3726d12bd$var$load("jryxA"),
    $2bae05c3726d12bd$var$load("dWZbK"),
    $2bae05c3726d12bd$var$load("dwffN")
]).then(()=>parcelRequire('bvmt1'));

});

parcelRegister("jqe2L", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $jiJCD = parcelRequire("jiJCD");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $9wGTI = parcelRequire("9wGTI");

const $350735cb5bb3c1ba$var$isCreateBlankPageInFabricEnabled = ()=>{
    return (0, $9wGTI.fg)('confluence_frontend_fabric_editor_blank_page') || (0, $9wGTI.fg)('confluence_frontend_fabric_editor_all_pages');
};
const $350735cb5bb3c1ba$export$9d03777b293b05ce = ()=>{
    return $350735cb5bb3c1ba$var$isCreateBlankPageInFabricEnabled();
};
const $350735cb5bb3c1ba$export$c8780cd30055dcb8 = (parentPageResponse, creationSpaceKey)=>{
    // parent page is in the selected space
    const spaceKey = parentPageResponse?.content?.nodes?.[0]?.space?.key;
    if (spaceKey !== creationSpaceKey) return false;
    // ancestors must be of the same content Type
    const contentType = parentPageResponse?.content?.nodes?.[0]?.type;
    if (contentType !== 'page') return false;
    // parent page must not be archived
    const status = parentPageResponse?.content?.nodes?.[0]?.status;
    if (status === 'archived') return false;
    // must have create access under the parent page
    const operations = parentPageResponse?.content?.nodes?.[0]?.operations;
    const hasCreateOperation = operations && operations.find((op)=>op?.targetType === 'page' && op.operation === 'create');
    return !!hasCreateOperation;
};
const $350735cb5bb3c1ba$export$4c6171230e6eef02 = (overrideValue, defaultValue)=>{
    return {
        value: overrideValue || defaultValue,
        usedOverride: !!overrideValue
    };
};
const $350735cb5bb3c1ba$export$a0b32aef6b0d7373 = (urlToChange, params, updateEditorMode)=>{
    updateEditorMode?.('create-page');
    const urlComponents = (0, $jiJCD.parse)(urlToChange, true);
    return (0, $jiJCD.format)({
        ...urlComponents,
        // remove `search`, otherwise
        // `query` will be ignored
        search: undefined,
        query: {
            ...urlComponents.query,
            ...params
        }
    });
};
const $350735cb5bb3c1ba$export$f59f47d22cf7d84d = (url)=>{
    if (!url) throw new Error('No url for new content');
    if (url.startsWith((0, $jlIaF.CONTEXT_PATH))) return url;
    return `${0, $jlIaF.CONTEXT_PATH}${url}`;
};
const $350735cb5bb3c1ba$export$cca9db3da8f2e4f8 = ({ spaceKey: spaceKey, contentId: contentId, url: url, type: type = 'page' })=>{
    const legacyDraftRouteMatch = (0, $1NBp8.RESUME_DRAFT_LEGACY).match(url);
    const draftShareId = legacyDraftRouteMatch?.query?.draftShareId || '';
    const editV2Url = type === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        contentType: 'blog',
        spaceKey: spaceKey,
        contentId: contentId
    }, {
        query: {
            draftShareId: draftShareId
        }
    }) : (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        contentType: 'pages',
        spaceKey: spaceKey,
        contentId: contentId
    }, {
        query: {
            draftShareId: draftShareId
        }
    });
    return $350735cb5bb3c1ba$export$f59f47d22cf7d84d(editV2Url);
};
const $350735cb5bb3c1ba$export$b47a1345d675bf12 = (error, messageMatches)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some(({ message: message })=>messageMatches.some((messageMatch)=>message.includes(messageMatch)));
    return false;
};
module.exports["isCreateBlankFabricPageEnabled"] = $350735cb5bb3c1ba$export$9d03777b293b05ce;
module.exports["appendQueryParams"] = $350735cb5bb3c1ba$export$a0b32aef6b0d7373;
module.exports["processDraftUrl"] = $350735cb5bb3c1ba$export$f59f47d22cf7d84d;
module.exports["getEditPageUrl"] = $350735cb5bb3c1ba$export$cca9db3da8f2e4f8;
module.exports["graphqlErrorHasMessage"] = $350735cb5bb3c1ba$export$b47a1345d675bf12;

});

parcelRegister("iU3Bi", function(module, exports) {

let $dc303ff82bf5720a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc303ff82bf5720a$var$load("9y1Aa").then(()=>parcelRequire('dwUCw'));

});

parcelRegister("4Y2RD", function(module, exports) {

let $39defcc6f09f64ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $39defcc6f09f64ed$var$load("6wr18"),
    $39defcc6f09f64ed$var$load("ffEVr"),
    $39defcc6f09f64ed$var$load("hhss7"),
    $39defcc6f09f64ed$var$load("jBwbI")
]).then(()=>parcelRequire('aEtWp'));

});

parcelRegister("fywGr", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $6mKj3 = parcelRequire("6mKj3");


var $5cryL = parcelRequire("5cryL");


var $8Z78B = parcelRequire("8Z78B");


var $1k2r8 = parcelRequire("1k2r8");

const $7aae32df106d9977$export$864cb1c5b7b9b39 = ()=>{
    // When the centralized onboarding state experiment is enabled, use the centralized preloader
    // to ensure all onboarding state queries hit the cache.
    if ((0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) return (0, $1k2r8.preloadAllOnboardingState)();
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS))
        }
    });
};
module.exports["preloadEditorOnboardingState"] = $7aae32df106d9977$export$864cb1c5b7b9b39;

});

parcelRegister("1k2r8", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9xoMO = parcelRequire("9xoMO");


var $8Z78B = parcelRequire("8Z78B");

const $2daa64592339f2ce$export$ce5c629ae8376218 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: (0, $9xoMO.OnboardingKeysCombined)
        }
    });
};
module.exports["preloadAllOnboardingState"] = $2daa64592339f2ce$export$ce5c629ae8376218;

});

parcelRegister("7yn0t", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4ri4I = parcelRequire("4ri4I");


var $58PBI = parcelRequire("58PBI");

const $41894bf31b7b5c77$export$c6419170331da813 = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { children: children, editSource: t1 } = t0;
    const editSource = t1 === undefined ? "" : t1;
    const preloader = (0, $42omo.useContext)((0, $58PBI.EditContentButtonPreloaderContext));
    const [doPreload, setDoPreload] = (0, $42omo.useState)(false);
    const [t2, t3] = (0, $4ri4I.useEditSource)();
    const { editSource: contextEditSource } = t2;
    const { setEditSource: setEditSource } = t3;
    let t4;
    if ($[0] !== editSource || $[1] !== setEditSource) {
        t4 = ()=>{
            setEditSource(editSource);
            setDoPreload(true);
        };
        $[0] = editSource;
        $[1] = setEditSource;
        $[2] = t4;
    } else t4 = $[2];
    const onHover = t4;
    let t5;
    if ($[3] !== children || $[4] !== onHover) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: onHover,
            onFocus: onHover
        }, children);
        $[3] = children;
        $[4] = onHover;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== contextEditSource || $[7] !== doPreload || $[8] !== editSource || $[9] !== preloader) {
        t6 = editSource === contextEditSource && doPreload && preloader ? preloader({}) : null;
        $[6] = contextEditSource;
        $[7] = doPreload;
        $[8] = editSource;
        $[9] = preloader;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t5 || $[12] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t5, t6);
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
};
module.exports["CreateContentButtonPreloader"] = $41894bf31b7b5c77$export$c6419170331da813;

});

parcelRegister("58PBI", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $037500d910957a1c$var$noop = ()=>null;
const $037500d910957a1c$export$2dc50c54ef05578f = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($037500d910957a1c$var$noop);
$037500d910957a1c$export$2dc50c54ef05578f.displayName = 'EditContentButtonPreloaderContext';
module.exports["EditContentButtonPreloaderContext"] = $037500d910957a1c$export$2dc50c54ef05578f;

});

parcelRegister("7DERG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b0c65948d0a153f5$export$92e41deae5b713d0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "c07Cp",
    name: 'ConfluenceSmartCreationModalLoader',
    loader: async ()=>(await (parcelRequire("gXz7g"))).ConfluenceSmartCreationModalManager
});
module.exports["ConfluenceSmartCreationModalLoader"] = $b0c65948d0a153f5$export$92e41deae5b713d0;

});

parcelRegister("gXz7g", function(module, exports) {

let $c58d65637ab6e9ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c58d65637ab6e9ee$var$load("gs8si").then(()=>parcelRequire('iaA9H'));

});

parcelRegister("6g41Q", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $14f8b7ba4c44a126$export$5389b57fe2014013 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "grVUL",
    name: "EngagementInlineDialogLoaderNav3",
    loader: async ()=>(await (parcelRequire("kxzsd"))).EngagementInlineDialogWrapper
});

const $14f8b7ba4c44a126$export$96098f07afe80f94 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xXIQx",
    name: "EngagementInlineDialogLoader",
    loader: async ()=>(await (parcelRequire("kxzsd"))).EngagementInlineDialogWrapper
});
module.exports["EngagementInlineDialogLoaderNav3"] = $14f8b7ba4c44a126$export$5389b57fe2014013;
module.exports["EngagementInlineDialogLoader"] = $14f8b7ba4c44a126$export$96098f07afe80f94;

});

parcelRegister("kxzsd", function(module, exports) {

let $ef42642c1e85e5e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef42642c1e85e5e7$var$load("gryT8"),
    $ef42642c1e85e5e7$var$load("b8oHe")
]).then(()=>parcelRequire('1Q21q'));

});

parcelRegister("kPga6", function(module, exports) {

let $f2951b7e808f1770$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f2951b7e808f1770$var$load("6wr18"),
    $f2951b7e808f1770$var$load("kFEyO"),
    $f2951b7e808f1770$var$load("hLjS5"),
    $f2951b7e808f1770$var$load("48rvp"),
    $f2951b7e808f1770$var$load("iMSgb"),
    $f2951b7e808f1770$var$load("ffEVr"),
    $f2951b7e808f1770$var$load("7EorR"),
    $f2951b7e808f1770$var$load("hhss7"),
    $f2951b7e808f1770$var$load("dnVDi")
]).then(()=>parcelRequire('ePUmE'));

});

parcelRegister("yuV6Z", function(module, exports) {
const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>`${$378a693b2c26358e$export$ca6dda5263526f75}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("9EfFC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dOMrE = parcelRequire("dOMrE");


var $i0btU = parcelRequire("i0btU");


var $4qXXo = parcelRequire("4qXXo");


var $l2474 = parcelRequire("l2474");


var $6mYMS = parcelRequire("6mYMS");


var $3jsXx = parcelRequire("3jsXx");


var $1DWH0 = parcelRequire("1DWH0");


var $28cxD = parcelRequire("28cxD");


var $bwC67 = parcelRequire("bwC67");


var $g6YCz = parcelRequire("g6YCz");

const $893da78086ca16ac$export$7452d7062a4d0634 = 1000;
const $893da78086ca16ac$export$af8124aa496797f2 = '_|unknown|_';
class $893da78086ca16ac$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        (0, $g6YCz.mentionRenderedUfoExperience).getInstance(this.props.id).success();
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $g6YCz.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $28cxD.UFOExperienceState)['STARTED'],
            (0, $28cxD.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwC67.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            }
        }, (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, `@${message}`));
    }
    render() {
        const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { text: text, id: id, accessLevel: accessLevel, localId: localId } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${$893da78086ca16ac$export$af8124aa496797f2}`;
        const showTooltip = mentionType === (0, $6mYMS.MentionType).RESTRICTED;
        const mentionComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dOMrE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4qXXo.default), {
            mentionType: mentionType,
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            spellCheck: false,
            "data-testid": `mention-${id}`,
            "data-mention-type": mentionType,
            "data-mention-tooltip": showTooltip
        }, failedMention ? this.renderUnknownUserError(id) : text || '@...'));
        const ssrPlaceholderProp = props.ssrPlaceholderId ? {
            'data-ssr-placeholder': props.ssrPlaceholderId
        } : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g6YCz.UfoErrorBoundary), {
            id: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            id: localId,
            "data-mention-id": id,
            "data-local-id": localId,
            "data-access-level": accessLevel,
            spellCheck: false,
            ...ssrPlaceholderProp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i0btU.default), null, showTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
            fallback: mentionComponent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l2474.default), {
            name: text
        }, mentionComponent)) : mentionComponent)));
    }
    constructor(props){
        super(props);
        this.hoverTimeout = void 0;
        this.handleOnClick = (e)=>{
            const { id: id, text: text, onClick: onClick } = this.props;
            if (onClick) onClick(id, text, e);
        };
        this.handleOnMouseEnter = (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, $893da78086ca16ac$export$7452d7062a4d0634);
        };
        this.handleOnMouseLeave = (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        };
        this.getMentionType = ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted } = this.props;
            if (isHighlighted) return (0, $6mYMS.MentionType).SELF;
            if ((0, $6mYMS.isRestricted)(accessLevel)) return (0, $6mYMS.MentionType).RESTRICTED;
            return (0, $6mYMS.MentionType).DEFAULT;
        };
        (0, $g6YCz.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
}
const $893da78086ca16ac$var$MentionWithAnalytics = (0, $1DWH0.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $3jsXx.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $3jsXx.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})($893da78086ca16ac$export$92ab8442e7a15cef);
const $893da78086ca16ac$var$Mention = $893da78086ca16ac$var$MentionWithAnalytics;
var $893da78086ca16ac$export$2e2bcd8739ae039 = $893da78086ca16ac$var$Mention;
module.exports["UNKNOWN_USER_ID"] = $893da78086ca16ac$export$af8124aa496797f2;
module.exports["default"] = $893da78086ca16ac$export$2e2bcd8739ae039;

});

parcelRegister("4qXXo", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-html-button */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $6fnsQ = parcelRequire("6fnsQ");


var $6mYMS = parcelRequire("6mYMS");


var $42omo = parcelRequire("42omo");

const $1278ab3a4b348f22$var$mentionStyle = {
    [(0, $6mYMS.MentionType).SELF]: {
        background: `var(--ds-background-brand-bold, ${(0, $6fnsQ.B400)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-inverse, ${(0, $6fnsQ.N20)})`,
        hoveredBackground: `var(--ds-background-brand-bold-hovered, ${(0, $6fnsQ.B400)})`,
        pressedBackground: `var(--ds-background-brand-bold-pressed, ${(0, $6fnsQ.B400)})`
    },
    [(0, $6mYMS.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: `var(--ds-border-bold, ${(0, $6fnsQ.N500)})`,
        text: `var(--ds-text, ${(0, $6fnsQ.N500)})`,
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $6mYMS.MentionType).DEFAULT]: {
        background: `var(--ds-background-neutral, ${(0, $6fnsQ.N30A)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-subtle, ${(0, $6fnsQ.N500)})`,
        hoveredBackground: `var(--ds-background-neutral-hovered, ${(0, $6fnsQ.N30A)})`,
        pressedBackground: `var(--ds-background-neutral-pressed, ${(0, $6fnsQ.N30A)})`
    }
};
const $1278ab3a4b348f22$var$getStyle = ({ mentionType: mentionType }, property)=>{
    const obj = $1278ab3a4b348f22$var$mentionStyle[mentionType][property];
    return typeof obj === 'string' ? obj : obj;
};
const $1278ab3a4b348f22$var$PrimitiveMention = /*#__PURE__*/ (0, $42omo.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $9K4OG.css)("display:inline;border:var(--ds-border-width, 1px) solid ", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'background'), ";color:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:var(--ds-font-weight-regular, 400);word-break:break-word;&:hover{background:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground'), ";}&:active{background:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground'), ";}"),
        ...other
    });
});
var $1278ab3a4b348f22$export$2e2bcd8739ae039 = $1278ab3a4b348f22$var$PrimitiveMention;
module.exports["default"] = $1278ab3a4b348f22$export$2e2bcd8739ae039;

});

parcelRegister("g6YCz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

const $af19f55bb4052571$export$1d011e4240507c78 = new (0, $9801n.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $iqaft.ExperienceTypes).Load,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
});
class $af19f55bb4052571$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch() {
        $af19f55bb4052571$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["mentionRenderedUfoExperience"] = $af19f55bb4052571$export$1d011e4240507c78;
module.exports["UfoErrorBoundary"] = $af19f55bb4052571$export$5ef1c2550074a375;

});

parcelRegister("hezkK", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $huXH9 = parcelRequire("huXH9");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $9yt4X = parcelRequire("9yt4X");


var $4Ve7Q = parcelRequire("4Ve7Q");

const $4efd70df50f13ebd$export$2f5dfaa7873e8973 = `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`;
const $4efd70df50f13ebd$var$styles = {
    agentAvatar: "_1e0c1txw _1bah1h6o _4cvr1h6o _mkrz1k6g",
    image: "_5ral1dfr _4t3i1osq _1bsb1osq",
    avatarContentContainer: "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o"
};
const $4efd70df50f13ebd$var$stylesCompiled = {
    innerShape: "_4t3i1lk2 _1bsb1lk2 _mkrz1k6g"
};
const $4efd70df50f13ebd$export$38b71b080e1832c8 = ({ imageUrl: imageUrl, size: size = 'medium', label: label, name: name, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, showBorder: showBorder = true, isRovoDev: isRovoDev, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const imgUrl = isForgeAgent && forgeAgentIconUrl ? forgeAgentIconUrl : imageUrl;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        "aria-label": label,
        xcss: $4efd70df50f13ebd$var$styles.agentAvatar,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            height: (0, $huXH9.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            width: (0, $huXH9.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/ensure-design-token-usage
            ...showBorder ? {
                backgroundColor: '#fff'
            } : {},
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...(0, $dh538.fg)('rovo_chat_bugfix_agent_avatar_squish') ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minHeight: (0, $huXH9.AVATAR_SIZES)[size],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minWidth: (0, $huXH9.AVATAR_SIZES)[size]
            } : {}
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $4efd70df50f13ebd$var$stylesCompiled.innerShape
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $4efd70df50f13ebd$var$styles.avatarContentContainer,
                children: imgUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "img",
                    xcss: $4efd70df50f13ebd$var$styles.image,
                    src: imgUrl,
                    alt: name || label || formatMessage((0, $4Ve7Q.messages).agentAvatarLabel)
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $9yt4X.GeneratedAvatar), {
                    agentId: agentId,
                    agentNamedId: agentNamedId,
                    agentIdentityAccountId: agentIdentityAccountId,
                    isRovoDev: isRovoDev,
                    size: size
                })
            })
        })
    });
};
module.exports["AGENT_AVATAR_CLIP_PATH"] = $4efd70df50f13ebd$export$2f5dfaa7873e8973;
module.exports["AgentAvatar"] = $4efd70df50f13ebd$export$38b71b080e1832c8;

});

parcelRegister("9yt4X", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $huXH9 = parcelRequire("huXH9");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

const $087487947faf3e7f$var$styles = {
    image: "_5ral1dfr _4t3i1osq _1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o",
    banner: "_1bsb1osq",
    bannerFillSpace: "_1bsb1osq _4t3i1osq _5ral1dfr"
};
const $087487947faf3e7f$var$Observer = ({ onLoad: onLoad })=>{
    (0, $42omo.useEffect)(()=>{
        onLoad();
    }, [
        onLoad
    ]);
    return null;
};

const $087487947faf3e7f$var$AutoDevAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1Jp34")));

const $087487947faf3e7f$var$AutoFixAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iXcnT")));

const $087487947faf3e7f$var$AutoReviewAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aUp1o")));

const $087487947faf3e7f$var$BacklogBuddyAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3KJ0b")));

const $087487947faf3e7f$var$CommsCrafterAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eKuAc")));

const $087487947faf3e7f$var$CultureAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6kpkG")));

const $087487947faf3e7f$var$CustomerInsightAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1Q4wY")));

const $087487947faf3e7f$var$DecisionDirectorAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dRCU8")));

const $087487947faf3e7f$var$FeatureFlagAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kQTXK")));

const $087487947faf3e7f$var$GenericAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kFBSF")));

const $087487947faf3e7f$var$HireWriterAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("44XTS")));

const $087487947faf3e7f$var$MarketingMessageMaestroAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2SnMt")));

const $087487947faf3e7f$var$MyUserManualAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cXu7g")));

const $087487947faf3e7f$var$OkrOracleAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3EvKg")));

const $087487947faf3e7f$var$OpsAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("htmh0")));

const $087487947faf3e7f$var$PitchPerfectorAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kTVse")));

const $087487947faf3e7f$var$ProductRequirementAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("emHN5")));

const $087487947faf3e7f$var$ReleaseNotesAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9Oxg9")));

const $087487947faf3e7f$var$ResearchScoutAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("doqXm")));

const $087487947faf3e7f$var$RovoDevAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("k0SSx")));

const $087487947faf3e7f$var$SocialMediaScribeAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kVvzt")));

const $087487947faf3e7f$var$TeamConnectionAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2Hx38")));

const $087487947faf3e7f$var$WorkflowBuilderAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3v9w9")));

const $087487947faf3e7f$var$TrialGuideAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("58iCo")));

const $087487947faf3e7f$var$JsmRovoServiceAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("df4F9")));
const $087487947faf3e7f$export$cf7c9ad03f4a70b2 = {
    primary: '#FCA700',
    secondary: '#FFC716'
};
const $087487947faf3e7f$export$3e344798f7855e62 = {
    primary: '#BF63F3',
    secondary: '#D8A0F7'
};
const $087487947faf3e7f$export$a3d0897f023251ae = {
    primary: '#82B536',
    secondary: '#B3DF72'
};
const $087487947faf3e7f$export$d933daaf7b69e6ee = {
    primary: '#357DE8',
    secondary: '#669DF1'
};
const $087487947faf3e7f$var$colorList = [
    $087487947faf3e7f$export$cf7c9ad03f4a70b2,
    $087487947faf3e7f$export$3e344798f7855e62,
    $087487947faf3e7f$export$a3d0897f023251ae,
    $087487947faf3e7f$export$d933daaf7b69e6ee
];
const $087487947faf3e7f$var$avatarList = [
    $087487947faf3e7f$var$CustomerInsightAvatar,
    $087487947faf3e7f$var$BacklogBuddyAvatar,
    $087487947faf3e7f$var$DecisionDirectorAvatar,
    $087487947faf3e7f$var$CommsCrafterAvatar,
    $087487947faf3e7f$var$AutoDevAvatar,
    $087487947faf3e7f$var$OkrOracleAvatar,
    $087487947faf3e7f$var$CultureAvatar,
    $087487947faf3e7f$var$SocialMediaScribeAvatar,
    $087487947faf3e7f$var$TeamConnectionAvatar,
    $087487947faf3e7f$var$HireWriterAvatar,
    $087487947faf3e7f$var$OpsAgentAvatar,
    $087487947faf3e7f$var$ResearchScoutAvatar,
    $087487947faf3e7f$var$ReleaseNotesAvatar,
    $087487947faf3e7f$var$MyUserManualAvatar,
    $087487947faf3e7f$var$PitchPerfectorAvatar,
    $087487947faf3e7f$var$AutoDevAvatar,
    $087487947faf3e7f$var$AutoFixAvatar,
    $087487947faf3e7f$var$AutoReviewAvatar,
    $087487947faf3e7f$var$MarketingMessageMaestroAvatar,
    $087487947faf3e7f$var$FeatureFlagAvatar,
    $087487947faf3e7f$var$ProductRequirementAvatar
];
const $087487947faf3e7f$export$a834793a4d0d739e = $087487947faf3e7f$var$avatarList.length * $087487947faf3e7f$var$colorList.length;
const $087487947faf3e7f$var$outOfTheBoxAgentAvatar = {
    autodev_template_unit_test_creator: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$AutoFixAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_migration_config_changer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$OpsAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_vulnerable_dependency_updater_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$MarketingMessageMaestroAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_code_standardizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$MyUserManualAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_code_observer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$ResearchScoutAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_code_accessibility_checker_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$HireWriterAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_code_documentation_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$SocialMediaScribeAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_feature_flag_cleaner_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$FeatureFlagAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    decision_director_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$DecisionDirectorAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    user_manual_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$MyUserManualAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    product_requirements_expert_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$ProductRequirementAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    issue_organizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$BacklogBuddyAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    ops_guide_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$OpsAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    jira_workflow_builder_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$WorkflowBuilderAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.primary,
                secondaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.secondary
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    itops_rca_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$AutoReviewAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    jira_trial_guide_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$TrialGuideAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.primary,
                secondaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.secondary
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    jsm_rovo_service_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$JsmRovoServiceAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    }
}; /**
    * agentIdentityAccountId examples:
    * 5b985e7c96cb052b5f65c830
    * 712020:19e57f67-c132-462b-8503-0c19953122cd
    *
    * agentId examples:
    * cd002f25-46e4-4023-80ff-32e4d90849b4
    */ 
const $087487947faf3e7f$export$c84eb7708138dd4 = ({ agentIdentityAccountId: agentIdentityAccountId, agentId: agentId })=>{
    // we prioritise agentIdentityAccountId first if it is available
    // this is because agentIdentityAccountId is more widely available (e.g. in ProfilePage)
    const idForAgentAvatar = agentIdentityAccountId || agentId;
    if (idForAgentAvatar) {
        // Take the last 8 characters of the id because JS can't handle 16 digit numbers
        const trimmedId = idForAgentAvatar.slice(-8).replace(/[-:]/g, '');
        const parsedId = parseInt(trimmedId, 16);
        if (isNaN(parsedId)) return 0;
        else return parsedId;
    }
    return null;
};
const $087487947faf3e7f$var$ROVO_DEV_AGENT_ID = '027f0676-e8e9-4939-8962-3850987d78bb';
const $087487947faf3e7f$var$getAvatarRender = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, isRovoDev: isRovoDev, size: size })=>{
    if (isRovoDev && (0, $dh538.fg)('rovo_dev_themed_identity_card')) return {
        render: /*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$RovoDevAvatar, {
            size: (0, $huXH9.AVATAR_SIZES)[size],
            primaryColor: "",
            secondaryColor: ""
        }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    };
     //@TODO CRCS-3129: Remove Rovo Dev hardcoded icon after TeamEU demos
    // Handle Rovo Dev agent avatar for TeamEU Demo
    if (agentId === $087487947faf3e7f$var$ROVO_DEV_AGENT_ID && (0, $dh538.fg)('jira_ai_force_rovo_dev_avatar')) return {
        render: /*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$RovoDevAvatar, {
            size: (0, $huXH9.AVATAR_SIZES)[size],
            primaryColor: "",
            secondaryColor: ""
        }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    };
    if (typeof agentNamedId === 'string' && $087487947faf3e7f$var$outOfTheBoxAgentAvatar[agentNamedId]) {
        const ootbAvatarResult = $087487947faf3e7f$var$outOfTheBoxAgentAvatar[agentNamedId];
        return {
            render: ootbAvatarResult.getRender(size),
            color: ootbAvatarResult.color
        };
    }
    const numberId = $087487947faf3e7f$export$c84eb7708138dd4({
        agentIdentityAccountId: agentIdentityAccountId,
        agentId: agentId
    });
    if (numberId !== null) {
        /**
     * this create all possible combinations of avatars and colors
     * e.g. [[avatar1, color1], [avatar1, color2], [avatar2, color1], [avatar2, color2]]
     * then choose 1 based on agentId
     */ const totalCombinations = $087487947faf3e7f$var$avatarList.length * $087487947faf3e7f$var$colorList.length;
        const combinationIndex = numberId % totalCombinations;
        const avatarIndex = Math.floor(combinationIndex / $087487947faf3e7f$var$colorList.length);
        const colorIndex = combinationIndex % $087487947faf3e7f$var$colorList.length;
        const Avatar = $087487947faf3e7f$var$avatarList[avatarIndex];
        const color = $087487947faf3e7f$var$colorList[colorIndex];
        return {
            render: /*#__PURE__*/ (0, $l998X.jsx)(Avatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: color.primary,
                secondaryColor: color.secondary
            }),
            color: color
        };
    }
    return {
        render: /*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$GenericAvatar, {
            size: (0, $huXH9.AVATAR_SIZES)[size],
            primaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.primary,
            secondaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.secondary
        }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    };
};
const $087487947faf3e7f$export$6efaefb8ad2fba40 = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, isRovoDev: isRovoDev, height: height, fillSpace: fillSpace })=>{
    const { color: color } = $087487947faf3e7f$var$getAvatarRender({
        agentNamedId: agentNamedId,
        agentId: agentId,
        agentIdentityAccountId: agentIdentityAccountId,
        isRovoDev: isRovoDev,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($087487947faf3e7f$var$styles.banner, fillSpace ? $087487947faf3e7f$var$styles.bannerFillSpace : undefined),
        style: {
            backgroundColor: color.primary,
            height: height ? `${height}px` : undefined
        }
    });
};
const $087487947faf3e7f$export$96bb253b7de22616 = (props)=>{
    const { render: render, color: color } = $087487947faf3e7f$var$getAvatarRender(props);
    const { onLoad: onLoad } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $087487947faf3e7f$var$styles.image,
        style: {
            backgroundColor: color.primary
        },
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Suspense), {
            fallback: null,
            children: [
                onLoad && /*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$Observer, {
                    onLoad: onLoad
                }),
                render
            ]
        })
    });
};
module.exports["AgentBanner"] = $087487947faf3e7f$export$6efaefb8ad2fba40;
module.exports["GeneratedAvatar"] = $087487947faf3e7f$export$96bb253b7de22616;

});

parcelRegister("1Jp34", function(module, exports) {

let $142d6c869fc93f1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $142d6c869fc93f1c$var$load("c9Qqc").then(()=>parcelRequire('f0XYo'));

});

parcelRegister("iXcnT", function(module, exports) {

let $dcc757fb35de9e43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dcc757fb35de9e43$var$load("1TK6P").then(()=>parcelRequire('kdo1N'));

});

parcelRegister("aUp1o", function(module, exports) {

let $7f128b1159aaf0b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f128b1159aaf0b3$var$load("grvAy").then(()=>parcelRequire('1xsEe'));

});

parcelRegister("3KJ0b", function(module, exports) {

let $2bb8937090f7886d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2bb8937090f7886d$var$load("23K0q").then(()=>parcelRequire('iOx72'));

});

parcelRegister("eKuAc", function(module, exports) {

let $abcd15b4f7a895b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $abcd15b4f7a895b0$var$load("3kQkj").then(()=>parcelRequire('5yA7f'));

});

parcelRegister("6kpkG", function(module, exports) {

let $49b842e0f53b0840$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $49b842e0f53b0840$var$load("6OXgE").then(()=>parcelRequire('40gXx'));

});

parcelRegister("1Q4wY", function(module, exports) {

let $156e297d03d850f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $156e297d03d850f4$var$load("cbucA").then(()=>parcelRequire('e6WCz'));

});

parcelRegister("dRCU8", function(module, exports) {

let $a17e67305e32e080$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a17e67305e32e080$var$load("bVhr1").then(()=>parcelRequire('b4yf3'));

});

parcelRegister("kQTXK", function(module, exports) {

let $f2e41300efb7f39f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f2e41300efb7f39f$var$load("kE0QC").then(()=>parcelRequire('lRRwN'));

});

parcelRegister("kFBSF", function(module, exports) {

let $f0c5054f72bf4788$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0c5054f72bf4788$var$load("eVFXf").then(()=>parcelRequire('xXksI'));

});

parcelRegister("44XTS", function(module, exports) {

let $2f86000f50552006$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f86000f50552006$var$load("9FhBz").then(()=>parcelRequire('gHjiO'));

});

parcelRegister("2SnMt", function(module, exports) {

let $21831245fa81e40e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $21831245fa81e40e$var$load("6zB8z").then(()=>parcelRequire('9sJzD'));

});

parcelRegister("cXu7g", function(module, exports) {

let $96f25b251372ce30$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $96f25b251372ce30$var$load("eENGY").then(()=>parcelRequire('cxxnV'));

});

parcelRegister("3EvKg", function(module, exports) {

let $2a8dbb6f12744413$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a8dbb6f12744413$var$load("hmlb0").then(()=>parcelRequire('8nSrm'));

});

parcelRegister("htmh0", function(module, exports) {

let $cb866c206a5b0b04$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb866c206a5b0b04$var$load("2NGxc").then(()=>parcelRequire('hGaQU'));

});

parcelRegister("kTVse", function(module, exports) {

let $f37582f3db40c2c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f37582f3db40c2c1$var$load("bPgcq").then(()=>parcelRequire('4zXPl'));

});

parcelRegister("emHN5", function(module, exports) {

let $a75516b19f472f5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a75516b19f472f5d$var$load("31b1q").then(()=>parcelRequire('1xC4V'));

});

parcelRegister("9Oxg9", function(module, exports) {

let $725295393c538ed1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $725295393c538ed1$var$load("8Lh9U").then(()=>parcelRequire('kqZOw'));

});

parcelRegister("doqXm", function(module, exports) {

let $9c026d43c7a38bfd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9c026d43c7a38bfd$var$load("6ZzYJ").then(()=>parcelRequire('bZPun'));

});

parcelRegister("k0SSx", function(module, exports) {

let $e91e6080a2f1e543$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e91e6080a2f1e543$var$load("2zIbn").then(()=>parcelRequire('bXyC6'));

});

parcelRegister("kVvzt", function(module, exports) {

let $f3c19ee75daa2848$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3c19ee75daa2848$var$load("410SS").then(()=>parcelRequire('aY5Ef'));

});

parcelRegister("2Hx38", function(module, exports) {

let $1f793be472254651$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f793be472254651$var$load("z3s9q").then(()=>parcelRequire('9mYoH'));

});

parcelRegister("3v9w9", function(module, exports) {

let $28cba65833e09a5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $28cba65833e09a5e$var$load("9gqcE").then(()=>parcelRequire('3hbTz'));

});

parcelRegister("58iCo", function(module, exports) {

let $3bcc244b8daf70af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3bcc244b8daf70af$var$load("eipnW").then(()=>parcelRequire('3AA8L'));

});

parcelRegister("df4F9", function(module, exports) {

let $9a404af99aaca7d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9a404af99aaca7d7$var$load("jdAk9").then(()=>parcelRequire('bqzK1'));

});

parcelRegister("4Ve7Q", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $c1395595ab243cbd$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    agentAvatarLabel: {
        id: "ai-mate.agent-avatar-label",
        defaultMessage: "Agent avatar"
    }
});
module.exports["messages"] = $c1395595ab243cbd$export$defe85febe8b728c;

});

parcelRegister("d3bcC", function(module, exports) {

var $5VFXo = parcelRequire("5VFXo");


var $aXiya = parcelRequire("aXiya");


var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $jMyy4 = parcelRequire("jMyy4");


var $ij4CE = parcelRequire("ij4CE");


var $fFmJj = parcelRequire("fFmJj");


var $ep3mz = parcelRequire("ep3mz");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $18a2fd912dfb58ac$var$ContentAnalyticsViewedComments = (0, $eSUdr.default)`query useViewedCommentsQuery($contentId:ID!$contentType:ConfluenceAnalyticsCommentContentType!){contentAnalyticsViewedComments(contentId:$contentId contentType:$contentType){commentIds}}`;
// Helper function to safely convert content type for the viewed comments query
const $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments = (contentType)=>{
    // Only page, database, and whiteboard support the viewed comments query
    if (contentType === 'page' || contentType === 'database' || contentType === 'whiteboard') return contentType;
    // Fallback to page for other content types (blogpost, embed, etc.)
    return 'page';
};
// Helper to generate stable ROOT_QUERY cache key
// Ensures consistent key format regardless of object property order
const $18a2fd912dfb58ac$var$getRootQueryCacheId = (pageId, contentType)=>{
    const validContentType = $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType);
    // Sort keys to ensure stable JSON.stringify output
    const variables = {
        contentId: pageId,
        contentType: validContentType
    };
    return `$ROOT_QUERY.contentAnalyticsViewedComments(${JSON.stringify(variables)})`;
};
const $18a2fd912dfb58ac$export$cd81a9ad0848990 = ({ pageId: pageId })=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $aXiya.default)
    });
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $5VFXo.default)
    });
    // Network-only query for fresh data
    const { refetch: refetch } = (0, $jMyy4.useQueryInterop)(/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ $18a2fd912dfb58ac$var$ContentAnalyticsViewedComments, {
        skip: true,
        // Never query on render
        fetchPolicy: 'network-only',
        variables: {
            contentId: pageId,
            contentType: $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType)
        }
    });
    // Helper function to process the query result
    const processQueryResult = (0, $42omo.useCallback)((data)=>{
        const commentIds = data?.contentAnalyticsViewedComments?.commentIds ?? [];
        const viewedCommentsSet = new Set(commentIds.filter((id)=>id !== null));
        return {
            success: true,
            data: viewedCommentsSet
        };
    }, []);
    // Helper function for cache-only queries
    const executeCacheOnlyQuery = (0, $42omo.useCallback)(()=>{
        if (!pageId || !contentType) throw new Error('Page ID and content type are required');
        try {
            // Read from ROOT_QUERY (where Apollo stores query results)
            const rootQueryCacheId = $18a2fd912dfb58ac$var$getRootQueryCacheId(pageId, contentType);
            const rootQueryData = readFragmentInterop({
                id: rootQueryCacheId
            });
            if (rootQueryData) {
                // Convert fragment data to query result format
                const queryResult = {
                    contentAnalyticsViewedComments: {
                        commentIds: rootQueryData.commentIds,
                        __typename: 'ViewedComments'
                    }
                };
                return processQueryResult(queryResult);
            }
            return {
                success: false,
                error: new Error('No viewed comments data found in cache')
            };
        } catch (error) {
            // Handle cache read errors - these are local operations so we just log unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return {
                success: false,
                error: error
            };
        }
    }, [
        pageId,
        contentType,
        processQueryResult,
        readFragmentInterop
    ]);
    // Helper function for network-only queries
    const executeNetworkOnlyQuery = (0, $42omo.useCallback)(async ()=>{
        if (!pageId) throw new Error('Page ID and content type are required');
        try {
            const result = await refetch({
                contentId: pageId,
                contentType: $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType)
            });
            // Apollo automatically writes query results to ROOT_QUERY cache, so we don't need to explicitly write
            // The executeCacheOnlyQuery function will read from ROOT_QUERY directly
            return processQueryResult(result.data);
        } catch (error) {
            // Handle expected errors (403/unauthorized, network errors) - just mark as handled
            if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return {
                    success: false,
                    error: error
                };
            }
            // Handle unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return {
                success: false,
                error: error
            };
        }
    }, [
        pageId,
        contentType,
        processQueryResult,
        refetch
    ]);
    // Cached data query - uses cache-only for performance
    const getViewedCommentsCacheOnly = (0, $42omo.useCallback)(()=>{
        try {
            return executeCacheOnlyQuery();
        } catch (error) {
            return {
                success: false,
                error: error
            };
        }
    }, [
        executeCacheOnlyQuery
    ]);
    // Fresh data query - always uses network-only for latest data
    const getViewedCommentsFresh = (0, $42omo.useCallback)(()=>executeNetworkOnlyQuery(), [
        executeNetworkOnlyQuery
    ]);
    // Function to update the viewed comments cache
    // This is used for optimistic updates when comments are viewed locally
    const updateViewedCommentsCache = (0, $42omo.useCallback)((commentIds)=>{
        if (!pageId || !contentType || commentIds.length === 0) return;
        try {
            // Read from ROOT_QUERY (where Apollo stores query results)
            const rootQueryCacheId = $18a2fd912dfb58ac$var$getRootQueryCacheId(pageId, contentType);
            const rootQueryData = readFragmentInterop({
                id: rootQueryCacheId
            });
            const existingCommentIds = rootQueryData?.commentIds ?? [];
            // Merge new comment IDs with existing ones
            const existingSet = new Set(existingCommentIds.filter((id)=>id !== null));
            commentIds.forEach((id)=>existingSet.add(id));
            const mergedCommentIds = Array.from(existingSet);
            // Update ROOT_QUERY cache
            writeFragmentInterop({
                fragmentId: rootQueryCacheId,
                data: {
                    commentIds: mergedCommentIds,
                    __typename: 'ViewedComments'
                }
            });
        } catch (error) {
            // Handle cache writing errors - these are local operations so we just log unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        pageId,
        contentType,
        readFragmentInterop,
        writeFragmentInterop
    ]);
    return {
        getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
        getViewedCommentsFresh: getViewedCommentsFresh,
        updateViewedCommentsCache: updateViewedCommentsCache
    };
};
module.exports["useViewedComments"] = $18a2fd912dfb58ac$export$cd81a9ad0848990;

});

parcelRegister("5VFXo", function(module, exports) {
/**
 * @generated SignedSource<<d7ff2c3ce2ccb5f9937eae905c203b17>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a1027eddc6949c38$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewedComments_read",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "commentIds"
        }
    ],
    "type": "ViewedComments"
};
$a1027eddc6949c38$var$node.hash = "8133cc01831582777d2e0911570e19eb";
var $a1027eddc6949c38$export$2e2bcd8739ae039 = $a1027eddc6949c38$var$node;
module.exports["default"] = $a1027eddc6949c38$export$2e2bcd8739ae039;

});

parcelRegister("aXiya", function(module, exports) {
/**
 * @generated SignedSource<<4105699bb3b57f32cd10410da7fded55>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7e3d4a4e06abb15d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewedComments_write",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "commentIds"
        }
    ],
    "type": "ViewedComments"
};
$7e3d4a4e06abb15d$var$node.hash = "d155cf7774eeec1efd57aa640539aef9";
var $7e3d4a4e06abb15d$export$2e2bcd8739ae039 = $7e3d4a4e06abb15d$var$node;
module.exports["default"] = $7e3d4a4e06abb15d$export$2e2bcd8739ae039;

});

parcelRegister("ij2FZ", function(module, exports) {
const $d70a1b66183cdb12$export$d0e832101df0ac96 = 'com.atlassian.rovo.skill';
const $d70a1b66183cdb12$export$d4f002c79ea2ad20 = 'skill';
const $d70a1b66183cdb12$export$e4d0b30afd49f7df = 'skillTag';
const $d70a1b66183cdb12$export$18f911e214c46d8 = /\/([a-zA-Z0-9-]+)/g;
const $d70a1b66183cdb12$export$aae1b80712c1b67b = `${$d70a1b66183cdb12$export$d4f002c79ea2ad20}:${$d70a1b66183cdb12$export$e4d0b30afd49f7df}`;
const $d70a1b66183cdb12$export$b22d8560058c60e1 = (extensionType, extensionKey)=>{
    return extensionType === $d70a1b66183cdb12$export$d0e832101df0ac96 && extensionKey === $d70a1b66183cdb12$export$aae1b80712c1b67b;
};
module.exports["ROVO_SKILL_EXTENSION_TYPE"] = $d70a1b66183cdb12$export$d0e832101df0ac96;
module.exports["ROVO_SKILL_EXTENSION_KEY"] = $d70a1b66183cdb12$export$d4f002c79ea2ad20;
module.exports["ROVO_SKILL_TAG_PATTERN"] = $d70a1b66183cdb12$export$18f911e214c46d8;
module.exports["ROVO_SKILL_COMBINED_EXTENSION_KEY"] = $d70a1b66183cdb12$export$aae1b80712c1b67b;
module.exports["isSkillTagExtension"] = $d70a1b66183cdb12$export$b22d8560058c60e1;

});

parcelRegister("lpRYt", function(module, exports) {

var $2Yzoe = parcelRequire("2Yzoe");


var $csam1 = parcelRequire("csam1");


var $aRZzN = parcelRequire("aRZzN");


var $42JDa = parcelRequire("42JDa");


var $5SAOw = parcelRequire("5SAOw");


var $dh538 = parcelRequire("dh538");


var $aFrN0 = parcelRequire("aFrN0");


var $kVuPa = parcelRequire("kVuPa");


var $kbmYM = parcelRequire("kbmYM");


var $6RXI6 = parcelRequire("6RXI6");


var $3Jbpl = parcelRequire("3Jbpl");


var $j0P3F = parcelRequire("j0P3F");


var $dSj2z = parcelRequire("dSj2z");


var $1Ce64 = parcelRequire("1Ce64");


var $5XYXq = parcelRequire("5XYXq");


var $7ai6d = parcelRequire("7ai6d");


var $bCKHR = parcelRequire("bCKHR");

class $2d26328991932579$export$614853bf2169db97 extends (0, $aRZzN.MarkdownTransformer) {
    parse(content) {
        const node = this.parser.parse(content);
        if (!node) return new (0, $5SAOw.Node)();
        return node;
    }
    constructor(schema, pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, isNonAgentMessage){
        super();
        this.parser = void 0;
        const md = (0, (/*@__PURE__*/$parcel$interopDefault($2Yzoe)))('zero', {
            html: false
        });
        md.enable([
            // Process html entity - &#123;, &#xAF;, &quot;, ...
            'entity',
            // Process escaped chars and hardbreaks
            'escape',
            'newline'
        ]);
        (0, $bCKHR.enableSchemaPlugins)(md, schema);
        // enable modified version of linkify plugin
        // @see https://product-fabric.atlassian.net/browse/ED-3097
        md.use((0, $6RXI6.createLinkifyPlugin)(pluginConfig.linkify));
        md.use((0, $aFrN0.default));
        if ((0, $dh538.fg)('rovo_enable_data_sculptor')) md.use((0, $kVuPa.default));
        md.use((0, $kbmYM.default));
        md.use((0, $5XYXq.default));
        // Convert links with Linking Platform supported URLs to Smart Links
        if (!streaming && (schema.nodes.inlineCard || schema.nodes.blockCard || schema.nodes.embedCard)) // this is where we should separate it into its own plugin called createSmartLinksPluginRefresh
        md.use((0, $dSj2z.createSmartLinksPlugin)(pluginConfig.smartLinks, isExperimentEnabled, shouldShowAsInline, isNonAgentMessage));
        // Convert links matching people directory URLs to mentions
        if (schema.nodes.mention) md.use((0, $j0P3F.default));
        // Table support
        if (schema.nodes.table) {
            md.use((0, $csam1.markdownItTable));
            if ((0, $dh538.fg)('rovo_chat_enable_markdown_table_break_tags')) md.use((0, $1Ce64.default));
        }
        // Image support
        if (schema.nodes.media && schema.nodes.mediaSingle) md.use((0, $3Jbpl.default));
        const filter = (0, $bCKHR.filterSchemaMapping)(schema, (0, $7ai6d.mdToPmSchema));
        this.parser = new (0, $42JDa.MarkdownParser)(schema, md, filter);
    }
}
module.exports["AiMateMarkdownTransformer"] = $2d26328991932579$export$614853bf2169db97;

});

parcelRegister("aFrN0", function(module, exports) {
$parcel$export(module.exports, "default", () => $eedc127a683be258$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

const $eedc127a683be258$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ const $eedc127a683be258$var$citation = (state)=>{
    const tokens = [];
    // TODO: Remove the next two lines when rovo_chat_simplify_citation_logic enabled and cleaned up
    const citationIndexMap = {};
    let currentIndex = 1;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $eedc127a683be258$var$CITATION_REGEX.test(childToken.content)) {
                /**
					 * Example content: `Hello [^1^][^1^].`
					 * `parts` will be ['Hello ', '1', '', '1', '.']
					 */ const parts = childToken.content.split($eedc127a683be258$var$CITATION_REGEX);
                const newChildren = [];
                /**
					 * we want to remove consecutive citation
					 * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
					 * should be transformed to `Hello 1. How are you 1 2`
					 */ let lastCitation = null;
                let isLastCitationDuplicate = false;
                // only want to add space in the next part after citation
                // if the last citation is valid
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        // this is a text part
                        /**
							 * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
							 * So it doesn't end up rendering empty space that will end up with multi empty spaces
							 * because previous valid citation already added 1 empty space
							 *
							 * Example: For `[^1^][^1^]`
							 * it will be split into parts: ['', '1', '', '1', ''],
							 * This code will skip any rendering for the last empty string (index=4)
							 * Because the empty string at index=2 already added 1 empty space from the code below
							 */ if (isLastCitationDuplicate && part.trim() === '') return;
                        if (part.trim() !== '') /**
								 * if the text part is not an empty string, we want to reset the last citation
								 * because the text part is a valid text, and not a space between citations
								 * so that we can render citation again, even if the next number is the same as the last number
								 *
								 * Example:
								 * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
								 */ lastCitation = null;
                        const textToken = new state.Token('text', '', 0);
                        if (index === parts.length - 1) textToken.content = part;
                        else textToken.content = part + ' ';
                        textToken.block = false;
                        textToken.level = childToken.level;
                        newChildren.push(textToken);
                    } else {
                        // this is a citation part
                        // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                        if (part === lastCitation) {
                            isLastCitationDuplicate = true;
                            return;
                        } else {
                            // always reset the duplicate flag
                            isLastCitationDuplicate = false;
                            lastCitation = part;
                        }
                        const citationToken = new state.Token('status', '', 0);
                        citationToken.content = '';
                        citationToken.block = false;
                        citationToken.level = childToken.level;
                        let citationText = part;
                        if (!(0, $dh538.fg)('rovo_chat_simplify_citation_logic')) {
                            citationText = citationIndexMap[part] ? citationIndexMap[part].toString() : currentIndex.toString();
                            if (!citationIndexMap[part]) {
                                citationIndexMap[part] = currentIndex;
                                currentIndex++;
                            }
                        }
                        citationToken.attrs = [
                            [
                                'color',
                                'blue'
                            ],
                            [
                                'text',
                                citationText
                            ],
                            // localId is used to identify the citation token in the DOM
                            // this overrides the uuid that is normally used
                            [
                                'localId',
                                `citation-${citationText}`
                            ]
                        ];
                        citationToken.content = citationText;
                        newChildren.push(citationToken);
                    }
                });
                tokenChildren.push(...newChildren);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $eedc127a683be258$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('citation', $eedc127a683be258$var$citation);

});

parcelRegister("kVuPa", function(module, exports) {
$parcel$export(module.exports, "default", () => $85f34bd2edc9da4d$export$2e2bcd8739ae039);
const $85f34bd2edc9da4d$var$SCULPTOR_REGEX = /\[\^(sculptor)\^\]/;
const $85f34bd2edc9da4d$var$dataSculptor = (state)=>{
    const tokens = [];
    let sculptorCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $85f34bd2edc9da4d$var$SCULPTOR_REGEX.test(childToken.content)) {
                const citationToken = new state.Token('status', '', 0);
                citationToken.content = '';
                citationToken.block = false;
                citationToken.level = childToken.level;
                const parts = childToken.content.split($85f34bd2edc9da4d$var$SCULPTOR_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        citationToken.attrs = [
                            [
                                'localId',
                                'data-sculptor-' + sculptorCounter
                            ],
                            [
                                'text',
                                'data-sculptor-' + sculptorCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(citationToken);
                        sculptorCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $85f34bd2edc9da4d$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('data-sculptor', $85f34bd2edc9da4d$var$dataSculptor);

});

parcelRegister("kbmYM", function(module, exports) {
const $8d6eacbf9e066d7e$var$EXPAND_REGEX = /\[\^(expand)\^\]/;
const $8d6eacbf9e066d7e$var$expandable = (state)=>{
    const tokens = [];
    let expandCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children?.length === 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $8d6eacbf9e066d7e$var$EXPAND_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($8d6eacbf9e066d7e$var$EXPAND_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        const expandToken = new state.Token('status', '', 0);
                        expandToken.content = '';
                        expandToken.block = false;
                        expandToken.level = childToken.level;
                        expandToken.attrs = [
                            [
                                'localId',
                                'expandable-' + expandCounter
                            ],
                            [
                                'text',
                                'expandable-' + expandCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(expandToken);
                        expandCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
const $8d6eacbf9e066d7e$var$mdPluginExpandable = (md)=>{
    md.core.ruler.push('expandable', $8d6eacbf9e066d7e$var$expandable);
};
var $8d6eacbf9e066d7e$export$2e2bcd8739ae039 = $8d6eacbf9e066d7e$var$mdPluginExpandable;
module.exports["default"] = $8d6eacbf9e066d7e$export$2e2bcd8739ae039;

});

parcelRegister("6RXI6", function(module, exports) {

var $2Gb84 = parcelRequire("2Gb84");


var $81OAa = parcelRequire("81OAa");

// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
const $146b6bae45423f24$var$arrayReplaceAt = (src, pos, newElements)=>{
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $146b6bae45423f24$var$isLinkOpen = (str)=>{
    return /^<a[>\s]/i.test(str);
};
const $146b6bae45423f24$var$isLinkClose = (str)=>{
    return /^<\/a\s*>/i.test(str);
};
const $146b6bae45423f24$export$8cd7d1ec2e6808da = ({ findFilepaths: findFilepaths, isLinkInMatches: isLinkInMatches })=>(state)=>{
        const blockTokens = state.tokens;
        const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($2Gb84)))();
        for(let j = 0, l = blockTokens.length; j < l; j++){
            if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
            let tokens = blockTokens[j].children;
            let htmlLinkLevel = 0;
            // We scan from the end, to keep position when new tags added.
            // Use reversed logic in links start/end match
            for(let i = tokens.length - 1; i >= 0; i--){
                const currentToken = tokens[i];
                // Skip content of markdown links
                if (currentToken.type === 'link_close') {
                    i--;
                    while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                    continue;
                }
                // Skip content of html tag links
                if (currentToken.type === 'html_inline') {
                    if ($146b6bae45423f24$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                    if ($146b6bae45423f24$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
                }
                if (htmlLinkLevel > 0) continue;
                if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                    const text = currentToken.content;
                    let links = (0, $81OAa.linkifyMatch)(text);
                    if (!links.length) links = linkify.match(text) || [];
                    // Now split string to nodes
                    const nodes = [];
                    let level = currentToken.level;
                    let lastPos = 0;
                    const filepaths = findFilepaths(text);
                    for(let ln = 0; ln < links.length; ln++){
                        if (isLinkInMatches(links[ln].index, filepaths)) continue;
                        const { url: url } = links[ln];
                        const fullUrl = state.md.normalizeLink(url);
                        if (!state.md.validateLink(fullUrl)) continue;
                        let urlText = links[ln].text;
                        // Linkifier might send raw hostnames like "example.com", where url
                        // starts with domain name. So we prepend http:// in those cases,
                        // and remove it afterwards.
                        //
                        if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                        else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                        else urlText = state.md.normalizeLinkText(urlText);
                        const pos = links[ln].index;
                        if (pos > lastPos) {
                            const token = new state.Token('text', '', 0);
                            token.content = text.slice(lastPos, pos);
                            token.level = level;
                            nodes.push(token);
                        }
                        let token = new state.Token('link_open', 'a', 1);
                        token.attrs = [
                            [
                                'href',
                                fullUrl
                            ]
                        ];
                        token.level = level++;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        token = new state.Token('text', '', 0);
                        token.content = urlText;
                        token.level = level;
                        nodes.push(token);
                        token = new state.Token('link_close', 'a', -1);
                        token.level = --level;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        lastPos = links[ln].lastIndex;
                    }
                    if (lastPos < text.length) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos);
                        token.level = level;
                        nodes.push(token);
                    }
                    // replace current node
                    blockTokens[j].children = tokens = $146b6bae45423f24$var$arrayReplaceAt(tokens, i, nodes);
                }
            }
        }
    };
const $146b6bae45423f24$export$763ac077c9998026 = (params)=>(md)=>md.core.ruler.push('custom-linkify', $146b6bae45423f24$export$8cd7d1ec2e6808da(params));
module.exports["createLinkifyPlugin"] = $146b6bae45423f24$export$763ac077c9998026;

});

parcelRegister("3Jbpl", function(module, exports) {
$parcel$export(module.exports, "default", () => $536a5df99342df46$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

function $536a5df99342df46$var$createRule() {
    // Match any images that aren't inside single backticks
    const mdImageRegex = RegExp("(?<!`)!\\[[^\\]]*\\]\\([^\\)]+\\)(?!`)", "g");
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open'
    ];
    return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        // Track the difference between original array indices and accumulated tokens indices
        // This is needed because when we skip processed tokens, the indices diverge
        let indexOffset = 0;
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && mdImageRegex.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                // Loop backwards through the tokens until a valid parent token is found
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                // If the previous token is not a valid parent token, add it to the start of the opening tokens array
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                // Create closing tokens for each opening token and reverse the array
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                const matches = token.content.match(mdImageRegex);
                // Process all images in the inline token
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substring(0, start);
                    inlineContentStack = inlineContentStack.substring(start + match.length);
                    // Add the inline tokens and media tokens to the subtree
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                // If there is any remaining content in the stack, add the inline tokens to the subtree
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                if ((0, $dh538.fg)('rovo_chat_markdown_renderer_image_processing_fix')) {
                    // Adjust cursor to account for previously skipped/modified tokens
                    const adjustedCursor = cursor - indexOffset;
                    tokens = [
                        ...tokens.slice(0, adjustedCursor),
                        ...subTree
                    ];
                    // Update offset: we consumed (i - cursor + 1) original tokens and added subTree.length
                    indexOffset += i + 1 - cursor - subTree.length;
                } else tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) {
                // Ignore token if it's already processed
                processedTokens.splice(processedTokens.indexOf(token.type), 1);
                // We skipped a token, so the offset increases
                indexOffset++;
            } else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
var $536a5df99342df46$export$2e2bcd8739ae039 = (md)=>{
    md.core.ruler.before('inline', 'media', $536a5df99342df46$var$createRule());
};

});

parcelRegister("j0P3F", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab169cc784e6afd4$export$2e2bcd8739ae039);
// Regex test is based on what's documented here:
// https://hello.atlassian.net/wiki/spaces/I/pages/1124693006/AAID+Format
const $ab169cc784e6afd4$var$isPeopleLink = (url)=>{
    return /^\/people\/[a-zA-Z0-9_\|\-\:]{1,128}$/g.test(url);
};
const $ab169cc784e6afd4$var$getAccountId = (url)=>{
    const match = url.match(/\/people\/([a-zA-Z0-9_\|\-\:]{1,128})/);
    return match ? match[1] : null;
};
const $ab169cc784e6afd4$var$mentionLinks = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        // We're only looking for inline children
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken, i)=>{
            const url = childToken.attrGet('href') ?? '';
            const discardedToken = [
                'link_close',
                'text'
            ].includes(childToken.type) && [
                tokenChildren[i - 1]?.type,
                tokenChildren[i - 2]?.type
            ].includes('mention');
            // Discarded tokens are preserved as `null` so index
            // cross-referencing between processed and raw tokens may
            // be preserved, however null are filtered out later.
            if (discardedToken) {
                tokenChildren.push(null);
                return;
            }
            if (childToken.type === 'link_open' && $ab169cc784e6afd4$var$isPeopleLink(url)) {
                const mentionText = token.children?.[i + 1]?.content ?? '';
                let mentionToken = new state.Token('mention', '', 0);
                mentionToken.content = '';
                mentionToken.block = false;
                mentionToken.level = childToken.level;
                mentionToken.attrSet('id', `${$ab169cc784e6afd4$var$getAccountId(url)}`);
                if (mentionText) mentionToken.attrSet('text', `@${mentionText}`);
                tokenChildren.push(mentionToken);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $ab169cc784e6afd4$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('mention', $ab169cc784e6afd4$var$mentionLinks);

});

parcelRegister("dSj2z", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $gEMk1 = parcelRequire("gEMk1");

const $d5cccf701aceb868$var$linkPatternStart = '\\bhttps?:\\/\\/(?:www\\.)?';
const $d5cccf701aceb868$var$linkPatternEnd = '[^\\s\\]\\)]*';
// If we want to re-introduce canva support, please use the regex from this
// PR which was made redundant: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/135407/commits/0fcf626f035396cfcb87153a4d8d4721c844b07a#platform%2Fpackages%2Fai-mate%2Fconversation-assistant%2Fsrc%2Fcommon%2Futils%2Fcontent-transformer%2Fmd-tokenizer%2Fmd-plugin-smartlink%2Findex.ts
// Right now the support is dropped in favour of supporting what the Canva Agent needs.
// It's likely first-class Enhanced Smart links  (e.g `(my canva link "smartCard-embed")[http://some.canva.link]`
// will be how we support this in the future
const $d5cccf701aceb868$var$linkRegex = {
    youtube: `${$d5cccf701aceb868$var$linkPatternStart}youtube\\.com${$d5cccf701aceb868$var$linkPatternEnd}`,
    youtubeShortUrl: `${$d5cccf701aceb868$var$linkPatternStart}youtu\\.be${$d5cccf701aceb868$var$linkPatternEnd}`,
    loomVideo: `${$d5cccf701aceb868$var$linkPatternStart}loom\\.com\\/share\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    figmaFile: `${$d5cccf701aceb868$var$linkPatternStart}figma\\.com\\/(file|design)\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    confluenceWhiteboard: `${$d5cccf701aceb868$var$linkPatternStart}.*\\/wiki\\/spaces\\/.*\\/whiteboard\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    googlePresentationAndSpreadsheet: `${$d5cccf701aceb868$var$linkPatternStart}docs\\.google\\.com\\/(presentation|spreadsheets)\\/d\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    googleDoc: `${$d5cccf701aceb868$var$linkPatternStart}docs\\.google\\.com\\/(document)\\/d\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    googleForm: `${$d5cccf701aceb868$var$linkPatternStart}docs\\.google\\.com\\/forms\\/d\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    microsoftForm: `${$d5cccf701aceb868$var$linkPatternStart}forms\\.office\\.com\\/Pages\\/ResponsePage\\.aspx\\?id\\=${$d5cccf701aceb868$var$linkPatternEnd}`,
    // this will be removed following project
    analyticsChart: `\\bhttps://[^.]+\\.(atlassian\\.net|jira-dev\\.com)/analytics/[^/]+/chart-${$d5cccf701aceb868$var$linkPatternEnd}` // this will be removed following project
};
const $d5cccf701aceb868$var$supportedEmbedProviders = Object.values($d5cccf701aceb868$var$linkRegex).join('|');
const $d5cccf701aceb868$var$embedRegex = new RegExp($d5cccf701aceb868$var$supportedEmbedProviders, 'g');
const $d5cccf701aceb868$var$embedInlineRegex = [
    // avpRovoSkillsChart
    `${$d5cccf701aceb868$var$linkPatternStart}avp-rovo-skills\\.[-\\w]+.frontend.public.atl-paas.net/v1/chart[^\\s\\)]+${$d5cccf701aceb868$var$linkPatternEnd}`
];
const $d5cccf701aceb868$var$avpChartsRegex = `${$d5cccf701aceb868$var$linkPatternStart}.*?\\/avpviz\\/c\\/[^\\/]+.*${$d5cccf701aceb868$var$linkPatternEnd}`;
/**
 * Checks if there is more than one link in the token stream.
 * Used to determine if all links should be rendered inline instead of as embeds.
 */ const $d5cccf701aceb868$var$hasMultipleLinks = (tokens)=>{
    let linkCount = 0;
    for (const token of tokens){
        if (token.type !== 'inline' || !token.children) continue;
        for (const childToken of token.children)if (childToken?.type === 'link_open') {
            linkCount++;
            if (linkCount > 1) return true; // Early exit once we find more than one
        }
    }
    return false;
};
const $d5cccf701aceb868$var$createSmartLinks = ({ regexStorage: regexStorage, isNonAgentMessage: isNonAgentMessage, isExperimentEnabled: isExperimentEnabled })=>(state)=>{
        const tokens = [];
        const embedTokens = [];
        let embedMatches = [];
        let filteredTokens = [];
        // process each token to determine if the link should be converted to a smartlink
        for (const token of state.tokens){
            let processedTokenChildren = [];
            const regexMatchesRaw = token.content?.trim().match($d5cccf701aceb868$var$embedRegex);
            const regexMatches = regexMatchesRaw ? Array.from(new Set(regexMatchesRaw)) : [];
            embedMatches = [
                ...embedMatches,
                ...regexMatches
            ];
            // Any block or embed Smart Card links will be in an "inline" token. If
            // the current token is anything other than "inline", or there's no child tokens
            // to process, then we add it to the list of tokens to keep and move forward
            if (token.type !== 'inline' || !token.children) {
                tokens.push(token);
                continue;
            }
            var outputToken = new state.Token('inline', '', 0);
            let tokensToAppend = [
                outputToken
            ];
            if (token.children) {
                let discardUntilIndex = -1;
                token.children.forEach((childToken, i)=>{
                    const discardedToken = i <= discardUntilIndex && [
                        'link_close',
                        'text'
                    ].includes(childToken.type);
                    if (discardedToken) return;
                    const url = childToken.attrGet('href') ?? '';
                    const isInlineLink = url === token.children?.[i + 1]?.content;
                    if (childToken?.type === 'link_open' && ((0, $gEMk1.isSupportedByLinkingPlatform)(url, regexStorage) || isInlineLink)) {
                        // Discard the next two tokens. We're now processing the opening node for a URL
                        // that will result in a new node that replaces it, therefore the subsequent link content and
                        // closing node are no longer needed
                        discardUntilIndex = i + 2;
                        // Check if this link should be rendered as an embed card inline (e.g., Loom, YouTube, Figma) at end of result
                        const matchesEmbedRegex = url.match($d5cccf701aceb868$var$embedRegex);
                        if (matchesEmbedRegex && !embedMatches.includes(url)) embedMatches.push(url);
                        const shouldRenderAvpRovoSkillsEmbedInline = token.level <= 1 && $d5cccf701aceb868$var$embedInlineRegex.some((r)=>url.match(r));
                        const shouldRenderAvpChartsEmbedInline = token.level <= 1 && url.match($d5cccf701aceb868$var$avpChartsRegex) && (0, $dh538.fg)('ai_mate_unfurl_avp_charts');
                        const shouldRenderAvpEmbedInline = shouldRenderAvpRovoSkillsEmbedInline || shouldRenderAvpChartsEmbedInline;
                        if (shouldRenderAvpEmbedInline) {
                            outputToken.children = processedTokenChildren;
                            tokensToAppend.push(new state.Token('paragraph_close', '', 0));
                            processedTokenChildren = [];
                            let embedToken = new state.Token('embedCard', '', 0);
                            embedToken.content = '';
                            embedToken.block = true;
                            embedToken.attrSet('url', url);
                            embedToken.attrSet('layout', 'center');
                            tokensToAppend.push(embedToken);
                            tokensToAppend.push(new state.Token('paragraph_open', '', 0));
                            outputToken = new state.Token('inline', '', 0);
                            tokensToAppend.push(outputToken);
                            return;
                        }
                        // create an inline card for the links that don't qualify
                        let cardToken = new state.Token('inlineCard', '', 0);
                        cardToken.content = '';
                        cardToken.block = false;
                        cardToken.level = childToken.level;
                        cardToken.attrSet('url', url);
                        processedTokenChildren.push(cardToken);
                        return;
                    }
                    // pushes non link tokens as is
                    processedTokenChildren.push(childToken);
                });
            }
            // set processed children to the output token
            outputToken.children = processedTokenChildren;
            // Keeps inline tokens that have children and all non-inline tokens.
            const blockTokensWithContent = tokensToAppend.filter((t)=>t.type !== 'inline' || t.children?.length);
            tokens.push(...blockTokensWithContent);
        }
        // Remove empty paragraphs otherwise add it to the filteredTokens
        for(let i = 0; i < tokens.length; i++)if (i < tokens.length - 1 && tokens[i].type === 'paragraph_open' && tokens[i + 1].type === 'paragraph_close') i = i + 1;
        else filteredTokens.push(tokens[i]);
        // Render all embeds at the end of the results if it is an agent message
        if (embedMatches?.length && !isNonAgentMessage && !isExperimentEnabled?.('rovo_chat_smartlink_embedcard_improvements', true)) // Default behavior: render all embeds at the end
        [
            ...new Set(embedMatches)
        ].forEach((match)=>{
            let embedToken = new state.Token('embedCard', '', 0);
            embedToken.content = '';
            embedToken.block = true;
            embedToken.attrSet('url', match);
            embedToken.attrSet('layout', 'center');
            embedTokens.push(embedToken);
        });
        state.tokens = [
            ...filteredTokens,
            ...embedTokens
        ];
        return;
    };
const $d5cccf701aceb868$var$createSmartLinksRefresh = ({ regexStorage: regexStorage, isExperimentEnabled: isExperimentEnabled, shouldShowAsInline: shouldShowAsInline })=>(state)=>{
        const tokens = [];
        const embedTokens = [];
        let embedMatches = [];
        let filteredTokens = [];
        const renderedInlineEmbeds = new Set();
        // If there are more than one link or the user opened the chat in mini modal, all links display inline
        const forceAllToInline = $d5cccf701aceb868$var$hasMultipleLinks(state.tokens) || shouldShowAsInline;
        // process each token to determine if the link should be converted to a smartlink
        for (const token of state.tokens){
            let processedTokenChildren = [];
            const regexMatchesRaw = token.content?.trim().match($d5cccf701aceb868$var$embedRegex);
            const regexMatches = regexMatchesRaw ? Array.from(new Set(regexMatchesRaw)) : [];
            embedMatches = [
                ...embedMatches,
                ...regexMatches
            ];
            // Any block or embed Smart Card links will be in an "inline" token. If
            // the current token is anything other than "inline", or there's no child tokens
            // to process, then we add it to the list of tokens to keep and move forward
            if (token.type !== 'inline' || !token.children) {
                tokens.push(token);
                continue;
            }
            var outputToken = new state.Token('inline', '', 0);
            let tokensToAppend = [
                outputToken
            ];
            if (token.children) {
                let discardUntilIndex = -1;
                token.children.forEach((childToken, i)=>{
                    const discardedToken = i <= discardUntilIndex && [
                        'link_close',
                        'text'
                    ].includes(childToken.type);
                    if (discardedToken) return;
                    const url = childToken.attrGet('href') ?? '';
                    const isInlineLink = url === token.children?.[i + 1]?.content;
                    if (childToken?.type === 'link_open' && ((0, $gEMk1.isSupportedByLinkingPlatform)(url, regexStorage) || isInlineLink)) {
                        // Discard the next two tokens. We're now processing the opening node for a URL
                        // that will result in a new node that replaces it, therefore the subsequent link content and
                        // closing node are no longer needed
                        discardUntilIndex = i + 2;
                        // Check if this link should be rendered as an embed card inline (e.g., Loom, YouTube, Figma) at end of result
                        const matchesEmbedRegex = url.match($d5cccf701aceb868$var$embedRegex);
                        if (matchesEmbedRegex && !embedMatches.includes(url)) embedMatches.push(url);
                        // handle condition for when link in the token content matches the linkRegex
                        const shouldRenderLinksAsEmbed = matchesEmbedRegex;
                        const shouldRenderAvpRovoSkillsEmbedInline = token.level <= 1 && $d5cccf701aceb868$var$embedInlineRegex.some((r)=>url.match(r));
                        const shouldRenderAvpChartsEmbedInline = token.level <= 1 && url.match($d5cccf701aceb868$var$avpChartsRegex) && (0, $dh538.fg)('ai_mate_unfurl_avp_charts');
                        const shouldRenderAvpEmbedInline = shouldRenderAvpRovoSkillsEmbedInline || shouldRenderAvpChartsEmbedInline;
                        // Render inline embed if either regex matches and token content is not part of a list
                        const shouldRenderEmbedInline = shouldRenderLinksAsEmbed && token.level <= 1;
                        if (shouldRenderAvpEmbedInline || shouldRenderLinksAsEmbed && isExperimentEnabled?.('rovo_chat_smartlink_embedcard_improvements', true)) {
                            // handle case if it is an analytic chart link or microsoft form link
                            // these should be rendered as inline cards, not embed cards
                            const isMicrosoftFormLink = new RegExp($d5cccf701aceb868$var$linkRegex.microsoftForm).test(url);
                            const isAnalyticsChartLink = new RegExp($d5cccf701aceb868$var$linkRegex.analyticsChart).test(url);
                            if (!forceAllToInline && shouldRenderEmbedInline && !isMicrosoftFormLink && !isAnalyticsChartLink || shouldRenderAvpEmbedInline) {
                                outputToken.children = processedTokenChildren;
                                tokensToAppend.push(new state.Token('paragraph_close', '', 0));
                                processedTokenChildren = [];
                                let embedToken = new state.Token('embedCard', '', 0);
                                embedToken.content = '';
                                embedToken.block = true;
                                embedToken.attrSet('url', url);
                                embedToken.attrSet('layout', 'center');
                                tokensToAppend.push(embedToken);
                                tokensToAppend.push(new state.Token('paragraph_open', '', 0));
                                outputToken = new state.Token('inline', '', 0);
                                tokensToAppend.push(outputToken);
                                // Track that we've rendered this URL as an inline embed
                                renderedInlineEmbeds.add(url);
                                return;
                            }
                        }
                        // create an inline card for the links that don't qualify
                        let cardToken = new state.Token('inlineCard', '', 0);
                        cardToken.content = '';
                        cardToken.block = false;
                        cardToken.level = childToken.level;
                        cardToken.attrSet('url', url);
                        processedTokenChildren.push(cardToken);
                        return;
                    }
                    // pushes non link tokens as is
                    processedTokenChildren.push(childToken);
                });
            }
            // set processed children to the output token
            outputToken.children = processedTokenChildren;
            // Keeps inline tokens that have children and all non-inline tokens.
            const blockTokensWithContent = tokensToAppend.filter((t)=>t.type !== 'inline' || t.children?.length);
            tokens.push(...blockTokensWithContent);
        }
        // Remove empty paragraphs otherwise add it to the filteredTokens
        for(let i = 0; i < tokens.length; i++)if (i < tokens.length - 1 && tokens[i].type === 'paragraph_open' && tokens[i + 1].type === 'paragraph_close') i = i + 1;
        else filteredTokens.push(tokens[i]);
        state.tokens = [
            ...filteredTokens,
            ...embedTokens
        ];
        return;
    };
const $d5cccf701aceb868$export$9625a798761643ac = (params, isExperimentEnabled, shouldShowAsInline, isNonAgentMessage)=>(md)=>md.core.ruler.push('inlineCard', isExperimentEnabled?.('rovo_chat_smartlink_embedcard_improvements', false) ? $d5cccf701aceb868$var$createSmartLinksRefresh({
            ...params,
            isExperimentEnabled: isExperimentEnabled,
            shouldShowAsInline: shouldShowAsInline
        }) : $d5cccf701aceb868$var$createSmartLinks({
            ...params,
            isNonAgentMessage: isNonAgentMessage,
            isExperimentEnabled: isExperimentEnabled
        }));
module.exports["createSmartLinksPlugin"] = $d5cccf701aceb868$export$9625a798761643ac;

});

parcelRegister("gEMk1", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $lBWya = parcelRequire("lBWya");

const $bf5d74ffdabdc3d2$export$4b1056d02426889c = (url, regexStorage)=>{
    const cachedProviderRegex = $bf5d74ffdabdc3d2$export$90caa0c170ea581(regexStorage);
    if (!cachedProviderRegex.length || !url.length) return false;
    const regexPattern = new RegExp(cachedProviderRegex, 'g');
    return regexPattern.test(url);
};
const $bf5d74ffdabdc3d2$export$90caa0c170ea581 = (regexStorage)=>{
    if (regexStorage.getItem((0, $lBWya.LS_PROVIDER_KEY))) return JSON.parse(`${regexStorage.getItem((0, $lBWya.LS_PROVIDER_KEY))}`);
    return '';
};
const $bf5d74ffdabdc3d2$export$5af966b3aa3b1d83 = (regexStorage, providerRegex)=>{
    regexStorage?.setItem((0, $lBWya.LS_PROVIDER_KEY), JSON.stringify(providerRegex));
};
const $bf5d74ffdabdc3d2$export$d08c351b3b4e4934 = async (regexStorage, baseUrl)=>{
    const providerData = await $bf5d74ffdabdc3d2$export$dfebbb511ada4128(baseUrl);
    if (providerData) {
        const providerRegex = $bf5d74ffdabdc3d2$export$b7ac97ae80c7eb5a(providerData);
        $bf5d74ffdabdc3d2$export$5af966b3aa3b1d83(regexStorage, providerRegex);
        const providerMapping = $bf5d74ffdabdc3d2$export$8eafd18d19de7df5(providerData);
        $bf5d74ffdabdc3d2$export$b22dfe84603542b1(regexStorage, providerMapping);
    }
};
const $bf5d74ffdabdc3d2$export$b7ac97ae80c7eb5a = (data)=>{
    if (!data?.providers || !Array.isArray(data.providers)) return '';
    const sources = data.providers.reduce((acc, provider)=>{
        const providerSources = provider.patterns?.map((pattern)=>pattern.source) || [];
        return [
            ...acc,
            ...providerSources
        ];
    }, []);
    return sources.join('|');
};
const $bf5d74ffdabdc3d2$export$8eafd18d19de7df5 = (data)=>{
    if (!data?.providers || !Array.isArray(data.providers)) return {
        combinedRegex: '',
        patterns: []
    };
    const patterns = data.providers.flatMap((provider)=>(provider.patterns || []).map((pattern)=>({
                key: provider.key,
                regex: pattern.source
            })));
    const combinedRegex = patterns.map((p)=>p.regex).join('|');
    return {
        combinedRegex: combinedRegex,
        patterns: patterns
    };
};
const $bf5d74ffdabdc3d2$export$25b8a9cebf834f6e = (regexStorage)=>{
    const stored = regexStorage.getItem((0, $lBWya.LS_PROVIDER_MAPPING_KEY));
    if (stored) try {
        return JSON.parse(stored);
    } catch  {
        return null;
    }
    return null;
};
const $bf5d74ffdabdc3d2$export$b22dfe84603542b1 = (regexStorage, providerMapping)=>{
    regexStorage?.setItem((0, $lBWya.LS_PROVIDER_MAPPING_KEY), JSON.stringify(providerMapping));
};
const $bf5d74ffdabdc3d2$export$dfebbb511ada4128 = (0, $2XqLN.default)(async (baseUrl = '')=>{
    try {
        const response = await fetch(baseUrl + (0, $lBWya.PROVIDERS_API), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                type: 'resolve'
            })
        });
        const data = await response.json();
        return data || null;
    } catch  {
        return null;
    }
});
const $bf5d74ffdabdc3d2$export$ab8eaff0f2d596bd = (0, $2XqLN.default)(async (baseUrl = '')=>{
    const data = await $bf5d74ffdabdc3d2$export$dfebbb511ada4128(baseUrl);
    return data ? $bf5d74ffdabdc3d2$export$b7ac97ae80c7eb5a(data) : '';
});
module.exports["isSupportedByLinkingPlatform"] = $bf5d74ffdabdc3d2$export$4b1056d02426889c;
module.exports["hydrateLinkingPlatformCache"] = $bf5d74ffdabdc3d2$export$d08c351b3b4e4934;

});

parcelRegister("lBWya", function(module, exports) {
const $9088146284880a5b$export$57ad190cdc563df3 = `/gateway/api/object-resolver/providers`;
const $9088146284880a5b$export$1a30f994aeced995 = `/gateway/api/object-resolver/resolve/batch`;
const $9088146284880a5b$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $9088146284880a5b$export$b9858121ed269ff3 = 'aiMateSmartLinkProviderMapping';
module.exports["PROVIDERS_API"] = $9088146284880a5b$export$57ad190cdc563df3;
module.exports["LS_PROVIDER_KEY"] = $9088146284880a5b$export$56bec2f197c16818;
module.exports["LS_PROVIDER_MAPPING_KEY"] = $9088146284880a5b$export$b9858121ed269ff3;

});

parcelRegister("1Ce64", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ff6b0f828ae5055$export$2e2bcd8739ae039);
const $9ff6b0f828ae5055$var$tableBreakTags = (state)=>{
    const tokens = state.tokens;
    // Find all table tokens
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // Check if we're inside a table
        if (token.type === 'table_open') {
            // Process all tokens until the matching table_close
            let j = i + 1;
            while(j < tokens.length && tokens[j].type !== 'table_close'){
                // If we're in a table cell content
                if (tokens && tokens[j]?.type === 'inline' && tokens[j]?.children && tokens[j]?.children?.length) {
                    // Process the content of the cell
                    const children = tokens[j]?.children;
                    if (!children) continue;
                    for(let k = 0; k < children.length; k++){
                        const child = children[k];
                        if (!child) continue;
                        // Replace <br>, <br/>, and <br /> tags with newlines
                        // Match different variations of <br> tags
                        const brRegex = /<br\s*\/?>/gi;
                        if (brRegex.test(child.content)) {
                            child.content = child.content.replace(brRegex, '\n');
                            // If the content is now just a newline, change the token type
                            if (child.content === '\n') child.type = 'hardbreak';
                        }
                    }
                }
                j++;
            }
            // Skip to the end of the table
            i = j;
        }
    }
    return;
};
var $9ff6b0f828ae5055$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('table-break-tags', $9ff6b0f828ae5055$var$tableBreakTags);

});

parcelRegister("5XYXq", function(module, exports) {
$parcel$export(module.exports, "default", () => $28815f35966a9eaf$export$2e2bcd8739ae039);
const $28815f35966a9eaf$var$CHART_REGEX = /\[\^(chart)\^\]/;
const $28815f35966a9eaf$var$visualizationChart = (state)=>{
    const tokens = [];
    let chartCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $28815f35966a9eaf$var$CHART_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($28815f35966a9eaf$var$CHART_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        // Create a new token for each chart match
                        const chartToken = new state.Token('status', '', 0);
                        chartToken.content = '';
                        chartToken.block = false;
                        chartToken.level = childToken.level;
                        chartToken.attrs = [
                            [
                                'localId',
                                'chart-' + chartCounter
                            ],
                            [
                                'text',
                                'loading chart-' + chartCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(chartToken);
                        chartCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
function $28815f35966a9eaf$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('chart', $28815f35966a9eaf$var$visualizationChart);
}

});

parcelRegister("7ai6d", function(module, exports) {
const $a1a032ec05100051$export$cd54a56af01ba875 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $a1a032ec05100051$export$eb83d753215c78a2 = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        attrs: (tok)=>({
                state: tok.meta
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    code_inline: {
        mark: 'code'
    },
    ordered_list: {
        block: 'orderedList',
        attrs: (tok)=>{
            const order = +(tok.attrGet('order') || 1);
            return {
                order: order
            };
        }
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        attrs: (tok)=>({
                language: tok.info?.trim() || null
            })
    },
    image: {
        node: 'image',
        attrs: (_tok)=>{
            return {};
        }
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                type: 'external'
            };
        }
    },
    // Enable ADF SmartLinks, produced by our SmartLink MD plugin
    inlineCard: {
        node: 'inlineCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    blockCard: {
        node: 'blockCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    embedCard: {
        node: 'embedCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    // Enable ADF Mentions, produced by our Mentions MD plugin which converts /people links
    mention: {
        node: 'mention',
        attrs: (tok)=>{
            return {
                id: tok.attrGet('id'),
                text: tok.attrGet('text'),
                type: 'mention'
            };
        }
    },
    status: {
        node: 'status',
        attrs: (token)=>({
                text: token.attrGet('text'),
                color: token.attrGet('color'),
                localId: token.attrGet('localId')
            })
    }
};
module.exports["pmToMd"] = $a1a032ec05100051$export$cd54a56af01ba875;
module.exports["mdToPmSchema"] = $a1a032ec05100051$export$eb83d753215c78a2;

});

parcelRegister("bCKHR", function(module, exports) {

var $7ai6d = parcelRequire("7ai6d");

const $8bba972fb5d34921$export$155749302793c60c = (schema, map)=>Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
const $8bba972fb5d34921$export$a1cf9d9b96e16789 = (md, schema)=>{
    for(const k in 0, $7ai6d.pmToMd){
        const key = k;
        for(const i in (0, $7ai6d.pmToMd)[key]){
            const idx = i;
            if (schema[key][idx]) md.enable((0, $7ai6d.pmToMd)[key][idx]);
        }
    }
};
module.exports["filterSchemaMapping"] = $8bba972fb5d34921$export$155749302793c60c;
module.exports["enableSchemaPlugins"] = $8bba972fb5d34921$export$a1cf9d9b96e16789;

});

parcelRegister("4pEXC", function(module, exports) {

var $b0F8r = parcelRequire("b0F8r");


var $b7FrM = parcelRequire("b7FrM");


var $lpRYt = parcelRequire("lpRYt");


var $ij2FZ = parcelRequire("ij2FZ");

const $cdcb92bd6c40797f$export$d801201dc544181 = (content)=>{
    /*
	This try-catch is a necessary guard rail against broken content to prevent higher level
	error boundaries from displaying the error and breaking the experience.
	*/ try {
        return typeof content !== 'string' && 'type' in content && content.type === 'doc';
    } catch  {
        return false;
    }
};
const $cdcb92bd6c40797f$export$a236f395afded7e0 = (content, suggestionContent)=>{
    if ($cdcb92bd6c40797f$export$d801201dc544181(content)) {
        // Ensure the content is an array of nodes
        const updatedContent = Array.isArray(content.content) ? content.content : [
            content.content
        ];
        // Append the new paragraph node
        updatedContent.push({
            type: 'paragraph',
            content: [
                {
                    type: 'text',
                    text: suggestionContent
                }
            ]
        });
        // Return the updated DocNode
        return {
            ...content,
            content: updatedContent
        };
    }
    return `${content}\n\n${suggestionContent}`;
};
const $cdcb92bd6c40797f$var$pluginConfig = {
    linkify: {
        findFilepaths: $b0F8r.findFilepaths,
        isLinkInMatches: $b0F8r.isLinkInMatches
    },
    smartLinks: {
        regexStorage: globalThis.localStorage
    }
};
const $cdcb92bd6c40797f$export$3374c63d7715b4ce = new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, false));
const $cdcb92bd6c40797f$var$streamingAdfEncoder = new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, true));
const $cdcb92bd6c40797f$export$53ded0b846f45216 = (content, streaming = false, isExperimentEnabled, shouldShowAsInline, isNonAgentMessage)=>{
    if ($cdcb92bd6c40797f$export$d801201dc544181(content)) return content;
    if (isExperimentEnabled || isNonAgentMessage) return new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, isNonAgentMessage)).encode(content);
    else return streaming ? $cdcb92bd6c40797f$var$streamingAdfEncoder.encode(content) : $cdcb92bd6c40797f$export$3374c63d7715b4ce.encode(content);
};
const $cdcb92bd6c40797f$export$cc924f6f2bb49b7c = (content)=>{
    const contentNodes = [];
    let lastIndex = 0;
    let match;
    let promptLength = 0;
    // Find all skill tag matches
    const matches = [];
    while((match = (0, $ij2FZ.ROVO_SKILL_TAG_PATTERN).exec(content)) !== null)matches.push({
        index: match.index,
        skillSlug: match[1],
        length: match[0].length
    });
    // Process the string segment by segment
    for(let i = 0; i < matches.length; i++){
        const currentMatch = matches[i];
        const matchStart = currentMatch.index;
        const matchEnd = matchStart + currentMatch.length;
        // Add text before the skill tag (if any)
        if (matchStart > lastIndex) {
            const textBefore = content.substring(lastIndex, matchStart);
            if (textBefore) {
                contentNodes.push({
                    type: 'text',
                    text: textBefore
                });
                promptLength += textBefore.length;
            }
        }
        // Add the skill tag as inlineExtension
        contentNodes.push({
            type: 'inlineExtension',
            attrs: {
                extensionKey: (0, $ij2FZ.ROVO_SKILL_COMBINED_EXTENSION_KEY),
                extensionType: (0, $ij2FZ.ROVO_SKILL_EXTENSION_TYPE),
                parameters: {
                    slug: currentMatch.skillSlug
                }
            }
        });
        promptLength += 1;
        lastIndex = matchEnd;
    }
    // Add remaining text after the last match (if any)
    if (lastIndex < content.length) {
        const textAfter = content.substring(lastIndex);
        if (textAfter) {
            contentNodes.push({
                type: 'text',
                text: textAfter
            });
            promptLength += textAfter.length;
        }
    }
    // If no matches were found, return the entire string as text
    if (contentNodes.length === 0) {
        contentNodes.push({
            type: 'text',
            text: content
        });
        promptLength += content.length;
    }
    return {
        adf: {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: contentNodes
                }
            ]
        },
        promptLength: promptLength
    };
};
module.exports["isAdfContent"] = $cdcb92bd6c40797f$export$d801201dc544181;
module.exports["appendContent"] = $cdcb92bd6c40797f$export$a236f395afded7e0;
module.exports["encodeAdf"] = $cdcb92bd6c40797f$export$53ded0b846f45216;
module.exports["encodeSkillPromptToAdf"] = $cdcb92bd6c40797f$export$cc924f6f2bb49b7c;

});

parcelRegister("5MO1q", function(module, exports) {
const $bc280b458a56ce28$export$e8114853eca81277 = 'ai-mate';
const $bc280b458a56ce28$export$1106bf31edf2a9b8 = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DEACTIVATED: 'convoai.rest.bad.request.archived.agent',
    ROVO_PRODUCT_NOT_ACTIVE: 'convoai.rest.rovo.product.not.active',
    HAS_HIPAA_ENABLED: 'convoai.rest.browsing.product.has.hipaa.enabled',
    FILE_SIZE_TOO_LARGE: 'convoai.rest.bad.request.file.size.too.large'
};
const $bc280b458a56ce28$export$333e4f57333eadfa = {
    UNSUPPORTED_FILE_TYPE: 415,
    FILE_RAI_POLICY_VIOLATION: 406
};
module.exports["ASSISTANCE_SERVICE_ERROR_CODES"] = $bc280b458a56ce28$export$1106bf31edf2a9b8;
module.exports["STATUS_CODES"] = $bc280b458a56ce28$export$333e4f57333eadfa;

});

parcelRegister("flpNp", function(module, exports) {
class $1d075fa469bb0891$export$f2e832acab1bdd79 extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $1d075fa469bb0891$export$89d83cc97c52a37 = (error)=>error instanceof $1d075fa469bb0891$export$f2e832acab1bdd79;
const $1d075fa469bb0891$export$3c02d1a328d4d808 = (error)=>{
    if ($1d075fa469bb0891$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $1d075fa469bb0891$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};
module.exports["ApiError"] = $1d075fa469bb0891$export$f2e832acab1bdd79;
module.exports["isApiError"] = $1d075fa469bb0891$export$89d83cc97c52a37;
module.exports["mapErrorToApiError"] = $1d075fa469bb0891$export$3c02d1a328d4d808;

});

parcelRegister("ljUdP", function(module, exports) {

var $5MO1q = parcelRequire("5MO1q");


var $flpNp = parcelRequire("flpNp");

const $35329f6c3dcf5d43$export$5945515082cc2cbf = 'convoai.rest.not.found';
const $35329f6c3dcf5d43$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
var $35329f6c3dcf5d43$export$2e28f9aa1dcf9823 = /*#__PURE__*/ function(PromptCategory) {
    PromptCategory["ANALYZE"] = "Analyze";
    PromptCategory["BRAINSTORM"] = "Brainstorm";
    PromptCategory["REVIEW"] = "Review";
    PromptCategory["SUMMARIZE"] = "Summarize";
    PromptCategory["CREATE"] = "Create";
    PromptCategory["EXECUTE"] = "Execute";
    PromptCategory["FIND"] = "Find";
    PromptCategory["LEARN"] = "Learn";
    return PromptCategory;
}({});
var $35329f6c3dcf5d43$export$bd1535eb0caf2683 = /*#__PURE__*/ function(PromptRole) {
    PromptRole["GENERAL"] = "General";
    PromptRole["ENGINEERING"] = "Engineering";
    PromptRole["PRODUCT"] = "Product";
    PromptRole["PROGRAM_MANAGEMENT"] = "Program Management";
    PromptRole["DESIGN"] = "Design";
    PromptRole["MARKETING"] = "Marketing";
    PromptRole["IT_OPS"] = "IT Ops";
    PromptRole["SALES"] = "Sales";
    PromptRole["CUSTOMER_SUPPORT"] = "Customer Support";
    PromptRole["HELPDESK_SUPPORT"] = "Helpdesk Support";
    PromptRole["SECURITY"] = "Security";
    return PromptRole;
}({});
const $35329f6c3dcf5d43$export$fb661125ffb29bd6 = (message)=>{
    return $35329f6c3dcf5d43$export$a69fab2afb88c2eb(message) || $35329f6c3dcf5d43$export$6f965deda7f0960c(message) || $35329f6c3dcf5d43$export$b4631726cbc1440a(message);
};
const $35329f6c3dcf5d43$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $35329f6c3dcf5d43$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $35329f6c3dcf5d43$export$a6e5100ca2770191 = (message)=>message instanceof Object && $35329f6c3dcf5d43$export$6f965deda7f0960c(message.message);
const $35329f6c3dcf5d43$export$5c1c15675df13ae5 = (message)=>$35329f6c3dcf5d43$export$b4631726cbc1440a(message) && message.message?.message?.async_status === 'IN_PROGRESS';
const $35329f6c3dcf5d43$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $35329f6c3dcf5d43$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $35329f6c3dcf5d43$export$1e1cf807ece63df4 = (message)=>$35329f6c3dcf5d43$export$d422a2733a3b5def(message) && message.message?.message_template === $35329f6c3dcf5d43$export$c424fe9570a5f2d9;
const $35329f6c3dcf5d43$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $35329f6c3dcf5d43$export$51a109436d382715 = (message)=>message instanceof Object && message.type === 'REASONING_PART';
const $35329f6c3dcf5d43$export$dbf4211c9117b9bc = (message)=>message instanceof Object && message.type === 'ACTION_PART';
const $35329f6c3dcf5d43$export$3d7b0b359441d5a6 = (message)=>message instanceof Object && message.type === 'ACTION_CLASSIFICATION';
const $35329f6c3dcf5d43$export$584e11c2903f4ed6 = (message)=>message instanceof Object && message.type === 'ACTION_PREPARE';
const $35329f6c3dcf5d43$export$7d94ce53d589f586 = (message)=>message instanceof Object && message.type === 'ACTION_COMPLETE';
const $35329f6c3dcf5d43$export$abec64f24e2ec3e7 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_START';
const $35329f6c3dcf5d43$export$9c1f93971e9e3fbe = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH';
const $35329f6c3dcf5d43$export$79a0ed7d987faa8f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP';
const $35329f6c3dcf5d43$export$7b1c8227569f1a92 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE';
const $35329f6c3dcf5d43$export$cde91b49af35d559 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_PLAN';
const $35329f6c3dcf5d43$export$ac74da022f74040a = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT';
const $35329f6c3dcf5d43$export$68192da24ac8c141 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_SOURCE';
const $35329f6c3dcf5d43$export$cfccfd17b68ccb0 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_COMPLETE';
const $35329f6c3dcf5d43$export$c679ee34f7312895 = (message)=>message instanceof Object && message.type === 'RECONNECT_SUPPORTED';
const $35329f6c3dcf5d43$export$b00dd9d0560e29d2 = (message)=>message instanceof Object && message.type === 'ANSWER_GENERATION_TYPE';
const $35329f6c3dcf5d43$export$5fa02529cd2ab34c = (message)=>message instanceof Object && message.type === 'DL_SUB_AGENT';
const $35329f6c3dcf5d43$export$46e0fb5e4b019a49 = (message)=>message instanceof Object && message.type === 'TRACE' && (message.message.message_template === 'RESEARCH' || message.message.message_template === 'RESEARCH_STEP' || message.message.message_template === 'RESEARCH_STEP_TITLE' || message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT' || message.message.message_template === 'RESEARCH_STEP_SOURCE' || message.message.message_template === 'RESEARCH_STEP_COMPLETE');
const $35329f6c3dcf5d43$export$fd5a05be03f147a0 = (message)=>{
    // TRACE and research steps are sharing the same type, but we want to separate them
    if ($35329f6c3dcf5d43$export$46e0fb5e4b019a49(message)) return false;
    if ($35329f6c3dcf5d43$export$cde91b49af35d559(message)) return false;
    return message instanceof Object && message.type === 'TRACE';
};
const $35329f6c3dcf5d43$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $35329f6c3dcf5d43$export$b8391261162989d9 = (message)=>$35329f6c3dcf5d43$export$6f965deda7f0960c(message) && (message?.message_metadata?.is_action_execution ?? false) && message?.message_metadata?.action_execution_result === 'SUCCESS';
const $35329f6c3dcf5d43$export$1060c4fa97e34fa7 = (payloadContext)=>{
    return payloadContext?.resolution?.type === 'cancel';
};
const $35329f6c3dcf5d43$export$6ce1ccc24e75456f = (error)=>(0, $flpNp.isApiError)(error) && error.errorAttributes?.errorCode === $35329f6c3dcf5d43$export$5945515082cc2cbf;
const $35329f6c3dcf5d43$export$c3c933dad2745d3f = (msg)=>msg && msg.type === 'ACTION_ERROR' && msg.message && msg.message.status === 'ERRORED';
const $35329f6c3dcf5d43$export$bc96a6a479480590 = (error)=>(0, $flpNp.isApiError)(error) && error.errorAttributes.statusCode === 429;
const $35329f6c3dcf5d43$export$f8b1b75846492611 = (error)=>(0, $flpNp.isApiError)(error) && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === (0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).HAS_HIPAA_ENABLED;
const $35329f6c3dcf5d43$export$d263dc5d64f36d48 = (error)=>error instanceof Object && error?.detail?.type === 'ERROR' && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === $35329f6c3dcf5d43$export$c424fe9570a5f2d9;
const $35329f6c3dcf5d43$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';
function $35329f6c3dcf5d43$export$4af48296a8d61cec(payloadContext) {
    return payloadContext?.resolution?.type === 'confirm';
}
module.exports["ACCEPTABLE_USE_VIOLATIONS_ERROR"] = $35329f6c3dcf5d43$export$c424fe9570a5f2d9;
module.exports["isHumanMessage"] = $35329f6c3dcf5d43$export$a69fab2afb88c2eb;
module.exports["isAssistantMessage"] = $35329f6c3dcf5d43$export$6f965deda7f0960c;
module.exports["isStreamResponse"] = $35329f6c3dcf5d43$export$b4631726cbc1440a;
module.exports["isAgentResponse"] = $35329f6c3dcf5d43$export$a6e5100ca2770191;
module.exports["isInProgressStreamResponse"] = $35329f6c3dcf5d43$export$5c1c15675df13ae5;
module.exports["isStreamError"] = $35329f6c3dcf5d43$export$d422a2733a3b5def;
module.exports["isStreamAUPError"] = $35329f6c3dcf5d43$export$1e1cf807ece63df4;
module.exports["isStreamAnswerPart"] = $35329f6c3dcf5d43$export$e45102edbc73b240;
module.exports["isStreamReasoningPart"] = $35329f6c3dcf5d43$export$51a109436d382715;
module.exports["isStreamActionPart"] = $35329f6c3dcf5d43$export$dbf4211c9117b9bc;
module.exports["isStreamActionClassification"] = $35329f6c3dcf5d43$export$3d7b0b359441d5a6;
module.exports["isStreamActionPrepare"] = $35329f6c3dcf5d43$export$584e11c2903f4ed6;
module.exports["isStreamActionComplete"] = $35329f6c3dcf5d43$export$7d94ce53d589f586;
module.exports["isStreamResearchStart"] = $35329f6c3dcf5d43$export$abec64f24e2ec3e7;
module.exports["isStreamResearchBeginningTrace"] = $35329f6c3dcf5d43$export$9c1f93971e9e3fbe;
module.exports["isStreamResearchStepContent"] = $35329f6c3dcf5d43$export$79a0ed7d987faa8f;
module.exports["isStreamResearchStepTitle"] = $35329f6c3dcf5d43$export$7b1c8227569f1a92;
module.exports["isStreamResearchPlan"] = $35329f6c3dcf5d43$export$cde91b49af35d559;
module.exports["isStreamResearchStepTitleShort"] = $35329f6c3dcf5d43$export$ac74da022f74040a;
module.exports["isStreamResearchStepSource"] = $35329f6c3dcf5d43$export$68192da24ac8c141;
module.exports["isStreamResearchStepCompleted"] = $35329f6c3dcf5d43$export$cfccfd17b68ccb0;
module.exports["isStreamAnswerGenerationType"] = $35329f6c3dcf5d43$export$b00dd9d0560e29d2;
module.exports["isStreamDynamicLayoutSubAgent"] = $35329f6c3dcf5d43$export$5fa02529cd2ab34c;
module.exports["isStreamResearchPayload"] = $35329f6c3dcf5d43$export$46e0fb5e4b019a49;
module.exports["isStreamTrace"] = $35329f6c3dcf5d43$export$fd5a05be03f147a0;
module.exports["isFollowUpMessage"] = $35329f6c3dcf5d43$export$aeae5b4fda357302;
module.exports["isActionExecutedSuccessfully"] = $35329f6c3dcf5d43$export$b8391261162989d9;
module.exports["isActionResolutionCancelled"] = $35329f6c3dcf5d43$export$1060c4fa97e34fa7;
module.exports["isChannelNotFoundError"] = $35329f6c3dcf5d43$export$6ce1ccc24e75456f;
module.exports["isStreamActionError"] = $35329f6c3dcf5d43$export$c3c933dad2745d3f;
module.exports["isRateLimitedError"] = $35329f6c3dcf5d43$export$bc96a6a479480590;
module.exports["isHipaaError"] = $35329f6c3dcf5d43$export$f8b1b75846492611;
module.exports["isAUPViolationError"] = $35329f6c3dcf5d43$export$d263dc5d64f36d48;
module.exports["isConversationChannelDataMessage"] = $35329f6c3dcf5d43$export$b454081350f4a578;
module.exports["isConfirmAction"] = $35329f6c3dcf5d43$export$4af48296a8d61cec;

});

parcelRegister("99vXA", function(module, exports) {
const $54861eb441be5d90$export$11cc4786742ed7c2 = ()=>{
    const date = new Date();
    const formattedDate = date.toLocaleDateString(undefined, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    });
    const formattedTime = date.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    const name = `${formattedDate} ${formattedTime}`;
    return name;
};
module.exports["generateConversationName"] = $54861eb441be5d90$export$11cc4786742ed7c2;

});

parcelRegister("aclUh", function(module, exports) {

var $ljUdP = parcelRequire("ljUdP");

const $68019d45b4210062$export$218c8c3169c024d2 = (streamResponse)=>streamResponse.message.message.id;
const $68019d45b4210062$var$addAnswerPartAssistantMessage = (response, answerPart)=>{
    const content = `${response.content}${answerPart.message.content}`;
    // Remove source indexes, e.g [^1^] from the content
    const cleanedContent = content.replace(/\[\^\d+\^\]/g, '');
    return {
        ...response,
        content: cleanedContent
    };
};
const $68019d45b4210062$var$addAnswerPartAgentResponse = (response, answerPart)=>({
        ...response,
        message: $68019d45b4210062$var$addAnswerPartAssistantMessage(response.message, answerPart)
    });
// ****************************************************************************
// Action streaming accumulation configuration
// ****************************************************************************
const $68019d45b4210062$var$toPathArr = (path)=>Array.isArray(path) ? path : path.split('.').filter(Boolean);
const $68019d45b4210062$var$getAtPath = (obj, path)=>{
    let cur = obj;
    for (const key of path){
        if (cur == null || typeof cur !== 'object') return undefined;
        cur = cur[key];
    }
    return cur;
};
const $68019d45b4210062$var$setAtPath = (obj, path, value)=>{
    if (path.length === 0) return value;
    const [head, ...rest] = path;
    const base = obj && typeof obj === 'object' ? obj : {};
    return {
        ...base,
        [head]: $68019d45b4210062$var$setAtPath(base[head], rest, value)
    };
};
// Defines which sub-field(s) of a message action's data should be accumulated by string appending.
// Keyed by action key. Values can be a dot path or an array path, or an array of multiple paths.
// E.g.:
// {
//   'create-document-action': 'content',
//   'update-document-action': ['content', 'meta.subtitle']
// }
let $68019d45b4210062$var$actionDataAccumulationConfig = {
    ['aifc-confluence-page-create']: 'adf'
};
const $68019d45b4210062$export$a1715e22f3105088 = (prev, next)=>{
    const key = next.key;
    const rulePaths = $68019d45b4210062$var$actionDataAccumulationConfig[key];
    const prevData = prev?.data;
    const newData = next?.data;
    if (rulePaths && typeof prevData === 'object' && prevData !== null && typeof newData === 'object' && newData !== null) {
        const paths = Array.isArray(rulePaths) ? rulePaths : [
            rulePaths
        ];
        let base = {
            ...newData
        };
        for (const p of paths){
            const pathArr = $68019d45b4210062$var$toPathArr(p);
            const prevVal = $68019d45b4210062$var$getAtPath(prevData, pathArr);
            const nextVal = $68019d45b4210062$var$getAtPath(newData, pathArr);
            const accumulated = String(prevVal ?? '') + String(nextVal ?? '');
            base = $68019d45b4210062$var$setAtPath(base, pathArr, accumulated);
        }
        return {
            ...prev,
            data: base,
            status: next.status
        };
    }
    // Default: replace only data from next, keep other fields from prev
    return {
        ...prev,
        data: next.data,
        status: next.status
    };
};
const $68019d45b4210062$export$6554ad578994a75f = (actions, actionPart, actionUpdaterOverride)=>{
    const { key: key } = actionPart.message;
    const existingActionIndex = actions.findIndex((action)=>action.key === key);
    if (existingActionIndex === -1) return [
        ...actions || [],
        actionPart.message
    ];
    const updatedActions = [
        ...actions
    ];
    const prevAction = updatedActions[existingActionIndex];
    const nextAction = actionPart.message;
    updatedActions[existingActionIndex] = actionUpdaterOverride ? actionUpdaterOverride(prevAction, nextAction) : $68019d45b4210062$export$a1715e22f3105088(prevAction, nextAction);
    return updatedActions;
};
const $68019d45b4210062$export$6e5609c05ab74cc7 = (response, answerPart)=>({
        ...response,
        message: $68019d45b4210062$var$addAnswerPartAgentResponse(response.message, answerPart)
    });
const $68019d45b4210062$export$13b6a4e4e3704011 = (response, actionPart, actionUpdaterOverride)=>{
    const { message: message } = response.message;
    const { actions: actions } = message;
    const isActionsArrayPresent = actions && actions.length > 0;
    return {
        ...response,
        message: {
            ...response.message,
            message: {
                ...message,
                actions: !isActionsArrayPresent ? [
                    actionPart.message
                ] : $68019d45b4210062$export$6554ad578994a75f(actions, actionPart, actionUpdaterOverride)
            }
        }
    };
};
const $68019d45b4210062$var$removeSensitiveDataAssistantMessage = (message)=>{
    const { plugin_invocations: plugin_invocations, ...rest } = message;
    return {
        ...rest,
        plugin_invocations: plugin_invocations.map((pluginInvocation)=>({
                ...pluginInvocation,
                plugin_output: '--PRIVATE--'
            }))
    };
};
const $68019d45b4210062$var$removeSensitiveDataAgentResponse = (message)=>({
        ...message,
        message: $68019d45b4210062$var$removeSensitiveDataAssistantMessage(message.message)
    });
const $68019d45b4210062$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        message: $68019d45b4210062$var$removeSensitiveDataAgentResponse(message.message)
    });
const $68019d45b4210062$export$4010f996e89e886a = (id, content, isFromSeededConversation, requestId, fileUploads)=>{
    return {
        role: 'HUMAN',
        id: id,
        content: content,
        time_created: new Date().toISOString(),
        user_ari: 'unknown',
        plugin_invocations: [],
        isFromSeededConversation: isFromSeededConversation,
        requestId: requestId,
        file_uploads: fileUploads
    };
};
const $68019d45b4210062$export$3220a4ff7b3a96df = (message)=>{
    if ((0, $ljUdP.isAgentResponse)(message)) return {
        type: 'FINAL_RESPONSE',
        message: message
    };
    return {
        type: 'FINAL_RESPONSE',
        message: {
            message: message
        }
    };
};
module.exports["getId"] = $68019d45b4210062$export$218c8c3169c024d2;
module.exports["addAnswerPart"] = $68019d45b4210062$export$6e5609c05ab74cc7;
module.exports["addActionPart"] = $68019d45b4210062$export$13b6a4e4e3704011;
module.exports["removeSensitiveData"] = $68019d45b4210062$export$efd4f6b5d168b654;
module.exports["createHumanMessage"] = $68019d45b4210062$export$4010f996e89e886a;
module.exports["toStreamResponse"] = $68019d45b4210062$export$3220a4ff7b3a96df;

});

parcelRegister("9eLw5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $9zUhf = parcelRequire("9zUhf");

var $cclHy = parcelRequire("cclHy");

var $1P1Tu = parcelRequire("1P1Tu");


var $flpNp = parcelRequire("flpNp");

const $2c362c1c58e43242$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        cache: {}
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            }
    }
});
const $2c362c1c58e43242$var$selector = (0, $cclHy.createSelector)((state)=>state.cache, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
	 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
	 * and it will determine whether to rerender the component
	 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
	 *
	 * e.g. for `enabled` true condition:
	 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
	 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
	 *
	 * To test this, run the unit test, and then force this function to return new stuff on every call
	 * e.g. `return { ...result, random: Math.random() };`
	 * it will result in increase renderCount in the unit test
	 */ (cache, key, initialQueryEnabled)=>cache[key] ?? {
        data: null,
        error: null,
        isFetching: initialQueryEnabled
    });
const $2c362c1c58e43242$var$useCacheEntry = (0, $9zUhf.createHook)($2c362c1c58e43242$var$store, {
    selector: $2c362c1c58e43242$var$selector
});
const $2c362c1c58e43242$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $42omo.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $42omo.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $42omo.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $2c362c1c58e43242$var$useCacheEntry({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            updateCacheEntry(queryKey, {
                data: response
            });
            onSuccessRef.current?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $flpNp.mapErrorToApiError)(error);
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $42omo.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $fFa3V.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData
    };
};
module.exports["useQuery"] = $2c362c1c58e43242$export$dd0a697e1782aedd;

});

parcelRegister("2Cfy4", function(module, exports) {
const $0009c874b00d4f72$export$8849fb25713dbf70 = 'rovoLastClickedRecommendedAgent';
const $0009c874b00d4f72$export$73b400613798970e = 'rovo-agents-fe';
module.exports["LAST_CLICKED_RECOMMENDED_AGENT_KEY"] = $0009c874b00d4f72$export$8849fb25713dbf70;
module.exports["ROVO_AGENTS_FE_TEAM_NAME"] = $0009c874b00d4f72$export$73b400613798970e;

});

parcelRegister("8CAML", function(module, exports) {

var $8Igpw = parcelRequire("8Igpw");

const $ece6631c27d5e331$var$extractQueryName = (gqlQuery)=>{
    const operationMatch = gqlQuery.match(/(?:query|mutation)\s+(\w+)/);
    return operationMatch ? operationMatch[1] : undefined;
};
const $ece6631c27d5e331$export$f602b5befecb0b84 = async ({ gqlQuery: gqlQuery, headerOptions: headerOptions, variables: variables, abortController: abortController })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            headers: {
                'Content-Type': 'application/json',
                ...headerOptions
            },
            method: 'POST',
            body: JSON.stringify({
                query: gqlQuery,
                variables: variables
            }),
            signal: abortController?.signal
        });
        const json = await response.json();
        if (json?.errors?.length) await $ece6631c27d5e331$var$processGqlErrorResponse({
            errors: json.errors,
            gqlQuery: gqlQuery
        });
        return json;
    } catch (err) {
        // GqlApiError is already processed
        if (err instanceof $ece6631c27d5e331$export$ba203f24e0131ba7) throw err;
        // Handle abort signal gracefully, it shouldn't be considered an error despite being caught
        if (err instanceof Error && err.name === 'AbortError') return {
            data: null,
            errors: undefined
        };
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        throw new (0, $8Igpw.FetchError)(`GraphQL query failed (promise rejected): ${originalErrorMessage}`, {
            errorCode: 'performGqlFetchError'
        });
    }
};
class $ece6631c27d5e331$export$ba203f24e0131ba7 extends Error {
    constructor({ errors: errors, queryName: queryName }){
        const errorsString = errors.map((error)=>error.message).join(', ');
        const errorMessage = `GraphQL API error: ${errorsString}`;
        super(errorMessage);
        this.message = void 0;
        this.errorAttributes = void 0;
        this.message = errorMessage;
        this.name = 'GraphQLError';
        this.errorAttributes = {
            errorCode: 'GqlApiError',
            queryName: queryName,
            rawErrorMessage: errorMessage,
            errors: errorsString
        };
    }
}
const $ece6631c27d5e331$var$processGqlErrorResponse = async ({ errors: errors, gqlQuery: gqlQuery })=>{
    const errorsToThrow = [];
    errors.forEach((error)=>{
        errorsToThrow.push({
            message: error.message,
            status_code: error.extensions.statusCode,
            classification: error.extensions.classification
        });
    });
    throw new $ece6631c27d5e331$export$ba203f24e0131ba7({
        errors: errorsToThrow,
        queryName: $ece6631c27d5e331$var$extractQueryName(gqlQuery)
    });
};
module.exports["performGqlFetch"] = $ece6631c27d5e331$export$f602b5befecb0b84;

});

parcelRegister("iswAx", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $fBMbo = parcelRequire("fBMbo");


var $2Nwuj = parcelRequire("2Nwuj");


var $4Nwes = parcelRequire("4Nwes");


var $9EfFC = parcelRequire("9EfFC");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");


var $9uTsJ = parcelRequire("9uTsJ");


var $kpYGL = parcelRequire("kpYGL");


var $1yaYZ = parcelRequire("1yaYZ");


var $9eLw5 = parcelRequire("9eLw5");


var $26nu6 = parcelRequire("26nu6");


var $cqFPV = parcelRequire("cqFPV");


var $fQF1W = parcelRequire("fQF1W");


var $eOn3v = parcelRequire("eOn3v");


var $5kyLi = parcelRequire("5kyLi");

const $baa53903be441878$export$3761e66a04602cbd = (ari)=>{
    const matched = ari.match(/\/([a-zA-Z0-9_\|\-\:]{1,128})$/);
    return matched ? matched[1] : undefined;
};
const $baa53903be441878$export$acf3e1bcf222b00d = (aaid)=>{
    return `ari:cloud:identity::user/${aaid}`;
};
const $baa53903be441878$export$1565ea9a9fb7ad67 = ({ agent: agent, siteId: siteId, simplified: simplified, onClick: onClick })=>{
    if ((0, $26nu6.isSystemAgent)(agent) || (0, $26nu6.isOOTBAgent)(agent) || !agent.creator) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        testId: "atlassian-icon",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4Nwes.AtlassianIcon), {
                label: "",
                appearance: "brand",
                size: "small"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                children: "Atlassian"
            })
        ]
    });
    if ((0, $26nu6.isCustomerAgent)(agent)) {
        const authoringTeam = agent.authoring_team;
        if (authoringTeam?.id) return /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
            alignBlock: "center",
            testId: "atlassian-icon",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                href: authoringTeam.profile_url,
                target: "_blank",
                onClick: onClick,
                children: authoringTeam.display_name
            })
        });
        const aaid = agent.creator ? $baa53903be441878$export$3761e66a04602cbd(agent.creator) : undefined;
        if (!aaid) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)($baa53903be441878$var$ResolvingMention, {
            userId: aaid,
            siteId: siteId,
            profileCard: true,
            simplified: simplified,
            onClick: onClick
        });
    }
    if ((0, $26nu6.isForgeAgent)(agent)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        children: agent.creator
    });
    return null;
};
// TODO consolidate this with `AgentCreator` component `platform/packages/ai-mate/conversation-assistant-agent/src/common/ui/creator/index.tsx`
const $baa53903be441878$var$ResolvingMention = ({ userId: userId, siteId: siteId, profileCard: profileCard = false, simplified: simplified = false, onClick: onClick })=>{
    (0, $fBMbo.di)($baa53903be441878$export$5d980898591175e);
    const { profile: profile, client: client } = $baa53903be441878$export$5d980898591175e(userId, siteId);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { atlasURL: atlasURL } = (0, $fQF1W.useAtlasURL)(siteId);
    const fullName = profile.data?.status === 'inactive' && profile.data.fullName ? formatMessage((0, $5kyLi.default).deactivatedCreatorName, {
        name: profile.data.fullName
    }) : profile.data?.fullName;
    if (profile.isFetching || !profile.data) return /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
        isShimmering: true,
        height: 18,
        width: 100,
        borderRadius: 3
    });
    if (simplified) {
        const profileUrl = atlasURL(`/people/${userId}`);
        return (0, $dh538.fg)('dst-a11y__replace-anchor-with-link__ai-mate') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
            href: profileUrl,
            target: "_blank",
            onClick: onClick,
            children: fullName
        }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, $l998X.jsx)("a", {
            href: profileUrl,
            target: "_blank",
            onClick: onClick,
            children: fullName
        });
    }
    return profileCard ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9uTsJ.default), {
        userId: userId,
        resourceClient: client,
        ariaLabel: fullName,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9EfFC.default), {
            id: userId,
            isHighlighted: profile.data.isCurrentUser,
            text: `@${fullName}`
        })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $9EfFC.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    });
};
function $baa53903be441878$export$5d980898591175e(userId, siteId, shouldFetch = true) {
    const profileClient = (0, $eOn3v.useProfileClient)();
    const profile = (0, $9eLw5.useQuery)({
        queryKey: [
            'fetchProfile',
            siteId,
            userId
        ],
        queryFn: async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (error) {
                (0, $1yaYZ.logException)({
                    exception: error,
                    name: 'ConversationAssistantAgentUseProfileResolutionError'
                });
                return {};
            }
        },
        enabled: shouldFetch
    });
    return {
        profile: profile,
        client: profileClient
    };
}
const $baa53903be441878$export$13d60404a0dddebd = (agents, filters)=>{
    return agents.filter((agent)=>agent.name.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase()) || agent.description?.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase())).sort((a, b)=>a.name.localeCompare(b.name));
};
const $baa53903be441878$export$a6e36c224ec3c0cb = (agent)=>{
    const enabledSources = agent.scenarios?.filter((scenario)=>scenario.isActive && scenario.isValid?.value)?.flatMap((scenario)=>scenario.knowledgeSources).filter((source)=>source?.enabled).flatMap((source)=>source?.sources).filter((source)=>source?.enabled);
    if (!enabledSources?.length) return [];
    const allAris = enabledSources?.reduce((acc, cur)=>{
        const allFilters = [
            ...cur?.filters?.parentFilter ?? [],
            ...cur?.filters?.spaceFilter ?? [],
            ...cur?.filters?.projectFilter ?? []
        ];
        allFilters.forEach((item)=>acc.add(item));
        return acc;
    }, new Set());
    return Array.from(allAris);
};
const $baa53903be441878$export$6d876204c5d593ac = ({ availableAgents: availableAgents, product: product })=>{
    // If no product is provided / product is not supported, fallback to using default agents
    const defaultAgentsNamedIds = product ? (0, $cqFPV.DEFAULT_OOTB_AGENTS_NAMED_IDS)[product] ?? (0, $cqFPV.DEFAULT_AGENTS_NAMED_ID_LIST) : (0, $cqFPV.DEFAULT_AGENTS_NAMED_ID_LIST);
    const defaultAgents = availableAgents.filter((agent)=>defaultAgentsNamedIds.has(agent.named_id) || agent.external_config_reference && defaultAgentsNamedIds.has(agent.external_config_reference));
    return defaultAgents;
};
module.exports["getAAIDFromARI"] = $baa53903be441878$export$3761e66a04602cbd;
module.exports["getARIFromAAID"] = $baa53903be441878$export$acf3e1bcf222b00d;
module.exports["AgentCreatedBy"] = $baa53903be441878$export$1565ea9a9fb7ad67;
module.exports["useProfileResolution"] = $baa53903be441878$export$5d980898591175e;
module.exports["getEnabledKnowlegeArisFromAgent"] = $baa53903be441878$export$a6e36c224ec3c0cb;
module.exports["getSuggestedOotbAgents"] = $baa53903be441878$export$6d876204c5d593ac;

});

parcelRegister("26nu6", function(module, exports) {
const $04c28723649a2305$export$7c120b233d4844c6 = (agent)=>agent.creator_type === 'SYSTEM';
const $04c28723649a2305$export$f817e52cf2c5cc8c = (agent)=>agent.creator_type === 'CUSTOMER';
const $04c28723649a2305$export$2149adda3d8a5807 = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE';
const $04c28723649a2305$export$95433d0f8c6ad323 = (agent)=>agent.visibility === 'PRIVATE';
const $04c28723649a2305$export$7091e3bee2adaacb = (agent)=>agent.creator_type === 'OOTB';
const $04c28723649a2305$export$916e4870f74f205b = {
    ALL_AGENTS: 'all-agents',
    STARRED_AGENTS: 'starred-agents',
    MY_AGENTS: 'my-agents',
    TEMPLATES: 'templates',
    VERIFIED_AGENTS: 'verified-agents'
};
module.exports["isSystemAgent"] = $04c28723649a2305$export$7c120b233d4844c6;
module.exports["isCustomerAgent"] = $04c28723649a2305$export$f817e52cf2c5cc8c;
module.exports["isForgeAgent"] = $04c28723649a2305$export$2149adda3d8a5807;
module.exports["isOOTBAgent"] = $04c28723649a2305$export$7091e3bee2adaacb;

});

parcelRegister("cqFPV", function(module, exports) {
const $570a782ebb8f75e0$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC'
};
const $570a782ebb8f75e0$export$2d0163867590928d = new Set([
    'decision_director_agent',
    'user_manual_writer_agent',
    'product_requirements_expert_agent'
]);
const $570a782ebb8f75e0$export$804d9ee5f4cc40a8 = {
    ['confluence']: new Set([
        'decision_director_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ]),
    ['jira']: new Set([
        'rovo_expert_agent',
        'issue_organizer_agent',
        'jira_theme_analyzer_agent'
    ]),
    ['atlas']: new Set([
        'progress_tracker_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ])
};
const $570a782ebb8f75e0$var$AGENT_AUP_ERROR_CODE = `convoai.agent.responsible-ai.failure`;
const $570a782ebb8f75e0$var$HIPAA_ERROR_CODE = 'convoai.rest.browsing.product.has.hipaa.enabled';
const $570a782ebb8f75e0$export$a08ace1426fa4a9e = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $570a782ebb8f75e0$var$AGENT_AUP_ERROR_CODE;
const $570a782ebb8f75e0$export$f8b1b75846492611 = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $570a782ebb8f75e0$var$HIPAA_ERROR_CODE;
const $570a782ebb8f75e0$export$429080cfef3412f2 = 'browse-agents-container';
module.exports["DEFAULT_AGENTS_NAMED_ID_LIST"] = $570a782ebb8f75e0$export$2d0163867590928d;
module.exports["DEFAULT_OOTB_AGENTS_NAMED_IDS"] = $570a782ebb8f75e0$export$804d9ee5f4cc40a8;
module.exports["isCreateOrEditAgentAUPError"] = $570a782ebb8f75e0$export$a08ace1426fa4a9e;
module.exports["isHipaaError"] = $570a782ebb8f75e0$export$f8b1b75846492611;
module.exports["AGENTS_CONTAINER_ID"] = $570a782ebb8f75e0$export$429080cfef3412f2;

});

parcelRegister("fQF1W", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $827Ne = parcelRequire("827Ne");


var $dYtRL = parcelRequire("dYtRL");

const $2a6bb271c0fd2ecb$export$8a1abb7c176bd202 = (siteId)=>{
    const { data: tenantData } = (0, $dYtRL.useTenantDataController)(siteId);
    const atlasURL = (0, $42omo.useCallback)((path)=>(0, $827Ne.getAtlasURL)(siteId, path, tenantData?.orgId), [
        siteId,
        tenantData?.orgId
    ]);
    return {
        atlasURL: atlasURL
    };
};
const $2a6bb271c0fd2ecb$export$b61b99f9ac0264be = (siteId)=>{
    const { atlasURL: atlasURL } = $2a6bb271c0fd2ecb$export$8a1abb7c176bd202(siteId);
    return atlasURL('/chat/agents/new');
};
module.exports["useAtlasURL"] = $2a6bb271c0fd2ecb$export$8a1abb7c176bd202;

});

parcelRegister("827Ne", function(module, exports) {

var $6FQwA = parcelRequire("6FQwA");


var $bhcGS = parcelRequire("bhcGS");

const $5ae4133df3384b49$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $5ae4133df3384b49$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $5ae4133df3384b49$export$5105758c0e772381 = ()=>{
    return (0, $bhcGS.isStaging)() ? $5ae4133df3384b49$var$ATLAS_STAGING_URL : $5ae4133df3384b49$var$ATLAS_PROD_URL;
};
const $5ae4133df3384b49$export$bfee0f88bf621ad3 = (siteId, path, orgId)=>{
    let argConcat = '?';
    let processedPath = path.startsWith('/') ? path : `/${path}`;
    if (processedPath.includes('?')) argConcat = '&';
    const basePath = orgId ? `${$5ae4133df3384b49$export$5105758c0e772381()}/o/${orgId}` : $5ae4133df3384b49$export$5105758c0e772381();
    return (0, $6FQwA.addRovoParamsToUrl)(`${basePath}${processedPath}${argConcat}cloudId=${siteId}`, {
        cloudId: siteId
    });
};
module.exports["getAtlasHost"] = $5ae4133df3384b49$export$5105758c0e772381;
module.exports["getAtlasURL"] = $5ae4133df3384b49$export$bfee0f88bf621ad3;

});

parcelRegister("6FQwA", function(module, exports) {

var $kGZ7I = parcelRequire("kGZ7I");

const $fba4647064c9da0b$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $fba4647064c9da0b$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $fba4647064c9da0b$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $fba4647064c9da0b$export$9748efee331ec573 = (param)=>`${0, $kGZ7I.ROVO_PARAM_PREFIX}${$fba4647064c9da0b$export$fda91e425d265029(param)}`;
const $fba4647064c9da0b$export$f2888183a34644d4 = (param)=>{
    return $fba4647064c9da0b$export$858653b7ee3cbb17(param.replace((0, $kGZ7I.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $fba4647064c9da0b$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $fba4647064c9da0b$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $kGZ7I.ROVO_PARAM_PREFIX))) return;
        const paramKey = $fba4647064c9da0b$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $fba4647064c9da0b$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $fba4647064c9da0b$var$processParams(q).rovoParams;
    } catch  {
        return {};
    }
};
const $fba4647064c9da0b$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $fba4647064c9da0b$export$ef04687636c850fe(window.location.pathname, params));
};
const $fba4647064c9da0b$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $fba4647064c9da0b$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $fba4647064c9da0b$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $fba4647064c9da0b$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$fba4647064c9da0b$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).filter(([_, value])=>value !== undefined).map(([key, value])=>{
        return `${$fba4647064c9da0b$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $fba4647064c9da0b$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $fba4647064c9da0b$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
	For products using react-resource-router (e.g Atlas) to
	pass as the value of `query` on the route definition. It ensures that our parameters
	are not stripped from the URL when loading the page, or through redirect hops
	Any new parameters we want to maintain should be added here as well, which means
	only a version bump is needed in those products to support the latest param list
	The !=false simply means that the parameter is supported but is optional, and should
	not contain a value of 'false'
	*/ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $kGZ7I.ROVO_VALID_PARAMS).map((param)=>`${$fba4647064c9da0b$export$9748efee331ec573(param)}${suffix}`);
};
module.exports["getRovoParams"] = $fba4647064c9da0b$export$6405071f390601f7;
module.exports["updatePageRovoParams"] = $fba4647064c9da0b$export$4a302fc7d977f7b3;
module.exports["addRovoParamsToUrl"] = $fba4647064c9da0b$export$ef04687636c850fe;
module.exports["encodeRovoParams"] = $fba4647064c9da0b$export$eddc20a009406015;

});

parcelRegister("kGZ7I", function(module, exports) {
const $0075612de7c1f282$export$5a550907ffbc9119 = 'rovoChat';
const $0075612de7c1f282$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen',
    'insertPrompt'
];
module.exports["ROVO_PARAM_PREFIX"] = $0075612de7c1f282$export$5a550907ffbc9119;
module.exports["ROVO_VALID_PARAMS"] = $0075612de7c1f282$export$3cd6b610e7ede579;

});

parcelRegister("bhcGS", function(module, exports) {
const $f2c917fe02396491$export$23da1d24a38b0bde = ()=>{
    const host = window.location.host;
    return host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
};
module.exports["isStaging"] = $f2c917fe02396491$export$23da1d24a38b0bde;

});

parcelRegister("dYtRL", function(module, exports) {

var $fBMbo = parcelRequire("fBMbo");


var $16lEl = parcelRequire("16lEl");


var $hUyPY = parcelRequire("hUyPY");


var $9eLw5 = parcelRequire("9eLw5");


var $hGGLc = parcelRequire("hGGLc");

const $63d59501eb65c4db$export$b863fec6791eae25 = (siteId)=>{
    (0, $fBMbo.di)((0, $9eLw5.useQuery));
    const experience = (0, $hUyPY.useAIMateExperienceTracker)();
    const { data: data, isFetching: isFetching, error: error } = (0, $9eLw5.useQuery)({
        queryKey: [
            'viewAgentTenantData',
            siteId
        ],
        queryFn: async ()=>{
            experience.start({
                id: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA,
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
            const result = await (0, $hGGLc.getCloudUrlFromId)(siteId);
            return result;
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA,
                error: error
            });
        }
    });
    return {
        data: data,
        isFetching: isFetching,
        error: error
    };
};
module.exports["useTenantDataController"] = $63d59501eb65c4db$export$b863fec6791eae25;

});

parcelRegister("hGGLc", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $8CAML = parcelRequire("8CAML");

const $0fc4c72c92b990ea$var$CloudIdLookupQuery = `
query tenantQuery($cloudIds: [ID!]) {
  tenantContexts(cloudIds: $cloudIds) {
    cloudUrl
	orgId
  }
}
`;
const $0fc4c72c92b990ea$var$cache = new Map();
const $0fc4c72c92b990ea$export$d4ace54df9bd6bb1 = async (cloudId)=>{
    // If AIFC is enabled, use the new caching
    if ((0, $dh538.fg)('aifc_create_enabled')) {
        // Check if we already have a pending promise or cached result
        if ($0fc4c72c92b990ea$var$cache.has(cloudId)) return $0fc4c72c92b990ea$var$cache.get(cloudId);
        const response = await (0, $8CAML.performGqlFetch)({
            gqlQuery: $0fc4c72c92b990ea$var$CloudIdLookupQuery,
            variables: {
                cloudIds: [
                    cloudId
                ]
            }
        });
        const result = response.data?.tenantContexts?.[0];
        if (result) // Store the promise in the cache
        $0fc4c72c92b990ea$var$cache.set(cloudId, result);
        return result;
    }
    const response = await (0, $8CAML.performGqlFetch)({
        gqlQuery: $0fc4c72c92b990ea$var$CloudIdLookupQuery,
        variables: {
            cloudIds: [
                cloudId
            ]
        }
    });
    return response.data?.tenantContexts?.[0];
};
module.exports["getCloudUrlFromId"] = $0fc4c72c92b990ea$export$d4ace54df9bd6bb1;

});

parcelRegister("eOn3v", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $fHxn4 = parcelRequire("fHxn4");

const $1bde4828e2efe4cf$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
let $1bde4828e2efe4cf$var$client;
const $1bde4828e2efe4cf$export$d43dc22a8337ee9f = ()=>{
    (0, $fBMbo.di)((0, $fHxn4.default));
    const profileClient = (0, $42omo.useMemo)(()=>{
        if (!$1bde4828e2efe4cf$var$client) // To support di
        $1bde4828e2efe4cf$var$client = new (0, $fHxn4.default)({
            url: $1bde4828e2efe4cf$var$DIRECTORY_URL,
            cacheSize: 1000,
            // 1 day
            cacheMaxAge: 86400000
        });
        return $1bde4828e2efe4cf$var$client;
    }, []);
    return profileClient;
};
module.exports["useProfileClient"] = $1bde4828e2efe4cf$export$d43dc22a8337ee9f;

});

parcelRegister("5kyLi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b55ef878efda143d$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $b55ef878efda143d$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    deactivatedCreatorName: {
        id: "rovo-chat.agent-card.deactivated-name",
        defaultMessage: "{name} (deactivated)"
    }
});

});

parcelRegister("5kjCz", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $irVI7 = parcelRequire("irVI7");


var $glCMv = parcelRequire("glCMv");


var $fGzMp = parcelRequire("fGzMp");


var $kmyYx = parcelRequire("kmyYx");


var $aJPUt = parcelRequire("aJPUt");


var $04e9M = parcelRequire("04e9M");


var $78QFu = parcelRequire("78QFu");


var $9Cbhx = parcelRequire("9Cbhx");

const $44f37a86f8c1409e$export$c3c3c3f81a03570c = 'renderer';
const $44f37a86f8c1409e$export$e70b8cd540123fd4 = 'editor';
const $44f37a86f8c1409e$export$f783453b83c906eb = 'pdf';
const $44f37a86f8c1409e$var$ACTION = {
    SUCCESS: 'taskSuccess',
    FAIL: 'taskFail',
    ABORT: 'taskAbort',
    START: 'taskStart'
};
const $44f37a86f8c1409e$export$84a4de0ef6621278 = (name)=>name.split('.').slice(1).join('.');
const $44f37a86f8c1409e$export$b94fa6ed199caed2 = (macroEventRegister = new Map())=>{
    const macros = [];
    // @ts-ignore
    for (const v of macroEventRegister.values()){
        const { name: name } = v;
        if (name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) {
            const macro = {
                uniqueHash: $44f37a86f8c1409e$export$84a4de0ef6621278(name),
                ...$44f37a86f8c1409e$export$ae13022b12e7d19a(v)
            };
            macros.push(macro);
        }
    }
    return macros;
};
const $44f37a86f8c1409e$export$c1196ba2be68e8d3 = (macro)=>{
    return {
        type: macro?.type || '',
        macroId: (0, $9Cbhx.getMacroId)(macro?.parameters),
        extensionKey: (0, $9Cbhx.getExtensionKey)(macro),
        extensionType: macro?.extensionType || ''
    };
};
const $44f37a86f8c1409e$export$ae13022b12e7d19a = (macroEvent)=>{
    return {
        extensionKey: (0, $9Cbhx.getExtensionKey)(macroEvent?.experienceAttributes),
        extensionType: macroEvent?.experienceAttributes?.extensionType || '',
        type: macroEvent?.experienceAttributes?.type || '',
        macroId: macroEvent?.experienceAttributes?.macroId || '',
        duration: macroEvent?.duration || '',
        status: macroEvent?.status || '',
        pageId: macroEvent?.pageId || ''
    };
};
const $44f37a86f8c1409e$export$b16b3cab64ff0bd4 = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) return;
    $44f37a86f8c1409e$export$f7c63e38d5d9fd0b(mode, contentId).start({
        attributes: {
            mode: mode
        },
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
        id: contentId
    });
};
const $44f37a86f8c1409e$export$f9ebd83e8406755f = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) {
        if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister)) {
            const macroAttributes = {
                mode: mode,
                macros: null
            };
            if ($44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) macroAttributes.macros = $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister);
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    ...macroAttributes
                }
            });
        } else (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
            reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
            attributes: {
                macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                mode: mode
            }
        });
        const jiraMacro = $44f37a86f8c1409e$export$32db3a6a0c8b81ea(macroEventRegister);
        jiraMacro.forEach((macro)=>{
            const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
            const status = macro.status;
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: status,
                    attributes: {
                        ...macro.experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`
                    }
                });
            });
        });
        // clean up after aborting all event
        macroEventRegister.clear();
        $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
    }
};
const $44f37a86f8c1409e$export$d693932e457c5586 = (eventRegister = new Map())=>{
    if (eventRegister.size === 0) return true;
    // only check whether all sub-experience has finished
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) return false;
    }
    return true;
};
const $44f37a86f8c1409e$export$375cf77d729480fb = (eventRegister = new Map())=>{
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) return true;
    }
    return false;
};
const $44f37a86f8c1409e$export$faf154bb66b40b64 = (name)=>name.includes((0, $9Cbhx.JIRA_EXTENSION_KEY));
const $44f37a86f8c1409e$export$f2ada44de4a33ea1 = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$32db3a6a0c8b81ea = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name)) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$98d7b4463a1de442 = (contentId, mode)=>{
    (function macroTimeout() {
        setTimeout(()=>{
            const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
            if (!macroEventRegister.has(contentId)) return;
            const pageEvent = macroEventRegister.get(contentId);
            const isTimedOut = Math.round(window.performance.now() - pageEvent.startTime) > (0, $aJPUt.ExperienceTimeout).MACRO_LOAD;
            // 1. all macro loaded or main-experience timeout and have sub-experience
            //    succeed the main experience and report to experience tracker and done
            if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister) && $44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            else if (isTimedOut) {
                // 2a. timeout does not has sub-experience, succeed the main experience
                if (!$44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                    name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                    attributes: {
                        mode: mode
                    }
                });
                else {
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
                        attributes: {
                            macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                            mode: mode
                        }
                    });
                    const unsuceededJIRAMacro = $44f37a86f8c1409e$export$f2ada44de4a33ea1(macroEventRegister);
                    unsuceededJIRAMacro.forEach((macro)=>{
                        const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
                        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                            analyticsWebClient.sendOperationalEvent({
                                source: 'ui',
                                actionSubject: 'macroTracker',
                                action: 'taskAbort',
                                attributes: {
                                    ...macro.experienceAttributes,
                                    extensionKey: extensionKey,
                                    mode: mode,
                                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                                    reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                                }
                            });
                        });
                    });
                }
                // clean up after aborting all event
                macroEventRegister.clear();
                $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            } else macroTimeout();
        }, 2000);
    })();
};
const $44f37a86f8c1409e$var$macroEventRegisterHash = new Map();
const $44f37a86f8c1409e$export$adf8cb42c7fe1834 = (mode, contentId)=>{
    if ($44f37a86f8c1409e$var$macroEventRegisterHash.has(`${mode}.${contentId}`)) return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, new Map());
    return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
};
const $44f37a86f8c1409e$export$d7fca4196d2b6b6c = (mode, contentId, name, experienceAttributes)=>{
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'macroTracker',
                action: 'taskStart',
                attributes: {
                    ...experienceAttributes,
                    extensionKey: extensionKey,
                    mode: mode,
                    pageId: contentId,
                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            });
        });
    }
};
const $44f37a86f8c1409e$export$d10b6dded8392899 = (mode, contentId, name, experienceAttributes)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    const macroId = experienceAttributes?.macroId;
    if (!macroEventRegister.has(macroId)) return;
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        const { status: status } = macroEventRegister.get(macroId);
        if (status === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskSuccess',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.ABORT) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskAbort',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.FAIL) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskFail',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        error: new (0, $glCMv.ExperienceTimeoutError)(`JIRA macro failed to complete in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`)
                    }
                });
            });
        }
    }
};
const $44f37a86f8c1409e$export$f7c63e38d5d9fd0b = (0, $2XqLN.default)((mode, contentId)=>{
    const macroTracker = new (0, $kmyYx.ExperienceTracker)();
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    macroTracker.subscribe((event)=>{
        const { action: action, name: name, attributes: experienceAttributes, ...rest } = event;
        const macroId = experienceAttributes?.macroId;
        if (action === $44f37a86f8c1409e$var$ACTION.START) {
            // prevent triggering of event
            const current = macroEventRegister.get(macroId);
            if (current && current.id === macroId) return;
            if (name === (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) // prevent firing the same view-all-macro more than once
            {
                if (!macroEventRegister.has(contentId)) {
                    // clear the event register, prevent event being re-tracked between SPA transition
                    macroEventRegister.clear();
                    (0, $fGzMp.getExperienceTracker)().start({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                        id: contentId,
                        attributes: {
                            mode: mode
                        }
                    });
                    macroEventRegister.set(contentId, {
                        status: $44f37a86f8c1409e$var$ACTION.START,
                        name: name,
                        mode: mode,
                        ...rest
                    });
                    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
                }
            } else {
                // tracking each macro, report to MacroTracker
                macroEventRegister.set(macroId, {
                    status: $44f37a86f8c1409e$var$ACTION.START,
                    name: name,
                    experienceAttributes: {
                        ...experienceAttributes,
                        extensionKey: (0, $9Cbhx.getExtensionKey)(experienceAttributes)
                    },
                    pageId: contentId,
                    mode: mode,
                    ...rest
                });
                $44f37a86f8c1409e$export$d7fca4196d2b6b6c(mode, contentId, name, experienceAttributes);
            }
        } else if (action === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, name: name } = event;
            // tracking each macro when it successfully loads
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.SUCCESS,
                duration: duration,
                pageId: contentId
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action === $44f37a86f8c1409e$var$ACTION.ABORT) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, reason: reason, name: name } = event;
            // tracking each macro when it aborts loading
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.ABORT,
                duration: duration,
                pageId: contentId,
                reason: reason
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro aborts to load, aborts the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                reason: 'Macro abort loading',
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action == $44f37a86f8c1409e$var$ACTION.FAIL) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, error: error, name: name } = event;
            // tracking each macro when it fails to load
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.FAIL,
                duration: duration,
                pageId: contentId,
                error: error
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro fails to load, fails the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                error: error,
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode,
                    ...experienceAttributes
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        }
        $44f37a86f8c1409e$export$98d7b4463a1de442(contentId, mode);
    });
    return macroTracker;
});
const $44f37a86f8c1409e$export$4ce0bedef4e84bb7 = (mode, extension)=>{
    const attributes = $44f37a86f8c1409e$export$c1196ba2be68e8d3(extension);
    return `${mode}.${(0, $9Cbhx.getExtensionKey)(attributes)}.${attributes.macroId}`;
};
module.exports["RENDERER"] = $44f37a86f8c1409e$export$c3c3c3f81a03570c;
module.exports["EDITOR"] = $44f37a86f8c1409e$export$e70b8cd540123fd4;
module.exports["PDF"] = $44f37a86f8c1409e$export$f783453b83c906eb;
module.exports["getMacroAttributesFromADFNode"] = $44f37a86f8c1409e$export$c1196ba2be68e8d3;
module.exports["startMacroExperience"] = $44f37a86f8c1409e$export$b16b3cab64ff0bd4;
module.exports["getMacroExperienceTracker"] = $44f37a86f8c1409e$export$f7c63e38d5d9fd0b;
module.exports["stopMacroExperience"] = $44f37a86f8c1409e$export$f9ebd83e8406755f;
module.exports["stopJIRAMacro"] = $44f37a86f8c1409e$export$d10b6dded8392899;
module.exports["getExperienceName"] = $44f37a86f8c1409e$export$4ce0bedef4e84bb7;

});

parcelRegister("9Cbhx", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $hukUK = parcelRequire("hukUK");

const $9293ebd9645c82d6$export$7486394da5136452 = 'jira';
const $9293ebd9645c82d6$export$8d178e7efa3ed0e7 = 'issue-count';
const $9293ebd9645c82d6$export$c3f023baaa9b214b = 'table-view';
const $9293ebd9645c82d6$export$7d601f5ae4a82040 = 'single-issue';
const $9293ebd9645c82d6$export$47eae2202f029f6b = (parameters)=>{
    if (!parameters) return (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const idFromNode = parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    // for macro that does not have unique macro id, we want to generate some unique id
    return (0, $hukUK.objectHash)(parameters);
};
const $9293ebd9645c82d6$export$218d96312e385949 = (attributes)=>{
    if (!attributes) return '';
    const { extensionKey: extensionKey } = attributes;
    const macroParams = attributes?.parameters?.macroParams;
    if (extensionKey === $9293ebd9645c82d6$export$7486394da5136452) return `${extensionKey}${$9293ebd9645c82d6$export$cc2f094f034c7f8f(macroParams)}`;
    return extensionKey;
};
const $9293ebd9645c82d6$export$cc2f094f034c7f8f = (macroParams)=>{
    const prefix = '-';
    if (macroParams?.count?.value === 'true') return prefix + $9293ebd9645c82d6$export$8d178e7efa3ed0e7;
    else if (macroParams?.columns && macroParams?.maximumIssues) return prefix + $9293ebd9645c82d6$export$c3f023baaa9b214b;
    else if (macroParams?.key?.value) return prefix + $9293ebd9645c82d6$export$7d601f5ae4a82040;
    return '';
};
module.exports["JIRA_EXTENSION_KEY"] = $9293ebd9645c82d6$export$7486394da5136452;
module.exports["getMacroId"] = $9293ebd9645c82d6$export$47eae2202f029f6b;
module.exports["getExtensionKey"] = $9293ebd9645c82d6$export$218d96312e385949;

});

parcelRegister("2bAZx", function(module, exports) {
// inspired by https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.js
/* eslint react-hooks/exhaustive-deps: 0 */ //Todo: this is flawed because callback is not included in the dependency array generated by useDeepCompareMemoize
// if the callback function (all use cases I found were inline functions and therfore not passed as a ref, were passes to the dep array they would trigger a re-evaluation every render defeating the purpose
// in order to properly work and handle the callback function being changed, the callback argument must be a useCallback or other function passed by ref and have it be included in the memoized depenedency array

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");

function $a4fa77695d2683a4$export$db77f469fe79526e(callback, dependencies) {
    (0, $42omo.useEffect)(callback, $a4fa77695d2683a4$var$useDeepCompareMemoize(dependencies));
}
//eslint-ignore react-hooks/exhaustive-deps
function $a4fa77695d2683a4$var$useDeepCompareMemoize(value) {
    const ref = (0, $42omo.useRef)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(value, ref.current)) ref.current = value;
    return ref.current;
}
module.exports["useDeepCompareEffect"] = $a4fa77695d2683a4$export$db77f469fe79526e;

});

parcelRegister("bX5uj", function(module, exports) {

var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $b23c2b4e39153eb4$export$3462df5a881e125d({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceSuccess"] = $b23c2b4e39153eb4$export$3462df5a881e125d;

});


//# sourceMappingURL=CreateComponent.c7f5e0e1.js.map
